// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file zdc.proto (package zdc, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file zdc.proto.
 */
export const file_zdc: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Custom empty message
 *
 * @generated from message zdc.Empty
 */
export type Empty = Message<"zdc.Empty"> & {
};

/**
 * Describes the message zdc.Empty.
 * Use `create(EmptySchema)` to create a new message.
 */
export const EmptySchema: GenMessage<Empty> = /*@__PURE__*/
  messageDesc(file_zdc, 0);

/**
 * Стандартная команда платформы (SSoT — сервер): у каждого типа объекта
 * метаданных свой набор (как в 1С): формы списка — create/create_group/
 * refresh/delete/search/filter; объект справочника/задачи — save/save_and_close/
 * close/refresh (+done/canceled/take/release для задач); документ — +post/
 * post_and_close. Клиент НЕ определяет команды — только исполняет.
 *
 * @generated from message zdc.StandardCommand
 */
export type StandardCommand = Message<"zdc.StandardCommand"> & {
  /**
   * код команды (save, post, done, create, ...)
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * отображаемое имя
   *
   * @generated from field: string synonym = 2;
   */
  synonym: string;

  /**
   * 'list' | 'object' (к какой форме относится)
   *
   * @generated from field: string kind = 3;
   */
  kind: string;
};

/**
 * Describes the message zdc.StandardCommand.
 * Use `create(StandardCommandSchema)` to create a new message.
 */
export const StandardCommandSchema: GenMessage<StandardCommand> = /*@__PURE__*/
  messageDesc(file_zdc, 1);

/**
 * @generated from message zdc.ListStandardCommandsRequest
 */
export type ListStandardCommandsRequest = Message<"zdc.ListStandardCommandsRequest"> & {
  /**
   * catalog | document | task | ...
   *
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * object | list | selection
   *
   * @generated from field: string form_type = 2;
   */
  formType: string;
};

/**
 * Describes the message zdc.ListStandardCommandsRequest.
 * Use `create(ListStandardCommandsRequestSchema)` to create a new message.
 */
export const ListStandardCommandsRequestSchema: GenMessage<ListStandardCommandsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 2);

/**
 * @generated from message zdc.StandardCommandList
 */
export type StandardCommandList = Message<"zdc.StandardCommandList"> & {
  /**
   * @generated from field: repeated zdc.StandardCommand items = 1;
   */
  items: StandardCommand[];
};

/**
 * Describes the message zdc.StandardCommandList.
 * Use `create(StandardCommandListSchema)` to create a new message.
 */
export const StandardCommandListSchema: GenMessage<StandardCommandList> = /*@__PURE__*/
  messageDesc(file_zdc, 3);

/**
 * Детерминированный резолв типа объекта по физической таблице (SSoT — сервер):
 * никаких клиентских каскадов «попробуем catalog → document → task».
 *
 * @generated from message zdc.ResolveTableEntityRequest
 */
export type ResolveTableEntityRequest = Message<"zdc.ResolveTableEntityRequest"> & {
  /**
   * @generated from field: string table = 1;
   */
  table: string;
};

/**
 * Describes the message zdc.ResolveTableEntityRequest.
 * Use `create(ResolveTableEntityRequestSchema)` to create a new message.
 */
export const ResolveTableEntityRequestSchema: GenMessage<ResolveTableEntityRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 4);

/**
 * @generated from message zdc.ResolveTableEntityResponse
 */
export type ResolveTableEntityResponse = Message<"zdc.ResolveTableEntityResponse"> & {
  /**
   * 'catalog' | 'document' | 'task' | '' (не найдено)
   *
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;
};

/**
 * Describes the message zdc.ResolveTableEntityResponse.
 * Use `create(ResolveTableEntityResponseSchema)` to create a new message.
 */
export const ResolveTableEntityResponseSchema: GenMessage<ResolveTableEntityResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 5);

/**
 * ============================================================
 * Шаблоны карточек (карточный движок, план 11): именованные
 * профили отображения ObjectCard — variant/behavior/блоки.
 * definition_json — свободная JSON-структура (клиентский рендер).
 * ============================================================
 *
 * @generated from message zdc.CardTemplate
 */
export type CardTemplate = Message<"zdc.CardTemplate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * код шаблона
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * отображаемое имя
   *
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * {variant, behavior, blocks[]}
   *
   * @generated from field: string definition_json = 5;
   */
  definitionJson: string;

  /**
   * @generated from field: bool is_system = 6;
   */
  isSystem: boolean;

  /**
   * @generated from field: string created_at = 7;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 8;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.CardTemplate.
 * Use `create(CardTemplateSchema)` to create a new message.
 */
export const CardTemplateSchema: GenMessage<CardTemplate> = /*@__PURE__*/
  messageDesc(file_zdc, 6);

/**
 * @generated from message zdc.CardTemplateList
 */
export type CardTemplateList = Message<"zdc.CardTemplateList"> & {
  /**
   * @generated from field: repeated zdc.CardTemplate items = 1;
   */
  items: CardTemplate[];
};

/**
 * Describes the message zdc.CardTemplateList.
 * Use `create(CardTemplateListSchema)` to create a new message.
 */
export const CardTemplateListSchema: GenMessage<CardTemplateList> = /*@__PURE__*/
  messageDesc(file_zdc, 7);

/**
 * @generated from message zdc.ListCardTemplatesRequest
 */
export type ListCardTemplatesRequest = Message<"zdc.ListCardTemplatesRequest"> & {
};

/**
 * Describes the message zdc.ListCardTemplatesRequest.
 * Use `create(ListCardTemplatesRequestSchema)` to create a new message.
 */
export const ListCardTemplatesRequestSchema: GenMessage<ListCardTemplatesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 8);

/**
 * @generated from message zdc.GetCardTemplateRequest
 */
export type GetCardTemplateRequest = Message<"zdc.GetCardTemplateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetCardTemplateRequest.
 * Use `create(GetCardTemplateRequestSchema)` to create a new message.
 */
export const GetCardTemplateRequestSchema: GenMessage<GetCardTemplateRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 9);

/**
 * @generated from message zdc.CreateCardTemplateRequest
 */
export type CreateCardTemplateRequest = Message<"zdc.CreateCardTemplateRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string synonym = 2;
   */
  synonym: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string definition_json = 4;
   */
  definitionJson: string;
};

/**
 * Describes the message zdc.CreateCardTemplateRequest.
 * Use `create(CreateCardTemplateRequestSchema)` to create a new message.
 */
export const CreateCardTemplateRequestSchema: GenMessage<CreateCardTemplateRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 10);

/**
 * @generated from message zdc.UpdateCardTemplateRequest
 */
export type UpdateCardTemplateRequest = Message<"zdc.UpdateCardTemplateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string definition_json = 5;
   */
  definitionJson: string;
};

/**
 * Describes the message zdc.UpdateCardTemplateRequest.
 * Use `create(UpdateCardTemplateRequestSchema)` to create a new message.
 */
export const UpdateCardTemplateRequestSchema: GenMessage<UpdateCardTemplateRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 11);

/**
 * @generated from message zdc.DeleteCardTemplateRequest
 */
export type DeleteCardTemplateRequest = Message<"zdc.DeleteCardTemplateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteCardTemplateRequest.
 * Use `create(DeleteCardTemplateRequestSchema)` to create a new message.
 */
export const DeleteCardTemplateRequestSchema: GenMessage<DeleteCardTemplateRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 12);

/**
 * @generated from message zdc.LogEventRequest
 */
export type LogEventRequest = Message<"zdc.LogEventRequest"> & {
  /**
   * debug | info | warning | error
   *
   * @generated from field: string level = 1;
   */
  level: string;

  /**
   * auth | data | metadata | file | system | sync | ui | security
   *
   * @generated from field: string category = 2;
   */
  category: string;

  /**
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * catalog/document/register/...
   *
   * @generated from field: string entity_type = 4;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 5;
   */
  entityCode: string;

  /**
   * @generated from field: string object_id = 6;
   */
  objectId: string;

  /**
   * JSON-детали
   *
   * @generated from field: string details = 7;
   */
  details: string;

  /**
   * desktop | pwa | web (клиент сообщает сам)
   *
   * @generated from field: string client_app = 8;
   */
  clientApp: string;

  /**
   * код приложения-источника (пусто = «Система»/ядро)
   *
   * @generated from field: string app = 9;
   */
  app: string;
};

/**
 * Describes the message zdc.LogEventRequest.
 * Use `create(LogEventRequestSchema)` to create a new message.
 */
export const LogEventRequestSchema: GenMessage<LogEventRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 13);

/**
 * @generated from message zdc.EventLogRecord
 */
export type EventLogRecord = Message<"zdc.EventLogRecord"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * время события (серверное, RFC3339)
   *
   * @generated from field: string ts = 2;
   */
  ts: string;

  /**
   * @generated from field: string level = 3;
   */
  level: string;

  /**
   * @generated from field: string category = 4;
   */
  category: string;

  /**
   * @generated from field: string message = 5;
   */
  message: string;

  /**
   * @generated from field: string entity_type = 6;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 7;
   */
  entityCode: string;

  /**
   * @generated from field: string object_id = 8;
   */
  objectId: string;

  /**
   * @generated from field: string user_id = 9;
   */
  userId: string;

  /**
   * @generated from field: string user_name = 10;
   */
  userName: string;

  /**
   * server | client
   *
   * @generated from field: string source = 11;
   */
  source: string;

  /**
   * @generated from field: string details = 12;
   */
  details: string;

  /**
   * IP клиента (сервер определяет сам)
   *
   * @generated from field: string client_ip = 13;
   */
  clientIp: string;

  /**
   * User-Agent (сервер определяет сам)
   *
   * @generated from field: string user_agent = 14;
   */
  userAgent: string;

  /**
   * desktop | pwa | web | unknown
   *
   * @generated from field: string client_app = 15;
   */
  clientApp: string;

  /**
   * код приложения-источника; пусто = «Система» (ядро)
   *
   * @generated from field: string app = 16;
   */
  app: string;
};

/**
 * Describes the message zdc.EventLogRecord.
 * Use `create(EventLogRecordSchema)` to create a new message.
 */
export const EventLogRecordSchema: GenMessage<EventLogRecord> = /*@__PURE__*/
  messageDesc(file_zdc, 14);

/**
 * @generated from message zdc.EventLogList
 */
export type EventLogList = Message<"zdc.EventLogList"> & {
  /**
   * @generated from field: repeated zdc.EventLogRecord items = 1;
   */
  items: EventLogRecord[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message zdc.EventLogList.
 * Use `create(EventLogListSchema)` to create a new message.
 */
export const EventLogListSchema: GenMessage<EventLogList> = /*@__PURE__*/
  messageDesc(file_zdc, 15);

/**
 * @generated from message zdc.EventLogListRequest
 */
export type EventLogListRequest = Message<"zdc.EventLogListRequest"> & {
  /**
   * фильтр: info/warning/error (пусто = все)
   *
   * @generated from field: string level = 1;
   */
  level: string;

  /**
   * фильтр категории
   *
   * @generated from field: string category = 2;
   */
  category: string;

  /**
   * @generated from field: string entity_type = 3;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 4;
   */
  entityCode: string;

  /**
   * @generated from field: string user_id = 5;
   */
  userId: string;

  /**
   * поиск по message (LIKE)
   *
   * @generated from field: string search = 6;
   */
  search: string;

  /**
   * RFC3339, начало периода
   *
   * @generated from field: string from_ts = 7;
   */
  fromTs: string;

  /**
   * RFC3339, конец периода
   *
   * @generated from field: string to_ts = 8;
   */
  toTs: string;

  /**
   * default 200
   *
   * @generated from field: int32 limit = 9;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 10;
   */
  offset: number;

  /**
   * server | client
   *
   * @generated from field: string source = 11;
   */
  source: string;

  /**
   * фильтр по приложению (пусто = все)
   *
   * @generated from field: string app = 12;
   */
  app: string;
};

/**
 * Describes the message zdc.EventLogListRequest.
 * Use `create(EventLogListRequestSchema)` to create a new message.
 */
export const EventLogListRequestSchema: GenMessage<EventLogListRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 16);

/**
 * @generated from message zdc.EventLogClearRequest
 */
export type EventLogClearRequest = Message<"zdc.EventLogClearRequest"> & {
  /**
   * удалить события старше (RFC3339); пусто = все
   *
   * @generated from field: string before_ts = 1;
   */
  beforeTs: string;
};

/**
 * Describes the message zdc.EventLogClearRequest.
 * Use `create(EventLogClearRequestSchema)` to create a new message.
 */
export const EventLogClearRequestSchema: GenMessage<EventLogClearRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 17);

/**
 * --- Полномочия (как в 1С «ПолномочияСотрудников», 2026-08-30) ---
 *
 * @generated from message zdc.Permission
 */
export type Permission = Message<"zdc.Permission"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * boolean | level | value
   *
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * @generated from field: string default_value = 5;
   */
  defaultValue: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: bool is_system = 7;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 8;
   */
  templateId: string;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 10;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.Permission.
 * Use `create(PermissionSchema)` to create a new message.
 */
export const PermissionSchema: GenMessage<Permission> = /*@__PURE__*/
  messageDesc(file_zdc, 18);

/**
 * @generated from message zdc.PermissionList
 */
export type PermissionList = Message<"zdc.PermissionList"> & {
  /**
   * @generated from field: repeated zdc.Permission items = 1;
   */
  items: Permission[];
};

/**
 * Describes the message zdc.PermissionList.
 * Use `create(PermissionListSchema)` to create a new message.
 */
export const PermissionListSchema: GenMessage<PermissionList> = /*@__PURE__*/
  messageDesc(file_zdc, 19);

/**
 * @generated from message zdc.GetPermissionRequest
 */
export type GetPermissionRequest = Message<"zdc.GetPermissionRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.GetPermissionRequest.
 * Use `create(GetPermissionRequestSchema)` to create a new message.
 */
export const GetPermissionRequestSchema: GenMessage<GetPermissionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 20);

/**
 * @generated from message zdc.SavePermissionRequest
 */
export type SavePermissionRequest = Message<"zdc.SavePermissionRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * @generated from field: string default_value = 5;
   */
  defaultValue: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;
};

/**
 * Describes the message zdc.SavePermissionRequest.
 * Use `create(SavePermissionRequestSchema)` to create a new message.
 */
export const SavePermissionRequestSchema: GenMessage<SavePermissionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 21);

/**
 * @generated from message zdc.DeletePermissionRequest
 */
export type DeletePermissionRequest = Message<"zdc.DeletePermissionRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.DeletePermissionRequest.
 * Use `create(DeletePermissionRequestSchema)` to create a new message.
 */
export const DeletePermissionRequestSchema: GenMessage<DeletePermissionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 22);

/**
 * @generated from message zdc.PermissionValue
 */
export type PermissionValue = Message<"zdc.PermissionValue"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * пользователь (пусто = нет)
   *
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * роль (пусто = нет)
   *
   * @generated from field: string role_id = 3;
   */
  roleId: string;

  /**
   * контейнер (пусто = нет)
   *
   * @generated from field: string container_id = 4;
   */
  containerId: string;

  /**
   * @generated from field: string permission_code = 5;
   */
  permissionCode: string;

  /**
   * текст; парсится по kind
   *
   * @generated from field: string value = 6;
   */
  value: string;

  /**
   * '' | all | own | org | custom
   *
   * @generated from field: string scope = 7;
   */
  scope: string;

  /**
   * JSON (для custom)
   *
   * @generated from field: string scope_params = 8;
   */
  scopeParams: string;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 10;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.PermissionValue.
 * Use `create(PermissionValueSchema)` to create a new message.
 */
export const PermissionValueSchema: GenMessage<PermissionValue> = /*@__PURE__*/
  messageDesc(file_zdc, 23);

/**
 * @generated from message zdc.ListPermissionValuesRequest
 */
export type ListPermissionValuesRequest = Message<"zdc.ListPermissionValuesRequest"> & {
  /**
   * @generated from field: string permission_code = 1;
   */
  permissionCode: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: string role_id = 3;
   */
  roleId: string;

  /**
   * @generated from field: string container_id = 4;
   */
  containerId: string;
};

/**
 * Describes the message zdc.ListPermissionValuesRequest.
 * Use `create(ListPermissionValuesRequestSchema)` to create a new message.
 */
export const ListPermissionValuesRequestSchema: GenMessage<ListPermissionValuesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 24);

/**
 * @generated from message zdc.PermissionValueList
 */
export type PermissionValueList = Message<"zdc.PermissionValueList"> & {
  /**
   * @generated from field: repeated zdc.PermissionValue items = 1;
   */
  items: PermissionValue[];
};

/**
 * Describes the message zdc.PermissionValueList.
 * Use `create(PermissionValueListSchema)` to create a new message.
 */
export const PermissionValueListSchema: GenMessage<PermissionValueList> = /*@__PURE__*/
  messageDesc(file_zdc, 25);

/**
 * @generated from message zdc.SavePermissionValueRequest
 */
export type SavePermissionValueRequest = Message<"zdc.SavePermissionValueRequest"> & {
  /**
   * @generated from field: zdc.PermissionValue value = 1;
   */
  value?: PermissionValue | undefined;
};

/**
 * Describes the message zdc.SavePermissionValueRequest.
 * Use `create(SavePermissionValueRequestSchema)` to create a new message.
 */
export const SavePermissionValueRequestSchema: GenMessage<SavePermissionValueRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 26);

/**
 * @generated from message zdc.DeletePermissionValueRequest
 */
export type DeletePermissionValueRequest = Message<"zdc.DeletePermissionValueRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeletePermissionValueRequest.
 * Use `create(DeletePermissionValueRequestSchema)` to create a new message.
 */
export const DeletePermissionValueRequestSchema: GenMessage<DeletePermissionValueRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 27);

/**
 * @generated from message zdc.ResolvePermissionRequest
 */
export type ResolvePermissionRequest = Message<"zdc.ResolvePermissionRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;
};

/**
 * Describes the message zdc.ResolvePermissionRequest.
 * Use `create(ResolvePermissionRequestSchema)` to create a new message.
 */
export const ResolvePermissionRequestSchema: GenMessage<ResolvePermissionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 28);

/**
 * @generated from message zdc.ResolvedPermission
 */
export type ResolvedPermission = Message<"zdc.ResolvedPermission"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * строковое значение (bool/число/строка)
   *
   * @generated from field: string value = 2;
   */
  value: string;

  /**
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * entity | role | container | default
   *
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * all | own | org | custom
   *
   * @generated from field: string scope = 5;
   */
  scope: string;

  /**
   * @generated from field: bool is_explicit = 6;
   */
  isExplicit: boolean;
};

/**
 * Describes the message zdc.ResolvedPermission.
 * Use `create(ResolvedPermissionSchema)` to create a new message.
 */
export const ResolvedPermissionSchema: GenMessage<ResolvedPermission> = /*@__PURE__*/
  messageDesc(file_zdc, 29);

/**
 * @generated from message zdc.BackupInfo
 */
export type BackupInfo = Message<"zdc.BackupInfo"> & {
  /**
   * backup-{slug}-{ts}.hdd
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: int64 size_bytes = 2;
   */
  sizeBytes: bigint;

  /**
   * RFC3339 (из имени файла)
   *
   * @generated from field: string created_at = 3;
   */
  createdAt: string;

  /**
   * startup | scheduled | manual | before_restore | before_import | before_update
   *
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * Describes the message zdc.BackupInfo.
 * Use `create(BackupInfoSchema)` to create a new message.
 */
export const BackupInfoSchema: GenMessage<BackupInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 30);

/**
 * @generated from message zdc.BackupList
 */
export type BackupList = Message<"zdc.BackupList"> & {
  /**
   * @generated from field: repeated zdc.BackupInfo items = 1;
   */
  items: BackupInfo[];
};

/**
 * Describes the message zdc.BackupList.
 * Use `create(BackupListSchema)` to create a new message.
 */
export const BackupListSchema: GenMessage<BackupList> = /*@__PURE__*/
  messageDesc(file_zdc, 31);

/**
 * @generated from message zdc.CreateBackupRequest
 */
export type CreateBackupRequest = Message<"zdc.CreateBackupRequest"> & {
  /**
   * @generated from field: string reason = 1;
   */
  reason: string;
};

/**
 * Describes the message zdc.CreateBackupRequest.
 * Use `create(CreateBackupRequestSchema)` to create a new message.
 */
export const CreateBackupRequestSchema: GenMessage<CreateBackupRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 32);

/**
 * @generated from message zdc.DeleteBackupRequest
 */
export type DeleteBackupRequest = Message<"zdc.DeleteBackupRequest"> & {
  /**
   * только имя файла (backup-*.hdd), без пути
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message zdc.DeleteBackupRequest.
 * Use `create(DeleteBackupRequestSchema)` to create a new message.
 */
export const DeleteBackupRequestSchema: GenMessage<DeleteBackupRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 33);

/**
 * @generated from message zdc.DownloadBackupRequest
 */
export type DownloadBackupRequest = Message<"zdc.DownloadBackupRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message zdc.DownloadBackupRequest.
 * Use `create(DownloadBackupRequestSchema)` to create a new message.
 */
export const DownloadBackupRequestSchema: GenMessage<DownloadBackupRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 34);

/**
 * @generated from message zdc.DownloadBackupResult
 */
export type DownloadBackupResult = Message<"zdc.DownloadBackupResult"> & {
  /**
   * base64 (.hdd)
   *
   * @generated from field: string data = 1;
   */
  data: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message zdc.DownloadBackupResult.
 * Use `create(DownloadBackupResultSchema)` to create a new message.
 */
export const DownloadBackupResultSchema: GenMessage<DownloadBackupResult> = /*@__PURE__*/
  messageDesc(file_zdc, 35);

/**
 * @generated from message zdc.RestoreBackupRequest
 */
export type RestoreBackupRequest = Message<"zdc.RestoreBackupRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message zdc.RestoreBackupRequest.
 * Use `create(RestoreBackupRequestSchema)` to create a new message.
 */
export const RestoreBackupRequestSchema: GenMessage<RestoreBackupRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 36);

/**
 * @generated from message zdc.RestoreBackupResult
 */
export type RestoreBackupResult = Message<"zdc.RestoreBackupResult"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message zdc.RestoreBackupResult.
 * Use `create(RestoreBackupResultSchema)` to create a new message.
 */
export const RestoreBackupResultSchema: GenMessage<RestoreBackupResult> = /*@__PURE__*/
  messageDesc(file_zdc, 37);

/**
 * @generated from message zdc.BackupSettings
 */
export type BackupSettings = Message<"zdc.BackupSettings"> & {
  /**
   * авто-бэкапы (default true)
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * хранить последние N (default 10)
   *
   * @generated from field: int32 retention_count = 2;
   */
  retentionCount: number;

  /**
   * не старше M дней (default 30)
   *
   * @generated from field: int32 retention_days = 3;
   */
  retentionDays: number;

  /**
   * фоновый интервал (default 24)
   *
   * @generated from field: int32 auto_interval_hours = 4;
   */
  autoIntervalHours: number;

  /**
   * файловое хранилище (type='folder', как все хранилища)
   *
   * @generated from field: string storage_code = 5;
   */
  storageCode: string;
};

/**
 * Describes the message zdc.BackupSettings.
 * Use `create(BackupSettingsSchema)` to create a new message.
 */
export const BackupSettingsSchema: GenMessage<BackupSettings> = /*@__PURE__*/
  messageDesc(file_zdc, 38);

/**
 * @generated from message zdc.Storage
 */
export type Storage = Message<"zdc.Storage"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 'db' | 'folder' | 's3'
   *
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: bool is_default = 4;
   */
  isDefault: boolean;

  /**
   * лимит размера файла, байт (0 = без ограничения)
   *
   * @generated from field: int64 max_size = 5;
   */
  maxSize: bigint;

  /**
   * JSON: {"path": "..."} - путь каталога для type='folder'
   *
   * @generated from field: string config = 6;
   */
  config: string;

  /**
   * системное (main/tmp/backups) — удаление запрещено
   *
   * @generated from field: bool is_system = 7;
   */
  isSystem: boolean;

  /**
   * занято (folder: сумма размеров файлов; db: сумма file_size)
   *
   * @generated from field: int64 usage_bytes = 8;
   */
  usageBytes: bigint;

  /**
   * свободно на диске (folder: диск каталога; db: диск файла БД)
   *
   * @generated from field: int64 free_bytes = 9;
   */
  freeBytes: bigint;
};

/**
 * Describes the message zdc.Storage.
 * Use `create(StorageSchema)` to create a new message.
 */
export const StorageSchema: GenMessage<Storage> = /*@__PURE__*/
  messageDesc(file_zdc, 39);

/**
 * @generated from message zdc.StorageList
 */
export type StorageList = Message<"zdc.StorageList"> & {
  /**
   * @generated from field: repeated zdc.Storage items = 1;
   */
  items: Storage[];
};

/**
 * Describes the message zdc.StorageList.
 * Use `create(StorageListSchema)` to create a new message.
 */
export const StorageListSchema: GenMessage<StorageList> = /*@__PURE__*/
  messageDesc(file_zdc, 40);

/**
 * @generated from message zdc.ListStoragesRequest
 */
export type ListStoragesRequest = Message<"zdc.ListStoragesRequest"> & {
};

/**
 * Describes the message zdc.ListStoragesRequest.
 * Use `create(ListStoragesRequestSchema)` to create a new message.
 */
export const ListStoragesRequestSchema: GenMessage<ListStoragesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 41);

/**
 * @generated from message zdc.CreateStorageRequest
 */
export type CreateStorageRequest = Message<"zdc.CreateStorageRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 'db' | 'folder'
   *
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: bool is_default = 4;
   */
  isDefault: boolean;

  /**
   * @generated from field: int64 max_size = 5;
   */
  maxSize: bigint;

  /**
   * @generated from field: string config = 6;
   */
  config: string;
};

/**
 * Describes the message zdc.CreateStorageRequest.
 * Use `create(CreateStorageRequestSchema)` to create a new message.
 */
export const CreateStorageRequestSchema: GenMessage<CreateStorageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 42);

/**
 * @generated from message zdc.UpdateStorageRequest
 */
export type UpdateStorageRequest = Message<"zdc.UpdateStorageRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: bool is_default = 4;
   */
  isDefault: boolean;

  /**
   * @generated from field: int64 max_size = 5;
   */
  maxSize: bigint;

  /**
   * @generated from field: string config = 6;
   */
  config: string;
};

/**
 * Describes the message zdc.UpdateStorageRequest.
 * Use `create(UpdateStorageRequestSchema)` to create a new message.
 */
export const UpdateStorageRequestSchema: GenMessage<UpdateStorageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 43);

/**
 * @generated from message zdc.DeleteStorageRequest
 */
export type DeleteStorageRequest = Message<"zdc.DeleteStorageRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.DeleteStorageRequest.
 * Use `create(DeleteStorageRequestSchema)` to create a new message.
 */
export const DeleteStorageRequestSchema: GenMessage<DeleteStorageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 44);

/**
 * @generated from message zdc.UploadFileRequest
 */
export type UploadFileRequest = Message<"zdc.UploadFileRequest"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: string file_type = 3;
   */
  fileType: string;

  /**
   * пусто = хранилище по умолчанию
   *
   * @generated from field: string storage_code = 4;
   */
  storageCode: string;

  /**
   * Владелец файла (запись справочника/документа, как в 1С): файл создаётся
   * в системном справочнике «ФайлыПоДокументам» с owner_id = owner_id
   *
   * @generated from field: string owner_id = 5;
   */
  ownerId: string;

  /**
   * Геокоординаты (чувствительные данные): хранятся, НЕ возвращаются наружу
   * (GetFileInfo/ListFiles их не содержат). Настройка показа — отдельный этап.
   *
   * @generated from field: double geo_lat = 6;
   */
  geoLat: number;

  /**
   * @generated from field: double geo_lon = 7;
   */
  geoLon: number;

  /**
   * M4 «Версии файлов»: id существующего файла — загрузка НОВОЙ ВЕРСИИ
   * (содержимое заменяется, история сохраняется; ссылки на файл не меняются).
   *
   * @generated from field: string as_new_version_of = 8;
   */
  asNewVersionOf: string;
};

/**
 * Describes the message zdc.UploadFileRequest.
 * Use `create(UploadFileRequestSchema)` to create a new message.
 */
export const UploadFileRequestSchema: GenMessage<UploadFileRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 45);

/**
 * @generated from message zdc.FileInfo
 */
export type FileInfo = Message<"zdc.FileInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: int64 file_size = 3;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_type = 4;
   */
  fileType: string;

  /**
   * @generated from field: string storage_code = 5;
   */
  storageCode: string;

  /**
   * @generated from field: string file_key = 6;
   */
  fileKey: string;

  /**
   * @generated from field: string file_hash = 7;
   */
  fileHash: string;
};

/**
 * Describes the message zdc.FileInfo.
 * Use `create(FileInfoSchema)` to create a new message.
 */
export const FileInfoSchema: GenMessage<FileInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 46);

/**
 * @generated from message zdc.DownloadFileRequest
 */
export type DownloadFileRequest = Message<"zdc.DownloadFileRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DownloadFileRequest.
 * Use `create(DownloadFileRequestSchema)` to create a new message.
 */
export const DownloadFileRequestSchema: GenMessage<DownloadFileRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 47);

/**
 * @generated from message zdc.DownloadFileResponse
 */
export type DownloadFileResponse = Message<"zdc.DownloadFileResponse"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * @generated from field: string file_type = 2;
   */
  fileType: string;

  /**
   * @generated from field: string file_name = 3;
   */
  fileName: string;
};

/**
 * Describes the message zdc.DownloadFileResponse.
 * Use `create(DownloadFileResponseSchema)` to create a new message.
 */
export const DownloadFileResponseSchema: GenMessage<DownloadFileResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 48);

/**
 * @generated from message zdc.StartChunkedUploadRequest
 */
export type StartChunkedUploadRequest = Message<"zdc.StartChunkedUploadRequest"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: string file_type = 2;
   */
  fileType: string;

  /**
   * размер чанка, байт (клиент; сервер не валидирует жёстко)
   *
   * @generated from field: int32 chunk_size = 3;
   */
  chunkSize: number;

  /**
   * всего чанков
   *
   * @generated from field: int32 total_chunks = 4;
   */
  totalChunks: number;

  /**
   * размер файла, байт
   *
   * @generated from field: int64 total_size = 5;
   */
  totalSize: bigint;

  /**
   * целевое хранилище (пусто = по умолчанию)
   *
   * @generated from field: string storage_code = 6;
   */
  storageCode: string;

  /**
   * владелец (запись объекта), как в UploadFile
   *
   * @generated from field: string owner_id = 7;
   */
  ownerId: string;

  /**
   * геокоординаты (чувствительные данные; как в UploadFile)
   *
   * @generated from field: double geo_lat = 8;
   */
  geoLat: number;

  /**
   * @generated from field: double geo_lon = 9;
   */
  geoLon: number;
};

/**
 * Describes the message zdc.StartChunkedUploadRequest.
 * Use `create(StartChunkedUploadRequestSchema)` to create a new message.
 */
export const StartChunkedUploadRequestSchema: GenMessage<StartChunkedUploadRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 49);

/**
 * @generated from message zdc.ChunkedUploadInfo
 */
export type ChunkedUploadInfo = Message<"zdc.ChunkedUploadInfo"> & {
  /**
   * id передачи (глобально уникален)
   *
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: int32 total_chunks = 3;
   */
  totalChunks: number;

  /**
   * @generated from field: int64 total_size = 4;
   */
  totalSize: bigint;

  /**
   * Чанки, УЖЕ принятые сервером (массив index) — клиент докачивает
   * отсутствующие (возобновление с места паузы/перезагрузки).
   *
   * @generated from field: repeated int32 received_chunks = 5;
   */
  receivedChunks: number[];

  /**
   * Файл создан (после последнего чанка) — id записи «Файлы» (FileInfo.id).
   *
   * @generated from field: string file_id = 6;
   */
  fileId: string;
};

/**
 * Describes the message zdc.ChunkedUploadInfo.
 * Use `create(ChunkedUploadInfoSchema)` to create a new message.
 */
export const ChunkedUploadInfoSchema: GenMessage<ChunkedUploadInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 50);

/**
 * @generated from message zdc.UploadChunkRequest
 */
export type UploadChunkRequest = Message<"zdc.UploadChunkRequest"> & {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;

  /**
   * 0-based
   *
   * @generated from field: int32 index = 2;
   */
  index: number;

  /**
   * содержимое чанка (≤ chunk_size)
   *
   * @generated from field: bytes data = 3;
   */
  data: Uint8Array;

  /**
   * последний чанк → собрать файл
   *
   * @generated from field: bool is_last = 4;
   */
  isLast: boolean;
};

/**
 * Describes the message zdc.UploadChunkRequest.
 * Use `create(UploadChunkRequestSchema)` to create a new message.
 */
export const UploadChunkRequestSchema: GenMessage<UploadChunkRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 51);

/**
 * @generated from message zdc.AbortChunkedUploadRequest
 */
export type AbortChunkedUploadRequest = Message<"zdc.AbortChunkedUploadRequest"> & {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;
};

/**
 * Describes the message zdc.AbortChunkedUploadRequest.
 * Use `create(AbortChunkedUploadRequestSchema)` to create a new message.
 */
export const AbortChunkedUploadRequestSchema: GenMessage<AbortChunkedUploadRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 52);

/**
 * @generated from message zdc.GetChunkedUploadRequest
 */
export type GetChunkedUploadRequest = Message<"zdc.GetChunkedUploadRequest"> & {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;
};

/**
 * Describes the message zdc.GetChunkedUploadRequest.
 * Use `create(GetChunkedUploadRequestSchema)` to create a new message.
 */
export const GetChunkedUploadRequestSchema: GenMessage<GetChunkedUploadRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 53);

/**
 * @generated from message zdc.GetFileInfoRequest
 */
export type GetFileInfoRequest = Message<"zdc.GetFileInfoRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetFileInfoRequest.
 * Use `create(GetFileInfoRequestSchema)` to create a new message.
 */
export const GetFileInfoRequestSchema: GenMessage<GetFileInfoRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 54);

/**
 * @generated from message zdc.GetFileThumbRequest
 */
export type GetFileThumbRequest = Message<"zdc.GetFileThumbRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * ширина превью (по умолчанию 320; высота по пропорции)
   *
   * @generated from field: int32 width = 2;
   */
  width: number;

  /**
   * момент видео (мс; по умолчанию 1000); картинки игнорируют
   *
   * @generated from field: int32 moment_ms = 3;
   */
  momentMs: number;
};

/**
 * Describes the message zdc.GetFileThumbRequest.
 * Use `create(GetFileThumbRequestSchema)` to create a new message.
 */
export const GetFileThumbRequestSchema: GenMessage<GetFileThumbRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 55);

/**
 * @generated from message zdc.GetFileThumbResponse
 */
export type GetFileThumbResponse = Message<"zdc.GetFileThumbResponse"> & {
  /**
   * JPEG-миниатюра
   *
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * "image/jpeg"
   *
   * @generated from field: string file_type = 2;
   */
  fileType: string;
};

/**
 * Describes the message zdc.GetFileThumbResponse.
 * Use `create(GetFileThumbResponseSchema)` to create a new message.
 */
export const GetFileThumbResponseSchema: GenMessage<GetFileThumbResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 56);

/**
 * @generated from message zdc.ListFilesRequest
 */
export type ListFilesRequest = Message<"zdc.ListFilesRequest"> & {
  /**
   * пусто = все файлы
   *
   * @generated from field: string owner_id = 1;
   */
  ownerId: string;

  /**
   * Включать файлы СВЯЗАННЫХ задач (задачи с subject_id = ownerId): файлы
   * остаются в задачах, но доступны и через объект (напр., вкладка заявки).
   *
   * @generated from field: bool include_linked = 2;
   */
  includeLinked: boolean;
};

/**
 * Describes the message zdc.ListFilesRequest.
 * Use `create(ListFilesRequestSchema)` to create a new message.
 */
export const ListFilesRequestSchema: GenMessage<ListFilesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 57);

/**
 * @generated from message zdc.FileDetailList
 */
export type FileDetailList = Message<"zdc.FileDetailList"> & {
  /**
   * @generated from field: repeated zdc.FileDetail items = 1;
   */
  items: FileDetail[];
};

/**
 * Describes the message zdc.FileDetailList.
 * Use `create(FileDetailListSchema)` to create a new message.
 */
export const FileDetailListSchema: GenMessage<FileDetailList> = /*@__PURE__*/
  messageDesc(file_zdc, 58);

/**
 * Сведения о файле для карточки (SSoT — сервер): имя, размер, тип,
 * кто загрузил (имя пользователя) и когда.
 *
 * @generated from message zdc.FileDetail
 */
export type FileDetail = Message<"zdc.FileDetail"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: int64 file_size = 3;
   */
  fileSize: bigint;

  /**
   * @generated from field: string file_type = 4;
   */
  fileType: string;

  /**
   * имя пользователя (created_by → entities.name)
   *
   * @generated from field: string uploaded_by = 5;
   */
  uploadedBy: string;

  /**
   * created_at записи файла
   *
   * @generated from field: string uploaded_at = 6;
   */
  uploadedAt: string;

  /**
   * Владелец файла (file_links.document): пусто для «все файлы»; при
   * include_linked показывает, что файл принадлежит связанному объекту (задаче).
   *
   * @generated from field: string owner_id = 7;
   */
  ownerId: string;
};

/**
 * Describes the message zdc.FileDetail.
 * Use `create(FileDetailSchema)` to create a new message.
 */
export const FileDetailSchema: GenMessage<FileDetail> = /*@__PURE__*/
  messageDesc(file_zdc, 59);

/**
 * @generated from message zdc.DeleteFileRequest
 */
export type DeleteFileRequest = Message<"zdc.DeleteFileRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteFileRequest.
 * Use `create(DeleteFileRequestSchema)` to create a new message.
 */
export const DeleteFileRequestSchema: GenMessage<DeleteFileRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 60);

/**
 * Синк файлов (offline-first): метаданные + SHA-256 (клиент качает дельту).
 *
 * @generated from message zdc.FileHashEntry
 */
export type FileHashEntry = Message<"zdc.FileHashEntry"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string file_hash = 2;
   */
  fileHash: string;

  /**
   * @generated from field: int64 file_size = 3;
   */
  fileSize: bigint;
};

/**
 * Describes the message zdc.FileHashEntry.
 * Use `create(FileHashEntrySchema)` to create a new message.
 */
export const FileHashEntrySchema: GenMessage<FileHashEntry> = /*@__PURE__*/
  messageDesc(file_zdc, 61);

/**
 * @generated from message zdc.FileHashList
 */
export type FileHashList = Message<"zdc.FileHashList"> & {
  /**
   * @generated from field: repeated zdc.FileHashEntry items = 1;
   */
  items: FileHashEntry[];
};

/**
 * Describes the message zdc.FileHashList.
 * Use `create(FileHashListSchema)` to create a new message.
 */
export const FileHashListSchema: GenMessage<FileHashList> = /*@__PURE__*/
  messageDesc(file_zdc, 62);

/**
 * ParseContentRequest — разбор содержимого файла по id.
 *
 * @generated from message zdc.ParseContentRequest
 */
export type ParseContentRequest = Message<"zdc.ParseContentRequest"> & {
  /**
   * @generated from field: string file_id = 1;
   */
  fileId: string;
};

/**
 * Describes the message zdc.ParseContentRequest.
 * Use `create(ParseContentRequestSchema)` to create a new message.
 */
export const ParseContentRequestSchema: GenMessage<ParseContentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 63);

/**
 * @generated from message zdc.ContentSheet
 */
export type ContentSheet = Message<"zdc.ContentSheet"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: repeated zdc.ContentRow rows = 2;
   */
  rows: ContentRow[];
};

/**
 * Describes the message zdc.ContentSheet.
 * Use `create(ContentSheetSchema)` to create a new message.
 */
export const ContentSheetSchema: GenMessage<ContentSheet> = /*@__PURE__*/
  messageDesc(file_zdc, 64);

/**
 * @generated from message zdc.ContentRow
 */
export type ContentRow = Message<"zdc.ContentRow"> & {
  /**
   * @generated from field: repeated string cells = 1;
   */
  cells: string[];
};

/**
 * Describes the message zdc.ContentRow.
 * Use `create(ContentRowSchema)` to create a new message.
 */
export const ContentRowSchema: GenMessage<ContentRow> = /*@__PURE__*/
  messageDesc(file_zdc, 65);

/**
 * @generated from message zdc.ParseContentResponse
 */
export type ParseContentResponse = Message<"zdc.ParseContentResponse"> & {
  /**
   * text | csv | xlsx | docx
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * для text/docx
   *
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * для xlsx/csv
   *
   * @generated from field: repeated zdc.ContentSheet sheets = 3;
   */
  sheets: ContentSheet[];

  /**
   * детерминированная ошибка разбора (не HTTP)
   *
   * @generated from field: string error = 4;
   */
  error: string;
};

/**
 * Describes the message zdc.ParseContentResponse.
 * Use `create(ParseContentResponseSchema)` to create a new message.
 */
export const ParseContentResponseSchema: GenMessage<ParseContentResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 66);

/**
 * @generated from message zdc.PictureLibrary
 */
export type PictureLibrary = Message<"zdc.PictureLibrary"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * → metadata_storages.code
   *
   * @generated from field: string storage_code = 5;
   */
  storageCode: string;

  /**
   * @generated from field: bool is_system = 6;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 7;
   */
  templateId: string;

  /**
   * per-user: userId, пусто = общая
   *
   * @generated from field: string owner_id = 8;
   */
  ownerId: string;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 10;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.PictureLibrary.
 * Use `create(PictureLibrarySchema)` to create a new message.
 */
export const PictureLibrarySchema: GenMessage<PictureLibrary> = /*@__PURE__*/
  messageDesc(file_zdc, 67);

/**
 * @generated from message zdc.Picture
 */
export type Picture = Message<"zdc.Picture"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string library_code = 2;
   */
  libraryCode: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string synonym = 4;
   */
  synonym: string;

  /**
   * → files.id
   *
   * @generated from field: string file_id = 5;
   */
  fileId: string;

  /**
   * @generated from field: bool is_system = 6;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 7;
   */
  templateId: string;

  /**
   * @generated from field: string owner_id = 8;
   */
  ownerId: string;

  /**
   * @generated from field: int32 sort_order = 9;
   */
  sortOrder: number;

  /**
   * @generated from field: string created_at = 10;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 11;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.Picture.
 * Use `create(PictureSchema)` to create a new message.
 */
export const PictureSchema: GenMessage<Picture> = /*@__PURE__*/
  messageDesc(file_zdc, 68);

/**
 * @generated from message zdc.PictureLibraryList
 */
export type PictureLibraryList = Message<"zdc.PictureLibraryList"> & {
  /**
   * @generated from field: repeated zdc.PictureLibrary items = 1;
   */
  items: PictureLibrary[];
};

/**
 * Describes the message zdc.PictureLibraryList.
 * Use `create(PictureLibraryListSchema)` to create a new message.
 */
export const PictureLibraryListSchema: GenMessage<PictureLibraryList> = /*@__PURE__*/
  messageDesc(file_zdc, 69);

/**
 * @generated from message zdc.PictureList
 */
export type PictureList = Message<"zdc.PictureList"> & {
  /**
   * @generated from field: repeated zdc.Picture items = 1;
   */
  items: Picture[];
};

/**
 * Describes the message zdc.PictureList.
 * Use `create(PictureListSchema)` to create a new message.
 */
export const PictureListSchema: GenMessage<PictureList> = /*@__PURE__*/
  messageDesc(file_zdc, 70);

/**
 * @generated from message zdc.ListPictureLibrariesRequest
 */
export type ListPictureLibrariesRequest = Message<"zdc.ListPictureLibrariesRequest"> & {
  /**
   * фильтр: пусто = все
   *
   * @generated from field: string owner_id = 1;
   */
  ownerId: string;
};

/**
 * Describes the message zdc.ListPictureLibrariesRequest.
 * Use `create(ListPictureLibrariesRequestSchema)` to create a new message.
 */
export const ListPictureLibrariesRequestSchema: GenMessage<ListPictureLibrariesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 71);

/**
 * @generated from message zdc.GetPictureLibraryRequest
 */
export type GetPictureLibraryRequest = Message<"zdc.GetPictureLibraryRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.GetPictureLibraryRequest.
 * Use `create(GetPictureLibraryRequestSchema)` to create a new message.
 */
export const GetPictureLibraryRequestSchema: GenMessage<GetPictureLibraryRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 72);

/**
 * @generated from message zdc.SavePictureLibraryRequest
 */
export type SavePictureLibraryRequest = Message<"zdc.SavePictureLibraryRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string storage_code = 5;
   */
  storageCode: string;
};

/**
 * Describes the message zdc.SavePictureLibraryRequest.
 * Use `create(SavePictureLibraryRequestSchema)` to create a new message.
 */
export const SavePictureLibraryRequestSchema: GenMessage<SavePictureLibraryRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 73);

/**
 * @generated from message zdc.DeletePictureLibraryRequest
 */
export type DeletePictureLibraryRequest = Message<"zdc.DeletePictureLibraryRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.DeletePictureLibraryRequest.
 * Use `create(DeletePictureLibraryRequestSchema)` to create a new message.
 */
export const DeletePictureLibraryRequestSchema: GenMessage<DeletePictureLibraryRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 74);

/**
 * @generated from message zdc.ListPicturesRequest
 */
export type ListPicturesRequest = Message<"zdc.ListPicturesRequest"> & {
  /**
   * пусто = все
   *
   * @generated from field: string library_code = 1;
   */
  libraryCode: string;
};

/**
 * Describes the message zdc.ListPicturesRequest.
 * Use `create(ListPicturesRequestSchema)` to create a new message.
 */
export const ListPicturesRequestSchema: GenMessage<ListPicturesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 75);

/**
 * @generated from message zdc.GetPictureRequest
 */
export type GetPictureRequest = Message<"zdc.GetPictureRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.GetPictureRequest.
 * Use `create(GetPictureRequestSchema)` to create a new message.
 */
export const GetPictureRequestSchema: GenMessage<GetPictureRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 76);

/**
 * @generated from message zdc.SavePictureRequest
 */
export type SavePictureRequest = Message<"zdc.SavePictureRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string library_code = 2;
   */
  libraryCode: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string synonym = 4;
   */
  synonym: string;

  /**
   * @generated from field: string file_id = 5;
   */
  fileId: string;

  /**
   * @generated from field: int32 sort_order = 6;
   */
  sortOrder: number;
};

/**
 * Describes the message zdc.SavePictureRequest.
 * Use `create(SavePictureRequestSchema)` to create a new message.
 */
export const SavePictureRequestSchema: GenMessage<SavePictureRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 77);

/**
 * @generated from message zdc.DeletePictureRequest
 */
export type DeletePictureRequest = Message<"zdc.DeletePictureRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.DeletePictureRequest.
 * Use `create(DeletePictureRequestSchema)` to create a new message.
 */
export const DeletePictureRequestSchema: GenMessage<DeletePictureRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 78);

/**
 * @generated from message zdc.ClearStorageRequest
 */
export type ClearStorageRequest = Message<"zdc.ClearStorageRequest"> & {
  /**
   * folder-хранилище: удалить все файлы в каталоге
   *
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.ClearStorageRequest.
 * Use `create(ClearStorageRequestSchema)` to create a new message.
 */
export const ClearStorageRequestSchema: GenMessage<ClearStorageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 79);

/**
 * @generated from message zdc.ResolveReferenceRequest
 */
export type ResolveReferenceRequest = Message<"zdc.ResolveReferenceRequest"> & {
  /**
   * Дескрипторы состава типа: 'Справочник.X','Документ.Y','catalog.x','document.y'
   *
   * @generated from field: repeated string types = 1;
   */
  types: string[];

  /**
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message zdc.ResolveReferenceRequest.
 * Use `create(ResolveReferenceRequestSchema)` to create a new message.
 */
export const ResolveReferenceRequestSchema: GenMessage<ResolveReferenceRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 80);

/**
 * @generated from message zdc.ResolveReferenceResponse
 */
export type ResolveReferenceResponse = Message<"zdc.ResolveReferenceResponse"> & {
  /**
   * 'catalog' | 'document' | 'enumeration'
   *
   * @generated from field: string object_type = 1;
   */
  objectType: string;

  /**
   * физическая таблица
   *
   * @generated from field: string object_name = 2;
   */
  objectName: string;

  /**
   * представление записи (name/code), если найдена
   *
   * @generated from field: string presentation = 3;
   */
  presentation: string;
};

/**
 * Describes the message zdc.ResolveReferenceResponse.
 * Use `create(ResolveReferenceResponseSchema)` to create a new message.
 */
export const ResolveReferenceResponseSchema: GenMessage<ResolveReferenceResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 81);

/**
 * @generated from message zdc.ExecuteHydraqlRequest
 */
export type ExecuteHydraqlRequest = Message<"zdc.ExecuteHydraqlRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: map<string, string> params = 2;
   */
  params: { [key: string]: string };
};

/**
 * Describes the message zdc.ExecuteHydraqlRequest.
 * Use `create(ExecuteHydraqlRequestSchema)` to create a new message.
 */
export const ExecuteHydraqlRequestSchema: GenMessage<ExecuteHydraqlRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 82);

/**
 * @generated from message zdc.HydraqlResponse
 */
export type HydraqlResponse = Message<"zdc.HydraqlResponse"> & {
  /**
   * @generated from field: repeated string columns = 1;
   */
  columns: string[];

  /**
   * @generated from field: repeated zdc.HydraqlRow rows = 2;
   */
  rows: HydraqlRow[];

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message zdc.HydraqlResponse.
 * Use `create(HydraqlResponseSchema)` to create a new message.
 */
export const HydraqlResponseSchema: GenMessage<HydraqlResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 83);

/**
 * @generated from message zdc.HydraqlRow
 */
export type HydraqlRow = Message<"zdc.HydraqlRow"> & {
  /**
   * @generated from field: repeated zdc.TableDataValue values = 1;
   */
  values: TableDataValue[];
};

/**
 * Describes the message zdc.HydraqlRow.
 * Use `create(HydraqlRowSchema)` to create a new message.
 */
export const HydraqlRowSchema: GenMessage<HydraqlRow> = /*@__PURE__*/
  messageDesc(file_zdc, 84);

/**
 * @generated from message zdc.ListTableDataRequest
 */
export type ListTableDataRequest = Message<"zdc.ListTableDataRequest"> & {
  /**
   * @generated from field: string schema = 1;
   */
  schema: string;

  /**
   * @generated from field: string table = 2;
   */
  table: string;

  /**
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;

  /**
   * @generated from field: int32 page = 4;
   */
  page: number;

  /**
   * @generated from field: string order_by = 5;
   */
  orderBy: string;

  /**
   * @generated from field: bool order_desc = 6;
   */
  orderDesc: boolean;

  /**
   * Показывать помеченные на удаление (is_marked=true) — только при праве
   * «Просмотр помеченных» (can_view_marked); по умолчанию скрыты (как в 1С)
   *
   * @generated from field: bool include_marked = 7;
   */
  includeMarked: boolean;

  /**
   * Отборы (SSoT — сервер фильтрует): {column, value} — точное равенство;
   * используется менеджером записи регистра (read/write) и произвольными формами
   *
   * @generated from field: repeated zdc.TableDataValue filters = 8;
   */
  filters: TableDataValue[];
};

/**
 * Describes the message zdc.ListTableDataRequest.
 * Use `create(ListTableDataRequestSchema)` to create a new message.
 */
export const ListTableDataRequestSchema: GenMessage<ListTableDataRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 85);

/**
 * АВТОПОДБОР (дополнения платформы): поиск представлений в таблице-источнике.
 *
 * @generated from message zdc.SuggestReferenceRequest
 */
export type SuggestReferenceRequest = Message<"zdc.SuggestReferenceRequest"> & {
  /**
   * физическая таблица источника (addresses, counterparties, entities…)
   *
   * @generated from field: string ref_table = 1;
   */
  refTable: string;

  /**
   * текст для поиска (name/code/value/number LIKE)
   *
   * @generated from field: string query = 2;
   */
  query: string;

  /**
   * максимум вариантов (по умолчанию 8)
   *
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message zdc.SuggestReferenceRequest.
 * Use `create(SuggestReferenceRequestSchema)` to create a new message.
 */
export const SuggestReferenceRequestSchema: GenMessage<SuggestReferenceRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 86);

/**
 * @generated from message zdc.SuggestReferenceResponse
 */
export type SuggestReferenceResponse = Message<"zdc.SuggestReferenceResponse"> & {
  /**
   * @generated from field: repeated zdc.SuggestReferenceItem items = 1;
   */
  items: SuggestReferenceItem[];
};

/**
 * Describes the message zdc.SuggestReferenceResponse.
 * Use `create(SuggestReferenceResponseSchema)` to create a new message.
 */
export const SuggestReferenceResponseSchema: GenMessage<SuggestReferenceResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 87);

/**
 * @generated from message zdc.SuggestReferenceItem
 */
export type SuggestReferenceItem = Message<"zdc.SuggestReferenceItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * представление (для адресов — value; для остальных — name)
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * код/номер (если есть)
   *
   * @generated from field: string code = 3;
   */
  code: string;
};

/**
 * Describes the message zdc.SuggestReferenceItem.
 * Use `create(SuggestReferenceItemSchema)` to create a new message.
 */
export const SuggestReferenceItemSchema: GenMessage<SuggestReferenceItem> = /*@__PURE__*/
  messageDesc(file_zdc, 88);

/**
 * @generated from message zdc.TableDataColumn
 */
export type TableDataColumn = Message<"zdc.TableDataColumn"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string data_type = 2;
   */
  dataType: string;

  /**
   * @generated from field: bool nullable = 3;
   */
  nullable: boolean;
};

/**
 * Describes the message zdc.TableDataColumn.
 * Use `create(TableDataColumnSchema)` to create a new message.
 */
export const TableDataColumnSchema: GenMessage<TableDataColumn> = /*@__PURE__*/
  messageDesc(file_zdc, 89);

/**
 * @generated from message zdc.TableDataRow
 */
export type TableDataRow = Message<"zdc.TableDataRow"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: repeated zdc.TableDataValue values = 2;
   */
  values: TableDataValue[];
};

/**
 * Describes the message zdc.TableDataRow.
 * Use `create(TableDataRowSchema)` to create a new message.
 */
export const TableDataRowSchema: GenMessage<TableDataRow> = /*@__PURE__*/
  messageDesc(file_zdc, 90);

/**
 * @generated from message zdc.TableDataValue
 */
export type TableDataValue = Message<"zdc.TableDataValue"> & {
  /**
   * @generated from field: string column = 1;
   */
  column: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message zdc.TableDataValue.
 * Use `create(TableDataValueSchema)` to create a new message.
 */
export const TableDataValueSchema: GenMessage<TableDataValue> = /*@__PURE__*/
  messageDesc(file_zdc, 91);

/**
 * @generated from message zdc.TableDataResponse
 */
export type TableDataResponse = Message<"zdc.TableDataResponse"> & {
  /**
   * @generated from field: repeated zdc.TableDataColumn columns = 1;
   */
  columns: TableDataColumn[];

  /**
   * @generated from field: repeated zdc.TableDataRow rows = 2;
   */
  rows: TableDataRow[];

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message zdc.TableDataResponse.
 * Use `create(TableDataResponseSchema)` to create a new message.
 */
export const TableDataResponseSchema: GenMessage<TableDataResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 92);

/**
 * @generated from message zdc.CreateTableRowRequest
 */
export type CreateTableRowRequest = Message<"zdc.CreateTableRowRequest"> & {
  /**
   * @generated from field: string schema = 1;
   */
  schema: string;

  /**
   * @generated from field: string table = 2;
   */
  table: string;

  /**
   * @generated from field: repeated zdc.TableDataValue values = 3;
   */
  values: TableDataValue[];

  /**
   * Реквизиты ФОРМЫ (виртуальные, как 1С): передаются в onBeforeSave
   * (РеквизитыФормы.X), в таблицу НЕ пишутся.
   *
   * @generated from field: map<string, string> form_attributes = 4;
   */
  formAttributes: { [key: string]: string };
};

/**
 * Describes the message zdc.CreateTableRowRequest.
 * Use `create(CreateTableRowRequestSchema)` to create a new message.
 */
export const CreateTableRowRequestSchema: GenMessage<CreateTableRowRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 93);

/**
 * @generated from message zdc.UpdateTableRowRequest
 */
export type UpdateTableRowRequest = Message<"zdc.UpdateTableRowRequest"> & {
  /**
   * @generated from field: string schema = 1;
   */
  schema: string;

  /**
   * @generated from field: string table = 2;
   */
  table: string;

  /**
   * @generated from field: string row_id = 3;
   */
  rowId: string;

  /**
   * @generated from field: repeated zdc.TableDataValue values = 4;
   */
  values: TableDataValue[];

  /**
   * @generated from field: map<string, string> form_attributes = 5;
   */
  formAttributes: { [key: string]: string };
};

/**
 * Describes the message zdc.UpdateTableRowRequest.
 * Use `create(UpdateTableRowRequestSchema)` to create a new message.
 */
export const UpdateTableRowRequestSchema: GenMessage<UpdateTableRowRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 94);

/**
 * @generated from message zdc.DeleteTableRowRequest
 */
export type DeleteTableRowRequest = Message<"zdc.DeleteTableRowRequest"> & {
  /**
   * @generated from field: string schema = 1;
   */
  schema: string;

  /**
   * @generated from field: string table = 2;
   */
  table: string;

  /**
   * @generated from field: string row_id = 3;
   */
  rowId: string;

  /**
   * permanent=true — ФИЗИЧЕСКОЕ удаление (пометка is_marked не ставится);
   * по умолчанию (false) — пометка на удаление (is_marked=true), запись скрывается
   *
   * @generated from field: bool permanent = 4;
   */
  permanent: boolean;
};

/**
 * Describes the message zdc.DeleteTableRowRequest.
 * Use `create(DeleteTableRowRequestSchema)` to create a new message.
 */
export const DeleteTableRowRequestSchema: GenMessage<DeleteTableRowRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 95);

/**
 * @generated from message zdc.ObjectRight
 */
export type ObjectRight = Message<"zdc.ObjectRight"> & {
  /**
   * @generated from field: string role_id = 1;
   */
  roleId: string;

  /**
   * имя роли (сервер подставляет для отображения)
   *
   * @generated from field: string role_name = 2;
   */
  roleName: string;

  /**
   * Чтение
   *
   * @generated from field: bool can_read = 3;
   */
  canRead: boolean;

  /**
   * Добавление
   *
   * @generated from field: bool can_create = 4;
   */
  canCreate: boolean;

  /**
   * Изменение
   *
   * @generated from field: bool can_update = 5;
   */
  canUpdate: boolean;

  /**
   * Удаление (пометка и физическое удаление)
   *
   * @generated from field: bool can_delete = 6;
   */
  canDelete: boolean;

  /**
   * Просмотр помеченных на удаление
   *
   * @generated from field: bool can_view_marked = 7;
   */
  canViewMarked: boolean;
};

/**
 * Describes the message zdc.ObjectRight.
 * Use `create(ObjectRightSchema)` to create a new message.
 */
export const ObjectRightSchema: GenMessage<ObjectRight> = /*@__PURE__*/
  messageDesc(file_zdc, 96);

/**
 * @generated from message zdc.ObjectRightsList
 */
export type ObjectRightsList = Message<"zdc.ObjectRightsList"> & {
  /**
   * @generated from field: repeated zdc.ObjectRight items = 1;
   */
  items: ObjectRight[];
};

/**
 * Describes the message zdc.ObjectRightsList.
 * Use `create(ObjectRightsListSchema)` to create a new message.
 */
export const ObjectRightsListSchema: GenMessage<ObjectRightsList> = /*@__PURE__*/
  messageDesc(file_zdc, 97);

/**
 * ============================================================
 * Хранилище настроек (user_settings): key-value JSON, привязка к пользователю
 * ============================================================
 *
 * @generated from message zdc.UserSetting
 */
export type UserSetting = Message<"zdc.UserSetting"> & {
  /**
   * пусто = ГЛОБАЛЬНАЯ настройка
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * JSON
   *
   * @generated from field: string value = 3;
   */
  value: string;

  /**
   * @generated from field: string updated_at = 4;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.UserSetting.
 * Use `create(UserSettingSchema)` to create a new message.
 */
export const UserSettingSchema: GenMessage<UserSetting> = /*@__PURE__*/
  messageDesc(file_zdc, 98);

/**
 * @generated from message zdc.UserSettingsList
 */
export type UserSettingsList = Message<"zdc.UserSettingsList"> & {
  /**
   * @generated from field: repeated zdc.UserSetting items = 1;
   */
  items: UserSetting[];
};

/**
 * Describes the message zdc.UserSettingsList.
 * Use `create(UserSettingsListSchema)` to create a new message.
 */
export const UserSettingsListSchema: GenMessage<UserSettingsList> = /*@__PURE__*/
  messageDesc(file_zdc, 99);

/**
 * @generated from message zdc.GetUserSettingsRequest
 */
export type GetUserSettingsRequest = Message<"zdc.GetUserSettingsRequest"> & {
};

/**
 * Describes the message zdc.GetUserSettingsRequest.
 * Use `create(GetUserSettingsRequestSchema)` to create a new message.
 */
export const GetUserSettingsRequestSchema: GenMessage<GetUserSettingsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 100);

/**
 * Настройки обсуждения объекта метаданных (вкладка «Обсуждения»):
 * авто-участники контекстного чата. entity_type: catalog/document/task/order.
 *
 * @generated from message zdc.GetChatSettingsRequest
 */
export type GetChatSettingsRequest = Message<"zdc.GetChatSettingsRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;
};

/**
 * Describes the message zdc.GetChatSettingsRequest.
 * Use `create(GetChatSettingsRequestSchema)` to create a new message.
 */
export const GetChatSettingsRequestSchema: GenMessage<GetChatSettingsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 101);

/**
 * @generated from message zdc.SetChatSettingsRequest
 */
export type SetChatSettingsRequest = Message<"zdc.SetChatSettingsRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;

  /**
   * добавлять авто-участников при создании чата
   *
   * @generated from field: bool auto_participants = 3;
   */
  autoParticipants: boolean;

  /**
   * Состав авто-участников (мультивыбор):
   * 'author' — создатель записи (created_by);
   * 'assignee' — автор/исполнитель (author_id/assignee_id — задачи/заявки);
   * 'user_refs' — все реквизиты-ссылки на пользователя (ref entities).
   *
   * @generated from field: repeated string participant_kinds = 4;
   */
  participantKinds: string[];
};

/**
 * Describes the message zdc.SetChatSettingsRequest.
 * Use `create(SetChatSettingsRequestSchema)` to create a new message.
 */
export const SetChatSettingsRequestSchema: GenMessage<SetChatSettingsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 102);

/**
 * @generated from message zdc.ChatSettings
 */
export type ChatSettings = Message<"zdc.ChatSettings"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;

  /**
   * @generated from field: bool auto_participants = 3;
   */
  autoParticipants: boolean;

  /**
   * @generated from field: repeated string participant_kinds = 4;
   */
  participantKinds: string[];
};

/**
 * Describes the message zdc.ChatSettings.
 * Use `create(ChatSettingsSchema)` to create a new message.
 */
export const ChatSettingsSchema: GenMessage<ChatSettings> = /*@__PURE__*/
  messageDesc(file_zdc, 103);

/**
 * @generated from message zdc.SetUserSettingRequest
 */
export type SetUserSettingRequest = Message<"zdc.SetUserSettingRequest"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * JSON
   *
   * @generated from field: string value = 2;
   */
  value: string;

  /**
   * пусто = глобально (только админ); свой — любой
   *
   * @generated from field: string user_id = 3;
   */
  userId: string;
};

/**
 * Describes the message zdc.SetUserSettingRequest.
 * Use `create(SetUserSettingRequestSchema)` to create a new message.
 */
export const SetUserSettingRequestSchema: GenMessage<SetUserSettingRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 104);

/**
 * @generated from message zdc.DeleteUserSettingRequest
 */
export type DeleteUserSettingRequest = Message<"zdc.DeleteUserSettingRequest"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * пусто = глобальная
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * Describes the message zdc.DeleteUserSettingRequest.
 * Use `create(DeleteUserSettingRequestSchema)` to create a new message.
 */
export const DeleteUserSettingRequestSchema: GenMessage<DeleteUserSettingRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 105);

/**
 * @generated from message zdc.ListAllUserSettingsRequest
 */
export type ListAllUserSettingsRequest = Message<"zdc.ListAllUserSettingsRequest"> & {
  /**
   * фильтр: пусто = все
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message zdc.ListAllUserSettingsRequest.
 * Use `create(ListAllUserSettingsRequestSchema)` to create a new message.
 */
export const ListAllUserSettingsRequestSchema: GenMessage<ListAllUserSettingsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 106);

/**
 * @generated from message zdc.GetObjectRightsRequest
 */
export type GetObjectRightsRequest = Message<"zdc.GetObjectRightsRequest"> & {
  /**
   * 'catalog' | 'document' | 'register'
   *
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;
};

/**
 * Describes the message zdc.GetObjectRightsRequest.
 * Use `create(GetObjectRightsRequestSchema)` to create a new message.
 */
export const GetObjectRightsRequestSchema: GenMessage<GetObjectRightsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 107);

/**
 * @generated from message zdc.SetObjectRightsRequest
 */
export type SetObjectRightsRequest = Message<"zdc.SetObjectRightsRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;

  /**
   * Полный набор прав: заменяет существующий (записи полностью совпадающие
   * с правами по умолчанию можно не передавать). Пустой список = сброс к
   * правам по умолчанию (все роли получают полный доступ).
   *
   * @generated from field: repeated zdc.ObjectRight rights = 3;
   */
  rights: ObjectRight[];
};

/**
 * Describes the message zdc.SetObjectRightsRequest.
 * Use `create(SetObjectRightsRequestSchema)` to create a new message.
 */
export const SetObjectRightsRequestSchema: GenMessage<SetObjectRightsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 108);

/**
 * @generated from message zdc.Layout
 */
export type Layout = Message<"zdc.Layout"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 'object' (объект метаданных) | 'common' (общий)
   *
   * @generated from field: string parent_type = 2;
   */
  parentType: string;

  /**
   * код объекта (для object)
   *
   * @generated from field: string parent_code = 3;
   */
  parentCode: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * tabular | text | html | word | image | binary
   *
   * @generated from field: string layout_type = 5;
   */
  layoutType: string;

  /**
   * текст (text/html) или JSON-описание
   *
   * @generated from field: string content = 6;
   */
  content: string;

  /**
   * base64 (tabular=xlsx, word=docx, image, binary)
   *
   * @generated from field: string binary_content = 7;
   */
  binaryContent: string;

  /**
   * @generated from field: string description = 8;
   */
  description: string;

  /**
   * @generated from field: bool is_active = 9;
   */
  isActive: boolean;

  /**
   * @generated from field: string created_at = 10;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 11;
   */
  updatedAt: string;

  /**
   * отображаемое имя (как в 1С)
   *
   * @generated from field: string synonym = 12;
   */
  synonym: string;

  /**
   * Печатная форма (как в 1С): допустимо ТОЛЬКО для parent_type='object'.
   *
   * @generated from field: bool is_print = 13;
   */
  isPrint: boolean;
};

/**
 * Describes the message zdc.Layout.
 * Use `create(LayoutSchema)` to create a new message.
 */
export const LayoutSchema: GenMessage<Layout> = /*@__PURE__*/
  messageDesc(file_zdc, 109);

/**
 * @generated from message zdc.LayoutList
 */
export type LayoutList = Message<"zdc.LayoutList"> & {
  /**
   * @generated from field: repeated zdc.Layout items = 1;
   */
  items: Layout[];
};

/**
 * Describes the message zdc.LayoutList.
 * Use `create(LayoutListSchema)` to create a new message.
 */
export const LayoutListSchema: GenMessage<LayoutList> = /*@__PURE__*/
  messageDesc(file_zdc, 110);

/**
 * @generated from message zdc.ListLayoutsRequest
 */
export type ListLayoutsRequest = Message<"zdc.ListLayoutsRequest"> & {
  /**
   * 'object' | 'common' (пусто = все)
   *
   * @generated from field: string parent_type = 1;
   */
  parentType: string;

  /**
   * @generated from field: string parent_code = 2;
   */
  parentCode: string;

  /**
   * true = только печатные формы (false = без фильтра)
   *
   * @generated from field: bool is_print = 3;
   */
  isPrint: boolean;
};

/**
 * Describes the message zdc.ListLayoutsRequest.
 * Use `create(ListLayoutsRequestSchema)` to create a new message.
 */
export const ListLayoutsRequestSchema: GenMessage<ListLayoutsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 111);

/**
 * @generated from message zdc.GetLayoutRequest
 */
export type GetLayoutRequest = Message<"zdc.GetLayoutRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetLayoutRequest.
 * Use `create(GetLayoutRequestSchema)` to create a new message.
 */
export const GetLayoutRequestSchema: GenMessage<GetLayoutRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 112);

/**
 * @generated from message zdc.CreateLayoutRequest
 */
export type CreateLayoutRequest = Message<"zdc.CreateLayoutRequest"> & {
  /**
   * @generated from field: string parent_type = 1;
   */
  parentType: string;

  /**
   * @generated from field: string parent_code = 2;
   */
  parentCode: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string layout_type = 4;
   */
  layoutType: string;

  /**
   * @generated from field: string content = 5;
   */
  content: string;

  /**
   * @generated from field: string binary_content = 6;
   */
  binaryContent: string;

  /**
   * @generated from field: string description = 7;
   */
  description: string;

  /**
   * @generated from field: string synonym = 8;
   */
  synonym: string;

  /**
   * печатная форма — только parent_type='object'
   *
   * @generated from field: bool is_print = 9;
   */
  isPrint: boolean;
};

/**
 * Describes the message zdc.CreateLayoutRequest.
 * Use `create(CreateLayoutRequestSchema)` to create a new message.
 */
export const CreateLayoutRequestSchema: GenMessage<CreateLayoutRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 113);

/**
 * @generated from message zdc.UpdateLayoutRequest
 */
export type UpdateLayoutRequest = Message<"zdc.UpdateLayoutRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string layout_type = 3;
   */
  layoutType: string;

  /**
   * @generated from field: string content = 4;
   */
  content: string;

  /**
   * @generated from field: string binary_content = 5;
   */
  binaryContent: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: bool is_active = 7;
   */
  isActive: boolean;

  /**
   * @generated from field: string synonym = 8;
   */
  synonym: string;

  /**
   * печатная форма — только parent_type='object'
   *
   * @generated from field: bool is_print = 9;
   */
  isPrint: boolean;
};

/**
 * Describes the message zdc.UpdateLayoutRequest.
 * Use `create(UpdateLayoutRequestSchema)` to create a new message.
 */
export const UpdateLayoutRequestSchema: GenMessage<UpdateLayoutRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 114);

/**
 * @generated from message zdc.DeleteLayoutRequest
 */
export type DeleteLayoutRequest = Message<"zdc.DeleteLayoutRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteLayoutRequest.
 * Use `create(DeleteLayoutRequestSchema)` to create a new message.
 */
export const DeleteLayoutRequestSchema: GenMessage<DeleteLayoutRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 115);

/**
 * @generated from message zdc.RenderLayoutRequest
 */
export type RenderLayoutRequest = Message<"zdc.RenderLayoutRequest"> & {
  /**
   * @generated from field: string layout_id = 1;
   */
  layoutId: string;

  /**
   * Параметры подстановки {{Поле}} в макете: имя → значение
   *
   * @generated from field: map<string, string> params = 2;
   */
  params: { [key: string]: string };

  /**
   * Формат результата: 'xlsx' | 'pdf' | 'html' | 'docx' | 'txt' (по типу макета)
   *
   * @generated from field: string format = 3;
   */
  format: string;

  /**
   * record_id — ПЕЧАТЬ ПО ЗАПИСИ (SSoT — сервер): параметры собираются из полей
   * записи (значения + {col}_presentation + русские имена полей), а повторяемая
   * область макета — из строк табличной части записи. Требует макет
   * parent_type='object' с is_print=true. Пусто — обычный рендер по params.
   *
   * @generated from field: string record_id = 4;
   */
  recordId: string;
};

/**
 * Describes the message zdc.RenderLayoutRequest.
 * Use `create(RenderLayoutRequestSchema)` to create a new message.
 */
export const RenderLayoutRequestSchema: GenMessage<RenderLayoutRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 116);

/**
 * @generated from message zdc.RenderLayoutResponse
 */
export type RenderLayoutResponse = Message<"zdc.RenderLayoutResponse"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * @generated from field: string mime_type = 2;
   */
  mimeType: string;

  /**
   * @generated from field: string file_name = 3;
   */
  fileName: string;
};

/**
 * Describes the message zdc.RenderLayoutResponse.
 * Use `create(RenderLayoutResponseSchema)` to create a new message.
 */
export const RenderLayoutResponseSchema: GenMessage<RenderLayoutResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 117);

/**
 * @generated from message zdc.ConvertXlsRequest
 */
export type ConvertXlsRequest = Message<"zdc.ConvertXlsRequest"> & {
  /**
   * base64 .xls (старый бинарный формат)
   *
   * @generated from field: string data = 1;
   */
  data: string;

  /**
   * имя листа (пусто = «Лист1»)
   *
   * @generated from field: string sheet_name = 2;
   */
  sheetName: string;
};

/**
 * Describes the message zdc.ConvertXlsRequest.
 * Use `create(ConvertXlsRequestSchema)` to create a new message.
 */
export const ConvertXlsRequestSchema: GenMessage<ConvertXlsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 118);

/**
 * @generated from message zdc.ConvertXlsResponse
 */
export type ConvertXlsResponse = Message<"zdc.ConvertXlsResponse"> & {
  /**
   * base64 .xlsx
   *
   * @generated from field: string data = 1;
   */
  data: string;
};

/**
 * Describes the message zdc.ConvertXlsResponse.
 * Use `create(ConvertXlsResponseSchema)` to create a new message.
 */
export const ConvertXlsResponseSchema: GenMessage<ConvertXlsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 119);

/**
 * @generated from message zdc.TableRowResponse
 */
export type TableRowResponse = Message<"zdc.TableRowResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: repeated zdc.TableDataValue values = 2;
   */
  values: TableDataValue[];
};

/**
 * Describes the message zdc.TableRowResponse.
 * Use `create(TableRowResponseSchema)` to create a new message.
 */
export const TableRowResponseSchema: GenMessage<TableRowResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 120);

/**
 * ===== ЕДИНЫЙ МЕХАНИЗМ ФОРМ (SSoT) =====
 *
 * @generated from message zdc.FormManifestField
 */
export type FormManifestField = Message<"zdc.FormManifestField"> & {
  /**
   * ключ значения на форме (el.attribute макета)
   *
   * @generated from field: string attribute = 1;
   */
  attribute: string;

  /**
   * подпись поля
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * physical | form_attribute | special
   *
   * @generated from field: string purpose = 3;
   */
  purpose: string;

  /**
   * физическая колонка (для physical)
   *
   * @generated from field: string column = 4;
   */
  column: string;

  /**
   * тип данных (рендер)
   *
   * @generated from field: string data_type = 5;
   */
  dataType: string;

  /**
   * таблица-источник ссылки
   *
   * @generated from field: string ref_table = 6;
   */
  refTable: string;

  /**
   * @generated from field: string ref_object_type = 7;
   */
  refObjectType: string;

  /**
   * @generated from field: string ref_object_name = 8;
   */
  refObjectName: string;

  /**
   * @generated from field: bool is_required = 9;
   */
  isRequired: boolean;

  /**
   * @generated from field: bool read_only = 10;
   */
  readOnly: boolean;

  /**
   * @generated from field: bool hidden_by_default = 11;
   */
  hiddenByDefault: boolean;

  /**
   * дополнения с элемента макета
   *
   * @generated from field: repeated zdc.FieldExtensionRef extensions = 12;
   */
  extensions: FieldExtensionRef[];

  /**
   * составной тип (дескрипторы)
   *
   * @generated from field: repeated string types = 13;
   */
  types: string[];

  /**
   * @generated from field: string defined_type_id = 14;
   */
  definedTypeId: string;

  /**
   * @generated from field: string source_settings = 15;
   */
  sourceSettings: string;

  /**
   * @generated from field: string format = 16;
   */
  format: string;

  /**
   * @generated from field: int32 importance = 17;
   */
  importance: number;
};

/**
 * Describes the message zdc.FormManifestField.
 * Use `create(FormManifestFieldSchema)` to create a new message.
 */
export const FormManifestFieldSchema: GenMessage<FormManifestField> = /*@__PURE__*/
  messageDesc(file_zdc, 121);

/**
 * @generated from message zdc.FieldExtensionRef
 */
export type FieldExtensionRef = Message<"zdc.FieldExtensionRef"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * JSON
   *
   * @generated from field: string settings = 2;
   */
  settings: string;
};

/**
 * Describes the message zdc.FieldExtensionRef.
 * Use `create(FieldExtensionRefSchema)` to create a new message.
 */
export const FieldExtensionRefSchema: GenMessage<FieldExtensionRef> = /*@__PURE__*/
  messageDesc(file_zdc, 122);

/**
 * @generated from message zdc.FormManifestTabular
 */
export type FormManifestTabular = Message<"zdc.FormManifestTabular"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string synonym = 2;
   */
  synonym: string;

  /**
   * @generated from field: string table = 3;
   */
  table: string;
};

/**
 * Describes the message zdc.FormManifestTabular.
 * Use `create(FormManifestTabularSchema)` to create a new message.
 */
export const FormManifestTabularSchema: GenMessage<FormManifestTabular> = /*@__PURE__*/
  messageDesc(file_zdc, 123);

/**
 * @generated from message zdc.FormManifest
 */
export type FormManifest = Message<"zdc.FormManifest"> & {
  /**
   * @generated from field: string form_id = 1;
   */
  formId: string;

  /**
   * @generated from field: string form_name = 2;
   */
  formName: string;

  /**
   * @generated from field: string form_type = 3;
   */
  formType: string;

  /**
   * catalog|document|order|task|register|system
   *
   * @generated from field: string object_type = 4;
   */
  objectType: string;

  /**
   * @generated from field: string object_name = 5;
   */
  objectName: string;

  /**
   * для модулей/прав (order/orders и т.п.)
   *
   * @generated from field: string entity_type = 6;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 7;
   */
  entityCode: string;

  /**
   * физическая таблица записи
   *
   * @generated from field: string table = 8;
   */
  table: string;

  /**
   * @generated from field: repeated zdc.FormManifestField fields = 9;
   */
  fields: FormManifestField[];

  /**
   * @generated from field: repeated zdc.FormManifestTabular tabular_sections = 10;
   */
  tabularSections: FormManifestTabular[];

  /**
   * @generated from field: bool has_object_form = 11;
   */
  hasObjectForm: boolean;
};

/**
 * Describes the message zdc.FormManifest.
 * Use `create(FormManifestSchema)` to create a new message.
 */
export const FormManifestSchema: GenMessage<FormManifest> = /*@__PURE__*/
  messageDesc(file_zdc, 124);

/**
 * @generated from message zdc.GetFormManifestRequest
 */
export type GetFormManifestRequest = Message<"zdc.GetFormManifestRequest"> & {
  /**
   * @generated from field: string form_id = 1;
   */
  formId: string;
};

/**
 * Describes the message zdc.GetFormManifestRequest.
 * Use `create(GetFormManifestRequestSchema)` to create a new message.
 */
export const GetFormManifestRequestSchema: GenMessage<GetFormManifestRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 125);

/**
 * @generated from message zdc.SaveFormRequest
 */
export type SaveFormRequest = Message<"zdc.SaveFormRequest"> & {
  /**
   * @generated from field: string form_id = 1;
   */
  formId: string;

  /**
   * пусто = создать
   *
   * @generated from field: string record_id = 2;
   */
  recordId: string;

  /**
   * attribute → value (String)
   *
   * @generated from field: map<string, string> values = 3;
   */
  values: { [key: string]: string };

  /**
   * @generated from field: int32 expected_version = 4;
   */
  expectedVersion: number;
};

/**
 * Describes the message zdc.SaveFormRequest.
 * Use `create(SaveFormRequestSchema)` to create a new message.
 */
export const SaveFormRequestSchema: GenMessage<SaveFormRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 126);

/**
 * @generated from message zdc.SaveFormResponse
 */
export type SaveFormResponse = Message<"zdc.SaveFormResponse"> & {
  /**
   * @generated from field: string record_id = 1;
   */
  recordId: string;

  /**
   * итоговые физические значения
   *
   * @generated from field: map<string, string> values = 2;
   */
  values: { [key: string]: string };

  /**
   * реквизиты формы (изменённые модулем)
   *
   * @generated from field: map<string, string> form_attributes = 3;
   */
  formAttributes: { [key: string]: string };

  /**
   * @generated from field: string error = 4;
   */
  error: string;
};

/**
 * Describes the message zdc.SaveFormResponse.
 * Use `create(SaveFormResponseSchema)` to create a new message.
 */
export const SaveFormResponseSchema: GenMessage<SaveFormResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 127);

/**
 * @generated from message zdc.GetAuditHistoryRequest
 */
export type GetAuditHistoryRequest = Message<"zdc.GetAuditHistoryRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message zdc.GetAuditHistoryRequest.
 * Use `create(GetAuditHistoryRequestSchema)` to create a new message.
 */
export const GetAuditHistoryRequestSchema: GenMessage<GetAuditHistoryRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 128);

/**
 * @generated from message zdc.AuditRecord
 */
export type AuditRecord = Message<"zdc.AuditRecord"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 3;
   */
  entityCode: string;

  /**
   * @generated from field: string operation = 4;
   */
  operation: string;

  /**
   * @generated from field: string old_data = 5;
   */
  oldData: string;

  /**
   * @generated from field: string new_data = 6;
   */
  newData: string;

  /**
   * @generated from field: string performed_by = 7;
   */
  performedBy: string;

  /**
   * @generated from field: string performed_at = 8;
   */
  performedAt: string;
};

/**
 * Describes the message zdc.AuditRecord.
 * Use `create(AuditRecordSchema)` to create a new message.
 */
export const AuditRecordSchema: GenMessage<AuditRecord> = /*@__PURE__*/
  messageDesc(file_zdc, 129);

/**
 * @generated from message zdc.AuditHistoryResponse
 */
export type AuditHistoryResponse = Message<"zdc.AuditHistoryResponse"> & {
  /**
   * @generated from field: repeated zdc.AuditRecord records = 1;
   */
  records: AuditRecord[];
};

/**
 * Describes the message zdc.AuditHistoryResponse.
 * Use `create(AuditHistoryResponseSchema)` to create a new message.
 */
export const AuditHistoryResponseSchema: GenMessage<AuditHistoryResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 130);

/**
 * Нумераторы: автокод справочников / автономер документов
 *
 * @generated from message zdc.GetNumberingRequest
 */
export type GetNumberingRequest = Message<"zdc.GetNumberingRequest"> & {
  /**
   * catalog | document
   *
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;

  /**
   * code | number
   *
   * @generated from field: string field_name = 3;
   */
  fieldName: string;
};

/**
 * Describes the message zdc.GetNumberingRequest.
 * Use `create(GetNumberingRequestSchema)` to create a new message.
 */
export const GetNumberingRequestSchema: GenMessage<GetNumberingRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 131);

/**
 * @generated from message zdc.SetNumberingRequest
 */
export type SetNumberingRequest = Message<"zdc.SetNumberingRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;

  /**
   * @generated from field: string field_name = 3;
   */
  fieldName: string;

  /**
   * @generated from field: string prefix = 4;
   */
  prefix: string;

  /**
   * строка из '0' — ширина с нулями; пусто = без паддинга
   *
   * @generated from field: string format = 5;
   */
  format: string;

  /**
   * @generated from field: int32 start_value = 6;
   */
  startValue: number;

  /**
   * @generated from field: int32 step = 7;
   */
  step: number;

  /**
   * '' | year | month | day
   *
   * @generated from field: string period = 8;
   */
  period: string;
};

/**
 * Describes the message zdc.SetNumberingRequest.
 * Use `create(SetNumberingRequestSchema)` to create a new message.
 */
export const SetNumberingRequestSchema: GenMessage<SetNumberingRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 132);

/**
 * @generated from message zdc.NumberingConfig
 */
export type NumberingConfig = Message<"zdc.NumberingConfig"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;

  /**
   * @generated from field: string field_name = 3;
   */
  fieldName: string;

  /**
   * @generated from field: string prefix = 4;
   */
  prefix: string;

  /**
   * @generated from field: string format = 5;
   */
  format: string;

  /**
   * @generated from field: int32 start_value = 6;
   */
  startValue: number;

  /**
   * @generated from field: int32 step = 7;
   */
  step: number;

  /**
   * @generated from field: string period = 8;
   */
  period: string;

  /**
   * @generated from field: int32 current_value = 9;
   */
  currentValue: number;

  /**
   * @generated from field: string last_period = 10;
   */
  lastPeriod: string;
};

/**
 * Describes the message zdc.NumberingConfig.
 * Use `create(NumberingConfigSchema)` to create a new message.
 */
export const NumberingConfigSchema: GenMessage<NumberingConfig> = /*@__PURE__*/
  messageDesc(file_zdc, 133);

/**
 * @generated from message zdc.Base
 */
export type Base = Message<"zdc.Base"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string slug = 3;
   */
  slug: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string connection_type = 5;
   */
  connectionType: string;

  /**
   * @generated from field: string connection_string = 6;
   */
  connectionString: string;

  /**
   * @generated from field: bool is_published = 7;
   */
  isPublished: boolean;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 9;
   */
  updatedAt: string;

  /**
   * sqlite, postgres
   *
   * @generated from field: string db_type = 10;
   */
  dbType: string;

  /**
   * path or DSN
   *
   * @generated from field: string db_dsn = 11;
   */
  dbDsn: string;

  /**
   * draft, published, archived
   *
   * @generated from field: string status = 12;
   */
  status: string;

  /**
   * @generated from field: bool is_default = 13;
   */
  isDefault: boolean;

  /**
   * @generated from field: string admin_user = 14;
   */
  adminUser: string;

  /**
   * @generated from field: bool sync_enabled = 15;
   */
  syncEnabled: boolean;

  /**
   * @generated from field: int64 last_sync_version = 16;
   */
  lastSyncVersion: bigint;

  /**
   * @generated from field: string last_sync_at = 17;
   */
  lastSyncAt: string;

  /**
   * @generated from field: int64 version = 18;
   */
  version: bigint;

  /**
   * JSON-настройки базы (саморегистрация, шаблон логина и др.)
   *
   * @generated from field: string settings = 19;
   */
  settings: string;
};

/**
 * Describes the message zdc.Base.
 * Use `create(BaseSchema)` to create a new message.
 */
export const BaseSchema: GenMessage<Base> = /*@__PURE__*/
  messageDesc(file_zdc, 134);

/**
 * @generated from message zdc.BaseList
 */
export type BaseList = Message<"zdc.BaseList"> & {
  /**
   * @generated from field: repeated zdc.Base items = 1;
   */
  items: Base[];
};

/**
 * Describes the message zdc.BaseList.
 * Use `create(BaseListSchema)` to create a new message.
 */
export const BaseListSchema: GenMessage<BaseList> = /*@__PURE__*/
  messageDesc(file_zdc, 135);

/**
 * Владелец справочника/документа (как в 1С): владельцем может быть
 * справочник ИЛИ документ (пользовательский сценарий «Заявка» → «Задачи»).
 *
 * @generated from message zdc.CatalogOwner
 */
export type CatalogOwner = Message<"zdc.CatalogOwner"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * 'catalog' | 'document'
   *
   * @generated from field: string type = 2;
   */
  type: string;
};

/**
 * Describes the message zdc.CatalogOwner.
 * Use `create(CatalogOwnerSchema)` to create a new message.
 */
export const CatalogOwnerSchema: GenMessage<CatalogOwner> = /*@__PURE__*/
  messageDesc(file_zdc, 136);

/**
 * @generated from message zdc.Catalog
 */
export type Catalog = Message<"zdc.Catalog"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string synonym = 4;
   */
  synonym: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: string base_id = 6;
   */
  baseId: string;

  /**
   * @generated from field: repeated zdc.Field fields = 7;
   */
  fields: Field[];

  /**
   * @generated from field: repeated zdc.TabularSection tabular_sections = 8;
   */
  tabularSections: TabularSection[];

  /**
   * @generated from field: repeated zdc.Form forms = 9;
   */
  forms: Form[];

  /**
   * @generated from field: repeated zdc.Module modules = 10;
   */
  modules: Module[];

  /**
   * @generated from field: string created_at = 11;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 12;
   */
  updatedAt: string;

  /**
   * @generated from field: bool is_audit_enabled = 13;
   */
  isAuditEnabled: boolean;

  /**
   * Иерархия (как в 1С): '' | 'groups_and_items' | 'items'
   *
   * @generated from field: string hierarchy_type = 14;
   */
  hierarchyType: string;

  /**
   * Владельцы (как в 1С): справочники/документы-владельцы (может быть несколько);
   * владелец типа 'defined_type' — определяемый тип (объекты из его состава)
   *
   * @generated from field: repeated zdc.CatalogOwner owners = 15;
   */
  owners: CatalogOwner[];

  /**
   * Развёрнутые владельцы: определяемые типы раскрыты в реальные объекты состава
   * (для вкладок подчинённых, пикера владельца, представлений) — SSoT: сервер
   *
   * @generated from field: repeated zdc.CatalogOwner resolved_owners = 16;
   */
  resolvedOwners: CatalogOwner[];

  /**
   * Права ТЕКУЩЕГО пользователя (сервер заполняет по ролям из JWT;
   * для конфигуратора-админа — все права). Права по ролям — GetObjectRights
   *
   * @generated from field: zdc.ObjectRight rights = 17;
   */
  rights?: ObjectRight | undefined;

  /**
   * Виды списка/объекта (десктоп/мобильный): единый механизм видов
   *
   * @generated from field: string view_settings = 18;
   */
  viewSettings: string;

  /**
   * Отслеживание прочтения (objects_reads): открытие формы → прочитано
   *
   * @generated from field: bool track_reads = 19;
   */
  trackReads: boolean;

  /**
   * Объект ПОСТАВКИ (template_id): защищён от изменения/удаления, метка в дереве
   *
   * @generated from field: string template_id = 20;
   */
  templateId: string;

  /**
   * Системный справочник ЯДРА (как в 1С): «Файлы» (files_po_dokumentam) —
   * защищён от удаления, метка «СИСТ.» в дереве
   *
   * @generated from field: bool is_system = 21;
   */
  isSystem: boolean;
};

/**
 * Describes the message zdc.Catalog.
 * Use `create(CatalogSchema)` to create a new message.
 */
export const CatalogSchema: GenMessage<Catalog> = /*@__PURE__*/
  messageDesc(file_zdc, 137);

/**
 * @generated from message zdc.CatalogList
 */
export type CatalogList = Message<"zdc.CatalogList"> & {
  /**
   * @generated from field: repeated zdc.Catalog items = 1;
   */
  items: Catalog[];
};

/**
 * Describes the message zdc.CatalogList.
 * Use `create(CatalogListSchema)` to create a new message.
 */
export const CatalogListSchema: GenMessage<CatalogList> = /*@__PURE__*/
  messageDesc(file_zdc, 138);

/**
 * @generated from message zdc.Document
 */
export type Document = Message<"zdc.Document"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string base_id = 5;
   */
  baseId: string;

  /**
   * @generated from field: repeated zdc.Field fields = 6;
   */
  fields: Field[];

  /**
   * @generated from field: repeated zdc.TabularSection tabular_sections = 7;
   */
  tabularSections: TabularSection[];

  /**
   * @generated from field: repeated zdc.Form forms = 8;
   */
  forms: Form[];

  /**
   * @generated from field: repeated zdc.Module modules = 9;
   */
  modules: Module[];

  /**
   * @generated from field: string created_at = 10;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 11;
   */
  updatedAt: string;

  /**
   * @generated from field: bool is_audit_enabled = 12;
   */
  isAuditEnabled: boolean;

  /**
   * Права ТЕКУЩЕГО пользователя (см. Catalog.rights)
   *
   * @generated from field: zdc.ObjectRight rights = 13;
   */
  rights?: ObjectRight | undefined;

  /**
   * Виды списка/объекта (десктоп/мобильный): единый механизм видов
   *
   * @generated from field: string view_settings = 14;
   */
  viewSettings: string;

  /**
   * Отслеживание прочтения (objects_reads)
   *
   * @generated from field: bool track_reads = 15;
   */
  trackReads: boolean;

  /**
   * Объект ПОСТАВКИ (template_id): защищён от изменения/удаления, метка в дереве
   *
   * @generated from field: string template_id = 16;
   */
  templateId: string;

  /**
   * Синоним (отображаемое имя: «Договоры» при name='Dogovory') — как у Catalog
   *
   * @generated from field: string synonym = 17;
   */
  synonym: string;
};

/**
 * Describes the message zdc.Document.
 * Use `create(DocumentSchema)` to create a new message.
 */
export const DocumentSchema: GenMessage<Document> = /*@__PURE__*/
  messageDesc(file_zdc, 139);

/**
 * @generated from message zdc.DocumentList
 */
export type DocumentList = Message<"zdc.DocumentList"> & {
  /**
   * @generated from field: repeated zdc.Document items = 1;
   */
  items: Document[];
};

/**
 * Describes the message zdc.DocumentList.
 * Use `create(DocumentListSchema)` to create a new message.
 */
export const DocumentListSchema: GenMessage<DocumentList> = /*@__PURE__*/
  messageDesc(file_zdc, 140);

/**
 * @generated from message zdc.Register
 */
export type Register = Message<"zdc.Register"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string base_id = 5;
   */
  baseId: string;

  /**
   * @generated from field: string register_type = 6;
   */
  registerType: string;

  /**
   * @generated from field: repeated zdc.RegisterDimension dimensions = 7;
   */
  dimensions: RegisterDimension[];

  /**
   * @generated from field: repeated zdc.RegisterResource resources = 8;
   */
  resources: RegisterResource[];

  /**
   * @generated from field: repeated zdc.Form forms = 9;
   */
  forms: Form[];

  /**
   * @generated from field: repeated zdc.Module modules = 10;
   */
  modules: Module[];

  /**
   * @generated from field: string created_at = 11;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 12;
   */
  updatedAt: string;

  /**
   * @generated from field: bool is_audit_enabled = 13;
   */
  isAuditEnabled: boolean;

  /**
   * Права текущего пользователя (как Catalog.rights)
   *
   * @generated from field: zdc.ObjectRight rights = 14;
   */
  rights?: ObjectRight | undefined;

  /**
   * Свойства регистра (как в 1С)
   *
   * накопление: 'balance' | 'turnover'
   *
   * @generated from field: string accumulation_kind = 15;
   */
  accumulationKind: string;

  /**
   * сведения: '' | 'second' | 'day' | 'month' | 'quarter' | 'year'
   *
   * @generated from field: string periodicity = 16;
   */
  periodicity: string;

  /**
   * сведения: '' | 'to_registrator'
   *
   * @generated from field: string subordination = 17;
   */
  subordination: string;

  /**
   * физическая таблица движений
   *
   * @generated from field: string movements_table = 18;
   */
  movementsTable: string;

  /**
   * схема (PostgreSQL)
   *
   * @generated from field: string schema_name = 19;
   */
  schemaName: string;

  /**
   * системный регистр (связи) — защита от удаления
   *
   * @generated from field: bool is_system = 20;
   */
  isSystem: boolean;

  /**
   * синоним (отображаемое имя: «Задачи», «Заявки», «Файлы»)
   *
   * @generated from field: string synonym = 21;
   */
  synonym: string;

  /**
   * объект ПОСТАВКИ (защита + метка в дереве)
   *
   * @generated from field: string template_id = 22;
   */
  templateId: string;

  /**
   * Бухгалтерский регистр (учёт: шаг 1): корреспонденция (MVP — только true),
   * план счетов и число субконто (0..3)
   *
   * @generated from field: bool supports_correspondence = 23;
   */
  supportsCorrespondence: boolean;

  /**
   * @generated from field: string chart_of_accounts_code = 24;
   */
  chartOfAccountsCode: string;

  /**
   * @generated from field: int32 max_subconto_count = 25;
   */
  maxSubcontoCount: number;
};

/**
 * Describes the message zdc.Register.
 * Use `create(RegisterSchema)` to create a new message.
 */
export const RegisterSchema: GenMessage<Register> = /*@__PURE__*/
  messageDesc(file_zdc, 141);

/**
 * @generated from message zdc.RegisterList
 */
export type RegisterList = Message<"zdc.RegisterList"> & {
  /**
   * @generated from field: repeated zdc.Register items = 1;
   */
  items: Register[];
};

/**
 * Describes the message zdc.RegisterList.
 * Use `create(RegisterListSchema)` to create a new message.
 */
export const RegisterListSchema: GenMessage<RegisterList> = /*@__PURE__*/
  messageDesc(file_zdc, 142);

/**
 * @generated from message zdc.RegisterDimension
 */
export type RegisterDimension = Message<"zdc.RegisterDimension"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string dimension_type = 4;
   */
  dimensionType: string;

  /**
   * @generated from field: string data_type = 5;
   */
  dataType: string;

  /**
   * @generated from field: string ref_catalog_code = 6;
   */
  refCatalogCode: string;

  /**
   * @generated from field: bool is_active = 7;
   */
  isActive: boolean;
};

/**
 * Describes the message zdc.RegisterDimension.
 * Use `create(RegisterDimensionSchema)` to create a new message.
 */
export const RegisterDimensionSchema: GenMessage<RegisterDimension> = /*@__PURE__*/
  messageDesc(file_zdc, 143);

/**
 * @generated from message zdc.RegisterResource
 */
export type RegisterResource = Message<"zdc.RegisterResource"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string resource_type = 5;
   */
  resourceType: string;

  /**
   * @generated from field: string data_type = 6;
   */
  dataType: string;

  /**
   * @generated from field: bool is_active = 7;
   */
  isActive: boolean;
};

/**
 * Describes the message zdc.RegisterResource.
 * Use `create(RegisterResourceSchema)` to create a new message.
 */
export const RegisterResourceSchema: GenMessage<RegisterResource> = /*@__PURE__*/
  messageDesc(file_zdc, 144);

/**
 * Параметр выбора (как в 1С): статичный отбор формы выбора,
 * например {field: "is_marked", condition: "=", value: "false"}.
 *
 * @generated from message zdc.SelectionParam
 */
export type SelectionParam = Message<"zdc.SelectionParam"> & {
  /**
   * поле отбора (физическая колонка: 'is_marked', 'code', ...)
   *
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * '=' | '!=' | '>' | '<' | '>=' | '<=' | 'like' | 'is_null' | 'is_not_null'
   *
   * @generated from field: string condition = 2;
   */
  condition: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * Describes the message zdc.SelectionParam.
 * Use `create(SelectionParamSchema)` to create a new message.
 */
export const SelectionParamSchema: GenMessage<SelectionParam> = /*@__PURE__*/
  messageDesc(file_zdc, 145);

/**
 * Связь параметра выбора (как в 1С): параметр формы выбора ← реквизит формы/колонка ТЧ.
 * Значение реквизита подставляется в параметр при открытии формы выбора.
 * Пример: {param: "Владелец", field: "Номенклатура"} — фильтр owner_id = значение поля «Номенклатура».
 *
 * @generated from message zdc.SelectionLink
 */
export type SelectionLink = Message<"zdc.SelectionLink"> & {
  /**
   * параметр формы выбора ('Владелец')
   *
   * @generated from field: string param = 1;
   */
  param: string;

  /**
   * реквизит формы / колонка той же ТЧ, значение которого подставляется
   *
   * @generated from field: string field = 2;
   */
  field: string;
};

/**
 * Describes the message zdc.SelectionLink.
 * Use `create(SelectionLinkSchema)` to create a new message.
 */
export const SelectionLinkSchema: GenMessage<SelectionLink> = /*@__PURE__*/
  messageDesc(file_zdc, 146);

/**
 * @generated from message zdc.Field
 */
export type Field = Message<"zdc.Field"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string field_type = 5;
   */
  fieldType: string;

  /**
   * @generated from field: string data_type = 6;
   */
  dataType: string;

  /**
   * @generated from field: bool is_required = 7;
   */
  isRequired: boolean;

  /**
   * @generated from field: bool is_nullable = 8;
   */
  isNullable: boolean;

  /**
   * @generated from field: string default_value = 9;
   */
  defaultValue: string;

  /**
   * @generated from field: string ref_catalog_code = 10;
   */
  refCatalogCode: string;

  /**
   * @generated from field: string ref_document_code = 11;
   */
  refDocumentCode: string;

  /**
   * @generated from field: string enum_values = 12;
   */
  enumValues: string;

  /**
   * @generated from field: bool is_active = 13;
   */
  isActive: boolean;

  /**
   * @generated from field: int32 order = 14;
   */
  order: number;

  /**
   * @generated from field: string created_at = 15;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 16;
   */
  updatedAt: string;

  /**
   * Составной тип (как в 1С): дескрипторы типов — 'text','number','date','boolean',
   * 'Справочник.Код','Документ.Код','ОпределяемыйТип.Имя'
   *
   * @generated from field: repeated string types = 17;
   */
  types: string[];

  /**
   * Определяемый тип (как в 1С): тип создаётся программно, ссылается на существующие типы
   *
   * @generated from field: string defined_type_id = 18;
   */
  definedTypeId: string;

  /**
   * @generated from field: string ref_table = 19;
   */
  refTable: string;

  /**
   * Параметры выбора (как в 1С): статичные отборы формы выбора этого поля
   *
   * @generated from field: repeated zdc.SelectionParam selection_params = 20;
   */
  selectionParams: SelectionParam[];

  /**
   * Связи параметров выбора (как в 1С): параметр формы выбора ← реквизит формы
   *
   * @generated from field: repeated zdc.SelectionLink selection_links = 21;
   */
  selectionLinks: SelectionLink[];

  /**
   * Синоним (отображаемое имя, как в 1С): для колонок списков/заголовков
   *
   * @generated from field: string synonym = 22;
   */
  synonym: string;

  /**
   * ВАЖНОСТЬ ОТОБРАЖЕНИЯ в карточке (1..5, default 3; как в 1С):
   * 5 — заголовок карточки, 4 — вторая строка, 3 — основная строка,
   * 1–2 — страницы-точки (листание). Универсальный механизм карточного
   * движка: применяется в списках (viewMode=cards), формах, страницах.
   *
   * @generated from field: int32 importance = 23;
   */
  importance: number;

  /**
   * ФОРМАТ ВЫВОДА (как в 1С): универсальная строка формата,
   * применяется во ВСЕХ точках вывода (списки/карточки/формы/ТЧ/отчёты).
   * Примеры: 'date:dd.MM.yyyy' (дата без времени), 'date:dd.MM.yyyy HH:mm',
   * 'number:2' (2 знака), 'number:0;group' (с группировкой).
   *
   * @generated from field: string format = 24;
   */
  format: string;

  /**
   * ИСТОЧНИК ДАННЫХ (универсальный механизм «поле с источником», SSoT — сервер):
   * JSON {"api":"dadata","operation":"find-party"|"suggest-address",
   * "query_field":"inn","mapping":[{"from":"name","to":"name"},...]} —
   * автодополнение/подбор из внешних API (ExternalAPI) + авто-заполнение формы.
   *
   * @generated from field: string source_settings = 25;
   */
  sourceSettings: string;

  /**
   * СКРЫТО ПО УМОЛЧАНИЮ (универсальный механизм, как в 1С): поле НЕ выводится
   * в авто-колонках списков, авто-формах объектов, карточках и формах выбора,
   * если пользователь не выбрал его ЯВНО (макет/колонки кастомной формы).
   * Служебные поля (например «Код» справочника) помечаются при создании;
   * любое поле можно пометить вручную. Значение по умолчанию — false.
   *
   * @generated from field: bool hidden_by_default = 26;
   */
  hiddenByDefault: boolean;

  /**
   * ВИД ДВИЖЕНИЯ РЕГИСТРА (как в 1С): '' (обычное поле) | 'dimension' (измерение)
   * | 'resource' (ресурс) | 'special' (реквизит). Поля регистров — ЕДИНЫЙ
   * механизм с реквизитами объектов (metadata_fields).
   *
   * @generated from field: string field_kind = 27;
   */
  fieldKind: string;

  /**
   * Проверка заполнения (quality)
   *
   * @generated from field: string check = 33;
   */
  check: string;

  /**
   * Объект ПОСТАВКИ (template_id): защита + метка в дереве
   *
   * @generated from field: string template_id = 28;
   */
  templateId: string;

  /**
   * СИСТЕМНЫЙ реквизит ЯДРА (Создал/Изменил/Даты — ЕДИНЫЙ механизм
   * system_fields.go): метка «СИСТ.», защита от удаления
   *
   * @generated from field: bool is_system = 29;
   */
  isSystem: boolean;

  /**
   * ПОДСКАЗКА реквизита (как в 1С): текст подсказки
   *
   * @generated from field: string hint = 30;
   */
  hint: string;

  /**
   * ПОЛОЖЕНИЕ подсказки: '' (нет) | 'hover' (при наведении) | 'bottom' (снизу)
   * | 'button' (кнопка «?»)
   *
   * @generated from field: string hint_position = 31;
   */
  hintPosition: string;

  /**
   * ТЕКСТ ВНУТРИ НЕЗАПОЛНЕННОГО ПОЛЯ (placeholder, как в 1С)
   *
   * @generated from field: string placeholder = 32;
   */
  placeholder: string;

  /**
   * МАСКИРОВАНИЕ (универсальный механизм ядра): JSON правил построчного
   * сокрытия [{roles,conditions[{field,operator,value,logic}],action}]
   * — движок ApplyFieldMasks применяется во ВСЕХ точках выдачи данных
   *
   * @generated from field: string mask_rules = 34;
   */
  maskRules: string;

  /**
   * ГОЛОСОВОЙ ВВОД (реквизит): микрофон у текстового поля — распознавание
   * речи в реальном времени (адаптер «речь в текст»). По умолчанию ВЫКЛ.
   *
   * @generated from field: bool voice_input = 35;
   */
  voiceInput: boolean;
};

/**
 * Describes the message zdc.Field.
 * Use `create(FieldSchema)` to create a new message.
 */
export const FieldSchema: GenMessage<Field> = /*@__PURE__*/
  messageDesc(file_zdc, 147);

/**
 * Определяемый тип (как в 1С): именованный состав типов, создаётся программно
 *
 * @generated from message zdc.DefinedType
 */
export type DefinedType = Message<"zdc.DefinedType"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: repeated string types = 4;
   */
  types: string[];

  /**
   * @generated from field: string created_at = 5;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 6;
   */
  updatedAt: string;

  /**
   * Системный (как в 1С): создан платформой, защищён от удаления
   *
   * @generated from field: bool is_system = 7;
   */
  isSystem: boolean;

  /**
   * Поставка-владелец (шаг 3 учёта): template_id — защита Update/Delete
   *
   * @generated from field: string template_id = 8;
   */
  templateId: string;
};

/**
 * Describes the message zdc.DefinedType.
 * Use `create(DefinedTypeSchema)` to create a new message.
 */
export const DefinedTypeSchema: GenMessage<DefinedType> = /*@__PURE__*/
  messageDesc(file_zdc, 148);

/**
 * @generated from message zdc.DefinedTypeList
 */
export type DefinedTypeList = Message<"zdc.DefinedTypeList"> & {
  /**
   * @generated from field: repeated zdc.DefinedType items = 1;
   */
  items: DefinedType[];
};

/**
 * Describes the message zdc.DefinedTypeList.
 * Use `create(DefinedTypeListSchema)` to create a new message.
 */
export const DefinedTypeListSchema: GenMessage<DefinedTypeList> = /*@__PURE__*/
  messageDesc(file_zdc, 149);

/**
 * @generated from message zdc.EnumValue
 */
export type EnumValue = Message<"zdc.EnumValue"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * имя значения (для кода/синхронизации, как предопределённый)
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * значение (код)
   *
   * @generated from field: string value = 3;
   */
  value: string;

  /**
   * отображаемое имя
   *
   * @generated from field: string synonym = 4;
   */
  synonym: string;

  /**
   * @generated from field: int32 sort_order = 5;
   */
  sortOrder: number;

  /**
   * стиль оформления (имя из metadata_styles; может отсутствовать)
   *
   * @generated from field: string style = 6;
   */
  style: string;
};

/**
 * Describes the message zdc.EnumValue.
 * Use `create(EnumValueSchema)` to create a new message.
 */
export const EnumValueSchema: GenMessage<EnumValue> = /*@__PURE__*/
  messageDesc(file_zdc, 150);

/**
 * @generated from message zdc.Enum
 */
export type Enum = Message<"zdc.Enum"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string synonym = 4;
   */
  synonym: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * значения (предопределённые)
   *
   * @generated from field: repeated zdc.EnumValue values = 6;
   */
  values: EnumValue[];

  /**
   * @generated from field: bool is_active = 7;
   */
  isActive: boolean;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 9;
   */
  updatedAt: string;

  /**
   * системное перечисление ЯДРА (PriorityTask — EnsureTaskCore)
   *
   * @generated from field: bool is_system = 10;
   */
  isSystem: boolean;

  /**
   * объект поставки (поставочное перечисление)
   *
   * @generated from field: string template_id = 11;
   */
  templateId: string;
};

/**
 * Describes the message zdc.Enum.
 * Use `create(EnumSchema)` to create a new message.
 */
export const EnumSchema: GenMessage<Enum> = /*@__PURE__*/
  messageDesc(file_zdc, 151);

/**
 * @generated from message zdc.EnumList
 */
export type EnumList = Message<"zdc.EnumList"> & {
  /**
   * @generated from field: repeated zdc.Enum items = 1;
   */
  items: Enum[];
};

/**
 * Describes the message zdc.EnumList.
 * Use `create(EnumListSchema)` to create a new message.
 */
export const EnumListSchema: GenMessage<EnumList> = /*@__PURE__*/
  messageDesc(file_zdc, 152);

/**
 * @generated from message zdc.ListEnumsRequest
 */
export type ListEnumsRequest = Message<"zdc.ListEnumsRequest"> & {
};

/**
 * Describes the message zdc.ListEnumsRequest.
 * Use `create(ListEnumsRequestSchema)` to create a new message.
 */
export const ListEnumsRequestSchema: GenMessage<ListEnumsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 153);

/**
 * @generated from message zdc.GetEnumRequest
 */
export type GetEnumRequest = Message<"zdc.GetEnumRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.GetEnumRequest.
 * Use `create(GetEnumRequestSchema)` to create a new message.
 */
export const GetEnumRequestSchema: GenMessage<GetEnumRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 154);

/**
 * @generated from message zdc.CreateEnumRequest
 */
export type CreateEnumRequest = Message<"zdc.CreateEnumRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: repeated zdc.EnumValue values = 5;
   */
  values: EnumValue[];
};

/**
 * Describes the message zdc.CreateEnumRequest.
 * Use `create(CreateEnumRequestSchema)` to create a new message.
 */
export const CreateEnumRequestSchema: GenMessage<CreateEnumRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 155);

/**
 * @generated from message zdc.UpdateEnumRequest
 */
export type UpdateEnumRequest = Message<"zdc.UpdateEnumRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: repeated zdc.EnumValue values = 5;
   */
  values: EnumValue[];
};

/**
 * Describes the message zdc.UpdateEnumRequest.
 * Use `create(UpdateEnumRequestSchema)` to create a new message.
 */
export const UpdateEnumRequestSchema: GenMessage<UpdateEnumRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 156);

/**
 * @generated from message zdc.DeleteEnumRequest
 */
export type DeleteEnumRequest = Message<"zdc.DeleteEnumRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.DeleteEnumRequest.
 * Use `create(DeleteEnumRequestSchema)` to create a new message.
 */
export const DeleteEnumRequestSchema: GenMessage<DeleteEnumRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 157);

/**
 * @generated from message zdc.Predetermined
 */
export type Predetermined = Message<"zdc.Predetermined"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 'catalog' | 'chart_account'
   *
   * @generated from field: string entity_type = 2;
   */
  entityType: string;

  /**
   * код справочника/плана счетов
   *
   * @generated from field: string entity_code = 3;
   */
  entityCode: string;

  /**
   * predetermined_name (для кода/синхронизации)
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * код записи (справочника/счёта)
   *
   * @generated from field: string code = 5;
   */
  code: string;

  /**
   * отображаемое имя
   *
   * @generated from field: string synonym = 6;
   */
  synonym: string;

  /**
   * @generated from field: int32 sort_order = 7;
   */
  sortOrder: number;

  /**
   * стиль оформления (имя из metadata_styles; может отсутствовать)
   *
   * @generated from field: string style = 10;
   */
  style: string;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 9;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.Predetermined.
 * Use `create(PredeterminedSchema)` to create a new message.
 */
export const PredeterminedSchema: GenMessage<Predetermined> = /*@__PURE__*/
  messageDesc(file_zdc, 158);

/**
 * @generated from message zdc.PredeterminedList
 */
export type PredeterminedList = Message<"zdc.PredeterminedList"> & {
  /**
   * @generated from field: repeated zdc.Predetermined items = 1;
   */
  items: Predetermined[];
};

/**
 * Describes the message zdc.PredeterminedList.
 * Use `create(PredeterminedListSchema)` to create a new message.
 */
export const PredeterminedListSchema: GenMessage<PredeterminedList> = /*@__PURE__*/
  messageDesc(file_zdc, 159);

/**
 * @generated from message zdc.ListPredeterminedRequest
 */
export type ListPredeterminedRequest = Message<"zdc.ListPredeterminedRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;
};

/**
 * Describes the message zdc.ListPredeterminedRequest.
 * Use `create(ListPredeterminedRequestSchema)` to create a new message.
 */
export const ListPredeterminedRequestSchema: GenMessage<ListPredeterminedRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 160);

/**
 * @generated from message zdc.SavePredeterminedRequest
 */
export type SavePredeterminedRequest = Message<"zdc.SavePredeterminedRequest"> & {
  /**
   * пусто = создание
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 3;
   */
  entityCode: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: string code = 5;
   */
  code: string;

  /**
   * @generated from field: string synonym = 6;
   */
  synonym: string;

  /**
   * @generated from field: int32 sort_order = 7;
   */
  sortOrder: number;
};

/**
 * Describes the message zdc.SavePredeterminedRequest.
 * Use `create(SavePredeterminedRequestSchema)` to create a new message.
 */
export const SavePredeterminedRequestSchema: GenMessage<SavePredeterminedRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 161);

/**
 * @generated from message zdc.DeletePredeterminedRequest
 */
export type DeletePredeterminedRequest = Message<"zdc.DeletePredeterminedRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeletePredeterminedRequest.
 * Use `create(DeletePredeterminedRequestSchema)` to create a new message.
 */
export const DeletePredeterminedRequestSchema: GenMessage<DeletePredeterminedRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 162);

/**
 * @generated from message zdc.FunctionalOption
 */
export type FunctionalOption = Message<"zdc.FunctionalOption"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * constant (константа) | roles | register | catalog_attr (реквизит справочника)
   *
   * @generated from field: string source_type = 4;
   */
  sourceType: string;

  /**
   * @generated from field: string register_code = 5;
   */
  registerCode: string;

  /**
   * @generated from field: string resource_name = 6;
   */
  resourceName: string;

  /**
   * параметры (провайдеры значений)
   *
   * @generated from field: repeated zdc.OptionParam params = 7;
   */
  params: OptionParam[];

  /**
   * @generated from field: bool default_enabled = 8;
   */
  defaultEnabled: boolean;

  /**
   * @generated from field: string description = 9;
   */
  description: string;

  /**
   * @generated from field: bool is_system = 10;
   */
  isSystem: boolean;

  /**
   * source_type='roles'
   *
   * @generated from field: repeated zdc.OptionValue values = 11;
   */
  values: OptionValue[];

  /**
   * состав (что скрывается)
   *
   * @generated from field: repeated zdc.OptionMember members = 12;
   */
  members: OptionMember[];

  /**
   * @generated from field: string created_at = 13;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 14;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.FunctionalOption.
 * Use `create(FunctionalOptionSchema)` to create a new message.
 */
export const FunctionalOptionSchema: GenMessage<FunctionalOption> = /*@__PURE__*/
  messageDesc(file_zdc, 163);

/**
 * @generated from message zdc.OptionParam
 */
export type OptionParam = Message<"zdc.OptionParam"> & {
  /**
   * имя параметра (измерение регистра)
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * поле/измерение регистра
   *
   * @generated from field: string field = 2;
   */
  field: string;

  /**
   * user | profile_field | setting | module
   *
   * @generated from field: string provider = 3;
   */
  provider: string;

  /**
   * @generated from field: string provider_field = 4;
   */
  providerField: string;
};

/**
 * Describes the message zdc.OptionParam.
 * Use `create(OptionParamSchema)` to create a new message.
 */
export const OptionParamSchema: GenMessage<OptionParam> = /*@__PURE__*/
  messageDesc(file_zdc, 164);

/**
 * @generated from message zdc.OptionValue
 */
export type OptionValue = Message<"zdc.OptionValue"> & {
  /**
   * @generated from field: string role_id = 1;
   */
  roleId: string;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;
};

/**
 * Describes the message zdc.OptionValue.
 * Use `create(OptionValueSchema)` to create a new message.
 */
export const OptionValueSchema: GenMessage<OptionValue> = /*@__PURE__*/
  messageDesc(file_zdc, 165);

/**
 * @generated from message zdc.OptionMember
 */
export type OptionMember = Message<"zdc.OptionMember"> & {
  /**
   * section|catalog|document|register|field|command|form|predetermined|enum_value|section_object
   *
   * @generated from field: string member_type = 1;
   */
  memberType: string;

  /**
   * @generated from field: string member_code = 2;
   */
  memberCode: string;
};

/**
 * Describes the message zdc.OptionMember.
 * Use `create(OptionMemberSchema)` to create a new message.
 */
export const OptionMemberSchema: GenMessage<OptionMember> = /*@__PURE__*/
  messageDesc(file_zdc, 166);

/**
 * @generated from message zdc.FunctionalOptionList
 */
export type FunctionalOptionList = Message<"zdc.FunctionalOptionList"> & {
  /**
   * @generated from field: repeated zdc.FunctionalOption items = 1;
   */
  items: FunctionalOption[];
};

/**
 * Describes the message zdc.FunctionalOptionList.
 * Use `create(FunctionalOptionListSchema)` to create a new message.
 */
export const FunctionalOptionListSchema: GenMessage<FunctionalOptionList> = /*@__PURE__*/
  messageDesc(file_zdc, 167);

/**
 * @generated from message zdc.Constant
 */
export type Constant = Message<"zdc.Constant"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * boolean|string|number|date|text
   *
   * @generated from field: string data_type = 4;
   */
  dataType: string;

  /**
   * @generated from field: string value = 5;
   */
  value: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: bool is_system = 7;
   */
  isSystem: boolean;

  /**
   * происхождение: поставка
   *
   * @generated from field: string template_id = 8;
   */
  templateId: string;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 10;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.Constant.
 * Use `create(ConstantSchema)` to create a new message.
 */
export const ConstantSchema: GenMessage<Constant> = /*@__PURE__*/
  messageDesc(file_zdc, 168);

/**
 * @generated from message zdc.ConstantList
 */
export type ConstantList = Message<"zdc.ConstantList"> & {
  /**
   * @generated from field: repeated zdc.Constant items = 1;
   */
  items: Constant[];
};

/**
 * Describes the message zdc.ConstantList.
 * Use `create(ConstantListSchema)` to create a new message.
 */
export const ConstantListSchema: GenMessage<ConstantList> = /*@__PURE__*/
  messageDesc(file_zdc, 169);

/**
 * @generated from message zdc.GetConstantRequest
 */
export type GetConstantRequest = Message<"zdc.GetConstantRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message zdc.GetConstantRequest.
 * Use `create(GetConstantRequestSchema)` to create a new message.
 */
export const GetConstantRequestSchema: GenMessage<GetConstantRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 170);

/**
 * @generated from message zdc.SaveConstantRequest
 */
export type SaveConstantRequest = Message<"zdc.SaveConstantRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string data_type = 4;
   */
  dataType: string;

  /**
   * @generated from field: string value = 5;
   */
  value: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;
};

/**
 * Describes the message zdc.SaveConstantRequest.
 * Use `create(SaveConstantRequestSchema)` to create a new message.
 */
export const SaveConstantRequestSchema: GenMessage<SaveConstantRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 171);

/**
 * @generated from message zdc.DeleteConstantRequest
 */
export type DeleteConstantRequest = Message<"zdc.DeleteConstantRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message zdc.DeleteConstantRequest.
 * Use `create(DeleteConstantRequestSchema)` to create a new message.
 */
export const DeleteConstantRequestSchema: GenMessage<DeleteConstantRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 172);

/**
 * Языки конфигурации (как в 1С): перечень языков, используемых интерфейсом
 * и адаптером «речь в текст» (STT). name — код ('ru'), synonym — название
 * («Русский»), value — локаль STT ('ru-RU'). Системный «Русский» защищён.
 *
 * @generated from message zdc.Language
 */
export type Language = Message<"zdc.Language"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * код: 'ru'
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * «Русский»
   *
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * локаль STT: 'ru-RU'
   *
   * @generated from field: string value = 4;
   */
  value: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: bool is_system = 6;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 7;
   */
  templateId: string;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 9;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.Language.
 * Use `create(LanguageSchema)` to create a new message.
 */
export const LanguageSchema: GenMessage<Language> = /*@__PURE__*/
  messageDesc(file_zdc, 173);

/**
 * @generated from message zdc.LanguageList
 */
export type LanguageList = Message<"zdc.LanguageList"> & {
  /**
   * @generated from field: repeated zdc.Language items = 1;
   */
  items: Language[];
};

/**
 * Describes the message zdc.LanguageList.
 * Use `create(LanguageListSchema)` to create a new message.
 */
export const LanguageListSchema: GenMessage<LanguageList> = /*@__PURE__*/
  messageDesc(file_zdc, 174);

/**
 * @generated from message zdc.SaveLanguageRequest
 */
export type SaveLanguageRequest = Message<"zdc.SaveLanguageRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string value = 4;
   */
  value: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;
};

/**
 * Describes the message zdc.SaveLanguageRequest.
 * Use `create(SaveLanguageRequestSchema)` to create a new message.
 */
export const SaveLanguageRequestSchema: GenMessage<SaveLanguageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 175);

/**
 * @generated from message zdc.DeleteLanguageRequest
 */
export type DeleteLanguageRequest = Message<"zdc.DeleteLanguageRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message zdc.DeleteLanguageRequest.
 * Use `create(DeleteLanguageRequestSchema)` to create a new message.
 */
export const DeleteLanguageRequestSchema: GenMessage<DeleteLanguageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 176);

/**
 * Перевод (Этап 3): значение ключа на локали. Уникальность (key, locale).
 *
 * @generated from message zdc.Translation
 */
export type Translation = Message<"zdc.Translation"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * ключ (напр. 'site.profi.header.title')
   *
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * код языка ('ru','en' — из metadata_languages.name)
   *
   * @generated from field: string locale = 3;
   */
  locale: string;

  /**
   * @generated from field: string value = 4;
   */
  value: string;

  /**
   * @generated from field: bool is_system = 5;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 6;
   */
  templateId: string;

  /**
   * @generated from field: string created_at = 7;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 8;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.Translation.
 * Use `create(TranslationSchema)` to create a new message.
 */
export const TranslationSchema: GenMessage<Translation> = /*@__PURE__*/
  messageDesc(file_zdc, 177);

/**
 * @generated from message zdc.TranslationList
 */
export type TranslationList = Message<"zdc.TranslationList"> & {
  /**
   * @generated from field: repeated zdc.Translation items = 1;
   */
  items: Translation[];
};

/**
 * Describes the message zdc.TranslationList.
 * Use `create(TranslationListSchema)` to create a new message.
 */
export const TranslationListSchema: GenMessage<TranslationList> = /*@__PURE__*/
  messageDesc(file_zdc, 178);

/**
 * @generated from message zdc.ListTranslationsRequest
 */
export type ListTranslationsRequest = Message<"zdc.ListTranslationsRequest"> & {
  /**
   * фильтр по началу ключа ('' = все)
   *
   * @generated from field: string key_prefix = 1;
   */
  keyPrefix: string;

  /**
   * фильтр по локали ('' = все)
   *
   * @generated from field: string locale = 2;
   */
  locale: string;
};

/**
 * Describes the message zdc.ListTranslationsRequest.
 * Use `create(ListTranslationsRequestSchema)` to create a new message.
 */
export const ListTranslationsRequestSchema: GenMessage<ListTranslationsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 179);

/**
 * @generated from message zdc.SaveTranslationRequest
 */
export type SaveTranslationRequest = Message<"zdc.SaveTranslationRequest"> & {
  /**
   * обязателен
   *
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * обязательна (код языка базы)
   *
   * @generated from field: string locale = 2;
   */
  locale: string;

  /**
   * пусто = удалить значение? нет: пустое значение допустимо
   *
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * Describes the message zdc.SaveTranslationRequest.
 * Use `create(SaveTranslationRequestSchema)` to create a new message.
 */
export const SaveTranslationRequestSchema: GenMessage<SaveTranslationRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 180);

/**
 * @generated from message zdc.DeleteTranslationRequest
 */
export type DeleteTranslationRequest = Message<"zdc.DeleteTranslationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteTranslationRequest.
 * Use `create(DeleteTranslationRequestSchema)` to create a new message.
 */
export const DeleteTranslationRequestSchema: GenMessage<DeleteTranslationRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 181);

/**
 * @generated from message zdc.GetTranslationsRequest
 */
export type GetTranslationsRequest = Message<"zdc.GetTranslationsRequest"> & {
  /**
   * @generated from field: string locale = 1;
   */
  locale: string;
};

/**
 * Describes the message zdc.GetTranslationsRequest.
 * Use `create(GetTranslationsRequestSchema)` to create a new message.
 */
export const GetTranslationsRequestSchema: GenMessage<GetTranslationsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 182);

/**
 * @generated from message zdc.GetFunctionalOptionRequest
 */
export type GetFunctionalOptionRequest = Message<"zdc.GetFunctionalOptionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetFunctionalOptionRequest.
 * Use `create(GetFunctionalOptionRequestSchema)` to create a new message.
 */
export const GetFunctionalOptionRequestSchema: GenMessage<GetFunctionalOptionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 183);

/**
 * @generated from message zdc.SaveFunctionalOptionRequest
 */
export type SaveFunctionalOptionRequest = Message<"zdc.SaveFunctionalOptionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string source_type = 4;
   */
  sourceType: string;

  /**
   * @generated from field: string register_code = 5;
   */
  registerCode: string;

  /**
   * @generated from field: string resource_name = 6;
   */
  resourceName: string;

  /**
   * @generated from field: repeated zdc.OptionParam params = 7;
   */
  params: OptionParam[];

  /**
   * @generated from field: bool default_enabled = 8;
   */
  defaultEnabled: boolean;

  /**
   * @generated from field: string description = 9;
   */
  description: string;

  /**
   * @generated from field: repeated zdc.OptionValue values = 10;
   */
  values: OptionValue[];

  /**
   * @generated from field: repeated zdc.OptionMember members = 11;
   */
  members: OptionMember[];
};

/**
 * Describes the message zdc.SaveFunctionalOptionRequest.
 * Use `create(SaveFunctionalOptionRequestSchema)` to create a new message.
 */
export const SaveFunctionalOptionRequestSchema: GenMessage<SaveFunctionalOptionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 184);

/**
 * @generated from message zdc.DeleteFunctionalOptionRequest
 */
export type DeleteFunctionalOptionRequest = Message<"zdc.DeleteFunctionalOptionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteFunctionalOptionRequest.
 * Use `create(DeleteFunctionalOptionRequestSchema)` to create a new message.
 */
export const DeleteFunctionalOptionRequestSchema: GenMessage<DeleteFunctionalOptionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 185);

/**
 * @generated from message zdc.ActiveOption
 */
export type ActiveOption = Message<"zdc.ActiveOption"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;
};

/**
 * Describes the message zdc.ActiveOption.
 * Use `create(ActiveOptionSchema)` to create a new message.
 */
export const ActiveOptionSchema: GenMessage<ActiveOption> = /*@__PURE__*/
  messageDesc(file_zdc, 186);

/**
 * @generated from message zdc.ActiveOptionList
 */
export type ActiveOptionList = Message<"zdc.ActiveOptionList"> & {
  /**
   * @generated from field: repeated zdc.ActiveOption items = 1;
   */
  items: ActiveOption[];

  /**
   * Коды элементов, СКРЫТЫХ функциональными опциями для текущего пользователя
   * (состав неактивных опций; единый источник видимости на клиенте).
   *
   * @generated from field: repeated string hidden_codes = 2;
   */
  hiddenCodes: string[];
};

/**
 * Describes the message zdc.ActiveOptionList.
 * Use `create(ActiveOptionListSchema)` to create a new message.
 */
export const ActiveOptionListSchema: GenMessage<ActiveOptionList> = /*@__PURE__*/
  messageDesc(file_zdc, 187);

/**
 * Модуль конфигурации (как 1С модуль приложения)
 *
 * @generated from message zdc.ConfigModule
 */
export type ConfigModule = Message<"zdc.ConfigModule"> & {
  /**
   * @generated from field: string source_code = 1;
   */
  sourceCode: string;

  /**
   * @generated from field: string updated_at = 2;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.ConfigModule.
 * Use `create(ConfigModuleSchema)` to create a new message.
 */
export const ConfigModuleSchema: GenMessage<ConfigModule> = /*@__PURE__*/
  messageDesc(file_zdc, 188);

/**
 * @generated from message zdc.SaveConfigModuleRequest
 */
export type SaveConfigModuleRequest = Message<"zdc.SaveConfigModuleRequest"> & {
  /**
   * @generated from field: string source_code = 1;
   */
  sourceCode: string;
};

/**
 * Describes the message zdc.SaveConfigModuleRequest.
 * Use `create(SaveConfigModuleRequestSchema)` to create a new message.
 */
export const SaveConfigModuleRequestSchema: GenMessage<SaveConfigModuleRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 189);

/**
 * @generated from message zdc.Style
 */
export type Style = Message<"zdc.Style"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: zdc.StyleAttributes attributes = 4;
   */
  attributes?: StyleAttributes | undefined;

  /**
   * @generated from field: bool is_system = 5;
   */
  isSystem: boolean;

  /**
   * @generated from field: int32 sort_order = 6;
   */
  sortOrder: number;

  /**
   * @generated from field: string created_at = 7;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 8;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.Style.
 * Use `create(StyleSchema)` to create a new message.
 */
export const StyleSchema: GenMessage<Style> = /*@__PURE__*/
  messageDesc(file_zdc, 190);

/**
 * @generated from message zdc.StyleAttributes
 */
export type StyleAttributes = Message<"zdc.StyleAttributes"> & {
  /**
   * слот темы ('success') или hex
   *
   * @generated from field: string text_color = 1;
   */
  textColor: string;

  /**
   * слот темы или hex
   *
   * @generated from field: string background_color = 2;
   */
  backgroundColor: string;

  /**
   * @generated from field: bool bold = 3;
   */
  bold: boolean;

  /**
   * @generated from field: bool italic = 4;
   */
  italic: boolean;

  /**
   * @generated from field: bool strikethrough = 5;
   */
  strikethrough: boolean;

  /**
   * @generated from field: bool underline = 6;
   */
  underline: boolean;

  /**
   * px (0 = дефолт)
   *
   * @generated from field: int32 font_size = 7;
   */
  fontSize: number;

  /**
   * UTF/эмодзи или 'file:<id>'
   *
   * @generated from field: string icon = 8;
   */
  icon: string;
};

/**
 * Describes the message zdc.StyleAttributes.
 * Use `create(StyleAttributesSchema)` to create a new message.
 */
export const StyleAttributesSchema: GenMessage<StyleAttributes> = /*@__PURE__*/
  messageDesc(file_zdc, 191);

/**
 * @generated from message zdc.StyleList
 */
export type StyleList = Message<"zdc.StyleList"> & {
  /**
   * @generated from field: repeated zdc.Style items = 1;
   */
  items: Style[];
};

/**
 * Describes the message zdc.StyleList.
 * Use `create(StyleListSchema)` to create a new message.
 */
export const StyleListSchema: GenMessage<StyleList> = /*@__PURE__*/
  messageDesc(file_zdc, 192);

/**
 * @generated from message zdc.SaveStyleRequest
 */
export type SaveStyleRequest = Message<"zdc.SaveStyleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: zdc.StyleAttributes attributes = 4;
   */
  attributes?: StyleAttributes | undefined;

  /**
   * @generated from field: int32 sort_order = 5;
   */
  sortOrder: number;
};

/**
 * Describes the message zdc.SaveStyleRequest.
 * Use `create(SaveStyleRequestSchema)` to create a new message.
 */
export const SaveStyleRequestSchema: GenMessage<SaveStyleRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 193);

/**
 * @generated from message zdc.DeleteStyleRequest
 */
export type DeleteStyleRequest = Message<"zdc.DeleteStyleRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message zdc.DeleteStyleRequest.
 * Use `create(DeleteStyleRequestSchema)` to create a new message.
 */
export const DeleteStyleRequestSchema: GenMessage<DeleteStyleRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 194);

/**
 * Слот цвета темы (реестр платформы)
 *
 * @generated from message zdc.StyleSlot
 */
export type StyleSlot = Message<"zdc.StyleSlot"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string synonym = 2;
   */
  synonym: string;

  /**
   * @generated from field: string light = 3;
   */
  light: string;

  /**
   * @generated from field: string dark = 4;
   */
  dark: string;
};

/**
 * Describes the message zdc.StyleSlot.
 * Use `create(StyleSlotSchema)` to create a new message.
 */
export const StyleSlotSchema: GenMessage<StyleSlot> = /*@__PURE__*/
  messageDesc(file_zdc, 195);

/**
 * @generated from message zdc.StyleSlotList
 */
export type StyleSlotList = Message<"zdc.StyleSlotList"> & {
  /**
   * @generated from field: repeated zdc.StyleSlot items = 1;
   */
  items: StyleSlot[];
};

/**
 * Describes the message zdc.StyleSlotList.
 * Use `create(StyleSlotListSchema)` to create a new message.
 */
export const StyleSlotListSchema: GenMessage<StyleSlotList> = /*@__PURE__*/
  messageDesc(file_zdc, 196);

/**
 * @generated from message zdc.Color
 */
export type Color = Message<"zdc.Color"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * код (латиница): 'white', 'beige'...
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * «Белый», «Бежевый»...
   *
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * hex: #FFFFFF
   *
   * @generated from field: string value = 4;
   */
  value: string;

  /**
   * @generated from field: bool is_system = 5;
   */
  isSystem: boolean;

  /**
   * @generated from field: int32 sort_order = 6;
   */
  sortOrder: number;

  /**
   * @generated from field: string created_at = 7;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 8;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.Color.
 * Use `create(ColorSchema)` to create a new message.
 */
export const ColorSchema: GenMessage<Color> = /*@__PURE__*/
  messageDesc(file_zdc, 197);

/**
 * @generated from message zdc.ColorList
 */
export type ColorList = Message<"zdc.ColorList"> & {
  /**
   * @generated from field: repeated zdc.Color items = 1;
   */
  items: Color[];
};

/**
 * Describes the message zdc.ColorList.
 * Use `create(ColorListSchema)` to create a new message.
 */
export const ColorListSchema: GenMessage<ColorList> = /*@__PURE__*/
  messageDesc(file_zdc, 198);

/**
 * @generated from message zdc.SaveColorRequest
 */
export type SaveColorRequest = Message<"zdc.SaveColorRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string synonym = 2;
   */
  synonym: string;

  /**
   * hex (#RRGGBB)
   *
   * @generated from field: string value = 3;
   */
  value: string;

  /**
   * @generated from field: int32 sort_order = 4;
   */
  sortOrder: number;
};

/**
 * Describes the message zdc.SaveColorRequest.
 * Use `create(SaveColorRequestSchema)` to create a new message.
 */
export const SaveColorRequestSchema: GenMessage<SaveColorRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 199);

/**
 * @generated from message zdc.DeleteColorRequest
 */
export type DeleteColorRequest = Message<"zdc.DeleteColorRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message zdc.DeleteColorRequest.
 * Use `create(DeleteColorRequestSchema)` to create a new message.
 */
export const DeleteColorRequestSchema: GenMessage<DeleteColorRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 200);

/**
 * @generated from message zdc.CondFormat
 */
export type CondFormat = Message<"zdc.CondFormat"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * form | list
   *
   * @generated from field: string scope = 2;
   */
  scope: string;

  /**
   * catalog:code | document:code | form:<id>
   *
   * @generated from field: string target = 3;
   */
  target: string;

  /**
   * field:<code> | row | column:<code>
   *
   * @generated from field: repeated string applies_to = 4;
   */
  appliesTo: string[];

  /**
   * @generated from field: repeated zdc.CondCondition conditions = 5;
   */
  conditions: CondCondition[];

  /**
   * имя стиля (metadata_styles)
   *
   * @generated from field: string style_id = 6;
   */
  styleId: string;

  /**
   * @generated from field: bool hidden = 7;
   */
  hidden: boolean;

  /**
   * @generated from field: bool disabled = 8;
   */
  disabled: boolean;

  /**
   * @generated from field: int32 sort_order = 9;
   */
  sortOrder: number;

  /**
   * @generated from field: bool is_active = 10;
   */
  isActive: boolean;

  /**
   * @generated from field: string description = 11;
   */
  description: string;

  /**
   * @generated from field: string created_at = 12;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 13;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.CondFormat.
 * Use `create(CondFormatSchema)` to create a new message.
 */
export const CondFormatSchema: GenMessage<CondFormat> = /*@__PURE__*/
  messageDesc(file_zdc, 201);

/**
 * @generated from message zdc.CondCondition
 */
export type CondCondition = Message<"zdc.CondCondition"> & {
  /**
   * поле или __current_user__/__current_roles__/__is_admin__
   *
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * = | != | > | < | >= | <= | is_null | is_not_null | like | in
   *
   * @generated from field: string operator = 2;
   */
  operator: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;

  /**
   * and | or
   *
   * @generated from field: string logic = 4;
   */
  logic: string;

  /**
   * группа (разные группы = OR)
   *
   * @generated from field: int32 group = 5;
   */
  group: number;
};

/**
 * Describes the message zdc.CondCondition.
 * Use `create(CondConditionSchema)` to create a new message.
 */
export const CondConditionSchema: GenMessage<CondCondition> = /*@__PURE__*/
  messageDesc(file_zdc, 202);

/**
 * @generated from message zdc.CondFormatList
 */
export type CondFormatList = Message<"zdc.CondFormatList"> & {
  /**
   * @generated from field: repeated zdc.CondFormat items = 1;
   */
  items: CondFormat[];
};

/**
 * Describes the message zdc.CondFormatList.
 * Use `create(CondFormatListSchema)` to create a new message.
 */
export const CondFormatListSchema: GenMessage<CondFormatList> = /*@__PURE__*/
  messageDesc(file_zdc, 203);

/**
 * @generated from message zdc.ListConditionalFormatsRequest
 */
export type ListConditionalFormatsRequest = Message<"zdc.ListConditionalFormatsRequest"> & {
  /**
   * пусто = все
   *
   * @generated from field: string scope = 1;
   */
  scope: string;

  /**
   * пусто = все
   *
   * @generated from field: string target = 2;
   */
  target: string;
};

/**
 * Describes the message zdc.ListConditionalFormatsRequest.
 * Use `create(ListConditionalFormatsRequestSchema)` to create a new message.
 */
export const ListConditionalFormatsRequestSchema: GenMessage<ListConditionalFormatsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 204);

/**
 * @generated from message zdc.SaveCondFormatRequest
 */
export type SaveCondFormatRequest = Message<"zdc.SaveCondFormatRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string scope = 2;
   */
  scope: string;

  /**
   * @generated from field: string target = 3;
   */
  target: string;

  /**
   * @generated from field: repeated string applies_to = 4;
   */
  appliesTo: string[];

  /**
   * @generated from field: repeated zdc.CondCondition conditions = 5;
   */
  conditions: CondCondition[];

  /**
   * @generated from field: string style_id = 6;
   */
  styleId: string;

  /**
   * @generated from field: bool hidden = 7;
   */
  hidden: boolean;

  /**
   * @generated from field: bool disabled = 8;
   */
  disabled: boolean;

  /**
   * @generated from field: int32 sort_order = 9;
   */
  sortOrder: number;

  /**
   * @generated from field: bool is_active = 10;
   */
  isActive: boolean;

  /**
   * @generated from field: string description = 11;
   */
  description: string;
};

/**
 * Describes the message zdc.SaveCondFormatRequest.
 * Use `create(SaveCondFormatRequestSchema)` to create a new message.
 */
export const SaveCondFormatRequestSchema: GenMessage<SaveCondFormatRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 205);

/**
 * @generated from message zdc.DeleteCondFormatRequest
 */
export type DeleteCondFormatRequest = Message<"zdc.DeleteCondFormatRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteCondFormatRequest.
 * Use `create(DeleteCondFormatRequestSchema)` to create a new message.
 */
export const DeleteCondFormatRequestSchema: GenMessage<DeleteCondFormatRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 206);

/**
 * @generated from message zdc.EventSubscription
 */
export type EventSubscription = Message<"zdc.EventSubscription"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * task.created, task.taken, data.row.created...
   *
   * @generated from field: string event = 3;
   */
  event: string;

  /**
   * условия по полям payload
   *
   * @generated from field: repeated zdc.CondCondition filter = 4;
   */
  filter: CondCondition[];

  /**
   * notification | module | chat
   *
   * @generated from field: string handler_type = 5;
   */
  handlerType: string;

  /**
   * @generated from field: zdc.NotificationConfig notification = 6;
   */
  notification?: NotificationConfig | undefined;

  /**
   * JS (goja): handleEvent(eventJSON)
   *
   * @generated from field: string module_code = 7;
   */
  moduleCode: string;

  /**
   * handler_type='chat': сообщения в чаты от бота
   *
   * @generated from field: zdc.ChatConfig chat = 13;
   */
  chat?: ChatConfig | undefined;

  /**
   * @generated from field: int32 sort_order = 8;
   */
  sortOrder: number;

  /**
   * @generated from field: bool is_active = 9;
   */
  isActive: boolean;

  /**
   * @generated from field: string description = 10;
   */
  description: string;

  /**
   * @generated from field: string created_at = 11;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 12;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.EventSubscription.
 * Use `create(EventSubscriptionSchema)` to create a new message.
 */
export const EventSubscriptionSchema: GenMessage<EventSubscription> = /*@__PURE__*/
  messageDesc(file_zdc, 207);

/**
 * @generated from message zdc.NotificationConfig
 */
export type NotificationConfig = Message<"zdc.NotificationConfig"> & {
  /**
   * author | assignee | user | role
   *
   * @generated from field: string recipient = 1;
   */
  recipient: string;

  /**
   * для user — id; для role — имя роли
   *
   * @generated from field: string recipient_value = 2;
   */
  recipientValue: string;

  /**
   * @generated from field: string channel = 3;
   */
  channel: string;

  /**
   * {{Поле}} из payload
   *
   * @generated from field: string title_template = 4;
   */
  titleTemplate: string;

  /**
   * @generated from field: string message_template = 5;
   */
  messageTemplate: string;
};

/**
 * Describes the message zdc.NotificationConfig.
 * Use `create(NotificationConfigSchema)` to create a new message.
 */
export const NotificationConfigSchema: GenMessage<NotificationConfig> = /*@__PURE__*/
  messageDesc(file_zdc, 208);

/**
 * ЧАТ-обработчик подписки (системный бот «Уведомитель»): сообщение в
 * direct-чаты получателей (author/assignee/user/role) и настроенные чаты/группы.
 *
 * @generated from message zdc.ChatConfig
 */
export type ChatConfig = Message<"zdc.ChatConfig"> & {
  /**
   * author | assignee | user | role
   *
   * @generated from field: repeated string recipients = 1;
   */
  recipients: string[];

  /**
   * для user — id; для role — имя роли
   *
   * @generated from field: string recipient_value = 2;
   */
  recipientValue: string;

  /**
   * conversation_id дополнительных чатов/групп
   *
   * @generated from field: repeated string chats = 3;
   */
  chats: string[];

  /**
   * {{Поле}} из payload
   *
   * @generated from field: string message_template = 4;
   */
  messageTemplate: string;
};

/**
 * Describes the message zdc.ChatConfig.
 * Use `create(ChatConfigSchema)` to create a new message.
 */
export const ChatConfigSchema: GenMessage<ChatConfig> = /*@__PURE__*/
  messageDesc(file_zdc, 209);

/**
 * @generated from message zdc.EventSubscriptionList
 */
export type EventSubscriptionList = Message<"zdc.EventSubscriptionList"> & {
  /**
   * @generated from field: repeated zdc.EventSubscription items = 1;
   */
  items: EventSubscription[];
};

/**
 * Describes the message zdc.EventSubscriptionList.
 * Use `create(EventSubscriptionListSchema)` to create a new message.
 */
export const EventSubscriptionListSchema: GenMessage<EventSubscriptionList> = /*@__PURE__*/
  messageDesc(file_zdc, 210);

/**
 * @generated from message zdc.SaveEventSubscriptionRequest
 */
export type SaveEventSubscriptionRequest = Message<"zdc.SaveEventSubscriptionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string event = 3;
   */
  event: string;

  /**
   * @generated from field: repeated zdc.CondCondition filter = 4;
   */
  filter: CondCondition[];

  /**
   * @generated from field: string handler_type = 5;
   */
  handlerType: string;

  /**
   * @generated from field: zdc.NotificationConfig notification = 6;
   */
  notification?: NotificationConfig | undefined;

  /**
   * @generated from field: string module_code = 7;
   */
  moduleCode: string;

  /**
   * @generated from field: zdc.ChatConfig chat = 13;
   */
  chat?: ChatConfig | undefined;

  /**
   * @generated from field: int32 sort_order = 8;
   */
  sortOrder: number;

  /**
   * @generated from field: bool is_active = 9;
   */
  isActive: boolean;

  /**
   * @generated from field: string description = 10;
   */
  description: string;
};

/**
 * Describes the message zdc.SaveEventSubscriptionRequest.
 * Use `create(SaveEventSubscriptionRequestSchema)` to create a new message.
 */
export const SaveEventSubscriptionRequestSchema: GenMessage<SaveEventSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 211);

/**
 * @generated from message zdc.DeleteEventSubscriptionRequest
 */
export type DeleteEventSubscriptionRequest = Message<"zdc.DeleteEventSubscriptionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteEventSubscriptionRequest.
 * Use `create(DeleteEventSubscriptionRequestSchema)` to create a new message.
 */
export const DeleteEventSubscriptionRequestSchema: GenMessage<DeleteEventSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 212);

/**
 * @generated from message zdc.NotificationItem
 */
export type NotificationItem = Message<"zdc.NotificationItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * @generated from field: string event = 4;
   */
  event: string;

  /**
   * @generated from field: string related_id = 5;
   */
  relatedId: string;

  /**
   * @generated from field: bool is_read = 6;
   */
  isRead: boolean;

  /**
   * @generated from field: string created_at = 7;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.NotificationItem.
 * Use `create(NotificationItemSchema)` to create a new message.
 */
export const NotificationItemSchema: GenMessage<NotificationItem> = /*@__PURE__*/
  messageDesc(file_zdc, 213);

/**
 * @generated from message zdc.NotificationList
 */
export type NotificationList = Message<"zdc.NotificationList"> & {
  /**
   * @generated from field: repeated zdc.NotificationItem items = 1;
   */
  items: NotificationItem[];
};

/**
 * Describes the message zdc.NotificationList.
 * Use `create(NotificationListSchema)` to create a new message.
 */
export const NotificationListSchema: GenMessage<NotificationList> = /*@__PURE__*/
  messageDesc(file_zdc, 214);

/**
 * @generated from message zdc.FieldList
 */
export type FieldList = Message<"zdc.FieldList"> & {
  /**
   * @generated from field: repeated zdc.Field items = 1;
   */
  items: Field[];
};

/**
 * Describes the message zdc.FieldList.
 * Use `create(FieldListSchema)` to create a new message.
 */
export const FieldListSchema: GenMessage<FieldList> = /*@__PURE__*/
  messageDesc(file_zdc, 215);

/**
 * @generated from message zdc.TabularSection
 */
export type TabularSection = Message<"zdc.TabularSection"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string parent_type = 5;
   */
  parentType: string;

  /**
   * @generated from field: string parent_code = 6;
   */
  parentCode: string;

  /**
   * @generated from field: repeated zdc.TabularColumn columns = 7;
   */
  columns: TabularColumn[];

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive: boolean;

  /**
   * @generated from field: int32 order = 9;
   */
  order: number;

  /**
   * @generated from field: string created_at = 10;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 11;
   */
  updatedAt: string;

  /**
   * Синоним (отображаемое имя ТЧ, как в 1С)
   *
   * @generated from field: string synonym = 12;
   */
  synonym: string;
};

/**
 * Describes the message zdc.TabularSection.
 * Use `create(TabularSectionSchema)` to create a new message.
 */
export const TabularSectionSchema: GenMessage<TabularSection> = /*@__PURE__*/
  messageDesc(file_zdc, 216);

/**
 * @generated from message zdc.TabularSectionList
 */
export type TabularSectionList = Message<"zdc.TabularSectionList"> & {
  /**
   * @generated from field: repeated zdc.TabularSection items = 1;
   */
  items: TabularSection[];
};

/**
 * Describes the message zdc.TabularSectionList.
 * Use `create(TabularSectionListSchema)` to create a new message.
 */
export const TabularSectionListSchema: GenMessage<TabularSectionList> = /*@__PURE__*/
  messageDesc(file_zdc, 217);

/**
 * @generated from message zdc.TabularColumn
 */
export type TabularColumn = Message<"zdc.TabularColumn"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string column_type = 5;
   */
  columnType: string;

  /**
   * @generated from field: string data_type = 6;
   */
  dataType: string;

  /**
   * @generated from field: bool is_required = 7;
   */
  isRequired: boolean;

  /**
   * @generated from field: bool is_nullable = 8;
   */
  isNullable: boolean;

  /**
   * @generated from field: string default_value = 9;
   */
  defaultValue: string;

  /**
   * @generated from field: string ref_catalog_code = 10;
   */
  refCatalogCode: string;

  /**
   * @generated from field: string ref_document_code = 11;
   */
  refDocumentCode: string;

  /**
   * @generated from field: string enum_values = 12;
   */
  enumValues: string;

  /**
   * @generated from field: bool is_active = 13;
   */
  isActive: boolean;

  /**
   * @generated from field: int32 order = 14;
   */
  order: number;

  /**
   * @generated from field: string created_at = 15;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 16;
   */
  updatedAt: string;

  /**
   * Параметры выбора (как в 1С): статичные отборы формы выбора этой колонки
   *
   * @generated from field: repeated zdc.SelectionParam selection_params = 17;
   */
  selectionParams: SelectionParam[];

  /**
   * Связи параметров выбора (как в 1С): параметр формы выбора ← колонка ТОЙ ЖЕ строки ТЧ
   *
   * @generated from field: repeated zdc.SelectionLink selection_links = 18;
   */
  selectionLinks: SelectionLink[];

  /**
   * формат вывода (как в 1С)
   *
   * @generated from field: string format = 19;
   */
  format: string;
};

/**
 * Describes the message zdc.TabularColumn.
 * Use `create(TabularColumnSchema)` to create a new message.
 */
export const TabularColumnSchema: GenMessage<TabularColumn> = /*@__PURE__*/
  messageDesc(file_zdc, 218);

/**
 * @generated from message zdc.TabularColumnList
 */
export type TabularColumnList = Message<"zdc.TabularColumnList"> & {
  /**
   * @generated from field: repeated zdc.TabularColumn items = 1;
   */
  items: TabularColumn[];
};

/**
 * Describes the message zdc.TabularColumnList.
 * Use `create(TabularColumnListSchema)` to create a new message.
 */
export const TabularColumnListSchema: GenMessage<TabularColumnList> = /*@__PURE__*/
  messageDesc(file_zdc, 219);

/**
 * @generated from message zdc.Form
 */
export type Form = Message<"zdc.Form"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string form_type = 5;
   */
  formType: string;

  /**
   * @generated from field: string parent_type = 6;
   */
  parentType: string;

  /**
   * @generated from field: string parent_code = 7;
   */
  parentCode: string;

  /**
   * @generated from field: string layout_json = 8;
   */
  layoutJson: string;

  /**
   * @generated from field: string form_module = 9;
   */
  formModule: string;

  /**
   * @generated from field: bool is_active = 10;
   */
  isActive: boolean;

  /**
   * @generated from field: int32 order = 11;
   */
  order: number;

  /**
   * @generated from field: string created_at = 12;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 13;
   */
  updatedAt: string;

  /**
   * происхождение: поставка (ПОСТАВКА-бейдж в дереве)
   *
   * @generated from field: string template_id = 14;
   */
  templateId: string;

  /**
   * ОСНОВНАЯ форма для своего типа (object/list/selection):
   *
   * @generated from field: bool is_main = 15;
   */
  isMain: boolean;
};

/**
 * Describes the message zdc.Form.
 * Use `create(FormSchema)` to create a new message.
 */
export const FormSchema: GenMessage<Form> = /*@__PURE__*/
  messageDesc(file_zdc, 220);

/**
 * @generated from message zdc.FormList
 */
export type FormList = Message<"zdc.FormList"> & {
  /**
   * @generated from field: repeated zdc.Form items = 1;
   */
  items: Form[];
};

/**
 * Describes the message zdc.FormList.
 * Use `create(FormListSchema)` to create a new message.
 */
export const FormListSchema: GenMessage<FormList> = /*@__PURE__*/
  messageDesc(file_zdc, 221);

/**
 * @generated from message zdc.Module
 */
export type Module = Message<"zdc.Module"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string module_type = 5;
   */
  moduleType: string;

  /**
   * @generated from field: string parent_type = 6;
   */
  parentType: string;

  /**
   * @generated from field: string parent_code = 7;
   */
  parentCode: string;

  /**
   * @generated from field: string code_content = 8;
   */
  codeContent: string;

  /**
   * @generated from field: bool is_active = 9;
   */
  isActive: boolean;

  /**
   * @generated from field: string created_at = 10;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 11;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.Module.
 * Use `create(ModuleSchema)` to create a new message.
 */
export const ModuleSchema: GenMessage<Module> = /*@__PURE__*/
  messageDesc(file_zdc, 222);

/**
 * @generated from message zdc.ModuleList
 */
export type ModuleList = Message<"zdc.ModuleList"> & {
  /**
   * @generated from field: repeated zdc.Module items = 1;
   */
  items: Module[];
};

/**
 * Describes the message zdc.ModuleList.
 * Use `create(ModuleListSchema)` to create a new message.
 */
export const ModuleListSchema: GenMessage<ModuleList> = /*@__PURE__*/
  messageDesc(file_zdc, 223);

/**
 * @generated from message zdc.Entity
 */
export type Entity = Message<"zdc.Entity"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string login = 2;
   */
  login: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * @generated from field: string password = 5;
   */
  password: string;

  /**
   * @generated from field: repeated string roles = 6;
   */
  roles: string[];

  /**
   * @generated from field: repeated zdc.EntityLink links = 7;
   */
  links: EntityLink[];

  /**
   * @generated from field: repeated zdc.EntityFilterAssignment filter_assignments = 8;
   */
  filterAssignments: EntityFilterAssignment[];

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 10;
   */
  updatedAt: string;

  /**
   * --- Профиль (как в 1С: сведения о пользователе) ---
   *
   * телефон
   *
   * @generated from field: string phone = 11;
   */
  phone: string;

  /**
   * аватар: id файла из системного справочника «Файлы» (НЕ URL!)
   *
   * @generated from field: string avatar_url = 12;
   */
  avatarUrl: string;

  /**
   * дата рождения (YYYY-MM-DD)
   *
   * @generated from field: string birth_date = 13;
   */
  birthDate: string;

  /**
   * город
   *
   * @generated from field: string city = 14;
   */
  city: string;

  /**
   * активен (false = заблокирован, вход запрещён)
   *
   * @generated from field: bool is_active = 15;
   */
  isActive: boolean;

  /**
   * показывать в списке входа (лаунчер)
   *
   * @generated from field: bool show_in_login_list = 16;
   */
  showInLoginList: boolean;

  /**
   * организация пользователя (операторы видят свои заявки/задачи)
   *
   * @generated from field: string organization_id = 17;
   */
  organizationId: string;

  /**
   * СИСТЕМНАЯ учётная запись ЯДРА (admin/guest — is_system): метка «СИСТ.»
   *
   * @generated from field: bool is_system = 18;
   */
  isSystem: boolean;

  /**
   * Пресенс/происхождение: способ создания (self_registration | admin | qr | ...),
   * дата создания, последний вход (сервер заполняет; SSoT — сервер)
   *
   * @generated from field: string created_via = 19;
   */
  createdVia: string;

  /**
   * @generated from field: string last_seen_at = 20;
   */
  lastSeenAt: string;

  /**
   * ЦИФРОВОЙ КЛЮЧ: вариант авторизации ('password' | 'pin' | 'both') + признак
   * «ключ задан» (сам PIN никогда не возвращается — только bcrypt-хэш)
   *
   * @generated from field: string auth_mode = 21;
   */
  authMode: string;

  /**
   * @generated from field: bool pin_set = 22;
   */
  pinSet: boolean;

  /**
   * ИИ-блок: вид сущности — '' (человек) | 'bot' (сервисный бот) | 'persona'
   * (виртуальная личность). is_bot остаётся производным флагом (bot/persona).
   *
   * @generated from field: string kind = 23;
   */
  kind: string;

  /**
   * ИИ-блок: ссылка на агента (metadata_ai_agents), «душа» бота/личности.
   *
   * @generated from field: string bot_agent_id = 24;
   */
  botAgentId: string;

  /**
   * ИИ-блок: транспорт бота/личности — '' (внутренний чат, событийно)
   * или код адаптера внешней системы (metadata_adapters).
   *
   * @generated from field: string bot_transport = 25;
   */
  botTransport: string;

  /**
   * ИИ-блок: признак «это бот/личность» (видной из kind; дублируется для удобства).
   *
   * @generated from field: bool is_bot = 26;
   */
  isBot: boolean;

  /**
   * ПОДТВЕРЖДЕНИЕ ТЕЛЕФОНА (без SMS/звонков): когда и каким доверенным
   * каналом подтверждён номер (telegram|max|operator). Пусто = не подтверждён;
   * смена номера сбрасывает подтверждение (SSoT — сервер).
   *
   * @generated from field: string phone_verified_at = 27;
   */
  phoneVerifiedAt: string;

  /**
   * @generated from field: string phone_verified_via = 28;
   */
  phoneVerifiedVia: string;

  /**
   * ПРОФИЛЬ (для ВСЕХ баз): пол ('male'|'female'|'' = не заполнено; текст,
   * не перечисление — работает везде без зависимостей) и ДВА АДРЕСА
   * (консультация address-resolution 2026-10-30): «прописка» (стабильный,
   * ручной) и «текущий» (где сейчас; ручной ввод — истина, авто-источники
   * только по явному действию).
   *
   * текущий адрес (текст; физколонка `address` — legacy имя)
   *
   * @generated from field: string address_current = 29;
   */
  addressCurrent: string;

  /**
   * пол: 'male' | 'female' | '' (не заполнено)
   *
   * @generated from field: string gender = 30;
   */
  gender: string;

  /**
   * адрес проживания / прописка (ручной, стабильный)
   *
   * @generated from field: string address_home = 31;
   */
  addressHome: string;

  /**
   * Источник/точность/свежесть ТЕКУЩЕГО адреса: 'manual' | 'gps' | 'ip' | ''
   * (пусто = не определено/очищено); точность: 'exact' | 'street' | 'city' |
   * 'region' | ''; updated_at — когда источник последний раз менял значение.
   *
   * @generated from field: string address_current_source = 32;
   */
  addressCurrentSource: string;

  /**
   * @generated from field: string address_current_accuracy = 33;
   */
  addressCurrentAccuracy: string;

  /**
   * @generated from field: string address_current_updated_at = 34;
   */
  addressCurrentUpdatedAt: string;
};

/**
 * Describes the message zdc.Entity.
 * Use `create(EntitySchema)` to create a new message.
 */
export const EntitySchema: GenMessage<Entity> = /*@__PURE__*/
  messageDesc(file_zdc, 224);

/**
 * Канал связи пользователя (как в 1С: контактная информация механизма):
 * telegram / whatsapp / signal / email / phone / ... — channel — произвольный
 *
 * @generated from message zdc.EntityChannel
 */
export type EntityChannel = Message<"zdc.EntityChannel"> & {
  /**
   * @generated from field: string channel = 1;
   */
  channel: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;

  /**
   * основной канал (для нотификаций/восстановления пароля)
   *
   * @generated from field: bool is_main = 3;
   */
  isMain: boolean;

  /**
   * подтверждён владельцем (код из канала)
   *
   * @generated from field: bool is_verified = 4;
   */
  isVerified: boolean;

  /**
   * @generated from field: string verified_at = 5;
   */
  verifiedAt: string;

  /**
   * когда отправлен последний код
   *
   * @generated from field: string verification_sent_at = 6;
   */
  verificationSentAt: string;
};

/**
 * Describes the message zdc.EntityChannel.
 * Use `create(EntityChannelSchema)` to create a new message.
 */
export const EntityChannelSchema: GenMessage<EntityChannel> = /*@__PURE__*/
  messageDesc(file_zdc, 225);

/**
 * Запрос кода подтверждения канала (отправляет внешний сервис каналов).
 *
 * @generated from message zdc.SendVerificationCodeRequest
 */
export type SendVerificationCodeRequest = Message<"zdc.SendVerificationCodeRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string channel = 2;
   */
  channel: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * Describes the message zdc.SendVerificationCodeRequest.
 * Use `create(SendVerificationCodeRequestSchema)` to create a new message.
 */
export const SendVerificationCodeRequestSchema: GenMessage<SendVerificationCodeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 226);

/**
 * Проверка кода подтверждения канала.
 *
 * @generated from message zdc.VerifyChannelRequest
 */
export type VerifyChannelRequest = Message<"zdc.VerifyChannelRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string channel = 2;
   */
  channel: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;

  /**
   * @generated from field: string code = 4;
   */
  code: string;
};

/**
 * Describes the message zdc.VerifyChannelRequest.
 * Use `create(VerifyChannelRequestSchema)` to create a new message.
 */
export const VerifyChannelRequestSchema: GenMessage<VerifyChannelRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 227);

/**
 * Тестовая отправка кода на канал (кнопка «Проверить» в настройках канала).
 *
 * @generated from message zdc.TestChannelRequest
 */
export type TestChannelRequest = Message<"zdc.TestChannelRequest"> & {
  /**
   * @generated from field: string channel = 1;
   */
  channel: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message zdc.TestChannelRequest.
 * Use `create(TestChannelRequestSchema)` to create a new message.
 */
export const TestChannelRequestSchema: GenMessage<TestChannelRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 228);

/**
 * Доступный канал (SSoT — реестр провайдеров сервера).
 *
 * @generated from message zdc.ChannelInfo
 */
export type ChannelInfo = Message<"zdc.ChannelInfo"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string display = 2;
   */
  display: string;

  /**
   * @generated from field: bool builtin = 3;
   */
  builtin: boolean;

  /**
   * @generated from field: bool configurable = 4;
   */
  configurable: boolean;

  /**
   * поля настроек канала
   *
   * @generated from field: repeated string fields = 5;
   */
  fields: string[];
};

/**
 * Describes the message zdc.ChannelInfo.
 * Use `create(ChannelInfoSchema)` to create a new message.
 */
export const ChannelInfoSchema: GenMessage<ChannelInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 229);

/**
 * @generated from message zdc.ChannelInfoList
 */
export type ChannelInfoList = Message<"zdc.ChannelInfoList"> & {
  /**
   * @generated from field: repeated zdc.ChannelInfo items = 1;
   */
  items: ChannelInfo[];
};

/**
 * Describes the message zdc.ChannelInfoList.
 * Use `create(ChannelInfoListSchema)` to create a new message.
 */
export const ChannelInfoListSchema: GenMessage<ChannelInfoList> = /*@__PURE__*/
  messageDesc(file_zdc, 230);

/**
 * Настройки регистрации (публичные — для формы регистрации ДО входа).
 *
 * @generated from message zdc.RegistrationSettings
 */
export type RegistrationSettings = Message<"zdc.RegistrationSettings"> & {
  /**
   * отображаемые поля формы регистрации
   *
   * @generated from field: repeated string visible_fields = 1;
   */
  visibleFields: string[];

  /**
   * обязательные (⊆ видимых)
   *
   * @generated from field: repeated string required_fields = 2;
   */
  requiredFields: string[];

  /**
   * каналы: доступность + проверка
   *
   * @generated from field: repeated zdc.RegistrationSettings.ChannelOption channels = 3;
   */
  channels: RegistrationSettings_ChannelOption[];

  /**
   * Идентификаторы входа, разрешённые настройкой базы:
   * login | email | phone. Пусто/нет настройки = все три (совместимость).
   *
   * @generated from field: repeated string allowed_login_identities = 4;
   */
  allowedLoginIdentities: string[];

  /**
   * телефон обязателен при регистрации
   *
   * @generated from field: bool require_phone = 5;
   */
  requirePhone: boolean;

  /**
   * email обязателен при регистрации
   *
   * @generated from field: bool require_email = 6;
   */
  requireEmail: boolean;

  /**
   * Каналы подтверждения телефона (telegram | max). Пусто — телефонная
   * регистрация недоступна (валидатор не пропускает phone-only без канала).
   *
   * @generated from field: repeated string phone_verification_channels = 7;
   */
  phoneVerificationChannels: string[];
};

/**
 * Describes the message zdc.RegistrationSettings.
 * Use `create(RegistrationSettingsSchema)` to create a new message.
 */
export const RegistrationSettingsSchema: GenMessage<RegistrationSettings> = /*@__PURE__*/
  messageDesc(file_zdc, 231);

/**
 * @generated from message zdc.RegistrationSettings.ChannelOption
 */
export type RegistrationSettings_ChannelOption = Message<"zdc.RegistrationSettings.ChannelOption"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string display = 2;
   */
  display: string;

  /**
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;

  /**
   * @generated from field: bool verify = 4;
   */
  verify: boolean;
};

/**
 * Describes the message zdc.RegistrationSettings.ChannelOption.
 * Use `create(RegistrationSettings_ChannelOptionSchema)` to create a new message.
 */
export const RegistrationSettings_ChannelOptionSchema: GenMessage<RegistrationSettings_ChannelOption> = /*@__PURE__*/
  messageDesc(file_zdc, 231, 0);

/**
 * @generated from message zdc.EntityList
 */
export type EntityList = Message<"zdc.EntityList"> & {
  /**
   * @generated from field: repeated zdc.Entity items = 1;
   */
  items: Entity[];
};

/**
 * Describes the message zdc.EntityList.
 * Use `create(EntityListSchema)` to create a new message.
 */
export const EntityListSchema: GenMessage<EntityList> = /*@__PURE__*/
  messageDesc(file_zdc, 232);

/**
 * @generated from message zdc.EntityLink
 */
export type EntityLink = Message<"zdc.EntityLink"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: string base_id = 3;
   */
  baseId: string;

  /**
   * @generated from field: string employee_id = 4;
   */
  employeeId: string;

  /**
   * @generated from field: string employee_name = 5;
   */
  employeeName: string;

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.EntityLink.
 * Use `create(EntityLinkSchema)` to create a new message.
 */
export const EntityLinkSchema: GenMessage<EntityLink> = /*@__PURE__*/
  messageDesc(file_zdc, 233);

/**
 * @generated from message zdc.EntityLinkList
 */
export type EntityLinkList = Message<"zdc.EntityLinkList"> & {
  /**
   * @generated from field: repeated zdc.EntityLink items = 1;
   */
  items: EntityLink[];
};

/**
 * Describes the message zdc.EntityLinkList.
 * Use `create(EntityLinkListSchema)` to create a new message.
 */
export const EntityLinkListSchema: GenMessage<EntityLinkList> = /*@__PURE__*/
  messageDesc(file_zdc, 234);

/**
 * @generated from message zdc.EntityRole
 */
export type EntityRole = Message<"zdc.EntityRole"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: string role_id = 3;
   */
  roleId: string;

  /**
   * @generated from field: string role_name = 4;
   */
  roleName: string;

  /**
   * @generated from field: string created_at = 5;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.EntityRole.
 * Use `create(EntityRoleSchema)` to create a new message.
 */
export const EntityRoleSchema: GenMessage<EntityRole> = /*@__PURE__*/
  messageDesc(file_zdc, 235);

/**
 * @generated from message zdc.EntityRoleList
 */
export type EntityRoleList = Message<"zdc.EntityRoleList"> & {
  /**
   * @generated from field: repeated zdc.EntityRole items = 1;
   */
  items: EntityRole[];
};

/**
 * Describes the message zdc.EntityRoleList.
 * Use `create(EntityRoleListSchema)` to create a new message.
 */
export const EntityRoleListSchema: GenMessage<EntityRoleList> = /*@__PURE__*/
  messageDesc(file_zdc, 236);

/**
 * @generated from message zdc.EntityPermission
 */
export type EntityPermission = Message<"zdc.EntityPermission"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: string permission = 3;
   */
  permission: string;

  /**
   * @generated from field: string scope_type = 4;
   */
  scopeType: string;

  /**
   * @generated from field: string scope_id = 5;
   */
  scopeId: string;

  /**
   * @generated from field: bool allow = 6;
   */
  allow: boolean;

  /**
   * @generated from field: string created_at = 7;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.EntityPermission.
 * Use `create(EntityPermissionSchema)` to create a new message.
 */
export const EntityPermissionSchema: GenMessage<EntityPermission> = /*@__PURE__*/
  messageDesc(file_zdc, 237);

/**
 * @generated from message zdc.EntityPermissionList
 */
export type EntityPermissionList = Message<"zdc.EntityPermissionList"> & {
  /**
   * @generated from field: repeated zdc.EntityPermission items = 1;
   */
  items: EntityPermission[];
};

/**
 * Describes the message zdc.EntityPermissionList.
 * Use `create(EntityPermissionListSchema)` to create a new message.
 */
export const EntityPermissionListSchema: GenMessage<EntityPermissionList> = /*@__PURE__*/
  messageDesc(file_zdc, 238);

/**
 * @generated from message zdc.EntityFilterAssignment
 */
export type EntityFilterAssignment = Message<"zdc.EntityFilterAssignment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: string filter_key = 3;
   */
  filterKey: string;

  /**
   * @generated from field: string filter_values = 4;
   */
  filterValues: string;

  /**
   * @generated from field: string created_at = 5;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.EntityFilterAssignment.
 * Use `create(EntityFilterAssignmentSchema)` to create a new message.
 */
export const EntityFilterAssignmentSchema: GenMessage<EntityFilterAssignment> = /*@__PURE__*/
  messageDesc(file_zdc, 239);

/**
 * @generated from message zdc.EntityFilterAssignmentList
 */
export type EntityFilterAssignmentList = Message<"zdc.EntityFilterAssignmentList"> & {
  /**
   * @generated from field: repeated zdc.EntityFilterAssignment items = 1;
   */
  items: EntityFilterAssignment[];
};

/**
 * Describes the message zdc.EntityFilterAssignmentList.
 * Use `create(EntityFilterAssignmentListSchema)` to create a new message.
 */
export const EntityFilterAssignmentListSchema: GenMessage<EntityFilterAssignmentList> = /*@__PURE__*/
  messageDesc(file_zdc, 240);

/**
 * @generated from message zdc.PackageManifest
 */
export type PackageManifest = Message<"zdc.PackageManifest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string version = 3;
   */
  version: string;

  /**
   * @generated from field: repeated string changelog = 4;
   */
  changelog: string[];

  /**
   * startup | package
   *
   * @generated from field: string kind = 5;
   */
  kind: string;

  /**
   * @generated from field: string min_platform = 6;
   */
  minPlatform: string;
};

/**
 * Describes the message zdc.PackageManifest.
 * Use `create(PackageManifestSchema)` to create a new message.
 */
export const PackageManifestSchema: GenMessage<PackageManifest> = /*@__PURE__*/
  messageDesc(file_zdc, 241);

/**
 * @generated from message zdc.ApplyPackageRequest
 */
export type ApplyPackageRequest = Message<"zdc.ApplyPackageRequest"> & {
  /**
   * base64 файла поставки (.hdd с манифестом)
   *
   * @generated from field: string data = 1;
   */
  data: string;
};

/**
 * Describes the message zdc.ApplyPackageRequest.
 * Use `create(ApplyPackageRequestSchema)` to create a new message.
 */
export const ApplyPackageRequestSchema: GenMessage<ApplyPackageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 242);

/**
 * @generated from message zdc.ApplyPackageResult
 */
export type ApplyPackageResult = Message<"zdc.ApplyPackageResult"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: zdc.PackageManifest manifest = 3;
   */
  manifest?: PackageManifest | undefined;
};

/**
 * Describes the message zdc.ApplyPackageResult.
 * Use `create(ApplyPackageResultSchema)` to create a new message.
 */
export const ApplyPackageResultSchema: GenMessage<ApplyPackageResult> = /*@__PURE__*/
  messageDesc(file_zdc, 243);

/**
 * @generated from message zdc.ExportPackageRequest
 */
export type ExportPackageRequest = Message<"zdc.ExportPackageRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string version = 3;
   */
  version: string;

  /**
   * @generated from field: repeated string changelog = 4;
   */
  changelog: string[];

  /**
   * @generated from field: string kind = 5;
   */
  kind: string;

  /**
   * А+Б (§18): false = ТОЛЬКО конфигурация (как .cf в 1С); true = + данные мастер-базы
   *
   * @generated from field: bool include_data = 6;
   */
  includeData: boolean;
};

/**
 * Describes the message zdc.ExportPackageRequest.
 * Use `create(ExportPackageRequestSchema)` to create a new message.
 */
export const ExportPackageRequestSchema: GenMessage<ExportPackageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 244);

/**
 * @generated from message zdc.InstalledPackage
 */
export type InstalledPackage = Message<"zdc.InstalledPackage"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string version = 3;
   */
  version: string;

  /**
   * @generated from field: string installed_at = 4;
   */
  installedAt: string;
};

/**
 * Describes the message zdc.InstalledPackage.
 * Use `create(InstalledPackageSchema)` to create a new message.
 */
export const InstalledPackageSchema: GenMessage<InstalledPackage> = /*@__PURE__*/
  messageDesc(file_zdc, 245);

/**
 * @generated from message zdc.InstalledPackageList
 */
export type InstalledPackageList = Message<"zdc.InstalledPackageList"> & {
  /**
   * @generated from field: repeated zdc.InstalledPackage items = 1;
   */
  items: InstalledPackage[];
};

/**
 * Describes the message zdc.InstalledPackageList.
 * Use `create(InstalledPackageListSchema)` to create a new message.
 */
export const InstalledPackageListSchema: GenMessage<InstalledPackageList> = /*@__PURE__*/
  messageDesc(file_zdc, 246);

/**
 * @generated from message zdc.PackageSettings
 */
export type PackageSettings = Message<"zdc.PackageSettings"> & {
  /**
   * пусто = локальный каталог
   *
   * @generated from field: string repository_url = 1;
   */
  repositoryUrl: string;

  /**
   * @generated from field: bool auto_update = 2;
   */
  autoUpdate: boolean;

  /**
   * ed25519 pub hex: фид хаба ОБЯЗАН быть подписан
   *
   * @generated from field: string trusted_key = 3;
   */
  trustedKey: string;

  /**
   * Политика обновления УСТАНОВЛЕННЫХ поставок (кроме core — он всегда auto):
   * "auto" (применять) | "notify" (уведомлять) | "manual" (ничего).
   *
   * @generated from field: string update_mode = 4;
   */
  updateMode: string;

  /**
   * Канал проверки обновлений (Hydra Update Hub): stable | beta (пусто = stable).
   *
   * @generated from field: string update_channel = 5;
   */
  updateChannel: string;
};

/**
 * Describes the message zdc.PackageSettings.
 * Use `create(PackageSettingsSchema)` to create a new message.
 */
export const PackageSettingsSchema: GenMessage<PackageSettings> = /*@__PURE__*/
  messageDesc(file_zdc, 247);

/**
 * Список поставок из репозитория (LocalDir/HTTP) с признаком доступного обновления.
 *
 * @generated from message zdc.PackageUpdate
 */
export type PackageUpdate = Message<"zdc.PackageUpdate"> & {
  /**
   * @generated from field: zdc.PackageManifest manifest = 1;
   */
  manifest?: PackageManifest | undefined;

  /**
   * установленная в базе (пусто — не установлена)
   *
   * @generated from field: string current_version = 2;
   */
  currentVersion: string;

  /**
   * @generated from field: bool update_available = 3;
   */
  updateAvailable: boolean;

  /**
   * Репозиторий (для ApplyFromRepository / автообновления): url файла,
   * SHA-256 hash (контроль целостности), размер, источник ('local' | 'http')
   *
   * @generated from field: string url = 4;
   */
  url: string;

  /**
   * @generated from field: string hash = 5;
   */
  hash: string;

  /**
   * @generated from field: int64 size = 6;
   */
  size: bigint;

  /**
   * @generated from field: string source = 7;
   */
  source: string;
};

/**
 * Describes the message zdc.PackageUpdate.
 * Use `create(PackageUpdateSchema)` to create a new message.
 */
export const PackageUpdateSchema: GenMessage<PackageUpdate> = /*@__PURE__*/
  messageDesc(file_zdc, 248);

/**
 * @generated from message zdc.PackageUpdateList
 */
export type PackageUpdateList = Message<"zdc.PackageUpdateList"> & {
  /**
   * @generated from field: repeated zdc.PackageUpdate items = 1;
   */
  items: PackageUpdate[];
};

/**
 * Describes the message zdc.PackageUpdateList.
 * Use `create(PackageUpdateListSchema)` to create a new message.
 */
export const PackageUpdateListSchema: GenMessage<PackageUpdateList> = /*@__PURE__*/
  messageDesc(file_zdc, 249);

/**
 * Применение поставки ИЗ РЕПОЗИТОРИЯ одной кнопкой:
 * template_id обязателен, version пусто = последняя доступная.
 *
 * @generated from message zdc.ApplyFromRepositoryRequest
 */
export type ApplyFromRepositoryRequest = Message<"zdc.ApplyFromRepositoryRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: string version = 2;
   */
  version: string;
};

/**
 * Describes the message zdc.ApplyFromRepositoryRequest.
 * Use `create(ApplyFromRepositoryRequestSchema)` to create a new message.
 */
export const ApplyFromRepositoryRequestSchema: GenMessage<ApplyFromRepositoryRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 250);

/**
 * Удаление поставки (как 1С «снять с поддержки» + удаление объектов):
 * удаляются ВСЕ объекты поставки ВМЕСТЕ С ИХ ДАННЫМИ (физические таблицы).
 *
 * @generated from message zdc.UninstallPackageRequest
 */
export type UninstallPackageRequest = Message<"zdc.UninstallPackageRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * Describes the message zdc.UninstallPackageRequest.
 * Use `create(UninstallPackageRequestSchema)` to create a new message.
 */
export const UninstallPackageRequestSchema: GenMessage<UninstallPackageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 251);

/**
 * ПЕРЕПРИМЕНЕНИЕ установленной поставки (та же версия, из файла {templatesDir}/
 * {id}-{version}.hdd): догоны ядра (справка/тест дополнений и т.п.) применяются
 * повторно; идемпотентно.
 *
 * @generated from message zdc.ReapplyPackageRequest
 */
export type ReapplyPackageRequest = Message<"zdc.ReapplyPackageRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * Describes the message zdc.ReapplyPackageRequest.
 * Use `create(ReapplyPackageRequestSchema)` to create a new message.
 */
export const ReapplyPackageRequestSchema: GenMessage<ReapplyPackageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 252);

/**
 * МАСТЕР-БАЗА одной кнопкой (упрощённый механизм обновления поставки):
 * 1) Снять с поддержки ВСЮ поставку — метки template_id уходят со ВСЕХ объектов
 *    поставки (объекты остаются, свободно редактируются).
 * 2) Обновить поставку — пересборка .hdd из ТЕКУЩЕЙ конфигурации базы (новая
 *    версия) + ВОЗВРАТ на поддержку + файл в репозитории (templatesDir).
 *
 * @generated from message zdc.UnprotectPackageRequest
 */
export type UnprotectPackageRequest = Message<"zdc.UnprotectPackageRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * Describes the message zdc.UnprotectPackageRequest.
 * Use `create(UnprotectPackageRequestSchema)` to create a new message.
 */
export const UnprotectPackageRequestSchema: GenMessage<UnprotectPackageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 253);

/**
 * @generated from message zdc.RefreshPackageRequest
 */
export type RefreshPackageRequest = Message<"zdc.RefreshPackageRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * НОВАЯ версия (semver)
   *
   * @generated from field: string version = 2;
   */
  version: string;

  /**
   * @generated from field: string changelog = 3;
   */
  changelog: string;

  /**
   * пусто = сохранить текущее имя
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * А+Б (§18): false = только конфигурация; true = + данные мастер-базы
   *
   * @generated from field: bool include_data = 5;
   */
  includeData: boolean;
};

/**
 * Describes the message zdc.RefreshPackageRequest.
 * Use `create(RefreshPackageRequestSchema)` to create a new message.
 */
export const RefreshPackageRequestSchema: GenMessage<RefreshPackageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 254);

/**
 * @generated from message zdc.RefreshPackageResult
 */
export type RefreshPackageResult = Message<"zdc.RefreshPackageResult"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * {template_id}-{version}.hdd
   *
   * @generated from field: string file_name = 3;
   */
  fileName: string;

  /**
   * base64 файла (для скачивания)
   *
   * @generated from field: string data = 4;
   */
  data: string;
};

/**
 * Describes the message zdc.RefreshPackageResult.
 * Use `create(RefreshPackageResultSchema)` to create a new message.
 */
export const RefreshPackageResultSchema: GenMessage<RefreshPackageResult> = /*@__PURE__*/
  messageDesc(file_zdc, 255);

/**
 * @generated from message zdc.LoginRequest
 */
export type LoginRequest = Message<"zdc.LoginRequest"> & {
  /**
   * @generated from field: string login = 1;
   */
  login: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * Цифровой ключ (4 цифры) — для auth_mode 'pin' | 'both' (пароль или ключ)
   *
   * @generated from field: string pin = 3;
   */
  pin: string;

  /**
   * УСТРОЙСТВО ВХОДА (необязательно): стабильный id устройства клиента
   * (localStorage/нативное хранилище) и человеческое имя. Сервер привязывает
   * их к сессии: «Мои устройства» и доверие устройства после подтверждения
   * телефона. Пусто — сессия без привязки к устройству (не доверенная).
   *
   * @generated from field: string device_id = 4;
   */
  deviceId: string;

  /**
   * @generated from field: string device_name = 5;
   */
  deviceName: string;
};

/**
 * Describes the message zdc.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 256);

/**
 * ВХОД ПО QR-КОДУ: у каждого пользователя СВОЙ уникальный токен-ссылка
 * ({origin}/login/qr/{token}); вход по ссылке = обычная сессия (JWT+сессия).
 * Перегенерация токена ОТМЕНЯЕТ все старые ссылки.
 *
 * @generated from message zdc.GetQrLoginTokenRequest
 */
export type GetQrLoginTokenRequest = Message<"zdc.GetQrLoginTokenRequest"> & {
  /**
   * user_id: пусто = СВОЙ токен (JWT); чужой user_id — только администратор
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * origin клиента (http://host:port) — сервер строит ссылку входа и
   * генерирует QR-код (PNG): {origin}/login/qr/{token}
   *
   * @generated from field: string origin = 2;
   */
  origin: string;
};

/**
 * Describes the message zdc.GetQrLoginTokenRequest.
 * Use `create(GetQrLoginTokenRequestSchema)` to create a new message.
 */
export const GetQrLoginTokenRequestSchema: GenMessage<GetQrLoginTokenRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 257);

/**
 * @generated from message zdc.GetQrLoginTokenResponse
 */
export type GetQrLoginTokenResponse = Message<"zdc.GetQrLoginTokenResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * QR-код ссылки входа {origin}/login/qr/{token} — PNG (base64), генерирует СЕРВЕР
   *
   * @generated from field: string qr_png = 2;
   */
  qrPng: string;
};

/**
 * Describes the message zdc.GetQrLoginTokenResponse.
 * Use `create(GetQrLoginTokenResponseSchema)` to create a new message.
 */
export const GetQrLoginTokenResponseSchema: GenMessage<GetQrLoginTokenResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 258);

/**
 * @generated from message zdc.LoginByQrTokenRequest
 */
export type LoginByQrTokenRequest = Message<"zdc.LoginByQrTokenRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message zdc.LoginByQrTokenRequest.
 * Use `create(LoginByQrTokenRequestSchema)` to create a new message.
 */
export const LoginByQrTokenRequestSchema: GenMessage<LoginByQrTokenRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 259);

/**
 * @generated from message zdc.RegenerateQrLoginTokenRequest
 */
export type RegenerateQrLoginTokenRequest = Message<"zdc.RegenerateQrLoginTokenRequest"> & {
  /**
   * user_id: пусто = СВОЙ токен (JWT); чужой user_id — только администратор
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string origin = 2;
   */
  origin: string;
};

/**
 * Describes the message zdc.RegenerateQrLoginTokenRequest.
 * Use `create(RegenerateQrLoginTokenRequestSchema)` to create a new message.
 */
export const RegenerateQrLoginTokenRequestSchema: GenMessage<RegenerateQrLoginTokenRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 260);

/**
 * Вход по коду приглашения: код выдаёт специалист (InviteUser), пациент
 * вводит его на форме входа. Код одноразовый (погашается при входе).
 *
 * @generated from message zdc.LoginByInviteCodeRequest
 */
export type LoginByInviteCodeRequest = Message<"zdc.LoginByInviteCodeRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.LoginByInviteCodeRequest.
 * Use `create(LoginByInviteCodeRequestSchema)` to create a new message.
 */
export const LoginByInviteCodeRequestSchema: GenMessage<LoginByInviteCodeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 261);

/**
 * Установка первых/новых учётных данных текущего пользователя: хотя бы одно
 * из полей (пароль ≥ 6 символов ИЛИ цифровой ключ — ровно 4 цифры).
 *
 * @generated from message zdc.SetLoginCredentialsRequest
 */
export type SetLoginCredentialsRequest = Message<"zdc.SetLoginCredentialsRequest"> & {
  /**
   * @generated from field: string password = 1;
   */
  password: string;

  /**
   * @generated from field: string pin = 2;
   */
  pin: string;
};

/**
 * Describes the message zdc.SetLoginCredentialsRequest.
 * Use `create(SetLoginCredentialsRequestSchema)` to create a new message.
 */
export const SetLoginCredentialsRequestSchema: GenMessage<SetLoginCredentialsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 262);

/**
 * Предложение установки PWA после входа (настройка БАЗЫ: pwa.offer_enabled)
 *
 * @generated from message zdc.GetPwaOfferRequest
 */
export type GetPwaOfferRequest = Message<"zdc.GetPwaOfferRequest"> & {
};

/**
 * Describes the message zdc.GetPwaOfferRequest.
 * Use `create(GetPwaOfferRequestSchema)` to create a new message.
 */
export const GetPwaOfferRequestSchema: GenMessage<GetPwaOfferRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 263);

/**
 * @generated from message zdc.GetPwaOfferResponse
 */
export type GetPwaOfferResponse = Message<"zdc.GetPwaOfferResponse"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;
};

/**
 * Describes the message zdc.GetPwaOfferResponse.
 * Use `create(GetPwaOfferResponseSchema)` to create a new message.
 */
export const GetPwaOfferResponseSchema: GenMessage<GetPwaOfferResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 264);

/**
 * @generated from message zdc.SetPwaOfferRequest
 */
export type SetPwaOfferRequest = Message<"zdc.SetPwaOfferRequest"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;
};

/**
 * Describes the message zdc.SetPwaOfferRequest.
 * Use `create(SetPwaOfferRequestSchema)` to create a new message.
 */
export const SetPwaOfferRequestSchema: GenMessage<SetPwaOfferRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 265);

/**
 * @generated from message zdc.LoginResponse
 */
export type LoginResponse = Message<"zdc.LoginResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: zdc.Entity entity = 2;
   */
  entity?: Entity | undefined;

  /**
   * true — у пользователя ещё НЕТ собственных учётных данных (вход по коду
   * приглашения/первый вход): требуется установить пароль и/или цифровой ключ
   * (SetLoginCredentials). После установки — false.
   *
   * @generated from field: bool must_set_credentials = 3;
   */
  mustSetCredentials: boolean;
};

/**
 * Describes the message zdc.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema: GenMessage<LoginResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 266);

/**
 * @generated from message zdc.LoginEntitiesResponse
 */
export type LoginEntitiesResponse = Message<"zdc.LoginEntitiesResponse"> & {
  /**
   * @generated from field: repeated zdc.Entity items = 1;
   */
  items: Entity[];
};

/**
 * Describes the message zdc.LoginEntitiesResponse.
 * Use `create(LoginEntitiesResponseSchema)` to create a new message.
 */
export const LoginEntitiesResponseSchema: GenMessage<LoginEntitiesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 267);

/**
 * @generated from message zdc.RegisterRequest
 */
export type RegisterRequest = Message<"zdc.RegisterRequest"> & {
  /**
   * @generated from field: string login = 1;
   */
  login: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * Устройство входа (как LoginRequest): привязка к сессии.
   *
   * @generated from field: string device_id = 5;
   */
  deviceId: string;

  /**
   * @generated from field: string device_name = 6;
   */
  deviceName: string;

  /**
   * Код приглашения (механизм приглашений): принимается при регистрации.
   * Пусто — обычная регистрация. Неверный/погашенный код — явная ошибка.
   *
   * @generated from field: string invite_code = 7;
   */
  inviteCode: string;

  /**
   * Телефон для регистрации «только по телефону» (hydramedic). Нормализация —
   * на сервере (auth.NormalizePhone). Телефонная регистрация НЕ создаёт сессию:
   * сначала код из канала (Telegram/MAX), затем CompleteRegistration.
   *
   * @generated from field: string phone = 8;
   */
  phone: string;

  /**
   * Канал подтверждения телефона из настроек базы (phone_verification_channels):
   * telegram | max. Пусто — первый разрешённый.
   *
   * @generated from field: string verification_channel = 9;
   */
  verificationChannel: string;
};

/**
 * Describes the message zdc.RegisterRequest.
 * Use `create(RegisterRequestSchema)` to create a new message.
 */
export const RegisterRequestSchema: GenMessage<RegisterRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 268);

/**
 * @generated from message zdc.RegisterResponse
 */
export type RegisterResponse = Message<"zdc.RegisterResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: zdc.Entity entity = 2;
   */
  entity?: Entity | undefined;

  /**
   * true — регистрация требует подтверждения канала: код отправлен
   * (например, на email); завершение — CompleteRegistration.
   *
   * @generated from field: bool verification_required = 3;
   */
  verificationRequired: boolean;

  /**
   * на какой канал отправлен код
   *
   * @generated from field: string verification_channel = 4;
   */
  verificationChannel: string;

  /**
   * Телефонная регистрация через Telegram/MAX без привязки: одноразовая ссылка
   * запуска бота (deep link). Пользователь открывает её, бот присылает код,
   * затем CompleteRegistration(phone, code).
   *
   * @generated from field: string verification_url = 5;
   */
  verificationUrl: string;

  /**
   * @generated from field: string verification_hint = 6;
   */
  verificationHint: string;

  /**
   * @generated from field: string verification_expires_at = 7;
   */
  verificationExpiresAt: string;
};

/**
 * Describes the message zdc.RegisterResponse.
 * Use `create(RegisterResponseSchema)` to create a new message.
 */
export const RegisterResponseSchema: GenMessage<RegisterResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 269);

/**
 * Завершение регистрации после подтверждения канала (ввод кода из канала).
 *
 * @generated from message zdc.CompleteRegistrationRequest
 */
export type CompleteRegistrationRequest = Message<"zdc.CompleteRegistrationRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * Код приглашения (если регистрация начата с ним): применяется после
   * создания пользователя. Пусто — берётся сохранённый при Register.
   *
   * @generated from field: string invite_code = 3;
   */
  inviteCode: string;

  /**
   * Телефонная регистрация: нормализованный сервером телефон (можно вводить
   * в любом формате) и канал подтверждения (telegram | max).
   *
   * @generated from field: string phone = 4;
   */
  phone: string;

  /**
   * @generated from field: string channel = 5;
   */
  channel: string;
};

/**
 * Describes the message zdc.CompleteRegistrationRequest.
 * Use `create(CompleteRegistrationRequestSchema)` to create a new message.
 */
export const CompleteRegistrationRequestSchema: GenMessage<CompleteRegistrationRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 270);

/**
 * @generated from message zdc.CompleteRegistrationResponse
 */
export type CompleteRegistrationResponse = Message<"zdc.CompleteRegistrationResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: zdc.Entity entity = 2;
   */
  entity?: Entity | undefined;
};

/**
 * Describes the message zdc.CompleteRegistrationResponse.
 * Use `create(CompleteRegistrationResponseSchema)` to create a new message.
 */
export const CompleteRegistrationResponseSchema: GenMessage<CompleteRegistrationResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 271);

/**
 * @generated from message zdc.AdminSwitchRequest
 */
export type AdminSwitchRequest = Message<"zdc.AdminSwitchRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;
};

/**
 * Describes the message zdc.AdminSwitchRequest.
 * Use `create(AdminSwitchRequestSchema)` to create a new message.
 */
export const AdminSwitchRequestSchema: GenMessage<AdminSwitchRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 272);

/**
 * @generated from message zdc.AdminSwitchResponse
 */
export type AdminSwitchResponse = Message<"zdc.AdminSwitchResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message zdc.AdminSwitchResponse.
 * Use `create(AdminSwitchResponseSchema)` to create a new message.
 */
export const AdminSwitchResponseSchema: GenMessage<AdminSwitchResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 273);

/**
 * @generated from message zdc.Role
 */
export type Role = Message<"zdc.Role"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: bool is_system = 4;
   */
  isSystem: boolean;

  /**
   * @generated from field: repeated zdc.RolePermission permissions = 5;
   */
  permissions: RolePermission[];

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 7;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.Role.
 * Use `create(RoleSchema)` to create a new message.
 */
export const RoleSchema: GenMessage<Role> = /*@__PURE__*/
  messageDesc(file_zdc, 274);

/**
 * @generated from message zdc.RoleList
 */
export type RoleList = Message<"zdc.RoleList"> & {
  /**
   * @generated from field: repeated zdc.Role items = 1;
   */
  items: Role[];
};

/**
 * Describes the message zdc.RoleList.
 * Use `create(RoleListSchema)` to create a new message.
 */
export const RoleListSchema: GenMessage<RoleList> = /*@__PURE__*/
  messageDesc(file_zdc, 275);

/**
 * @generated from message zdc.RolePermission
 */
export type RolePermission = Message<"zdc.RolePermission"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string role_id = 2;
   */
  roleId: string;

  /**
   * @generated from field: string permission = 3;
   */
  permission: string;

  /**
   * @generated from field: string scope_type = 4;
   */
  scopeType: string;

  /**
   * @generated from field: string scope_id = 5;
   */
  scopeId: string;

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.RolePermission.
 * Use `create(RolePermissionSchema)` to create a new message.
 */
export const RolePermissionSchema: GenMessage<RolePermission> = /*@__PURE__*/
  messageDesc(file_zdc, 276);

/**
 * @generated from message zdc.CreateRoleRequest
 */
export type CreateRoleRequest = Message<"zdc.CreateRoleRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message zdc.CreateRoleRequest.
 * Use `create(CreateRoleRequestSchema)` to create a new message.
 */
export const CreateRoleRequestSchema: GenMessage<CreateRoleRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 277);

/**
 * @generated from message zdc.UpdateRoleRequest
 */
export type UpdateRoleRequest = Message<"zdc.UpdateRoleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message zdc.UpdateRoleRequest.
 * Use `create(UpdateRoleRequestSchema)` to create a new message.
 */
export const UpdateRoleRequestSchema: GenMessage<UpdateRoleRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 278);

/**
 * @generated from message zdc.DeleteRoleRequest
 */
export type DeleteRoleRequest = Message<"zdc.DeleteRoleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteRoleRequest.
 * Use `create(DeleteRoleRequestSchema)` to create a new message.
 */
export const DeleteRoleRequestSchema: GenMessage<DeleteRoleRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 279);

/**
 * @generated from message zdc.SetDefaultRoleRequest
 */
export type SetDefaultRoleRequest = Message<"zdc.SetDefaultRoleRequest"> & {
  /**
   * @generated from field: string role_id = 1;
   */
  roleId: string;
};

/**
 * Describes the message zdc.SetDefaultRoleRequest.
 * Use `create(SetDefaultRoleRequestSchema)` to create a new message.
 */
export const SetDefaultRoleRequestSchema: GenMessage<SetDefaultRoleRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 280);

/**
 * @generated from message zdc.ListSessionsRequest
 */
export type ListSessionsRequest = Message<"zdc.ListSessionsRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;
};

/**
 * Describes the message zdc.ListSessionsRequest.
 * Use `create(ListSessionsRequestSchema)` to create a new message.
 */
export const ListSessionsRequestSchema: GenMessage<ListSessionsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 281);

/**
 * @generated from message zdc.ListAllSessionsRequest
 */
export type ListAllSessionsRequest = Message<"zdc.ListAllSessionsRequest"> & {
};

/**
 * Describes the message zdc.ListAllSessionsRequest.
 * Use `create(ListAllSessionsRequestSchema)` to create a new message.
 */
export const ListAllSessionsRequestSchema: GenMessage<ListAllSessionsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 282);

/**
 * @generated from message zdc.SessionInfo
 */
export type SessionInfo = Message<"zdc.SessionInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * имя пользователя (для общего списка сессий)
   *
   * @generated from field: string entity_name = 3;
   */
  entityName: string;

  /**
   * @generated from field: string created_at = 4;
   */
  createdAt: string;

  /**
   * @generated from field: string expires_at = 5;
   */
  expiresAt: string;

  /**
   * @generated from field: string ip = 6;
   */
  ip: string;

  /**
   * @generated from field: string user_agent = 7;
   */
  userAgent: string;

  /**
   * desktop | pwa | web
   *
   * @generated from field: string client_app = 8;
   */
  clientApp: string;

  /**
   * Устройство входа и доверие (после подтверждения телефона):
   *
   * @generated from field: string last_seen_at = 9;
   */
  lastSeenAt: string;

  /**
   * @generated from field: string device_id = 10;
   */
  deviceId: string;

  /**
   * @generated from field: string device_name = 11;
   */
  deviceName: string;

  /**
   * @generated from field: bool trusted = 12;
   */
  trusted: boolean;

  /**
   * сессия ТЕКУЩЕГО запроса (для «Мои устройства»)
   *
   * @generated from field: bool current = 13;
   */
  current: boolean;
};

/**
 * Describes the message zdc.SessionInfo.
 * Use `create(SessionInfoSchema)` to create a new message.
 */
export const SessionInfoSchema: GenMessage<SessionInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 283);

/**
 * @generated from message zdc.SessionList
 */
export type SessionList = Message<"zdc.SessionList"> & {
  /**
   * @generated from field: repeated zdc.SessionInfo items = 1;
   */
  items: SessionInfo[];
};

/**
 * Describes the message zdc.SessionList.
 * Use `create(SessionListSchema)` to create a new message.
 */
export const SessionListSchema: GenMessage<SessionList> = /*@__PURE__*/
  messageDesc(file_zdc, 284);

/**
 * @generated from message zdc.TrustMyDeviceRequest
 */
export type TrustMyDeviceRequest = Message<"zdc.TrustMyDeviceRequest"> & {
  /**
   * true — пометить ТЕКУЩУЮ сессию доверенной (требует подтверждённого
   * телефона), false — снять доверие.
   *
   * @generated from field: bool trusted = 1;
   */
  trusted: boolean;
};

/**
 * Describes the message zdc.TrustMyDeviceRequest.
 * Use `create(TrustMyDeviceRequestSchema)` to create a new message.
 */
export const TrustMyDeviceRequestSchema: GenMessage<TrustMyDeviceRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 285);

/**
 * @generated from message zdc.RevokeMyDeviceRequest
 */
export type RevokeMyDeviceRequest = Message<"zdc.RevokeMyDeviceRequest"> & {
  /**
   * только СВОЯ сессия (чужая → NotFound)
   *
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message zdc.RevokeMyDeviceRequest.
 * Use `create(RevokeMyDeviceRequestSchema)` to create a new message.
 */
export const RevokeMyDeviceRequestSchema: GenMessage<RevokeMyDeviceRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 286);

/**
 * Канал подтверждения: telegram | max | operator.
 *
 * @generated from message zdc.PhoneVerificationChannel
 */
export type PhoneVerificationChannel = Message<"zdc.PhoneVerificationChannel"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: bool available = 3;
   */
  available: boolean;

  /**
   * почему недоступен (пусто = доступен)
   *
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * Describes the message zdc.PhoneVerificationChannel.
 * Use `create(PhoneVerificationChannelSchema)` to create a new message.
 */
export const PhoneVerificationChannelSchema: GenMessage<PhoneVerificationChannel> = /*@__PURE__*/
  messageDesc(file_zdc, 287);

/**
 * @generated from message zdc.PhoneVerificationStatus
 */
export type PhoneVerificationStatus = Message<"zdc.PhoneVerificationStatus"> & {
  /**
   * @generated from field: string phone = 1;
   */
  phone: string;

  /**
   * @generated from field: string verified_at = 2;
   */
  verifiedAt: string;

  /**
   * @generated from field: string verified_via = 3;
   */
  verifiedVia: string;

  /**
   * @generated from field: repeated zdc.PhoneVerificationChannel channels = 4;
   */
  channels: PhoneVerificationChannel[];

  /**
   * Ожидающий подтверждения запрос (код отправлен/заявка у оператора).
   *
   * @generated from field: bool pending = 5;
   */
  pending: boolean;

  /**
   * @generated from field: string pending_channel = 6;
   */
  pendingChannel: string;

  /**
   * @generated from field: string pending_expires_at = 7;
   */
  pendingExpiresAt: string;
};

/**
 * Describes the message zdc.PhoneVerificationStatus.
 * Use `create(PhoneVerificationStatusSchema)` to create a new message.
 */
export const PhoneVerificationStatusSchema: GenMessage<PhoneVerificationStatus> = /*@__PURE__*/
  messageDesc(file_zdc, 288);

/**
 * @generated from message zdc.GetPhoneVerificationRequest
 */
export type GetPhoneVerificationRequest = Message<"zdc.GetPhoneVerificationRequest"> & {
};

/**
 * Describes the message zdc.GetPhoneVerificationRequest.
 * Use `create(GetPhoneVerificationRequestSchema)` to create a new message.
 */
export const GetPhoneVerificationRequestSchema: GenMessage<GetPhoneVerificationRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 289);

/**
 * @generated from message zdc.GetPhoneVerificationResponse
 */
export type GetPhoneVerificationResponse = Message<"zdc.GetPhoneVerificationResponse"> & {
  /**
   * @generated from field: zdc.PhoneVerificationStatus status = 1;
   */
  status?: PhoneVerificationStatus | undefined;
};

/**
 * Describes the message zdc.GetPhoneVerificationResponse.
 * Use `create(GetPhoneVerificationResponseSchema)` to create a new message.
 */
export const GetPhoneVerificationResponseSchema: GenMessage<GetPhoneVerificationResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 290);

/**
 * @generated from message zdc.RequestPhoneVerificationRequest
 */
export type RequestPhoneVerificationRequest = Message<"zdc.RequestPhoneVerificationRequest"> & {
  /**
   * telegram | max | operator
   *
   * @generated from field: string channel = 1;
   */
  channel: string;
};

/**
 * Describes the message zdc.RequestPhoneVerificationRequest.
 * Use `create(RequestPhoneVerificationRequestSchema)` to create a new message.
 */
export const RequestPhoneVerificationRequestSchema: GenMessage<RequestPhoneVerificationRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 291);

/**
 * @generated from message zdc.RequestPhoneVerificationResponse
 */
export type RequestPhoneVerificationResponse = Message<"zdc.RequestPhoneVerificationResponse"> & {
  /**
   * @generated from field: bool sent = 1;
   */
  sent: boolean;

  /**
   * @generated from field: string channel = 2;
   */
  channel: string;

  /**
   * @generated from field: string expires_at = 3;
   */
  expiresAt: string;

  /**
   * куда отправлен код / что делать дальше
   *
   * @generated from field: string hint = 4;
   */
  hint: string;
};

/**
 * Describes the message zdc.RequestPhoneVerificationResponse.
 * Use `create(RequestPhoneVerificationResponseSchema)` to create a new message.
 */
export const RequestPhoneVerificationResponseSchema: GenMessage<RequestPhoneVerificationResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 292);

/**
 * @generated from message zdc.ConfirmPhoneVerificationRequest
 */
export type ConfirmPhoneVerificationRequest = Message<"zdc.ConfirmPhoneVerificationRequest"> & {
  /**
   * telegram | max (код из канала)
   *
   * @generated from field: string channel = 1;
   */
  channel: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message zdc.ConfirmPhoneVerificationRequest.
 * Use `create(ConfirmPhoneVerificationRequestSchema)` to create a new message.
 */
export const ConfirmPhoneVerificationRequestSchema: GenMessage<ConfirmPhoneVerificationRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 293);

/**
 * @generated from message zdc.ConfirmPhoneVerificationResponse
 */
export type ConfirmPhoneVerificationResponse = Message<"zdc.ConfirmPhoneVerificationResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string verified_at = 2;
   */
  verifiedAt: string;

  /**
   * @generated from field: string verified_via = 3;
   */
  verifiedVia: string;

  /**
   * @generated from field: bool device_trusted = 4;
   */
  deviceTrusted: boolean;
};

/**
 * Describes the message zdc.ConfirmPhoneVerificationResponse.
 * Use `create(ConfirmPhoneVerificationResponseSchema)` to create a new message.
 */
export const ConfirmPhoneVerificationResponseSchema: GenMessage<ConfirmPhoneVerificationResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 294);

/**
 * @generated from message zdc.AttachPhoneVerificationRequest
 */
export type AttachPhoneVerificationRequest = Message<"zdc.AttachPhoneVerificationRequest"> & {
  /**
   * Подписанная атрибуция центра доверия (trust.v1, Ed25519).
   *
   * @generated from field: string attestation_token = 1;
   */
  attestationToken: string;
};

/**
 * Describes the message zdc.AttachPhoneVerificationRequest.
 * Use `create(AttachPhoneVerificationRequestSchema)` to create a new message.
 */
export const AttachPhoneVerificationRequestSchema: GenMessage<AttachPhoneVerificationRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 295);

/**
 * @generated from message zdc.AttachPhoneVerificationResponse
 */
export type AttachPhoneVerificationResponse = Message<"zdc.AttachPhoneVerificationResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string verified_at = 2;
   */
  verifiedAt: string;

  /**
   * provider атрибуции: telegram | trusted_device | sms
   *
   * @generated from field: string verified_via = 3;
   */
  verifiedVia: string;

  /**
   * @generated from field: bool device_trusted = 4;
   */
  deviceTrusted: boolean;
};

/**
 * Describes the message zdc.AttachPhoneVerificationResponse.
 * Use `create(AttachPhoneVerificationResponseSchema)` to create a new message.
 */
export const AttachPhoneVerificationResponseSchema: GenMessage<AttachPhoneVerificationResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 296);

/**
 * @generated from message zdc.SetMyPhoneRequest
 */
export type SetMyPhoneRequest = Message<"zdc.SetMyPhoneRequest"> & {
  /**
   * @generated from field: string phone = 1;
   */
  phone: string;
};

/**
 * Describes the message zdc.SetMyPhoneRequest.
 * Use `create(SetMyPhoneRequestSchema)` to create a new message.
 */
export const SetMyPhoneRequestSchema: GenMessage<SetMyPhoneRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 297);

/**
 * @generated from message zdc.SetMyPhoneResponse
 */
export type SetMyPhoneResponse = Message<"zdc.SetMyPhoneResponse"> & {
  /**
   * @generated from field: zdc.PhoneVerificationStatus status = 1;
   */
  status?: PhoneVerificationStatus | undefined;
};

/**
 * Describes the message zdc.SetMyPhoneResponse.
 * Use `create(SetMyPhoneResponseSchema)` to create a new message.
 */
export const SetMyPhoneResponseSchema: GenMessage<SetMyPhoneResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 298);

/**
 * @generated from message zdc.RevokeSessionRequest
 */
export type RevokeSessionRequest = Message<"zdc.RevokeSessionRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message zdc.RevokeSessionRequest.
 * Use `create(RevokeSessionRequestSchema)` to create a new message.
 */
export const RevokeSessionRequestSchema: GenMessage<RevokeSessionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 299);

/**
 * @generated from message zdc.RevokeAllSessionsRequest
 */
export type RevokeAllSessionsRequest = Message<"zdc.RevokeAllSessionsRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;
};

/**
 * Describes the message zdc.RevokeAllSessionsRequest.
 * Use `create(RevokeAllSessionsRequestSchema)` to create a new message.
 */
export const RevokeAllSessionsRequestSchema: GenMessage<RevokeAllSessionsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 300);

/**
 * @generated from message zdc.SubscribeRequest
 */
export type SubscribeRequest = Message<"zdc.SubscribeRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: repeated string topics = 2;
   */
  topics: string[];
};

/**
 * Describes the message zdc.SubscribeRequest.
 * Use `create(SubscribeRequestSchema)` to create a new message.
 */
export const SubscribeRequestSchema: GenMessage<SubscribeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 301);

/**
 * @generated from message zdc.Event
 */
export type Event = Message<"zdc.Event"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string topic = 2;
   */
  topic: string;

  /**
   * @generated from field: string entity_type = 3;
   */
  entityType: string;

  /**
   * @generated from field: string entity_id = 4;
   */
  entityId: string;

  /**
   * @generated from field: string action = 5;
   */
  action: string;

  /**
   * @generated from field: string payload = 6;
   */
  payload: string;

  /**
   * @generated from field: string timestamp = 7;
   */
  timestamp: string;

  /**
   * @generated from field: bool retained = 8;
   */
  retained: boolean;
};

/**
 * Describes the message zdc.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema: GenMessage<Event> = /*@__PURE__*/
  messageDesc(file_zdc, 302);

/**
 * @generated from message zdc.PublishRequest
 */
export type PublishRequest = Message<"zdc.PublishRequest"> & {
  /**
   * @generated from field: string topic = 1;
   */
  topic: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType: string;

  /**
   * @generated from field: string entity_id = 3;
   */
  entityId: string;

  /**
   * @generated from field: string action = 4;
   */
  action: string;

  /**
   * @generated from field: string payload = 5;
   */
  payload: string;

  /**
   * @generated from field: bool retain = 6;
   */
  retain: boolean;
};

/**
 * Describes the message zdc.PublishRequest.
 * Use `create(PublishRequestSchema)` to create a new message.
 */
export const PublishRequestSchema: GenMessage<PublishRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 303);

/**
 * Метрики шины (B2): счётчики фиксируются в МОМЕНТ ПОПЫТКИ доставки
 * (подписчик × фактический топик): delivered — в очереди/отдано retained;
 * dropped — очередь подписчика переполнена (издатель не блокируется).
 *
 * @generated from message zdc.BusStatsRequest
 */
export type BusStatsRequest = Message<"zdc.BusStatsRequest"> & {
  /**
   * фильтр тем по префиксу ('' = все; app.<code>. — приложение)
   *
   * @generated from field: string prefix = 1;
   */
  prefix: string;
};

/**
 * Describes the message zdc.BusStatsRequest.
 * Use `create(BusStatsRequestSchema)` to create a new message.
 */
export const BusStatsRequestSchema: GenMessage<BusStatsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 304);

/**
 * @generated from message zdc.BusSubscriberStats
 */
export type BusSubscriberStats = Message<"zdc.BusSubscriberStats"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: repeated string filters = 2;
   */
  filters: string[];

  /**
   * @generated from field: int64 delivered = 3;
   */
  delivered: bigint;

  /**
   * @generated from field: int64 dropped = 4;
   */
  dropped: bigint;

  /**
   * @generated from field: int64 queue_len = 5;
   */
  queueLen: bigint;

  /**
   * @generated from field: int64 queue_cap = 6;
   */
  queueCap: bigint;
};

/**
 * Describes the message zdc.BusSubscriberStats.
 * Use `create(BusSubscriberStatsSchema)` to create a new message.
 */
export const BusSubscriberStatsSchema: GenMessage<BusSubscriberStats> = /*@__PURE__*/
  messageDesc(file_zdc, 305);

/**
 * @generated from message zdc.BusTopicStats
 */
export type BusTopicStats = Message<"zdc.BusTopicStats"> & {
  /**
   * @generated from field: string topic = 1;
   */
  topic: string;

  /**
   * @generated from field: int64 delivered = 2;
   */
  delivered: bigint;

  /**
   * @generated from field: int64 dropped = 3;
   */
  dropped: bigint;

  /**
   * @generated from field: repeated zdc.BusSubscriberStats subscribers = 4;
   */
  subscribers: BusSubscriberStats[];
};

/**
 * Describes the message zdc.BusTopicStats.
 * Use `create(BusTopicStatsSchema)` to create a new message.
 */
export const BusTopicStatsSchema: GenMessage<BusTopicStats> = /*@__PURE__*/
  messageDesc(file_zdc, 306);

/**
 * @generated from message zdc.BusStats
 */
export type BusStats = Message<"zdc.BusStats"> & {
  /**
   * топ по дропам (desc), затем топик (asc)
   *
   * @generated from field: repeated zdc.BusTopicStats topics = 1;
   */
  topics: BusTopicStats[];

  /**
   * дропы по отфильтрованным темам
   *
   * @generated from field: int64 total_dropped = 2;
   */
  totalDropped: bigint;

  /**
   * активных подписок на шине
   *
   * @generated from field: int64 subscribers = 3;
   */
  subscribers: bigint;

  /**
   * тем в счётчиках (после фильтра)
   *
   * @generated from field: int64 topics_count = 4;
   */
  topicsCount: bigint;
};

/**
 * Describes the message zdc.BusStats.
 * Use `create(BusStatsSchema)` to create a new message.
 */
export const BusStatsSchema: GenMessage<BusStats> = /*@__PURE__*/
  messageDesc(file_zdc, 307);

/**
 * @generated from message zdc.GenerateDDLRequest
 */
export type GenerateDDLRequest = Message<"zdc.GenerateDDLRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;
};

/**
 * Describes the message zdc.GenerateDDLRequest.
 * Use `create(GenerateDDLRequestSchema)` to create a new message.
 */
export const GenerateDDLRequestSchema: GenMessage<GenerateDDLRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 308);

/**
 * @generated from message zdc.GenerateDDLResponse
 */
export type GenerateDDLResponse = Message<"zdc.GenerateDDLResponse"> & {
  /**
   * @generated from field: string ddl = 1;
   */
  ddl: string;
};

/**
 * Describes the message zdc.GenerateDDLResponse.
 * Use `create(GenerateDDLResponseSchema)` to create a new message.
 */
export const GenerateDDLResponseSchema: GenMessage<GenerateDDLResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 309);

/**
 * @generated from message zdc.ApplyDDLRequest
 */
export type ApplyDDLRequest = Message<"zdc.ApplyDDLRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;
};

/**
 * Describes the message zdc.ApplyDDLRequest.
 * Use `create(ApplyDDLRequestSchema)` to create a new message.
 */
export const ApplyDDLRequestSchema: GenMessage<ApplyDDLRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 310);

/**
 * @generated from message zdc.CreateBaseRequest
 */
export type CreateBaseRequest = Message<"zdc.CreateBaseRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string slug = 3;
   */
  slug: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * sqlite, postgres
   *
   * @generated from field: string db_type = 5;
   */
  dbType: string;

  /**
   * path or DSN
   *
   * @generated from field: string db_dsn = 6;
   */
  dbDsn: string;

  /**
   * @generated from field: string admin_user = 7;
   */
  adminUser: string;

  /**
   * JSON-настройки базы (опционально)
   *
   * @generated from field: string settings = 8;
   */
  settings: string;
};

/**
 * Describes the message zdc.CreateBaseRequest.
 * Use `create(CreateBaseRequestSchema)` to create a new message.
 */
export const CreateBaseRequestSchema: GenMessage<CreateBaseRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 311);

/**
 * @generated from message zdc.ListBasesRequest
 */
export type ListBasesRequest = Message<"zdc.ListBasesRequest"> & {
};

/**
 * Describes the message zdc.ListBasesRequest.
 * Use `create(ListBasesRequestSchema)` to create a new message.
 */
export const ListBasesRequestSchema: GenMessage<ListBasesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 312);

/**
 * @generated from message zdc.GetBaseRequest
 */
export type GetBaseRequest = Message<"zdc.GetBaseRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetBaseRequest.
 * Use `create(GetBaseRequestSchema)` to create a new message.
 */
export const GetBaseRequestSchema: GenMessage<GetBaseRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 313);

/**
 * @generated from message zdc.UpdateBaseRequest
 */
export type UpdateBaseRequest = Message<"zdc.UpdateBaseRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string slug = 3;
   */
  slug: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string admin_user = 5;
   */
  adminUser: string;

  /**
   * JSON-настройки базы (полная замена)
   *
   * @generated from field: string settings = 6;
   */
  settings: string;

  /**
   * Адрес базы данных (путь к файлу SQLite или DSN PostgreSQL).
   * Пусто = НЕ менять адрес (обновляются только переданные поля).
   * Смена адреса применяется сразу: закэшированный адаптер базы закрывается,
   * следующие запросы открываются по новому адресу.
   *
   * @generated from field: string db_dsn = 7;
   */
  dbDsn: string;
};

/**
 * Describes the message zdc.UpdateBaseRequest.
 * Use `create(UpdateBaseRequestSchema)` to create a new message.
 */
export const UpdateBaseRequestSchema: GenMessage<UpdateBaseRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 314);

/**
 * @generated from message zdc.DeleteBaseRequest
 */
export type DeleteBaseRequest = Message<"zdc.DeleteBaseRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteBaseRequest.
 * Use `create(DeleteBaseRequestSchema)` to create a new message.
 */
export const DeleteBaseRequestSchema: GenMessage<DeleteBaseRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 315);

/**
 * @generated from message zdc.PublishBaseRequest
 */
export type PublishBaseRequest = Message<"zdc.PublishBaseRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.PublishBaseRequest.
 * Use `create(PublishBaseRequestSchema)` to create a new message.
 */
export const PublishBaseRequestSchema: GenMessage<PublishBaseRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 316);

/**
 * Открыть базу по slug (переключение текущей базы сервера) — для веб-клиентов,
 * у которых нет нативного bridge (Wails OpenBase).
 *
 * @generated from message zdc.OpenBaseRequest
 */
export type OpenBaseRequest = Message<"zdc.OpenBaseRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;
};

/**
 * Describes the message zdc.OpenBaseRequest.
 * Use `create(OpenBaseRequestSchema)` to create a new message.
 */
export const OpenBaseRequestSchema: GenMessage<OpenBaseRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 317);

/**
 * @generated from message zdc.GetBaseSettingsRequest
 */
export type GetBaseSettingsRequest = Message<"zdc.GetBaseSettingsRequest"> & {
  /**
   * пусто = текущая/умолчание
   *
   * @generated from field: string slug = 1;
   */
  slug: string;
};

/**
 * Describes the message zdc.GetBaseSettingsRequest.
 * Use `create(GetBaseSettingsRequestSchema)` to create a new message.
 */
export const GetBaseSettingsRequestSchema: GenMessage<GetBaseSettingsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 318);

/**
 * @generated from message zdc.GetBaseSettingsResponse
 */
export type GetBaseSettingsResponse = Message<"zdc.GetBaseSettingsResponse"> & {
  /**
   * JSON настроек базы (pwa.* и пр.)
   *
   * @generated from field: string settings = 1;
   */
  settings: string;
};

/**
 * Describes the message zdc.GetBaseSettingsResponse.
 * Use `create(GetBaseSettingsResponseSchema)` to create a new message.
 */
export const GetBaseSettingsResponseSchema: GenMessage<GetBaseSettingsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 319);

/**
 * ExportBaseRequest: секреты по умолчанию ВКЛЮЧЕНЫ (exclude_secrets=false).
 *
 * @generated from message zdc.ExportBaseRequest
 */
export type ExportBaseRequest = Message<"zdc.ExportBaseRequest"> & {
  /**
   * true = не включать секреты (config.secrets_key, ключи)
   *
   * @generated from field: bool exclude_secrets = 1;
   */
  excludeSecrets: boolean;

  /**
   * необязательная доп. защита секретной части
   *
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * пусто = текущая база
   *
   * @generated from field: string base_slug = 3;
   */
  baseSlug: string;
};

/**
 * Describes the message zdc.ExportBaseRequest.
 * Use `create(ExportBaseRequestSchema)` to create a new message.
 */
export const ExportBaseRequestSchema: GenMessage<ExportBaseRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 320);

/**
 * @generated from message zdc.ExportBaseResult
 */
export type ExportBaseResult = Message<"zdc.ExportBaseResult"> & {
  /**
   * base64 (.hdd)
   *
   * @generated from field: string data = 1;
   */
  data: string;

  /**
   * предлагаемое имя файла
   *
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: zdc.BaseDumpManifest manifest = 3;
   */
  manifest?: BaseDumpManifest | undefined;
};

/**
 * Describes the message zdc.ExportBaseResult.
 * Use `create(ExportBaseResultSchema)` to create a new message.
 */
export const ExportBaseResultSchema: GenMessage<ExportBaseResult> = /*@__PURE__*/
  messageDesc(file_zdc, 321);

/**
 * @generated from message zdc.InspectBaseDumpRequest
 */
export type InspectBaseDumpRequest = Message<"zdc.InspectBaseDumpRequest"> & {
  /**
   * base64 (.hdd)
   *
   * @generated from field: string data = 1;
   */
  data: string;
};

/**
 * Describes the message zdc.InspectBaseDumpRequest.
 * Use `create(InspectBaseDumpRequestSchema)` to create a new message.
 */
export const InspectBaseDumpRequestSchema: GenMessage<InspectBaseDumpRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 322);

/**
 * BaseDumpManifest — манифест снимка (без секретов).
 *
 * @generated from message zdc.BaseDumpManifest
 */
export type BaseDumpManifest = Message<"zdc.BaseDumpManifest"> & {
  /**
   * @generated from field: string format_version = 1;
   */
  formatVersion: string;

  /**
   * @generated from field: string platform_version = 2;
   */
  platformVersion: string;

  /**
   * @generated from field: string min_platform = 3;
   */
  minPlatform: string;

  /**
   * @generated from field: string base_slug = 4;
   */
  baseSlug: string;

  /**
   * @generated from field: string base_name = 5;
   */
  baseName: string;

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;

  /**
   * @generated from field: bool contains_secrets = 7;
   */
  containsSecrets: boolean;

  /**
   * @generated from field: bool password_protected = 8;
   */
  passwordProtected: boolean;

  /**
   * @generated from field: string data_codec = 9;
   */
  dataCodec: string;

  /**
   * @generated from field: int32 table_count = 10;
   */
  tableCount: number;

  /**
   * @generated from field: int64 row_count = 11;
   */
  rowCount: bigint;

  /**
   * @generated from field: int32 blob_count = 12;
   */
  blobCount: number;
};

/**
 * Describes the message zdc.BaseDumpManifest.
 * Use `create(BaseDumpManifestSchema)` to create a new message.
 */
export const BaseDumpManifestSchema: GenMessage<BaseDumpManifest> = /*@__PURE__*/
  messageDesc(file_zdc, 323);

/**
 * @generated from message zdc.ImportBaseRequest
 */
export type ImportBaseRequest = Message<"zdc.ImportBaseRequest"> & {
  /**
   * base64 (.hdd)
   *
   * @generated from field: string data = 1;
   */
  data: string;

  /**
   * пароль снимка (если защищён)
   *
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * Цель А: загрузить в НОВУЮ базу (create_new=true).
   *
   * @generated from field: bool create_new = 3;
   */
  createNew: boolean;

  /**
   * @generated from field: string new_slug = 4;
   */
  newSlug: string;

  /**
   * @generated from field: string new_name = 5;
   */
  newName: string;

  /**
   * sqlite | postgres-schema (пусто = как у текущей/по умолчанию)
   *
   * @generated from field: string new_db_type = 8;
   */
  newDbType: string;

  /**
   * Цель Б: затереть ТЕКУЩУЮ базу (wipe_existing=true). confirm_name —
   * slug или имя текущей базы (защита от случайного уничтожения данных).
   *
   * @generated from field: bool wipe_existing = 6;
   */
  wipeExisting: boolean;

  /**
   * create_new и wipe_existing взаимоисключающи; ни одно не задано → ошибка.
   *
   * @generated from field: string confirm_name = 7;
   */
  confirmName: string;
};

/**
 * Describes the message zdc.ImportBaseRequest.
 * Use `create(ImportBaseRequestSchema)` to create a new message.
 */
export const ImportBaseRequestSchema: GenMessage<ImportBaseRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 324);

/**
 * @generated from message zdc.ImportBaseResult
 */
export type ImportBaseResult = Message<"zdc.ImportBaseResult"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: string slug = 3;
   */
  slug: string;

  /**
   * @generated from field: int32 table_count = 4;
   */
  tableCount: number;

  /**
   * @generated from field: int64 row_count = 5;
   */
  rowCount: bigint;
};

/**
 * Describes the message zdc.ImportBaseResult.
 * Use `create(ImportBaseResultSchema)` to create a new message.
 */
export const ImportBaseResultSchema: GenMessage<ImportBaseResult> = /*@__PURE__*/
  messageDesc(file_zdc, 325);

/**
 * @generated from message zdc.RegisterLocalBaseRequest
 */
export type RegisterLocalBaseRequest = Message<"zdc.RegisterLocalBaseRequest"> & {
  /**
   * файл .sqlite ИЛИ папка (сканируется на *.sqlite)
   *
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message zdc.RegisterLocalBaseRequest.
 * Use `create(RegisterLocalBaseRequestSchema)` to create a new message.
 */
export const RegisterLocalBaseRequestSchema: GenMessage<RegisterLocalBaseRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 326);

/**
 * @generated from message zdc.PullChangesRequest
 */
export type PullChangesRequest = Message<"zdc.PullChangesRequest"> & {
  /**
   * @generated from field: string base_id = 1;
   */
  baseId: string;

  /**
   * @generated from field: int64 last_version = 2;
   */
  lastVersion: bigint;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * Курсор пагинации: таблица, с которой продолжается выдача (пусто = с начала).
   * Заполняется клиентом из next_cursor_table предыдущего ответа. Без курсора
   * каждый ответ отдавал бы ПЕРВУЮ пачку заново (бесконечный цикл синхронизации).
   *
   * @generated from field: string cursor_table = 4;
   */
  cursorTable: string;

  /**
   * Смещение строк внутри таблицы cursor_table (снимок и дельта — offset).
   *
   * @generated from field: int32 cursor_offset = 5;
   */
  cursorOffset: number;
};

/**
 * Describes the message zdc.PullChangesRequest.
 * Use `create(PullChangesRequestSchema)` to create a new message.
 */
export const PullChangesRequestSchema: GenMessage<PullChangesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 327);

/**
 * @generated from message zdc.PushChangesRequest
 */
export type PushChangesRequest = Message<"zdc.PushChangesRequest"> & {
  /**
   * @generated from field: string base_id = 1;
   */
  baseId: string;

  /**
   * @generated from field: repeated zdc.ChangeRecord records = 2;
   */
  records: ChangeRecord[];
};

/**
 * Describes the message zdc.PushChangesRequest.
 * Use `create(PushChangesRequestSchema)` to create a new message.
 */
export const PushChangesRequestSchema: GenMessage<PushChangesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 328);

/**
 * @generated from message zdc.ChangeRecord
 */
export type ChangeRecord = Message<"zdc.ChangeRecord"> & {
  /**
   * @generated from field: string table = 1;
   */
  table: string;

  /**
   * @generated from field: string operation = 2;
   */
  operation: string;

  /**
   * @generated from field: string row_id = 3;
   */
  rowId: string;

  /**
   * @generated from field: map<string, string> data = 4;
   */
  data: { [key: string]: string };

  /**
   * @generated from field: int64 expected_version = 5;
   */
  expectedVersion: bigint;

  /**
   * Реквизиты ФОРМЫ (виртуальные): из offline-очереди — доходят до onBeforeSave
   * (РеквизитыФормы.X) при применении синка на сервере.
   *
   * @generated from field: map<string, string> form_attributes = 6;
   */
  formAttributes: { [key: string]: string };
};

/**
 * Describes the message zdc.ChangeRecord.
 * Use `create(ChangeRecordSchema)` to create a new message.
 */
export const ChangeRecordSchema: GenMessage<ChangeRecord> = /*@__PURE__*/
  messageDesc(file_zdc, 329);

/**
 * @generated from message zdc.PullChangesResponse
 */
export type PullChangesResponse = Message<"zdc.PullChangesResponse"> & {
  /**
   * @generated from field: repeated zdc.ChangeRecord records = 1;
   */
  records: ChangeRecord[];

  /**
   * @generated from field: bool has_more = 2;
   */
  hasMore: boolean;

  /**
   * @generated from field: int64 base_version = 3;
   */
  baseVersion: bigint;

  /**
   * Курсор следующей пачки — заполнен ТОЛЬКО при has_more=true. Клиент обязан
   * передать его в следующем PullChanges (иначе прогресса нет).
   *
   * @generated from field: string next_cursor_table = 4;
   */
  nextCursorTable: string;

  /**
   * @generated from field: int32 next_cursor_offset = 5;
   */
  nextCursorOffset: number;
};

/**
 * Describes the message zdc.PullChangesResponse.
 * Use `create(PullChangesResponseSchema)` to create a new message.
 */
export const PullChangesResponseSchema: GenMessage<PullChangesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 330);

/**
 * @generated from message zdc.PushChangesResponse
 */
export type PushChangesResponse = Message<"zdc.PushChangesResponse"> & {
  /**
   * @generated from field: int32 accepted = 1;
   */
  accepted: number;

  /**
   * @generated from field: int32 rejected = 2;
   */
  rejected: number;

  /**
   * @generated from field: int64 base_version = 3;
   */
  baseVersion: bigint;

  /**
   * @generated from field: repeated zdc.SyncConflict conflicts = 4;
   */
  conflicts: SyncConflict[];

  /**
   * @generated from field: repeated zdc.IDMapping mapping = 5;
   */
  mapping: IDMapping[];
};

/**
 * Describes the message zdc.PushChangesResponse.
 * Use `create(PushChangesResponseSchema)` to create a new message.
 */
export const PushChangesResponseSchema: GenMessage<PushChangesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 331);

/**
 * @generated from message zdc.SyncConflict
 */
export type SyncConflict = Message<"zdc.SyncConflict"> & {
  /**
   * @generated from field: string record_id = 1;
   */
  recordId: string;

  /**
   * @generated from field: int64 local_version = 2;
   */
  localVersion: bigint;

  /**
   * @generated from field: int64 server_version = 3;
   */
  serverVersion: bigint;

  /**
   * @generated from field: map<string, string> server_data = 4;
   */
  serverData: { [key: string]: string };

  /**
   * @generated from field: map<string, string> local_data = 5;
   */
  localData: { [key: string]: string };

  /**
   * @generated from field: string table = 6;
   */
  table: string;
};

/**
 * Describes the message zdc.SyncConflict.
 * Use `create(SyncConflictSchema)` to create a new message.
 */
export const SyncConflictSchema: GenMessage<SyncConflict> = /*@__PURE__*/
  messageDesc(file_zdc, 332);

/**
 * @generated from message zdc.IDMapping
 */
export type IDMapping = Message<"zdc.IDMapping"> & {
  /**
   * @generated from field: string local_id = 1;
   */
  localId: string;

  /**
   * @generated from field: string server_id = 2;
   */
  serverId: string;

  /**
   * @generated from field: string table_name = 3;
   */
  tableName: string;
};

/**
 * Describes the message zdc.IDMapping.
 * Use `create(IDMappingSchema)` to create a new message.
 */
export const IDMappingSchema: GenMessage<IDMapping> = /*@__PURE__*/
  messageDesc(file_zdc, 333);

/**
 * @generated from message zdc.ListCatalogsRequest
 */
export type ListCatalogsRequest = Message<"zdc.ListCatalogsRequest"> & {
  /**
   * @generated from field: string base_id = 1;
   */
  baseId: string;
};

/**
 * Describes the message zdc.ListCatalogsRequest.
 * Use `create(ListCatalogsRequestSchema)` to create a new message.
 */
export const ListCatalogsRequestSchema: GenMessage<ListCatalogsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 334);

/**
 * @generated from message zdc.GetCatalogRequest
 */
export type GetCatalogRequest = Message<"zdc.GetCatalogRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetCatalogRequest.
 * Use `create(GetCatalogRequestSchema)` to create a new message.
 */
export const GetCatalogRequestSchema: GenMessage<GetCatalogRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 335);

/**
 * @generated from message zdc.CreateCatalogRequest
 */
export type CreateCatalogRequest = Message<"zdc.CreateCatalogRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string base_id = 5;
   */
  baseId: string;

  /**
   * @generated from field: bool is_audit_enabled = 6;
   */
  isAuditEnabled: boolean;

  /**
   * @generated from field: string hierarchy_type = 7;
   */
  hierarchyType: string;

  /**
   * @generated from field: repeated zdc.CatalogOwner owners = 8;
   */
  owners: CatalogOwner[];

  /**
   * Виды списка/объекта (JSON)
   *
   * @generated from field: string view_settings = 9;
   */
  viewSettings: string;

  /**
   * @generated from field: bool track_reads = 10;
   */
  trackReads: boolean;
};

/**
 * Describes the message zdc.CreateCatalogRequest.
 * Use `create(CreateCatalogRequestSchema)` to create a new message.
 */
export const CreateCatalogRequestSchema: GenMessage<CreateCatalogRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 336);

/**
 * @generated from message zdc.UpdateCatalogRequest
 */
export type UpdateCatalogRequest = Message<"zdc.UpdateCatalogRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string synonym = 4;
   */
  synonym: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: bool is_audit_enabled = 6;
   */
  isAuditEnabled: boolean;

  /**
   * @generated from field: string hierarchy_type = 7;
   */
  hierarchyType: string;

  /**
   * @generated from field: repeated zdc.CatalogOwner owners = 8;
   */
  owners: CatalogOwner[];

  /**
   * Явный признак очистки владельцев: proto3 JSON не сериализует пустой repeated
   * (owners=[] теряется) — без флага отвязать ВСЕХ владельцев невозможно.
   *
   * @generated from field: bool clear_owners = 9;
   */
  clearOwners: boolean;

  /**
   * Виды списка/объекта (JSON)
   *
   * @generated from field: string view_settings = 10;
   */
  viewSettings: string;

  /**
   * @generated from field: bool track_reads = 11;
   */
  trackReads: boolean;
};

/**
 * Describes the message zdc.UpdateCatalogRequest.
 * Use `create(UpdateCatalogRequestSchema)` to create a new message.
 */
export const UpdateCatalogRequestSchema: GenMessage<UpdateCatalogRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 337);

/**
 * @generated from message zdc.DeleteCatalogRequest
 */
export type DeleteCatalogRequest = Message<"zdc.DeleteCatalogRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteCatalogRequest.
 * Use `create(DeleteCatalogRequestSchema)` to create a new message.
 */
export const DeleteCatalogRequestSchema: GenMessage<DeleteCatalogRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 338);

/**
 * @generated from message zdc.ListDocumentsRequest
 */
export type ListDocumentsRequest = Message<"zdc.ListDocumentsRequest"> & {
  /**
   * @generated from field: string base_id = 1;
   */
  baseId: string;
};

/**
 * Describes the message zdc.ListDocumentsRequest.
 * Use `create(ListDocumentsRequestSchema)` to create a new message.
 */
export const ListDocumentsRequestSchema: GenMessage<ListDocumentsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 339);

/**
 * @generated from message zdc.GetDocumentRequest
 */
export type GetDocumentRequest = Message<"zdc.GetDocumentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetDocumentRequest.
 * Use `create(GetDocumentRequestSchema)` to create a new message.
 */
export const GetDocumentRequestSchema: GenMessage<GetDocumentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 340);

/**
 * @generated from message zdc.CreateDocumentRequest
 */
export type CreateDocumentRequest = Message<"zdc.CreateDocumentRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string base_id = 5;
   */
  baseId: string;

  /**
   * @generated from field: bool is_audit_enabled = 6;
   */
  isAuditEnabled: boolean;

  /**
   * Виды списка/объекта (JSON)
   *
   * @generated from field: string view_settings = 7;
   */
  viewSettings: string;

  /**
   * @generated from field: bool track_reads = 8;
   */
  trackReads: boolean;
};

/**
 * Describes the message zdc.CreateDocumentRequest.
 * Use `create(CreateDocumentRequestSchema)` to create a new message.
 */
export const CreateDocumentRequestSchema: GenMessage<CreateDocumentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 341);

/**
 * @generated from message zdc.UpdateDocumentRequest
 */
export type UpdateDocumentRequest = Message<"zdc.UpdateDocumentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string synonym = 4;
   */
  synonym: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: bool is_audit_enabled = 6;
   */
  isAuditEnabled: boolean;

  /**
   * Виды списка/объекта (JSON)
   *
   * @generated from field: string view_settings = 7;
   */
  viewSettings: string;

  /**
   * @generated from field: bool track_reads = 8;
   */
  trackReads: boolean;
};

/**
 * Describes the message zdc.UpdateDocumentRequest.
 * Use `create(UpdateDocumentRequestSchema)` to create a new message.
 */
export const UpdateDocumentRequestSchema: GenMessage<UpdateDocumentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 342);

/**
 * @generated from message zdc.DeleteDocumentRequest
 */
export type DeleteDocumentRequest = Message<"zdc.DeleteDocumentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteDocumentRequest.
 * Use `create(DeleteDocumentRequestSchema)` to create a new message.
 */
export const DeleteDocumentRequestSchema: GenMessage<DeleteDocumentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 343);

/**
 * @generated from message zdc.ListRegistersRequest
 */
export type ListRegistersRequest = Message<"zdc.ListRegistersRequest"> & {
  /**
   * @generated from field: string base_id = 1;
   */
  baseId: string;
};

/**
 * Describes the message zdc.ListRegistersRequest.
 * Use `create(ListRegistersRequestSchema)` to create a new message.
 */
export const ListRegistersRequestSchema: GenMessage<ListRegistersRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 344);

/**
 * @generated from message zdc.GetRegisterRequest
 */
export type GetRegisterRequest = Message<"zdc.GetRegisterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetRegisterRequest.
 * Use `create(GetRegisterRequestSchema)` to create a new message.
 */
export const GetRegisterRequestSchema: GenMessage<GetRegisterRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 345);

/**
 * @generated from message zdc.CreateRegisterRequest
 */
export type CreateRegisterRequest = Message<"zdc.CreateRegisterRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string base_id = 4;
   */
  baseId: string;

  /**
   * @generated from field: string register_type = 5;
   */
  registerType: string;

  /**
   * @generated from field: bool is_audit_enabled = 6;
   */
  isAuditEnabled: boolean;

  /**
   * @generated from field: string accumulation_kind = 7;
   */
  accumulationKind: string;

  /**
   * @generated from field: string periodicity = 8;
   */
  periodicity: string;

  /**
   * @generated from field: string subordination = 9;
   */
  subordination: string;

  /**
   * @generated from field: string movements_table = 10;
   */
  movementsTable: string;

  /**
   * @generated from field: string schema_name = 11;
   */
  schemaName: string;

  /**
   * @generated from field: string synonym = 12;
   */
  synonym: string;

  /**
   * @generated from field: bool supports_correspondence = 13;
   */
  supportsCorrespondence: boolean;

  /**
   * @generated from field: string chart_of_accounts_code = 14;
   */
  chartOfAccountsCode: string;

  /**
   * @generated from field: int32 max_subconto_count = 15;
   */
  maxSubcontoCount: number;
};

/**
 * Describes the message zdc.CreateRegisterRequest.
 * Use `create(CreateRegisterRequestSchema)` to create a new message.
 */
export const CreateRegisterRequestSchema: GenMessage<CreateRegisterRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 346);

/**
 * @generated from message zdc.UpdateRegisterRequest
 */
export type UpdateRegisterRequest = Message<"zdc.UpdateRegisterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string register_type = 5;
   */
  registerType: string;

  /**
   * @generated from field: bool is_audit_enabled = 6;
   */
  isAuditEnabled: boolean;

  /**
   * @generated from field: string accumulation_kind = 7;
   */
  accumulationKind: string;

  /**
   * @generated from field: string periodicity = 8;
   */
  periodicity: string;

  /**
   * @generated from field: string subordination = 9;
   */
  subordination: string;

  /**
   * @generated from field: string movements_table = 10;
   */
  movementsTable: string;

  /**
   * @generated from field: string schema_name = 11;
   */
  schemaName: string;

  /**
   * @generated from field: string synonym = 12;
   */
  synonym: string;

  /**
   * @generated from field: bool supports_correspondence = 13;
   */
  supportsCorrespondence: boolean;

  /**
   * @generated from field: string chart_of_accounts_code = 14;
   */
  chartOfAccountsCode: string;

  /**
   * @generated from field: int32 max_subconto_count = 15;
   */
  maxSubcontoCount: number;
};

/**
 * Describes the message zdc.UpdateRegisterRequest.
 * Use `create(UpdateRegisterRequestSchema)` to create a new message.
 */
export const UpdateRegisterRequestSchema: GenMessage<UpdateRegisterRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 347);

/**
 * @generated from message zdc.DeleteRegisterRequest
 */
export type DeleteRegisterRequest = Message<"zdc.DeleteRegisterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteRegisterRequest.
 * Use `create(DeleteRegisterRequestSchema)` to create a new message.
 */
export const DeleteRegisterRequestSchema: GenMessage<DeleteRegisterRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 348);

/**
 * @generated from message zdc.ListFieldsRequest
 */
export type ListFieldsRequest = Message<"zdc.ListFieldsRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;
};

/**
 * Describes the message zdc.ListFieldsRequest.
 * Use `create(ListFieldsRequestSchema)` to create a new message.
 */
export const ListFieldsRequestSchema: GenMessage<ListFieldsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 349);

/**
 * @generated from message zdc.GetFieldRequest
 */
export type GetFieldRequest = Message<"zdc.GetFieldRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetFieldRequest.
 * Use `create(GetFieldRequestSchema)` to create a new message.
 */
export const GetFieldRequestSchema: GenMessage<GetFieldRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 350);

/**
 * @generated from message zdc.CreateFieldRequest
 */
export type CreateFieldRequest = Message<"zdc.CreateFieldRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string field_type = 4;
   */
  fieldType: string;

  /**
   * @generated from field: string data_type = 5;
   */
  dataType: string;

  /**
   * @generated from field: bool is_required = 6;
   */
  isRequired: boolean;

  /**
   * @generated from field: bool is_nullable = 7;
   */
  isNullable: boolean;

  /**
   * @generated from field: string default_value = 8;
   */
  defaultValue: string;

  /**
   * @generated from field: string ref_catalog_code = 9;
   */
  refCatalogCode: string;

  /**
   * @generated from field: string ref_document_code = 10;
   */
  refDocumentCode: string;

  /**
   * @generated from field: string enum_values = 11;
   */
  enumValues: string;

  /**
   * @generated from field: string entity_type = 12;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 13;
   */
  entityCode: string;

  /**
   * @generated from field: repeated string types = 14;
   */
  types: string[];

  /**
   * @generated from field: string defined_type_id = 15;
   */
  definedTypeId: string;

  /**
   * @generated from field: string ref_table = 16;
   */
  refTable: string;

  /**
   * @generated from field: repeated zdc.SelectionParam selection_params = 17;
   */
  selectionParams: SelectionParam[];

  /**
   * @generated from field: repeated zdc.SelectionLink selection_links = 18;
   */
  selectionLinks: SelectionLink[];

  /**
   * важность отображения в карточке (1..5, default 3)
   *
   * @generated from field: int32 importance = 19;
   */
  importance: number;

  /**
   * формат вывода (как в 1С)
   *
   * @generated from field: string format = 20;
   */
  format: string;

  /**
   * Синоним (отображаемое имя: заголовки полей форм, колонки)
   *
   * @generated from field: string synonym = 21;
   */
  synonym: string;

  /**
   * ИСТОЧНИК ДАННЫХ (JSON: api/operation/query_field/mapping) — «поле с источником»
   *
   * @generated from field: string source_settings = 22;
   */
  sourceSettings: string;

  /**
   * Скрыто по умолчанию (см. Field.hidden_by_default)
   *
   * @generated from field: bool hidden_by_default = 23;
   */
  hiddenByDefault: boolean;

  /**
   * Вид движения регистра ('' | 'dimension' | 'resource' | 'special')
   *
   * @generated from field: string field_kind = 24;
   */
  fieldKind: string;

  /**
   * Проверка заполнения
   *
   * @generated from field: string check = 28;
   */
  check: string;

  /**
   * Подсказка реквизита (как в 1С): текст/положение (''|hover|bottom|button)/placeholder
   *
   * @generated from field: string hint = 25;
   */
  hint: string;

  /**
   * @generated from field: string hint_position = 26;
   */
  hintPosition: string;

  /**
   * @generated from field: string placeholder = 27;
   */
  placeholder: string;

  /**
   * Маскирование поля (JSON правил; см. Field.mask_rules)
   *
   * @generated from field: string mask_rules = 29;
   */
  maskRules: string;

  /**
   * Голосовой ввод (микрофон у текстового поля; по умолчанию ВЫКЛ)
   *
   * @generated from field: bool voice_input = 30;
   */
  voiceInput: boolean;
};

/**
 * Describes the message zdc.CreateFieldRequest.
 * Use `create(CreateFieldRequestSchema)` to create a new message.
 */
export const CreateFieldRequestSchema: GenMessage<CreateFieldRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 351);

/**
 * @generated from message zdc.UpdateFieldRequest
 */
export type UpdateFieldRequest = Message<"zdc.UpdateFieldRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string field_type = 5;
   */
  fieldType: string;

  /**
   * @generated from field: string data_type = 6;
   */
  dataType: string;

  /**
   * @generated from field: bool is_required = 7;
   */
  isRequired: boolean;

  /**
   * @generated from field: bool is_nullable = 8;
   */
  isNullable: boolean;

  /**
   * @generated from field: string default_value = 9;
   */
  defaultValue: string;

  /**
   * @generated from field: string ref_catalog_code = 10;
   */
  refCatalogCode: string;

  /**
   * @generated from field: string ref_document_code = 11;
   */
  refDocumentCode: string;

  /**
   * @generated from field: string enum_values = 12;
   */
  enumValues: string;

  /**
   * @generated from field: repeated string types = 13;
   */
  types: string[];

  /**
   * @generated from field: string defined_type_id = 14;
   */
  definedTypeId: string;

  /**
   * @generated from field: string ref_table = 15;
   */
  refTable: string;

  /**
   * @generated from field: repeated zdc.SelectionParam selection_params = 16;
   */
  selectionParams: SelectionParam[];

  /**
   * @generated from field: repeated zdc.SelectionLink selection_links = 17;
   */
  selectionLinks: SelectionLink[];

  /**
   * важность отображения в карточке (1..5, default 3)
   *
   * @generated from field: int32 importance = 18;
   */
  importance: number;

  /**
   * формат вывода (как в 1С)
   *
   * @generated from field: string format = 19;
   */
  format: string;

  /**
   * Синоним (отображаемое имя: заголовки полей форм, колонки)
   *
   * @generated from field: string synonym = 20;
   */
  synonym: string;

  /**
   * ИСТОЧНИК ДАННЫХ (JSON: api/operation/query_field/mapping) — «поле с источником»
   *
   * @generated from field: string source_settings = 21;
   */
  sourceSettings: string;

  /**
   * Скрыто по умолчанию (см. Field.hidden_by_default)
   *
   * @generated from field: bool hidden_by_default = 22;
   */
  hiddenByDefault: boolean;

  /**
   * Вид движения регистра ('' | 'dimension' | 'resource' | 'special')
   *
   * @generated from field: string field_kind = 23;
   */
  fieldKind: string;

  /**
   * Проверка заполнения
   *
   * @generated from field: string check = 28;
   */
  check: string;

  /**
   * Подсказка реквизита (как в 1С): текст/положение (''|hover|bottom|button)/placeholder
   *
   * @generated from field: string hint = 24;
   */
  hint: string;

  /**
   * @generated from field: string hint_position = 25;
   */
  hintPosition: string;

  /**
   * @generated from field: string placeholder = 26;
   */
  placeholder: string;

  /**
   * Маскирование поля (JSON правил; см. Field.mask_rules)
   *
   * @generated from field: string mask_rules = 29;
   */
  maskRules: string;

  /**
   * Голосовой ввод (микрофон у текстового поля; по умолчанию ВЫКЛ)
   *
   * @generated from field: bool voice_input = 30;
   */
  voiceInput: boolean;
};

/**
 * Describes the message zdc.UpdateFieldRequest.
 * Use `create(UpdateFieldRequestSchema)` to create a new message.
 */
export const UpdateFieldRequestSchema: GenMessage<UpdateFieldRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 352);

/**
 * @generated from message zdc.DeleteFieldRequest
 */
export type DeleteFieldRequest = Message<"zdc.DeleteFieldRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteFieldRequest.
 * Use `create(DeleteFieldRequestSchema)` to create a new message.
 */
export const DeleteFieldRequestSchema: GenMessage<DeleteFieldRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 353);

/**
 * «Снять с поддержки» (как в 1С): объект ПОСТАВКИ становится ПОЛЬЗОВАТЕЛЬСКИМ
 * (template_id очищается — защита Update/Delete снимается, метка «ПОСТАВКА» уходит).
 * entity_type: catalog | document | register | field | enumeration | task_type |
 * order_type | section; entity_code — код объекта (для поля — column_name).
 *
 * @generated from message zdc.UnprotectTemplateObjectRequest
 */
export type UnprotectTemplateObjectRequest = Message<"zdc.UnprotectTemplateObjectRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;
};

/**
 * Describes the message zdc.UnprotectTemplateObjectRequest.
 * Use `create(UnprotectTemplateObjectRequestSchema)` to create a new message.
 */
export const UnprotectTemplateObjectRequestSchema: GenMessage<UnprotectTemplateObjectRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 354);

/**
 * Дополнение = {обложка + логика}: обложка (UI-виджет/настройки) отделена от
 * логики ('builtin:<code>' ядра | 'module:<code>' JS goja). default_for — вид по
 * умолчанию для полей/объектов; visibility — all/roles/guest-вариант.
 *
 * @generated from message zdc.FieldExtension
 */
export type FieldExtension = Message<"zdc.FieldExtension"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * field_view | form_handler | object_handler | command
   *
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * JSON: {widget, settings_schema:[{name,label,type,default}]}
   *
   * @generated from field: string oblozhka = 4;
   */
  oblozhka: string;

  /**
   * 'builtin:<code>' | 'module:<code>'
   *
   * @generated from field: string logic = 5;
   */
  logic: string;

  /**
   * JSON: {mode: all|roles|guest, roles:[], guest:{...}}
   *
   * @generated from field: string visibility = 6;
   */
  visibility: string;

  /**
   * JSON: [{data_type,ref_table,column_name,object_type,object_code}]
   *
   * @generated from field: string default_for = 7;
   */
  defaultFor: string;

  /**
   * @generated from field: bool is_system = 8;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 9;
   */
  templateId: string;

  /**
   * СПРАВКА (человеческая форма, с примерами) — часть спецификации
   *
   * @generated from field: string help = 10;
   */
  help: string;
};

/**
 * Describes the message zdc.FieldExtension.
 * Use `create(FieldExtensionSchema)` to create a new message.
 */
export const FieldExtensionSchema: GenMessage<FieldExtension> = /*@__PURE__*/
  messageDesc(file_zdc, 355);

/**
 * @generated from message zdc.FieldExtensionList
 */
export type FieldExtensionList = Message<"zdc.FieldExtensionList"> & {
  /**
   * @generated from field: repeated zdc.FieldExtension items = 1;
   */
  items: FieldExtension[];
};

/**
 * Describes the message zdc.FieldExtensionList.
 * Use `create(FieldExtensionListSchema)` to create a new message.
 */
export const FieldExtensionListSchema: GenMessage<FieldExtensionList> = /*@__PURE__*/
  messageDesc(file_zdc, 356);

/**
 * @generated from message zdc.ListFieldExtensionsRequest
 */
export type ListFieldExtensionsRequest = Message<"zdc.ListFieldExtensionsRequest"> & {
};

/**
 * Describes the message zdc.ListFieldExtensionsRequest.
 * Use `create(ListFieldExtensionsRequestSchema)` to create a new message.
 */
export const ListFieldExtensionsRequestSchema: GenMessage<ListFieldExtensionsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 357);

/**
 * @generated from message zdc.GetFieldExtensionRequest
 */
export type GetFieldExtensionRequest = Message<"zdc.GetFieldExtensionRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.GetFieldExtensionRequest.
 * Use `create(GetFieldExtensionRequestSchema)` to create a new message.
 */
export const GetFieldExtensionRequestSchema: GenMessage<GetFieldExtensionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 358);

/**
 * @generated from message zdc.SaveFieldExtensionRequest
 */
export type SaveFieldExtensionRequest = Message<"zdc.SaveFieldExtensionRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * @generated from field: string oblozhka = 4;
   */
  oblozhka: string;

  /**
   * @generated from field: string logic = 5;
   */
  logic: string;

  /**
   * @generated from field: string visibility = 6;
   */
  visibility: string;

  /**
   * @generated from field: string default_for = 7;
   */
  defaultFor: string;

  /**
   * @generated from field: string help = 8;
   */
  help: string;
};

/**
 * Describes the message zdc.SaveFieldExtensionRequest.
 * Use `create(SaveFieldExtensionRequestSchema)` to create a new message.
 */
export const SaveFieldExtensionRequestSchema: GenMessage<SaveFieldExtensionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 359);

/**
 * @generated from message zdc.DeleteFieldExtensionRequest
 */
export type DeleteFieldExtensionRequest = Message<"zdc.DeleteFieldExtensionRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.DeleteFieldExtensionRequest.
 * Use `create(DeleteFieldExtensionRequestSchema)` to create a new message.
 */
export const DeleteFieldExtensionRequestSchema: GenMessage<DeleteFieldExtensionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 360);

/**
 * Отметить объект прочитанным текущим пользователем (objects_reads).
 *
 * @generated from message zdc.ObjectReadRequest
 */
export type ObjectReadRequest = Message<"zdc.ObjectReadRequest"> & {
  /**
   * 'catalog' | 'document' | 'task' | ...
   *
   * @generated from field: string object_type = 1;
   */
  objectType: string;

  /**
   * код справочника/документа/типа задачи
   *
   * @generated from field: string object_code = 2;
   */
  objectCode: string;

  /**
   * UUID записи
   *
   * @generated from field: string object_id = 3;
   */
  objectId: string;
};

/**
 * Describes the message zdc.ObjectReadRequest.
 * Use `create(ObjectReadRequestSchema)` to create a new message.
 */
export const ObjectReadRequestSchema: GenMessage<ObjectReadRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 361);

/**
 * @generated from message zdc.ListDefinedTypesRequest
 */
export type ListDefinedTypesRequest = Message<"zdc.ListDefinedTypesRequest"> & {
};

/**
 * Describes the message zdc.ListDefinedTypesRequest.
 * Use `create(ListDefinedTypesRequestSchema)` to create a new message.
 */
export const ListDefinedTypesRequestSchema: GenMessage<ListDefinedTypesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 362);

/**
 * @generated from message zdc.GetDefinedTypeRequest
 */
export type GetDefinedTypeRequest = Message<"zdc.GetDefinedTypeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetDefinedTypeRequest.
 * Use `create(GetDefinedTypeRequestSchema)` to create a new message.
 */
export const GetDefinedTypeRequestSchema: GenMessage<GetDefinedTypeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 363);

/**
 * @generated from message zdc.CreateDefinedTypeRequest
 */
export type CreateDefinedTypeRequest = Message<"zdc.CreateDefinedTypeRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string synonym = 2;
   */
  synonym: string;

  /**
   * @generated from field: repeated string types = 3;
   */
  types: string[];
};

/**
 * Describes the message zdc.CreateDefinedTypeRequest.
 * Use `create(CreateDefinedTypeRequestSchema)` to create a new message.
 */
export const CreateDefinedTypeRequestSchema: GenMessage<CreateDefinedTypeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 364);

/**
 * @generated from message zdc.UpdateDefinedTypeRequest
 */
export type UpdateDefinedTypeRequest = Message<"zdc.UpdateDefinedTypeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: repeated string types = 4;
   */
  types: string[];
};

/**
 * Describes the message zdc.UpdateDefinedTypeRequest.
 * Use `create(UpdateDefinedTypeRequestSchema)` to create a new message.
 */
export const UpdateDefinedTypeRequestSchema: GenMessage<UpdateDefinedTypeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 365);

/**
 * @generated from message zdc.DeleteDefinedTypeRequest
 */
export type DeleteDefinedTypeRequest = Message<"zdc.DeleteDefinedTypeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteDefinedTypeRequest.
 * Use `create(DeleteDefinedTypeRequestSchema)` to create a new message.
 */
export const DeleteDefinedTypeRequestSchema: GenMessage<DeleteDefinedTypeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 366);

/**
 * @generated from message zdc.ListTabularSectionsRequest
 */
export type ListTabularSectionsRequest = Message<"zdc.ListTabularSectionsRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;
};

/**
 * Describes the message zdc.ListTabularSectionsRequest.
 * Use `create(ListTabularSectionsRequestSchema)` to create a new message.
 */
export const ListTabularSectionsRequestSchema: GenMessage<ListTabularSectionsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 367);

/**
 * @generated from message zdc.GetTabularSectionRequest
 */
export type GetTabularSectionRequest = Message<"zdc.GetTabularSectionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetTabularSectionRequest.
 * Use `create(GetTabularSectionRequestSchema)` to create a new message.
 */
export const GetTabularSectionRequestSchema: GenMessage<GetTabularSectionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 368);

/**
 * @generated from message zdc.CreateTabularSectionRequest
 */
export type CreateTabularSectionRequest = Message<"zdc.CreateTabularSectionRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string parent_type = 4;
   */
  parentType: string;

  /**
   * @generated from field: string parent_code = 5;
   */
  parentCode: string;

  /**
   * Синоним (отображаемое имя ТЧ, как в 1С)
   *
   * @generated from field: string synonym = 6;
   */
  synonym: string;
};

/**
 * Describes the message zdc.CreateTabularSectionRequest.
 * Use `create(CreateTabularSectionRequestSchema)` to create a new message.
 */
export const CreateTabularSectionRequestSchema: GenMessage<CreateTabularSectionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 369);

/**
 * @generated from message zdc.UpdateTabularSectionRequest
 */
export type UpdateTabularSectionRequest = Message<"zdc.UpdateTabularSectionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * Синоним (отображаемое имя ТЧ, как в 1С)
   *
   * @generated from field: string synonym = 5;
   */
  synonym: string;
};

/**
 * Describes the message zdc.UpdateTabularSectionRequest.
 * Use `create(UpdateTabularSectionRequestSchema)` to create a new message.
 */
export const UpdateTabularSectionRequestSchema: GenMessage<UpdateTabularSectionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 370);

/**
 * @generated from message zdc.DeleteTabularSectionRequest
 */
export type DeleteTabularSectionRequest = Message<"zdc.DeleteTabularSectionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteTabularSectionRequest.
 * Use `create(DeleteTabularSectionRequestSchema)` to create a new message.
 */
export const DeleteTabularSectionRequestSchema: GenMessage<DeleteTabularSectionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 371);

/**
 * @generated from message zdc.ListTabularColumnsRequest
 */
export type ListTabularColumnsRequest = Message<"zdc.ListTabularColumnsRequest"> & {
  /**
   * @generated from field: string tabular_section_id = 1;
   */
  tabularSectionId: string;
};

/**
 * Describes the message zdc.ListTabularColumnsRequest.
 * Use `create(ListTabularColumnsRequestSchema)` to create a new message.
 */
export const ListTabularColumnsRequestSchema: GenMessage<ListTabularColumnsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 372);

/**
 * @generated from message zdc.GetTabularColumnRequest
 */
export type GetTabularColumnRequest = Message<"zdc.GetTabularColumnRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetTabularColumnRequest.
 * Use `create(GetTabularColumnRequestSchema)` to create a new message.
 */
export const GetTabularColumnRequestSchema: GenMessage<GetTabularColumnRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 373);

/**
 * @generated from message zdc.CreateTabularColumnRequest
 */
export type CreateTabularColumnRequest = Message<"zdc.CreateTabularColumnRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string column_type = 4;
   */
  columnType: string;

  /**
   * @generated from field: string data_type = 5;
   */
  dataType: string;

  /**
   * @generated from field: bool is_required = 6;
   */
  isRequired: boolean;

  /**
   * @generated from field: bool is_nullable = 7;
   */
  isNullable: boolean;

  /**
   * @generated from field: string default_value = 8;
   */
  defaultValue: string;

  /**
   * @generated from field: string ref_catalog_code = 9;
   */
  refCatalogCode: string;

  /**
   * @generated from field: string ref_document_code = 10;
   */
  refDocumentCode: string;

  /**
   * @generated from field: string enum_values = 11;
   */
  enumValues: string;

  /**
   * @generated from field: string tabular_section_id = 12;
   */
  tabularSectionId: string;

  /**
   * @generated from field: repeated zdc.SelectionParam selection_params = 13;
   */
  selectionParams: SelectionParam[];

  /**
   * @generated from field: repeated zdc.SelectionLink selection_links = 14;
   */
  selectionLinks: SelectionLink[];

  /**
   * формат вывода (как в 1С)
   *
   * @generated from field: string format = 15;
   */
  format: string;
};

/**
 * Describes the message zdc.CreateTabularColumnRequest.
 * Use `create(CreateTabularColumnRequestSchema)` to create a new message.
 */
export const CreateTabularColumnRequestSchema: GenMessage<CreateTabularColumnRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 374);

/**
 * @generated from message zdc.UpdateTabularColumnRequest
 */
export type UpdateTabularColumnRequest = Message<"zdc.UpdateTabularColumnRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string column_type = 5;
   */
  columnType: string;

  /**
   * @generated from field: string data_type = 6;
   */
  dataType: string;

  /**
   * @generated from field: bool is_required = 7;
   */
  isRequired: boolean;

  /**
   * @generated from field: bool is_nullable = 8;
   */
  isNullable: boolean;

  /**
   * @generated from field: string default_value = 9;
   */
  defaultValue: string;

  /**
   * @generated from field: string ref_catalog_code = 10;
   */
  refCatalogCode: string;

  /**
   * @generated from field: string ref_document_code = 11;
   */
  refDocumentCode: string;

  /**
   * @generated from field: string enum_values = 12;
   */
  enumValues: string;

  /**
   * @generated from field: repeated zdc.SelectionParam selection_params = 13;
   */
  selectionParams: SelectionParam[];

  /**
   * @generated from field: repeated zdc.SelectionLink selection_links = 14;
   */
  selectionLinks: SelectionLink[];

  /**
   * формат вывода (как в 1С)
   *
   * @generated from field: string format = 15;
   */
  format: string;
};

/**
 * Describes the message zdc.UpdateTabularColumnRequest.
 * Use `create(UpdateTabularColumnRequestSchema)` to create a new message.
 */
export const UpdateTabularColumnRequestSchema: GenMessage<UpdateTabularColumnRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 375);

/**
 * @generated from message zdc.DeleteTabularColumnRequest
 */
export type DeleteTabularColumnRequest = Message<"zdc.DeleteTabularColumnRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteTabularColumnRequest.
 * Use `create(DeleteTabularColumnRequestSchema)` to create a new message.
 */
export const DeleteTabularColumnRequestSchema: GenMessage<DeleteTabularColumnRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 376);

/**
 * @generated from message zdc.ListFormsRequest
 */
export type ListFormsRequest = Message<"zdc.ListFormsRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;

  /**
   * РґР»СЏ multi-base РїРѕРґРґРµСЂР¶РєРё
   *
   * @generated from field: string base_id = 3;
   */
  baseId: string;
};

/**
 * Describes the message zdc.ListFormsRequest.
 * Use `create(ListFormsRequestSchema)` to create a new message.
 */
export const ListFormsRequestSchema: GenMessage<ListFormsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 377);

/**
 * @generated from message zdc.GetFormRequest
 */
export type GetFormRequest = Message<"zdc.GetFormRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * РґР»СЏ multi-base РїРѕРґРґРµСЂР¶РєРё
   *
   * @generated from field: string base_id = 2;
   */
  baseId: string;
};

/**
 * Describes the message zdc.GetFormRequest.
 * Use `create(GetFormRequestSchema)` to create a new message.
 */
export const GetFormRequestSchema: GenMessage<GetFormRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 378);

/**
 * @generated from message zdc.CreateFormRequest
 */
export type CreateFormRequest = Message<"zdc.CreateFormRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string form_type = 4;
   */
  formType: string;

  /**
   * @generated from field: string parent_type = 5;
   */
  parentType: string;

  /**
   * @generated from field: string parent_code = 6;
   */
  parentCode: string;

  /**
   * @generated from field: string layout_json = 7;
   */
  layoutJson: string;

  /**
   * @generated from field: string form_module = 8;
   */
  formModule: string;

  /**
   * РґР»СЏ multi-base РїРѕРґРґРµСЂР¶РєРё
   *
   * @generated from field: string base_id = 9;
   */
  baseId: string;
};

/**
 * Describes the message zdc.CreateFormRequest.
 * Use `create(CreateFormRequestSchema)` to create a new message.
 */
export const CreateFormRequestSchema: GenMessage<CreateFormRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 379);

/**
 * @generated from message zdc.UpdateFormRequest
 */
export type UpdateFormRequest = Message<"zdc.UpdateFormRequest"> & {
  /**
   * ВСЕ поля кроме id — НЕОБЯЗАТЕЛЬНЫЕ (presence): сервер меняет ТОЛЬКО переданные
   * поля. Обычное сохранение формы (конструктор/API) больше НЕ стирает «Основную
   * форму» (is_main), имя или макет — дефект 2026-10-17: колонки писались
   * безусловно, значение по умолчанию затирало существующее.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string code = 2;
   */
  code?: string | undefined;

  /**
   * @generated from field: optional string name = 3;
   */
  name?: string | undefined;

  /**
   * @generated from field: optional string description = 4;
   */
  description?: string | undefined;

  /**
   * @generated from field: optional string form_type = 5;
   */
  formType?: string | undefined;

  /**
   * @generated from field: optional string layout_json = 6;
   */
  layoutJson?: string | undefined;

  /**
   * @generated from field: optional string form_module = 7;
   */
  formModule?: string | undefined;

  /**
   * РґР»СЏ multi-base РїРѕРґРґРµСЂР¶РєРё
   *
   * @generated from field: optional string base_id = 8;
   */
  baseId?: string | undefined;

  /**
   * Основная форма для типа; true снимает у остальных того же типа
   *
   * @generated from field: optional bool is_main = 9;
   */
  isMain?: boolean | undefined;
};

/**
 * Describes the message zdc.UpdateFormRequest.
 * Use `create(UpdateFormRequestSchema)` to create a new message.
 */
export const UpdateFormRequestSchema: GenMessage<UpdateFormRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 380);

/**
 * @generated from message zdc.DeleteFormRequest
 */
export type DeleteFormRequest = Message<"zdc.DeleteFormRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * РґР»СЏ multi-base РїРѕРґРґРµСЂР¶РєРё
   *
   * @generated from field: string base_id = 2;
   */
  baseId: string;
};

/**
 * Describes the message zdc.DeleteFormRequest.
 * Use `create(DeleteFormRequestSchema)` to create a new message.
 */
export const DeleteFormRequestSchema: GenMessage<DeleteFormRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 381);

/**
 * @generated from message zdc.ListModulesRequest
 */
export type ListModulesRequest = Message<"zdc.ListModulesRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;
};

/**
 * Describes the message zdc.ListModulesRequest.
 * Use `create(ListModulesRequestSchema)` to create a new message.
 */
export const ListModulesRequestSchema: GenMessage<ListModulesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 382);

/**
 * @generated from message zdc.GetModuleRequest
 */
export type GetModuleRequest = Message<"zdc.GetModuleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetModuleRequest.
 * Use `create(GetModuleRequestSchema)` to create a new message.
 */
export const GetModuleRequestSchema: GenMessage<GetModuleRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 383);

/**
 * @generated from message zdc.CreateModuleRequest
 */
export type CreateModuleRequest = Message<"zdc.CreateModuleRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string module_type = 4;
   */
  moduleType: string;

  /**
   * @generated from field: string parent_type = 5;
   */
  parentType: string;

  /**
   * @generated from field: string parent_code = 6;
   */
  parentCode: string;

  /**
   * @generated from field: string code_content = 7;
   */
  codeContent: string;
};

/**
 * Describes the message zdc.CreateModuleRequest.
 * Use `create(CreateModuleRequestSchema)` to create a new message.
 */
export const CreateModuleRequestSchema: GenMessage<CreateModuleRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 384);

/**
 * @generated from message zdc.UpdateModuleRequest
 */
export type UpdateModuleRequest = Message<"zdc.UpdateModuleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string code_content = 5;
   */
  codeContent: string;
};

/**
 * Describes the message zdc.UpdateModuleRequest.
 * Use `create(UpdateModuleRequestSchema)` to create a new message.
 */
export const UpdateModuleRequestSchema: GenMessage<UpdateModuleRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 385);

/**
 * @generated from message zdc.DeleteModuleRequest
 */
export type DeleteModuleRequest = Message<"zdc.DeleteModuleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteModuleRequest.
 * Use `create(DeleteModuleRequestSchema)` to create a new message.
 */
export const DeleteModuleRequestSchema: GenMessage<DeleteModuleRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 386);

/**
 * @generated from message zdc.ExecuteModuleRequest
 */
export type ExecuteModuleRequest = Message<"zdc.ExecuteModuleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string function_name = 2;
   */
  functionName: string;

  /**
   * @generated from field: string params = 3;
   */
  params: string;
};

/**
 * Describes the message zdc.ExecuteModuleRequest.
 * Use `create(ExecuteModuleRequestSchema)` to create a new message.
 */
export const ExecuteModuleRequestSchema: GenMessage<ExecuteModuleRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 387);

/**
 * @generated from message zdc.ExecuteModuleResponse
 */
export type ExecuteModuleResponse = Message<"zdc.ExecuteModuleResponse"> & {
  /**
   * @generated from field: string result = 1;
   */
  result: string;

  /**
   * @generated from field: string error = 2;
   */
  error: string;
};

/**
 * Describes the message zdc.ExecuteModuleResponse.
 * Use `create(ExecuteModuleResponseSchema)` to create a new message.
 */
export const ExecuteModuleResponseSchema: GenMessage<ExecuteModuleResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 388);

/**
 * @generated from message zdc.PostDocumentRequest
 */
export type PostDocumentRequest = Message<"zdc.PostDocumentRequest"> & {
  /**
   * @generated from field: string document_type = 1;
   */
  documentType: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId: string;
};

/**
 * Describes the message zdc.PostDocumentRequest.
 * Use `create(PostDocumentRequestSchema)` to create a new message.
 */
export const PostDocumentRequestSchema: GenMessage<PostDocumentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 389);

/**
 * @generated from message zdc.PostDocumentResponse
 */
export type PostDocumentResponse = Message<"zdc.PostDocumentResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message zdc.PostDocumentResponse.
 * Use `create(PostDocumentResponseSchema)` to create a new message.
 */
export const PostDocumentResponseSchema: GenMessage<PostDocumentResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 390);

/**
 * @generated from message zdc.UnpostDocumentRequest
 */
export type UnpostDocumentRequest = Message<"zdc.UnpostDocumentRequest"> & {
  /**
   * @generated from field: string document_type = 1;
   */
  documentType: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId: string;
};

/**
 * Describes the message zdc.UnpostDocumentRequest.
 * Use `create(UnpostDocumentRequestSchema)` to create a new message.
 */
export const UnpostDocumentRequestSchema: GenMessage<UnpostDocumentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 391);

/**
 * @generated from message zdc.ListEntitiesRequest
 */
export type ListEntitiesRequest = Message<"zdc.ListEntitiesRequest"> & {
  /**
   * @generated from field: string role_id = 1;
   */
  roleId: string;

  /**
   * @generated from field: string base_id = 2;
   */
  baseId: string;

  /**
   * people_only — только ЛЮДИ: системные учётки и боты исключаются
   * НЕЗАВИСИМО от админа (пикеры контактов: чат/звонки/Remote — «Гость»,
   * «Поддержка», «Уведомитель» там не нужны). Пусто/false — прежнее
   * поведение (UsersPage/администрирование видят все учётные записи).
   *
   * @generated from field: bool people_only = 3;
   */
  peopleOnly: boolean;
};

/**
 * Describes the message zdc.ListEntitiesRequest.
 * Use `create(ListEntitiesRequestSchema)` to create a new message.
 */
export const ListEntitiesRequestSchema: GenMessage<ListEntitiesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 392);

/**
 * @generated from message zdc.GetEntityRequest
 */
export type GetEntityRequest = Message<"zdc.GetEntityRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetEntityRequest.
 * Use `create(GetEntityRequestSchema)` to create a new message.
 */
export const GetEntityRequestSchema: GenMessage<GetEntityRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 393);

/**
 * @generated from message zdc.CreateEntityRequest
 */
export type CreateEntityRequest = Message<"zdc.CreateEntityRequest"> & {
  /**
   * @generated from field: string login = 1;
   */
  login: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string password = 4;
   */
  password: string;

  /**
   * @generated from field: string phone = 5;
   */
  phone: string;

  /**
   * @generated from field: string avatar_url = 6;
   */
  avatarUrl: string;

  /**
   * @generated from field: string birth_date = 7;
   */
  birthDate: string;

  /**
   * @generated from field: string city = 8;
   */
  city: string;

  /**
   * @generated from field: bool is_active = 9;
   */
  isActive: boolean;

  /**
   * @generated from field: bool show_in_login_list = 10;
   */
  showInLoginList: boolean;

  /**
   * @generated from field: string organization_id = 11;
   */
  organizationId: string;

  /**
   * Цифровой ключ (4 цифры; непустой = установить) + вариант авторизации
   *
   * @generated from field: string pin = 12;
   */
  pin: string;

  /**
   * ''/'password' | 'pin' | 'both'
   *
   * @generated from field: string auth_mode = 13;
   */
  authMode: string;

  /**
   * ИИ-блок: вид сущности ''|'bot'|'persona', агент, транспорт
   *
   * @generated from field: string kind = 14;
   */
  kind: string;

  /**
   * @generated from field: string bot_agent_id = 15;
   */
  botAgentId: string;

  /**
   * @generated from field: string bot_transport = 16;
   */
  botTransport: string;

  /**
   * Профиль (для ВСЕХ баз): пол ('male'|'female'|'') и два адреса.
   * При создании текущий адрес всегда ручной: source='manual', updated_at=now.
   *
   * текущий адрес (текст)
   *
   * @generated from field: string address_current = 17;
   */
  addressCurrent: string;

  /**
   * @generated from field: string gender = 18;
   */
  gender: string;

  /**
   * адрес проживания / прописка
   *
   * @generated from field: string address_home = 19;
   */
  addressHome: string;
};

/**
 * Describes the message zdc.CreateEntityRequest.
 * Use `create(CreateEntityRequestSchema)` to create a new message.
 */
export const CreateEntityRequestSchema: GenMessage<CreateEntityRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 394);

/**
 * @generated from message zdc.UpdateEntityRequest
 */
export type UpdateEntityRequest = Message<"zdc.UpdateEntityRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string login = 2;
   */
  login: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * непустой = смена пароля (bcrypt)
   *
   * @generated from field: string password = 5;
   */
  password: string;

  /**
   * @generated from field: string phone = 6;
   */
  phone: string;

  /**
   * @generated from field: string avatar_url = 7;
   */
  avatarUrl: string;

  /**
   * @generated from field: string birth_date = 8;
   */
  birthDate: string;

  /**
   * @generated from field: string city = 9;
   */
  city: string;

  /**
   * Presence (optional): обновляем ТОЛЬКО если поле явно передано. Иначе
   * точечный апдейт (смена пароля/PIN) обнулял бы is_active → «учётка заблокирована».
   *
   * @generated from field: optional bool is_active = 10;
   */
  isActive?: boolean | undefined;

  /**
   * @generated from field: optional bool show_in_login_list = 11;
   */
  showInLoginList?: boolean | undefined;

  /**
   * @generated from field: string organization_id = 12;
   */
  organizationId: string;

  /**
   * Цифровой ключ (4 цифры; непустой = установить/сменить) + вариант авторизации
   *
   * @generated from field: string pin = 13;
   */
  pin: string;

  /**
   * ''/'password' | 'pin' | 'both'
   *
   * @generated from field: string auth_mode = 14;
   */
  authMode: string;

  /**
   * ИИ-блок: вид сущности ''|'bot'|'persona', агент, транспорт
   *
   * @generated from field: string kind = 15;
   */
  kind: string;

  /**
   * @generated from field: string bot_agent_id = 16;
   */
  botAgentId: string;

  /**
   * @generated from field: string bot_transport = 17;
   */
  botTransport: string;

  /**
   * Профиль (для ВСЕХ баз): пол ('male'|'female'|'') и два адреса.
   * PRESENCE (optional): обновляем ТОЛЬКО если поле явно передано — иначе
   * точечный апдейт (смена аватара/пароля) стирает профиль; переданное
   * ПУСТОЕ значение ОЧИЩАЕТ (селект «— не указан» реально снимает пол).
   *
   * @generated from field: optional string address_current = 18;
   */
  addressCurrent?: string | undefined;

  /**
   * @generated from field: optional string gender = 19;
   */
  gender?: string | undefined;

  /**
   * @generated from field: optional string address_home = 20;
   */
  addressHome?: string | undefined;

  /**
   * Источник/точность ТЕКУЩЕГО адреса — применяются ТОЛЬКО вместе с
   * address_current (без него — InvalidArgument). Пустой/не переданный source
   * при непустом адресе = 'manual' (ручной ввод — истина); accuracy — по
   * источнику (gps→street, ip→city, manual→''). Клиент передаёт gps/street
   * после кнопки «Определить по геолокации».
   *
   * manual | gps | ip | ''
   *
   * @generated from field: optional string address_current_source = 21;
   */
  addressCurrentSource?: string | undefined;

  /**
   * exact | street | city | region | ''
   *
   * @generated from field: optional string address_current_accuracy = 22;
   */
  addressCurrentAccuracy?: string | undefined;
};

/**
 * Describes the message zdc.UpdateEntityRequest.
 * Use `create(UpdateEntityRequestSchema)` to create a new message.
 */
export const UpdateEntityRequestSchema: GenMessage<UpdateEntityRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 395);

/**
 * @generated from message zdc.ListEntityChannelsRequest
 */
export type ListEntityChannelsRequest = Message<"zdc.ListEntityChannelsRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;
};

/**
 * Describes the message zdc.ListEntityChannelsRequest.
 * Use `create(ListEntityChannelsRequestSchema)` to create a new message.
 */
export const ListEntityChannelsRequestSchema: GenMessage<ListEntityChannelsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 396);

/**
 * @generated from message zdc.EntityChannelList
 */
export type EntityChannelList = Message<"zdc.EntityChannelList"> & {
  /**
   * @generated from field: repeated zdc.EntityChannel items = 1;
   */
  items: EntityChannel[];
};

/**
 * Describes the message zdc.EntityChannelList.
 * Use `create(EntityChannelListSchema)` to create a new message.
 */
export const EntityChannelListSchema: GenMessage<EntityChannelList> = /*@__PURE__*/
  messageDesc(file_zdc, 397);

/**
 * @generated from message zdc.SetEntityChannelsRequest
 */
export type SetEntityChannelsRequest = Message<"zdc.SetEntityChannelsRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * полная замена (как права)
   *
   * @generated from field: repeated zdc.EntityChannel channels = 2;
   */
  channels: EntityChannel[];
};

/**
 * Describes the message zdc.SetEntityChannelsRequest.
 * Use `create(SetEntityChannelsRequestSchema)` to create a new message.
 */
export const SetEntityChannelsRequestSchema: GenMessage<SetEntityChannelsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 398);

/**
 * @generated from message zdc.DeleteEntityRequest
 */
export type DeleteEntityRequest = Message<"zdc.DeleteEntityRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteEntityRequest.
 * Use `create(DeleteEntityRequestSchema)` to create a new message.
 */
export const DeleteEntityRequestSchema: GenMessage<DeleteEntityRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 399);

/**
 * @generated from message zdc.UpdateEntityOneCTokenRequest
 */
export type UpdateEntityOneCTokenRequest = Message<"zdc.UpdateEntityOneCTokenRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string token = 2;
   */
  token: string;
};

/**
 * Describes the message zdc.UpdateEntityOneCTokenRequest.
 * Use `create(UpdateEntityOneCTokenRequestSchema)` to create a new message.
 */
export const UpdateEntityOneCTokenRequestSchema: GenMessage<UpdateEntityOneCTokenRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 400);

/**
 * Приглашение пользователя (клиент сервиса/пациент): одноразовый код входа.
 *
 * @generated from message zdc.InviteUserRequest
 */
export type InviteUserRequest = Message<"zdc.InviteUserRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * Канал доставки: '' (sms при заданном телефоне, иначе email) | sms | email.
   *
   * @generated from field: string channel = 2;
   */
  channel: string;
};

/**
 * Describes the message zdc.InviteUserRequest.
 * Use `create(InviteUserRequestSchema)` to create a new message.
 */
export const InviteUserRequestSchema: GenMessage<InviteUserRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 401);

/**
 * @generated from message zdc.InviteUserResponse
 */
export type InviteUserResponse = Message<"zdc.InviteUserResponse"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * фактический канал ('' = контакта нет — только вручную)
   *
   * @generated from field: string channel = 2;
   */
  channel: string;

  /**
   * адрес доставки ('' = нет контакта)
   *
   * @generated from field: string target = 3;
   */
  target: string;

  /**
   * Код ВОЗВРАЩАЕТСЯ только если доставка не выполнена (нет канала/контакта/
   * сервиса) — специалист передаёт его пациенту лично; при доставке — пусто.
   *
   * @generated from field: string code = 4;
   */
  code: string;

  /**
   * @generated from field: bool delivered = 5;
   */
  delivered: boolean;

  /**
   * @generated from field: string delivery_error = 6;
   */
  deliveryError: string;

  /**
   * @generated from field: string expires_at = 7;
   */
  expiresAt: string;
};

/**
 * Describes the message zdc.InviteUserResponse.
 * Use `create(InviteUserResponseSchema)` to create a new message.
 */
export const InviteUserResponseSchema: GenMessage<InviteUserResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 402);

/**
 * @generated from message zdc.ListEntityLinksRequest
 */
export type ListEntityLinksRequest = Message<"zdc.ListEntityLinksRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;
};

/**
 * Describes the message zdc.ListEntityLinksRequest.
 * Use `create(ListEntityLinksRequestSchema)` to create a new message.
 */
export const ListEntityLinksRequestSchema: GenMessage<ListEntityLinksRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 403);

/**
 * @generated from message zdc.CreateEntityLinkRequest
 */
export type CreateEntityLinkRequest = Message<"zdc.CreateEntityLinkRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string base_id = 2;
   */
  baseId: string;

  /**
   * @generated from field: string employee_id = 3;
   */
  employeeId: string;

  /**
   * @generated from field: string employee_name = 4;
   */
  employeeName: string;
};

/**
 * Describes the message zdc.CreateEntityLinkRequest.
 * Use `create(CreateEntityLinkRequestSchema)` to create a new message.
 */
export const CreateEntityLinkRequestSchema: GenMessage<CreateEntityLinkRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 404);

/**
 * @generated from message zdc.DeleteEntityLinkRequest
 */
export type DeleteEntityLinkRequest = Message<"zdc.DeleteEntityLinkRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteEntityLinkRequest.
 * Use `create(DeleteEntityLinkRequestSchema)` to create a new message.
 */
export const DeleteEntityLinkRequestSchema: GenMessage<DeleteEntityLinkRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 405);

/**
 * @generated from message zdc.ListEntityRolesRequest
 */
export type ListEntityRolesRequest = Message<"zdc.ListEntityRolesRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;
};

/**
 * Describes the message zdc.ListEntityRolesRequest.
 * Use `create(ListEntityRolesRequestSchema)` to create a new message.
 */
export const ListEntityRolesRequestSchema: GenMessage<ListEntityRolesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 406);

/**
 * @generated from message zdc.SetEntityRoleRequest
 */
export type SetEntityRoleRequest = Message<"zdc.SetEntityRoleRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string role_id = 2;
   */
  roleId: string;
};

/**
 * Describes the message zdc.SetEntityRoleRequest.
 * Use `create(SetEntityRoleRequestSchema)` to create a new message.
 */
export const SetEntityRoleRequestSchema: GenMessage<SetEntityRoleRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 407);

/**
 * @generated from message zdc.DeleteEntityRoleRequest
 */
export type DeleteEntityRoleRequest = Message<"zdc.DeleteEntityRoleRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string role_id = 2;
   */
  roleId: string;
};

/**
 * Describes the message zdc.DeleteEntityRoleRequest.
 * Use `create(DeleteEntityRoleRequestSchema)` to create a new message.
 */
export const DeleteEntityRoleRequestSchema: GenMessage<DeleteEntityRoleRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 408);

/**
 * @generated from message zdc.GetEntityPermissionsRequest
 */
export type GetEntityPermissionsRequest = Message<"zdc.GetEntityPermissionsRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;
};

/**
 * Describes the message zdc.GetEntityPermissionsRequest.
 * Use `create(GetEntityPermissionsRequestSchema)` to create a new message.
 */
export const GetEntityPermissionsRequestSchema: GenMessage<GetEntityPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 409);

/**
 * @generated from message zdc.SetEntityPermissionRequest
 */
export type SetEntityPermissionRequest = Message<"zdc.SetEntityPermissionRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string permission = 2;
   */
  permission: string;

  /**
   * @generated from field: string scope_type = 3;
   */
  scopeType: string;

  /**
   * @generated from field: string scope_id = 4;
   */
  scopeId: string;

  /**
   * @generated from field: bool allow = 5;
   */
  allow: boolean;
};

/**
 * Describes the message zdc.SetEntityPermissionRequest.
 * Use `create(SetEntityPermissionRequestSchema)` to create a new message.
 */
export const SetEntityPermissionRequestSchema: GenMessage<SetEntityPermissionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 410);

/**
 * @generated from message zdc.DeleteEntityPermissionRequest
 */
export type DeleteEntityPermissionRequest = Message<"zdc.DeleteEntityPermissionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteEntityPermissionRequest.
 * Use `create(DeleteEntityPermissionRequestSchema)` to create a new message.
 */
export const DeleteEntityPermissionRequestSchema: GenMessage<DeleteEntityPermissionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 411);

/**
 * @generated from message zdc.ListEntityFilterAssignmentsRequest
 */
export type ListEntityFilterAssignmentsRequest = Message<"zdc.ListEntityFilterAssignmentsRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;
};

/**
 * Describes the message zdc.ListEntityFilterAssignmentsRequest.
 * Use `create(ListEntityFilterAssignmentsRequestSchema)` to create a new message.
 */
export const ListEntityFilterAssignmentsRequestSchema: GenMessage<ListEntityFilterAssignmentsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 412);

/**
 * @generated from message zdc.SetEntityFilterAssignmentRequest
 */
export type SetEntityFilterAssignmentRequest = Message<"zdc.SetEntityFilterAssignmentRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string filter_key = 2;
   */
  filterKey: string;

  /**
   * @generated from field: string filter_values = 3;
   */
  filterValues: string;
};

/**
 * Describes the message zdc.SetEntityFilterAssignmentRequest.
 * Use `create(SetEntityFilterAssignmentRequestSchema)` to create a new message.
 */
export const SetEntityFilterAssignmentRequestSchema: GenMessage<SetEntityFilterAssignmentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 413);

/**
 * @generated from message zdc.DeleteEntityFilterAssignmentRequest
 */
export type DeleteEntityFilterAssignmentRequest = Message<"zdc.DeleteEntityFilterAssignmentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteEntityFilterAssignmentRequest.
 * Use `create(DeleteEntityFilterAssignmentRequestSchema)` to create a new message.
 */
export const DeleteEntityFilterAssignmentRequestSchema: GenMessage<DeleteEntityFilterAssignmentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 414);

/**
 * @generated from message zdc.GetEffectiveFiltersRequest
 */
export type GetEffectiveFiltersRequest = Message<"zdc.GetEffectiveFiltersRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string filter_key = 2;
   */
  filterKey: string;
};

/**
 * Describes the message zdc.GetEffectiveFiltersRequest.
 * Use `create(GetEffectiveFiltersRequestSchema)` to create a new message.
 */
export const GetEffectiveFiltersRequestSchema: GenMessage<GetEffectiveFiltersRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 415);

/**
 * @generated from message zdc.EffectiveFiltersResponse
 */
export type EffectiveFiltersResponse = Message<"zdc.EffectiveFiltersResponse"> & {
  /**
   * @generated from field: string filter_values = 1;
   */
  filterValues: string;

  /**
   * @generated from field: bool unrestricted = 2;
   */
  unrestricted: boolean;
};

/**
 * Describes the message zdc.EffectiveFiltersResponse.
 * Use `create(EffectiveFiltersResponseSchema)` to create a new message.
 */
export const EffectiveFiltersResponseSchema: GenMessage<EffectiveFiltersResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 416);

/**
 * @generated from message zdc.Section
 */
export type Section = Message<"zdc.Section"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string dbase_id = 4;
   */
  dbaseId: string;

  /**
   * @generated from field: int32 sort_order = 5;
   */
  sortOrder: number;

  /**
   * @generated from field: bool is_visible = 6;
   */
  isVisible: boolean;

  /**
   * @generated from field: string created_at = 7;
   */
  createdAt: string;

  /**
   * @generated from field: repeated string roles = 8;
   */
  roles: string[];

  /**
   * Поведение в сайдбаре: 'auto' | 'collapsed' | 'expanded' (как в 1С)
   *
   * @generated from field: string behavior = 9;
   */
  behavior: string;

  /**
   * Происхождение (ЕДИНЫЙ механизм): template_id — раздел ПОСТАВКИ
   *
   * @generated from field: string template_id = 10;
   */
  templateId: string;

  /**
   * Иерархия разделов: родитель (пусто = корень) и вид ('section'|'group')
   *
   * @generated from field: string parent_id = 11;
   */
  parentId: string;

  /**
   * @generated from field: string kind = 12;
   */
  kind: string;
};

/**
 * Describes the message zdc.Section.
 * Use `create(SectionSchema)` to create a new message.
 */
export const SectionSchema: GenMessage<Section> = /*@__PURE__*/
  messageDesc(file_zdc, 417);

/**
 * @generated from message zdc.SectionList
 */
export type SectionList = Message<"zdc.SectionList"> & {
  /**
   * @generated from field: repeated zdc.Section items = 1;
   */
  items: Section[];
};

/**
 * Describes the message zdc.SectionList.
 * Use `create(SectionListSchema)` to create a new message.
 */
export const SectionListSchema: GenMessage<SectionList> = /*@__PURE__*/
  messageDesc(file_zdc, 418);

/**
 * @generated from message zdc.SectionObject
 */
export type SectionObject = Message<"zdc.SectionObject"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string section_id = 2;
   */
  sectionId: string;

  /**
   * @generated from field: string object_type = 3;
   */
  objectType: string;

  /**
   * @generated from field: string object_name = 4;
   */
  objectName: string;

  /**
   * @generated from field: string synonym = 5;
   */
  synonym: string;

  /**
   * @generated from field: int32 sort_order = 6;
   */
  sortOrder: number;

  /**
   * @generated from field: string list_form_id = 7;
   */
  listFormId: string;

  /**
   * @generated from field: string object_form_id = 8;
   */
  objectFormId: string;

  /**
   * @generated from field: string selection_form_id = 9;
   */
  selectionFormId: string;
};

/**
 * Describes the message zdc.SectionObject.
 * Use `create(SectionObjectSchema)` to create a new message.
 */
export const SectionObjectSchema: GenMessage<SectionObject> = /*@__PURE__*/
  messageDesc(file_zdc, 419);

/**
 * @generated from message zdc.SectionObjectList
 */
export type SectionObjectList = Message<"zdc.SectionObjectList"> & {
  /**
   * @generated from field: repeated zdc.SectionObject items = 1;
   */
  items: SectionObject[];
};

/**
 * Describes the message zdc.SectionObjectList.
 * Use `create(SectionObjectListSchema)` to create a new message.
 */
export const SectionObjectListSchema: GenMessage<SectionObjectList> = /*@__PURE__*/
  messageDesc(file_zdc, 420);

/**
 * @generated from message zdc.GetSectionRequest
 */
export type GetSectionRequest = Message<"zdc.GetSectionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetSectionRequest.
 * Use `create(GetSectionRequestSchema)` to create a new message.
 */
export const GetSectionRequestSchema: GenMessage<GetSectionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 421);

/**
 * @generated from message zdc.CreateSectionRequest
 */
export type CreateSectionRequest = Message<"zdc.CreateSectionRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string dbase_id = 3;
   */
  dbaseId: string;

  /**
   * @generated from field: int32 sort_order = 4;
   */
  sortOrder: number;

  /**
   * @generated from field: repeated string roles = 5;
   */
  roles: string[];

  /**
   * @generated from field: string behavior = 6;
   */
  behavior: string;

  /**
   * Видимость раздела: по умолчанию СКРЫТ (false) — пока не настроен
   * (объекты/роли), в Предприятии не показывается (как в 1С).
   *
   * @generated from field: bool is_visible = 7;
   */
  isVisible: boolean;

  /**
   * Иерархия: родитель (пусто = корень) и вид ('section'|'group')
   *
   * @generated from field: string parent_id = 8;
   */
  parentId: string;

  /**
   * @generated from field: string kind = 9;
   */
  kind: string;
};

/**
 * Describes the message zdc.CreateSectionRequest.
 * Use `create(CreateSectionRequestSchema)` to create a new message.
 */
export const CreateSectionRequestSchema: GenMessage<CreateSectionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 422);

/**
 * @generated from message zdc.UpdateSectionRequest
 */
export type UpdateSectionRequest = Message<"zdc.UpdateSectionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string dbase_id = 4;
   */
  dbaseId: string;

  /**
   * @generated from field: int32 sort_order = 5;
   */
  sortOrder: number;

  /**
   * @generated from field: bool is_visible = 6;
   */
  isVisible: boolean;

  /**
   * @generated from field: repeated string roles = 7;
   */
  roles: string[];

  /**
   * @generated from field: string behavior = 8;
   */
  behavior: string;

  /**
   * Иерархия: родитель (пусто = корень) и вид ('section'|'group')
   *
   * @generated from field: string parent_id = 9;
   */
  parentId: string;

  /**
   * @generated from field: string kind = 10;
   */
  kind: string;
};

/**
 * Describes the message zdc.UpdateSectionRequest.
 * Use `create(UpdateSectionRequestSchema)` to create a new message.
 */
export const UpdateSectionRequestSchema: GenMessage<UpdateSectionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 423);

/**
 * @generated from message zdc.DeleteSectionRequest
 */
export type DeleteSectionRequest = Message<"zdc.DeleteSectionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteSectionRequest.
 * Use `create(DeleteSectionRequestSchema)` to create a new message.
 */
export const DeleteSectionRequestSchema: GenMessage<DeleteSectionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 424);

/**
 * @generated from message zdc.ListSectionObjectsRequest
 */
export type ListSectionObjectsRequest = Message<"zdc.ListSectionObjectsRequest"> & {
  /**
   * @generated from field: string section_id = 1;
   */
  sectionId: string;
};

/**
 * Describes the message zdc.ListSectionObjectsRequest.
 * Use `create(ListSectionObjectsRequestSchema)` to create a new message.
 */
export const ListSectionObjectsRequestSchema: GenMessage<ListSectionObjectsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 425);

/**
 * @generated from message zdc.CreateSectionObjectRequest
 */
export type CreateSectionObjectRequest = Message<"zdc.CreateSectionObjectRequest"> & {
  /**
   * @generated from field: string section_id = 1;
   */
  sectionId: string;

  /**
   * @generated from field: string object_type = 2;
   */
  objectType: string;

  /**
   * @generated from field: string object_name = 3;
   */
  objectName: string;

  /**
   * @generated from field: string synonym = 4;
   */
  synonym: string;

  /**
   * @generated from field: int32 sort_order = 5;
   */
  sortOrder: number;
};

/**
 * Describes the message zdc.CreateSectionObjectRequest.
 * Use `create(CreateSectionObjectRequestSchema)` to create a new message.
 */
export const CreateSectionObjectRequestSchema: GenMessage<CreateSectionObjectRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 426);

/**
 * @generated from message zdc.DeleteSectionObjectRequest
 */
export type DeleteSectionObjectRequest = Message<"zdc.DeleteSectionObjectRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteSectionObjectRequest.
 * Use `create(DeleteSectionObjectRequestSchema)` to create a new message.
 */
export const DeleteSectionObjectRequestSchema: GenMessage<DeleteSectionObjectRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 427);

/**
 * @generated from message zdc.ThemeColor
 */
export type ThemeColor = Message<"zdc.ThemeColor"> & {
  /**
   * @generated from field: string color_key = 1;
   */
  colorKey: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message zdc.ThemeColor.
 * Use `create(ThemeColorSchema)` to create a new message.
 */
export const ThemeColorSchema: GenMessage<ThemeColor> = /*@__PURE__*/
  messageDesc(file_zdc, 428);

/**
 * @generated from message zdc.Theme
 */
export type Theme = Message<"zdc.Theme"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool is_default = 3;
   */
  isDefault: boolean;

  /**
   * @generated from field: string created_at = 4;
   */
  createdAt: string;

  /**
   * @generated from field: repeated zdc.ThemeColor colors = 5;
   */
  colors: ThemeColor[];

  /**
   * системная тема («Светлая»/«Тёмная») — нельзя удалить/переименовать
   *
   * @generated from field: bool is_system = 6;
   */
  isSystem: boolean;
};

/**
 * Describes the message zdc.Theme.
 * Use `create(ThemeSchema)` to create a new message.
 */
export const ThemeSchema: GenMessage<Theme> = /*@__PURE__*/
  messageDesc(file_zdc, 429);

/**
 * @generated from message zdc.ThemeList
 */
export type ThemeList = Message<"zdc.ThemeList"> & {
  /**
   * @generated from field: repeated zdc.Theme items = 1;
   */
  items: Theme[];
};

/**
 * Describes the message zdc.ThemeList.
 * Use `create(ThemeListSchema)` to create a new message.
 */
export const ThemeListSchema: GenMessage<ThemeList> = /*@__PURE__*/
  messageDesc(file_zdc, 430);

/**
 * @generated from message zdc.GetThemeRequest
 */
export type GetThemeRequest = Message<"zdc.GetThemeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetThemeRequest.
 * Use `create(GetThemeRequestSchema)` to create a new message.
 */
export const GetThemeRequestSchema: GenMessage<GetThemeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 431);

/**
 * @generated from message zdc.CreateThemeRequest
 */
export type CreateThemeRequest = Message<"zdc.CreateThemeRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: repeated zdc.ThemeColor colors = 2;
   */
  colors: ThemeColor[];
};

/**
 * Describes the message zdc.CreateThemeRequest.
 * Use `create(CreateThemeRequestSchema)` to create a new message.
 */
export const CreateThemeRequestSchema: GenMessage<CreateThemeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 432);

/**
 * @generated from message zdc.UpdateThemeRequest
 */
export type UpdateThemeRequest = Message<"zdc.UpdateThemeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated zdc.ThemeColor colors = 3;
   */
  colors: ThemeColor[];
};

/**
 * Describes the message zdc.UpdateThemeRequest.
 * Use `create(UpdateThemeRequestSchema)` to create a new message.
 */
export const UpdateThemeRequestSchema: GenMessage<UpdateThemeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 433);

/**
 * @generated from message zdc.DeleteThemeRequest
 */
export type DeleteThemeRequest = Message<"zdc.DeleteThemeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteThemeRequest.
 * Use `create(DeleteThemeRequestSchema)` to create a new message.
 */
export const DeleteThemeRequestSchema: GenMessage<DeleteThemeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 434);

/**
 * @generated from message zdc.SetDefaultThemeRequest
 */
export type SetDefaultThemeRequest = Message<"zdc.SetDefaultThemeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.SetDefaultThemeRequest.
 * Use `create(SetDefaultThemeRequestSchema)` to create a new message.
 */
export const SetDefaultThemeRequestSchema: GenMessage<SetDefaultThemeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 435);

/**
 * @generated from message zdc.RolePermissionList
 */
export type RolePermissionList = Message<"zdc.RolePermissionList"> & {
  /**
   * @generated from field: repeated zdc.RolePermission items = 1;
   */
  items: RolePermission[];
};

/**
 * Describes the message zdc.RolePermissionList.
 * Use `create(RolePermissionListSchema)` to create a new message.
 */
export const RolePermissionListSchema: GenMessage<RolePermissionList> = /*@__PURE__*/
  messageDesc(file_zdc, 436);

/**
 * @generated from message zdc.ListRolePermissionsRequest
 */
export type ListRolePermissionsRequest = Message<"zdc.ListRolePermissionsRequest"> & {
  /**
   * @generated from field: string role_id = 1;
   */
  roleId: string;
};

/**
 * Describes the message zdc.ListRolePermissionsRequest.
 * Use `create(ListRolePermissionsRequestSchema)` to create a new message.
 */
export const ListRolePermissionsRequestSchema: GenMessage<ListRolePermissionsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 437);

/**
 * @generated from message zdc.SetRolePermissionsRequest
 */
export type SetRolePermissionsRequest = Message<"zdc.SetRolePermissionsRequest"> & {
  /**
   * @generated from field: string role_id = 1;
   */
  roleId: string;

  /**
   * @generated from field: repeated zdc.RolePermission permissions = 2;
   */
  permissions: RolePermission[];
};

/**
 * Describes the message zdc.SetRolePermissionsRequest.
 * Use `create(SetRolePermissionsRequestSchema)` to create a new message.
 */
export const SetRolePermissionsRequestSchema: GenMessage<SetRolePermissionsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 438);

/**
 * @generated from message zdc.DBaseType
 */
export type DBaseType = Message<"zdc.DBaseType"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: bool is_active = 5;
   */
  isActive: boolean;

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.DBaseType.
 * Use `create(DBaseTypeSchema)` to create a new message.
 */
export const DBaseTypeSchema: GenMessage<DBaseType> = /*@__PURE__*/
  messageDesc(file_zdc, 439);

/**
 * @generated from message zdc.DBaseTypeList
 */
export type DBaseTypeList = Message<"zdc.DBaseTypeList"> & {
  /**
   * @generated from field: repeated zdc.DBaseType items = 1;
   */
  items: DBaseType[];
};

/**
 * Describes the message zdc.DBaseTypeList.
 * Use `create(DBaseTypeListSchema)` to create a new message.
 */
export const DBaseTypeListSchema: GenMessage<DBaseTypeList> = /*@__PURE__*/
  messageDesc(file_zdc, 440);

/**
 * @generated from message zdc.DBaseTypeQuery
 */
export type DBaseTypeQuery = Message<"zdc.DBaseTypeQuery"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string dbase_type_id = 2;
   */
  dbaseTypeId: string;

  /**
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: string query_text = 5;
   */
  queryText: string;

  /**
   * @generated from field: string indicator_kind = 6;
   */
  indicatorKind: string;

  /**
   * @generated from field: string created_at = 7;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.DBaseTypeQuery.
 * Use `create(DBaseTypeQuerySchema)` to create a new message.
 */
export const DBaseTypeQuerySchema: GenMessage<DBaseTypeQuery> = /*@__PURE__*/
  messageDesc(file_zdc, 441);

/**
 * @generated from message zdc.DBaseTypeQueryList
 */
export type DBaseTypeQueryList = Message<"zdc.DBaseTypeQueryList"> & {
  /**
   * @generated from field: repeated zdc.DBaseTypeQuery items = 1;
   */
  items: DBaseTypeQuery[];
};

/**
 * Describes the message zdc.DBaseTypeQueryList.
 * Use `create(DBaseTypeQueryListSchema)` to create a new message.
 */
export const DBaseTypeQueryListSchema: GenMessage<DBaseTypeQueryList> = /*@__PURE__*/
  messageDesc(file_zdc, 442);

/**
 * @generated from message zdc.CreateDBaseTypeRequest
 */
export type CreateDBaseTypeRequest = Message<"zdc.CreateDBaseTypeRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message zdc.CreateDBaseTypeRequest.
 * Use `create(CreateDBaseTypeRequestSchema)` to create a new message.
 */
export const CreateDBaseTypeRequestSchema: GenMessage<CreateDBaseTypeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 443);

/**
 * @generated from message zdc.UpdateDBaseTypeRequest
 */
export type UpdateDBaseTypeRequest = Message<"zdc.UpdateDBaseTypeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;
};

/**
 * Describes the message zdc.UpdateDBaseTypeRequest.
 * Use `create(UpdateDBaseTypeRequestSchema)` to create a new message.
 */
export const UpdateDBaseTypeRequestSchema: GenMessage<UpdateDBaseTypeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 444);

/**
 * @generated from message zdc.DeleteDBaseTypeRequest
 */
export type DeleteDBaseTypeRequest = Message<"zdc.DeleteDBaseTypeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteDBaseTypeRequest.
 * Use `create(DeleteDBaseTypeRequestSchema)` to create a new message.
 */
export const DeleteDBaseTypeRequestSchema: GenMessage<DeleteDBaseTypeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 445);

/**
 * @generated from message zdc.ListDBaseTypeQueriesRequest
 */
export type ListDBaseTypeQueriesRequest = Message<"zdc.ListDBaseTypeQueriesRequest"> & {
  /**
   * @generated from field: string dbase_type_id = 1;
   */
  dbaseTypeId: string;
};

/**
 * Describes the message zdc.ListDBaseTypeQueriesRequest.
 * Use `create(ListDBaseTypeQueriesRequestSchema)` to create a new message.
 */
export const ListDBaseTypeQueriesRequestSchema: GenMessage<ListDBaseTypeQueriesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 446);

/**
 * @generated from message zdc.CreateDBaseTypeQueryRequest
 */
export type CreateDBaseTypeQueryRequest = Message<"zdc.CreateDBaseTypeQueryRequest"> & {
  /**
   * @generated from field: string dbase_type_id = 1;
   */
  dbaseTypeId: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string query_text = 4;
   */
  queryText: string;

  /**
   * @generated from field: string indicator_kind = 5;
   */
  indicatorKind: string;
};

/**
 * Describes the message zdc.CreateDBaseTypeQueryRequest.
 * Use `create(CreateDBaseTypeQueryRequestSchema)` to create a new message.
 */
export const CreateDBaseTypeQueryRequestSchema: GenMessage<CreateDBaseTypeQueryRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 447);

/**
 * @generated from message zdc.UpdateDBaseTypeQueryRequest
 */
export type UpdateDBaseTypeQueryRequest = Message<"zdc.UpdateDBaseTypeQueryRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string query_text = 4;
   */
  queryText: string;

  /**
   * @generated from field: string indicator_kind = 5;
   */
  indicatorKind: string;
};

/**
 * Describes the message zdc.UpdateDBaseTypeQueryRequest.
 * Use `create(UpdateDBaseTypeQueryRequestSchema)` to create a new message.
 */
export const UpdateDBaseTypeQueryRequestSchema: GenMessage<UpdateDBaseTypeQueryRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 448);

/**
 * @generated from message zdc.DeleteDBaseTypeQueryRequest
 */
export type DeleteDBaseTypeQueryRequest = Message<"zdc.DeleteDBaseTypeQueryRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteDBaseTypeQueryRequest.
 * Use `create(DeleteDBaseTypeQueryRequestSchema)` to create a new message.
 */
export const DeleteDBaseTypeQueryRequestSchema: GenMessage<DeleteDBaseTypeQueryRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 449);

/**
 * @generated from message zdc.SyncJob
 */
export type SyncJob = Message<"zdc.SyncJob"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string job_type = 2;
   */
  jobType: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: string params = 4;
   */
  params: string;

  /**
   * @generated from field: string progress = 5;
   */
  progress: string;

  /**
   * @generated from field: string result = 6;
   */
  result: string;

  /**
   * @generated from field: string scheduled_at = 7;
   */
  scheduledAt: string;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.SyncJob.
 * Use `create(SyncJobSchema)` to create a new message.
 */
export const SyncJobSchema: GenMessage<SyncJob> = /*@__PURE__*/
  messageDesc(file_zdc, 450);

/**
 * @generated from message zdc.SyncJobList
 */
export type SyncJobList = Message<"zdc.SyncJobList"> & {
  /**
   * @generated from field: repeated zdc.SyncJob items = 1;
   */
  items: SyncJob[];
};

/**
 * Describes the message zdc.SyncJobList.
 * Use `create(SyncJobListSchema)` to create a new message.
 */
export const SyncJobListSchema: GenMessage<SyncJobList> = /*@__PURE__*/
  messageDesc(file_zdc, 451);

/**
 * @generated from message zdc.PeripheralTask
 */
export type PeripheralTask = Message<"zdc.PeripheralTask"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string db_id = 2;
   */
  dbId: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: string command = 4;
   */
  command: string;

  /**
   * @generated from field: string payload = 5;
   */
  payload: string;

  /**
   * @generated from field: string result = 6;
   */
  result: string;

  /**
   * @generated from field: int32 priority = 7;
   */
  priority: number;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.PeripheralTask.
 * Use `create(PeripheralTaskSchema)` to create a new message.
 */
export const PeripheralTaskSchema: GenMessage<PeripheralTask> = /*@__PURE__*/
  messageDesc(file_zdc, 452);

/**
 * @generated from message zdc.PeripheralTaskList
 */
export type PeripheralTaskList = Message<"zdc.PeripheralTaskList"> & {
  /**
   * @generated from field: repeated zdc.PeripheralTask items = 1;
   */
  items: PeripheralTask[];
};

/**
 * Describes the message zdc.PeripheralTaskList.
 * Use `create(PeripheralTaskListSchema)` to create a new message.
 */
export const PeripheralTaskListSchema: GenMessage<PeripheralTaskList> = /*@__PURE__*/
  messageDesc(file_zdc, 453);

/**
 * @generated from message zdc.PeripheralSession
 */
export type PeripheralSession = Message<"zdc.PeripheralSession"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string db_id = 2;
   */
  dbId: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: string leased_at = 4;
   */
  leasedAt: string;

  /**
   * @generated from field: string closed_at = 5;
   */
  closedAt: string;
};

/**
 * Describes the message zdc.PeripheralSession.
 * Use `create(PeripheralSessionSchema)` to create a new message.
 */
export const PeripheralSessionSchema: GenMessage<PeripheralSession> = /*@__PURE__*/
  messageDesc(file_zdc, 454);

/**
 * @generated from message zdc.PeripheralSessionList
 */
export type PeripheralSessionList = Message<"zdc.PeripheralSessionList"> & {
  /**
   * @generated from field: repeated zdc.PeripheralSession items = 1;
   */
  items: PeripheralSession[];
};

/**
 * Describes the message zdc.PeripheralSessionList.
 * Use `create(PeripheralSessionListSchema)` to create a new message.
 */
export const PeripheralSessionListSchema: GenMessage<PeripheralSessionList> = /*@__PURE__*/
  messageDesc(file_zdc, 455);

/**
 * @generated from message zdc.CreateSyncJobRequest
 */
export type CreateSyncJobRequest = Message<"zdc.CreateSyncJobRequest"> & {
  /**
   * @generated from field: string job_type = 1;
   */
  jobType: string;

  /**
   * @generated from field: string params = 2;
   */
  params: string;
};

/**
 * Describes the message zdc.CreateSyncJobRequest.
 * Use `create(CreateSyncJobRequestSchema)` to create a new message.
 */
export const CreateSyncJobRequestSchema: GenMessage<CreateSyncJobRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 456);

/**
 * @generated from message zdc.UpdateSyncJobRequest
 */
export type UpdateSyncJobRequest = Message<"zdc.UpdateSyncJobRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string progress = 3;
   */
  progress: string;

  /**
   * @generated from field: string result = 4;
   */
  result: string;
};

/**
 * Describes the message zdc.UpdateSyncJobRequest.
 * Use `create(UpdateSyncJobRequestSchema)` to create a new message.
 */
export const UpdateSyncJobRequestSchema: GenMessage<UpdateSyncJobRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 457);

/**
 * @generated from message zdc.DeleteSyncJobRequest
 */
export type DeleteSyncJobRequest = Message<"zdc.DeleteSyncJobRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteSyncJobRequest.
 * Use `create(DeleteSyncJobRequestSchema)` to create a new message.
 */
export const DeleteSyncJobRequestSchema: GenMessage<DeleteSyncJobRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 458);

/**
 * @generated from message zdc.RunSyncJobRequest
 */
export type RunSyncJobRequest = Message<"zdc.RunSyncJobRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.RunSyncJobRequest.
 * Use `create(RunSyncJobRequestSchema)` to create a new message.
 */
export const RunSyncJobRequestSchema: GenMessage<RunSyncJobRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 459);

/**
 * @generated from message zdc.ListPeripheralTasksRequest
 */
export type ListPeripheralTasksRequest = Message<"zdc.ListPeripheralTasksRequest"> & {
  /**
   * @generated from field: string db_id = 1;
   */
  dbId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * Describes the message zdc.ListPeripheralTasksRequest.
 * Use `create(ListPeripheralTasksRequestSchema)` to create a new message.
 */
export const ListPeripheralTasksRequestSchema: GenMessage<ListPeripheralTasksRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 460);

/**
 * @generated from message zdc.CreatePeripheralTaskRequest
 */
export type CreatePeripheralTaskRequest = Message<"zdc.CreatePeripheralTaskRequest"> & {
  /**
   * @generated from field: string db_id = 1;
   */
  dbId: string;

  /**
   * @generated from field: string command = 2;
   */
  command: string;

  /**
   * @generated from field: string payload = 3;
   */
  payload: string;
};

/**
 * Describes the message zdc.CreatePeripheralTaskRequest.
 * Use `create(CreatePeripheralTaskRequestSchema)` to create a new message.
 */
export const CreatePeripheralTaskRequestSchema: GenMessage<CreatePeripheralTaskRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 461);

/**
 * @generated from message zdc.UpdatePeripheralTaskRequest
 */
export type UpdatePeripheralTaskRequest = Message<"zdc.UpdatePeripheralTaskRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * Describes the message zdc.UpdatePeripheralTaskRequest.
 * Use `create(UpdatePeripheralTaskRequestSchema)` to create a new message.
 */
export const UpdatePeripheralTaskRequestSchema: GenMessage<UpdatePeripheralTaskRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 462);

/**
 * @generated from message zdc.DeletePeripheralTaskRequest
 */
export type DeletePeripheralTaskRequest = Message<"zdc.DeletePeripheralTaskRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeletePeripheralTaskRequest.
 * Use `create(DeletePeripheralTaskRequestSchema)` to create a new message.
 */
export const DeletePeripheralTaskRequestSchema: GenMessage<DeletePeripheralTaskRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 463);

/**
 * @generated from message zdc.ListPeripheralSessionsRequest
 */
export type ListPeripheralSessionsRequest = Message<"zdc.ListPeripheralSessionsRequest"> & {
  /**
   * @generated from field: string db_id = 1;
   */
  dbId: string;
};

/**
 * Describes the message zdc.ListPeripheralSessionsRequest.
 * Use `create(ListPeripheralSessionsRequestSchema)` to create a new message.
 */
export const ListPeripheralSessionsRequestSchema: GenMessage<ListPeripheralSessionsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 464);

/**
 * @generated from message zdc.ClosePeripheralSessionRequest
 */
export type ClosePeripheralSessionRequest = Message<"zdc.ClosePeripheralSessionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.ClosePeripheralSessionRequest.
 * Use `create(ClosePeripheralSessionRequestSchema)` to create a new message.
 */
export const ClosePeripheralSessionRequestSchema: GenMessage<ClosePeripheralSessionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 465);

/**
 * @generated from message zdc.Log
 */
export type Log = Message<"zdc.Log"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string level = 2;
   */
  level: string;

  /**
   * @generated from field: string source = 3;
   */
  source: string;

  /**
   * @generated from field: string message = 4;
   */
  message: string;

  /**
   * @generated from field: string details = 5;
   */
  details: string;

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.Log.
 * Use `create(LogSchema)` to create a new message.
 */
export const LogSchema: GenMessage<Log> = /*@__PURE__*/
  messageDesc(file_zdc, 466);

/**
 * @generated from message zdc.LogList
 */
export type LogList = Message<"zdc.LogList"> & {
  /**
   * @generated from field: repeated zdc.Log items = 1;
   */
  items: Log[];
};

/**
 * Describes the message zdc.LogList.
 * Use `create(LogListSchema)` to create a new message.
 */
export const LogListSchema: GenMessage<LogList> = /*@__PURE__*/
  messageDesc(file_zdc, 467);

/**
 * @generated from message zdc.ListLogsRequest
 */
export type ListLogsRequest = Message<"zdc.ListLogsRequest"> & {
  /**
   * @generated from field: int32 limit = 1;
   */
  limit: number;

  /**
   * @generated from field: string level = 2;
   */
  level: string;
};

/**
 * Describes the message zdc.ListLogsRequest.
 * Use `create(ListLogsRequestSchema)` to create a new message.
 */
export const ListLogsRequestSchema: GenMessage<ListLogsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 468);

/**
 * @generated from message zdc.SetConfigInfoRequest
 */
export type SetConfigInfoRequest = Message<"zdc.SetConfigInfoRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string timezone = 3;
   */
  timezone: string;

  /**
   * @generated from field: string format_date = 4;
   */
  formatDate: string;

  /**
   * @generated from field: string format_datetime = 5;
   */
  formatDatetime: string;

  /**
   * @generated from field: string format_time = 6;
   */
  formatTime: string;

  /**
   * @generated from field: string format_number = 7;
   */
  formatNumber: string;

  /**
   * @generated from field: string format_empty = 8;
   */
  formatEmpty: string;

  /**
   * @generated from field: string format_boolean = 9;
   */
  formatBoolean: string;

  /**
   * Язык конфигурации (код из ветки «Языки», напр. 'ru') — для интерфейса
   * и адаптера «речь в текст»
   *
   * @generated from field: string language = 10;
   */
  language: string;

  /**
   * Основной воркспейс (код; пусто = системный «Предприятие»). Приложения/назначения
   * воркспейсов — отдельными реестрами (pages kind='workspace'/'app' + page_roles).
   *
   * @generated from field: string default_workspace = 11;
   */
  defaultWorkspace: string;
};

/**
 * Describes the message zdc.SetConfigInfoRequest.
 * Use `create(SetConfigInfoRequestSchema)` to create a new message.
 */
export const SetConfigInfoRequestSchema: GenMessage<SetConfigInfoRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 469);

/**
 * @generated from message zdc.SyncS3Request
 */
export type SyncS3Request = Message<"zdc.SyncS3Request"> & {
  /**
   * @generated from field: string direction = 1;
   */
  direction: string;
};

/**
 * Describes the message zdc.SyncS3Request.
 * Use `create(SyncS3RequestSchema)` to create a new message.
 */
export const SyncS3RequestSchema: GenMessage<SyncS3Request> = /*@__PURE__*/
  messageDesc(file_zdc, 470);

/**
 * @generated from message zdc.SyncS3Response
 */
export type SyncS3Response = Message<"zdc.SyncS3Response"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message zdc.SyncS3Response.
 * Use `create(SyncS3ResponseSchema)` to create a new message.
 */
export const SyncS3ResponseSchema: GenMessage<SyncS3Response> = /*@__PURE__*/
  messageDesc(file_zdc, 471);

/**
 * @generated from message zdc.ConfigInfo
 */
export type ConfigInfo = Message<"zdc.ConfigInfo"> & {
  /**
   * @generated from field: string version = 1;
   */
  version: string;

  /**
   * @generated from field: string db_type = 2;
   */
  dbType: string;

  /**
   * @generated from field: string db_host = 3;
   */
  dbHost: string;

  /**
   * @generated from field: int32 table_count = 4;
   */
  tableCount: number;

  /**
   * @generated from field: string last_migration = 5;
   */
  lastMigration: string;

  /**
   * Имя конфигурации (отображается в дереве конфигуратора) и описание
   *
   * @generated from field: string name = 6;
   */
  name: string;

  /**
   * @generated from field: string description = 7;
   */
  description: string;

  /**
   * Часовой пояс конфигурации (например 'Europe/Moscow'): все даты
   * выводятся в этом поясе (храним UTC, форматируем в поясе конфигурации)
   *
   * @generated from field: string timezone = 8;
   */
  timezone: string;

  /**
   * Глобальные форматы вывода по умолчанию для основных типов данных
   * (применяются, если не переопределены реквизитом; как в 1С):
   * date:dd.MM.yyyy | datetime:dd.MM.yyyy HH:mm | time:HH:mm | empty:dash | ...
   *
   * @generated from field: string format_date = 9;
   */
  formatDate: string;

  /**
   * @generated from field: string format_datetime = 10;
   */
  formatDatetime: string;

  /**
   * @generated from field: string format_time = 11;
   */
  formatTime: string;

  /**
   * @generated from field: string format_number = 12;
   */
  formatNumber: string;

  /**
   * @generated from field: string format_empty = 13;
   */
  formatEmpty: string;

  /**
   * @generated from field: string format_boolean = 14;
   */
  formatBoolean: string;

  /**
   * Язык конфигурации (код из ветки «Языки», напр. 'ru') — для интерфейса
   * и адаптера «речь в текст»
   *
   * @generated from field: string language = 15;
   */
  language: string;

  /**
   * Основной воркспейс (код; пусто = системный «Предприятие») — 2026-09-04
   *
   * @generated from field: string default_workspace = 16;
   */
  defaultWorkspace: string;
};

/**
 * Describes the message zdc.ConfigInfo.
 * Use `create(ConfigInfoSchema)` to create a new message.
 */
export const ConfigInfoSchema: GenMessage<ConfigInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 472);

/**
 * @generated from message zdc.ConfigExportResult
 */
export type ConfigExportResult = Message<"zdc.ConfigExportResult"> & {
  /**
   * @generated from field: string data = 1;
   */
  data: string;
};

/**
 * Describes the message zdc.ConfigExportResult.
 * Use `create(ConfigExportResultSchema)` to create a new message.
 */
export const ConfigExportResultSchema: GenMessage<ConfigExportResult> = /*@__PURE__*/
  messageDesc(file_zdc, 473);

/**
 * @generated from message zdc.ValidateConfigRequest
 */
export type ValidateConfigRequest = Message<"zdc.ValidateConfigRequest"> & {
  /**
   * @generated from field: string data = 1;
   */
  data: string;
};

/**
 * Describes the message zdc.ValidateConfigRequest.
 * Use `create(ValidateConfigRequestSchema)` to create a new message.
 */
export const ValidateConfigRequestSchema: GenMessage<ValidateConfigRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 474);

/**
 * @generated from message zdc.ValidateConfigResult
 */
export type ValidateConfigResult = Message<"zdc.ValidateConfigResult"> & {
  /**
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * @generated from field: string errors = 2;
   */
  errors: string;
};

/**
 * Describes the message zdc.ValidateConfigResult.
 * Use `create(ValidateConfigResultSchema)` to create a new message.
 */
export const ValidateConfigResultSchema: GenMessage<ValidateConfigResult> = /*@__PURE__*/
  messageDesc(file_zdc, 475);

/**
 * @generated from message zdc.ImportConfigRequest
 */
export type ImportConfigRequest = Message<"zdc.ImportConfigRequest"> & {
  /**
   * @generated from field: string data = 1;
   */
  data: string;
};

/**
 * Describes the message zdc.ImportConfigRequest.
 * Use `create(ImportConfigRequestSchema)` to create a new message.
 */
export const ImportConfigRequestSchema: GenMessage<ImportConfigRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 476);

/**
 * @generated from message zdc.ImportConfigResult
 */
export type ImportConfigResult = Message<"zdc.ImportConfigResult"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message zdc.ImportConfigResult.
 * Use `create(ImportConfigResultSchema)` to create a new message.
 */
export const ImportConfigResultSchema: GenMessage<ImportConfigResult> = /*@__PURE__*/
  messageDesc(file_zdc, 477);

/**
 * @generated from message zdc.Indicator
 */
export type Indicator = Message<"zdc.Indicator"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * @generated from field: string data_type = 4;
   */
  dataType: string;

  /**
   * @generated from field: string unit = 5;
   */
  unit: string;

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.Indicator.
 * Use `create(IndicatorSchema)` to create a new message.
 */
export const IndicatorSchema: GenMessage<Indicator> = /*@__PURE__*/
  messageDesc(file_zdc, 478);

/**
 * @generated from message zdc.IndicatorList
 */
export type IndicatorList = Message<"zdc.IndicatorList"> & {
  /**
   * @generated from field: repeated zdc.Indicator items = 1;
   */
  items: Indicator[];
};

/**
 * Describes the message zdc.IndicatorList.
 * Use `create(IndicatorListSchema)` to create a new message.
 */
export const IndicatorListSchema: GenMessage<IndicatorList> = /*@__PURE__*/
  messageDesc(file_zdc, 479);

/**
 * @generated from message zdc.IndicatorRecord
 */
export type IndicatorRecord = Message<"zdc.IndicatorRecord"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string indicator_id = 2;
   */
  indicatorId: string;

  /**
   * @generated from field: string organization_id = 3;
   */
  organizationId: string;

  /**
   * @generated from field: string period = 4;
   */
  period: string;

  /**
   * @generated from field: double value = 5;
   */
  value: number;

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.IndicatorRecord.
 * Use `create(IndicatorRecordSchema)` to create a new message.
 */
export const IndicatorRecordSchema: GenMessage<IndicatorRecord> = /*@__PURE__*/
  messageDesc(file_zdc, 480);

/**
 * @generated from message zdc.IndicatorRecordList
 */
export type IndicatorRecordList = Message<"zdc.IndicatorRecordList"> & {
  /**
   * @generated from field: repeated zdc.IndicatorRecord items = 1;
   */
  items: IndicatorRecord[];
};

/**
 * Describes the message zdc.IndicatorRecordList.
 * Use `create(IndicatorRecordListSchema)` to create a new message.
 */
export const IndicatorRecordListSchema: GenMessage<IndicatorRecordList> = /*@__PURE__*/
  messageDesc(file_zdc, 481);

/**
 * @generated from message zdc.CreateIndicatorRequest
 */
export type CreateIndicatorRequest = Message<"zdc.CreateIndicatorRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string data_type = 3;
   */
  dataType: string;

  /**
   * @generated from field: string unit = 4;
   */
  unit: string;
};

/**
 * Describes the message zdc.CreateIndicatorRequest.
 * Use `create(CreateIndicatorRequestSchema)` to create a new message.
 */
export const CreateIndicatorRequestSchema: GenMessage<CreateIndicatorRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 482);

/**
 * @generated from message zdc.ImportStatementRequest
 */
export type ImportStatementRequest = Message<"zdc.ImportStatementRequest"> & {
  /**
   * @generated from field: string filename = 1;
   */
  filename: string;

  /**
   * base64 файла
   *
   * @generated from field: string data = 2;
   */
  data: string;

  /**
   * 'clientbank' | 'csv'
   *
   * @generated from field: string format = 3;
   */
  format: string;

  /**
   * для CSV: 'receipt' | 'payment'
   *
   * @generated from field: string doc_type = 4;
   */
  docType: string;
};

/**
 * Describes the message zdc.ImportStatementRequest.
 * Use `create(ImportStatementRequestSchema)` to create a new message.
 */
export const ImportStatementRequestSchema: GenMessage<ImportStatementRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 483);

/**
 * @generated from message zdc.StatementImportError
 */
export type StatementImportError = Message<"zdc.StatementImportError"> & {
  /**
   * @generated from field: int32 line = 1;
   */
  line: number;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message zdc.StatementImportError.
 * Use `create(StatementImportErrorSchema)` to create a new message.
 */
export const StatementImportErrorSchema: GenMessage<StatementImportError> = /*@__PURE__*/
  messageDesc(file_zdc, 484);

/**
 * @generated from message zdc.ImportStatementResponse
 */
export type ImportStatementResponse = Message<"zdc.ImportStatementResponse"> & {
  /**
   * @generated from field: int32 imported_count = 1;
   */
  importedCount: number;

  /**
   * @generated from field: repeated zdc.StatementImportError errors = 2;
   */
  errors: StatementImportError[];
};

/**
 * Describes the message zdc.ImportStatementResponse.
 * Use `create(ImportStatementResponseSchema)` to create a new message.
 */
export const ImportStatementResponseSchema: GenMessage<ImportStatementResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 485);

/**
 * @generated from message zdc.CallModuleFunctionRequest
 */
export type CallModuleFunctionRequest = Message<"zdc.CallModuleFunctionRequest"> & {
  /**
   * 'document' | 'catalog' | 'order' | 'task' | ...
   *
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * код объекта (таблица)
   *
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;

  /**
   * экспортная функция модуля (functions.X)
   *
   * @generated from field: string function_name = 3;
   */
  functionName: string;

  /**
   * параметры функции (JSON)
   *
   * @generated from field: string args_json = 4;
   */
  argsJson: string;
};

/**
 * Describes the message zdc.CallModuleFunctionRequest.
 * Use `create(CallModuleFunctionRequestSchema)` to create a new message.
 */
export const CallModuleFunctionRequestSchema: GenMessage<CallModuleFunctionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 486);

/**
 * @generated from message zdc.CallModuleFunctionResponse
 */
export type CallModuleFunctionResponse = Message<"zdc.CallModuleFunctionResponse"> & {
  /**
   * возвращаемое значение функции (JSON)
   *
   * @generated from field: string result_json = 1;
   */
  resultJson: string;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: int32 duration_ms = 3;
   */
  durationMs: number;

  /**
   * @generated from field: repeated string logs = 4;
   */
  logs: string[];
};

/**
 * Describes the message zdc.CallModuleFunctionResponse.
 * Use `create(CallModuleFunctionResponseSchema)` to create a new message.
 */
export const CallModuleFunctionResponseSchema: GenMessage<CallModuleFunctionResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 487);

/**
 * @generated from message zdc.OrderType
 */
export type OrderType = Message<"zdc.OrderType"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: bool is_system = 5;
   */
  isSystem: boolean;

  /**
   * @generated from field: string behavior = 6;
   */
  behavior: string;

  /**
   * @generated from field: string view_settings = 7;
   */
  viewSettings: string;

  /**
   * Объект ПОСТАВКИ (template_id): защита + метка в дереве
   *
   * @generated from field: string template_id = 8;
   */
  templateId: string;
};

/**
 * Describes the message zdc.OrderType.
 * Use `create(OrderTypeSchema)` to create a new message.
 */
export const OrderTypeSchema: GenMessage<OrderType> = /*@__PURE__*/
  messageDesc(file_zdc, 488);

/**
 * @generated from message zdc.OrderTypeList
 */
export type OrderTypeList = Message<"zdc.OrderTypeList"> & {
  /**
   * @generated from field: repeated zdc.OrderType items = 1;
   */
  items: OrderType[];
};

/**
 * Describes the message zdc.OrderTypeList.
 * Use `create(OrderTypeListSchema)` to create a new message.
 */
export const OrderTypeListSchema: GenMessage<OrderTypeList> = /*@__PURE__*/
  messageDesc(file_zdc, 489);

/**
 * @generated from message zdc.ListOrderTypesRequest
 */
export type ListOrderTypesRequest = Message<"zdc.ListOrderTypesRequest"> & {
};

/**
 * Describes the message zdc.ListOrderTypesRequest.
 * Use `create(ListOrderTypesRequestSchema)` to create a new message.
 */
export const ListOrderTypesRequestSchema: GenMessage<ListOrderTypesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 490);

/**
 * @generated from message zdc.GetOrderTypeRequest
 */
export type GetOrderTypeRequest = Message<"zdc.GetOrderTypeRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.GetOrderTypeRequest.
 * Use `create(GetOrderTypeRequestSchema)` to create a new message.
 */
export const GetOrderTypeRequestSchema: GenMessage<GetOrderTypeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 491);

/**
 * @generated from message zdc.CreateOrderTypeRequest
 */
export type CreateOrderTypeRequest = Message<"zdc.CreateOrderTypeRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string behavior = 5;
   */
  behavior: string;
};

/**
 * Describes the message zdc.CreateOrderTypeRequest.
 * Use `create(CreateOrderTypeRequestSchema)` to create a new message.
 */
export const CreateOrderTypeRequestSchema: GenMessage<CreateOrderTypeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 492);

/**
 * @generated from message zdc.UpdateOrderTypeRequest
 */
export type UpdateOrderTypeRequest = Message<"zdc.UpdateOrderTypeRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string behavior = 5;
   */
  behavior: string;
};

/**
 * Describes the message zdc.UpdateOrderTypeRequest.
 * Use `create(UpdateOrderTypeRequestSchema)` to create a new message.
 */
export const UpdateOrderTypeRequestSchema: GenMessage<UpdateOrderTypeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 493);

/**
 * @generated from message zdc.DeleteOrderTypeRequest
 */
export type DeleteOrderTypeRequest = Message<"zdc.DeleteOrderTypeRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.DeleteOrderTypeRequest.
 * Use `create(DeleteOrderTypeRequestSchema)` to create a new message.
 */
export const DeleteOrderTypeRequestSchema: GenMessage<DeleteOrderTypeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 494);

/**
 * @generated from message zdc.Order
 */
export type Order = Message<"zdc.Order"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string status_code = 4;
   */
  statusCode: string;

  /**
   * @generated from field: string status_name = 5;
   */
  statusName: string;

  /**
   * @generated from field: map<string, string> extra_fields = 6;
   */
  extraFields: { [key: string]: string };

  /**
   * @generated from field: string created_at = 7;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 8;
   */
  updatedAt: string;

  /**
   * @generated from field: string order_type = 9;
   */
  orderType: string;

  /**
   * Пометка удаления (как в 1С): скрыта из списков; окончательное удаление — админ.
   *
   * @generated from field: bool is_marked = 10;
   */
  isMarked: boolean;

  /**
   * Номер заявки (нумератор) — в списках/карточках/заголовке формы.
   *
   * @generated from field: string number = 11;
   */
  number: string;

  /**
   * Доступные файлы заявки: свои + всех связанных задач (отметка «есть файлы»).
   *
   * @generated from field: int32 files_count = 12;
   */
  filesCount: number;

  /**
   * Дата изменения статуса (timestamp; сервер фиксирует при КАЖДОЙ смене статуса).
   *
   * @generated from field: string status_changed_at = 13;
   */
  statusChangedAt: string;
};

/**
 * Describes the message zdc.Order.
 * Use `create(OrderSchema)` to create a new message.
 */
export const OrderSchema: GenMessage<Order> = /*@__PURE__*/
  messageDesc(file_zdc, 495);

/**
 * @generated from message zdc.OrderList
 */
export type OrderList = Message<"zdc.OrderList"> & {
  /**
   * @generated from field: repeated zdc.Order items = 1;
   */
  items: Order[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * Курсор следующей страницы (курсорная пагинация без OFFSET; пусто = конец).
   *
   * @generated from field: string next_cursor = 3;
   */
  nextCursor: string;
};

/**
 * Describes the message zdc.OrderList.
 * Use `create(OrderListSchema)` to create a new message.
 */
export const OrderListSchema: GenMessage<OrderList> = /*@__PURE__*/
  messageDesc(file_zdc, 496);

/**
 * @generated from message zdc.ListOrdersRequest
 */
export type ListOrdersRequest = Message<"zdc.ListOrdersRequest"> & {
  /**
   * @generated from field: string order_type = 1;
   */
  orderType: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string search = 3;
   */
  search: string;

  /**
   * @generated from field: int32 page_size = 4;
   */
  pageSize: number;

  /**
   * @generated from field: int32 page = 5;
   */
  page: number;

  /**
   * @generated from field: bool include_done = 6;
   */
  includeDone: boolean;

  /**
   * Показывать помеченные на удаление (право «Просмотр помеченных»; у админа всегда).
   *
   * @generated from field: bool include_marked = 7;
   */
  includeMarked: boolean;

  /**
   * Курсор следующей страницы (непрозрачная строка из next_cursor). Пустая
   * строка = первая страница. Вместе с page (стр. > 0) не используется —
   * взаимоисключающие режимы пагинации (ошибка InvalidArgument).
   *
   * @generated from field: optional string cursor = 8;
   */
  cursor?: string | undefined;
};

/**
 * Describes the message zdc.ListOrdersRequest.
 * Use `create(ListOrdersRequestSchema)` to create a new message.
 */
export const ListOrdersRequestSchema: GenMessage<ListOrdersRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 497);

/**
 * @generated from message zdc.GetOrderRequest
 */
export type GetOrderRequest = Message<"zdc.GetOrderRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetOrderRequest.
 * Use `create(GetOrderRequestSchema)` to create a new message.
 */
export const GetOrderRequestSchema: GenMessage<GetOrderRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 498);

/**
 * @generated from message zdc.UpdateOrderRequest
 */
export type UpdateOrderRequest = Message<"zdc.UpdateOrderRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: map<string, string> extra_fields = 4;
   */
  extraFields: { [key: string]: string };

  /**
   * Реквизиты ФОРМЫ (виртуальные): в onBeforeSave (РеквизитыФормы.X)
   *
   * @generated from field: map<string, string> form_attributes = 5;
   */
  formAttributes: { [key: string]: string };
};

/**
 * Describes the message zdc.UpdateOrderRequest.
 * Use `create(UpdateOrderRequestSchema)` to create a new message.
 */
export const UpdateOrderRequestSchema: GenMessage<UpdateOrderRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 499);

/**
 * @generated from message zdc.DeleteOrderRequest
 */
export type DeleteOrderRequest = Message<"zdc.DeleteOrderRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true — ОКОНЧАТЕЛЬНОЕ (физическое) удаление — только администратор;
   * false (по умолчанию) — пометка на удаление (is_marked, скрывается из списков),
   * каскадно помечает связанные задачи (предмет = заявка).
   *
   * @generated from field: bool permanent = 2;
   */
  permanent: boolean;
};

/**
 * Describes the message zdc.DeleteOrderRequest.
 * Use `create(DeleteOrderRequestSchema)` to create a new message.
 */
export const DeleteOrderRequestSchema: GenMessage<DeleteOrderRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 500);

/**
 * Снятие пометки удаления с заявки (каскадно — с её задач).
 *
 * @generated from message zdc.RestoreOrderRequest
 */
export type RestoreOrderRequest = Message<"zdc.RestoreOrderRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.RestoreOrderRequest.
 * Use `create(RestoreOrderRequestSchema)` to create a new message.
 */
export const RestoreOrderRequestSchema: GenMessage<RestoreOrderRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 501);

/**
 * @generated from message zdc.SetOrderStatusRequest
 */
export type SetOrderStatusRequest = Message<"zdc.SetOrderStatusRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string to_code = 2;
   */
  toCode: string;
};

/**
 * Describes the message zdc.SetOrderStatusRequest.
 * Use `create(SetOrderStatusRequestSchema)` to create a new message.
 */
export const SetOrderStatusRequestSchema: GenMessage<SetOrderStatusRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 502);

/**
 * @generated from message zdc.ResolveCustomerRequest
 */
export type ResolveCustomerRequest = Message<"zdc.ResolveCustomerRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string phone = 2;
   */
  phone: string;
};

/**
 * Describes the message zdc.ResolveCustomerRequest.
 * Use `create(ResolveCustomerRequestSchema)` to create a new message.
 */
export const ResolveCustomerRequestSchema: GenMessage<ResolveCustomerRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 503);

/**
 * @generated from message zdc.ResolveCustomerResponse
 */
export type ResolveCustomerResponse = Message<"zdc.ResolveCustomerResponse"> & {
  /**
   * @generated from field: string counterparty_id = 1;
   */
  counterpartyId: string;

  /**
   * @generated from field: string physical_person_id = 2;
   */
  physicalPersonId: string;

  /**
   * @generated from field: bool created = 3;
   */
  created: boolean;
};

/**
 * Describes the message zdc.ResolveCustomerResponse.
 * Use `create(ResolveCustomerResponseSchema)` to create a new message.
 */
export const ResolveCustomerResponseSchema: GenMessage<ResolveCustomerResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 504);

/**
 * @generated from message zdc.CreateOrderRequest
 */
export type CreateOrderRequest = Message<"zdc.CreateOrderRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string phone = 2;
   */
  phone: string;

  /**
   * @generated from field: string counterparty_id = 3;
   */
  counterpartyId: string;

  /**
   * @generated from field: string service_id = 4;
   */
  serviceId: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: string address_id = 6;
   */
  addressId: string;

  /**
   * @generated from field: string address_text = 7;
   */
  addressText: string;

  /**
   * @generated from field: string organization_id = 8;
   */
  organizationId: string;

  /**
   * @generated from field: string priority = 9;
   */
  priority: string;

  /**
   * @generated from field: string source = 10;
   */
  source: string;

  /**
   * @generated from field: string desired_date = 11;
   */
  desiredDate: string;

  /**
   * @generated from field: string desired_time = 12;
   */
  desiredTime: string;

  /**
   * @generated from field: map<string, string> extra_fields = 13;
   */
  extraFields: { [key: string]: string };

  /**
   * Реквизиты ФОРМЫ (виртуальные): в onBeforeSave (РеквизитыФормы.X)
   *
   * @generated from field: map<string, string> form_attributes = 14;
   */
  formAttributes: { [key: string]: string };
};

/**
 * Describes the message zdc.CreateOrderRequest.
 * Use `create(CreateOrderRequestSchema)` to create a new message.
 */
export const CreateOrderRequestSchema: GenMessage<CreateOrderRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 505);

/**
 * @generated from message zdc.OrderSettings
 */
export type OrderSettings = Message<"zdc.OrderSettings"> & {
  /**
   * @generated from field: bool guest_enabled = 1;
   */
  guestEnabled: boolean;
};

/**
 * Describes the message zdc.OrderSettings.
 * Use `create(OrderSettingsSchema)` to create a new message.
 */
export const OrderSettingsSchema: GenMessage<OrderSettings> = /*@__PURE__*/
  messageDesc(file_zdc, 506);

/**
 * @generated from message zdc.CreateOrderResponse
 */
export type CreateOrderResponse = Message<"zdc.CreateOrderResponse"> & {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId: string;

  /**
   * @generated from field: string order_number = 2;
   */
  orderNumber: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;
};

/**
 * Describes the message zdc.CreateOrderResponse.
 * Use `create(CreateOrderResponseSchema)` to create a new message.
 */
export const CreateOrderResponseSchema: GenMessage<CreateOrderResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 507);

/**
 * @generated from message zdc.UpdateIndicatorRequest
 */
export type UpdateIndicatorRequest = Message<"zdc.UpdateIndicatorRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * @generated from field: string data_type = 4;
   */
  dataType: string;

  /**
   * @generated from field: string unit = 5;
   */
  unit: string;
};

/**
 * Describes the message zdc.UpdateIndicatorRequest.
 * Use `create(UpdateIndicatorRequestSchema)` to create a new message.
 */
export const UpdateIndicatorRequestSchema: GenMessage<UpdateIndicatorRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 508);

/**
 * @generated from message zdc.DeleteIndicatorRequest
 */
export type DeleteIndicatorRequest = Message<"zdc.DeleteIndicatorRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteIndicatorRequest.
 * Use `create(DeleteIndicatorRequestSchema)` to create a new message.
 */
export const DeleteIndicatorRequestSchema: GenMessage<DeleteIndicatorRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 509);

/**
 * @generated from message zdc.ListIndicatorRecordsRequest
 */
export type ListIndicatorRecordsRequest = Message<"zdc.ListIndicatorRecordsRequest"> & {
  /**
   * @generated from field: string indicator_id = 1;
   */
  indicatorId: string;
};

/**
 * Describes the message zdc.ListIndicatorRecordsRequest.
 * Use `create(ListIndicatorRecordsRequestSchema)` to create a new message.
 */
export const ListIndicatorRecordsRequestSchema: GenMessage<ListIndicatorRecordsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 510);

/**
 * @generated from message zdc.CreateIndicatorRecordRequest
 */
export type CreateIndicatorRecordRequest = Message<"zdc.CreateIndicatorRecordRequest"> & {
  /**
   * @generated from field: string indicator_id = 1;
   */
  indicatorId: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string period = 3;
   */
  period: string;

  /**
   * @generated from field: double value = 4;
   */
  value: number;
};

/**
 * Describes the message zdc.CreateIndicatorRecordRequest.
 * Use `create(CreateIndicatorRecordRequestSchema)` to create a new message.
 */
export const CreateIndicatorRecordRequestSchema: GenMessage<CreateIndicatorRecordRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 511);

/**
 * @generated from message zdc.DeleteIndicatorRecordRequest
 */
export type DeleteIndicatorRecordRequest = Message<"zdc.DeleteIndicatorRecordRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteIndicatorRecordRequest.
 * Use `create(DeleteIndicatorRecordRequestSchema)` to create a new message.
 */
export const DeleteIndicatorRecordRequestSchema: GenMessage<DeleteIndicatorRecordRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 512);

/**
 * @generated from message zdc.PingDBaseRequest
 */
export type PingDBaseRequest = Message<"zdc.PingDBaseRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.PingDBaseRequest.
 * Use `create(PingDBaseRequestSchema)` to create a new message.
 */
export const PingDBaseRequestSchema: GenMessage<PingDBaseRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 513);

/**
 * @generated from message zdc.PingDBaseResponse
 */
export type PingDBaseResponse = Message<"zdc.PingDBaseResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message zdc.PingDBaseResponse.
 * Use `create(PingDBaseResponseSchema)` to create a new message.
 */
export const PingDBaseResponseSchema: GenMessage<PingDBaseResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 514);

/**
 * @generated from message zdc.MigrateDBaseRequest
 */
export type MigrateDBaseRequest = Message<"zdc.MigrateDBaseRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.MigrateDBaseRequest.
 * Use `create(MigrateDBaseRequestSchema)` to create a new message.
 */
export const MigrateDBaseRequestSchema: GenMessage<MigrateDBaseRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 515);

/**
 * @generated from message zdc.MigrateDBaseResponse
 */
export type MigrateDBaseResponse = Message<"zdc.MigrateDBaseResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message zdc.MigrateDBaseResponse.
 * Use `create(MigrateDBaseResponseSchema)` to create a new message.
 */
export const MigrateDBaseResponseSchema: GenMessage<MigrateDBaseResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 516);

/**
 * @generated from message zdc.SyncRawDataRequest
 */
export type SyncRawDataRequest = Message<"zdc.SyncRawDataRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string period_start = 2;
   */
  periodStart: string;

  /**
   * @generated from field: string period_end = 3;
   */
  periodEnd: string;
};

/**
 * Describes the message zdc.SyncRawDataRequest.
 * Use `create(SyncRawDataRequestSchema)` to create a new message.
 */
export const SyncRawDataRequestSchema: GenMessage<SyncRawDataRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 517);

/**
 * @generated from message zdc.SyncRawDataResponse
 */
export type SyncRawDataResponse = Message<"zdc.SyncRawDataResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message zdc.SyncRawDataResponse.
 * Use `create(SyncRawDataResponseSchema)` to create a new message.
 */
export const SyncRawDataResponseSchema: GenMessage<SyncRawDataResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 518);

/**
 * @generated from message zdc.PullDataRequest
 */
export type PullDataRequest = Message<"zdc.PullDataRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string data_type = 2;
   */
  dataType: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message zdc.PullDataRequest.
 * Use `create(PullDataRequestSchema)` to create a new message.
 */
export const PullDataRequestSchema: GenMessage<PullDataRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 519);

/**
 * @generated from message zdc.PullDataResponse
 */
export type PullDataResponse = Message<"zdc.PullDataResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: string data = 3;
   */
  data: string;
};

/**
 * Describes the message zdc.PullDataResponse.
 * Use `create(PullDataResponseSchema)` to create a new message.
 */
export const PullDataResponseSchema: GenMessage<PullDataResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 520);

/**
 * @generated from message zdc.RotateKeyRequest
 */
export type RotateKeyRequest = Message<"zdc.RotateKeyRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.RotateKeyRequest.
 * Use `create(RotateKeyRequestSchema)` to create a new message.
 */
export const RotateKeyRequestSchema: GenMessage<RotateKeyRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 521);

/**
 * @generated from message zdc.RotateKeyResponse
 */
export type RotateKeyResponse = Message<"zdc.RotateKeyResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string new_key = 2;
   */
  newKey: string;
};

/**
 * Describes the message zdc.RotateKeyResponse.
 * Use `create(RotateKeyResponseSchema)` to create a new message.
 */
export const RotateKeyResponseSchema: GenMessage<RotateKeyResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 522);

/**
 * @generated from message zdc.TriggerPollRequest
 */
export type TriggerPollRequest = Message<"zdc.TriggerPollRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.TriggerPollRequest.
 * Use `create(TriggerPollRequestSchema)` to create a new message.
 */
export const TriggerPollRequestSchema: GenMessage<TriggerPollRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 523);

/**
 * @generated from message zdc.TriggerPollResponse
 */
export type TriggerPollResponse = Message<"zdc.TriggerPollResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message zdc.TriggerPollResponse.
 * Use `create(TriggerPollResponseSchema)` to create a new message.
 */
export const TriggerPollResponseSchema: GenMessage<TriggerPollResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 524);

/**
 * @generated from message zdc.ListDBaseEmployeesRequest
 */
export type ListDBaseEmployeesRequest = Message<"zdc.ListDBaseEmployeesRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.ListDBaseEmployeesRequest.
 * Use `create(ListDBaseEmployeesRequestSchema)` to create a new message.
 */
export const ListDBaseEmployeesRequestSchema: GenMessage<ListDBaseEmployeesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 525);

/**
 * @generated from message zdc.DBaseEmployee
 */
export type DBaseEmployee = Message<"zdc.DBaseEmployee"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message zdc.DBaseEmployee.
 * Use `create(DBaseEmployeeSchema)` to create a new message.
 */
export const DBaseEmployeeSchema: GenMessage<DBaseEmployee> = /*@__PURE__*/
  messageDesc(file_zdc, 526);

/**
 * @generated from message zdc.DBaseEmployeeList
 */
export type DBaseEmployeeList = Message<"zdc.DBaseEmployeeList"> & {
  /**
   * @generated from field: repeated zdc.DBaseEmployee items = 1;
   */
  items: DBaseEmployee[];
};

/**
 * Describes the message zdc.DBaseEmployeeList.
 * Use `create(DBaseEmployeeListSchema)` to create a new message.
 */
export const DBaseEmployeeListSchema: GenMessage<DBaseEmployeeList> = /*@__PURE__*/
  messageDesc(file_zdc, 527);

/**
 * @generated from message zdc.ExecuteQueriesRequest
 */
export type ExecuteQueriesRequest = Message<"zdc.ExecuteQueriesRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: repeated zdc.ExecuteQueryItem queries = 2;
   */
  queries: ExecuteQueryItem[];
};

/**
 * Describes the message zdc.ExecuteQueriesRequest.
 * Use `create(ExecuteQueriesRequestSchema)` to create a new message.
 */
export const ExecuteQueriesRequestSchema: GenMessage<ExecuteQueriesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 528);

/**
 * @generated from message zdc.ExecuteQueryItem
 */
export type ExecuteQueryItem = Message<"zdc.ExecuteQueryItem"> & {
  /**
   * @generated from field: string query_id = 1;
   */
  queryId: string;

  /**
   * @generated from field: string params = 2;
   */
  params: string;
};

/**
 * Describes the message zdc.ExecuteQueryItem.
 * Use `create(ExecuteQueryItemSchema)` to create a new message.
 */
export const ExecuteQueryItemSchema: GenMessage<ExecuteQueryItem> = /*@__PURE__*/
  messageDesc(file_zdc, 529);

/**
 * @generated from message zdc.ExecuteQueriesResponse
 */
export type ExecuteQueriesResponse = Message<"zdc.ExecuteQueriesResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string data = 2;
   */
  data: string;
};

/**
 * Describes the message zdc.ExecuteQueriesResponse.
 * Use `create(ExecuteQueriesResponseSchema)` to create a new message.
 */
export const ExecuteQueriesResponseSchema: GenMessage<ExecuteQueriesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 530);

/**
 * @generated from message zdc.Connector
 */
export type Connector = Message<"zdc.Connector"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: string config = 4;
   */
  config: string;

  /**
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.Connector.
 * Use `create(ConnectorSchema)` to create a new message.
 */
export const ConnectorSchema: GenMessage<Connector> = /*@__PURE__*/
  messageDesc(file_zdc, 531);

/**
 * @generated from message zdc.ConnectorList
 */
export type ConnectorList = Message<"zdc.ConnectorList"> & {
  /**
   * @generated from field: repeated zdc.Connector items = 1;
   */
  items: Connector[];
};

/**
 * Describes the message zdc.ConnectorList.
 * Use `create(ConnectorListSchema)` to create a new message.
 */
export const ConnectorListSchema: GenMessage<ConnectorList> = /*@__PURE__*/
  messageDesc(file_zdc, 532);

/**
 * @generated from message zdc.ConnectorObject
 */
export type ConnectorObject = Message<"zdc.ConnectorObject"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string connector_id = 2;
   */
  connectorId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string config = 4;
   */
  config: string;
};

/**
 * Describes the message zdc.ConnectorObject.
 * Use `create(ConnectorObjectSchema)` to create a new message.
 */
export const ConnectorObjectSchema: GenMessage<ConnectorObject> = /*@__PURE__*/
  messageDesc(file_zdc, 533);

/**
 * @generated from message zdc.ConnectorObjectList
 */
export type ConnectorObjectList = Message<"zdc.ConnectorObjectList"> & {
  /**
   * @generated from field: repeated zdc.ConnectorObject items = 1;
   */
  items: ConnectorObject[];
};

/**
 * Describes the message zdc.ConnectorObjectList.
 * Use `create(ConnectorObjectListSchema)` to create a new message.
 */
export const ConnectorObjectListSchema: GenMessage<ConnectorObjectList> = /*@__PURE__*/
  messageDesc(file_zdc, 534);

/**
 * @generated from message zdc.CreateConnectorRequest
 */
export type CreateConnectorRequest = Message<"zdc.CreateConnectorRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string config = 3;
   */
  config: string;
};

/**
 * Describes the message zdc.CreateConnectorRequest.
 * Use `create(CreateConnectorRequestSchema)` to create a new message.
 */
export const CreateConnectorRequestSchema: GenMessage<CreateConnectorRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 535);

/**
 * @generated from message zdc.UpdateConnectorRequest
 */
export type UpdateConnectorRequest = Message<"zdc.UpdateConnectorRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: string config = 4;
   */
  config: string;
};

/**
 * Describes the message zdc.UpdateConnectorRequest.
 * Use `create(UpdateConnectorRequestSchema)` to create a new message.
 */
export const UpdateConnectorRequestSchema: GenMessage<UpdateConnectorRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 536);

/**
 * @generated from message zdc.DeleteConnectorRequest
 */
export type DeleteConnectorRequest = Message<"zdc.DeleteConnectorRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteConnectorRequest.
 * Use `create(DeleteConnectorRequestSchema)` to create a new message.
 */
export const DeleteConnectorRequestSchema: GenMessage<DeleteConnectorRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 537);

/**
 * @generated from message zdc.ListConnectorObjectsRequest
 */
export type ListConnectorObjectsRequest = Message<"zdc.ListConnectorObjectsRequest"> & {
  /**
   * @generated from field: string connector_id = 1;
   */
  connectorId: string;
};

/**
 * Describes the message zdc.ListConnectorObjectsRequest.
 * Use `create(ListConnectorObjectsRequestSchema)` to create a new message.
 */
export const ListConnectorObjectsRequestSchema: GenMessage<ListConnectorObjectsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 538);

/**
 * @generated from message zdc.CreateConnectorObjectRequest
 */
export type CreateConnectorObjectRequest = Message<"zdc.CreateConnectorObjectRequest"> & {
  /**
   * @generated from field: string connector_id = 1;
   */
  connectorId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string config = 3;
   */
  config: string;
};

/**
 * Describes the message zdc.CreateConnectorObjectRequest.
 * Use `create(CreateConnectorObjectRequestSchema)` to create a new message.
 */
export const CreateConnectorObjectRequestSchema: GenMessage<CreateConnectorObjectRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 539);

/**
 * @generated from message zdc.DeleteConnectorObjectRequest
 */
export type DeleteConnectorObjectRequest = Message<"zdc.DeleteConnectorObjectRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteConnectorObjectRequest.
 * Use `create(DeleteConnectorObjectRequestSchema)` to create a new message.
 */
export const DeleteConnectorObjectRequestSchema: GenMessage<DeleteConnectorObjectRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 540);

/**
 * @generated from message zdc.Metric
 */
export type Metric = Message<"zdc.Metric"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string dbase_type_id = 5;
   */
  dbaseTypeId: string;

  /**
   * @generated from field: string query_ref = 6;
   */
  queryRef: string;

  /**
   * @generated from field: string template = 7;
   */
  template: string;

  /**
   * @generated from field: string aggregation = 8;
   */
  aggregation: string;

  /**
   * @generated from field: string source = 9;
   */
  source: string;

  /**
   * @generated from field: bool is_active = 10;
   */
  isActive: boolean;

  /**
   * @generated from field: string created_at = 11;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.Metric.
 * Use `create(MetricSchema)` to create a new message.
 */
export const MetricSchema: GenMessage<Metric> = /*@__PURE__*/
  messageDesc(file_zdc, 541);

/**
 * @generated from message zdc.MetricList
 */
export type MetricList = Message<"zdc.MetricList"> & {
  /**
   * @generated from field: repeated zdc.Metric items = 1;
   */
  items: Metric[];
};

/**
 * Describes the message zdc.MetricList.
 * Use `create(MetricListSchema)` to create a new message.
 */
export const MetricListSchema: GenMessage<MetricList> = /*@__PURE__*/
  messageDesc(file_zdc, 542);

/**
 * @generated from message zdc.CreateMetricRequest
 */
export type CreateMetricRequest = Message<"zdc.CreateMetricRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string dbase_type_id = 4;
   */
  dbaseTypeId: string;

  /**
   * @generated from field: string query_ref = 5;
   */
  queryRef: string;

  /**
   * @generated from field: string template = 6;
   */
  template: string;

  /**
   * @generated from field: string aggregation = 7;
   */
  aggregation: string;

  /**
   * @generated from field: string source = 8;
   */
  source: string;
};

/**
 * Describes the message zdc.CreateMetricRequest.
 * Use `create(CreateMetricRequestSchema)` to create a new message.
 */
export const CreateMetricRequestSchema: GenMessage<CreateMetricRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 543);

/**
 * @generated from message zdc.UpdateMetricRequest
 */
export type UpdateMetricRequest = Message<"zdc.UpdateMetricRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string dbase_type_id = 5;
   */
  dbaseTypeId: string;

  /**
   * @generated from field: string query_ref = 6;
   */
  queryRef: string;

  /**
   * @generated from field: string template = 7;
   */
  template: string;

  /**
   * @generated from field: string aggregation = 8;
   */
  aggregation: string;

  /**
   * @generated from field: string source = 9;
   */
  source: string;

  /**
   * @generated from field: bool is_active = 10;
   */
  isActive: boolean;
};

/**
 * Describes the message zdc.UpdateMetricRequest.
 * Use `create(UpdateMetricRequestSchema)` to create a new message.
 */
export const UpdateMetricRequestSchema: GenMessage<UpdateMetricRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 544);

/**
 * @generated from message zdc.DeleteMetricRequest
 */
export type DeleteMetricRequest = Message<"zdc.DeleteMetricRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteMetricRequest.
 * Use `create(DeleteMetricRequestSchema)` to create a new message.
 */
export const DeleteMetricRequestSchema: GenMessage<DeleteMetricRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 545);

/**
 * @generated from message zdc.EventPage
 */
export type EventPage = Message<"zdc.EventPage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string topic = 2;
   */
  topic: string;

  /**
   * @generated from field: string payload = 3;
   */
  payload: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: string error = 5;
   */
  error: string;

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.EventPage.
 * Use `create(EventPageSchema)` to create a new message.
 */
export const EventPageSchema: GenMessage<EventPage> = /*@__PURE__*/
  messageDesc(file_zdc, 546);

/**
 * @generated from message zdc.EventPageList
 */
export type EventPageList = Message<"zdc.EventPageList"> & {
  /**
   * @generated from field: repeated zdc.EventPage items = 1;
   */
  items: EventPage[];
};

/**
 * Describes the message zdc.EventPageList.
 * Use `create(EventPageListSchema)` to create a new message.
 */
export const EventPageListSchema: GenMessage<EventPageList> = /*@__PURE__*/
  messageDesc(file_zdc, 547);

/**
 * @generated from message zdc.EventStats
 */
export type EventStats = Message<"zdc.EventStats"> & {
  /**
   * @generated from field: int64 total = 1;
   */
  total: bigint;

  /**
   * @generated from field: int64 pending = 2;
   */
  pending: bigint;

  /**
   * @generated from field: int64 failed = 3;
   */
  failed: bigint;

  /**
   * @generated from field: int64 dead_letter = 4;
   */
  deadLetter: bigint;
};

/**
 * Describes the message zdc.EventStats.
 * Use `create(EventStatsSchema)` to create a new message.
 */
export const EventStatsSchema: GenMessage<EventStats> = /*@__PURE__*/
  messageDesc(file_zdc, 548);

/**
 * @generated from message zdc.ListEventsRequest
 */
export type ListEventsRequest = Message<"zdc.ListEventsRequest"> & {
  /**
   * @generated from field: int32 limit = 1;
   */
  limit: number;

  /**
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * Describes the message zdc.ListEventsRequest.
 * Use `create(ListEventsRequestSchema)` to create a new message.
 */
export const ListEventsRequestSchema: GenMessage<ListEventsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 549);

/**
 * @generated from message zdc.RetryEventRequest
 */
export type RetryEventRequest = Message<"zdc.RetryEventRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.RetryEventRequest.
 * Use `create(RetryEventRequestSchema)` to create a new message.
 */
export const RetryEventRequestSchema: GenMessage<RetryEventRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 550);

/**
 * @generated from message zdc.DeleteEventSchemaRequest
 */
export type DeleteEventSchemaRequest = Message<"zdc.DeleteEventSchemaRequest"> & {
  /**
   * @generated from field: string topic = 1;
   */
  topic: string;

  /**
   * @generated from field: string version = 2;
   */
  version: string;
};

/**
 * Describes the message zdc.DeleteEventSchemaRequest.
 * Use `create(DeleteEventSchemaRequestSchema)` to create a new message.
 */
export const DeleteEventSchemaRequestSchema: GenMessage<DeleteEventSchemaRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 551);

/**
 * @generated from message zdc.Equipment
 */
export type Equipment = Message<"zdc.Equipment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: string config = 4;
   */
  config: string;

  /**
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.Equipment.
 * Use `create(EquipmentSchema)` to create a new message.
 */
export const EquipmentSchema: GenMessage<Equipment> = /*@__PURE__*/
  messageDesc(file_zdc, 552);

/**
 * @generated from message zdc.EquipmentList
 */
export type EquipmentList = Message<"zdc.EquipmentList"> & {
  /**
   * @generated from field: repeated zdc.Equipment items = 1;
   */
  items: Equipment[];
};

/**
 * Describes the message zdc.EquipmentList.
 * Use `create(EquipmentListSchema)` to create a new message.
 */
export const EquipmentListSchema: GenMessage<EquipmentList> = /*@__PURE__*/
  messageDesc(file_zdc, 553);

/**
 * @generated from message zdc.CreateEquipmentRequest
 */
export type CreateEquipmentRequest = Message<"zdc.CreateEquipmentRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string config = 3;
   */
  config: string;
};

/**
 * Describes the message zdc.CreateEquipmentRequest.
 * Use `create(CreateEquipmentRequestSchema)` to create a new message.
 */
export const CreateEquipmentRequestSchema: GenMessage<CreateEquipmentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 554);

/**
 * @generated from message zdc.UpdateEquipmentRequest
 */
export type UpdateEquipmentRequest = Message<"zdc.UpdateEquipmentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: string config = 4;
   */
  config: string;
};

/**
 * Describes the message zdc.UpdateEquipmentRequest.
 * Use `create(UpdateEquipmentRequestSchema)` to create a new message.
 */
export const UpdateEquipmentRequestSchema: GenMessage<UpdateEquipmentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 555);

/**
 * @generated from message zdc.DeleteEquipmentRequest
 */
export type DeleteEquipmentRequest = Message<"zdc.DeleteEquipmentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteEquipmentRequest.
 * Use `create(DeleteEquipmentRequestSchema)` to create a new message.
 */
export const DeleteEquipmentRequestSchema: GenMessage<DeleteEquipmentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 556);

/**
 * @generated from message zdc.TestEquipmentRequest
 */
export type TestEquipmentRequest = Message<"zdc.TestEquipmentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string command = 2;
   */
  command: string;
};

/**
 * Describes the message zdc.TestEquipmentRequest.
 * Use `create(TestEquipmentRequestSchema)` to create a new message.
 */
export const TestEquipmentRequestSchema: GenMessage<TestEquipmentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 557);

/**
 * @generated from message zdc.TestEquipmentResponse
 */
export type TestEquipmentResponse = Message<"zdc.TestEquipmentResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string result = 2;
   */
  result: string;
};

/**
 * Describes the message zdc.TestEquipmentResponse.
 * Use `create(TestEquipmentResponseSchema)` to create a new message.
 */
export const TestEquipmentResponseSchema: GenMessage<TestEquipmentResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 558);

/**
 * @generated from message zdc.DriverInfo
 */
export type DriverInfo = Message<"zdc.DriverInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string version = 3;
   */
  version: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: repeated string capabilities = 5;
   */
  capabilities: string[];
};

/**
 * Describes the message zdc.DriverInfo.
 * Use `create(DriverInfoSchema)` to create a new message.
 */
export const DriverInfoSchema: GenMessage<DriverInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 559);

/**
 * @generated from message zdc.DriverList
 */
export type DriverList = Message<"zdc.DriverList"> & {
  /**
   * @generated from field: repeated zdc.DriverInfo drivers = 1;
   */
  drivers: DriverInfo[];
};

/**
 * Describes the message zdc.DriverList.
 * Use `create(DriverListSchema)` to create a new message.
 */
export const DriverListSchema: GenMessage<DriverList> = /*@__PURE__*/
  messageDesc(file_zdc, 560);

/**
 * @generated from message zdc.IoTDevice
 */
export type IoTDevice = Message<"zdc.IoTDevice"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: string group_id = 4;
   */
  groupId: string;

  /**
   * @generated from field: string config = 5;
   */
  config: string;

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.IoTDevice.
 * Use `create(IoTDeviceSchema)` to create a new message.
 */
export const IoTDeviceSchema: GenMessage<IoTDevice> = /*@__PURE__*/
  messageDesc(file_zdc, 561);

/**
 * @generated from message zdc.IoTDeviceList
 */
export type IoTDeviceList = Message<"zdc.IoTDeviceList"> & {
  /**
   * @generated from field: repeated zdc.IoTDevice items = 1;
   */
  items: IoTDevice[];
};

/**
 * Describes the message zdc.IoTDeviceList.
 * Use `create(IoTDeviceListSchema)` to create a new message.
 */
export const IoTDeviceListSchema: GenMessage<IoTDeviceList> = /*@__PURE__*/
  messageDesc(file_zdc, 562);

/**
 * @generated from message zdc.IoTDeviceGroup
 */
export type IoTDeviceGroup = Message<"zdc.IoTDeviceGroup"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string created_at = 3;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.IoTDeviceGroup.
 * Use `create(IoTDeviceGroupSchema)` to create a new message.
 */
export const IoTDeviceGroupSchema: GenMessage<IoTDeviceGroup> = /*@__PURE__*/
  messageDesc(file_zdc, 563);

/**
 * @generated from message zdc.IoTDeviceGroupList
 */
export type IoTDeviceGroupList = Message<"zdc.IoTDeviceGroupList"> & {
  /**
   * @generated from field: repeated zdc.IoTDeviceGroup items = 1;
   */
  items: IoTDeviceGroup[];
};

/**
 * Describes the message zdc.IoTDeviceGroupList.
 * Use `create(IoTDeviceGroupListSchema)` to create a new message.
 */
export const IoTDeviceGroupListSchema: GenMessage<IoTDeviceGroupList> = /*@__PURE__*/
  messageDesc(file_zdc, 564);

/**
 * @generated from message zdc.IoTRule
 */
export type IoTRule = Message<"zdc.IoTRule"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string condition_expr = 3;
   */
  conditionExpr: string;

  /**
   * @generated from field: string action = 4;
   */
  action: string;

  /**
   * @generated from field: string created_at = 5;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.IoTRule.
 * Use `create(IoTRuleSchema)` to create a new message.
 */
export const IoTRuleSchema: GenMessage<IoTRule> = /*@__PURE__*/
  messageDesc(file_zdc, 565);

/**
 * @generated from message zdc.IoTRuleList
 */
export type IoTRuleList = Message<"zdc.IoTRuleList"> & {
  /**
   * @generated from field: repeated zdc.IoTRule items = 1;
   */
  items: IoTRule[];
};

/**
 * Describes the message zdc.IoTRuleList.
 * Use `create(IoTRuleListSchema)` to create a new message.
 */
export const IoTRuleListSchema: GenMessage<IoTRuleList> = /*@__PURE__*/
  messageDesc(file_zdc, 566);

/**
 * @generated from message zdc.CreateIoTDeviceRequest
 */
export type CreateIoTDeviceRequest = Message<"zdc.CreateIoTDeviceRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string group_id = 3;
   */
  groupId: string;

  /**
   * @generated from field: string config = 4;
   */
  config: string;
};

/**
 * Describes the message zdc.CreateIoTDeviceRequest.
 * Use `create(CreateIoTDeviceRequestSchema)` to create a new message.
 */
export const CreateIoTDeviceRequestSchema: GenMessage<CreateIoTDeviceRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 567);

/**
 * @generated from message zdc.DeleteIoTDeviceRequest
 */
export type DeleteIoTDeviceRequest = Message<"zdc.DeleteIoTDeviceRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteIoTDeviceRequest.
 * Use `create(DeleteIoTDeviceRequestSchema)` to create a new message.
 */
export const DeleteIoTDeviceRequestSchema: GenMessage<DeleteIoTDeviceRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 568);

/**
 * @generated from message zdc.CreateIoTRuleRequest
 */
export type CreateIoTRuleRequest = Message<"zdc.CreateIoTRuleRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string condition_expr = 2;
   */
  conditionExpr: string;

  /**
   * @generated from field: string action = 3;
   */
  action: string;
};

/**
 * Describes the message zdc.CreateIoTRuleRequest.
 * Use `create(CreateIoTRuleRequestSchema)` to create a new message.
 */
export const CreateIoTRuleRequestSchema: GenMessage<CreateIoTRuleRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 569);

/**
 * @generated from message zdc.DeleteIoTRuleRequest
 */
export type DeleteIoTRuleRequest = Message<"zdc.DeleteIoTRuleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteIoTRuleRequest.
 * Use `create(DeleteIoTRuleRequestSchema)` to create a new message.
 */
export const DeleteIoTRuleRequestSchema: GenMessage<DeleteIoTRuleRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 570);

/**
 * @generated from message zdc.GetKPIRequest
 */
export type GetKPIRequest = Message<"zdc.GetKPIRequest"> & {
  /**
   * @generated from field: string metric = 1;
   */
  metric: string;

  /**
   * @generated from field: string period = 2;
   */
  period: string;
};

/**
 * Describes the message zdc.GetKPIRequest.
 * Use `create(GetKPIRequestSchema)` to create a new message.
 */
export const GetKPIRequestSchema: GenMessage<GetKPIRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 571);

/**
 * @generated from message zdc.KPIResponse
 */
export type KPIResponse = Message<"zdc.KPIResponse"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: double value = 2;
   */
  value: number;

  /**
   * @generated from field: double prev_value = 3;
   */
  prevValue: number;

  /**
   * @generated from field: double change_pct = 4;
   */
  changePct: number;

  /**
   * @generated from field: string trend = 5;
   */
  trend: string;

  /**
   * @generated from field: string period = 6;
   */
  period: string;
};

/**
 * Describes the message zdc.KPIResponse.
 * Use `create(KPIResponseSchema)` to create a new message.
 */
export const KPIResponseSchema: GenMessage<KPIResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 572);

/**
 * @generated from message zdc.RunReportRequest
 */
export type RunReportRequest = Message<"zdc.RunReportRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: string params = 2;
   */
  params: string;
};

/**
 * Describes the message zdc.RunReportRequest.
 * Use `create(RunReportRequestSchema)` to create a new message.
 */
export const RunReportRequestSchema: GenMessage<RunReportRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 573);

/**
 * @generated from message zdc.RunReportResponse
 */
export type RunReportResponse = Message<"zdc.RunReportResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string data = 2;
   */
  data: string;
};

/**
 * Describes the message zdc.RunReportResponse.
 * Use `create(RunReportResponseSchema)` to create a new message.
 */
export const RunReportResponseSchema: GenMessage<RunReportResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 574);

/**
 * @generated from message zdc.GetFormPropertiesRequest
 */
export type GetFormPropertiesRequest = Message<"zdc.GetFormPropertiesRequest"> & {
  /**
   * @generated from field: string form_id = 1;
   */
  formId: string;

  /**
   * РґР»СЏ multi-base РїРѕРґРґРµСЂР¶РєРё
   *
   * @generated from field: string base_id = 2;
   */
  baseId: string;
};

/**
 * Describes the message zdc.GetFormPropertiesRequest.
 * Use `create(GetFormPropertiesRequestSchema)` to create a new message.
 */
export const GetFormPropertiesRequestSchema: GenMessage<GetFormPropertiesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 575);

/**
 * @generated from message zdc.FormPropertiesResponse
 */
export type FormPropertiesResponse = Message<"zdc.FormPropertiesResponse"> & {
  /**
   * @generated from field: repeated zdc.FormProperty properties = 1;
   */
  properties: FormProperty[];
};

/**
 * Describes the message zdc.FormPropertiesResponse.
 * Use `create(FormPropertiesResponseSchema)` to create a new message.
 */
export const FormPropertiesResponseSchema: GenMessage<FormPropertiesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 576);

/**
 * @generated from message zdc.SetFormPropertiesRequest
 */
export type SetFormPropertiesRequest = Message<"zdc.SetFormPropertiesRequest"> & {
  /**
   * @generated from field: string form_id = 1;
   */
  formId: string;

  /**
   * @generated from field: repeated zdc.FormProperty properties = 2;
   */
  properties: FormProperty[];

  /**
   * РґР»СЏ multi-base РїРѕРґРґРµСЂР¶РєРё
   *
   * @generated from field: string base_id = 3;
   */
  baseId: string;
};

/**
 * Describes the message zdc.SetFormPropertiesRequest.
 * Use `create(SetFormPropertiesRequestSchema)` to create a new message.
 */
export const SetFormPropertiesRequestSchema: GenMessage<SetFormPropertiesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 577);

/**
 * @generated from message zdc.GetFormFieldsRequest
 */
export type GetFormFieldsRequest = Message<"zdc.GetFormFieldsRequest"> & {
  /**
   * @generated from field: string form_id = 1;
   */
  formId: string;

  /**
   * РґР»СЏ multi-base РїРѕРґРґРµСЂР¶РєРё
   *
   * @generated from field: string base_id = 2;
   */
  baseId: string;
};

/**
 * Describes the message zdc.GetFormFieldsRequest.
 * Use `create(GetFormFieldsRequestSchema)` to create a new message.
 */
export const GetFormFieldsRequestSchema: GenMessage<GetFormFieldsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 578);

/**
 * @generated from message zdc.FormFieldsResponse
 */
export type FormFieldsResponse = Message<"zdc.FormFieldsResponse"> & {
  /**
   * @generated from field: repeated zdc.FormField fields = 1;
   */
  fields: FormField[];
};

/**
 * Describes the message zdc.FormFieldsResponse.
 * Use `create(FormFieldsResponseSchema)` to create a new message.
 */
export const FormFieldsResponseSchema: GenMessage<FormFieldsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 579);

/**
 * @generated from message zdc.FormProperty
 */
export type FormProperty = Message<"zdc.FormProperty"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string data_type = 3;
   */
  dataType: string;

  /**
   * @generated from field: bool is_main = 4;
   */
  isMain: boolean;

  /**
   * @generated from field: string synonym = 5;
   */
  synonym: string;

  /**
   * @generated from field: string usage = 6;
   */
  usage: string;

  /**
   * Режим выбора (как в 1С): '' (по умолчанию) | 'items' (элементы) | 'groups' (группы) | 'both' (любое)
   *
   * @generated from field: string select_mode = 13;
   */
  selectMode: string;

  /**
   * reference / object
   *
   * @generated from field: string ref_type = 10;
   */
  refType: string;

  /**
   * @generated from field: string ref_code = 11;
   */
  refCode: string;

  /**
   * @generated from field: string ref_tabular_section = 12;
   */
  refTabularSection: string;

  /**
   * dynamic_list
   *
   * @generated from field: zdc.DynamicListSource source = 20;
   */
  source?: DynamicListSource | undefined;

  /**
   * value_list
   *
   * @generated from field: repeated zdc.ValueListColumn columns = 30;
   */
  columns: ValueListColumn[];

  /**
   * common
   *
   * @generated from field: bool required = 40;
   */
  required: boolean;

  /**
   * @generated from field: bool read_only = 41;
   */
  readOnly: boolean;

  /**
   * @generated from field: bool visible = 42;
   */
  visible: boolean;

  /**
   * @generated from field: string default_value = 43;
   */
  defaultValue: string;

  /**
   * @generated from field: string tool_tip = 44;
   */
  toolTip: string;

  /**
   * register_record (РегистрСведенийМенеджерЗаписи / НаборЗаписей)
   * Набор записей: true = рендер таблицы записей (несколько строк);
   * false (по умолчанию) = одна запись (поля по пути «Реквизит.Поле»).
   *
   * @generated from field: bool multiple = 45;
   */
  multiple: boolean;

  /**
   * Связи измерений «измерение ← источник значения» (как в 1С):
   *   source=''            — измерение не связано (заполняется вручную);
   *   source='current_object' — значение = id текущей записи формы;
   *   source='field'       — значение из реквизита формы (поле = путь, напр. «Объект.Сотрудник»).
   *
   * @generated from field: repeated zdc.RegisterRecordDimensionLink dimension_links = 46;
   */
  dimensionLinks: RegisterRecordDimensionLink[];
};

/**
 * Describes the message zdc.FormProperty.
 * Use `create(FormPropertySchema)` to create a new message.
 */
export const FormPropertySchema: GenMessage<FormProperty> = /*@__PURE__*/
  messageDesc(file_zdc, 580);

/**
 * @generated from message zdc.RegisterRecordDimensionLink
 */
export type RegisterRecordDimensionLink = Message<"zdc.RegisterRecordDimensionLink"> & {
  /**
   * код измерения регистра (физическая колонка)
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * '' | 'current_object' | 'field'
   *
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * путь реквизита формы для source='field'
   *
   * @generated from field: string field = 3;
   */
  field: string;
};

/**
 * Describes the message zdc.RegisterRecordDimensionLink.
 * Use `create(RegisterRecordDimensionLinkSchema)` to create a new message.
 */
export const RegisterRecordDimensionLinkSchema: GenMessage<RegisterRecordDimensionLink> = /*@__PURE__*/
  messageDesc(file_zdc, 581);

/**
 * @generated from message zdc.DynamicListSource
 */
export type DynamicListSource = Message<"zdc.DynamicListSource"> & {
  /**
   * base_table, query
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string table = 2;
   */
  table: string;

  /**
   * @generated from field: string query = 3;
   */
  query: string;

  /**
   * @generated from field: repeated zdc.QueryParam params = 4;
   */
  params: QueryParam[];

  /**
   * Отборы динамического списка (как в 1С): применяются к базовой таблице.
   *
   * @generated from field: repeated zdc.ListFilter filters = 5;
   */
  filters: ListFilter[];

  /**
   * Включённые стандартные команды списка: create, refresh, delete, search, filter.
   * Пусто = все команды включены.
   *
   * @generated from field: repeated string commands = 6;
   */
  commands: string[];
};

/**
 * Describes the message zdc.DynamicListSource.
 * Use `create(DynamicListSourceSchema)` to create a new message.
 */
export const DynamicListSourceSchema: GenMessage<DynamicListSource> = /*@__PURE__*/
  messageDesc(file_zdc, 582);

/**
 * Отбор динамического списка (1С-стиль).
 *
 * @generated from message zdc.ListFilter
 */
export type ListFilter = Message<"zdc.ListFilter"> & {
  /**
   * имя колонки
   *
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * =, !=, >, <, >=, <=, like, is_null, is_not_null
   *
   * @generated from field: string condition = 2;
   */
  condition: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * Describes the message zdc.ListFilter.
 * Use `create(ListFilterSchema)` to create a new message.
 */
export const ListFilterSchema: GenMessage<ListFilter> = /*@__PURE__*/
  messageDesc(file_zdc, 583);

/**
 * @generated from message zdc.QueryParam
 */
export type QueryParam = Message<"zdc.QueryParam"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * Describes the message zdc.QueryParam.
 * Use `create(QueryParamSchema)` to create a new message.
 */
export const QueryParamSchema: GenMessage<QueryParam> = /*@__PURE__*/
  messageDesc(file_zdc, 584);

/**
 * @generated from message zdc.ValueListColumn
 */
export type ValueListColumn = Message<"zdc.ValueListColumn"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string data_type = 2;
   */
  dataType: string;

  /**
   * @generated from field: int32 width = 3;
   */
  width: number;
};

/**
 * Describes the message zdc.ValueListColumn.
 * Use `create(ValueListColumnSchema)` to create a new message.
 */
export const ValueListColumnSchema: GenMessage<ValueListColumn> = /*@__PURE__*/
  messageDesc(file_zdc, 585);

/**
 * @generated from message zdc.FormField
 */
export type FormField = Message<"zdc.FormField"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string data_type = 2;
   */
  dataType: string;

  /**
   * @generated from field: bool nullable = 3;
   */
  nullable: boolean;

  /**
   * @generated from field: string label = 4;
   */
  label: string;

  /**
   * @generated from field: string path = 5;
   */
  path: string;

  /**
   * @generated from field: bool is_tabular_section_field = 6;
   */
  isTabularSectionField: boolean;

  /**
   * @generated from field: string tabular_section = 7;
   */
  tabularSection: string;
};

/**
 * Describes the message zdc.FormField.
 * Use `create(FormFieldSchema)` to create a new message.
 */
export const FormFieldSchema: GenMessage<FormField> = /*@__PURE__*/
  messageDesc(file_zdc, 586);

/**
 * @generated from message zdc.ObjectLock
 */
export type ObjectLock = Message<"zdc.ObjectLock"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string table_schema = 2;
   */
  tableSchema: string;

  /**
   * @generated from field: string table_name = 3;
   */
  tableName: string;

  /**
   * @generated from field: string row_id = 4;
   */
  rowId: string;

  /**
   * @generated from field: string user_id = 5;
   */
  userId: string;

  /**
   * @generated from field: string user_name = 6;
   */
  userName: string;

  /**
   * @generated from field: string lock_type = 7;
   */
  lockType: string;

  /**
   * @generated from field: string session_id = 8;
   */
  sessionId: string;

  /**
   * @generated from field: string acquired_at = 9;
   */
  acquiredAt: string;

  /**
   * @generated from field: string expires_at = 10;
   */
  expiresAt: string;
};

/**
 * Describes the message zdc.ObjectLock.
 * Use `create(ObjectLockSchema)` to create a new message.
 */
export const ObjectLockSchema: GenMessage<ObjectLock> = /*@__PURE__*/
  messageDesc(file_zdc, 587);

/**
 * @generated from message zdc.AcquireLockRequest
 */
export type AcquireLockRequest = Message<"zdc.AcquireLockRequest"> & {
  /**
   * @generated from field: string table_schema = 1;
   */
  tableSchema: string;

  /**
   * @generated from field: string table_name = 2;
   */
  tableName: string;

  /**
   * @generated from field: string row_id = 3;
   */
  rowId: string;

  /**
   * edit
   *
   * @generated from field: string lock_type = 4;
   */
  lockType: string;

  /**
   * @generated from field: string session_id = 5;
   */
  sessionId: string;

  /**
   * default 900 (15 min)
   *
   * @generated from field: int32 ttl_seconds = 6;
   */
  ttlSeconds: number;
};

/**
 * Describes the message zdc.AcquireLockRequest.
 * Use `create(AcquireLockRequestSchema)` to create a new message.
 */
export const AcquireLockRequestSchema: GenMessage<AcquireLockRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 588);

/**
 * @generated from message zdc.AcquireLockResponse
 */
export type AcquireLockResponse = Message<"zdc.AcquireLockResponse"> & {
  /**
   * @generated from field: bool acquired = 1;
   */
  acquired: boolean;

  /**
   * @generated from field: string lock_id = 2;
   */
  lockId: string;

  /**
   * @generated from field: string expires_at = 3;
   */
  expiresAt: string;

  /**
   * заполнен, если acquired=false
   *
   * @generated from field: zdc.ObjectLock conflict = 4;
   */
  conflict?: ObjectLock | undefined;
};

/**
 * Describes the message zdc.AcquireLockResponse.
 * Use `create(AcquireLockResponseSchema)` to create a new message.
 */
export const AcquireLockResponseSchema: GenMessage<AcquireLockResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 589);

/**
 * @generated from message zdc.ReleaseLockRequest
 */
export type ReleaseLockRequest = Message<"zdc.ReleaseLockRequest"> & {
  /**
   * @generated from field: string lock_id = 1;
   */
  lockId: string;
};

/**
 * Describes the message zdc.ReleaseLockRequest.
 * Use `create(ReleaseLockRequestSchema)` to create a new message.
 */
export const ReleaseLockRequestSchema: GenMessage<ReleaseLockRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 590);

/**
 * @generated from message zdc.ReleaseLockResponse
 */
export type ReleaseLockResponse = Message<"zdc.ReleaseLockResponse"> & {
  /**
   * @generated from field: bool released = 1;
   */
  released: boolean;
};

/**
 * Describes the message zdc.ReleaseLockResponse.
 * Use `create(ReleaseLockResponseSchema)` to create a new message.
 */
export const ReleaseLockResponseSchema: GenMessage<ReleaseLockResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 591);

/**
 * @generated from message zdc.ForceReleaseLockRequest
 */
export type ForceReleaseLockRequest = Message<"zdc.ForceReleaseLockRequest"> & {
  /**
   * @generated from field: string lock_id = 1;
   */
  lockId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message zdc.ForceReleaseLockRequest.
 * Use `create(ForceReleaseLockRequestSchema)` to create a new message.
 */
export const ForceReleaseLockRequestSchema: GenMessage<ForceReleaseLockRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 592);

/**
 * @generated from message zdc.ForceReleaseLockResponse
 */
export type ForceReleaseLockResponse = Message<"zdc.ForceReleaseLockResponse"> & {
  /**
   * @generated from field: bool released = 1;
   */
  released: boolean;
};

/**
 * Describes the message zdc.ForceReleaseLockResponse.
 * Use `create(ForceReleaseLockResponseSchema)` to create a new message.
 */
export const ForceReleaseLockResponseSchema: GenMessage<ForceReleaseLockResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 593);

/**
 * @generated from message zdc.ListLocksRequest
 */
export type ListLocksRequest = Message<"zdc.ListLocksRequest"> & {
  /**
   * @generated from field: string table_schema = 1;
   */
  tableSchema: string;

  /**
   * @generated from field: string table_name = 2;
   */
  tableName: string;

  /**
   * если пусто — все строки таблицы
   *
   * @generated from field: string row_id = 3;
   */
  rowId: string;
};

/**
 * Describes the message zdc.ListLocksRequest.
 * Use `create(ListLocksRequestSchema)` to create a new message.
 */
export const ListLocksRequestSchema: GenMessage<ListLocksRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 594);

/**
 * @generated from message zdc.ListLocksResponse
 */
export type ListLocksResponse = Message<"zdc.ListLocksResponse"> & {
  /**
   * @generated from field: repeated zdc.ObjectLock locks = 1;
   */
  locks: ObjectLock[];
};

/**
 * Describes the message zdc.ListLocksResponse.
 * Use `create(ListLocksResponseSchema)` to create a new message.
 */
export const ListLocksResponseSchema: GenMessage<ListLocksResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 595);

/**
 * @generated from message zdc.RequestReleaseLockRequest
 */
export type RequestReleaseLockRequest = Message<"zdc.RequestReleaseLockRequest"> & {
  /**
   * @generated from field: string lock_id = 1;
   */
  lockId: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message zdc.RequestReleaseLockRequest.
 * Use `create(RequestReleaseLockRequestSchema)` to create a new message.
 */
export const RequestReleaseLockRequestSchema: GenMessage<RequestReleaseLockRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 596);

/**
 * @generated from message zdc.RequestReleaseLockResponse
 */
export type RequestReleaseLockResponse = Message<"zdc.RequestReleaseLockResponse"> & {
  /**
   * @generated from field: bool requested = 1;
   */
  requested: boolean;

  /**
   * @generated from field: string requested_at = 2;
   */
  requestedAt: string;
};

/**
 * Describes the message zdc.RequestReleaseLockResponse.
 * Use `create(RequestReleaseLockResponseSchema)` to create a new message.
 */
export const RequestReleaseLockResponseSchema: GenMessage<RequestReleaseLockResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 597);

/**
 * @generated from message zdc.Report
 */
export type Report = Message<"zdc.Report"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string definition_json = 4;
   */
  definitionJson: string;

  /**
   * @generated from field: bool is_template = 5;
   */
  isTemplate: boolean;

  /**
   * @generated from field: string template_id = 6;
   */
  templateId: string;

  /**
   * @generated from field: string folder_id = 7;
   */
  folderId: string;

  /**
   * @generated from field: string created_by = 8;
   */
  createdBy: string;

  /**
   * @generated from field: string updated_by = 9;
   */
  updatedBy: string;

  /**
   * @generated from field: string created_at = 10;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 11;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.Report.
 * Use `create(ReportSchema)` to create a new message.
 */
export const ReportSchema: GenMessage<Report> = /*@__PURE__*/
  messageDesc(file_zdc, 598);

/**
 * @generated from message zdc.ReportList
 */
export type ReportList = Message<"zdc.ReportList"> & {
  /**
   * @generated from field: repeated zdc.Report items = 1;
   */
  items: Report[];
};

/**
 * Describes the message zdc.ReportList.
 * Use `create(ReportListSchema)` to create a new message.
 */
export const ReportListSchema: GenMessage<ReportList> = /*@__PURE__*/
  messageDesc(file_zdc, 599);

/**
 * @generated from message zdc.ListReportsRequest
 */
export type ListReportsRequest = Message<"zdc.ListReportsRequest"> & {
  /**
   * @generated from field: string folder_id = 1;
   */
  folderId: string;
};

/**
 * Describes the message zdc.ListReportsRequest.
 * Use `create(ListReportsRequestSchema)` to create a new message.
 */
export const ListReportsRequestSchema: GenMessage<ListReportsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 600);

/**
 * @generated from message zdc.GetReportRequest
 */
export type GetReportRequest = Message<"zdc.GetReportRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetReportRequest.
 * Use `create(GetReportRequestSchema)` to create a new message.
 */
export const GetReportRequestSchema: GenMessage<GetReportRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 601);

/**
 * @generated from message zdc.CreateReportRequest
 */
export type CreateReportRequest = Message<"zdc.CreateReportRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string definition_json = 3;
   */
  definitionJson: string;

  /**
   * @generated from field: bool is_template = 4;
   */
  isTemplate: boolean;

  /**
   * @generated from field: string folder_id = 5;
   */
  folderId: string;
};

/**
 * Describes the message zdc.CreateReportRequest.
 * Use `create(CreateReportRequestSchema)` to create a new message.
 */
export const CreateReportRequestSchema: GenMessage<CreateReportRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 602);

/**
 * @generated from message zdc.UpdateReportRequest
 */
export type UpdateReportRequest = Message<"zdc.UpdateReportRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string definition_json = 4;
   */
  definitionJson: string;

  /**
   * @generated from field: bool is_template = 5;
   */
  isTemplate: boolean;

  /**
   * @generated from field: string folder_id = 6;
   */
  folderId: string;
};

/**
 * Describes the message zdc.UpdateReportRequest.
 * Use `create(UpdateReportRequestSchema)` to create a new message.
 */
export const UpdateReportRequestSchema: GenMessage<UpdateReportRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 603);

/**
 * @generated from message zdc.DeleteReportRequest
 */
export type DeleteReportRequest = Message<"zdc.DeleteReportRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteReportRequest.
 * Use `create(DeleteReportRequestSchema)` to create a new message.
 */
export const DeleteReportRequestSchema: GenMessage<DeleteReportRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 604);

/**
 * @generated from message zdc.RenderReportRequest
 */
export type RenderReportRequest = Message<"zdc.RenderReportRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string parameters_json = 2;
   */
  parametersJson: string;

  /**
   * @generated from field: zdc.ReportFormat format = 3;
   */
  format: ReportFormat;

  /**
   * @generated from field: int32 page = 4;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 5;
   */
  pageSize: number;
};

/**
 * Describes the message zdc.RenderReportRequest.
 * Use `create(RenderReportRequestSchema)` to create a new message.
 */
export const RenderReportRequestSchema: GenMessage<RenderReportRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 605);

/**
 * @generated from message zdc.RenderReportResponse
 */
export type RenderReportResponse = Message<"zdc.RenderReportResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: zdc.ReportFormat format = 2;
   */
  format: ReportFormat;

  /**
   * @generated from field: string data_json = 3;
   */
  dataJson: string;

  /**
   * @generated from field: int32 total_rows = 4;
   */
  totalRows: number;

  /**
   * @generated from field: int32 total_pages = 5;
   */
  totalPages: number;

  /**
   * @generated from field: string error_message = 6;
   */
  errorMessage: string;
};

/**
 * Describes the message zdc.RenderReportResponse.
 * Use `create(RenderReportResponseSchema)` to create a new message.
 */
export const RenderReportResponseSchema: GenMessage<RenderReportResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 606);

/**
 * @generated from message zdc.ExportReportRequest
 */
export type ExportReportRequest = Message<"zdc.ExportReportRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string parameters_json = 2;
   */
  parametersJson: string;

  /**
   * @generated from field: zdc.ReportFormat format = 3;
   */
  format: ReportFormat;
};

/**
 * Describes the message zdc.ExportReportRequest.
 * Use `create(ExportReportRequestSchema)` to create a new message.
 */
export const ExportReportRequestSchema: GenMessage<ExportReportRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 607);

/**
 * @generated from message zdc.ExportReportResponse
 */
export type ExportReportResponse = Message<"zdc.ExportReportResponse"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType: string;

  /**
   * @generated from field: string filename = 3;
   */
  filename: string;

  /**
   * @generated from field: string error_message = 4;
   */
  errorMessage: string;
};

/**
 * Describes the message zdc.ExportReportResponse.
 * Use `create(ExportReportResponseSchema)` to create a new message.
 */
export const ExportReportResponseSchema: GenMessage<ExportReportResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 608);

/**
 * Статус схемы: код + отображаемое имя + цвет (для бейджа в UI) +
 * стиль оформления (имя из metadata_styles; при заданном — приоритетнее color).
 *
 * @generated from message zdc.StatusDef
 */
export type StatusDef = Message<"zdc.StatusDef"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * hex-цвет бейджа статуса
   *
   * @generated from field: string color = 4;
   */
  color: string;

  /**
   * начальный статус (присваивается при создании)
   *
   * @generated from field: bool is_initial = 5;
   */
  isInitial: boolean;

  /**
   * конечный статус (из него переходы не разрешены)
   *
   * @generated from field: bool is_final = 6;
   */
  isFinal: boolean;

  /**
   * @generated from field: int32 sort_order = 7;
   */
  sortOrder: number;

  /**
   * стиль оформления (платформенный механизм)
   *
   * @generated from field: string style = 8;
   */
  style: string;
};

/**
 * Describes the message zdc.StatusDef.
 * Use `create(StatusDefSchema)` to create a new message.
 */
export const StatusDefSchema: GenMessage<StatusDef> = /*@__PURE__*/
  messageDesc(file_zdc, 609);

/**
 * Переход между статусами: from → to, доступный ролям (пусто = всем).
 *
 * @generated from message zdc.TransitionDef
 */
export type TransitionDef = Message<"zdc.TransitionDef"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string from_code = 2;
   */
  fromCode: string;

  /**
   * @generated from field: string to_code = 3;
   */
  toCode: string;

  /**
   * роли, которым разрешён переход; пусто = все
   *
   * @generated from field: repeated string role_names = 4;
   */
  roleNames: string[];
};

/**
 * Describes the message zdc.TransitionDef.
 * Use `create(TransitionDefSchema)` to create a new message.
 */
export const TransitionDefSchema: GenMessage<TransitionDef> = /*@__PURE__*/
  messageDesc(file_zdc, 610);

/**
 * АВТОПРАВИЛО СТАТУСА (настраивается на статусной схеме ОБЪЕКТА-ПРЕДМЕТА).
 * Режим условия (mode):
 *   '' (старые правила) — совместимое условие по полю match: any — достаточно
 *   одной такой задачи, all — все задачи предмета в этом статусе;
 *   'any' / 'all' — то же условие, заданное явно;
 *   'last' — по ПОСЛЕДНЕЙ по дате задаче предмета: если её статус равен
 *   task_status, сервер устанавливает объекту статус set_status.
 *
 * @generated from message zdc.StatusAutoRule
 */
export type StatusAutoRule = Message<"zdc.StatusAutoRule"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * код статуса задачи, при достижении которого срабатывает правило
   *
   * @generated from field: string task_status = 2;
   */
  taskStatus: string;

  /**
   * any — любая задача; all — все задачи (для mode='')
   *
   * @generated from field: string match = 3;
   */
  match: string;

  /**
   * код статуса объекта (из статусов этой схемы)
   *
   * @generated from field: string set_status = 4;
   */
  setStatus: string;

  /**
   * '' — как раньше; any|all — явное условие; last — по последней задаче
   *
   * @generated from field: string mode = 5;
   */
  mode: string;
};

/**
 * Describes the message zdc.StatusAutoRule.
 * Use `create(StatusAutoRuleSchema)` to create a new message.
 */
export const StatusAutoRuleSchema: GenMessage<StatusAutoRule> = /*@__PURE__*/
  messageDesc(file_zdc, 611);

/**
 * Схема статусной модели объекта (одна на entity_type+entity_code).
 *
 * @generated from message zdc.StatusSchema
 */
export type StatusSchema = Message<"zdc.StatusSchema"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * отображаемое имя
   *
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * 'catalog' | 'document' | 'task'
   *
   * @generated from field: string entity_type = 4;
   */
  entityType: string;

  /**
   * код/физическая таблица объекта
   *
   * @generated from field: string entity_code = 5;
   */
  entityCode: string;

  /**
   * поле объекта, хранящее статус (default 'status')
   *
   * @generated from field: string field_name = 6;
   */
  fieldName: string;

  /**
   * @generated from field: string description = 7;
   */
  description: string;

  /**
   * @generated from field: repeated zdc.StatusDef statuses = 8;
   */
  statuses: StatusDef[];

  /**
   * @generated from field: repeated zdc.TransitionDef transitions = 9;
   */
  transitions: TransitionDef[];

  /**
   * @generated from field: string created_at = 10;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 11;
   */
  updatedAt: string;

  /**
   * автоправила статуса (серверное применение)
   *
   * @generated from field: repeated zdc.StatusAutoRule auto_rules = 12;
   */
  autoRules: StatusAutoRule[];
};

/**
 * Describes the message zdc.StatusSchema.
 * Use `create(StatusSchemaSchema)` to create a new message.
 */
export const StatusSchemaSchema: GenMessage<StatusSchema> = /*@__PURE__*/
  messageDesc(file_zdc, 612);

/**
 * @generated from message zdc.StatusSchemaList
 */
export type StatusSchemaList = Message<"zdc.StatusSchemaList"> & {
  /**
   * @generated from field: repeated zdc.StatusSchema items = 1;
   */
  items: StatusSchema[];
};

/**
 * Describes the message zdc.StatusSchemaList.
 * Use `create(StatusSchemaListSchema)` to create a new message.
 */
export const StatusSchemaListSchema: GenMessage<StatusSchemaList> = /*@__PURE__*/
  messageDesc(file_zdc, 613);

/**
 * @generated from message zdc.GetStatusSchemaRequest
 */
export type GetStatusSchemaRequest = Message<"zdc.GetStatusSchemaRequest"> & {
  /**
   * по id
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * или по объекту
   *
   * @generated from field: string entity_type = 2;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 3;
   */
  entityCode: string;
};

/**
 * Describes the message zdc.GetStatusSchemaRequest.
 * Use `create(GetStatusSchemaRequestSchema)` to create a new message.
 */
export const GetStatusSchemaRequestSchema: GenMessage<GetStatusSchemaRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 614);

/**
 * @generated from message zdc.SaveStatusSchemaRequest
 */
export type SaveStatusSchemaRequest = Message<"zdc.SaveStatusSchemaRequest"> & {
  /**
   * Пустой id = создание; заданный = полная замена (статусы/переходы перезаписываются).
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string entity_type = 4;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 5;
   */
  entityCode: string;

  /**
   * @generated from field: string field_name = 6;
   */
  fieldName: string;

  /**
   * @generated from field: string description = 7;
   */
  description: string;

  /**
   * @generated from field: repeated zdc.StatusDef statuses = 8;
   */
  statuses: StatusDef[];

  /**
   * @generated from field: repeated zdc.TransitionDef transitions = 9;
   */
  transitions: TransitionDef[];

  /**
   * полная замена вместе со статусами/переходами
   *
   * @generated from field: repeated zdc.StatusAutoRule auto_rules = 10;
   */
  autoRules: StatusAutoRule[];
};

/**
 * Describes the message zdc.SaveStatusSchemaRequest.
 * Use `create(SaveStatusSchemaRequestSchema)` to create a new message.
 */
export const SaveStatusSchemaRequestSchema: GenMessage<SaveStatusSchemaRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 615);

/**
 * @generated from message zdc.DeleteStatusSchemaRequest
 */
export type DeleteStatusSchemaRequest = Message<"zdc.DeleteStatusSchemaRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteStatusSchemaRequest.
 * Use `create(DeleteStatusSchemaRequestSchema)` to create a new message.
 */
export const DeleteStatusSchemaRequestSchema: GenMessage<DeleteStatusSchemaRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 616);

/**
 * Доступные переходы для ТЕКУЩЕГО пользователя (роли из JWT):
 * применяются к объекту (entity_type+entity_code) из текущего статуса.
 *
 * @generated from message zdc.GetTransitionsRequest
 */
export type GetTransitionsRequest = Message<"zdc.GetTransitionsRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;

  /**
   * @generated from field: string from_code = 3;
   */
  fromCode: string;
};

/**
 * Describes the message zdc.GetTransitionsRequest.
 * Use `create(GetTransitionsRequestSchema)` to create a new message.
 */
export const GetTransitionsRequestSchema: GenMessage<GetTransitionsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 617);

/**
 * @generated from message zdc.GetTransitionsResponse
 */
export type GetTransitionsResponse = Message<"zdc.GetTransitionsResponse"> & {
  /**
   * @generated from field: repeated zdc.TransitionDef transitions = 1;
   */
  transitions: TransitionDef[];

  /**
   * @generated from field: string current_status_code = 2;
   */
  currentStatusCode: string;

  /**
   * @generated from field: string current_status_name = 3;
   */
  currentStatusName: string;
};

/**
 * Describes the message zdc.GetTransitionsResponse.
 * Use `create(GetTransitionsResponseSchema)` to create a new message.
 */
export const GetTransitionsResponseSchema: GenMessage<GetTransitionsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 618);

/**
 * Применить переход к объекту: проверяет переход по схеме + права ролей,
 * обновляет поле field_name у записи (SSoT: сервер).
 *
 * @generated from message zdc.ApplyStatusRequest
 */
export type ApplyStatusRequest = Message<"zdc.ApplyStatusRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;

  /**
   * @generated from field: string row_id = 3;
   */
  rowId: string;

  /**
   * @generated from field: string to_code = 4;
   */
  toCode: string;
};

/**
 * Describes the message zdc.ApplyStatusRequest.
 * Use `create(ApplyStatusRequestSchema)` to create a new message.
 */
export const ApplyStatusRequestSchema: GenMessage<ApplyStatusRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 619);

/**
 * @generated from message zdc.Task
 */
export type Task = Message<"zdc.Task"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * тема задачи
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * предмет: 'catalog' | 'document' | '' (без предмета)
   *
   * @generated from field: string subject_type = 4;
   */
  subjectType: string;

  /**
   * физическая таблица предмета (как refTable у полей)
   *
   * @generated from field: string subject_table = 17;
   */
  subjectTable: string;

  /**
   * id записи предмета
   *
   * @generated from field: string subject_id = 5;
   */
  subjectId: string;

  /**
   * представление предмета (сервер)
   *
   * @generated from field: string subject_presentation = 6;
   */
  subjectPresentation: string;

  /**
   * исполнитель (entities), пусто = в пуле
   *
   * @generated from field: string assignee_id = 7;
   */
  assigneeId: string;

  /**
   * представление исполнителя (сервер)
   *
   * @generated from field: string assignee_name = 8;
   */
  assigneeName: string;

  /**
   * автор (entities) — заполняется сервером при создании
   *
   * @generated from field: string author_id = 9;
   */
  authorId: string;

  /**
   * представление автора (сервер)
   *
   * @generated from field: string author_name = 10;
   */
  authorName: string;

  /**
   * срок (YYYY-MM-DD)
   *
   * @generated from field: string due_date = 11;
   */
  dueDate: string;

  /**
   * low | normal | high | critical (default normal)
   *
   * @generated from field: string priority = 12;
   */
  priority: string;

  /**
   * текущий статус (из статусной модели задач)
   *
   * @generated from field: string status_code = 13;
   */
  statusCode: string;

  /**
   * имя статуса (сервер)
   *
   * @generated from field: string status_name = 14;
   */
  statusName: string;

  /**
   * @generated from field: string created_at = 15;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 16;
   */
  updatedAt: string;

  /**
   * Пользовательские реквизиты задачи (колонки tasks, parent_type='task')
   *
   * @generated from field: map<string, string> extra_fields = 18;
   */
  extraFields: { [key: string]: string };

  /**
   * код типа задачи (таблица; '' = системный 'tasks')
   *
   * @generated from field: string task_type = 19;
   */
  taskType: string;

  /**
   * Комментарий исполнителя (команды «Выполнено»/«Отменено»)
   *
   * @generated from field: string executor_comment = 20;
   */
  executorComment: string;

  /**
   * Активных задач у ИСПОЛНИТЕЛЯ этой задачи (загруженность; считается по
   * assignee_id по ВСЕМ типам задач, активные = не done/canceled). Заполняется
   * в ListTasks. Пусто/0 = нет активных или исполнитель не задан.
   *
   * @generated from field: int32 assignee_active_count = 21;
   */
  assigneeActiveCount: number;

  /**
   * Пометка удаления (как в 1С): скрыта из списков; окончательное удаление — админ.
   *
   * @generated from field: bool is_marked = 22;
   */
  isMarked: boolean;

  /**
   * Дата изменения статуса (timestamp; сервер фиксирует при КАЖДОЙ смене статуса).
   *
   * @generated from field: string status_changed_at = 23;
   */
  statusChangedAt: string;
};

/**
 * Describes the message zdc.Task.
 * Use `create(TaskSchema)` to create a new message.
 */
export const TaskSchema: GenMessage<Task> = /*@__PURE__*/
  messageDesc(file_zdc, 620);

/**
 * @generated from message zdc.TaskList
 */
export type TaskList = Message<"zdc.TaskList"> & {
  /**
   * @generated from field: repeated zdc.Task items = 1;
   */
  items: Task[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * Курсор следующей страницы (курсорная пагинация без OFFSET; пусто = конец).
   *
   * @generated from field: string next_cursor = 3;
   */
  nextCursor: string;
};

/**
 * Describes the message zdc.TaskList.
 * Use `create(TaskListSchema)` to create a new message.
 */
export const TaskListSchema: GenMessage<TaskList> = /*@__PURE__*/
  messageDesc(file_zdc, 621);

/**
 * @generated from message zdc.ListTasksRequest
 */
export type ListTasksRequest = Message<"zdc.ListTasksRequest"> & {
  /**
   * '' | 'mine' | 'assigned' | 'pool' | 'inbox' (исполнитель=я) | 'outbox' (автор=я)
   *
   * @generated from field: string filter = 1;
   */
  filter: string;

  /**
   * предмет: 'catalog' | 'document'
   *
   * @generated from field: string subject_type = 2;
   */
  subjectType: string;

  /**
   * физическая таблица предмета
   *
   * @generated from field: string subject_table = 9;
   */
  subjectTable: string;

  /**
   * @generated from field: string subject_id = 3;
   */
  subjectId: string;

  /**
   * фильтр по статусу
   *
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * поиск по теме (LIKE)
   *
   * @generated from field: string search = 5;
   */
  search: string;

  /**
   * @generated from field: int32 page_size = 6;
   */
  pageSize: number;

  /**
   * @generated from field: int32 page = 7;
   */
  page: number;

  /**
   * включать выполненные (default false)
   *
   * @generated from field: bool include_done = 8;
   */
  includeDone: boolean;

  /**
   * код типа задачи ('' = системный 'tasks')
   *
   * @generated from field: string task_type = 10;
   */
  taskType: string;

  /**
   * Показывать помеченные на удаление (право «Просмотр помеченных»; у админа всегда).
   *
   * @generated from field: bool include_marked = 11;
   */
  includeMarked: boolean;

  /**
   * Курсор следующей страницы (непрозрачная строка из next_cursor). Пустая
   * строка = первая страница. Вместе с page (стр. > 0) не используется —
   * взаимоисключающие режимы пагинации (ошибка InvalidArgument).
   *
   * @generated from field: optional string cursor = 12;
   */
  cursor?: string | undefined;
};

/**
 * Describes the message zdc.ListTasksRequest.
 * Use `create(ListTasksRequestSchema)` to create a new message.
 */
export const ListTasksRequestSchema: GenMessage<ListTasksRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 622);

/**
 * @generated from message zdc.GetTaskRequest
 */
export type GetTaskRequest = Message<"zdc.GetTaskRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetTaskRequest.
 * Use `create(GetTaskRequestSchema)` to create a new message.
 */
export const GetTaskRequestSchema: GenMessage<GetTaskRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 623);

/**
 * @generated from message zdc.CreateTaskRequest
 */
export type CreateTaskRequest = Message<"zdc.CreateTaskRequest"> & {
  /**
   * обязателен
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string subject_type = 3;
   */
  subjectType: string;

  /**
   * @generated from field: string subject_table = 8;
   */
  subjectTable: string;

  /**
   * @generated from field: string subject_id = 4;
   */
  subjectId: string;

  /**
   * пусто = задача в пуле
   *
   * @generated from field: string assignee_id = 5;
   */
  assigneeId: string;

  /**
   * @generated from field: string due_date = 6;
   */
  dueDate: string;

  /**
   * @generated from field: string priority = 7;
   */
  priority: string;

  /**
   * Пользовательские реквизиты (колонки tasks)
   *
   * @generated from field: map<string, string> extra_fields = 9;
   */
  extraFields: { [key: string]: string };

  /**
   * код типа задачи ('' = системный 'tasks')
   *
   * @generated from field: string task_type = 10;
   */
  taskType: string;
};

/**
 * Describes the message zdc.CreateTaskRequest.
 * Use `create(CreateTaskRequestSchema)` to create a new message.
 */
export const CreateTaskRequestSchema: GenMessage<CreateTaskRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 624);

/**
 * @generated from message zdc.UpdateTaskRequest
 */
export type UpdateTaskRequest = Message<"zdc.UpdateTaskRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string subject_type = 4;
   */
  subjectType: string;

  /**
   * @generated from field: string subject_table = 9;
   */
  subjectTable: string;

  /**
   * @generated from field: string subject_id = 5;
   */
  subjectId: string;

  /**
   * @generated from field: string assignee_id = 6;
   */
  assigneeId: string;

  /**
   * @generated from field: string due_date = 7;
   */
  dueDate: string;

  /**
   * @generated from field: string priority = 8;
   */
  priority: string;

  /**
   * Пользовательские реквизиты (колонки tasks)
   *
   * @generated from field: map<string, string> extra_fields = 10;
   */
  extraFields: { [key: string]: string };

  /**
   * код типа задачи ('' = системный 'tasks')
   *
   * @generated from field: string task_type = 11;
   */
  taskType: string;
};

/**
 * Describes the message zdc.UpdateTaskRequest.
 * Use `create(UpdateTaskRequestSchema)` to create a new message.
 */
export const UpdateTaskRequestSchema: GenMessage<UpdateTaskRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 625);

/**
 * @generated from message zdc.DeleteTaskRequest
 */
export type DeleteTaskRequest = Message<"zdc.DeleteTaskRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true — ОКОНЧАТЕЛЬНОЕ (физическое) удаление — только администратор;
   * false (по умолчанию) — пометка на удаление (is_marked, скрывается из списков).
   *
   * @generated from field: bool permanent = 2;
   */
  permanent: boolean;
};

/**
 * Describes the message zdc.DeleteTaskRequest.
 * Use `create(DeleteTaskRequestSchema)` to create a new message.
 */
export const DeleteTaskRequestSchema: GenMessage<DeleteTaskRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 626);

/**
 * Снятие пометки удаления с задачи.
 *
 * @generated from message zdc.RestoreTaskRequest
 */
export type RestoreTaskRequest = Message<"zdc.RestoreTaskRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.RestoreTaskRequest.
 * Use `create(RestoreTaskRequestSchema)` to create a new message.
 */
export const RestoreTaskRequestSchema: GenMessage<RestoreTaskRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 627);

/**
 * Смена статуса задачи через статусную модель (проверка переходов + ролей).
 *
 * @generated from message zdc.SetTaskStatusRequest
 */
export type SetTaskStatusRequest = Message<"zdc.SetTaskStatusRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string to_code = 2;
   */
  toCode: string;

  /**
   * Комментарий исполнителя (команды «Выполнено»/«Отменено»): сохраняется
   * в системный реквизит «КомментарийИсполнителя» (executor_comment).
   *
   * @generated from field: string comment = 3;
   */
  comment: string;
};

/**
 * Describes the message zdc.SetTaskStatusRequest.
 * Use `create(SetTaskStatusRequestSchema)` to create a new message.
 */
export const SetTaskStatusRequestSchema: GenMessage<SetTaskStatusRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 628);

/**
 * «Взять» задачу из пула: исполнитель = текущий пользователь,
 * статус → первый НЕ начальный (в работу), если разрешено схемой.
 *
 * @generated from message zdc.TakeTaskRequest
 */
export type TakeTaskRequest = Message<"zdc.TakeTaskRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.TakeTaskRequest.
 * Use `create(TakeTaskRequestSchema)` to create a new message.
 */
export const TakeTaskRequestSchema: GenMessage<TakeTaskRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 629);

/**
 * Вернуть задачу в пул: исполнитель очищается, статус → начальный.
 *
 * @generated from message zdc.ReleaseTaskRequest
 */
export type ReleaseTaskRequest = Message<"zdc.ReleaseTaskRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.ReleaseTaskRequest.
 * Use `create(ReleaseTaskRequestSchema)` to create a new message.
 */
export const ReleaseTaskRequestSchema: GenMessage<ReleaseTaskRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 630);

/**
 * «Передать» задачу: исполнитель ЗАМЕНЯЕТСЯ (передача обращения другому
 * специалисту/в другую очередь). Статус НЕ меняется; повторная передача тому же
 * исполнителю — успех без записи (идемпотентно). Права: админ или task:edit.
 *
 * @generated from message zdc.TransferTaskRequest
 */
export type TransferTaskRequest = Message<"zdc.TransferTaskRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * новый исполнитель (entities; обязателен)
   *
   * @generated from field: string assignee_id = 2;
   */
  assigneeId: string;
};

/**
 * Describes the message zdc.TransferTaskRequest.
 * Use `create(TransferTaskRequestSchema)` to create a new message.
 */
export const TransferTaskRequestSchema: GenMessage<TransferTaskRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 631);

/**
 * @generated from message zdc.ListTaskTypesRequest
 */
export type ListTaskTypesRequest = Message<"zdc.ListTaskTypesRequest"> & {
};

/**
 * Describes the message zdc.ListTaskTypesRequest.
 * Use `create(ListTaskTypesRequestSchema)` to create a new message.
 */
export const ListTaskTypesRequestSchema: GenMessage<ListTaskTypesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 632);

/**
 * @generated from message zdc.GetTaskTypeRequest
 */
export type GetTaskTypeRequest = Message<"zdc.GetTaskTypeRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.GetTaskTypeRequest.
 * Use `create(GetTaskTypeRequestSchema)` to create a new message.
 */
export const GetTaskTypeRequestSchema: GenMessage<GetTaskTypeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 633);

/**
 * @generated from message zdc.CreateTaskTypeRequest
 */
export type CreateTaskTypeRequest = Message<"zdc.CreateTaskTypeRequest"> & {
  /**
   * обязателен (физическая таблица)
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * Виды списка/объекта (JSON)
   *
   * @generated from field: string view_settings = 5;
   */
  viewSettings: string;

  /**
   * по умолчанию включено
   *
   * @generated from field: bool track_reads = 6;
   */
  trackReads: boolean;

  /**
   * 'auto' | 'collapsed' | 'expanded'
   *
   * @generated from field: string behavior = 9;
   */
  behavior: string;

  /**
   * Запрашивать КомментарийИсполнителя при командах «Выполнено»/«Отменено»
   *
   * @generated from field: bool request_comment_on_done = 10;
   */
  requestCommentOnDone: boolean;

  /**
   * @generated from field: bool request_comment_on_cancel = 11;
   */
  requestCommentOnCancel: boolean;

  /**
   * Уведомления в чаты (JSON {to_author,to_assignee,chats})
   *
   * @generated from field: string notify_settings = 12;
   */
  notifySettings: string;
};

/**
 * Describes the message zdc.CreateTaskTypeRequest.
 * Use `create(CreateTaskTypeRequestSchema)` to create a new message.
 */
export const CreateTaskTypeRequestSchema: GenMessage<CreateTaskTypeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 634);

/**
 * @generated from message zdc.UpdateTaskTypeRequest
 */
export type UpdateTaskTypeRequest = Message<"zdc.UpdateTaskTypeRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * Виды списка/объекта (JSON)
   *
   * @generated from field: string view_settings = 5;
   */
  viewSettings: string;

  /**
   * по умолчанию включено
   *
   * @generated from field: bool track_reads = 6;
   */
  trackReads: boolean;

  /**
   * 'auto' | 'collapsed' | 'expanded'
   *
   * @generated from field: string behavior = 9;
   */
  behavior: string;

  /**
   * @generated from field: bool request_comment_on_done = 10;
   */
  requestCommentOnDone: boolean;

  /**
   * @generated from field: bool request_comment_on_cancel = 11;
   */
  requestCommentOnCancel: boolean;

  /**
   * Уведомления в чаты (JSON {to_author,to_assignee,chats})
   *
   * @generated from field: string notify_settings = 12;
   */
  notifySettings: string;
};

/**
 * Describes the message zdc.UpdateTaskTypeRequest.
 * Use `create(UpdateTaskTypeRequestSchema)` to create a new message.
 */
export const UpdateTaskTypeRequestSchema: GenMessage<UpdateTaskTypeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 635);

/**
 * @generated from message zdc.DeleteTaskTypeRequest
 */
export type DeleteTaskTypeRequest = Message<"zdc.DeleteTaskTypeRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.DeleteTaskTypeRequest.
 * Use `create(DeleteTaskTypeRequestSchema)` to create a new message.
 */
export const DeleteTaskTypeRequestSchema: GenMessage<DeleteTaskTypeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 636);

/**
 * @generated from message zdc.TaskType
 */
export type TaskType = Message<"zdc.TaskType"> & {
  /**
   * код типа (физическая таблица задач)
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * внутреннее имя
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * отображаемое имя
   *
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * системный тип (удаление запрещено)
   *
   * @generated from field: bool is_system = 5;
   */
  isSystem: boolean;

  /**
   * Виды списка/объекта (десктоп/мобильный): единый механизм видов
   *
   * @generated from field: string view_settings = 6;
   */
  viewSettings: string;

  /**
   * Отслеживание прочтения (по умолчанию ВКЛЮЧЕНО для задач)
   *
   * @generated from field: bool track_reads = 7;
   */
  trackReads: boolean;

  /**
   * Поведение в сайдбаре: 'auto' | 'collapsed' | 'expanded' (по умолчанию 'expanded')
   *
   * @generated from field: string behavior = 10;
   */
  behavior: string;

  /**
   * Объект ПОСТАВКИ (template_id): защита + метка в дереве
   *
   * @generated from field: string template_id = 11;
   */
  templateId: string;

  /**
   * Запрашивать КомментарийИсполнителя при командах «Выполнено»/«Отменено»
   *
   * @generated from field: bool request_comment_on_done = 12;
   */
  requestCommentOnDone: boolean;

  /**
   * @generated from field: bool request_comment_on_cancel = 13;
   */
  requestCommentOnCancel: boolean;

  /**
   * УВЕДОМЛЕНИЯ В ЧАТЫ (системный бот «Уведомитель»): JSON
   * {to_author, to_assignee, chats: [conversation_id]} — о новой задаче и
   * изменении статуса (событийная модель, отправка от бота)
   *
   * @generated from field: string notify_settings = 14;
   */
  notifySettings: string;
};

/**
 * Describes the message zdc.TaskType.
 * Use `create(TaskTypeSchema)` to create a new message.
 */
export const TaskTypeSchema: GenMessage<TaskType> = /*@__PURE__*/
  messageDesc(file_zdc, 637);

/**
 * @generated from message zdc.TaskTypeList
 */
export type TaskTypeList = Message<"zdc.TaskTypeList"> & {
  /**
   * @generated from field: repeated zdc.TaskType items = 1;
   */
  items: TaskType[];
};

/**
 * Describes the message zdc.TaskTypeList.
 * Use `create(TaskTypeListSchema)` to create a new message.
 */
export const TaskTypeListSchema: GenMessage<TaskTypeList> = /*@__PURE__*/
  messageDesc(file_zdc, 638);

/**
 * @generated from message zdc.SuggestAssigneesRequest
 */
export type SuggestAssigneesRequest = Message<"zdc.SuggestAssigneesRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * тип задачи (таблица): активные задачи считаются по нему (пусто = все типы)
   *
   * @generated from field: string task_type = 2;
   */
  taskType: string;
};

/**
 * Describes the message zdc.SuggestAssigneesRequest.
 * Use `create(SuggestAssigneesRequestSchema)` to create a new message.
 */
export const SuggestAssigneesRequestSchema: GenMessage<SuggestAssigneesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 639);

/**
 * @generated from message zdc.AssigneeCandidate
 */
export type AssigneeCandidate = Message<"zdc.AssigneeCandidate"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * навыки сотрудника (сопоставление по телефону)
   *
   * @generated from field: repeated string skills = 3;
   */
  skills: string[];

  /**
   * активных (не завершённых) задач у исполнителя (загруженность)
   *
   * @generated from field: int32 active_count = 4;
   */
  activeCount: number;
};

/**
 * Describes the message zdc.AssigneeCandidate.
 * Use `create(AssigneeCandidateSchema)` to create a new message.
 */
export const AssigneeCandidateSchema: GenMessage<AssigneeCandidate> = /*@__PURE__*/
  messageDesc(file_zdc, 640);

/**
 * @generated from message zdc.SuggestAssigneesResponse
 */
export type SuggestAssigneesResponse = Message<"zdc.SuggestAssigneesResponse"> & {
  /**
   * @generated from field: repeated zdc.AssigneeCandidate items = 1;
   */
  items: AssigneeCandidate[];
};

/**
 * Describes the message zdc.SuggestAssigneesResponse.
 * Use `create(SuggestAssigneesResponseSchema)` to create a new message.
 */
export const SuggestAssigneesResponseSchema: GenMessage<SuggestAssigneesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 641);

/**
 * @generated from message zdc.ExternalApiFieldSchema
 */
export type ExternalApiFieldSchema = Message<"zdc.ExternalApiFieldSchema"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * 'text' | 'secret' | 'bool' | 'list'
   *
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: bool required = 4;
   */
  required: boolean;

  /**
   * для type='list'
   *
   * @generated from field: repeated string options = 5;
   */
  options: string[];

  /**
   * @generated from field: string default_value = 6;
   */
  defaultValue: string;

  /**
   * @generated from field: string hint = 7;
   */
  hint: string;
};

/**
 * Describes the message zdc.ExternalApiFieldSchema.
 * Use `create(ExternalApiFieldSchemaSchema)` to create a new message.
 */
export const ExternalApiFieldSchemaSchema: GenMessage<ExternalApiFieldSchema> = /*@__PURE__*/
  messageDesc(file_zdc, 642);

/**
 * @generated from message zdc.ExternalApiTypeInfo
 */
export type ExternalApiTypeInfo = Message<"zdc.ExternalApiTypeInfo"> & {
  /**
   * 'osm'
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 'OpenStreetMap (Nominatim)'
   *
   * @generated from field: string display = 2;
   */
  display: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * схема настройки (визуальный редактор)
   *
   * @generated from field: repeated zdc.ExternalApiFieldSchema fields = 4;
   */
  fields: ExternalApiFieldSchema[];

  /**
   * @generated from field: bool builtin = 5;
   */
  builtin: boolean;
};

/**
 * Describes the message zdc.ExternalApiTypeInfo.
 * Use `create(ExternalApiTypeInfoSchema)` to create a new message.
 */
export const ExternalApiTypeInfoSchema: GenMessage<ExternalApiTypeInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 643);

/**
 * @generated from message zdc.ExternalApiTypeList
 */
export type ExternalApiTypeList = Message<"zdc.ExternalApiTypeList"> & {
  /**
   * @generated from field: repeated zdc.ExternalApiTypeInfo items = 1;
   */
  items: ExternalApiTypeInfo[];
};

/**
 * Describes the message zdc.ExternalApiTypeList.
 * Use `create(ExternalApiTypeListSchema)` to create a new message.
 */
export const ExternalApiTypeListSchema: GenMessage<ExternalApiTypeList> = /*@__PURE__*/
  messageDesc(file_zdc, 644);

/**
 * @generated from message zdc.ExternalApi
 */
export type ExternalApi = Message<"zdc.ExternalApi"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string api_type = 2;
   */
  apiType: string;

  /**
   * имя подключения (задаёт пользователь)
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * настройки по схеме типа (секреты не возвращаются)
   *
   * @generated from field: map<string, string> settings = 4;
   */
  settings: { [key: string]: string };

  /**
   * @generated from field: bool enabled = 5;
   */
  enabled: boolean;

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 7;
   */
  updatedAt: string;

  /**
   * @generated from field: bool is_system = 8;
   */
  isSystem: boolean;

  /**
   * JSON счётчиков {d:{key:n},w:{},m:{}}
   *
   * @generated from field: string usage = 9;
   */
  usage: string;
};

/**
 * Describes the message zdc.ExternalApi.
 * Use `create(ExternalApiSchema)` to create a new message.
 */
export const ExternalApiSchema: GenMessage<ExternalApi> = /*@__PURE__*/
  messageDesc(file_zdc, 645);

/**
 * @generated from message zdc.ResetApiUsageRequest
 */
export type ResetApiUsageRequest = Message<"zdc.ResetApiUsageRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.ResetApiUsageRequest.
 * Use `create(ResetApiUsageRequestSchema)` to create a new message.
 */
export const ResetApiUsageRequestSchema: GenMessage<ResetApiUsageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 646);

/**
 * @generated from message zdc.ExternalApiList
 */
export type ExternalApiList = Message<"zdc.ExternalApiList"> & {
  /**
   * @generated from field: repeated zdc.ExternalApi items = 1;
   */
  items: ExternalApi[];
};

/**
 * Describes the message zdc.ExternalApiList.
 * Use `create(ExternalApiListSchema)` to create a new message.
 */
export const ExternalApiListSchema: GenMessage<ExternalApiList> = /*@__PURE__*/
  messageDesc(file_zdc, 647);

/**
 * @generated from message zdc.GetExternalApiRequest
 */
export type GetExternalApiRequest = Message<"zdc.GetExternalApiRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetExternalApiRequest.
 * Use `create(GetExternalApiRequestSchema)` to create a new message.
 */
export const GetExternalApiRequestSchema: GenMessage<GetExternalApiRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 648);

/**
 * @generated from message zdc.CreateExternalApiRequest
 */
export type CreateExternalApiRequest = Message<"zdc.CreateExternalApiRequest"> & {
  /**
   * @generated from field: string api_type = 1;
   */
  apiType: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: map<string, string> settings = 3;
   */
  settings: { [key: string]: string };

  /**
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;
};

/**
 * Describes the message zdc.CreateExternalApiRequest.
 * Use `create(CreateExternalApiRequestSchema)` to create a new message.
 */
export const CreateExternalApiRequestSchema: GenMessage<CreateExternalApiRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 649);

/**
 * @generated from message zdc.UpdateExternalApiRequest
 */
export type UpdateExternalApiRequest = Message<"zdc.UpdateExternalApiRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: map<string, string> settings = 3;
   */
  settings: { [key: string]: string };

  /**
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;
};

/**
 * Describes the message zdc.UpdateExternalApiRequest.
 * Use `create(UpdateExternalApiRequestSchema)` to create a new message.
 */
export const UpdateExternalApiRequestSchema: GenMessage<UpdateExternalApiRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 650);

/**
 * @generated from message zdc.DeleteExternalApiRequest
 */
export type DeleteExternalApiRequest = Message<"zdc.DeleteExternalApiRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteExternalApiRequest.
 * Use `create(DeleteExternalApiRequestSchema)` to create a new message.
 */
export const DeleteExternalApiRequestSchema: GenMessage<DeleteExternalApiRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 651);

/**
 * @generated from message zdc.TestExternalApiRequest
 */
export type TestExternalApiRequest = Message<"zdc.TestExternalApiRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Для НОВОГО подключения (ещё не сохранённого): тест по введённым настройкам
   *
   * @generated from field: string api_type = 2;
   */
  apiType: string;

  /**
   * @generated from field: map<string, string> settings = 3;
   */
  settings: { [key: string]: string };
};

/**
 * Describes the message zdc.TestExternalApiRequest.
 * Use `create(TestExternalApiRequestSchema)` to create a new message.
 */
export const TestExternalApiRequestSchema: GenMessage<TestExternalApiRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 652);

/**
 * @generated from message zdc.TestExternalApiResult
 */
export type TestExternalApiResult = Message<"zdc.TestExternalApiResult"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * русский текст результата/ошибки
   *
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message zdc.TestExternalApiResult.
 * Use `create(TestExternalApiResultSchema)` to create a new message.
 */
export const TestExternalApiResultSchema: GenMessage<TestExternalApiResult> = /*@__PURE__*/
  messageDesc(file_zdc, 653);

/**
 * Геокодинг (адрес → координаты) через включённое OSM-подключение.
 *
 * @generated from message zdc.GeocodeRequest
 */
export type GeocodeRequest = Message<"zdc.GeocodeRequest"> & {
  /**
   * @generated from field: string address = 1;
   */
  address: string;
};

/**
 * Describes the message zdc.GeocodeRequest.
 * Use `create(GeocodeRequestSchema)` to create a new message.
 */
export const GeocodeRequestSchema: GenMessage<GeocodeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 654);

/**
 * @generated from message zdc.GeocodeResponse
 */
export type GeocodeResponse = Message<"zdc.GeocodeResponse"> & {
  /**
   * @generated from field: double lat = 1;
   */
  lat: number;

  /**
   * @generated from field: double lon = 2;
   */
  lon: number;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;
};

/**
 * Describes the message zdc.GeocodeResponse.
 * Use `create(GeocodeResponseSchema)` to create a new message.
 */
export const GeocodeResponseSchema: GenMessage<GeocodeResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 655);

/**
 * Обратный геокодинг (координаты → адрес).
 *
 * @generated from message zdc.ReverseGeocodeRequest
 */
export type ReverseGeocodeRequest = Message<"zdc.ReverseGeocodeRequest"> & {
  /**
   * @generated from field: double lat = 1;
   */
  lat: number;

  /**
   * @generated from field: double lon = 2;
   */
  lon: number;
};

/**
 * Describes the message zdc.ReverseGeocodeRequest.
 * Use `create(ReverseGeocodeRequestSchema)` to create a new message.
 */
export const ReverseGeocodeRequestSchema: GenMessage<ReverseGeocodeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 656);

/**
 * @generated from message zdc.ReverseGeocodeResponse
 */
export type ReverseGeocodeResponse = Message<"zdc.ReverseGeocodeResponse"> & {
  /**
   * @generated from field: string address = 1;
   */
  address: string;
};

/**
 * Describes the message zdc.ReverseGeocodeResponse.
 * Use `create(ReverseGeocodeResponseSchema)` to create a new message.
 */
export const ReverseGeocodeResponseSchema: GenMessage<ReverseGeocodeResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 657);

/**
 * @generated from message zdc.AddressSuggestion
 */
export type AddressSuggestion = Message<"zdc.AddressSuggestion"> & {
  /**
   * адрес одной строкой
   *
   * @generated from field: string value = 1;
   */
  value: string;

  /**
   * полный (с индексом)
   *
   * @generated from field: string unrestricted_value = 2;
   */
  unrestrictedValue: string;

  /**
   * @generated from field: string postal_code = 3;
   */
  postalCode: string;

  /**
   * @generated from field: string country = 4;
   */
  country: string;

  /**
   * @generated from field: string country_iso_code = 5;
   */
  countryIsoCode: string;

  /**
   * @generated from field: string region = 6;
   */
  region: string;

  /**
   * 'г' | 'обл' | 'край' | 'респ'
   *
   * @generated from field: string region_type = 7;
   */
  regionType: string;

  /**
   * 'город' | 'область' | ...
   *
   * @generated from field: string region_type_full = 8;
   */
  regionTypeFull: string;

  /**
   * @generated from field: string region_with_type = 9;
   */
  regionWithType: string;

  /**
   * @generated from field: string area = 10;
   */
  area: string;

  /**
   * @generated from field: string area_with_type = 11;
   */
  areaWithType: string;

  /**
   * @generated from field: string city = 12;
   */
  city: string;

  /**
   * @generated from field: string city_type = 13;
   */
  cityType: string;

  /**
   * @generated from field: string city_with_type = 14;
   */
  cityWithType: string;

  /**
   * @generated from field: string city_district = 15;
   */
  cityDistrict: string;

  /**
   * @generated from field: string settlement = 16;
   */
  settlement: string;

  /**
   * @generated from field: string settlement_with_type = 17;
   */
  settlementWithType: string;

  /**
   * @generated from field: string street = 18;
   */
  street: string;

  /**
   * 'ул' | 'пр-кт' | 'б-р'
   *
   * @generated from field: string street_type = 19;
   */
  streetType: string;

  /**
   * @generated from field: string street_with_type = 20;
   */
  streetWithType: string;

  /**
   * @generated from field: string house = 21;
   */
  house: string;

  /**
   * @generated from field: string house_type = 22;
   */
  houseType: string;

  /**
   * корпус/строение
   *
   * @generated from field: string block = 23;
   */
  block: string;

  /**
   * @generated from field: string block_type = 24;
   */
  blockType: string;

  /**
   * @generated from field: string flat = 25;
   */
  flat: string;

  /**
   * @generated from field: string flat_type = 26;
   */
  flatType: string;

  /**
   * @generated from field: double geo_lat = 27;
   */
  geoLat: number;

  /**
   * @generated from field: double geo_lon = 28;
   */
  geoLon: number;

  /**
   * @generated from field: string qc_geo = 29;
   */
  qcGeo: string;

  /**
   * @generated from field: string fias_id = 30;
   */
  fiasId: string;

  /**
   * @generated from field: string kladr_id = 31;
   */
  kladrId: string;
};

/**
 * Describes the message zdc.AddressSuggestion.
 * Use `create(AddressSuggestionSchema)` to create a new message.
 */
export const AddressSuggestionSchema: GenMessage<AddressSuggestion> = /*@__PURE__*/
  messageDesc(file_zdc, 658);

/**
 * @generated from message zdc.SuggestAddressRequest
 */
export type SuggestAddressRequest = Message<"zdc.SuggestAddressRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * 1..20, по умолчанию 10
   *
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * Describes the message zdc.SuggestAddressRequest.
 * Use `create(SuggestAddressRequestSchema)` to create a new message.
 */
export const SuggestAddressRequestSchema: GenMessage<SuggestAddressRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 659);

/**
 * @generated from message zdc.SuggestAddressResponse
 */
export type SuggestAddressResponse = Message<"zdc.SuggestAddressResponse"> & {
  /**
   * @generated from field: repeated zdc.AddressSuggestion items = 1;
   */
  items: AddressSuggestion[];
};

/**
 * Describes the message zdc.SuggestAddressResponse.
 * Use `create(SuggestAddressResponseSchema)` to create a new message.
 */
export const SuggestAddressResponseSchema: GenMessage<SuggestAddressResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 660);

/**
 * @generated from message zdc.FindPartyRequest
 */
export type FindPartyRequest = Message<"zdc.FindPartyRequest"> & {
  /**
   * @generated from field: string inn = 1;
   */
  inn: string;
};

/**
 * Describes the message zdc.FindPartyRequest.
 * Use `create(FindPartyRequestSchema)` to create a new message.
 */
export const FindPartyRequestSchema: GenMessage<FindPartyRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 661);

/**
 * @generated from message zdc.PartyInfo
 */
export type PartyInfo = Message<"zdc.PartyInfo"> & {
  /**
   * @generated from field: string inn = 1;
   */
  inn: string;

  /**
   * 'legal' | 'individual'
   *
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * краткое (ИП — ФИО)
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string full_name = 4;
   */
  fullName: string;

  /**
   * 'active' | 'liquidating' | 'liquidated' | 'reorganizing' | 'unknown'
   *
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: string kpp = 6;
   */
  kpp: string;

  /**
   * @generated from field: string ogrn = 7;
   */
  ogrn: string;

  /**
   * @generated from field: string address = 8;
   */
  address: string;

  /**
   * найдено в ЕГРЮЛ/ЕГРИП
   *
   * @generated from field: bool found = 9;
   */
  found: boolean;
};

/**
 * Describes the message zdc.PartyInfo.
 * Use `create(PartyInfoSchema)` to create a new message.
 */
export const PartyInfoSchema: GenMessage<PartyInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 662);

/**
 * @generated from message zdc.CleanNameRequest
 */
export type CleanNameRequest = Message<"zdc.CleanNameRequest"> & {
  /**
   * @generated from field: string fio = 1;
   */
  fio: string;
};

/**
 * Describes the message zdc.CleanNameRequest.
 * Use `create(CleanNameRequestSchema)` to create a new message.
 */
export const CleanNameRequestSchema: GenMessage<CleanNameRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 663);

/**
 * @generated from message zdc.CleanNameResponse
 */
export type CleanNameResponse = Message<"zdc.CleanNameResponse"> & {
  /**
   * нормализованное ФИО
   *
   * @generated from field: string result = 1;
   */
  result: string;

  /**
   * @generated from field: string surname = 2;
   */
  surname: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string patronymic = 4;
   */
  patronymic: string;

  /**
   * 'М' | 'Ж' | ''
   *
   * @generated from field: string gender = 5;
   */
  gender: string;
};

/**
 * Describes the message zdc.CleanNameResponse.
 * Use `create(CleanNameResponseSchema)` to create a new message.
 */
export const CleanNameResponseSchema: GenMessage<CleanNameResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 664);

/**
 * @generated from message zdc.CleanPhoneRequest
 */
export type CleanPhoneRequest = Message<"zdc.CleanPhoneRequest"> & {
  /**
   * @generated from field: string phone = 1;
   */
  phone: string;
};

/**
 * Describes the message zdc.CleanPhoneRequest.
 * Use `create(CleanPhoneRequestSchema)` to create a new message.
 */
export const CleanPhoneRequestSchema: GenMessage<CleanPhoneRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 665);

/**
 * @generated from message zdc.CleanPhoneResponse
 */
export type CleanPhoneResponse = Message<"zdc.CleanPhoneResponse"> & {
  /**
   * нормализованный +7…
   *
   * @generated from field: string result = 1;
   */
  result: string;

  /**
   * @generated from field: string country = 2;
   */
  country: string;

  /**
   * @generated from field: string region = 3;
   */
  region: string;

  /**
   * @generated from field: string provider = 4;
   */
  provider: string;

  /**
   * 'valid' | 'invalid' | 'unknown'
   *
   * @generated from field: string validity = 5;
   */
  validity: string;

  /**
   * @generated from field: string qc = 6;
   */
  qc: string;
};

/**
 * Describes the message zdc.CleanPhoneResponse.
 * Use `create(CleanPhoneResponseSchema)` to create a new message.
 */
export const CleanPhoneResponseSchema: GenMessage<CleanPhoneResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 666);

/**
 * @generated from message zdc.CleanPassportRequest
 */
export type CleanPassportRequest = Message<"zdc.CleanPassportRequest"> & {
  /**
   * @generated from field: string series = 1;
   */
  series: string;

  /**
   * @generated from field: string number = 2;
   */
  number: string;
};

/**
 * Describes the message zdc.CleanPassportRequest.
 * Use `create(CleanPassportRequestSchema)` to create a new message.
 */
export const CleanPassportRequestSchema: GenMessage<CleanPassportRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 667);

/**
 * @generated from message zdc.CleanPassportResponse
 */
export type CleanPassportResponse = Message<"zdc.CleanPassportResponse"> & {
  /**
   * @generated from field: string series = 1;
   */
  series: string;

  /**
   * @generated from field: string number = 2;
   */
  number: string;

  /**
   * @generated from field: string qc = 3;
   */
  qc: string;

  /**
   * 'valid' | 'invalid' | 'not_found' | 'unknown'
   *
   * @generated from field: string verified = 4;
   */
  verified: string;

  /**
   * текст проверки
   *
   * @generated from field: string detail = 5;
   */
  detail: string;
};

/**
 * Describes the message zdc.CleanPassportResponse.
 * Use `create(CleanPassportResponseSchema)` to create a new message.
 */
export const CleanPassportResponseSchema: GenMessage<CleanPassportResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 668);

/**
 * Создание/поиск иерархии адреса из подсказки (универсальный механизм:
 * конфигурация иерархии — настройка базы address_hierarchy, задаётся поставкой).
 *
 * @generated from message zdc.ResolveAddressSuggestionRequest
 */
export type ResolveAddressSuggestionRequest = Message<"zdc.ResolveAddressSuggestionRequest"> & {
  /**
   * @generated from field: zdc.AddressSuggestion suggestion = 1;
   */
  suggestion?: AddressSuggestion | undefined;
};

/**
 * Describes the message zdc.ResolveAddressSuggestionRequest.
 * Use `create(ResolveAddressSuggestionRequestSchema)` to create a new message.
 */
export const ResolveAddressSuggestionRequestSchema: GenMessage<ResolveAddressSuggestionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 669);

/**
 * @generated from message zdc.ResolveAddressSuggestionResponse
 */
export type ResolveAddressSuggestionResponse = Message<"zdc.ResolveAddressSuggestionResponse"> & {
  /**
   * @generated from field: string address_id = 1;
   */
  addressId: string;

  /**
   * @generated from field: string address_name = 2;
   */
  addressName: string;
};

/**
 * Describes the message zdc.ResolveAddressSuggestionResponse.
 * Use `create(ResolveAddressSuggestionResponseSchema)` to create a new message.
 */
export const ResolveAddressSuggestionResponseSchema: GenMessage<ResolveAddressSuggestionResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 670);

/**
 * Распознавание речи (STT): транскрибация аудио-файла (id из FileService)
 * в текст. Результат — ТОЛЬКО вызывающему (личная транскрибация).
 *
 * @generated from message zdc.TranscribeAudioRequest
 */
export type TranscribeAudioRequest = Message<"zdc.TranscribeAudioRequest"> & {
  /**
   * id файла (uploadFile → FileInfo.id)
   *
   * @generated from field: string file_id = 1;
   */
  fileId: string;
};

/**
 * Describes the message zdc.TranscribeAudioRequest.
 * Use `create(TranscribeAudioRequestSchema)` to create a new message.
 */
export const TranscribeAudioRequestSchema: GenMessage<TranscribeAudioRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 671);

/**
 * Слово расшифровки с метками времени (мс от начала записи) — переход по
 * слову в плеере. Список пуст, если провайдер не отдаёт пословных меток
 * (фейковые метки не создаются).
 *
 * @generated from message zdc.TranscriptWord
 */
export type TranscriptWord = Message<"zdc.TranscriptWord"> & {
  /**
   * слово (как вернул провайдер, с пробелами)
   *
   * @generated from field: string word = 1;
   */
  word: string;

  /**
   * начало, миллисекунды
   *
   * @generated from field: int64 start_ms = 2;
   */
  startMs: bigint;

  /**
   * конец, миллисекунды
   *
   * @generated from field: int64 end_ms = 3;
   */
  endMs: bigint;
};

/**
 * Describes the message zdc.TranscriptWord.
 * Use `create(TranscriptWordSchema)` to create a new message.
 */
export const TranscriptWordSchema: GenMessage<TranscriptWord> = /*@__PURE__*/
  messageDesc(file_zdc, 672);

/**
 * @generated from message zdc.TranscriptSegment
 */
export type TranscriptSegment = Message<"zdc.TranscriptSegment"> & {
  /**
   * текст фразы (как вернул провайдер)
   *
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * начало, миллисекунды
   *
   * @generated from field: int64 start_ms = 2;
   */
  startMs: bigint;

  /**
   * конец, миллисекунды
   *
   * @generated from field: int64 end_ms = 3;
   */
  endMs: bigint;
};

/**
 * Describes the message zdc.TranscriptSegment.
 * Use `create(TranscriptSegmentSchema)` to create a new message.
 */
export const TranscriptSegmentSchema: GenMessage<TranscriptSegment> = /*@__PURE__*/
  messageDesc(file_zdc, 673);

/**
 * @generated from message zdc.TranscribeAudioResponse
 */
export type TranscribeAudioResponse = Message<"zdc.TranscribeAudioResponse"> & {
  /**
   * распознанный текст (пусто — речь не распознана)
   *
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * Пословные метки времени (пусто — провайдер не даёт меток; фейковые не создаются).
   *
   * @generated from field: repeated zdc.TranscriptWord words = 2;
   */
  words: TranscriptWord[];

  /**
   * Фразовые сегменты — «главы» расшифровки (пусто — провайдер не даёт).
   *
   * @generated from field: repeated zdc.TranscriptSegment segments = 3;
   */
  segments: TranscriptSegment[];
};

/**
 * Describes the message zdc.TranscribeAudioResponse.
 * Use `create(TranscribeAudioResponseSchema)` to create a new message.
 */
export const TranscribeAudioResponseSchema: GenMessage<TranscribeAudioResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 674);

/**
 * ============================================================
 * UiAgentService — АГЕНТСКИЙ МОСТ (встроенная автоматизация UI desktop):
 *   Eval — выполнить JS в окне (заполнить поля/кликнуть/прочитать, с результатом);
 *   Snapshot — модель активной формы (поля/значения/кнопки/вкладки/текст);
 *   Capture — PNG-скриншот окна (base64).
 * Доступен ТОЛЬКО при флаге HYDRA_CDP_PORT (desktop; патч go-webview2),
 * для desktop-сессий; иначе — явная ошибка. Не для web/PWA/публикаций.
 * ============================================================
 *
 * @generated from message zdc.UiAgentEvalRequest
 */
export type UiAgentEvalRequest = Message<"zdc.UiAgentEvalRequest"> & {
  /**
   * @generated from field: string js = 1;
   */
  js: string;
};

/**
 * Describes the message zdc.UiAgentEvalRequest.
 * Use `create(UiAgentEvalRequestSchema)` to create a new message.
 */
export const UiAgentEvalRequestSchema: GenMessage<UiAgentEvalRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 675);

/**
 * @generated from message zdc.UiAgentEvalResponse
 */
export type UiAgentEvalResponse = Message<"zdc.UiAgentEvalResponse"> & {
  /**
   * JSON-строка результата (или значение)
   *
   * @generated from field: string result = 1;
   */
  result: string;
};

/**
 * Describes the message zdc.UiAgentEvalResponse.
 * Use `create(UiAgentEvalResponseSchema)` to create a new message.
 */
export const UiAgentEvalResponseSchema: GenMessage<UiAgentEvalResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 676);

/**
 * @generated from message zdc.UiAgentSnapshotRequest
 */
export type UiAgentSnapshotRequest = Message<"zdc.UiAgentSnapshotRequest"> & {
};

/**
 * Describes the message zdc.UiAgentSnapshotRequest.
 * Use `create(UiAgentSnapshotRequestSchema)` to create a new message.
 */
export const UiAgentSnapshotRequestSchema: GenMessage<UiAgentSnapshotRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 677);

/**
 * @generated from message zdc.UiAgentSnapshotResponse
 */
export type UiAgentSnapshotResponse = Message<"zdc.UiAgentSnapshotResponse"> & {
  /**
   * JSON-модель формы (URL/поля/кнопки/вкладки/текст)
   *
   * @generated from field: string snapshot = 1;
   */
  snapshot: string;
};

/**
 * Describes the message zdc.UiAgentSnapshotResponse.
 * Use `create(UiAgentSnapshotResponseSchema)` to create a new message.
 */
export const UiAgentSnapshotResponseSchema: GenMessage<UiAgentSnapshotResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 678);

/**
 * @generated from message zdc.UiAgentCaptureRequest
 */
export type UiAgentCaptureRequest = Message<"zdc.UiAgentCaptureRequest"> & {
};

/**
 * Describes the message zdc.UiAgentCaptureRequest.
 * Use `create(UiAgentCaptureRequestSchema)` to create a new message.
 */
export const UiAgentCaptureRequestSchema: GenMessage<UiAgentCaptureRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 679);

/**
 * @generated from message zdc.UiAgentCaptureResponse
 */
export type UiAgentCaptureResponse = Message<"zdc.UiAgentCaptureResponse"> & {
  /**
   * PNG
   *
   * @generated from field: string data_base64 = 1;
   */
  dataBase64: string;
};

/**
 * Describes the message zdc.UiAgentCaptureResponse.
 * Use `create(UiAgentCaptureResponseSchema)` to create a new message.
 */
export const UiAgentCaptureResponseSchema: GenMessage<UiAgentCaptureResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 680);

/**
 * @generated from message zdc.UiAgentDragEvent
 */
export type UiAgentDragEvent = Message<"zdc.UiAgentDragEvent"> & {
  /**
   * 'dragEnter' | 'dragOver' | 'drop' | 'dragCancel'
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: double x = 2;
   */
  x: number;

  /**
   * @generated from field: double y = 3;
   */
  y: number;

  /**
   * данные перетаскивания (mimeType -> data)
   *
   * @generated from field: repeated zdc.UiAgentDragData data = 4;
   */
  data: UiAgentDragData[];
};

/**
 * Describes the message zdc.UiAgentDragEvent.
 * Use `create(UiAgentDragEventSchema)` to create a new message.
 */
export const UiAgentDragEventSchema: GenMessage<UiAgentDragEvent> = /*@__PURE__*/
  messageDesc(file_zdc, 681);

/**
 * @generated from message zdc.UiAgentDragData
 */
export type UiAgentDragData = Message<"zdc.UiAgentDragData"> & {
  /**
   * @generated from field: string mime_type = 1;
   */
  mimeType: string;

  /**
   * @generated from field: string data = 2;
   */
  data: string;
};

/**
 * Describes the message zdc.UiAgentDragData.
 * Use `create(UiAgentDragDataSchema)` to create a new message.
 */
export const UiAgentDragDataSchema: GenMessage<UiAgentDragData> = /*@__PURE__*/
  messageDesc(file_zdc, 682);

/**
 * @generated from message zdc.UiAgentDragRequest
 */
export type UiAgentDragRequest = Message<"zdc.UiAgentDragRequest"> & {
  /**
   * НАЧАЛО перетаскивания: mousedown на источнике (CDP требует drag-сессию)
   *
   * @generated from field: double source_x = 1;
   */
  sourceX: number;

  /**
   * @generated from field: double source_y = 2;
   */
  sourceY: number;

  /**
   * последовательность (dragEnter -> dragOver -> drop)
   *
   * @generated from field: repeated zdc.UiAgentDragEvent events = 3;
   */
  events: UiAgentDragEvent[];
};

/**
 * Describes the message zdc.UiAgentDragRequest.
 * Use `create(UiAgentDragRequestSchema)` to create a new message.
 */
export const UiAgentDragRequestSchema: GenMessage<UiAgentDragRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 683);

/**
 * @generated from message zdc.UiAgentDragResponse
 */
export type UiAgentDragResponse = Message<"zdc.UiAgentDragResponse"> & {
};

/**
 * Describes the message zdc.UiAgentDragResponse.
 * Use `create(UiAgentDragResponseSchema)` to create a new message.
 */
export const UiAgentDragResponseSchema: GenMessage<UiAgentDragResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 684);

/**
 * ============================================================
 * GeoService — ЕДИНЫЙ ГЕО-ШОВ платформы (провайдер-агностик):
 *   локальный кэш («Адреса» + иерархия) → роутер провайдеров
 *   (capability «geo»: dadata/osm/ГАР) → нормализованный ответ с источником.
 *   В закрытом контуре (closed/airgap) внешние провайдеры исключены роутером:
 *   подсказки отдаются из локального кэша (source="local_cache"), при промахе —
 *   явная ошибка NotFound (наружу НЕ ходим). Все ответы несут source/cached.
 *   Поля подсказок — нормализованные (AddressSuggestion), как в DaData.
 * ============================================================
 *
 * @generated from message zdc.GeoSuggestResponse
 */
export type GeoSuggestResponse = Message<"zdc.GeoSuggestResponse"> & {
  /**
   * @generated from field: repeated zdc.AddressSuggestion items = 1;
   */
  items: AddressSuggestion[];

  /**
   * "local_cache" | "provider:<имя>"
   *
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * имя провайдера (пусто — результат из локального кэша)
   *
   * @generated from field: string provider = 3;
   */
  provider: string;

  /**
   * true — результат кэша (справочники/память)
   *
   * @generated from field: bool cached = 4;
   */
  cached: boolean;
};

/**
 * Describes the message zdc.GeoSuggestResponse.
 * Use `create(GeoSuggestResponseSchema)` to create a new message.
 */
export const GeoSuggestResponseSchema: GenMessage<GeoSuggestResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 685);

/**
 * @generated from message zdc.GeoPartyResponse
 */
export type GeoPartyResponse = Message<"zdc.GeoPartyResponse"> & {
  /**
   * @generated from field: zdc.PartyInfo party = 1;
   */
  party?: PartyInfo | undefined;

  /**
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * @generated from field: string provider = 3;
   */
  provider: string;
};

/**
 * Describes the message zdc.GeoPartyResponse.
 * Use `create(GeoPartyResponseSchema)` to create a new message.
 */
export const GeoPartyResponseSchema: GenMessage<GeoPartyResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 686);

/**
 * @generated from message zdc.GeoGeocodeRequest
 */
export type GeoGeocodeRequest = Message<"zdc.GeoGeocodeRequest"> & {
  /**
   * @generated from field: string address = 1;
   */
  address: string;
};

/**
 * Describes the message zdc.GeoGeocodeRequest.
 * Use `create(GeoGeocodeRequestSchema)` to create a new message.
 */
export const GeoGeocodeRequestSchema: GenMessage<GeoGeocodeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 687);

/**
 * @generated from message zdc.GeoGeocodeResponse
 */
export type GeoGeocodeResponse = Message<"zdc.GeoGeocodeResponse"> & {
  /**
   * @generated from field: double lat = 1;
   */
  lat: number;

  /**
   * @generated from field: double lon = 2;
   */
  lon: number;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * "provider:<имя>"
   *
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * @generated from field: string provider = 5;
   */
  provider: string;
};

/**
 * Describes the message zdc.GeoGeocodeResponse.
 * Use `create(GeoGeocodeResponseSchema)` to create a new message.
 */
export const GeoGeocodeResponseSchema: GenMessage<GeoGeocodeResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 688);

/**
 * @generated from message zdc.GeoReverseResponse
 */
export type GeoReverseResponse = Message<"zdc.GeoReverseResponse"> & {
  /**
   * @generated from field: zdc.AddressSuggestion address = 1;
   */
  address?: AddressSuggestion | undefined;

  /**
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * @generated from field: string provider = 3;
   */
  provider: string;
};

/**
 * Describes the message zdc.GeoReverseResponse.
 * Use `create(GeoReverseResponseSchema)` to create a new message.
 */
export const GeoReverseResponseSchema: GenMessage<GeoReverseResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 689);

/**
 * @generated from message zdc.GeoResolveResponse
 */
export type GeoResolveResponse = Message<"zdc.GeoResolveResponse"> & {
  /**
   * @generated from field: string address_id = 1;
   */
  addressId: string;

  /**
   * @generated from field: string address_name = 2;
   */
  addressName: string;

  /**
   * "local_cache" (write-through в справочники)
   *
   * @generated from field: string source = 3;
   */
  source: string;

  /**
   * @generated from field: bool cached = 4;
   */
  cached: boolean;
};

/**
 * Describes the message zdc.GeoResolveResponse.
 * Use `create(GeoResolveResponseSchema)` to create a new message.
 */
export const GeoResolveResponseSchema: GenMessage<GeoResolveResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 690);

/**
 * @generated from message zdc.Conversation
 */
export type Conversation = Message<"zdc.Conversation"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 'direct' | 'group'
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * группа; direct — имя собеседника (клиент) 
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: repeated string member_ids = 4;
   */
  memberIds: string[];

  /**
   * @generated from field: repeated string member_names = 5;
   */
  memberNames: string[];

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;

  /**
   * @generated from field: string last_message_at = 7;
   */
  lastMessageAt: string;

  /**
   * Последнее сообщение (для списка чатов)
   *
   * @generated from field: string last_message_text = 8;
   */
  lastMessageText: string;

  /**
   * @generated from field: string last_message_from = 9;
   */
  lastMessageFrom: string;

  /**
   * @generated from field: int32 unread_count = 10;
   */
  unreadCount: number;

  /**
   * Пресенс участников: id → last_seen_at (SSoT — сервер; «онлайн»/«был(а)…»)
   *
   * @generated from field: map<string, string> member_last_seen = 11;
   */
  memberLastSeen: { [key: string]: string };

  /**
   * Контекстное обсуждение: привязка чата к объекту платформы
   * (context_type = тип объекта, context_code = код объекта метаданных
   * (для настроек обсуждения), context_id = id записи; один чат на объект)
   *
   * @generated from field: string context_type = 12;
   */
  contextType: string;

  /**
   * @generated from field: string context_code = 13;
   */
  contextCode: string;

  /**
   * @generated from field: string context_id = 14;
   */
  contextId: string;

  /**
   * Непрочитанные УПОМИНАНИЯ текущего пользователя в этом чате (разбор @ на
   * сервере при отправке; счётчик — производный от read_by). Сбрасывается при
   * MarkConversationRead вместе с обычным непрочитанным.
   *
   * @generated from field: int32 mention_count = 15;
   */
  mentionCount: number;

  /**
   * Создатель чата («админ чата»): управляет участниками и названием группы;
   * глобальный администратор может всё. Отдельных ролей участников пока нет
   * (SetMemberRole — задел модели).
   *
   * @generated from field: string created_by = 16;
   */
  createdBy: string;
};

/**
 * Describes the message zdc.Conversation.
 * Use `create(ConversationSchema)` to create a new message.
 */
export const ConversationSchema: GenMessage<Conversation> = /*@__PURE__*/
  messageDesc(file_zdc, 691);

/**
 * @generated from message zdc.ListConversationsRequest
 */
export type ListConversationsRequest = Message<"zdc.ListConversationsRequest"> & {
  /**
   * Фильтр по контексту (пустые оба = ВСЕ чаты пользователя)
   *
   * @generated from field: string context_type = 1;
   */
  contextType: string;

  /**
   * @generated from field: string context_id = 2;
   */
  contextId: string;
};

/**
 * Describes the message zdc.ListConversationsRequest.
 * Use `create(ListConversationsRequestSchema)` to create a new message.
 */
export const ListConversationsRequestSchema: GenMessage<ListConversationsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 692);

/**
 * @generated from message zdc.ListConversationsResponse
 */
export type ListConversationsResponse = Message<"zdc.ListConversationsResponse"> & {
  /**
   * @generated from field: repeated zdc.Conversation items = 1;
   */
  items: Conversation[];
};

/**
 * Describes the message zdc.ListConversationsResponse.
 * Use `create(ListConversationsResponseSchema)` to create a new message.
 */
export const ListConversationsResponseSchema: GenMessage<ListConversationsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 693);

/**
 * @generated from message zdc.GetConversationRequest
 */
export type GetConversationRequest = Message<"zdc.GetConversationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetConversationRequest.
 * Use `create(GetConversationRequestSchema)` to create a new message.
 */
export const GetConversationRequestSchema: GenMessage<GetConversationRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 694);

/**
 * @generated from message zdc.GetConversationResponse
 */
export type GetConversationResponse = Message<"zdc.GetConversationResponse"> & {
  /**
   * @generated from field: zdc.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;
};

/**
 * Describes the message zdc.GetConversationResponse.
 * Use `create(GetConversationResponseSchema)` to create a new message.
 */
export const GetConversationResponseSchema: GenMessage<GetConversationResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 695);

/**
 * @generated from message zdc.CreateConversationRequest
 */
export type CreateConversationRequest = Message<"zdc.CreateConversationRequest"> & {
  /**
   * 'direct' | 'group'
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * для group (пусто = автоген «Чат N»)
   *
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * участники (без текущего — добавляется сам)
   *
   * @generated from field: repeated string member_ids = 3;
   */
  memberIds: string[];

  /**
   * Контекстное обсуждение (kind='group'; один чат на объект — повторный
   * вызов с тем же контекстом возвращает существующий). context_code — код
   * объекта метаданных (для настроек обсуждения).
   *
   * @generated from field: string context_type = 4;
   */
  contextType: string;

  /**
   * @generated from field: string context_code = 5;
   */
  contextCode: string;

  /**
   * @generated from field: string context_id = 6;
   */
  contextId: string;
};

/**
 * Describes the message zdc.CreateConversationRequest.
 * Use `create(CreateConversationRequestSchema)` to create a new message.
 */
export const CreateConversationRequestSchema: GenMessage<CreateConversationRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 696);

/**
 * @generated from message zdc.CreateConversationResponse
 */
export type CreateConversationResponse = Message<"zdc.CreateConversationResponse"> & {
  /**
   * @generated from field: zdc.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;
};

/**
 * Describes the message zdc.CreateConversationResponse.
 * Use `create(CreateConversationResponseSchema)` to create a new message.
 */
export const CreateConversationResponseSchema: GenMessage<CreateConversationResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 697);

/**
 * «Пригласить» в обсуждение/чат: добавление участника (создатель/любой участник
 * группы; direct — по создателю). Уже участник — NotFound? Нет — идемпотентно
 * возвращает успех (участник уже в чате).
 *
 * @generated from message zdc.AddConversationMemberRequest
 */
export type AddConversationMemberRequest = Message<"zdc.AddConversationMemberRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * пользователь (entities.id)
   *
   * @generated from field: string member_id = 2;
   */
  memberId: string;
};

/**
 * Describes the message zdc.AddConversationMemberRequest.
 * Use `create(AddConversationMemberRequestSchema)` to create a new message.
 */
export const AddConversationMemberRequestSchema: GenMessage<AddConversationMemberRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 698);

/**
 * @generated from message zdc.AddConversationMemberResponse
 */
export type AddConversationMemberResponse = Message<"zdc.AddConversationMemberResponse"> & {
  /**
   * @generated from field: zdc.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;
};

/**
 * Describes the message zdc.AddConversationMemberResponse.
 * Use `create(AddConversationMemberResponseSchema)` to create a new message.
 */
export const AddConversationMemberResponseSchema: GenMessage<AddConversationMemberResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 699);

/**
 * Удаление участника из группы: право — создатель чата или глобальный
 * администратор; создателя удалить нельзя (FailedPrecondition); для выхода
 * используйте LeaveConversation. Повторное удаление не-участника идемпотентно.
 * Событие chat.conversation.updated.{convId} + уведомление удалённому.
 *
 * @generated from message zdc.RemoveConversationMemberRequest
 */
export type RemoveConversationMemberRequest = Message<"zdc.RemoveConversationMemberRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string member_id = 2;
   */
  memberId: string;
};

/**
 * Describes the message zdc.RemoveConversationMemberRequest.
 * Use `create(RemoveConversationMemberRequestSchema)` to create a new message.
 */
export const RemoveConversationMemberRequestSchema: GenMessage<RemoveConversationMemberRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 700);

/**
 * @generated from message zdc.RemoveConversationMemberResponse
 */
export type RemoveConversationMemberResponse = Message<"zdc.RemoveConversationMemberResponse"> & {
  /**
   * @generated from field: zdc.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;
};

/**
 * Describes the message zdc.RemoveConversationMemberResponse.
 * Use `create(RemoveConversationMemberResponseSchema)` to create a new message.
 */
export const RemoveConversationMemberResponseSchema: GenMessage<RemoveConversationMemberResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 701);

/**
 * Выход из группового чата. Создатель выходит — права создателя переходят
 * ПЕРВОМУ оставшемуся участнику (детерминированно); последний участник выйти
 * не может (группа не остаётся пустой). Личный диалог покинуть нельзя.
 *
 * @generated from message zdc.LeaveConversationRequest
 */
export type LeaveConversationRequest = Message<"zdc.LeaveConversationRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;
};

/**
 * Describes the message zdc.LeaveConversationRequest.
 * Use `create(LeaveConversationRequestSchema)` to create a new message.
 */
export const LeaveConversationRequestSchema: GenMessage<LeaveConversationRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 702);

/**
 * @generated from message zdc.LeaveConversationResponse
 */
export type LeaveConversationResponse = Message<"zdc.LeaveConversationResponse"> & {
  /**
   * @generated from field: zdc.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;
};

/**
 * Describes the message zdc.LeaveConversationResponse.
 * Use `create(LeaveConversationResponseSchema)` to create a new message.
 */
export const LeaveConversationResponseSchema: GenMessage<LeaveConversationResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 703);

/**
 * Переименование группы (создатель чата или администратор; direct — нельзя).
 * Название обязательно, до 200 символов.
 *
 * @generated from message zdc.SetConversationTitleRequest
 */
export type SetConversationTitleRequest = Message<"zdc.SetConversationTitleRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;
};

/**
 * Describes the message zdc.SetConversationTitleRequest.
 * Use `create(SetConversationTitleRequestSchema)` to create a new message.
 */
export const SetConversationTitleRequestSchema: GenMessage<SetConversationTitleRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 704);

/**
 * @generated from message zdc.SetConversationTitleResponse
 */
export type SetConversationTitleResponse = Message<"zdc.SetConversationTitleResponse"> & {
  /**
   * @generated from field: zdc.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;
};

/**
 * Describes the message zdc.SetConversationTitleResponse.
 * Use `create(SetConversationTitleResponseSchema)` to create a new message.
 */
export const SetConversationTitleResponseSchema: GenMessage<SetConversationTitleResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 705);

/**
 * @generated from message zdc.ChatMessage
 */
export type ChatMessage = Message<"zdc.ChatMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string conversation_id = 2;
   */
  conversationId: string;

  /**
   * @generated from field: string sender_id = 3;
   */
  senderId: string;

  /**
   * @generated from field: string sender_name = 4;
   */
  senderName: string;

  /**
   * @generated from field: string text = 5;
   */
  text: string;

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;

  /**
   * @generated from field: repeated string read_by = 7;
   */
  readBy: string[];

  /**
   * Помечено на удаление «у всех» (deleted_at задан): админ видит is_deleted=true
   * (выделяется); обычный участник видит плейсхолдер «Сообщение удалено».
   *
   * @generated from field: bool is_deleted = 8;
   */
  isDeleted: boolean;

  /**
   * Вложения (файлы, SSoT: имена/размеры резолвит сервер из files по id)
   *
   * @generated from field: repeated zdc.FileRef attachments = 9;
   */
  attachments: FileRef[];

  /**
   * Ответ на сообщение (id исходного; клиент рендерит цитату)
   *
   * @generated from field: string reply_to = 10;
   */
  replyTo: string;

  /**
   * Реакции: [{emoji, user_id}] — бейджи под сообщением
   *
   * @generated from field: repeated zdc.MessageReaction reactions = 11;
   */
  reactions: MessageReaction[];

  /**
   * Отметка «изменено» (D2): момент последней правки; пусто — не редактировалось.
   *
   * @generated from field: string edited_at = 12;
   */
  editedAt: string;

  /**
   * История правок (D2): прежние версии текста (до 10), новые в конце.
   *
   * @generated from field: repeated zdc.ChatMessageEdit edit_history = 13;
   */
  editHistory: ChatMessageEdit[];

  /**
   * Число ответов треда (D3): «N ответов» под сообщением (0 — нет).
   *
   * @generated from field: int32 reply_count = 14;
   */
  replyCount: number;

  /**
   * Закреплено в чате (D6): правая панель «Закреплённые» (закрепить/снять —
   * PinMessage; событие chat.message.pinned.{convId}).
   *
   * @generated from field: bool is_pinned = 15;
   */
  isPinned: boolean;

  /**
   * Упоминания @ (SSoT разбора — сервер): только УЧАСТНИКИ чата, найденные по
   * login (регистронезависимо); @все/@all — все остальные участники.
   *
   * @generated from field: repeated zdc.ChatMention mentions = 16;
   */
  mentions: ChatMention[];
};

/**
 * Describes the message zdc.ChatMessage.
 * Use `create(ChatMessageSchema)` to create a new message.
 */
export const ChatMessageSchema: GenMessage<ChatMessage> = /*@__PURE__*/
  messageDesc(file_zdc, 706);

/**
 * Упоминание пользователя в сообщении (@login); сервер сохраняет разрешённых
 * участников — клиент подсвечивает их в тексте.
 *
 * @generated from message zdc.ChatMention
 */
export type ChatMention = Message<"zdc.ChatMention"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string login = 2;
   */
  login: string;
};

/**
 * Describes the message zdc.ChatMention.
 * Use `create(ChatMentionSchema)` to create a new message.
 */
export const ChatMentionSchema: GenMessage<ChatMention> = /*@__PURE__*/
  messageDesc(file_zdc, 707);

/**
 * Версия текста сообщения (история редактирования; D2).
 *
 * @generated from message zdc.ChatMessageEdit
 */
export type ChatMessageEdit = Message<"zdc.ChatMessageEdit"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: string edited_at = 2;
   */
  editedAt: string;
};

/**
 * Describes the message zdc.ChatMessageEdit.
 * Use `create(ChatMessageEditSchema)` to create a new message.
 */
export const ChatMessageEditSchema: GenMessage<ChatMessageEdit> = /*@__PURE__*/
  messageDesc(file_zdc, 708);

/**
 * @generated from message zdc.FileRef
 */
export type FileRef = Message<"zdc.FileRef"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int64 size = 3;
   */
  size: bigint;

  /**
   * MIME-тип файла (SSoT — сервер, из files.file_type): классификация вложений
   * (audio/* → проигрыватель, video/* → плеер, image/* → превью) без догадок
   * по расширению (webm бывает и голосовым, и видео).
   *
   * @generated from field: string file_type = 4;
   */
  fileType: string;
};

/**
 * Describes the message zdc.FileRef.
 * Use `create(FileRefSchema)` to create a new message.
 */
export const FileRefSchema: GenMessage<FileRef> = /*@__PURE__*/
  messageDesc(file_zdc, 709);

/**
 * Манифест приложения для рабочего клиента (kind='app'; не конфигуратор).
 *
 * @generated from message zdc.GetAppManifestRequest
 */
export type GetAppManifestRequest = Message<"zdc.GetAppManifestRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.GetAppManifestRequest.
 * Use `create(GetAppManifestRequestSchema)` to create a new message.
 */
export const GetAppManifestRequestSchema: GenMessage<GetAppManifestRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 710);

/**
 * @generated from message zdc.MessageReaction
 */
export type MessageReaction = Message<"zdc.MessageReaction"> & {
  /**
   * @generated from field: string emoji = 1;
   */
  emoji: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * Describes the message zdc.MessageReaction.
 * Use `create(MessageReactionSchema)` to create a new message.
 */
export const MessageReactionSchema: GenMessage<MessageReaction> = /*@__PURE__*/
  messageDesc(file_zdc, 711);

/**
 * @generated from message zdc.SendMessageRequest
 */
export type SendMessageRequest = Message<"zdc.SendMessageRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * Клиентский идентификатор (идемпотентность дубликатов при ретраях)
   *
   * @generated from field: string client_ref = 3;
   */
  clientRef: string;

  /**
   * Вложения: id файлов (uploadFile → FileInfo.id); текст = комментарий
   *
   * @generated from field: repeated string attachments = 4;
   */
  attachments: string[];

  /**
   * Ответ на сообщение (id исходного)
   *
   * @generated from field: string reply_to = 5;
   */
  replyTo: string;
};

/**
 * Describes the message zdc.SendMessageRequest.
 * Use `create(SendMessageRequestSchema)` to create a new message.
 */
export const SendMessageRequestSchema: GenMessage<SendMessageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 712);

/**
 * @generated from message zdc.SendMessageResponse
 */
export type SendMessageResponse = Message<"zdc.SendMessageResponse"> & {
  /**
   * @generated from field: zdc.ChatMessage message = 1;
   */
  message?: ChatMessage | undefined;
};

/**
 * Describes the message zdc.SendMessageResponse.
 * Use `create(SendMessageResponseSchema)` to create a new message.
 */
export const SendMessageResponseSchema: GenMessage<SendMessageResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 713);

/**
 * @generated from message zdc.ListMessagesRequest
 */
export type ListMessagesRequest = Message<"zdc.ListMessagesRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * пагинация: сообщения ДО этого времени (RFC3339; пусто = последние)
   *
   * @generated from field: string before_ts = 2;
   */
  beforeTs: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message zdc.ListMessagesRequest.
 * Use `create(ListMessagesRequestSchema)` to create a new message.
 */
export const ListMessagesRequestSchema: GenMessage<ListMessagesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 714);

/**
 * @generated from message zdc.ListMessagesResponse
 */
export type ListMessagesResponse = Message<"zdc.ListMessagesResponse"> & {
  /**
   * @generated from field: repeated zdc.ChatMessage items = 1;
   */
  items: ChatMessage[];
};

/**
 * Describes the message zdc.ListMessagesResponse.
 * Use `create(ListMessagesResponseSchema)` to create a new message.
 */
export const ListMessagesResponseSchema: GenMessage<ListMessagesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 715);

/**
 * @generated from message zdc.MarkConversationReadRequest
 */
export type MarkConversationReadRequest = Message<"zdc.MarkConversationReadRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;
};

/**
 * Describes the message zdc.MarkConversationReadRequest.
 * Use `create(MarkConversationReadRequestSchema)` to create a new message.
 */
export const MarkConversationReadRequestSchema: GenMessage<MarkConversationReadRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 716);

/**
 * Пометка удаления сообщений (soft-delete, как в 1С): scope='self' — скрыть
 * у себя (любой участник); scope='all' — пометить «у всех» (только админ).
 * Физическое удаление — сборкой мусора (план); админ видит помеченные.
 *
 * @generated from message zdc.DeleteMessageRequest
 */
export type DeleteMessageRequest = Message<"zdc.DeleteMessageRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * 'self' | 'all'
   *
   * @generated from field: string scope = 3;
   */
  scope: string;
};

/**
 * Describes the message zdc.DeleteMessageRequest.
 * Use `create(DeleteMessageRequestSchema)` to create a new message.
 */
export const DeleteMessageRequestSchema: GenMessage<DeleteMessageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 717);

/**
 * @generated from message zdc.ClearConversationRequest
 */
export type ClearConversationRequest = Message<"zdc.ClearConversationRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * 'self' | 'all'
   *
   * @generated from field: string scope = 2;
   */
  scope: string;
};

/**
 * Describes the message zdc.ClearConversationRequest.
 * Use `create(ClearConversationRequestSchema)` to create a new message.
 */
export const ClearConversationRequestSchema: GenMessage<ClearConversationRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 718);

/**
 * @generated from message zdc.ReactToMessageRequest
 */
export type ReactToMessageRequest = Message<"zdc.ReactToMessageRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * добавить/убрать мою реакцию
   *
   * @generated from field: string emoji = 3;
   */
  emoji: string;
};

/**
 * Describes the message zdc.ReactToMessageRequest.
 * Use `create(ReactToMessageRequestSchema)` to create a new message.
 */
export const ReactToMessageRequestSchema: GenMessage<ReactToMessageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 719);

/**
 * @generated from message zdc.ForwardMessageRequest
 */
export type ForwardMessageRequest = Message<"zdc.ForwardMessageRequest"> & {
  /**
   * @generated from field: string from_conversation_id = 1;
   */
  fromConversationId: string;

  /**
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * @generated from field: string to_conversation_id = 3;
   */
  toConversationId: string;
};

/**
 * Describes the message zdc.ForwardMessageRequest.
 * Use `create(ForwardMessageRequestSchema)` to create a new message.
 */
export const ForwardMessageRequestSchema: GenMessage<ForwardMessageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 720);

/**
 * @generated from message zdc.GetMessengerSettingsRequest
 */
export type GetMessengerSettingsRequest = Message<"zdc.GetMessengerSettingsRequest"> & {
};

/**
 * Describes the message zdc.GetMessengerSettingsRequest.
 * Use `create(GetMessengerSettingsRequestSchema)` to create a new message.
 */
export const GetMessengerSettingsRequestSchema: GenMessage<GetMessengerSettingsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 721);

/**
 * @generated from message zdc.MessengerSettings
 */
export type MessengerSettings = Message<"zdc.MessengerSettings"> & {
  /**
   * Telegram-бот: включён + токен (SSoT — настройки базы; токен НЕ возвращается
   * обратно — чувствительные данные: клиент только указывает заново)
   *
   * @generated from field: bool telegram_enabled = 1;
   */
  telegramEnabled: boolean;

  /**
   * @generated from field: string telegram_token = 2;
   */
  telegramToken: string;

  /**
   * @generated from field: bool telegram_token_set = 3;
   */
  telegramTokenSet: boolean;
};

/**
 * Describes the message zdc.MessengerSettings.
 * Use `create(MessengerSettingsSchema)` to create a new message.
 */
export const MessengerSettingsSchema: GenMessage<MessengerSettings> = /*@__PURE__*/
  messageDesc(file_zdc, 722);

/**
 * @generated from message zdc.SetMessengerSettingsRequest
 */
export type SetMessengerSettingsRequest = Message<"zdc.SetMessengerSettingsRequest"> & {
  /**
   * @generated from field: bool telegram_enabled = 1;
   */
  telegramEnabled: boolean;

  /**
   * Пусто = не менять (сохранить существующий)
   *
   * @generated from field: string telegram_token = 2;
   */
  telegramToken: string;
};

/**
 * Describes the message zdc.SetMessengerSettingsRequest.
 * Use `create(SetMessengerSettingsRequestSchema)` to create a new message.
 */
export const SetMessengerSettingsRequestSchema: GenMessage<SetMessengerSettingsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 723);

/**
 * Проверка связи с Telegram-ботом: отправляет тестовое сообщение
 * НА ТЕКУЩЕГО пользователя по его каналу связи (entity_channels: telegram).
 *
 * @generated from message zdc.TestTelegramRequest
 */
export type TestTelegramRequest = Message<"zdc.TestTelegramRequest"> & {
};

/**
 * Describes the message zdc.TestTelegramRequest.
 * Use `create(TestTelegramRequestSchema)` to create a new message.
 */
export const TestTelegramRequestSchema: GenMessage<TestTelegramRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 724);

/**
 * Тред: обсуждение под сообщением (D3).
 *
 * @generated from message zdc.ListThreadRequest
 */
export type ListThreadRequest = Message<"zdc.ListThreadRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string root_message_id = 2;
   */
  rootMessageId: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message zdc.ListThreadRequest.
 * Use `create(ListThreadRequestSchema)` to create a new message.
 */
export const ListThreadRequestSchema: GenMessage<ListThreadRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 725);

/**
 * @generated from message zdc.ListThreadResponse
 */
export type ListThreadResponse = Message<"zdc.ListThreadResponse"> & {
  /**
   * @generated from field: repeated zdc.ChatMessage items = 1;
   */
  items: ChatMessage[];
};

/**
 * Describes the message zdc.ListThreadResponse.
 * Use `create(ListThreadResponseSchema)` to create a new message.
 */
export const ListThreadResponseSchema: GenMessage<ListThreadResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 726);

/**
 * Правка сообщения: новый текст (до 4000 символов); удалённое — нельзя.
 *
 * @generated from message zdc.EditMessageRequest
 */
export type EditMessageRequest = Message<"zdc.EditMessageRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * @generated from field: string text = 3;
   */
  text: string;
};

/**
 * Describes the message zdc.EditMessageRequest.
 * Use `create(EditMessageRequestSchema)` to create a new message.
 */
export const EditMessageRequestSchema: GenMessage<EditMessageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 727);

/**
 * Закрепление сообщения (D6): pinned=true — закрепить, false — снять.
 *
 * @generated from message zdc.PinMessageRequest
 */
export type PinMessageRequest = Message<"zdc.PinMessageRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * @generated from field: bool pinned = 3;
   */
  pinned: boolean;
};

/**
 * Describes the message zdc.PinMessageRequest.
 * Use `create(PinMessageRequestSchema)` to create a new message.
 */
export const PinMessageRequestSchema: GenMessage<PinMessageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 728);

/**
 * Закреплённые сообщения чата (D6): новые первыми; offset — страница
 * (limit по умолчанию 50, максимум 100).
 *
 * @generated from message zdc.ListPinnedMessagesRequest
 */
export type ListPinnedMessagesRequest = Message<"zdc.ListPinnedMessagesRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;
};

/**
 * Describes the message zdc.ListPinnedMessagesRequest.
 * Use `create(ListPinnedMessagesRequestSchema)` to create a new message.
 */
export const ListPinnedMessagesRequestSchema: GenMessage<ListPinnedMessagesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 729);

/**
 * @generated from message zdc.ListPinnedMessagesResponse
 */
export type ListPinnedMessagesResponse = Message<"zdc.ListPinnedMessagesResponse"> & {
  /**
   * @generated from field: repeated zdc.ChatMessage items = 1;
   */
  items: ChatMessage[];
};

/**
 * Describes the message zdc.ListPinnedMessagesResponse.
 * Use `create(ListPinnedMessagesResponseSchema)` to create a new message.
 */
export const ListPinnedMessagesResponseSchema: GenMessage<ListPinnedMessagesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 730);

/**
 * Конверсия сообщения чата в заявку/задачу (§2.3, «Object-Centric Chat»):
 *   kind        — 'order' (заявка) или 'task' (задача);
 *   type_code   — код типа заявки/задачи ('' = единственный существующий тип);
 *   title       — переопределение темы ('' = первая строка/фрагмент ≤120);
 *   assignee_id — исполнитель (только kind='task'; пусто = пул задач);
 *   extra       — дополнительные реквизиты создаваемого объекта (пишутся
 *                 только существующие колонки; status_code валидируется по
 *                 статусной схеме типа).
 *
 * @generated from message zdc.ConvertMessageRequest
 */
export type ConvertMessageRequest = Message<"zdc.ConvertMessageRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * @generated from field: string type_code = 4;
   */
  typeCode: string;

  /**
   * @generated from field: string title = 5;
   */
  title: string;

  /**
   * @generated from field: string assignee_id = 6;
   */
  assigneeId: string;

  /**
   * @generated from field: map<string, string> extra = 7;
   */
  extra: { [key: string]: string };
};

/**
 * Describes the message zdc.ConvertMessageRequest.
 * Use `create(ConvertMessageRequestSchema)` to create a new message.
 */
export const ConvertMessageRequestSchema: GenMessage<ConvertMessageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 731);

/**
 * Результат конверсии: созданный объект + связь конверсии с сообщением.
 *
 * @generated from message zdc.ConvertMessageResponse
 */
export type ConvertMessageResponse = Message<"zdc.ConvertMessageResponse"> & {
  /**
   * 'order' | 'task'
   *
   * @generated from field: string object_type = 1;
   */
  objectType: string;

  /**
   * @generated from field: string object_id = 2;
   */
  objectId: string;

  /**
   * код типа созданного объекта
   *
   * @generated from field: string type_code = 3;
   */
  typeCode: string;

  /**
   * тема созданного объекта
   *
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * исходное сообщение (связь конверсии)
   *
   * @generated from field: string message_id = 5;
   */
  messageId: string;

  /**
   * Контекстный чат объекта-обсуждения, в котором было сообщение (пусто —
   * конверсия из обычного чата): связь созданного объекта с обсуждением.
   *
   * @generated from field: string conversation_id = 6;
   */
  conversationId: string;
};

/**
 * Describes the message zdc.ConvertMessageResponse.
 * Use `create(ConvertMessageResponseSchema)` to create a new message.
 */
export const ConvertMessageResponseSchema: GenMessage<ConvertMessageResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 732);

/**
 * Поиск по сообщениям: query — не менее 2 символов; limit по умолчанию 30 (макс. 100).
 *
 * @generated from message zdc.SearchMessagesRequest
 */
export type SearchMessagesRequest = Message<"zdc.SearchMessagesRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: string conversation_id = 2;
   */
  conversationId: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message zdc.SearchMessagesRequest.
 * Use `create(SearchMessagesRequestSchema)` to create a new message.
 */
export const SearchMessagesRequestSchema: GenMessage<SearchMessagesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 733);

/**
 * @generated from message zdc.SearchMessagesResponse
 */
export type SearchMessagesResponse = Message<"zdc.SearchMessagesResponse"> & {
  /**
   * @generated from field: repeated zdc.ChatSearchResult items = 1;
   */
  items: ChatSearchResult[];
};

/**
 * Describes the message zdc.SearchMessagesResponse.
 * Use `create(SearchMessagesResponseSchema)` to create a new message.
 */
export const SearchMessagesResponseSchema: GenMessage<SearchMessagesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 734);

/**
 * Найденное сообщение с контекстом чата (заголовок и сниппет вокруг совпадения).
 *
 * @generated from message zdc.ChatSearchResult
 */
export type ChatSearchResult = Message<"zdc.ChatSearchResult"> & {
  /**
   * @generated from field: zdc.ChatMessage message = 1;
   */
  message?: ChatMessage | undefined;

  /**
   * @generated from field: string conversation_title = 2;
   */
  conversationTitle: string;

  /**
   * @generated from field: string snippet = 3;
   */
  snippet: string;
};

/**
 * Describes the message zdc.ChatSearchResult.
 * Use `create(ChatSearchResultSchema)` to create a new message.
 */
export const ChatSearchResultSchema: GenMessage<ChatSearchResult> = /*@__PURE__*/
  messageDesc(file_zdc, 735);

/**
 * Chat wallpapers per-user per-chat
 *
 * @generated from message zdc.ChatWallpaper
 */
export type ChatWallpaper = Message<"zdc.ChatWallpaper"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * 'builtin' | 'file'
   *
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * preset id или fileId
   *
   * @generated from field: string value = 3;
   */
  value: string;

  /**
   * @generated from field: string updated_at = 4;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.ChatWallpaper.
 * Use `create(ChatWallpaperSchema)` to create a new message.
 */
export const ChatWallpaperSchema: GenMessage<ChatWallpaper> = /*@__PURE__*/
  messageDesc(file_zdc, 736);

/**
 * @generated from message zdc.GetChatWallpaperRequest
 */
export type GetChatWallpaperRequest = Message<"zdc.GetChatWallpaperRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;
};

/**
 * Describes the message zdc.GetChatWallpaperRequest.
 * Use `create(GetChatWallpaperRequestSchema)` to create a new message.
 */
export const GetChatWallpaperRequestSchema: GenMessage<GetChatWallpaperRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 737);

/**
 * @generated from message zdc.SetChatWallpaperRequest
 */
export type SetChatWallpaperRequest = Message<"zdc.SetChatWallpaperRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * Describes the message zdc.SetChatWallpaperRequest.
 * Use `create(SetChatWallpaperRequestSchema)` to create a new message.
 */
export const SetChatWallpaperRequestSchema: GenMessage<SetChatWallpaperRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 738);

/**
 * @generated from message zdc.DeleteChatWallpaperRequest
 */
export type DeleteChatWallpaperRequest = Message<"zdc.DeleteChatWallpaperRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;
};

/**
 * Describes the message zdc.DeleteChatWallpaperRequest.
 * Use `create(DeleteChatWallpaperRequestSchema)` to create a new message.
 */
export const DeleteChatWallpaperRequestSchema: GenMessage<DeleteChatWallpaperRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 739);

/**
 * Ссылки-приглашения чата: ссылка — секрет (token, base32). max_uses=0 —
 * безлимит; expires_in_minutes<=0 — без срока; role_on_join — роль при входе.
 *
 * @generated from message zdc.CreateConversationInviteRequest
 */
export type CreateConversationInviteRequest = Message<"zdc.CreateConversationInviteRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: int32 max_uses = 2;
   */
  maxUses: number;

  /**
   * @generated from field: int32 expires_in_minutes = 3;
   */
  expiresInMinutes: number;

  /**
   * Роль при входе по ссылке: participant | guest | viewer (пусто = participant).
   *
   * @generated from field: string role_on_join = 4;
   */
  roleOnJoin: string;
};

/**
 * Describes the message zdc.CreateConversationInviteRequest.
 * Use `create(CreateConversationInviteRequestSchema)` to create a new message.
 */
export const CreateConversationInviteRequestSchema: GenMessage<CreateConversationInviteRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 740);

/**
 * @generated from message zdc.CreateConversationInviteResponse
 */
export type CreateConversationInviteResponse = Message<"zdc.CreateConversationInviteResponse"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string expires_at = 2;
   */
  expiresAt: string;

  /**
   * @generated from field: int32 max_uses = 3;
   */
  maxUses: number;

  /**
   * @generated from field: string role_on_join = 4;
   */
  roleOnJoin: string;
};

/**
 * Describes the message zdc.CreateConversationInviteResponse.
 * Use `create(CreateConversationInviteResponseSchema)` to create a new message.
 */
export const CreateConversationInviteResponseSchema: GenMessage<CreateConversationInviteResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 741);

/**
 * Публичная мета ссылки (БЕЗ id чата): title/kind + требуется ли вход.
 *
 * @generated from message zdc.ResolveConversationInviteRequest
 */
export type ResolveConversationInviteRequest = Message<"zdc.ResolveConversationInviteRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.ResolveConversationInviteRequest.
 * Use `create(ResolveConversationInviteRequestSchema)` to create a new message.
 */
export const ResolveConversationInviteRequestSchema: GenMessage<ResolveConversationInviteRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 742);

/**
 * @generated from message zdc.ResolveConversationInviteResponse
 */
export type ResolveConversationInviteResponse = Message<"zdc.ResolveConversationInviteResponse"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: bool requires_auth = 3;
   */
  requiresAuth: boolean;

  /**
   * @generated from field: string role_on_join = 4;
   */
  roleOnJoin: string;
};

/**
 * Describes the message zdc.ResolveConversationInviteResponse.
 * Use `create(ResolveConversationInviteResponseSchema)` to create a new message.
 */
export const ResolveConversationInviteResponseSchema: GenMessage<ResolveConversationInviteResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 743);

/**
 * Погашение ссылки: conversation_id возвращается погасившему (для входа в чат);
 * guest=true — гость (пользователь не добавлен, id сущности не создаётся).
 *
 * @generated from message zdc.RedeemConversationInviteRequest
 */
export type RedeemConversationInviteRequest = Message<"zdc.RedeemConversationInviteRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.RedeemConversationInviteRequest.
 * Use `create(RedeemConversationInviteRequestSchema)` to create a new message.
 */
export const RedeemConversationInviteRequestSchema: GenMessage<RedeemConversationInviteRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 744);

/**
 * @generated from message zdc.RedeemConversationInviteResponse
 */
export type RedeemConversationInviteResponse = Message<"zdc.RedeemConversationInviteResponse"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string role = 2;
   */
  role: string;

  /**
   * @generated from field: bool guest = 3;
   */
  guest: boolean;

  /**
   * @generated from field: int32 uses = 4;
   */
  uses: number;

  /**
   * @generated from field: int32 max_uses = 5;
   */
  maxUses: number;
};

/**
 * Describes the message zdc.RedeemConversationInviteResponse.
 * Use `create(RedeemConversationInviteResponseSchema)` to create a new message.
 */
export const RedeemConversationInviteResponseSchema: GenMessage<RedeemConversationInviteResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 745);

/**
 * Подписка браузера на push-уведомления (PushSubscription из PushManager).
 *
 * @generated from message zdc.PushSubscriptionData
 */
export type PushSubscriptionData = Message<"zdc.PushSubscriptionData"> & {
  /**
   * PushSubscription.endpoint
   *
   * @generated from field: string endpoint = 1;
   */
  endpoint: string;

  /**
   * ключ (base64url) — для шифрования payload
   *
   * @generated from field: string p256dh = 2;
   */
  p256dh: string;

  /**
   * секрет (base64url)
   *
   * @generated from field: string auth = 3;
   */
  auth: string;
};

/**
 * Describes the message zdc.PushSubscriptionData.
 * Use `create(PushSubscriptionDataSchema)` to create a new message.
 */
export const PushSubscriptionDataSchema: GenMessage<PushSubscriptionData> = /*@__PURE__*/
  messageDesc(file_zdc, 746);

/**
 * @generated from message zdc.PushSubscribeRequest
 */
export type PushSubscribeRequest = Message<"zdc.PushSubscribeRequest"> & {
  /**
   * @generated from field: zdc.PushSubscriptionData subscription = 1;
   */
  subscription?: PushSubscriptionData | undefined;
};

/**
 * Describes the message zdc.PushSubscribeRequest.
 * Use `create(PushSubscribeRequestSchema)` to create a new message.
 */
export const PushSubscribeRequestSchema: GenMessage<PushSubscribeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 747);

/**
 * @generated from message zdc.PushUnsubscribeRequest
 */
export type PushUnsubscribeRequest = Message<"zdc.PushUnsubscribeRequest"> & {
  /**
   * @generated from field: string endpoint = 1;
   */
  endpoint: string;
};

/**
 * Describes the message zdc.PushUnsubscribeRequest.
 * Use `create(PushUnsubscribeRequestSchema)` to create a new message.
 */
export const PushUnsubscribeRequestSchema: GenMessage<PushUnsubscribeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 748);

/**
 * @generated from message zdc.PushGetVapidKeyRequest
 */
export type PushGetVapidKeyRequest = Message<"zdc.PushGetVapidKeyRequest"> & {
};

/**
 * Describes the message zdc.PushGetVapidKeyRequest.
 * Use `create(PushGetVapidKeyRequestSchema)` to create a new message.
 */
export const PushGetVapidKeyRequestSchema: GenMessage<PushGetVapidKeyRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 749);

/**
 * @generated from message zdc.PushVapidKeyResponse
 */
export type PushVapidKeyResponse = Message<"zdc.PushVapidKeyResponse"> & {
  /**
   * VAPID public key (base64url) — для PushManager.subscribe
   *
   * @generated from field: string public_key = 1;
   */
  publicKey: string;
};

/**
 * Describes the message zdc.PushVapidKeyResponse.
 * Use `create(PushVapidKeyResponseSchema)` to create a new message.
 */
export const PushVapidKeyResponseSchema: GenMessage<PushVapidKeyResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 750);

/**
 * @generated from message zdc.PushListSubscriptionsRequest
 */
export type PushListSubscriptionsRequest = Message<"zdc.PushListSubscriptionsRequest"> & {
};

/**
 * Describes the message zdc.PushListSubscriptionsRequest.
 * Use `create(PushListSubscriptionsRequestSchema)` to create a new message.
 */
export const PushListSubscriptionsRequestSchema: GenMessage<PushListSubscriptionsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 751);

/**
 * @generated from message zdc.PushSubscriptionInfo
 */
export type PushSubscriptionInfo = Message<"zdc.PushSubscriptionInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string endpoint = 2;
   */
  endpoint: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: string user_name = 4;
   */
  userName: string;

  /**
   * @generated from field: string created_at = 5;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.PushSubscriptionInfo.
 * Use `create(PushSubscriptionInfoSchema)` to create a new message.
 */
export const PushSubscriptionInfoSchema: GenMessage<PushSubscriptionInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 752);

/**
 * @generated from message zdc.PushListSubscriptionsResponse
 */
export type PushListSubscriptionsResponse = Message<"zdc.PushListSubscriptionsResponse"> & {
  /**
   * @generated from field: repeated zdc.PushSubscriptionInfo items = 1;
   */
  items: PushSubscriptionInfo[];
};

/**
 * Describes the message zdc.PushListSubscriptionsResponse.
 * Use `create(PushListSubscriptionsResponseSchema)` to create a new message.
 */
export const PushListSubscriptionsResponseSchema: GenMessage<PushListSubscriptionsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 753);

/**
 * @generated from message zdc.PushSendRequest
 */
export type PushSendRequest = Message<"zdc.PushSendRequest"> & {
  /**
   * получатель (пусто — всем подписанным)
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string body = 3;
   */
  body: string;

  /**
   * куда ведёт клик по уведомлению
   *
   * @generated from field: string url = 4;
   */
  url: string;
};

/**
 * Describes the message zdc.PushSendRequest.
 * Use `create(PushSendRequestSchema)` to create a new message.
 */
export const PushSendRequestSchema: GenMessage<PushSendRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 754);

/**
 * @generated from message zdc.MediaSettings
 */
export type MediaSettings = Message<"zdc.MediaSettings"> & {
  /**
   * адрес LiveKit для клиента (wss/ws); пусто = недоступно
   *
   * @generated from field: string livekit_url = 1;
   */
  livekitUrl: string;

  /**
   * LiveKit доступен (URL задан ИЛИ embed работает)
   *
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;
};

/**
 * Describes the message zdc.MediaSettings.
 * Use `create(MediaSettingsSchema)` to create a new message.
 */
export const MediaSettingsSchema: GenMessage<MediaSettings> = /*@__PURE__*/
  messageDesc(file_zdc, 755);

/**
 * @generated from message zdc.CreateLiveKitTokenRequest
 */
export type CreateLiveKitTokenRequest = Message<"zdc.CreateLiveKitTokenRequest"> & {
  /**
   * комната (conversation_id / объект / раздел)
   *
   * @generated from field: string room = 1;
   */
  room: string;
};

/**
 * Describes the message zdc.CreateLiveKitTokenRequest.
 * Use `create(CreateLiveKitTokenRequestSchema)` to create a new message.
 */
export const CreateLiveKitTokenRequestSchema: GenMessage<CreateLiveKitTokenRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 756);

/**
 * @generated from message zdc.CreateLiveKitTokenResponse
 */
export type CreateLiveKitTokenResponse = Message<"zdc.CreateLiveKitTokenResponse"> & {
  /**
   * access-токен (JWT, 6 часов)
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * livekit_url (то же, что GetMediaSettings)
   *
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * Describes the message zdc.CreateLiveKitTokenResponse.
 * Use `create(CreateLiveKitTokenResponseSchema)` to create a new message.
 */
export const CreateLiveKitTokenResponseSchema: GenMessage<CreateLiveKitTokenResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 757);

/**
 * @generated from message zdc.SaveLocationPointRequest
 */
export type SaveLocationPointRequest = Message<"zdc.SaveLocationPointRequest"> & {
  /**
   * Субъект точки: 'file' (файл), 'entity' (пользователь/сотрудник — трекинг)
   * или произвольный код субъекта. Для 'entity' субъект принудительно =
   * текущий JWT-пользователь (нельзя писать чужие координаты).
   *
   * @generated from field: string subject_type = 1;
   */
  subjectType: string;

  /**
   * @generated from field: string subject_id = 2;
   */
  subjectId: string;

  /**
   * @generated from field: double lat = 3;
   */
  lat: number;

  /**
   * @generated from field: double lon = 4;
   */
  lon: number;

  /**
   * Точность определения (метры) — опционально, от геолокации клиента.
   *
   * @generated from field: double accuracy = 5;
   */
  accuracy: number;

  /**
   * Время снятия точки на клиенте (RFC3339) — опционально; пусто = серверное.
   *
   * @generated from field: string captured_at = 6;
   */
  capturedAt: string;
};

/**
 * Describes the message zdc.SaveLocationPointRequest.
 * Use `create(SaveLocationPointRequestSchema)` to create a new message.
 */
export const SaveLocationPointRequestSchema: GenMessage<SaveLocationPointRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 758);

/**
 * @generated from message zdc.SaveLocationPointResponse
 */
export type SaveLocationPointResponse = Message<"zdc.SaveLocationPointResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.SaveLocationPointResponse.
 * Use `create(SaveLocationPointResponseSchema)` to create a new message.
 */
export const SaveLocationPointResponseSchema: GenMessage<SaveLocationPointResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 759);

/**
 * @generated from message zdc.GetLocationSettingsRequest
 */
export type GetLocationSettingsRequest = Message<"zdc.GetLocationSettingsRequest"> & {
};

/**
 * Describes the message zdc.GetLocationSettingsRequest.
 * Use `create(GetLocationSettingsRequestSchema)` to create a new message.
 */
export const GetLocationSettingsRequestSchema: GenMessage<GetLocationSettingsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 760);

/**
 * Режим отслеживания координат пользователя (роль/пользователь):
 *   off           — отслеживание выключено (координаты пользователя не собираются)
 *   optional      — пользователь решает сам (тумблер в профиле; по умолчанию)
 *   required      — при каждом входе предлагается включить (мягкий запрос)
 *   unconditional — пользователь не может выключить в профиле (обязательное)
 *
 * @generated from message zdc.LocationPolicyMode
 */
export type LocationPolicyMode = Message<"zdc.LocationPolicyMode"> & {
  /**
   * off | optional | required | unconditional
   *
   * @generated from field: string mode = 1;
   */
  mode: string;

  /**
   * Текущее согласие пользователя (client_choice): "on" | "off" | "" (не задано)
   *
   * @generated from field: string user_choice = 2;
   */
  userChoice: string;
};

/**
 * Describes the message zdc.LocationPolicyMode.
 * Use `create(LocationPolicyModeSchema)` to create a new message.
 */
export const LocationPolicyModeSchema: GenMessage<LocationPolicyMode> = /*@__PURE__*/
  messageDesc(file_zdc, 761);

/**
 * @generated from message zdc.LocationSettings
 */
export type LocationSettings = Message<"zdc.LocationSettings"> & {
  /**
   * Сбор координат (location.capture_enabled): false — SaveLocationPoint
   * отклоняется явной ошибкой.
   *
   * @generated from field: bool capture_enabled = 1;
   */
  captureEnabled: boolean;

  /**
   * Показ геопозиции (location.show_in_ui): false — чтение точек недоступно
   * (координаты — чувствительные данные, хранятся, но не показываются).
   *
   * @generated from field: bool show_in_ui = 2;
   */
  showInUi: boolean;

  /**
   * Роли с правом просмотра (location.view_roles, JSON-массив): пусто = только
   * admin (global:admin) видит точки.
   *
   * @generated from field: repeated string view_roles = 3;
   */
  viewRoles: string[];

  /**
   * Режим отслеживания по ролям (location.role_policy, JSON-объект роль→режим):
   * пусто = режим по умолчанию (capture_enabled → optional; выключен → off).
   *
   * @generated from field: map<string, string> role_policy = 4;
   */
  rolePolicy: { [key: string]: string };
};

/**
 * Describes the message zdc.LocationSettings.
 * Use `create(LocationSettingsSchema)` to create a new message.
 */
export const LocationSettingsSchema: GenMessage<LocationSettings> = /*@__PURE__*/
  messageDesc(file_zdc, 762);

/**
 * @generated from message zdc.SetLocationSettingsRequest
 */
export type SetLocationSettingsRequest = Message<"zdc.SetLocationSettingsRequest"> & {
  /**
   * @generated from field: bool capture_enabled = 1;
   */
  captureEnabled: boolean;

  /**
   * @generated from field: bool show_in_ui = 2;
   */
  showInUi: boolean;

  /**
   * @generated from field: repeated string view_roles = 3;
   */
  viewRoles: string[];

  /**
   * @generated from field: map<string, string> role_policy = 4;
   */
  rolePolicy: { [key: string]: string };
};

/**
 * Describes the message zdc.SetLocationSettingsRequest.
 * Use `create(SetLocationSettingsRequestSchema)` to create a new message.
 */
export const SetLocationSettingsRequestSchema: GenMessage<SetLocationSettingsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 763);

/**
 * Статус отслеживания координат ТЕКУЩЕГО пользователя (своя карточка/профиль):
 * эффективный режим (самый строгий из ролей) + разрешён ли сбор.
 *
 * @generated from message zdc.GetMyTrackingStatusRequest
 */
export type GetMyTrackingStatusRequest = Message<"zdc.GetMyTrackingStatusRequest"> & {
};

/**
 * Describes the message zdc.GetMyTrackingStatusRequest.
 * Use `create(GetMyTrackingStatusRequestSchema)` to create a new message.
 */
export const GetMyTrackingStatusRequestSchema: GenMessage<GetMyTrackingStatusRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 764);

/**
 * @generated from message zdc.TrackingStatus
 */
export type TrackingStatus = Message<"zdc.TrackingStatus"> & {
  /**
   * Эффективный режим пользователя: off | optional | required | unconditional
   *
   * @generated from field: string mode = 1;
   */
  mode: string;

  /**
   * Согласие пользователя (user_settings location.track): "on" | "off" | ""
   *
   * @generated from field: string user_choice = 2;
   */
  userChoice: string;

  /**
   * Отслеживание фактически включено: mode != off И user_choice == "on"
   * (для unconditional при пустом user_choice сервер считает включённым —
   * политика обязательна, пользователь не может отказаться).
   *
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;

  /**
   * Режим требует включения при входе (мягкий запрос / жёсткий блок)
   *
   * @generated from field: bool required = 4;
   */
  required: boolean;

  /**
   * @generated from field: bool unconditional = 5;
   */
  unconditional: boolean;

  /**
   * При unconditional — пользователь НЕ может выключить в профиле
   *
   * @generated from field: bool can_disable = 6;
   */
  canDisable: boolean;
};

/**
 * Describes the message zdc.TrackingStatus.
 * Use `create(TrackingStatusSchema)` to create a new message.
 */
export const TrackingStatusSchema: GenMessage<TrackingStatus> = /*@__PURE__*/
  messageDesc(file_zdc, 765);

/**
 * @generated from message zdc.SetMyTrackingRequest
 */
export type SetMyTrackingRequest = Message<"zdc.SetMyTrackingRequest"> & {
  /**
   * "on" | "off" — согласие пользователя ("" = сброс к политике)
   *
   * @generated from field: string enabled = 1;
   */
  enabled: string;
};

/**
 * Describes the message zdc.SetMyTrackingRequest.
 * Use `create(SetMyTrackingRequestSchema)` to create a new message.
 */
export const SetMyTrackingRequestSchema: GenMessage<SetMyTrackingRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 766);

/**
 * @generated from message zdc.GetUserTrackingRequest
 */
export type GetUserTrackingRequest = Message<"zdc.GetUserTrackingRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message zdc.GetUserTrackingRequest.
 * Use `create(GetUserTrackingRequestSchema)` to create a new message.
 */
export const GetUserTrackingRequestSchema: GenMessage<GetUserTrackingRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 767);

/**
 * @generated from message zdc.SetUserTrackingRequest
 */
export type SetUserTrackingRequest = Message<"zdc.SetUserTrackingRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * "on" | "off" | "" — принудительное согласие (только админ)
   *
   * @generated from field: string enabled = 2;
   */
  enabled: string;
};

/**
 * Describes the message zdc.SetUserTrackingRequest.
 * Use `create(SetUserTrackingRequestSchema)` to create a new message.
 */
export const SetUserTrackingRequestSchema: GenMessage<SetUserTrackingRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 768);

/**
 * @generated from message zdc.ListLocationPointsRequest
 */
export type ListLocationPointsRequest = Message<"zdc.ListLocationPointsRequest"> & {
  /**
   * Фильтры: субъект (пусто = все), период (RFC3339, пусто = без границы)
   *
   * @generated from field: string subject_type = 1;
   */
  subjectType: string;

  /**
   * @generated from field: string subject_id = 2;
   */
  subjectId: string;

  /**
   * @generated from field: string from_ts = 3;
   */
  fromTs: string;

  /**
   * @generated from field: string to_ts = 4;
   */
  toTs: string;

  /**
   * @generated from field: int32 limit = 5;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 6;
   */
  offset: number;
};

/**
 * Describes the message zdc.ListLocationPointsRequest.
 * Use `create(ListLocationPointsRequestSchema)` to create a new message.
 */
export const ListLocationPointsRequestSchema: GenMessage<ListLocationPointsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 769);

/**
 * @generated from message zdc.LocationPoint
 */
export type LocationPoint = Message<"zdc.LocationPoint"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string subject_type = 2;
   */
  subjectType: string;

  /**
   * @generated from field: string subject_id = 3;
   */
  subjectId: string;

  /**
   * Имя субъекта (SSoT — сервер): пользователь — имя (entities), файл — file_name
   *
   * @generated from field: string subject_name = 4;
   */
  subjectName: string;

  /**
   * @generated from field: double lat = 5;
   */
  lat: number;

  /**
   * @generated from field: double lon = 6;
   */
  lon: number;

  /**
   * @generated from field: double accuracy = 7;
   */
  accuracy: number;

  /**
   * @generated from field: string captured_at = 8;
   */
  capturedAt: string;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.LocationPoint.
 * Use `create(LocationPointSchema)` to create a new message.
 */
export const LocationPointSchema: GenMessage<LocationPoint> = /*@__PURE__*/
  messageDesc(file_zdc, 770);

/**
 * @generated from message zdc.ListLocationPointsResponse
 */
export type ListLocationPointsResponse = Message<"zdc.ListLocationPointsResponse"> & {
  /**
   * @generated from field: repeated zdc.LocationPoint items = 1;
   */
  items: LocationPoint[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message zdc.ListLocationPointsResponse.
 * Use `create(ListLocationPointsResponseSchema)` to create a new message.
 */
export const ListLocationPointsResponseSchema: GenMessage<ListLocationPointsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 771);

/**
 * --- Провайдеры ИИ ---
 *
 * @generated from message zdc.AiProvider
 */
export type AiProvider = Message<"zdc.AiProvider"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 'openai_compatible' (реестр типов расширяем)
   *
   * @generated from field: string provider_type = 4;
   */
  providerType: string;

  /**
   * @generated from field: string base_url = 5;
   */
  baseUrl: string;

  /**
   * @generated from field: string model = 6;
   */
  model: string;

  /**
   * @generated from field: int32 timeout_seconds = 7;
   */
  timeoutSeconds: number;

  /**
   * @generated from field: bool enabled = 8;
   */
  enabled: boolean;

  /**
   * ключ задан (всегда можно проверить)
   *
   * @generated from field: bool api_key_set = 9;
   */
  apiKeySet: boolean;

  /**
   * САМ КЛЮЧ — возвращается ТОЛЬКО администратору
   *
   * @generated from field: string api_key = 10;
   */
  apiKey: string;

  /**
   * (не-админ получает пустую строку + api_key_set)
   *
   * @generated from field: bool is_system = 11;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 12;
   */
  templateId: string;

  /**
   * @generated from field: string created_at = 13;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 14;
   */
  updatedAt: string;

  /**
   * P1: личный провайдер пользователя (пусто = базовый/системный провайдер
   * базы). Нужен UI для метки «базовый/личный» в выборе провайдера назначения.
   *
   * @generated from field: string owner_id = 15;
   */
  ownerId: string;
};

/**
 * Describes the message zdc.AiProvider.
 * Use `create(AiProviderSchema)` to create a new message.
 */
export const AiProviderSchema: GenMessage<AiProvider> = /*@__PURE__*/
  messageDesc(file_zdc, 772);

/**
 * @generated from message zdc.AiProviderTypeInfo
 */
export type AiProviderTypeInfo = Message<"zdc.AiProviderTypeInfo"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string display = 2;
   */
  display: string;

  /**
   * schema полей (api_key = secret)
   *
   * @generated from field: repeated zdc.ExternalApiFieldSchema fields = 3;
   */
  fields: ExternalApiFieldSchema[];
};

/**
 * Describes the message zdc.AiProviderTypeInfo.
 * Use `create(AiProviderTypeInfoSchema)` to create a new message.
 */
export const AiProviderTypeInfoSchema: GenMessage<AiProviderTypeInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 773);

/**
 * @generated from message zdc.ListAiProviderTypesResponse
 */
export type ListAiProviderTypesResponse = Message<"zdc.ListAiProviderTypesResponse"> & {
  /**
   * @generated from field: repeated zdc.AiProviderTypeInfo items = 1;
   */
  items: AiProviderTypeInfo[];
};

/**
 * Describes the message zdc.ListAiProviderTypesResponse.
 * Use `create(ListAiProviderTypesResponseSchema)` to create a new message.
 */
export const ListAiProviderTypesResponseSchema: GenMessage<ListAiProviderTypesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 774);

/**
 * @generated from message zdc.ListAiProviderTypesRequest
 */
export type ListAiProviderTypesRequest = Message<"zdc.ListAiProviderTypesRequest"> & {
};

/**
 * Describes the message zdc.ListAiProviderTypesRequest.
 * Use `create(ListAiProviderTypesRequestSchema)` to create a new message.
 */
export const ListAiProviderTypesRequestSchema: GenMessage<ListAiProviderTypesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 775);

/**
 * @generated from message zdc.ListAiProvidersResponse
 */
export type ListAiProvidersResponse = Message<"zdc.ListAiProvidersResponse"> & {
  /**
   * @generated from field: repeated zdc.AiProvider items = 1;
   */
  items: AiProvider[];
};

/**
 * Describes the message zdc.ListAiProvidersResponse.
 * Use `create(ListAiProvidersResponseSchema)` to create a new message.
 */
export const ListAiProvidersResponseSchema: GenMessage<ListAiProvidersResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 776);

/**
 * @generated from message zdc.GetAiProviderRequest
 */
export type GetAiProviderRequest = Message<"zdc.GetAiProviderRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetAiProviderRequest.
 * Use `create(GetAiProviderRequestSchema)` to create a new message.
 */
export const GetAiProviderRequestSchema: GenMessage<GetAiProviderRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 777);

/**
 * @generated from message zdc.SaveAiProviderRequest
 */
export type SaveAiProviderRequest = Message<"zdc.SaveAiProviderRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string provider_type = 4;
   */
  providerType: string;

  /**
   * @generated from field: string base_url = 5;
   */
  baseUrl: string;

  /**
   * @generated from field: string model = 6;
   */
  model: string;

  /**
   * @generated from field: int32 timeout_seconds = 7;
   */
  timeoutSeconds: number;

  /**
   * @generated from field: bool enabled = 8;
   */
  enabled: boolean;

  /**
   * непустой = установить/сменить
   *
   * @generated from field: string api_key = 9;
   */
  apiKey: string;
};

/**
 * Describes the message zdc.SaveAiProviderRequest.
 * Use `create(SaveAiProviderRequestSchema)` to create a new message.
 */
export const SaveAiProviderRequestSchema: GenMessage<SaveAiProviderRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 778);

/**
 * @generated from message zdc.DeleteAiProviderRequest
 */
export type DeleteAiProviderRequest = Message<"zdc.DeleteAiProviderRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteAiProviderRequest.
 * Use `create(DeleteAiProviderRequestSchema)` to create a new message.
 */
export const DeleteAiProviderRequestSchema: GenMessage<DeleteAiProviderRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 779);

/**
 * --- Модели (реестр: карточки с описанием возможностей, фильтры) ---
 * Реестр = ВСТРОЕННЫЕ (механизм ядра, internal/ai) + пользовательские
 * (metadata_ai_models). Модель выбирается провайдеру (просмотр) и агенту
 * (задаётся для работы) через ОКНО-КАРТОЧКИ (механизм форм выбора).
 *
 * @generated from message zdc.AiModel
 */
export type AiModel = Message<"zdc.AiModel"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * код ЛОГИЧЕСКОЙ модели (уникальный; что выбирает агент)
   *
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * отображаемое имя («Личная»)
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * тип провайдера (фильтр)
   *
   * @generated from field: string provider_type = 4;
   */
  providerType: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * JSON: {vision, tools, reasoning, context_window, max_tokens, ...}
   *
   * @generated from field: string capabilities = 6;
   */
  capabilities: string;

  /**
   * @generated from field: int32 context_window = 7;
   */
  contextWindow: number;

  /**
   * @generated from field: int32 max_tokens = 8;
   */
  maxTokens: number;

  /**
   * @generated from field: bool is_system = 9;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 10;
   */
  templateId: string;

  /**
   * @generated from field: int32 sort_order = 11;
   */
  sortOrder: number;

  /**
   * привязка к провайдеру
   *
   * @generated from field: string provider_id = 12;
   */
  providerId: string;

  /**
   * РЕАЛЬНАЯ модель провайдера (напр. meta-llama/llama-3.3-70b-instruct)
   *
   * @generated from field: string model_code = 13;
   */
  modelCode: string;
};

/**
 * Describes the message zdc.AiModel.
 * Use `create(AiModelSchema)` to create a new message.
 */
export const AiModelSchema: GenMessage<AiModel> = /*@__PURE__*/
  messageDesc(file_zdc, 780);

/**
 * @generated from message zdc.ListAiModelsResponse
 */
export type ListAiModelsResponse = Message<"zdc.ListAiModelsResponse"> & {
  /**
   * @generated from field: repeated zdc.AiModel items = 1;
   */
  items: AiModel[];
};

/**
 * Describes the message zdc.ListAiModelsResponse.
 * Use `create(ListAiModelsResponseSchema)` to create a new message.
 */
export const ListAiModelsResponseSchema: GenMessage<ListAiModelsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 781);

/**
 * @generated from message zdc.SaveAiModelRequest
 */
export type SaveAiModelRequest = Message<"zdc.SaveAiModelRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string provider_type = 4;
   */
  providerType: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: string capabilities = 6;
   */
  capabilities: string;

  /**
   * @generated from field: int32 context_window = 7;
   */
  contextWindow: number;

  /**
   * @generated from field: int32 max_tokens = 8;
   */
  maxTokens: number;

  /**
   * @generated from field: int32 sort_order = 9;
   */
  sortOrder: number;

  /**
   * @generated from field: string provider_id = 10;
   */
  providerId: string;

  /**
   * @generated from field: string model_code = 11;
   */
  modelCode: string;
};

/**
 * Describes the message zdc.SaveAiModelRequest.
 * Use `create(SaveAiModelRequestSchema)` to create a new message.
 */
export const SaveAiModelRequestSchema: GenMessage<SaveAiModelRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 782);

/**
 * @generated from message zdc.DeleteAiModelRequest
 */
export type DeleteAiModelRequest = Message<"zdc.DeleteAiModelRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteAiModelRequest.
 * Use `create(DeleteAiModelRequestSchema)` to create a new message.
 */
export const DeleteAiModelRequestSchema: GenMessage<DeleteAiModelRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 783);

/**
 * Запрос МОДЕЛЕЙ У ПРОВАЙДЕРА (GET {base_url}/models с ключом) — SSoT: реальные
 * модели приходят от провайдера, пресеты — только рекомендации.
 *
 * @generated from message zdc.ListProviderModelsRequest
 */
export type ListProviderModelsRequest = Message<"zdc.ListProviderModelsRequest"> & {
  /**
   * тест СОХРАНЁННОГО провайдера (по настройкам)
   *
   * @generated from field: string provider_id = 1;
   */
  providerId: string;

  /**
   * ИЛИ нового (без сохранения)
   *
   * @generated from field: string provider_type = 2;
   */
  providerType: string;

  /**
   * @generated from field: string base_url = 3;
   */
  baseUrl: string;

  /**
   * @generated from field: string api_key = 4;
   */
  apiKey: string;
};

/**
 * Describes the message zdc.ListProviderModelsRequest.
 * Use `create(ListProviderModelsRequestSchema)` to create a new message.
 */
export const ListProviderModelsRequestSchema: GenMessage<ListProviderModelsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 784);

/**
 * @generated from message zdc.ProviderModelInfo
 */
export type ProviderModelInfo = Message<"zdc.ProviderModelInfo"> & {
  /**
   * код модели (используется в провайдере/агенте)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * имя (если провайдер отдаёт; иначе = id)
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * контекст (токены; если провайдер отдаёт)
   *
   * @generated from field: int64 context_length = 3;
   */
  contextLength: bigint;

  /**
   * JSON с прочими деталями от провайдера (НЕ хардкор)
   *
   * @generated from field: string details = 4;
   */
  details: string;

  /**
   * Структурированные метаданные (если провайдер отдал; иначе пусто):
   *
   * создатель модели (организация)
   *
   * @generated from field: string owned_by = 5;
   */
  ownedBy: string;

  /**
   * макс. выход (токены)
   *
   * @generated from field: int64 max_output_tokens = 6;
   */
  maxOutputTokens: bigint;

  /**
   * модальности: text/image/audio/embedding/...
   *
   * @generated from field: repeated string modalities = 7;
   */
  modalities: string[];

  /**
   * цена вход (строкой: "$1.75" / "0.14")
   *
   * @generated from field: string input_price = 8;
   */
  inputPrice: string;

  /**
   * цена выход
   *
   * @generated from field: string output_price = 9;
   */
  outputPrice: string;

  /**
   * описание (если отдаёт)
   *
   * @generated from field: string description = 10;
   */
  description: string;

  /**
   * function calling / tool use
   *
   * @generated from field: bool supports_tool_calls = 11;
   */
  supportsToolCalls: boolean;
};

/**
 * Describes the message zdc.ProviderModelInfo.
 * Use `create(ProviderModelInfoSchema)` to create a new message.
 */
export const ProviderModelInfoSchema: GenMessage<ProviderModelInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 785);

/**
 * @generated from message zdc.ListProviderModelsResponse
 */
export type ListProviderModelsResponse = Message<"zdc.ListProviderModelsResponse"> & {
  /**
   * @generated from field: repeated zdc.ProviderModelInfo items = 1;
   */
  items: ProviderModelInfo[];
};

/**
 * Describes the message zdc.ListProviderModelsResponse.
 * Use `create(ListProviderModelsResponseSchema)` to create a new message.
 */
export const ListProviderModelsResponseSchema: GenMessage<ListProviderModelsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 786);

/**
 * @generated from message zdc.TestAiProviderRequest
 */
export type TestAiProviderRequest = Message<"zdc.TestAiProviderRequest"> & {
  /**
   * тест СОХРАНЁННОГО
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * ИЛИ нового (без сохранения)
   *
   * @generated from field: string provider_type = 2;
   */
  providerType: string;

  /**
   * @generated from field: string base_url = 3;
   */
  baseUrl: string;

  /**
   * @generated from field: string model = 4;
   */
  model: string;

  /**
   * @generated from field: string api_key = 5;
   */
  apiKey: string;

  /**
   * тестовый промпт (default «ping»)
   *
   * @generated from field: string prompt = 6;
   */
  prompt: string;
};

/**
 * Describes the message zdc.TestAiProviderRequest.
 * Use `create(TestAiProviderRequestSchema)` to create a new message.
 */
export const TestAiProviderRequestSchema: GenMessage<TestAiProviderRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 787);

/**
 * --- Инструменты агентов (ДИНАМИЧЕСКИ РАСШИРЯЕМЫЙ РЕЕСТР) ---
 *
 * @generated from message zdc.AiTool
 */
export type AiTool = Message<"zdc.AiTool"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * 'builtin' (ядро) | 'module' (JS goja) | 'wasm' (wazero)
   *
   * @generated from field: string kind = 5;
   */
  kind: string;

  /**
   * код встроенного инструмента (для kind='builtin')
   *
   * @generated from field: string builtin_code = 6;
   */
  builtinCode: string;

  /**
   * JS-код для kind='module' (function handleTool(params){...})
   *
   * @generated from field: string module_code = 7;
   */
  moduleCode: string;

  /**
   * @generated from field: bool is_system = 8;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 9;
   */
  templateId: string;

  /**
   * source — источник для kind='wasm': file_id файла .wasm из «Файлов» (SSoT).
   *
   * @generated from field: string source = 10;
   */
  source: string;
};

/**
 * Describes the message zdc.AiTool.
 * Use `create(AiToolSchema)` to create a new message.
 */
export const AiToolSchema: GenMessage<AiTool> = /*@__PURE__*/
  messageDesc(file_zdc, 788);

/**
 * @generated from message zdc.ListAiToolsResponse
 */
export type ListAiToolsResponse = Message<"zdc.ListAiToolsResponse"> & {
  /**
   * @generated from field: repeated zdc.AiTool items = 1;
   */
  items: AiTool[];
};

/**
 * Describes the message zdc.ListAiToolsResponse.
 * Use `create(ListAiToolsResponseSchema)` to create a new message.
 */
export const ListAiToolsResponseSchema: GenMessage<ListAiToolsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 789);

/**
 * @generated from message zdc.SaveAiToolRequest
 */
export type SaveAiToolRequest = Message<"zdc.SaveAiToolRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string kind = 5;
   */
  kind: string;

  /**
   * @generated from field: string builtin_code = 6;
   */
  builtinCode: string;

  /**
   * @generated from field: string module_code = 7;
   */
  moduleCode: string;

  /**
   * kind='wasm': file_id .wasm (валидируется компиляцией)
   *
   * @generated from field: string source = 8;
   */
  source: string;
};

/**
 * Describes the message zdc.SaveAiToolRequest.
 * Use `create(SaveAiToolRequestSchema)` to create a new message.
 */
export const SaveAiToolRequestSchema: GenMessage<SaveAiToolRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 790);

/**
 * @generated from message zdc.DeleteAiToolRequest
 */
export type DeleteAiToolRequest = Message<"zdc.DeleteAiToolRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteAiToolRequest.
 * Use `create(DeleteAiToolRequestSchema)` to create a new message.
 */
export const DeleteAiToolRequestSchema: GenMessage<DeleteAiToolRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 791);

/**
 * --- Тест инструмента (B3, БЕЗ AI-провайдера): исполняет инструмент ЛЮБОГО
 * kind (builtin/module/wasm) с заданным входом; только админ. ---
 *
 * @generated from message zdc.TestAiToolRequest
 */
export type TestAiToolRequest = Message<"zdc.TestAiToolRequest"> & {
  /**
   * код инструмента (metadata_ai_tools / builtin ядра)
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * JSON-вход инструмента ('' = пустой объект)
   *
   * @generated from field: string input_json = 2;
   */
  inputJson: string;
};

/**
 * Describes the message zdc.TestAiToolRequest.
 * Use `create(TestAiToolRequestSchema)` to create a new message.
 */
export const TestAiToolRequestSchema: GenMessage<TestAiToolRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 792);

/**
 * @generated from message zdc.TestAiToolResponse
 */
export type TestAiToolResponse = Message<"zdc.TestAiToolResponse"> & {
  /**
   * инструмент исполнился без ошибки
   *
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * JSON-результат (как модель получила бы)
   *
   * @generated from field: string result_json = 2;
   */
  resultJson: string;

  /**
   * явная ошибка (нет инструмента/контракт/таймаут)
   *
   * @generated from field: string error = 3;
   */
  error: string;

  /**
   * @generated from field: repeated string logs = 4;
   */
  logs: string[];

  /**
   * @generated from field: int64 duration_ms = 5;
   */
  durationMs: bigint;
};

/**
 * Describes the message zdc.TestAiToolResponse.
 * Use `create(TestAiToolResponseSchema)` to create a new message.
 */
export const TestAiToolResponseSchema: GenMessage<TestAiToolResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 793);

/**
 * --- Навыки (переиспользуемые инструкции агентов) ---
 *
 * @generated from message zdc.AiSkill
 */
export type AiSkill = Message<"zdc.AiSkill"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * markdown/инструкция (что делает навык)
   *
   * @generated from field: string content = 5;
   */
  content: string;

  /**
   * @generated from field: bool is_active = 6;
   */
  isActive: boolean;

  /**
   * @generated from field: bool is_system = 7;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 8;
   */
  templateId: string;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 10;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.AiSkill.
 * Use `create(AiSkillSchema)` to create a new message.
 */
export const AiSkillSchema: GenMessage<AiSkill> = /*@__PURE__*/
  messageDesc(file_zdc, 794);

/**
 * @generated from message zdc.ListAiSkillsResponse
 */
export type ListAiSkillsResponse = Message<"zdc.ListAiSkillsResponse"> & {
  /**
   * @generated from field: repeated zdc.AiSkill items = 1;
   */
  items: AiSkill[];
};

/**
 * Describes the message zdc.ListAiSkillsResponse.
 * Use `create(ListAiSkillsResponseSchema)` to create a new message.
 */
export const ListAiSkillsResponseSchema: GenMessage<ListAiSkillsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 795);

/**
 * @generated from message zdc.SaveAiSkillRequest
 */
export type SaveAiSkillRequest = Message<"zdc.SaveAiSkillRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string content = 5;
   */
  content: string;

  /**
   * @generated from field: bool is_active = 6;
   */
  isActive: boolean;
};

/**
 * Describes the message zdc.SaveAiSkillRequest.
 * Use `create(SaveAiSkillRequestSchema)` to create a new message.
 */
export const SaveAiSkillRequestSchema: GenMessage<SaveAiSkillRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 796);

/**
 * @generated from message zdc.DeleteAiSkillRequest
 */
export type DeleteAiSkillRequest = Message<"zdc.DeleteAiSkillRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteAiSkillRequest.
 * Use `create(DeleteAiSkillRequestSchema)` to create a new message.
 */
export const DeleteAiSkillRequestSchema: GenMessage<DeleteAiSkillRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 797);

/**
 * --- Персональный ассистент: назначения (подмена агента/модели) ---
 * P1 «Гибкие назначения» (2026-10-29): провайдер/ссылка на ключ/суточный
 * потолок/включённость/срок. СЕКРЕТЫ НАРУЖУ НЕ ХОДЯТ: key_ref — только
 * ССЫЛКА (base | user:<entity_id> | instance), сам ключ остаётся в
 * провайдере; сервер валидирует формат при сохранении.
 *
 * @generated from message zdc.AssistantAssignment
 */
export type AssistantAssignment = Message<"zdc.AssistantAssignment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * user | role | global
   *
   * @generated from field: string scope = 2;
   */
  scope: string;

  /**
   * entity_id | role_id (global — пусто)
   *
   * @generated from field: string scope_id = 3;
   */
  scopeId: string;

  /**
   * какой агент-ассистент ('' = системный default)
   *
   * @generated from field: string agent_code = 4;
   */
  agentCode: string;

  /**
   * логическая модель ('' = модель агента)
   *
   * @generated from field: string model_id = 5;
   */
  modelId: string;

  /**
   * краткий стиль общения
   *
   * @generated from field: string style = 6;
   */
  style: string;

  /**
   * @generated from field: string created_by = 7;
   */
  createdBy: string;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 9;
   */
  updatedAt: string;

  /**
   * P1: провайдер назначения ('' = из модели/агента/базы); приоритетнее модели.
   *
   * @generated from field: string provider_id = 10;
   */
  providerId: string;

  /**
   * P1: ссылка на ключ: '' | base | user:<entity_id> | instance (НЕ сам ключ).
   *
   * @generated from field: string key_ref = 11;
   */
  keyRef: string;

  /**
   * P1: суточный потолок расхода (0 = без лимита; единицы — внутренний учёт).
   *
   * @generated from field: double daily_cost_limit = 12;
   */
  dailyCostLimit: number;

  /**
   * P1: false — назначение не применяется (NULL в БД = включено —
   * presence через optional: клиент может не передавать и не сбрасывать).
   *
   * @generated from field: optional bool is_enabled = 13;
   */
  isEnabled?: boolean | undefined;

  /**
   * P1: срок действия, RFC3339 ('' = бессрочно).
   *
   * @generated from field: string valid_to = 14;
   */
  validTo: string;
};

/**
 * Describes the message zdc.AssistantAssignment.
 * Use `create(AssistantAssignmentSchema)` to create a new message.
 */
export const AssistantAssignmentSchema: GenMessage<AssistantAssignment> = /*@__PURE__*/
  messageDesc(file_zdc, 798);

/**
 * @generated from message zdc.ListAssistantAssignmentsResponse
 */
export type ListAssistantAssignmentsResponse = Message<"zdc.ListAssistantAssignmentsResponse"> & {
  /**
   * @generated from field: repeated zdc.AssistantAssignment items = 1;
   */
  items: AssistantAssignment[];
};

/**
 * Describes the message zdc.ListAssistantAssignmentsResponse.
 * Use `create(ListAssistantAssignmentsResponseSchema)` to create a new message.
 */
export const ListAssistantAssignmentsResponseSchema: GenMessage<ListAssistantAssignmentsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 799);

/**
 * @generated from message zdc.DeleteAssistantAssignmentRequest
 */
export type DeleteAssistantAssignmentRequest = Message<"zdc.DeleteAssistantAssignmentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteAssistantAssignmentRequest.
 * Use `create(DeleteAssistantAssignmentRequestSchema)` to create a new message.
 */
export const DeleteAssistantAssignmentRequestSchema: GenMessage<DeleteAssistantAssignmentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 800);

/**
 * --- Профиль пользователя для ассистента ---
 *
 * @generated from message zdc.AiUserProfile
 */
export type AiUserProfile = Message<"zdc.AiUserProfile"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * сжатый профиль
   *
   * @generated from field: string summary = 2;
   */
  summary: string;

  /**
   * цели/задачи
   *
   * @generated from field: repeated string goals = 3;
   */
  goals: string[];

  /**
   * предпочтения
   *
   * @generated from field: repeated string preferences = 4;
   */
  preferences: string[];

  /**
   * частые темы
   *
   * @generated from field: repeated string topics = 5;
   */
  topics: string[];

  /**
   * @generated from field: string updated_at = 6;
   */
  updatedAt: string;

  /**
   * Грани личности (профиль-аналитик извлекает из диалогов; пользователь правит):
   *
   * желания
   *
   * @generated from field: repeated string desires = 7;
   */
  desires: string[];

  /**
   * потребности
   *
   * @generated from field: repeated string needs = 8;
   */
  needs: string[];

  /**
   * увлечения
   *
   * @generated from field: repeated string hobbies = 9;
   */
  hobbies: string[];

  /**
   * занятия
   *
   * @generated from field: repeated string activities = 10;
   */
  activities: string[];

  /**
   * стиль общения/работы
   *
   * @generated from field: repeated string style = 11;
   */
  style: string[];

  /**
   * черты характера
   *
   * @generated from field: repeated string character = 12;
   */
  character: string[];

  /**
   * Ближний круг:
   *
   * домашние питомцы
   *
   * @generated from field: repeated string pets = 13;
   */
  pets: string[];

  /**
   * родственники
   *
   * @generated from field: repeated string relatives = 14;
   */
  relatives: string[];

  /**
   * знакомые
   *
   * @generated from field: repeated string acquaintances = 15;
   */
  acquaintances: string[];

  /**
   * друзья
   *
   * @generated from field: repeated string friends = 16;
   */
  friends: string[];
};

/**
 * Describes the message zdc.AiUserProfile.
 * Use `create(AiUserProfileSchema)` to create a new message.
 */
export const AiUserProfileSchema: GenMessage<AiUserProfile> = /*@__PURE__*/
  messageDesc(file_zdc, 801);

/**
 * @generated from message zdc.GetUserProfileRequest
 */
export type GetUserProfileRequest = Message<"zdc.GetUserProfileRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message zdc.GetUserProfileRequest.
 * Use `create(GetUserProfileRequestSchema)` to create a new message.
 */
export const GetUserProfileRequestSchema: GenMessage<GetUserProfileRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 802);

/**
 * @generated from message zdc.SaveUserProfileRequest
 */
export type SaveUserProfileRequest = Message<"zdc.SaveUserProfileRequest"> & {
  /**
   * пусто = свой (чужой — только админ)
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string summary = 2;
   */
  summary: string;

  /**
   * @generated from field: repeated string goals = 3;
   */
  goals: string[];

  /**
   * @generated from field: repeated string preferences = 4;
   */
  preferences: string[];

  /**
   * @generated from field: repeated string topics = 5;
   */
  topics: string[];

  /**
   * @generated from field: repeated string desires = 6;
   */
  desires: string[];

  /**
   * @generated from field: repeated string needs = 7;
   */
  needs: string[];

  /**
   * @generated from field: repeated string hobbies = 8;
   */
  hobbies: string[];

  /**
   * @generated from field: repeated string activities = 9;
   */
  activities: string[];

  /**
   * @generated from field: repeated string style = 10;
   */
  style: string[];

  /**
   * @generated from field: repeated string character = 11;
   */
  character: string[];

  /**
   * @generated from field: repeated string pets = 12;
   */
  pets: string[];

  /**
   * @generated from field: repeated string relatives = 13;
   */
  relatives: string[];

  /**
   * @generated from field: repeated string acquaintances = 14;
   */
  acquaintances: string[];

  /**
   * @generated from field: repeated string friends = 15;
   */
  friends: string[];
};

/**
 * Describes the message zdc.SaveUserProfileRequest.
 * Use `create(SaveUserProfileRequestSchema)` to create a new message.
 */
export const SaveUserProfileRequestSchema: GenMessage<SaveUserProfileRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 803);

/**
 * --- Агенты ---
 *
 * @generated from message zdc.AiAgent
 */
export type AiAgent = Message<"zdc.AiAgent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * системный промт (характер/инструкции)
   *
   * @generated from field: string prompt = 5;
   */
  prompt: string;

  /**
   * → AiProvider
   *
   * @generated from field: string provider_id = 6;
   */
  providerId: string;

  /**
   * (denorm для HCP/отображения)
   *
   * @generated from field: string provider_code = 7;
   */
  providerCode: string;

  /**
   * переопределение модели (пусто = из провайдера)
   *
   * @generated from field: string model = 8;
   */
  model: string;

  /**
   * @generated from field: double temperature = 9;
   */
  temperature: number;

  /**
   * @generated from field: int32 max_tokens = 10;
   */
  maxTokens: number;

  /**
   * коды инструментов (реестр AiTool)
   *
   * @generated from field: repeated string tools = 11;
   */
  tools: string[];

  /**
   * '' | 'global' | 'session' | 'per_user' — какая память
   *
   * @generated from field: string memory_scope = 12;
   */
  memoryScope: string;

  /**
   * права вызова (пусто = любой авторизованный)
   *
   * @generated from field: repeated string roles = 13;
   */
  roles: string[];

  /**
   * @generated from field: bool is_system = 14;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 15;
   */
  templateId: string;

  /**
   * @generated from field: string created_at = 16;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 17;
   */
  updatedAt: string;

  /**
   * ЛОГИЧЕСКАЯ модель (id из metadata_ai_models): агент работает через модель —
   * смена провайдера/реальной модели у модели НЕ затрагивает агента.
   *
   * @generated from field: string model_id = 18;
   */
  modelId: string;

  /**
   * denorm (реальная модель провайдера модели)
   *
   * @generated from field: string model_code = 19;
   */
  modelCode: string;

  /**
   * Контекст диалога: лимит токенов истории (0 = по умолчанию ~4000).
   * Свыше лимита — старые сообщения вытесняются (скользящее окно по токенам,
   * эвристика chars/4 до запроса; точный usage — от провайдера после ответа).
   *
   * @generated from field: int32 context_limit_tokens = 20;
   */
  contextLimitTokens: number;

  /**
   * Включён/выключен: ОТКЛЮЧЁННЫЙ агент недоступен (Ask → явная ошибка).
   *
   * @generated from field: bool is_enabled = 21;
   */
  isEnabled: boolean;

  /**
   * Приложение-владелец агента ('' = ядро/общий/системный агент).
   *
   * @generated from field: string app_code = 22;
   */
  appCode: string;

  /**
   * Трасинг диалога: каждый ход (user/assistant/tool) пишется в журнал
   * регистрации (категория ai) — для разбора и аудита.
   *
   * @generated from field: bool trace_enabled = 23;
   */
  traceEnabled: boolean;

  /**
   * МУЛЬТИМОДЕЛЬНОСТЬ: назначение (purpose: default/vision/image/voice/reasoning)
   * → логическая модель. Агент использует разные модели по назначению;
   * субагенты наследуют модель под свою роль. Пусто = одна модель (model_id).
   *
   * @generated from field: map<string, string> model_mapping = 24;
   */
  modelMapping: { [key: string]: string };
};

/**
 * Describes the message zdc.AiAgent.
 * Use `create(AiAgentSchema)` to create a new message.
 */
export const AiAgentSchema: GenMessage<AiAgent> = /*@__PURE__*/
  messageDesc(file_zdc, 804);

/**
 * @generated from message zdc.ListAiAgentsResponse
 */
export type ListAiAgentsResponse = Message<"zdc.ListAiAgentsResponse"> & {
  /**
   * @generated from field: repeated zdc.AiAgent items = 1;
   */
  items: AiAgent[];
};

/**
 * Describes the message zdc.ListAiAgentsResponse.
 * Use `create(ListAiAgentsResponseSchema)` to create a new message.
 */
export const ListAiAgentsResponseSchema: GenMessage<ListAiAgentsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 805);

/**
 * @generated from message zdc.GetAiAgentRequest
 */
export type GetAiAgentRequest = Message<"zdc.GetAiAgentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetAiAgentRequest.
 * Use `create(GetAiAgentRequestSchema)` to create a new message.
 */
export const GetAiAgentRequestSchema: GenMessage<GetAiAgentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 806);

/**
 * @generated from message zdc.SaveAiAgentRequest
 */
export type SaveAiAgentRequest = Message<"zdc.SaveAiAgentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string prompt = 5;
   */
  prompt: string;

  /**
   * @generated from field: string provider_id = 6;
   */
  providerId: string;

  /**
   * @generated from field: string model = 7;
   */
  model: string;

  /**
   * @generated from field: double temperature = 8;
   */
  temperature: number;

  /**
   * @generated from field: int32 max_tokens = 9;
   */
  maxTokens: number;

  /**
   * @generated from field: repeated string tools = 10;
   */
  tools: string[];

  /**
   * @generated from field: string memory_scope = 11;
   */
  memoryScope: string;

  /**
   * @generated from field: repeated string roles = 12;
   */
  roles: string[];

  /**
   * логическая модель (приоритет над model)
   *
   * @generated from field: string model_id = 13;
   */
  modelId: string;

  /**
   * лимит токенов истории диалога (0 = default)
   *
   * @generated from field: int32 context_limit_tokens = 14;
   */
  contextLimitTokens: number;

  /**
   * включён/выключен (отключённый недоступен)
   *
   * @generated from field: bool is_enabled = 15;
   */
  isEnabled: boolean;

  /**
   * приложение-владелец ('' = общий; только админ)
   *
   * @generated from field: string app_code = 16;
   */
  appCode: string;

  /**
   * трасинг диалога (лог ходов в журнал регистрации)
   *
   * @generated from field: bool trace_enabled = 17;
   */
  traceEnabled: boolean;

  /**
   * мультимодельность: purpose → model_id
   *
   * @generated from field: map<string, string> model_mapping = 18;
   */
  modelMapping: { [key: string]: string };
};

/**
 * Describes the message zdc.SaveAiAgentRequest.
 * Use `create(SaveAiAgentRequestSchema)` to create a new message.
 */
export const SaveAiAgentRequestSchema: GenMessage<SaveAiAgentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 807);

/**
 * @generated from message zdc.DeleteAiAgentRequest
 */
export type DeleteAiAgentRequest = Message<"zdc.DeleteAiAgentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteAiAgentRequest.
 * Use `create(DeleteAiAgentRequestSchema)` to create a new message.
 */
export const DeleteAiAgentRequestSchema: GenMessage<DeleteAiAgentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 808);

/**
 * @generated from message zdc.TestAiAgentRequest
 */
export type TestAiAgentRequest = Message<"zdc.TestAiAgentRequest"> & {
  /**
   * тест СОХРАНЁННОГО агента
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * тестовый запрос (default «Привет, расскажи о себе»)
   *
   * @generated from field: string prompt = 2;
   */
  prompt: string;
};

/**
 * Describes the message zdc.TestAiAgentRequest.
 * Use `create(TestAiAgentRequestSchema)` to create a new message.
 */
export const TestAiAgentRequestSchema: GenMessage<TestAiAgentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 809);

/**
 * @generated from message zdc.TestAiAgentResponse
 */
export type TestAiAgentResponse = Message<"zdc.TestAiAgentResponse"> & {
  /**
   * @generated from field: string result = 1;
   */
  result: string;

  /**
   * @generated from field: int32 duration_ms = 2;
   */
  durationMs: number;

  /**
   * какие инструменты вызывались
   *
   * @generated from field: repeated string tool_calls = 3;
   */
  toolCalls: string[];

  /**
   * @generated from field: string error = 4;
   */
  error: string;
};

/**
 * Describes the message zdc.TestAiAgentResponse.
 * Use `create(TestAiAgentResponseSchema)` to create a new message.
 */
export const TestAiAgentResponseSchema: GenMessage<TestAiAgentResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 810);

/**
 * --- AskAgent: вызов агента (синхронно) ---
 *
 * @generated from message zdc.AskAgentRequest
 */
export type AskAgentRequest = Message<"zdc.AskAgentRequest"> & {
  /**
   * код агента (или id)
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * запрос
   *
   * @generated from field: string prompt = 2;
   */
  prompt: string;

  /**
   * параметры (доп. контекст)
   *
   * @generated from field: map<string, string> params = 3;
   */
  params: { [key: string]: string };
};

/**
 * Describes the message zdc.AskAgentRequest.
 * Use `create(AskAgentRequestSchema)` to create a new message.
 */
export const AskAgentRequestSchema: GenMessage<AskAgentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 811);

/**
 * @generated from message zdc.AskAgentResponse
 */
export type AskAgentResponse = Message<"zdc.AskAgentResponse"> & {
  /**
   * @generated from field: string result = 1;
   */
  result: string;

  /**
   * @generated from field: int32 duration_ms = 2;
   */
  durationMs: number;

  /**
   * @generated from field: repeated string tool_calls = 3;
   */
  toolCalls: string[];

  /**
   * @generated from field: string error = 4;
   */
  error: string;
};

/**
 * Describes the message zdc.AskAgentResponse.
 * Use `create(AskAgentResponseSchema)` to create a new message.
 */
export const AskAgentResponseSchema: GenMessage<AskAgentResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 812);

/**
 * @generated from message zdc.AskAgentToolInfo
 */
export type AskAgentToolInfo = Message<"zdc.AskAgentToolInfo"> & {
  /**
   * имя инструмента (функции модели)
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * id вызова — корреляция START/RESULT
   *
   * @generated from field: string call_id = 2;
   */
  callId: string;
};

/**
 * Describes the message zdc.AskAgentToolInfo.
 * Use `create(AskAgentToolInfoSchema)` to create a new message.
 */
export const AskAgentToolInfoSchema: GenMessage<AskAgentToolInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 813);

/**
 * @generated from message zdc.AskAgentUsage
 */
export type AskAgentUsage = Message<"zdc.AskAgentUsage"> & {
  /**
   * @generated from field: int32 prompt_tokens = 1;
   */
  promptTokens: number;

  /**
   * @generated from field: int32 completion_tokens = 2;
   */
  completionTokens: number;

  /**
   * @generated from field: int32 total_tokens = 3;
   */
  totalTokens: number;
};

/**
 * Describes the message zdc.AskAgentUsage.
 * Use `create(AskAgentUsageSchema)` to create a new message.
 */
export const AskAgentUsageSchema: GenMessage<AskAgentUsage> = /*@__PURE__*/
  messageDesc(file_zdc, 814);

/**
 * @generated from message zdc.AskAgentChunk
 */
export type AskAgentChunk = Message<"zdc.AskAgentChunk"> & {
  /**
   * @generated from field: zdc.AskAgentChunkType type = 1;
   */
  type: AskAgentChunkType;

  /**
   * текст (TEXT_DELTA/TOOL_RESULT)
   *
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * метаданные инструмента (TOOL_START/TOOL_RESULT)
   *
   * @generated from field: zdc.AskAgentToolInfo tool = 3;
   */
  tool?: AskAgentToolInfo | undefined;

  /**
   * токены (только DONE; провайдер не дал — пусто)
   *
   * @generated from field: zdc.AskAgentUsage usage = 4;
   */
  usage?: AskAgentUsage | undefined;
};

/**
 * Describes the message zdc.AskAgentChunk.
 * Use `create(AskAgentChunkSchema)` to create a new message.
 */
export const AskAgentChunkSchema: GenMessage<AskAgentChunk> = /*@__PURE__*/
  messageDesc(file_zdc, 815);

/**
 * --- Память (граф) ---
 *
 * @generated from message zdc.AiMemoryNode
 */
export type AiMemoryNode = Message<"zdc.AiMemoryNode"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 'agent' | 'entity' | ...
   *
   * @generated from field: string subject_type = 2;
   */
  subjectType: string;

  /**
   * @generated from field: string subject_id = 3;
   */
  subjectId: string;

  /**
   * 'global' | 'current' | 'session' | 'per_user'
   *
   * @generated from field: string level = 4;
   */
  level: string;

  /**
   * @generated from field: string title = 5;
   */
  title: string;

  /**
   * JSON
   *
   * @generated from field: string content = 6;
   */
  content: string;

  /**
   * владелец узла (для per_user)
   *
   * @generated from field: string owner_id = 7;
   */
  ownerId: string;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;

  /**
   * кластеризация ПАМЯТИ ПО ДИАЛОГУ (чат) — узлы сессии
   *
   * @generated from field: string conversation_id = 9;
   */
  conversationId: string;
};

/**
 * Describes the message zdc.AiMemoryNode.
 * Use `create(AiMemoryNodeSchema)` to create a new message.
 */
export const AiMemoryNodeSchema: GenMessage<AiMemoryNode> = /*@__PURE__*/
  messageDesc(file_zdc, 816);

/**
 * @generated from message zdc.AiMemoryEdge
 */
export type AiMemoryEdge = Message<"zdc.AiMemoryEdge"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string from_node_id = 2;
   */
  fromNodeId: string;

  /**
   * @generated from field: string to_node_id = 3;
   */
  toNodeId: string;

  /**
   * @generated from field: string relation = 4;
   */
  relation: string;
};

/**
 * Describes the message zdc.AiMemoryEdge.
 * Use `create(AiMemoryEdgeSchema)` to create a new message.
 */
export const AiMemoryEdgeSchema: GenMessage<AiMemoryEdge> = /*@__PURE__*/
  messageDesc(file_zdc, 817);

/**
 * @generated from message zdc.ListAiMemoryResponse
 */
export type ListAiMemoryResponse = Message<"zdc.ListAiMemoryResponse"> & {
  /**
   * @generated from field: repeated zdc.AiMemoryNode nodes = 1;
   */
  nodes: AiMemoryNode[];

  /**
   * @generated from field: repeated zdc.AiMemoryEdge edges = 2;
   */
  edges: AiMemoryEdge[];
};

/**
 * Describes the message zdc.ListAiMemoryResponse.
 * Use `create(ListAiMemoryResponseSchema)` to create a new message.
 */
export const ListAiMemoryResponseSchema: GenMessage<ListAiMemoryResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 818);

/**
 * @generated from message zdc.SaveAiMemoryNodeRequest
 */
export type SaveAiMemoryNodeRequest = Message<"zdc.SaveAiMemoryNodeRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string subject_type = 2;
   */
  subjectType: string;

  /**
   * @generated from field: string subject_id = 3;
   */
  subjectId: string;

  /**
   * @generated from field: string level = 4;
   */
  level: string;

  /**
   * @generated from field: string title = 5;
   */
  title: string;

  /**
   * @generated from field: string content = 6;
   */
  content: string;

  /**
   * @generated from field: string owner_id = 7;
   */
  ownerId: string;

  /**
   * @generated from field: string conversation_id = 8;
   */
  conversationId: string;
};

/**
 * Describes the message zdc.SaveAiMemoryNodeRequest.
 * Use `create(SaveAiMemoryNodeRequestSchema)` to create a new message.
 */
export const SaveAiMemoryNodeRequestSchema: GenMessage<SaveAiMemoryNodeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 819);

/**
 * @generated from message zdc.DeleteAiMemoryRequest
 */
export type DeleteAiMemoryRequest = Message<"zdc.DeleteAiMemoryRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteAiMemoryRequest.
 * Use `create(DeleteAiMemoryRequestSchema)` to create a new message.
 */
export const DeleteAiMemoryRequestSchema: GenMessage<DeleteAiMemoryRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 820);

/**
 * --- Адаптеры внешних систем ---
 *
 * @generated from message zdc.AiAdapter
 */
export type AiAdapter = Message<"zdc.AiAdapter"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 'internal' | 'telegram' | ... (реестр)
   *
   * @generated from field: string adapter_type = 4;
   */
  adapterType: string;

  /**
   * настройки (секреты не возвращаются)
   *
   * @generated from field: map<string, string> settings = 5;
   */
  settings: { [key: string]: string };

  /**
   * @generated from field: bool enabled = 6;
   */
  enabled: boolean;

  /**
   * @generated from field: bool is_system = 7;
   */
  isSystem: boolean;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 9;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.AiAdapter.
 * Use `create(AiAdapterSchema)` to create a new message.
 */
export const AiAdapterSchema: GenMessage<AiAdapter> = /*@__PURE__*/
  messageDesc(file_zdc, 821);

/**
 * @generated from message zdc.AiAdapterTypeInfo
 */
export type AiAdapterTypeInfo = Message<"zdc.AiAdapterTypeInfo"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string display = 2;
   */
  display: string;

  /**
   * @generated from field: repeated zdc.ExternalApiFieldSchema fields = 3;
   */
  fields: ExternalApiFieldSchema[];
};

/**
 * Describes the message zdc.AiAdapterTypeInfo.
 * Use `create(AiAdapterTypeInfoSchema)` to create a new message.
 */
export const AiAdapterTypeInfoSchema: GenMessage<AiAdapterTypeInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 822);

/**
 * @generated from message zdc.ListAiAdaptersResponse
 */
export type ListAiAdaptersResponse = Message<"zdc.ListAiAdaptersResponse"> & {
  /**
   * @generated from field: repeated zdc.AiAdapter items = 1;
   */
  items: AiAdapter[];
};

/**
 * Describes the message zdc.ListAiAdaptersResponse.
 * Use `create(ListAiAdaptersResponseSchema)` to create a new message.
 */
export const ListAiAdaptersResponseSchema: GenMessage<ListAiAdaptersResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 823);

/**
 * @generated from message zdc.ListAiAdapterTypesResponse
 */
export type ListAiAdapterTypesResponse = Message<"zdc.ListAiAdapterTypesResponse"> & {
  /**
   * @generated from field: repeated zdc.AiAdapterTypeInfo items = 1;
   */
  items: AiAdapterTypeInfo[];
};

/**
 * Describes the message zdc.ListAiAdapterTypesResponse.
 * Use `create(ListAiAdapterTypesResponseSchema)` to create a new message.
 */
export const ListAiAdapterTypesResponseSchema: GenMessage<ListAiAdapterTypesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 824);

/**
 * @generated from message zdc.SaveAiAdapterRequest
 */
export type SaveAiAdapterRequest = Message<"zdc.SaveAiAdapterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string adapter_type = 4;
   */
  adapterType: string;

  /**
   * @generated from field: map<string, string> settings = 5;
   */
  settings: { [key: string]: string };

  /**
   * @generated from field: bool enabled = 6;
   */
  enabled: boolean;
};

/**
 * Describes the message zdc.SaveAiAdapterRequest.
 * Use `create(SaveAiAdapterRequestSchema)` to create a new message.
 */
export const SaveAiAdapterRequestSchema: GenMessage<SaveAiAdapterRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 825);

/**
 * @generated from message zdc.DeleteAiAdapterRequest
 */
export type DeleteAiAdapterRequest = Message<"zdc.DeleteAiAdapterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteAiAdapterRequest.
 * Use `create(DeleteAiAdapterRequestSchema)` to create a new message.
 */
export const DeleteAiAdapterRequestSchema: GenMessage<DeleteAiAdapterRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 826);

/**
 * @generated from message zdc.TestAiAdapterRequest
 */
export type TestAiAdapterRequest = Message<"zdc.TestAiAdapterRequest"> & {
  /**
   * тест сохранённого
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * ИЛИ нового
   *
   * @generated from field: string adapter_type = 2;
   */
  adapterType: string;

  /**
   * @generated from field: map<string, string> settings = 3;
   */
  settings: { [key: string]: string };

  /**
   * адресат (chat_id/логин) для внешних
   *
   * @generated from field: string target = 4;
   */
  target: string;
};

/**
 * Describes the message zdc.TestAiAdapterRequest.
 * Use `create(TestAiAdapterRequestSchema)` to create a new message.
 */
export const TestAiAdapterRequestSchema: GenMessage<TestAiAdapterRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 827);

/**
 * --- Боты/Личности (сущности kind='bot'|'persona') ---
 *
 * @generated from message zdc.AiBot
 */
export type AiBot = Message<"zdc.AiBot"> & {
  /**
   * id СУЩНОСТИ (entities)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string login = 2;
   */
  login: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 'bot' | 'persona'
   *
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * агент (из metadata_ai_agents) — может быть пуст
   *
   * @generated from field: string agent_code = 6;
   */
  agentCode: string;

  /**
   * '' (внутренний) | код адаптера
   *
   * @generated from field: string transport = 7;
   */
  transport: string;

  /**
   * @generated from field: string avatar_url = 8;
   */
  avatarUrl: string;

  /**
   * @generated from field: bool active = 9;
   */
  active: boolean;

  /**
   * @generated from field: bool is_system = 10;
   */
  isSystem: boolean;

  /**
   * @generated from field: string last_seen_at = 11;
   */
  lastSeenAt: string;
};

/**
 * Describes the message zdc.AiBot.
 * Use `create(AiBotSchema)` to create a new message.
 */
export const AiBotSchema: GenMessage<AiBot> = /*@__PURE__*/
  messageDesc(file_zdc, 828);

/**
 * @generated from message zdc.ListAiBotsResponse
 */
export type ListAiBotsResponse = Message<"zdc.ListAiBotsResponse"> & {
  /**
   * @generated from field: repeated zdc.AiBot items = 1;
   */
  items: AiBot[];
};

/**
 * Describes the message zdc.ListAiBotsResponse.
 * Use `create(ListAiBotsResponseSchema)` to create a new message.
 */
export const ListAiBotsResponseSchema: GenMessage<ListAiBotsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 829);

/**
 * @generated from message zdc.SaveAiBotRequest
 */
export type SaveAiBotRequest = Message<"zdc.SaveAiBotRequest"> & {
  /**
   * пусто = создать
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string login = 2;
   */
  login: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: string agent_id = 6;
   */
  agentId: string;

  /**
   * @generated from field: string transport = 7;
   */
  transport: string;

  /**
   * @generated from field: string avatar_url = 8;
   */
  avatarUrl: string;

  /**
   * @generated from field: bool active = 9;
   */
  active: boolean;
};

/**
 * Describes the message zdc.SaveAiBotRequest.
 * Use `create(SaveAiBotRequestSchema)` to create a new message.
 */
export const SaveAiBotRequestSchema: GenMessage<SaveAiBotRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 830);

/**
 * @generated from message zdc.DeleteAiBotRequest
 */
export type DeleteAiBotRequest = Message<"zdc.DeleteAiBotRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteAiBotRequest.
 * Use `create(DeleteAiBotRequestSchema)` to create a new message.
 */
export const DeleteAiBotRequestSchema: GenMessage<DeleteAiBotRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 831);

/**
 * --- Привязки бота к транспортам (волна 1a) ---
 * Бот (сущность kind='bot'|'persona') привязывается к транспорту: internal
 * (внутренний чат платформы) либо adapter (экземпляр адаптера, у типа которого
 * supports_bot_binding). Боты НЕ пишутся в adapter_links (та таблица — про
 * людей-контактов). Секреты здесь НЕ хранятся (только adapters.settings).
 *
 * @generated from message zdc.BotTransportReceiveState
 */
export type BotTransportReceiveState = Message<"zdc.BotTransportReceiveState"> & {
  /**
   * @generated from field: bool running = 1;
   */
  running: boolean;

  /**
   * @generated from field: string last_error = 2;
   */
  lastError: string;

  /**
   * @generated from field: string last_error_at = 3;
   */
  lastErrorAt: string;

  /**
   * @generated from field: string last_update_at = 4;
   */
  lastUpdateAt: string;

  /**
   * poll | webhook — режим приёма из настроек привязки
   *
   * @generated from field: string mode = 5;
   */
  mode: string;

  /**
   * пропущено ограничителем приёма (с момента запуска сервера)
   *
   * @generated from field: int64 dropped_inbound = 6;
   */
  droppedInbound: bigint;

  /**
   * отклонено ограничителем отправки/flood-блокировкой
   *
   * @generated from field: int64 dropped_outbound = 7;
   */
  droppedOutbound: bigint;
};

/**
 * Describes the message zdc.BotTransportReceiveState.
 * Use `create(BotTransportReceiveStateSchema)` to create a new message.
 */
export const BotTransportReceiveStateSchema: GenMessage<BotTransportReceiveState> = /*@__PURE__*/
  messageDesc(file_zdc, 832);

/**
 * @generated from message zdc.BotTransport
 */
export type BotTransport = Message<"zdc.BotTransport"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * сущность-бот
   *
   * @generated from field: string bot_id = 2;
   */
  botId: string;

  /**
   * internal | adapter
   *
   * @generated from field: string transport_kind = 3;
   */
  transportKind: string;

  /**
   * @generated from field: string adapter_id = 4;
   */
  adapterId: string;

  /**
   * резолв сервера (для UI)
   *
   * @generated from field: string adapter_name = 5;
   */
  adapterName: string;

  /**
   * telegram_bot | max_bot | ...
   *
   * @generated from field: string adapter_type = 6;
   */
  adapterType: string;

  /**
   * inbound | outbound | both
   *
   * @generated from field: string direction = 7;
   */
  direction: string;

  /**
   * primary | mirror | fallback
   *
   * @generated from field: string mode = 8;
   */
  mode: string;

  /**
   * JSON (несекретный)
   *
   * @generated from field: string settings = 9;
   */
  settings: string;

  /**
   * @generated from field: bool enabled = 10;
   */
  enabled: boolean;

  /**
   * состояние приёма (runtime)
   *
   * @generated from field: zdc.BotTransportReceiveState receive = 11;
   */
  receive?: BotTransportReceiveState | undefined;

  /**
   * @generated from field: string created_at = 12;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 13;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.BotTransport.
 * Use `create(BotTransportSchema)` to create a new message.
 */
export const BotTransportSchema: GenMessage<BotTransport> = /*@__PURE__*/
  messageDesc(file_zdc, 833);

/**
 * @generated from message zdc.ListBotTransportsRequest
 */
export type ListBotTransportsRequest = Message<"zdc.ListBotTransportsRequest"> & {
  /**
   * @generated from field: string bot_id = 1;
   */
  botId: string;
};

/**
 * Describes the message zdc.ListBotTransportsRequest.
 * Use `create(ListBotTransportsRequestSchema)` to create a new message.
 */
export const ListBotTransportsRequestSchema: GenMessage<ListBotTransportsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 834);

/**
 * @generated from message zdc.ListBotTransportsResponse
 */
export type ListBotTransportsResponse = Message<"zdc.ListBotTransportsResponse"> & {
  /**
   * @generated from field: repeated zdc.BotTransport items = 1;
   */
  items: BotTransport[];
};

/**
 * Describes the message zdc.ListBotTransportsResponse.
 * Use `create(ListBotTransportsResponseSchema)` to create a new message.
 */
export const ListBotTransportsResponseSchema: GenMessage<ListBotTransportsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 835);

/**
 * @generated from message zdc.SaveBotTransportRequest
 */
export type SaveBotTransportRequest = Message<"zdc.SaveBotTransportRequest"> & {
  /**
   * пусто = создать
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string bot_id = 2;
   */
  botId: string;

  /**
   * @generated from field: string transport_kind = 3;
   */
  transportKind: string;

  /**
   * @generated from field: string adapter_id = 4;
   */
  adapterId: string;

  /**
   * inbound | outbound | both
   *
   * @generated from field: string direction = 5;
   */
  direction: string;

  /**
   * primary | mirror | fallback
   *
   * @generated from field: string mode = 6;
   */
  mode: string;

  /**
   * JSON (несекретный)
   *
   * @generated from field: string settings = 7;
   */
  settings: string;

  /**
   * @generated from field: bool enabled = 8;
   */
  enabled: boolean;
};

/**
 * Describes the message zdc.SaveBotTransportRequest.
 * Use `create(SaveBotTransportRequestSchema)` to create a new message.
 */
export const SaveBotTransportRequestSchema: GenMessage<SaveBotTransportRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 836);

/**
 * @generated from message zdc.DeleteBotTransportRequest
 */
export type DeleteBotTransportRequest = Message<"zdc.DeleteBotTransportRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteBotTransportRequest.
 * Use `create(DeleteBotTransportRequestSchema)` to create a new message.
 */
export const DeleteBotTransportRequestSchema: GenMessage<DeleteBotTransportRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 837);

/**
 * --- Передача диалога человеку (волна 1c, §4.6/§5.1) ---
 * История и активные передачи: ОДНА активная передача на диалог; история
 * неизменяема (возврат — состояние returned, запись не удаляется). Гейты —
 * SSoT механизма (handoff.go): «взять» — админ ИЛИ роль-очередь; «вернуть» —
 * назначенный оператор ИЛИ админ. RPC — рабочие методы Предприятия
 * (НЕ конфигуратор: оператор работает в публикации).
 *
 * @generated from message zdc.BotHandoff
 */
export type BotHandoff = Message<"zdc.BotHandoff"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * чат диалога
   *
   * @generated from field: string conversation_id = 2;
   */
  conversationId: string;

  /**
   * бот диалога (сущность)
   *
   * @generated from field: string bot_id = 3;
   */
  botId: string;

  /**
   * собеседник-человек (сущность)
   *
   * @generated from field: string person_id = 4;
   */
  personId: string;

  /**
   * requested | active | returned
   *
   * @generated from field: string state = 5;
   */
  state: string;

  /**
   * command | manual | agent
   *
   * @generated from field: string source = 6;
   */
  source: string;

  /**
   * кто инициировал
   *
   * @generated from field: string requested_by = 7;
   */
  requestedBy: string;

  /**
   * оператор, взявший диалог
   *
   * @generated from field: string assigned_entity_id = 8;
   */
  assignedEntityId: string;

  /**
   * имя оператора (резолв сервера, для UI)
   *
   * @generated from field: string assigned_name = 9;
   */
  assignedName: string;

  /**
   * роль-очередь (по умолчанию «Оператор»)
   *
   * @generated from field: string role_code = 10;
   */
  roleCode: string;

  /**
   * причина/комментарий запроса
   *
   * @generated from field: string reason = 11;
   */
  reason: string;

  /**
   * @generated from field: string created_at = 12;
   */
  createdAt: string;

  /**
   * @generated from field: string assigned_at = 13;
   */
  assignedAt: string;

  /**
   * @generated from field: string returned_at = 14;
   */
  returnedAt: string;
};

/**
 * Describes the message zdc.BotHandoff.
 * Use `create(BotHandoffSchema)` to create a new message.
 */
export const BotHandoffSchema: GenMessage<BotHandoff> = /*@__PURE__*/
  messageDesc(file_zdc, 838);

/**
 * @generated from message zdc.ListBotHandoffsRequest
 */
export type ListBotHandoffsRequest = Message<"zdc.ListBotHandoffsRequest"> & {
  /**
   * пусто = все боты
   *
   * @generated from field: string bot_id = 1;
   */
  botId: string;

  /**
   * пусто = все диалоги
   *
   * @generated from field: string conversation_id = 2;
   */
  conversationId: string;

  /**
   * пусто = все; requested | active | returned
   *
   * @generated from field: string state = 3;
   */
  state: string;

  /**
   * RFC3339 (created_at >=)
   *
   * @generated from field: string from_ts = 4;
   */
  fromTs: string;

  /**
   * RFC3339 (created_at <=)
   *
   * @generated from field: string to_ts = 5;
   */
  toTs: string;

  /**
   * страница: default 50, максимум 200
   *
   * @generated from field: int32 limit = 6;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 7;
   */
  offset: number;
};

/**
 * Describes the message zdc.ListBotHandoffsRequest.
 * Use `create(ListBotHandoffsRequestSchema)` to create a new message.
 */
export const ListBotHandoffsRequestSchema: GenMessage<ListBotHandoffsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 839);

/**
 * @generated from message zdc.ListBotHandoffsResponse
 */
export type ListBotHandoffsResponse = Message<"zdc.ListBotHandoffsResponse"> & {
  /**
   * @generated from field: repeated zdc.BotHandoff items = 1;
   */
  items: BotHandoff[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message zdc.ListBotHandoffsResponse.
 * Use `create(ListBotHandoffsResponseSchema)` to create a new message.
 */
export const ListBotHandoffsResponseSchema: GenMessage<ListBotHandoffsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 840);

/**
 * Ручной запрос передачи (оператор/роль-очередь/собеседник диалога/админ):
 * активная передача уже есть → возвращается ОНА (идемпотентно, не ошибка).
 *
 * @generated from message zdc.RequestBotHandoffRequest
 */
export type RequestBotHandoffRequest = Message<"zdc.RequestBotHandoffRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string bot_id = 2;
   */
  botId: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message zdc.RequestBotHandoffRequest.
 * Use `create(RequestBotHandoffRequestSchema)` to create a new message.
 */
export const RequestBotHandoffRequestSchema: GenMessage<RequestBotHandoffRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 841);

/**
 * @generated from message zdc.TakeBotHandoffRequest
 */
export type TakeBotHandoffRequest = Message<"zdc.TakeBotHandoffRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.TakeBotHandoffRequest.
 * Use `create(TakeBotHandoffRequestSchema)` to create a new message.
 */
export const TakeBotHandoffRequestSchema: GenMessage<TakeBotHandoffRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 842);

/**
 * Возврат диалога боту (назначенный оператор/админ). reason — комментарий
 * оператора: пишется в журнал регистрации (поля в модели передачи нет).
 *
 * @generated from message zdc.ReturnBotHandoffRequest
 */
export type ReturnBotHandoffRequest = Message<"zdc.ReturnBotHandoffRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message zdc.ReturnBotHandoffRequest.
 * Use `create(ReturnBotHandoffRequestSchema)` to create a new message.
 */
export const ReturnBotHandoffRequestSchema: GenMessage<ReturnBotHandoffRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 843);

/**
 * --- Аналитика бота (волна 1c §4.9): агрегаты приёма/доставки/передач ---
 * Из существующих данных (заявки приёма, сообщения бота, передачи); новых
 * таблиц НЕТ. День — по часовому поясу конфигурации (config.timezone; нет —
 * UTC). Окно ≤ 90 дней; сырые строки источника ≤ 100 000 (превышение —
 * признак overflow, без тихого усечения).
 *
 * @generated from message zdc.BotAnalyticsDay
 */
export type BotAnalyticsDay = Message<"zdc.BotAnalyticsDay"> & {
  /**
   * YYYY-MM-DD (часовой пояс конфигурации)
   *
   * @generated from field: string day = 1;
   */
  day: string;

  /**
   * пусто = свод по всем адаптерам
   *
   * @generated from field: string adapter_id = 2;
   */
  adapterId: string;

  /**
   * входящие (все заявки приёма)
   *
   * @generated from field: int64 received = 3;
   */
  received: bigint;

  /**
   * доставленные
   *
   * @generated from field: int64 delivered = 4;
   */
  delivered: bigint;

  /**
   * доставлены с пропуском вложений
   *
   * @generated from field: int64 media_deferred = 5;
   */
  mediaDeferred: bigint;

  /**
   * ошибки доставки
   *
   * @generated from field: int64 errors = 6;
   */
  errors: bigint;

  /**
   * исходящие отправленные
   *
   * @generated from field: int64 outbound_sent = 7;
   */
  outboundSent: bigint;

  /**
   * исходящие с ошибкой
   *
   * @generated from field: int64 outbound_failed = 8;
   */
  outboundFailed: bigint;

  /**
   * передачи человеку (созданные)
   *
   * @generated from field: int64 handoffs = 9;
   */
  handoffs: bigint;
};

/**
 * Describes the message zdc.BotAnalyticsDay.
 * Use `create(BotAnalyticsDaySchema)` to create a new message.
 */
export const BotAnalyticsDaySchema: GenMessage<BotAnalyticsDay> = /*@__PURE__*/
  messageDesc(file_zdc, 844);

/**
 * @generated from message zdc.BotAnalyticsTotals
 */
export type BotAnalyticsTotals = Message<"zdc.BotAnalyticsTotals"> & {
  /**
   * @generated from field: int64 received = 1;
   */
  received: bigint;

  /**
   * @generated from field: int64 delivered = 2;
   */
  delivered: bigint;

  /**
   * @generated from field: int64 media_deferred = 3;
   */
  mediaDeferred: bigint;

  /**
   * @generated from field: int64 errors = 4;
   */
  errors: bigint;

  /**
   * @generated from field: int64 outbound_sent = 5;
   */
  outboundSent: bigint;

  /**
   * @generated from field: int64 outbound_failed = 6;
   */
  outboundFailed: bigint;

  /**
   * @generated from field: int64 handoffs = 7;
   */
  handoffs: bigint;
};

/**
 * Describes the message zdc.BotAnalyticsTotals.
 * Use `create(BotAnalyticsTotalsSchema)` to create a new message.
 */
export const BotAnalyticsTotalsSchema: GenMessage<BotAnalyticsTotals> = /*@__PURE__*/
  messageDesc(file_zdc, 845);

/**
 * @generated from message zdc.BotAnalyticsDrops
 */
export type BotAnalyticsDrops = Message<"zdc.BotAnalyticsDrops"> & {
  /**
   * разрез дропов (пусто = нет данных адаптера)
   *
   * @generated from field: string adapter_id = 1;
   */
  adapterId: string;

  /**
   * дропы ограничителя ПРИЁМА (счётчик приёма)
   *
   * @generated from field: int64 dropped_inbound = 2;
   */
  droppedInbound: bigint;

  /**
   * дропы ограничителя ОТПРАВКИ
   *
   * @generated from field: int64 dropped_outbound = 3;
   */
  droppedOutbound: bigint;
};

/**
 * Describes the message zdc.BotAnalyticsDrops.
 * Use `create(BotAnalyticsDropsSchema)` to create a new message.
 */
export const BotAnalyticsDropsSchema: GenMessage<BotAnalyticsDrops> = /*@__PURE__*/
  messageDesc(file_zdc, 846);

/**
 * @generated from message zdc.GetBotAnalyticsRequest
 */
export type GetBotAnalyticsRequest = Message<"zdc.GetBotAnalyticsRequest"> & {
  /**
   * @generated from field: string bot_id = 1;
   */
  botId: string;

  /**
   * пусто = все адаптеры
   *
   * @generated from field: string adapter_id = 2;
   */
  adapterId: string;

  /**
   * RFC3339 или YYYY-MM-DD (день — в поясе конфигурации)
   *
   * @generated from field: string from_ts = 3;
   */
  fromTs: string;

  /**
   * RFC3339 или YYYY-MM-DD; окно ≤ 90 дней
   *
   * @generated from field: string to_ts = 4;
   */
  toTs: string;
};

/**
 * Describes the message zdc.GetBotAnalyticsRequest.
 * Use `create(GetBotAnalyticsRequestSchema)` to create a new message.
 */
export const GetBotAnalyticsRequestSchema: GenMessage<GetBotAnalyticsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 847);

/**
 * @generated from message zdc.GetBotAnalyticsResponse
 */
export type GetBotAnalyticsResponse = Message<"zdc.GetBotAnalyticsResponse"> & {
  /**
   * фактическое окно (RFC3339, UTC)
   *
   * @generated from field: string from_ts = 1;
   */
  fromTs: string;

  /**
   * @generated from field: string to_ts = 2;
   */
  toTs: string;

  /**
   * часовой пояс конфигурации (расчёт дней)
   *
   * @generated from field: string timezone = 3;
   */
  timezone: string;

  /**
   * @generated from field: repeated zdc.BotAnalyticsDay days = 4;
   */
  days: BotAnalyticsDay[];

  /**
   * @generated from field: zdc.BotAnalyticsTotals totals = 5;
   */
  totals?: BotAnalyticsTotals | undefined;

  /**
   * @generated from field: zdc.BotAnalyticsDrops drops = 6;
   */
  drops?: BotAnalyticsDrops | undefined;

  /**
   * источник превысил лимит сырых строк (признак)
   *
   * @generated from field: bool overflow = 7;
   */
  overflow: boolean;
};

/**
 * Describes the message zdc.GetBotAnalyticsResponse.
 * Use `create(GetBotAnalyticsResponseSchema)` to create a new message.
 */
export const GetBotAnalyticsResponseSchema: GenMessage<GetBotAnalyticsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 848);

/**
 * @generated from message zdc.AppCallBackendRequest
 */
export type AppCallBackendRequest = Message<"zdc.AppCallBackendRequest"> & {
  /**
   * код приложения (kind='app')
   *
   * @generated from field: string app_code = 1;
   */
  appCode: string;

  /**
   * метод/путь бэкенда (GET|POST /path или '/path')
   *
   * @generated from field: string method = 2;
   */
  method: string;

  /**
   * JSON-тело (для POST)
   *
   * @generated from field: string body = 3;
   */
  body: string;
};

/**
 * Describes the message zdc.AppCallBackendRequest.
 * Use `create(AppCallBackendRequestSchema)` to create a new message.
 */
export const AppCallBackendRequestSchema: GenMessage<AppCallBackendRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 849);

/**
 * @generated from message zdc.AppCallBackendResponse
 */
export type AppCallBackendResponse = Message<"zdc.AppCallBackendResponse"> & {
  /**
   * http-статус бэкенда
   *
   * @generated from field: int32 status = 1;
   */
  status: number;

  /**
   * ответ (JSON/text)
   *
   * @generated from field: string body = 2;
   */
  body: string;

  /**
   * Сквозной id запроса ядра (X-Request-Id; correlation для трейсинга)
   *
   * @generated from field: string request_id = 3;
   */
  requestId: string;
};

/**
 * Describes the message zdc.AppCallBackendResponse.
 * Use `create(AppCallBackendResponseSchema)` to create a new message.
 */
export const AppCallBackendResponseSchema: GenMessage<AppCallBackendResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 850);

/**
 * @generated from message zdc.AppServiceRef
 */
export type AppServiceRef = Message<"zdc.AppServiceRef"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.AppServiceRef.
 * Use `create(AppServiceRefSchema)` to create a new message.
 */
export const AppServiceRefSchema: GenMessage<AppServiceRef> = /*@__PURE__*/
  messageDesc(file_zdc, 851);

/**
 * @generated from message zdc.ListAppServicesRequest
 */
export type ListAppServicesRequest = Message<"zdc.ListAppServicesRequest"> & {
};

/**
 * Describes the message zdc.ListAppServicesRequest.
 * Use `create(ListAppServicesRequestSchema)` to create a new message.
 */
export const ListAppServicesRequestSchema: GenMessage<ListAppServicesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 852);

/**
 * @generated from message zdc.AppServiceItem
 */
export type AppServiceItem = Message<"zdc.AppServiceItem"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string app_kind = 4;
   */
  appKind: string;

  /**
   * external | managed | ''
   *
   * @generated from field: string run_mode = 5;
   */
  runMode: string;

  /**
   * @generated from field: string external_url = 6;
   */
  externalUrl: string;

  /**
   * @generated from field: string bin_file_id = 7;
   */
  binFileId: string;

  /**
   * @generated from field: string file_name = 8;
   */
  fileName: string;

  /**
   * @generated from field: int32 port = 9;
   */
  port: number;

  /**
   * @generated from field: string health_path = 10;
   */
  healthPath: string;

  /**
   * @generated from field: repeated string args = 11;
   */
  args: string[];

  /**
   * @generated from field: bool auto_start = 12;
   */
  autoStart: boolean;

  /**
   * stopped|starting|running|degraded|error
   *
   * @generated from field: string status = 13;
   */
  status: string;

  /**
   * @generated from field: string last_error = 14;
   */
  lastError: string;

  /**
   * легаси-поле (external)
   *
   * @generated from field: string backend_url = 15;
   */
  backendUrl: string;
};

/**
 * Describes the message zdc.AppServiceItem.
 * Use `create(AppServiceItemSchema)` to create a new message.
 */
export const AppServiceItemSchema: GenMessage<AppServiceItem> = /*@__PURE__*/
  messageDesc(file_zdc, 853);

/**
 * @generated from message zdc.AppServiceList
 */
export type AppServiceList = Message<"zdc.AppServiceList"> & {
  /**
   * @generated from field: repeated zdc.AppServiceItem items = 1;
   */
  items: AppServiceItem[];
};

/**
 * Describes the message zdc.AppServiceList.
 * Use `create(AppServiceListSchema)` to create a new message.
 */
export const AppServiceListSchema: GenMessage<AppServiceList> = /*@__PURE__*/
  messageDesc(file_zdc, 854);

/**
 * @generated from message zdc.SaveAppServiceRequest
 */
export type SaveAppServiceRequest = Message<"zdc.SaveAppServiceRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * JSON BackendSettings (SSoT — сервер)
   *
   * @generated from field: string backend_settings = 2;
   */
  backendSettings: string;

  /**
   * легаси/external (синхронизируется с external_url)
   *
   * @generated from field: string backend_url = 3;
   */
  backendUrl: string;
};

/**
 * Describes the message zdc.SaveAppServiceRequest.
 * Use `create(SaveAppServiceRequestSchema)` to create a new message.
 */
export const SaveAppServiceRequestSchema: GenMessage<SaveAppServiceRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 855);

/**
 * @generated from message zdc.ListAppServiceLogsRequest
 */
export type ListAppServiceLogsRequest = Message<"zdc.ListAppServiceLogsRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message zdc.ListAppServiceLogsRequest.
 * Use `create(ListAppServiceLogsRequestSchema)` to create a new message.
 */
export const ListAppServiceLogsRequestSchema: GenMessage<ListAppServiceLogsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 856);

/**
 * @generated from message zdc.AppServiceLogsResponse
 */
export type AppServiceLogsResponse = Message<"zdc.AppServiceLogsResponse"> & {
  /**
   * @generated from field: repeated string lines = 1;
   */
  lines: string[];
};

/**
 * Describes the message zdc.AppServiceLogsResponse.
 * Use `create(AppServiceLogsResponseSchema)` to create a new message.
 */
export const AppServiceLogsResponseSchema: GenMessage<AppServiceLogsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 857);

/**
 * @generated from message zdc.AppServiceStats
 */
export type AppServiceStats = Message<"zdc.AppServiceStats"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: int64 calls = 2;
   */
  calls: bigint;

  /**
   * @generated from field: int64 errors = 3;
   */
  errors: bigint;

  /**
   * @generated from field: int64 total_ms = 4;
   */
  totalMs: bigint;

  /**
   * @generated from field: string last_error = 5;
   */
  lastError: string;

  /**
   * Дропы шины по темам app.<code>.* (backpressure; SSoT — метрики EventBus)
   *
   * @generated from field: int64 bus_dropped = 6;
   */
  busDropped: bigint;
};

/**
 * Describes the message zdc.AppServiceStats.
 * Use `create(AppServiceStatsSchema)` to create a new message.
 */
export const AppServiceStatsSchema: GenMessage<AppServiceStats> = /*@__PURE__*/
  messageDesc(file_zdc, 858);

/**
 * @generated from message zdc.AppServiceTokenResponse
 */
export type AppServiceTokenResponse = Message<"zdc.AppServiceTokenResponse"> & {
  /**
   * plaintext — показывается ОДИН раз
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int32 epoch = 2;
   */
  epoch: number;
};

/**
 * Describes the message zdc.AppServiceTokenResponse.
 * Use `create(AppServiceTokenResponseSchema)` to create a new message.
 */
export const AppServiceTokenResponseSchema: GenMessage<AppServiceTokenResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 859);

/**
 * @generated from message zdc.AppSecretsList
 */
export type AppSecretsList = Message<"zdc.AppSecretsList"> & {
  /**
   * @generated from field: repeated zdc.AppSecretKey items = 1;
   */
  items: AppSecretKey[];
};

/**
 * Describes the message zdc.AppSecretsList.
 * Use `create(AppSecretsListSchema)` to create a new message.
 */
export const AppSecretsListSchema: GenMessage<AppSecretsList> = /*@__PURE__*/
  messageDesc(file_zdc, 860);

/**
 * @generated from message zdc.AppSecretKey
 */
export type AppSecretKey = Message<"zdc.AppSecretKey"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: bool set = 2;
   */
  set: boolean;
};

/**
 * Describes the message zdc.AppSecretKey.
 * Use `create(AppSecretKeySchema)` to create a new message.
 */
export const AppSecretKeySchema: GenMessage<AppSecretKey> = /*@__PURE__*/
  messageDesc(file_zdc, 861);

/**
 * @generated from message zdc.SaveAppSecretRequest
 */
export type SaveAppSecretRequest = Message<"zdc.SaveAppSecretRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * Describes the message zdc.SaveAppSecretRequest.
 * Use `create(SaveAppSecretRequestSchema)` to create a new message.
 */
export const SaveAppSecretRequestSchema: GenMessage<SaveAppSecretRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 862);

/**
 * @generated from message zdc.AppSecretsValues
 */
export type AppSecretsValues = Message<"zdc.AppSecretsValues"> & {
  /**
   * @generated from field: map<string, string> values = 1;
   */
  values: { [key: string]: string };
};

/**
 * Describes the message zdc.AppSecretsValues.
 * Use `create(AppSecretsValuesSchema)` to create a new message.
 */
export const AppSecretsValuesSchema: GenMessage<AppSecretsValues> = /*@__PURE__*/
  messageDesc(file_zdc, 863);

/**
 * --- Таск-менеджер ядра (фоновые задания) ---
 *
 * @generated from message zdc.JobsListRequest
 */
export type JobsListRequest = Message<"zdc.JobsListRequest"> & {
  /**
   * queued|running|done|error|canceled; пусто = все
   *
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * фильтр по приложению; пусто = все
   *
   * @generated from field: string app_code = 2;
   */
  appCode: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset: number;
};

/**
 * Describes the message zdc.JobsListRequest.
 * Use `create(JobsListRequestSchema)` to create a new message.
 */
export const JobsListRequestSchema: GenMessage<JobsListRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 864);

/**
 * @generated from message zdc.JobsListResponse
 */
export type JobsListResponse = Message<"zdc.JobsListResponse"> & {
  /**
   * @generated from field: repeated zdc.BackgroundJob items = 1;
   */
  items: BackgroundJob[];
};

/**
 * Describes the message zdc.JobsListResponse.
 * Use `create(JobsListResponseSchema)` to create a new message.
 */
export const JobsListResponseSchema: GenMessage<JobsListResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 865);

/**
 * @generated from message zdc.JobsGetRequest
 */
export type JobsGetRequest = Message<"zdc.JobsGetRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.JobsGetRequest.
 * Use `create(JobsGetRequestSchema)` to create a new message.
 */
export const JobsGetRequestSchema: GenMessage<JobsGetRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 866);

/**
 * @generated from message zdc.JobsEnqueueRequest
 */
export type JobsEnqueueRequest = Message<"zdc.JobsEnqueueRequest"> & {
  /**
   * тип задания (обработчик зарегистрирован на сервере)
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * имя задания (UI)
   *
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * JSON аргументы
   *
   * @generated from field: string payload = 3;
   */
  payload: string;

  /**
   * приложение-источник (пусто = ядро)
   *
   * @generated from field: string app_code = 4;
   */
  appCode: string;
};

/**
 * Describes the message zdc.JobsEnqueueRequest.
 * Use `create(JobsEnqueueRequestSchema)` to create a new message.
 */
export const JobsEnqueueRequestSchema: GenMessage<JobsEnqueueRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 867);

/**
 * @generated from message zdc.JobsCancelRequest
 */
export type JobsCancelRequest = Message<"zdc.JobsCancelRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.JobsCancelRequest.
 * Use `create(JobsCancelRequestSchema)` to create a new message.
 */
export const JobsCancelRequestSchema: GenMessage<JobsCancelRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 868);

/**
 * @generated from message zdc.BackgroundJob
 */
export type BackgroundJob = Message<"zdc.BackgroundJob"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: string app_code = 3;
   */
  appCode: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * queued|running|done|error|canceled
   *
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * 0..100
   *
   * @generated from field: int32 progress = 6;
   */
  progress: number;

  /**
   * JSON
   *
   * @generated from field: string result = 7;
   */
  result: string;

  /**
   * @generated from field: string error = 8;
   */
  error: string;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * @generated from field: string started_at = 10;
   */
  startedAt: string;

  /**
   * @generated from field: string finished_at = 11;
   */
  finishedAt: string;

  /**
   * @generated from field: string created_by = 12;
   */
  createdBy: string;
};

/**
 * Describes the message zdc.BackgroundJob.
 * Use `create(BackgroundJobSchema)` to create a new message.
 */
export const BackgroundJobSchema: GenMessage<BackgroundJob> = /*@__PURE__*/
  messageDesc(file_zdc, 869);

/**
 * @generated from message zdc.SendVerificationRequest
 */
export type SendVerificationRequest = Message<"zdc.SendVerificationRequest"> & {
  /**
   * verify_email|verify_phone|login|reset|sign|lead_confirm|...
   *
   * @generated from field: string purpose = 1;
   */
  purpose: string;

  /**
   * email|telegram|max|webpush|in-app
   *
   * @generated from field: string channel = 2;
   */
  channel: string;

  /**
   * адрес/идентификатор получателя канала
   *
   * @generated from field: string target = 3;
   */
  target: string;

  /**
   * привязка к пользователю (пусто = гость)
   *
   * @generated from field: string entity_id = 4;
   */
  entityId: string;

  /**
   * идемпотентность запроса
   *
   * @generated from field: string client_ref = 5;
   */
  clientRef: string;

  /**
   * JSON контекста (заявка/документ/...)
   *
   * @generated from field: string meta = 6;
   */
  meta: string;
};

/**
 * Describes the message zdc.SendVerificationRequest.
 * Use `create(SendVerificationRequestSchema)` to create a new message.
 */
export const SendVerificationRequestSchema: GenMessage<SendVerificationRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 870);

/**
 * @generated from message zdc.SendVerificationResponse
 */
export type SendVerificationResponse = Message<"zdc.SendVerificationResponse"> & {
  /**
   * @generated from field: bool sent = 1;
   */
  sent: boolean;
};

/**
 * Describes the message zdc.SendVerificationResponse.
 * Use `create(SendVerificationResponseSchema)` to create a new message.
 */
export const SendVerificationResponseSchema: GenMessage<SendVerificationResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 871);

/**
 * @generated from message zdc.VerifyCodeRequest
 */
export type VerifyCodeRequest = Message<"zdc.VerifyCodeRequest"> & {
  /**
   * @generated from field: string purpose = 1;
   */
  purpose: string;

  /**
   * @generated from field: string channel = 2;
   */
  channel: string;

  /**
   * @generated from field: string target = 3;
   */
  target: string;

  /**
   * @generated from field: string code = 4;
   */
  code: string;
};

/**
 * Describes the message zdc.VerifyCodeRequest.
 * Use `create(VerifyCodeRequestSchema)` to create a new message.
 */
export const VerifyCodeRequestSchema: GenMessage<VerifyCodeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 872);

/**
 * @generated from message zdc.VerifyCodeResponse
 */
export type VerifyCodeResponse = Message<"zdc.VerifyCodeResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;
};

/**
 * Describes the message zdc.VerifyCodeResponse.
 * Use `create(VerifyCodeResponseSchema)` to create a new message.
 */
export const VerifyCodeResponseSchema: GenMessage<VerifyCodeResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 873);

/**
 * @generated from message zdc.SendActionMessageRequest
 */
export type SendActionMessageRequest = Message<"zdc.SendActionMessageRequest"> & {
  /**
   * order_lead|document_approve|payment_request|...
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * запись, к которой относится решение
   *
   * @generated from field: string ref_id = 2;
   */
  refId: string;

  /**
   * @generated from field: string step = 3;
   */
  step: string;

  /**
   * адрес/идентификатор получателя
   *
   * @generated from field: string recipient = 4;
   */
  recipient: string;

  /**
   * @generated from field: string channel = 5;
   */
  channel: string;

  /**
   * approve|reject|confirm
   *
   * @generated from field: string action = 6;
   */
  action: string;

  /**
   * @generated from field: string title = 7;
   */
  title: string;

  /**
   * @generated from field: string message = 8;
   */
  message: string;

  /**
   * @generated from field: string meta = 9;
   */
  meta: string;
};

/**
 * Describes the message zdc.SendActionMessageRequest.
 * Use `create(SendActionMessageRequestSchema)` to create a new message.
 */
export const SendActionMessageRequestSchema: GenMessage<SendActionMessageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 874);

/**
 * @generated from message zdc.SendActionMessageResponse
 */
export type SendActionMessageResponse = Message<"zdc.SendActionMessageResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: bool sent = 2;
   */
  sent: boolean;
};

/**
 * Describes the message zdc.SendActionMessageResponse.
 * Use `create(SendActionMessageResponseSchema)` to create a new message.
 */
export const SendActionMessageResponseSchema: GenMessage<SendActionMessageResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 875);

/**
 * @generated from message zdc.ActConfirmationRequest
 */
export type ActConfirmationRequest = Message<"zdc.ActConfirmationRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * approve|reject|confirm
   *
   * @generated from field: string action = 2;
   */
  action: string;

  /**
   * @generated from field: string comment = 3;
   */
  comment: string;
};

/**
 * Describes the message zdc.ActConfirmationRequest.
 * Use `create(ActConfirmationRequestSchema)` to create a new message.
 */
export const ActConfirmationRequestSchema: GenMessage<ActConfirmationRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 876);

/**
 * @generated from message zdc.ActConfirmationResponse
 */
export type ActConfirmationResponse = Message<"zdc.ActConfirmationResponse"> & {
  /**
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: string ref_id = 3;
   */
  refId: string;
};

/**
 * Describes the message zdc.ActConfirmationResponse.
 * Use `create(ActConfirmationResponseSchema)` to create a new message.
 */
export const ActConfirmationResponseSchema: GenMessage<ActConfirmationResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 877);

/**
 * @generated from message zdc.LoginByIdentityRequest
 */
export type LoginByIdentityRequest = Message<"zdc.LoginByIdentityRequest"> & {
  /**
   * telegram|max|...
   *
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * подписанные данные провайдера (initData/Login Widget)
   *
   * @generated from field: string init_data = 2;
   */
  initData: string;
};

/**
 * Describes the message zdc.LoginByIdentityRequest.
 * Use `create(LoginByIdentityRequestSchema)` to create a new message.
 */
export const LoginByIdentityRequestSchema: GenMessage<LoginByIdentityRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 878);

/**
 * @generated from message zdc.LinkIdentityRequest
 */
export type LinkIdentityRequest = Message<"zdc.LinkIdentityRequest"> & {
  /**
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * @generated from field: string init_data = 2;
   */
  initData: string;
};

/**
 * Describes the message zdc.LinkIdentityRequest.
 * Use `create(LinkIdentityRequestSchema)` to create a new message.
 */
export const LinkIdentityRequestSchema: GenMessage<LinkIdentityRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 879);

/**
 * @generated from message zdc.UnlinkIdentityRequest
 */
export type UnlinkIdentityRequest = Message<"zdc.UnlinkIdentityRequest"> & {
  /**
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * @generated from field: string external_id = 2;
   */
  externalId: string;

  /**
   * пусто = текущий пользователь
   *
   * @generated from field: string entity_id = 3;
   */
  entityId: string;
};

/**
 * Describes the message zdc.UnlinkIdentityRequest.
 * Use `create(UnlinkIdentityRequestSchema)` to create a new message.
 */
export const UnlinkIdentityRequestSchema: GenMessage<UnlinkIdentityRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 880);

/**
 * @generated from message zdc.ListIdentitiesRequest
 */
export type ListIdentitiesRequest = Message<"zdc.ListIdentitiesRequest"> & {
  /**
   * пусто = текущий пользователь
   *
   * @generated from field: string entity_id = 1;
   */
  entityId: string;
};

/**
 * Describes the message zdc.ListIdentitiesRequest.
 * Use `create(ListIdentitiesRequestSchema)` to create a new message.
 */
export const ListIdentitiesRequestSchema: GenMessage<ListIdentitiesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 881);

/**
 * @generated from message zdc.IdentityInfo
 */
export type IdentityInfo = Message<"zdc.IdentityInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string provider = 2;
   */
  provider: string;

  /**
   * @generated from field: string external_id = 3;
   */
  externalId: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: string email = 5;
   */
  email: string;

  /**
   * @generated from field: string phone = 6;
   */
  phone: string;

  /**
   * @generated from field: string verified_at = 7;
   */
  verifiedAt: string;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.IdentityInfo.
 * Use `create(IdentityInfoSchema)` to create a new message.
 */
export const IdentityInfoSchema: GenMessage<IdentityInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 882);

/**
 * @generated from message zdc.ListIdentitiesResponse
 */
export type ListIdentitiesResponse = Message<"zdc.ListIdentitiesResponse"> & {
  /**
   * @generated from field: repeated zdc.IdentityInfo items = 1;
   */
  items: IdentityInfo[];
};

/**
 * Describes the message zdc.ListIdentitiesResponse.
 * Use `create(ListIdentitiesResponseSchema)` to create a new message.
 */
export const ListIdentitiesResponseSchema: GenMessage<ListIdentitiesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 883);

/**
 * @generated from message zdc.LoginProvidersRequest
 */
export type LoginProvidersRequest = Message<"zdc.LoginProvidersRequest"> & {
};

/**
 * Describes the message zdc.LoginProvidersRequest.
 * Use `create(LoginProvidersRequestSchema)` to create a new message.
 */
export const LoginProvidersRequestSchema: GenMessage<LoginProvidersRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 884);

/**
 * @generated from message zdc.LoginProviderInfo
 */
export type LoginProviderInfo = Message<"zdc.LoginProviderInfo"> & {
  /**
   * telegram|max|...
   *
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * для Telegram Login Widget / ссылок t.me
   *
   * @generated from field: string bot_username = 3;
   */
  botUsername: string;
};

/**
 * Describes the message zdc.LoginProviderInfo.
 * Use `create(LoginProviderInfoSchema)` to create a new message.
 */
export const LoginProviderInfoSchema: GenMessage<LoginProviderInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 885);

/**
 * @generated from message zdc.LoginProvidersResponse
 */
export type LoginProvidersResponse = Message<"zdc.LoginProvidersResponse"> & {
  /**
   * @generated from field: repeated zdc.LoginProviderInfo items = 1;
   */
  items: LoginProviderInfo[];
};

/**
 * Describes the message zdc.LoginProvidersResponse.
 * Use `create(LoginProvidersResponseSchema)` to create a new message.
 */
export const LoginProvidersResponseSchema: GenMessage<LoginProvidersResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 886);

/**
 * M3: меню-кнопка приложения у бота базы
 *
 * @generated from message zdc.SetupAdapterMenuRequest
 */
export type SetupAdapterMenuRequest = Message<"zdc.SetupAdapterMenuRequest"> & {
  /**
   * @generated from field: string adapter_id = 1;
   */
  adapterId: string;

  /**
   * URL приложения (https, напр. {origin}/enterprise/{slug})
   *
   * @generated from field: string app_url = 2;
   */
  appUrl: string;

  /**
   * подпись кнопки (по умолчанию «Приложение»)
   *
   * @generated from field: string title = 3;
   */
  title: string;
};

/**
 * Describes the message zdc.SetupAdapterMenuRequest.
 * Use `create(SetupAdapterMenuRequestSchema)` to create a new message.
 */
export const SetupAdapterMenuRequestSchema: GenMessage<SetupAdapterMenuRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 887);

/**
 * M4 «Версии файлов»
 *
 * @generated from message zdc.FileVersionInfo
 */
export type FileVersionInfo = Message<"zdc.FileVersionInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string file_id = 2;
   */
  fileId: string;

  /**
   * @generated from field: int32 version = 3;
   */
  version: number;

  /**
   * @generated from field: int64 size = 4;
   */
  size: bigint;

  /**
   * @generated from field: string content_hash = 5;
   */
  contentHash: string;

  /**
   * @generated from field: string author_id = 6;
   */
  authorId: string;

  /**
   * @generated from field: string comment = 7;
   */
  comment: string;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.FileVersionInfo.
 * Use `create(FileVersionInfoSchema)` to create a new message.
 */
export const FileVersionInfoSchema: GenMessage<FileVersionInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 888);

/**
 * @generated from message zdc.ListFileVersionsRequest
 */
export type ListFileVersionsRequest = Message<"zdc.ListFileVersionsRequest"> & {
  /**
   * @generated from field: string file_id = 1;
   */
  fileId: string;
};

/**
 * Describes the message zdc.ListFileVersionsRequest.
 * Use `create(ListFileVersionsRequestSchema)` to create a new message.
 */
export const ListFileVersionsRequestSchema: GenMessage<ListFileVersionsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 889);

/**
 * @generated from message zdc.FileVersionsResponse
 */
export type FileVersionsResponse = Message<"zdc.FileVersionsResponse"> & {
  /**
   * @generated from field: repeated zdc.FileVersionInfo items = 1;
   */
  items: FileVersionInfo[];

  /**
   * @generated from field: int32 current_version = 2;
   */
  currentVersion: number;
};

/**
 * Describes the message zdc.FileVersionsResponse.
 * Use `create(FileVersionsResponseSchema)` to create a new message.
 */
export const FileVersionsResponseSchema: GenMessage<FileVersionsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 890);

/**
 * @generated from message zdc.DownloadFileVersionRequest
 */
export type DownloadFileVersionRequest = Message<"zdc.DownloadFileVersionRequest"> & {
  /**
   * @generated from field: string file_id = 1;
   */
  fileId: string;

  /**
   * @generated from field: int32 version = 2;
   */
  version: number;
};

/**
 * Describes the message zdc.DownloadFileVersionRequest.
 * Use `create(DownloadFileVersionRequestSchema)` to create a new message.
 */
export const DownloadFileVersionRequestSchema: GenMessage<DownloadFileVersionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 891);

/**
 * @generated from message zdc.RestoreFileVersionRequest
 */
export type RestoreFileVersionRequest = Message<"zdc.RestoreFileVersionRequest"> & {
  /**
   * @generated from field: string file_id = 1;
   */
  fileId: string;

  /**
   * @generated from field: int32 version = 2;
   */
  version: number;

  /**
   * @generated from field: string comment = 3;
   */
  comment: string;
};

/**
 * Describes the message zdc.RestoreFileVersionRequest.
 * Use `create(RestoreFileVersionRequestSchema)` to create a new message.
 */
export const RestoreFileVersionRequestSchema: GenMessage<RestoreFileVersionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 892);

/**
 * @generated from message zdc.CalendarEventInfo
 */
export type CalendarEventInfo = Message<"zdc.CalendarEventInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * meeting|slot|session|reminder
   *
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * @generated from field: string owner_id = 5;
   */
  ownerId: string;

  /**
   * RFC3339
   *
   * @generated from field: string start_at = 6;
   */
  startAt: string;

  /**
   * @generated from field: string end_at = 7;
   */
  endAt: string;

  /**
   * @generated from field: bool all_day = 8;
   */
  allDay: boolean;

  /**
   * @generated from field: string ref_type = 9;
   */
  refType: string;

  /**
   * @generated from field: string ref_id = 10;
   */
  refId: string;

  /**
   * event|task
   *
   * @generated from field: string source = 11;
   */
  source: string;
};

/**
 * Describes the message zdc.CalendarEventInfo.
 * Use `create(CalendarEventInfoSchema)` to create a new message.
 */
export const CalendarEventInfoSchema: GenMessage<CalendarEventInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 893);

/**
 * @generated from message zdc.ListCalendarRequest
 */
export type ListCalendarRequest = Message<"zdc.ListCalendarRequest"> & {
  /**
   * RFC3339 (обязательно)
   *
   * @generated from field: string from = 1;
   */
  from: string;

  /**
   * RFC3339 (обязательно)
   *
   * @generated from field: string to = 2;
   */
  to: string;

  /**
   * пусто = все источники
   *
   * @generated from field: string owner_id = 3;
   */
  ownerId: string;
};

/**
 * Describes the message zdc.ListCalendarRequest.
 * Use `create(ListCalendarRequestSchema)` to create a new message.
 */
export const ListCalendarRequestSchema: GenMessage<ListCalendarRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 894);

/**
 * @generated from message zdc.ListCalendarResponse
 */
export type ListCalendarResponse = Message<"zdc.ListCalendarResponse"> & {
  /**
   * @generated from field: repeated zdc.CalendarEventInfo items = 1;
   */
  items: CalendarEventInfo[];
};

/**
 * Describes the message zdc.ListCalendarResponse.
 * Use `create(ListCalendarResponseSchema)` to create a new message.
 */
export const ListCalendarResponseSchema: GenMessage<ListCalendarResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 895);

/**
 * @generated from message zdc.SaveCalendarEventRequest
 */
export type SaveCalendarEventRequest = Message<"zdc.SaveCalendarEventRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * @generated from field: string owner_id = 5;
   */
  ownerId: string;

  /**
   * RFC3339 (обязательно)
   *
   * @generated from field: string start_at = 6;
   */
  startAt: string;

  /**
   * @generated from field: string end_at = 7;
   */
  endAt: string;

  /**
   * @generated from field: bool all_day = 8;
   */
  allDay: boolean;

  /**
   * @generated from field: string ref_type = 9;
   */
  refType: string;

  /**
   * @generated from field: string ref_id = 10;
   */
  refId: string;

  /**
   * JSON [entity_id]
   *
   * @generated from field: string participants = 11;
   */
  participants: string;

  /**
   * @generated from field: string meta = 12;
   */
  meta: string;
};

/**
 * Describes the message zdc.SaveCalendarEventRequest.
 * Use `create(SaveCalendarEventRequestSchema)` to create a new message.
 */
export const SaveCalendarEventRequestSchema: GenMessage<SaveCalendarEventRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 896);

/**
 * @generated from message zdc.DeleteCalendarEventRequest
 */
export type DeleteCalendarEventRequest = Message<"zdc.DeleteCalendarEventRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteCalendarEventRequest.
 * Use `create(DeleteCalendarEventRequestSchema)` to create a new message.
 */
export const DeleteCalendarEventRequestSchema: GenMessage<DeleteCalendarEventRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 897);

/**
 * @generated from message zdc.TagInfo
 */
export type TagInfo = Message<"zdc.TagInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string parent_id = 3;
   */
  parentId: string;

  /**
   * "/id1/id2/..." — поддеревья (LIKE 'path%')
   *
   * @generated from field: string path = 4;
   */
  path: string;

  /**
   * @generated from field: string color = 5;
   */
  color: string;

  /**
   * @generated from field: int32 sort_order = 6;
   */
  sortOrder: number;

  /**
   * @generated from field: bool is_system = 7;
   */
  isSystem: boolean;

  /**
   * @generated from field: int32 usage_count = 8;
   */
  usageCount: number;
};

/**
 * Describes the message zdc.TagInfo.
 * Use `create(TagInfoSchema)` to create a new message.
 */
export const TagInfoSchema: GenMessage<TagInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 898);

/**
 * @generated from message zdc.ListTagsRequest
 */
export type ListTagsRequest = Message<"zdc.ListTagsRequest"> & {
  /**
   * @generated from field: string search = 1;
   */
  search: string;
};

/**
 * Describes the message zdc.ListTagsRequest.
 * Use `create(ListTagsRequestSchema)` to create a new message.
 */
export const ListTagsRequestSchema: GenMessage<ListTagsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 899);

/**
 * @generated from message zdc.ListTagsResponse
 */
export type ListTagsResponse = Message<"zdc.ListTagsResponse"> & {
  /**
   * @generated from field: repeated zdc.TagInfo tags = 1;
   */
  tags: TagInfo[];
};

/**
 * Describes the message zdc.ListTagsResponse.
 * Use `create(ListTagsResponseSchema)` to create a new message.
 */
export const ListTagsResponseSchema: GenMessage<ListTagsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 900);

/**
 * @generated from message zdc.SaveTagRequest
 */
export type SaveTagRequest = Message<"zdc.SaveTagRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string parent_id = 3;
   */
  parentId: string;

  /**
   * @generated from field: string color = 4;
   */
  color: string;

  /**
   * @generated from field: int32 sort_order = 5;
   */
  sortOrder: number;
};

/**
 * Describes the message zdc.SaveTagRequest.
 * Use `create(SaveTagRequestSchema)` to create a new message.
 */
export const SaveTagRequestSchema: GenMessage<SaveTagRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 901);

/**
 * @generated from message zdc.SaveTagResponse
 */
export type SaveTagResponse = Message<"zdc.SaveTagResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.SaveTagResponse.
 * Use `create(SaveTagResponseSchema)` to create a new message.
 */
export const SaveTagResponseSchema: GenMessage<SaveTagResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 902);

/**
 * @generated from message zdc.DeleteTagRequest
 */
export type DeleteTagRequest = Message<"zdc.DeleteTagRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteTagRequest.
 * Use `create(DeleteTagRequestSchema)` to create a new message.
 */
export const DeleteTagRequestSchema: GenMessage<DeleteTagRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 903);

/**
 * @generated from message zdc.TagSubjectRef
 */
export type TagSubjectRef = Message<"zdc.TagSubjectRef"> & {
  /**
   * catalog|document|order|task|file|chat_message|chat_conversation|entity|page|worktable|site|...
   *
   * @generated from field: string subject_type = 1;
   */
  subjectType: string;

  /**
   * код типа (catalog/document/order/task), '' для прочих
   *
   * @generated from field: string subject_code = 2;
   */
  subjectCode: string;

  /**
   * @generated from field: string subject_id = 3;
   */
  subjectId: string;
};

/**
 * Describes the message zdc.TagSubjectRef.
 * Use `create(TagSubjectRefSchema)` to create a new message.
 */
export const TagSubjectRefSchema: GenMessage<TagSubjectRef> = /*@__PURE__*/
  messageDesc(file_zdc, 904);

/**
 * @generated from message zdc.SetSubjectTagsRequest
 */
export type SetSubjectTagsRequest = Message<"zdc.SetSubjectTagsRequest"> & {
  /**
   * @generated from field: zdc.TagSubjectRef subject = 1;
   */
  subject?: TagSubjectRef | undefined;

  /**
   * @generated from field: repeated string tag_ids = 2;
   */
  tagIds: string[];
};

/**
 * Describes the message zdc.SetSubjectTagsRequest.
 * Use `create(SetSubjectTagsRequestSchema)` to create a new message.
 */
export const SetSubjectTagsRequestSchema: GenMessage<SetSubjectTagsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 905);

/**
 * @generated from message zdc.SetSubjectTagsResponse
 */
export type SetSubjectTagsResponse = Message<"zdc.SetSubjectTagsResponse"> & {
  /**
   * @generated from field: int32 count = 1;
   */
  count: number;
};

/**
 * Describes the message zdc.SetSubjectTagsResponse.
 * Use `create(SetSubjectTagsResponseSchema)` to create a new message.
 */
export const SetSubjectTagsResponseSchema: GenMessage<SetSubjectTagsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 906);

/**
 * @generated from message zdc.TagList
 */
export type TagList = Message<"zdc.TagList"> & {
  /**
   * @generated from field: repeated zdc.TagInfo tags = 1;
   */
  tags: TagInfo[];
};

/**
 * Describes the message zdc.TagList.
 * Use `create(TagListSchema)` to create a new message.
 */
export const TagListSchema: GenMessage<TagList> = /*@__PURE__*/
  messageDesc(file_zdc, 907);

/**
 * @generated from message zdc.ListSubjectTagsRequest
 */
export type ListSubjectTagsRequest = Message<"zdc.ListSubjectTagsRequest"> & {
  /**
   * @generated from field: repeated zdc.TagSubjectRef subjects = 1;
   */
  subjects: TagSubjectRef[];
};

/**
 * Describes the message zdc.ListSubjectTagsRequest.
 * Use `create(ListSubjectTagsRequestSchema)` to create a new message.
 */
export const ListSubjectTagsRequestSchema: GenMessage<ListSubjectTagsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 908);

/**
 * @generated from message zdc.ListSubjectTagsResponse
 */
export type ListSubjectTagsResponse = Message<"zdc.ListSubjectTagsResponse"> & {
  /**
   * ключ: type|code|id (TagSubjectRef.Key())
   *
   * @generated from field: map<string, zdc.TagList> items = 1;
   */
  items: { [key: string]: TagList };
};

/**
 * Describes the message zdc.ListSubjectTagsResponse.
 * Use `create(ListSubjectTagsResponseSchema)` to create a new message.
 */
export const ListSubjectTagsResponseSchema: GenMessage<ListSubjectTagsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 909);

/**
 * @generated from message zdc.ListSubjectsByTagRequest
 */
export type ListSubjectsByTagRequest = Message<"zdc.ListSubjectsByTagRequest"> & {
  /**
   * @generated from field: string tag_id = 1;
   */
  tagId: string;

  /**
   * @generated from field: bool include_subtree = 2;
   */
  includeSubtree: boolean;

  /**
   * @generated from field: string subject_type = 3;
   */
  subjectType: string;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 5;
   */
  offset: number;
};

/**
 * Describes the message zdc.ListSubjectsByTagRequest.
 * Use `create(ListSubjectsByTagRequestSchema)` to create a new message.
 */
export const ListSubjectsByTagRequestSchema: GenMessage<ListSubjectsByTagRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 910);

/**
 * @generated from message zdc.ListSubjectsByTagResponse
 */
export type ListSubjectsByTagResponse = Message<"zdc.ListSubjectsByTagResponse"> & {
  /**
   * @generated from field: repeated zdc.TagSubjectRef subjects = 1;
   */
  subjects: TagSubjectRef[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message zdc.ListSubjectsByTagResponse.
 * Use `create(ListSubjectsByTagResponseSchema)` to create a new message.
 */
export const ListSubjectsByTagResponseSchema: GenMessage<ListSubjectsByTagResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 911);

/**
 * @generated from message zdc.RouteStepDefInfo
 */
export type RouteStepDefInfo = Message<"zdc.RouteStepDefInfo"> & {
  /**
   * @generated from field: int32 order = 1;
   */
  order: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * approve|sign|notify
   *
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * role|user
   *
   * @generated from field: string assignee_type = 4;
   */
  assigneeType: string;

  /**
   * @generated from field: string assignee_value = 5;
   */
  assigneeValue: string;

  /**
   * @generated from field: int32 timeout_hours = 6;
   */
  timeoutHours: number;
};

/**
 * Describes the message zdc.RouteStepDefInfo.
 * Use `create(RouteStepDefInfoSchema)` to create a new message.
 */
export const RouteStepDefInfoSchema: GenMessage<RouteStepDefInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 912);

/**
 * @generated from message zdc.RouteTemplateInfo
 */
export type RouteTemplateInfo = Message<"zdc.RouteTemplateInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string synonym = 4;
   */
  synonym: string;

  /**
   * @generated from field: string entity_type = 5;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 6;
   */
  entityCode: string;

  /**
   * @generated from field: repeated zdc.RouteStepDefInfo steps = 7;
   */
  steps: RouteStepDefInfo[];

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive: boolean;
};

/**
 * Describes the message zdc.RouteTemplateInfo.
 * Use `create(RouteTemplateInfoSchema)` to create a new message.
 */
export const RouteTemplateInfoSchema: GenMessage<RouteTemplateInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 913);

/**
 * @generated from message zdc.RouteStepInfo
 */
export type RouteStepInfo = Message<"zdc.RouteStepInfo"> & {
  /**
   * @generated from field: int32 order = 1;
   */
  order: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * @generated from field: string assignee_type = 4;
   */
  assigneeType: string;

  /**
   * @generated from field: string assignee_value = 5;
   */
  assigneeValue: string;

  /**
   * pending|approve|reject|skipped
   *
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: string acted_by = 7;
   */
  actedBy: string;

  /**
   * @generated from field: string acted_at = 8;
   */
  actedAt: string;

  /**
   * @generated from field: string comment = 9;
   */
  comment: string;
};

/**
 * Describes the message zdc.RouteStepInfo.
 * Use `create(RouteStepInfoSchema)` to create a new message.
 */
export const RouteStepInfoSchema: GenMessage<RouteStepInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 914);

/**
 * @generated from message zdc.RouteInstanceInfo
 */
export type RouteInstanceInfo = Message<"zdc.RouteInstanceInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string route_code = 2;
   */
  routeCode: string;

  /**
   * @generated from field: string entity_type = 3;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 4;
   */
  entityCode: string;

  /**
   * @generated from field: string entity_id = 5;
   */
  entityId: string;

  /**
   * running|approved|rejected|canceled
   *
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: int32 current_step = 7;
   */
  currentStep: number;

  /**
   * @generated from field: int32 steps_total = 8;
   */
  stepsTotal: number;

  /**
   * @generated from field: string started_by = 9;
   */
  startedBy: string;

  /**
   * @generated from field: string started_at = 10;
   */
  startedAt: string;

  /**
   * @generated from field: string finished_at = 11;
   */
  finishedAt: string;

  /**
   * @generated from field: string comment = 12;
   */
  comment: string;

  /**
   * @generated from field: repeated zdc.RouteStepInfo steps = 13;
   */
  steps: RouteStepInfo[];
};

/**
 * Describes the message zdc.RouteInstanceInfo.
 * Use `create(RouteInstanceInfoSchema)` to create a new message.
 */
export const RouteInstanceInfoSchema: GenMessage<RouteInstanceInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 915);

/**
 * @generated from message zdc.ListRouteTemplatesRequest
 */
export type ListRouteTemplatesRequest = Message<"zdc.ListRouteTemplatesRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;
};

/**
 * Describes the message zdc.ListRouteTemplatesRequest.
 * Use `create(ListRouteTemplatesRequestSchema)` to create a new message.
 */
export const ListRouteTemplatesRequestSchema: GenMessage<ListRouteTemplatesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 916);

/**
 * @generated from message zdc.RouteTemplatesResponse
 */
export type RouteTemplatesResponse = Message<"zdc.RouteTemplatesResponse"> & {
  /**
   * @generated from field: repeated zdc.RouteTemplateInfo items = 1;
   */
  items: RouteTemplateInfo[];
};

/**
 * Describes the message zdc.RouteTemplatesResponse.
 * Use `create(RouteTemplatesResponseSchema)` to create a new message.
 */
export const RouteTemplatesResponseSchema: GenMessage<RouteTemplatesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 917);

/**
 * @generated from message zdc.SaveRouteTemplateRequest
 */
export type SaveRouteTemplateRequest = Message<"zdc.SaveRouteTemplateRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string entity_type = 4;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 5;
   */
  entityCode: string;

  /**
   * @generated from field: repeated zdc.RouteStepDefInfo steps = 6;
   */
  steps: RouteStepDefInfo[];

  /**
   * @generated from field: bool is_active = 7;
   */
  isActive: boolean;
};

/**
 * Describes the message zdc.SaveRouteTemplateRequest.
 * Use `create(SaveRouteTemplateRequestSchema)` to create a new message.
 */
export const SaveRouteTemplateRequestSchema: GenMessage<SaveRouteTemplateRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 918);

/**
 * @generated from message zdc.DeleteRouteTemplateRequest
 */
export type DeleteRouteTemplateRequest = Message<"zdc.DeleteRouteTemplateRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.DeleteRouteTemplateRequest.
 * Use `create(DeleteRouteTemplateRequestSchema)` to create a new message.
 */
export const DeleteRouteTemplateRequestSchema: GenMessage<DeleteRouteTemplateRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 919);

/**
 * @generated from message zdc.StartRouteRequest
 */
export type StartRouteRequest = Message<"zdc.StartRouteRequest"> & {
  /**
   * @generated from field: string route_code = 1;
   */
  routeCode: string;

  /**
   * @generated from field: string entity_type = 2;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 3;
   */
  entityCode: string;

  /**
   * @generated from field: string entity_id = 4;
   */
  entityId: string;
};

/**
 * Describes the message zdc.StartRouteRequest.
 * Use `create(StartRouteRequestSchema)` to create a new message.
 */
export const StartRouteRequestSchema: GenMessage<StartRouteRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 920);

/**
 * @generated from message zdc.GetRouteInstanceRequest
 */
export type GetRouteInstanceRequest = Message<"zdc.GetRouteInstanceRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetRouteInstanceRequest.
 * Use `create(GetRouteInstanceRequestSchema)` to create a new message.
 */
export const GetRouteInstanceRequestSchema: GenMessage<GetRouteInstanceRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 921);

/**
 * @generated from message zdc.ListRouteInstancesRequest
 */
export type ListRouteInstancesRequest = Message<"zdc.ListRouteInstancesRequest"> & {
  /**
   * маршруты конкретной записи
   *
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: bool running_only = 2;
   */
  runningOnly: boolean;
};

/**
 * Describes the message zdc.ListRouteInstancesRequest.
 * Use `create(ListRouteInstancesRequestSchema)` to create a new message.
 */
export const ListRouteInstancesRequestSchema: GenMessage<ListRouteInstancesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 922);

/**
 * @generated from message zdc.RouteInstancesResponse
 */
export type RouteInstancesResponse = Message<"zdc.RouteInstancesResponse"> & {
  /**
   * @generated from field: repeated zdc.RouteInstanceInfo items = 1;
   */
  items: RouteInstanceInfo[];
};

/**
 * Describes the message zdc.RouteInstancesResponse.
 * Use `create(RouteInstancesResponseSchema)` to create a new message.
 */
export const RouteInstancesResponseSchema: GenMessage<RouteInstancesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 923);

/**
 * @generated from message zdc.ActRouteStepRequest
 */
export type ActRouteStepRequest = Message<"zdc.ActRouteStepRequest"> & {
  /**
   * @generated from field: string instance_id = 1;
   */
  instanceId: string;

  /**
   * @generated from field: int32 step_order = 2;
   */
  stepOrder: number;

  /**
   * approve|reject
   *
   * @generated from field: string action = 3;
   */
  action: string;

  /**
   * @generated from field: string comment = 4;
   */
  comment: string;
};

/**
 * Describes the message zdc.ActRouteStepRequest.
 * Use `create(ActRouteStepRequestSchema)` to create a new message.
 */
export const ActRouteStepRequestSchema: GenMessage<ActRouteStepRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 924);

/**
 * @generated from message zdc.CancelRouteRequest
 */
export type CancelRouteRequest = Message<"zdc.CancelRouteRequest"> & {
  /**
   * @generated from field: string instance_id = 1;
   */
  instanceId: string;

  /**
   * @generated from field: string comment = 2;
   */
  comment: string;
};

/**
 * Describes the message zdc.CancelRouteRequest.
 * Use `create(CancelRouteRequestSchema)` to create a new message.
 */
export const CancelRouteRequestSchema: GenMessage<CancelRouteRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 925);

/**
 * @generated from message zdc.SignatureInfo
 */
export type SignatureInfo = Message<"zdc.SignatureInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string file_id = 2;
   */
  fileId: string;

  /**
   * @generated from field: string version_id = 3;
   */
  versionId: string;

  /**
   * @generated from field: int32 version = 4;
   */
  version: number;

  /**
   * @generated from field: string signer_id = 5;
   */
  signerId: string;

  /**
   * @generated from field: string signer_name = 6;
   */
  signerName: string;

  /**
   * @generated from field: string cert_thumbprint = 7;
   */
  certThumbprint: string;

  /**
   * @generated from field: string sig_format = 8;
   */
  sigFormat: string;

  /**
   * @generated from field: int64 sig_size = 9;
   */
  sigSize: bigint;

  /**
   * stored|verified|failed|revoked
   *
   * @generated from field: string status = 10;
   */
  status: string;

  /**
   * @generated from field: string verified_at = 11;
   */
  verifiedAt: string;

  /**
   * @generated from field: string verify_error = 12;
   */
  verifyError: string;

  /**
   * @generated from field: string comment = 13;
   */
  comment: string;

  /**
   * @generated from field: string created_at = 14;
   */
  createdAt: string;

  /**
   * base64 .sig — только в GetSignature (скачивание)
   *
   * @generated from field: string sig_data = 15;
   */
  sigData: string;
};

/**
 * Describes the message zdc.SignatureInfo.
 * Use `create(SignatureInfoSchema)` to create a new message.
 */
export const SignatureInfoSchema: GenMessage<SignatureInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 926);

/**
 * @generated from message zdc.AttachSignatureRequest
 */
export type AttachSignatureRequest = Message<"zdc.AttachSignatureRequest"> & {
  /**
   * @generated from field: string file_id = 1;
   */
  fileId: string;

  /**
   * конкретная версия файла (M4); пусто = текущая
   *
   * @generated from field: string version_id = 2;
   */
  versionId: string;

  /**
   * base64 отделённой подписи (.sig)
   *
   * @generated from field: string sig_data = 3;
   */
  sigData: string;

  /**
   * CAdES-BES|CMS|...
   *
   * @generated from field: string sig_format = 4;
   */
  sigFormat: string;

  /**
   * @generated from field: string signer_name = 5;
   */
  signerName: string;

  /**
   * @generated from field: string certificate = 6;
   */
  certificate: string;

  /**
   * @generated from field: string cert_thumbprint = 7;
   */
  certThumbprint: string;

  /**
   * @generated from field: string comment = 8;
   */
  comment: string;
};

/**
 * Describes the message zdc.AttachSignatureRequest.
 * Use `create(AttachSignatureRequestSchema)` to create a new message.
 */
export const AttachSignatureRequestSchema: GenMessage<AttachSignatureRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 927);

/**
 * @generated from message zdc.ListSignaturesRequest
 */
export type ListSignaturesRequest = Message<"zdc.ListSignaturesRequest"> & {
  /**
   * @generated from field: string file_id = 1;
   */
  fileId: string;
};

/**
 * Describes the message zdc.ListSignaturesRequest.
 * Use `create(ListSignaturesRequestSchema)` to create a new message.
 */
export const ListSignaturesRequestSchema: GenMessage<ListSignaturesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 928);

/**
 * @generated from message zdc.SignaturesResponse
 */
export type SignaturesResponse = Message<"zdc.SignaturesResponse"> & {
  /**
   * @generated from field: repeated zdc.SignatureInfo items = 1;
   */
  items: SignatureInfo[];
};

/**
 * Describes the message zdc.SignaturesResponse.
 * Use `create(SignaturesResponseSchema)` to create a new message.
 */
export const SignaturesResponseSchema: GenMessage<SignaturesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 929);

/**
 * @generated from message zdc.GetSignatureRequest
 */
export type GetSignatureRequest = Message<"zdc.GetSignatureRequest"> & {
  /**
   * возвращает и sig_data (скачивание .sig)
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetSignatureRequest.
 * Use `create(GetSignatureRequestSchema)` to create a new message.
 */
export const GetSignatureRequestSchema: GenMessage<GetSignatureRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 930);

/**
 * @generated from message zdc.SetSignatureStatusRequest
 */
export type SetSignatureStatusRequest = Message<"zdc.SetSignatureStatusRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * verified|failed|revoked (внешний слой проверки)
   *
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string verify_error = 3;
   */
  verifyError: string;
};

/**
 * Describes the message zdc.SetSignatureStatusRequest.
 * Use `create(SetSignatureStatusRequestSchema)` to create a new message.
 */
export const SetSignatureStatusRequestSchema: GenMessage<SetSignatureStatusRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 931);

/**
 * @generated from message zdc.VpnProfileInfo
 */
export type VpnProfileInfo = Message<"zdc.VpnProfileInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string synonym = 4;
   */
  synonym: string;

  /**
   * wireguard|openvpn|ikev2|ssh|l2tp|vless|vmess|trojan|shadowsocks|hysteria2|tuic
   *
   * @generated from field: string protocol = 5;
   */
  protocol: string;

  /**
   * @generated from field: string server = 6;
   */
  server: string;

  /**
   * @generated from field: int32 port = 7;
   */
  port: number;

  /**
   * @generated from field: string public_key = 8;
   */
  publicKey: string;

  /**
   * @generated from field: string address = 9;
   */
  address: string;

  /**
   * @generated from field: string dns = 10;
   */
  dns: string;

  /**
   * @generated from field: string allowed_ips = 11;
   */
  allowedIps: string;

  /**
   * @generated from field: bool is_active = 12;
   */
  isActive: boolean;

  /**
   * @generated from field: string template_id = 13;
   */
  templateId: string;

  /**
   * extra — дополнительные параметры ПРОТОКОЛА (JSON): для openvpn содержит
   * ca/cert/key (приватный ключ клиента!) — отдаётся ТОЛЬКО управляющим VPN
   * (админ/vpn_manage); VPN-клиентам всегда пусто.
   *
   * @generated from field: string extra = 14;
   */
  extra: string;
};

/**
 * Describes the message zdc.VpnProfileInfo.
 * Use `create(VpnProfileInfoSchema)` to create a new message.
 */
export const VpnProfileInfoSchema: GenMessage<VpnProfileInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 932);

/**
 * @generated from message zdc.ListVpnProfilesRequest
 */
export type ListVpnProfilesRequest = Message<"zdc.ListVpnProfilesRequest"> & {
  /**
   * @generated from field: bool active_only = 1;
   */
  activeOnly: boolean;
};

/**
 * Describes the message zdc.ListVpnProfilesRequest.
 * Use `create(ListVpnProfilesRequestSchema)` to create a new message.
 */
export const ListVpnProfilesRequestSchema: GenMessage<ListVpnProfilesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 933);

/**
 * @generated from message zdc.VpnProfilesResponse
 */
export type VpnProfilesResponse = Message<"zdc.VpnProfilesResponse"> & {
  /**
   * @generated from field: repeated zdc.VpnProfileInfo items = 1;
   */
  items: VpnProfileInfo[];
};

/**
 * Describes the message zdc.VpnProfilesResponse.
 * Use `create(VpnProfilesResponseSchema)` to create a new message.
 */
export const VpnProfilesResponseSchema: GenMessage<VpnProfilesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 934);

/**
 * @generated from message zdc.SaveVpnProfileRequest
 */
export type SaveVpnProfileRequest = Message<"zdc.SaveVpnProfileRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string protocol = 4;
   */
  protocol: string;

  /**
   * @generated from field: string server = 5;
   */
  server: string;

  /**
   * @generated from field: int32 port = 6;
   */
  port: number;

  /**
   * @generated from field: string public_key = 7;
   */
  publicKey: string;

  /**
   * @generated from field: string address = 8;
   */
  address: string;

  /**
   * @generated from field: string dns = 9;
   */
  dns: string;

  /**
   * @generated from field: string allowed_ips = 10;
   */
  allowedIps: string;

  /**
   * @generated from field: string extra = 11;
   */
  extra: string;

  /**
   * @generated from field: bool is_active = 12;
   */
  isActive: boolean;

  /**
   * пусто = не менять существующий
   *
   * @generated from field: string psk = 13;
   */
  psk: string;

  /**
   * пусто = не менять существующий
   *
   * @generated from field: string private_key = 14;
   */
  privateKey: string;

  /**
   * ssh-пароль (вход без ключей); пусто = не менять
   *
   * @generated from field: string password = 15;
   */
  password: string;
};

/**
 * Describes the message zdc.SaveVpnProfileRequest.
 * Use `create(SaveVpnProfileRequestSchema)` to create a new message.
 */
export const SaveVpnProfileRequestSchema: GenMessage<SaveVpnProfileRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 935);

/**
 * @generated from message zdc.DeleteVpnProfileRequest
 */
export type DeleteVpnProfileRequest = Message<"zdc.DeleteVpnProfileRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.DeleteVpnProfileRequest.
 * Use `create(DeleteVpnProfileRequestSchema)` to create a new message.
 */
export const DeleteVpnProfileRequestSchema: GenMessage<DeleteVpnProfileRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 936);

/**
 * @generated from message zdc.GetVpnAccessRequest
 */
export type GetVpnAccessRequest = Message<"zdc.GetVpnAccessRequest"> & {
  /**
   * @generated from field: string profile_code = 1;
   */
  profileCode: string;
};

/**
 * Describes the message zdc.GetVpnAccessRequest.
 * Use `create(GetVpnAccessRequestSchema)` to create a new message.
 */
export const GetVpnAccessRequestSchema: GenMessage<GetVpnAccessRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 937);

/**
 * @generated from message zdc.VpnAccessResponse
 */
export type VpnAccessResponse = Message<"zdc.VpnAccessResponse"> & {
  /**
   * @generated from field: repeated string role_ids = 1;
   */
  roleIds: string[];
};

/**
 * Describes the message zdc.VpnAccessResponse.
 * Use `create(VpnAccessResponseSchema)` to create a new message.
 */
export const VpnAccessResponseSchema: GenMessage<VpnAccessResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 938);

/**
 * @generated from message zdc.SetVpnAccessRequest
 */
export type SetVpnAccessRequest = Message<"zdc.SetVpnAccessRequest"> & {
  /**
   * @generated from field: string profile_code = 1;
   */
  profileCode: string;

  /**
   * @generated from field: repeated string role_ids = 2;
   */
  roleIds: string[];
};

/**
 * Describes the message zdc.SetVpnAccessRequest.
 * Use `create(SetVpnAccessRequestSchema)` to create a new message.
 */
export const SetVpnAccessRequestSchema: GenMessage<SetVpnAccessRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 939);

/**
 * @generated from message zdc.VpnConfigRequest
 */
export type VpnConfigRequest = Message<"zdc.VpnConfigRequest"> & {
  /**
   * @generated from field: string profile_code = 1;
   */
  profileCode: string;
};

/**
 * Describes the message zdc.VpnConfigRequest.
 * Use `create(VpnConfigRequestSchema)` to create a new message.
 */
export const VpnConfigRequestSchema: GenMessage<VpnConfigRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 940);

/**
 * @generated from message zdc.VpnConfigResponse
 */
export type VpnConfigResponse = Message<"zdc.VpnConfigResponse"> & {
  /**
   * @generated from field: string profile_code = 1;
   */
  profileCode: string;

  /**
   * @generated from field: string protocol = 2;
   */
  protocol: string;

  /**
   * текст клиентского конфига/ссылки (формат — config_format)
   *
   * @generated from field: string config = 3;
   */
  config: string;

  /**
   * QR того же текста (WG: приложения сканируют INI; uri: ссылка клиента)
   *
   * @generated from field: string qr_png_base64 = 4;
   */
  qrPngBase64: string;

  /**
   * ссылка/текст для копирования (uri-протоколы; иначе — пусто)
   *
   * @generated from field: string share_link = 5;
   */
  shareLink: string;

  /**
   * ini|ovpn|mobileconfig|text|uri
   *
   * @generated from field: string config_format = 6;
   */
  configFormat: string;
};

/**
 * Describes the message zdc.VpnConfigResponse.
 * Use `create(VpnConfigResponseSchema)` to create a new message.
 */
export const VpnConfigResponseSchema: GenMessage<VpnConfigResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 941);

/**
 * GetSshAccess: параметры подключения к ВСТРОЕННОМУ SSH-серверу базы
 * (transport ssh). Гейт — системная роль «VPN-клиент» либо админ. Возвращает
 * адрес/порт/логин, публичный хост-ключ (пиннинг) и готовые команды; секреты не
 * отдаются (пароль — учётка базы, ключ — реестр устройств пользователя).
 *
 * @generated from message zdc.GetSshAccessRequest
 */
export type GetSshAccessRequest = Message<"zdc.GetSshAccessRequest"> & {
};

/**
 * Describes the message zdc.GetSshAccessRequest.
 * Use `create(GetSshAccessRequestSchema)` to create a new message.
 */
export const GetSshAccessRequestSchema: GenMessage<GetSshAccessRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 942);

/**
 * @generated from message zdc.SshAccessResponse
 */
export type SshAccessResponse = Message<"zdc.SshAccessResponse"> & {
  /**
   * у пользователя есть доступ (роль vpn_client / админ)
   *
   * @generated from field: bool available = 1;
   */
  available: boolean;

  /**
   * встроенный SSH включён и есть активный ssh-профиль
   *
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * адрес подключения
   *
   * @generated from field: string host = 3;
   */
  host: string;

  /**
   * порт
   *
   * @generated from field: int32 port = 4;
   */
  port: number;

  /**
   * логин платформы текущего пользователя
   *
   * @generated from field: string login = 5;
   */
  login: string;

  /**
   * публичный хост-ключ (authorized_keys-строка) для пиннинга
   *
   * @generated from field: string host_key = 6;
   */
  hostKey: string;

  /**
   * готовая команда ssh
   *
   * @generated from field: string command = 7;
   */
  command: string;

  /**
   * пример локального проброса (ssh -L)
   *
   * @generated from field: string local_forward = 8;
   */
  localForward: string;

  /**
   * пример удалённого проброса (ssh -R)
   *
   * @generated from field: string remote_forward = 9;
   */
  remoteForward: string;

  /**
   * у пользователя есть устройство с открытым ключом
   *
   * @generated from field: bool key_registered = 10;
   */
  keyRegistered: boolean;

  /**
   * пояснение состояния (если enabled=false)
   *
   * @generated from field: string message = 11;
   */
  message: string;
};

/**
 * Describes the message zdc.SshAccessResponse.
 * Use `create(SshAccessResponseSchema)` to create a new message.
 */
export const SshAccessResponseSchema: GenMessage<SshAccessResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 943);

/**
 * TestVpnProfile: ПРОВЕРКА ДОСТУПНОСТИ профиля (кнопка «Проверить соединение»).
 * TCP — wireguard/openvpn/l2tp и TCP-URI-протоколы; SSH-рукопожатие — ssh
 * (пиннинг extra.host_key, если задан; вход НЕ выполняется); UDP/QUIC
 * (ikev2/hysteria2/tuic) — ok=false «проверка не поддерживается» (честно).
 *
 * @generated from message zdc.TestVpnProfileRequest
 */
export type TestVpnProfileRequest = Message<"zdc.TestVpnProfileRequest"> & {
  /**
   * @generated from field: string profile_code = 1;
   */
  profileCode: string;
};

/**
 * Describes the message zdc.TestVpnProfileRequest.
 * Use `create(TestVpnProfileRequestSchema)` to create a new message.
 */
export const TestVpnProfileRequestSchema: GenMessage<TestVpnProfileRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 944);

/**
 * @generated from message zdc.TestVpnProfileResponse
 */
export type TestVpnProfileResponse = Message<"zdc.TestVpnProfileResponse"> & {
  /**
   * проверка пройдена
   *
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * русский текст ошибки (пусто при ok=true)
   *
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * задержка проверки (мс)
   *
   * @generated from field: int64 latency_ms = 3;
   */
  latencyMs: bigint;

  /**
   * что именно проверено / примечание
   *
   * @generated from field: string details = 4;
   */
  details: string;
};

/**
 * Describes the message zdc.TestVpnProfileResponse.
 * Use `create(TestVpnProfileResponseSchema)` to create a new message.
 */
export const TestVpnProfileResponseSchema: GenMessage<TestVpnProfileResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 945);

/**
 * @generated from message zdc.ListVpnSessionsRequest
 */
export type ListVpnSessionsRequest = Message<"zdc.ListVpnSessionsRequest"> & {
  /**
   * @generated from field: string profile_code = 1;
   */
  profileCode: string;
};

/**
 * Describes the message zdc.ListVpnSessionsRequest.
 * Use `create(ListVpnSessionsRequestSchema)` to create a new message.
 */
export const ListVpnSessionsRequestSchema: GenMessage<ListVpnSessionsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 946);

/**
 * @generated from message zdc.VpnSessionInfo
 */
export type VpnSessionInfo = Message<"zdc.VpnSessionInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string profile_code = 2;
   */
  profileCode: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: string client_info = 5;
   */
  clientInfo: string;

  /**
   * @generated from field: string connected_at = 6;
   */
  connectedAt: string;

  /**
   * @generated from field: string disconnected_at = 7;
   */
  disconnectedAt: string;
};

/**
 * Describes the message zdc.VpnSessionInfo.
 * Use `create(VpnSessionInfoSchema)` to create a new message.
 */
export const VpnSessionInfoSchema: GenMessage<VpnSessionInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 947);

/**
 * @generated from message zdc.VpnSessionsResponse
 */
export type VpnSessionsResponse = Message<"zdc.VpnSessionsResponse"> & {
  /**
   * @generated from field: repeated zdc.VpnSessionInfo items = 1;
   */
  items: VpnSessionInfo[];
};

/**
 * Describes the message zdc.VpnSessionsResponse.
 * Use `create(VpnSessionsResponseSchema)` to create a new message.
 */
export const VpnSessionsResponseSchema: GenMessage<VpnSessionsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 948);

/**
 * @generated from message zdc.StartVpnSessionRequest
 */
export type StartVpnSessionRequest = Message<"zdc.StartVpnSessionRequest"> & {
  /**
   * @generated from field: string profile_code = 1;
   */
  profileCode: string;

  /**
   * @generated from field: string client_info = 2;
   */
  clientInfo: string;
};

/**
 * Describes the message zdc.StartVpnSessionRequest.
 * Use `create(StartVpnSessionRequestSchema)` to create a new message.
 */
export const StartVpnSessionRequestSchema: GenMessage<StartVpnSessionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 949);

/**
 * @generated from message zdc.StartVpnSessionResponse
 */
export type StartVpnSessionResponse = Message<"zdc.StartVpnSessionResponse"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message zdc.StartVpnSessionResponse.
 * Use `create(StartVpnSessionResponseSchema)` to create a new message.
 */
export const StartVpnSessionResponseSchema: GenMessage<StartVpnSessionResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 950);

/**
 * @generated from message zdc.FinishVpnSessionRequest
 */
export type FinishVpnSessionRequest = Message<"zdc.FinishVpnSessionRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * disconnected|error
   *
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * Describes the message zdc.FinishVpnSessionRequest.
 * Use `create(FinishVpnSessionRequestSchema)` to create a new message.
 */
export const FinishVpnSessionRequestSchema: GenMessage<FinishVpnSessionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 951);

/**
 * Набор протоколов — ПО БАЗЕ. store — всегда доступны; extended — только при
 * включённой политике базы (vpn.extended_enabled). Клиент показывает только
 * разрешённые (нет разрешения → нет пункта, без заглушек).
 *
 * @generated from message zdc.VpnProtocolInfo
 */
export type VpnProtocolInfo = Message<"zdc.VpnProtocolInfo"> & {
  /**
   * wireguard|openvpn|ikev2|ssh|l2tp|vless|vmess|trojan|shadowsocks|hysteria2|tuic
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * отображаемая подпись
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * store | extended
   *
   * @generated from field: string kind = 3;
   */
  kind: string;
};

/**
 * Describes the message zdc.VpnProtocolInfo.
 * Use `create(VpnProtocolInfoSchema)` to create a new message.
 */
export const VpnProtocolInfoSchema: GenMessage<VpnProtocolInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 952);

/**
 * @generated from message zdc.VpnSettings
 */
export type VpnSettings = Message<"zdc.VpnSettings"> & {
  /**
   * политика базы (по умолчанию false)
   *
   * @generated from field: bool extended_enabled = 1;
   */
  extendedEnabled: boolean;

  /**
   * полный реестр протоколов с классификацией
   *
   * @generated from field: repeated zdc.VpnProtocolInfo protocols = 2;
   */
  protocols: VpnProtocolInfo[];
};

/**
 * Describes the message zdc.VpnSettings.
 * Use `create(VpnSettingsSchema)` to create a new message.
 */
export const VpnSettingsSchema: GenMessage<VpnSettings> = /*@__PURE__*/
  messageDesc(file_zdc, 953);

/**
 * @generated from message zdc.GetVpnSettingsRequest
 */
export type GetVpnSettingsRequest = Message<"zdc.GetVpnSettingsRequest"> & {
};

/**
 * Describes the message zdc.GetVpnSettingsRequest.
 * Use `create(GetVpnSettingsRequestSchema)` to create a new message.
 */
export const GetVpnSettingsRequestSchema: GenMessage<GetVpnSettingsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 954);

/**
 * @generated from message zdc.GetVpnSettingsResponse
 */
export type GetVpnSettingsResponse = Message<"zdc.GetVpnSettingsResponse"> & {
  /**
   * @generated from field: zdc.VpnSettings settings = 1;
   */
  settings?: VpnSettings | undefined;
};

/**
 * Describes the message zdc.GetVpnSettingsResponse.
 * Use `create(GetVpnSettingsResponseSchema)` to create a new message.
 */
export const GetVpnSettingsResponseSchema: GenMessage<GetVpnSettingsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 955);

/**
 * @generated from message zdc.SetVpnSettingsRequest
 */
export type SetVpnSettingsRequest = Message<"zdc.SetVpnSettingsRequest"> & {
  /**
   * @generated from field: bool extended_enabled = 1;
   */
  extendedEnabled: boolean;
};

/**
 * Describes the message zdc.SetVpnSettingsRequest.
 * Use `create(SetVpnSettingsRequestSchema)` to create a new message.
 */
export const SetVpnSettingsRequestSchema: GenMessage<SetVpnSettingsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 956);

/**
 * --- Страница ---
 *
 * @generated from message zdc.Page
 */
export type Page = Message<"zdc.Page"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * латиница, уникальный (URL /p/{slug})
   *
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * имя (в дереве конфигуратора)
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * синоним (заголовок рабочего стола/страницы)
   *
   * @generated from field: string synonym = 4;
   */
  synonym: string;

  /**
   * 'worktable' | 'workspace' | 'site' | 'public' | 'page'
   *
   * @generated from field: string kind = 5;
   */
  kind: string;

  /**
   * JSON макет: {rows: [{cols: [{span, widgets: [{widget_type, props}]}]}]}
   *
   * @generated from field: string layout = 6;
   */
  layout: string;

  /**
   * @generated from field: bool is_system = 7;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 8;
   */
  templateId: string;

  /**
   * @generated from field: string template_version = 9;
   */
  templateVersion: string;

  /**
   * @generated from field: string created_at = 10;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 11;
   */
  updatedAt: string;

  /**
   * @generated from field: string created_by = 12;
   */
  createdBy: string;

  /**
   * @generated from field: string updated_by = 13;
   */
  updatedBy: string;

  /**
   * Workspace: тип приложения внутри платформы (расширяемый реестр)
   *
   * 'default' (Предприятие) | 'messenger' | ...
   *
   * @generated from field: string app_kind = 14;
   */
  appKind: string;

  /**
   * Workspace: иконка для свитчера (лукап из клиента по app_kind)
   *
   * @generated from field: string icon = 15;
   */
  icon: string;

  /**
   * Workspace: состав ПРИЛОЖЕНИЙ (коды kind='app'), входящих в этот воркспейс.
   * Приложение — самостоятельный модуль (чат и т.п.), чат по умолчанию на весь
   * воркспейс (не обязательно полноэкранное). Пусто у kind != 'workspace'.
   *
   * @generated from field: repeated string apps = 16;
   */
  apps: string[];

  /**
   * ПРИЛОЖЕНИЕ (kind='app'): endpoint БЭКЕНДА приложения (свой сервис на Go/
   * Python/Rust; вызывается через sdk.rpc-прокси ядра с JWT/RBAC контекстом).
   * Пусто — приложение только клиентское (или логика в модулях ядра/WASM).
   *
   * @generated from field: string backend_url = 17;
   */
  backendUrl: string;

  /**
   * ПРИЛОЖЕНИЕ (kind='app'): JSON-конфиг СЕРВИСА (под-этап A):
   * {run_mode:"external"|"managed"|"", external_url, bin_file_id, file_name,
   *  port, health_path, args:[], auto_start:bool}. SSoT — сервер.
   *
   * @generated from field: string backend_settings = 18;
   */
  backendSettings: string;
};

/**
 * Describes the message zdc.Page.
 * Use `create(PageSchema)` to create a new message.
 */
export const PageSchema: GenMessage<Page> = /*@__PURE__*/
  messageDesc(file_zdc, 957);

/**
 * @generated from message zdc.PageList
 */
export type PageList = Message<"zdc.PageList"> & {
  /**
   * @generated from field: repeated zdc.Page items = 1;
   */
  items: Page[];
};

/**
 * Describes the message zdc.PageList.
 * Use `create(PageListSchema)` to create a new message.
 */
export const PageListSchema: GenMessage<PageList> = /*@__PURE__*/
  messageDesc(file_zdc, 958);

/**
 * Доступные воркспейсы пользователя (ListMyWorkspaces).
 *
 * @generated from message zdc.WorkspaceList
 */
export type WorkspaceList = Message<"zdc.WorkspaceList"> & {
  /**
   * @generated from field: repeated zdc.Page items = 1;
   */
  items: Page[];

  /**
   * Основной воркспейс (код): пользователь → роль → config.default_workspace →
   * системный «Предприятие» (всегда не менее одного).
   *
   * @generated from field: string default_code = 2;
   */
  defaultCode: string;
};

/**
 * Describes the message zdc.WorkspaceList.
 * Use `create(WorkspaceListSchema)` to create a new message.
 */
export const WorkspaceListSchema: GenMessage<WorkspaceList> = /*@__PURE__*/
  messageDesc(file_zdc, 959);

/**
 * @generated from message zdc.ListPagesRequest
 */
export type ListPagesRequest = Message<"zdc.ListPagesRequest"> & {
};

/**
 * Describes the message zdc.ListPagesRequest.
 * Use `create(ListPagesRequestSchema)` to create a new message.
 */
export const ListPagesRequestSchema: GenMessage<ListPagesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 960);

/**
 * @generated from message zdc.GetPageRequest
 */
export type GetPageRequest = Message<"zdc.GetPageRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message zdc.GetPageRequest.
 * Use `create(GetPageRequestSchema)` to create a new message.
 */
export const GetPageRequestSchema: GenMessage<GetPageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 961);

/**
 * @generated from message zdc.CreatePageRequest
 */
export type CreatePageRequest = Message<"zdc.CreatePageRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * 'worktable' (default) | 'workspace' | 'app' | ...
   *
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * @generated from field: string layout = 5;
   */
  layout: string;

  /**
   * @generated from field: string app_kind = 6;
   */
  appKind: string;

  /**
   * Состав приложений воркспейса (коды kind='app'); только для kind='workspace'.
   *
   * @generated from field: repeated string apps = 7;
   */
  apps: string[];

  /**
   * Приложение: endpoint бэкенда (kind='app').
   *
   * @generated from field: string backend_url = 8;
   */
  backendUrl: string;

  /**
   * Приложение: JSON-конфиг сервиса (backend_settings; под-этап A).
   *
   * @generated from field: string backend_settings = 9;
   */
  backendSettings: string;
};

/**
 * Describes the message zdc.CreatePageRequest.
 * Use `create(CreatePageRequestSchema)` to create a new message.
 */
export const CreatePageRequestSchema: GenMessage<CreatePageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 962);

/**
 * @generated from message zdc.UpdatePageRequest
 */
export type UpdatePageRequest = Message<"zdc.UpdatePageRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * @generated from field: string layout = 5;
   */
  layout: string;

  /**
   * @generated from field: string app_kind = 6;
   */
  appKind: string;

  /**
   * Состав приложений воркспейса (полная замена; пусто = очистить)
   *
   * @generated from field: repeated string apps = 7;
   */
  apps: string[];

  /**
   * @generated from field: string backend_url = 8;
   */
  backendUrl: string;

  /**
   * JSON-конфиг сервиса (пустая строка = очистить; под-этап A).
   *
   * @generated from field: string backend_settings = 9;
   */
  backendSettings: string;
};

/**
 * Describes the message zdc.UpdatePageRequest.
 * Use `create(UpdatePageRequestSchema)` to create a new message.
 */
export const UpdatePageRequestSchema: GenMessage<UpdatePageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 963);

/**
 * @generated from message zdc.DeletePageRequest
 */
export type DeletePageRequest = Message<"zdc.DeletePageRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeletePageRequest.
 * Use `create(DeletePageRequestSchema)` to create a new message.
 */
export const DeletePageRequestSchema: GenMessage<DeletePageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 964);

/**
 * @generated from message zdc.CopyPageRequest
 */
export type CopyPageRequest = Message<"zdc.CopyPageRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string code = 4;
   */
  code: string;
};

/**
 * Describes the message zdc.CopyPageRequest.
 * Use `create(CopyPageRequestSchema)` to create a new message.
 */
export const CopyPageRequestSchema: GenMessage<CopyPageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 965);

/**
 * @generated from message zdc.UnprotectPageRequest
 */
export type UnprotectPageRequest = Message<"zdc.UnprotectPageRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.UnprotectPageRequest.
 * Use `create(UnprotectPageRequestSchema)` to create a new message.
 */
export const UnprotectPageRequestSchema: GenMessage<UnprotectPageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 966);

/**
 * --- Назначения (роли/пользователи) ---
 *
 * @generated from message zdc.PageRole
 */
export type PageRole = Message<"zdc.PageRole"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string page_id = 2;
   */
  pageId: string;

  /**
   * NULL = для всех (default)
   *
   * @generated from field: string role_id = 3;
   */
  roleId: string;

  /**
   * NULL = для всех; приоритет: entity > role > default
   *
   * @generated from field: string entity_id = 4;
   */
  entityId: string;

  /**
   * резолв (отображение)
   *
   * @generated from field: string role_name = 5;
   */
  roleName: string;

  /**
   * резолв (отображение)
   *
   * @generated from field: string entity_name = 6;
   */
  entityName: string;

  /**
   * назначение «по умолчанию» от поставки
   *
   * @generated from field: bool is_default = 7;
   */
  isDefault: boolean;

  /**
   * @generated from field: string created_by = 8;
   */
  createdBy: string;

  /**
   * порядок назначения (детерминированный резолв: sort_order, role_id)
   *
   * @generated from field: int32 sort_order = 9;
   */
  sortOrder: number;
};

/**
 * Describes the message zdc.PageRole.
 * Use `create(PageRoleSchema)` to create a new message.
 */
export const PageRoleSchema: GenMessage<PageRole> = /*@__PURE__*/
  messageDesc(file_zdc, 967);

/**
 * @generated from message zdc.PageRoleList
 */
export type PageRoleList = Message<"zdc.PageRoleList"> & {
  /**
   * @generated from field: repeated zdc.PageRole items = 1;
   */
  items: PageRole[];
};

/**
 * Describes the message zdc.PageRoleList.
 * Use `create(PageRoleListSchema)` to create a new message.
 */
export const PageRoleListSchema: GenMessage<PageRoleList> = /*@__PURE__*/
  messageDesc(file_zdc, 968);

/**
 * @generated from message zdc.ListPageRolesRequest
 */
export type ListPageRolesRequest = Message<"zdc.ListPageRolesRequest"> & {
  /**
   * @generated from field: string page_id = 1;
   */
  pageId: string;
};

/**
 * Describes the message zdc.ListPageRolesRequest.
 * Use `create(ListPageRolesRequestSchema)` to create a new message.
 */
export const ListPageRolesRequestSchema: GenMessage<ListPageRolesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 969);

/**
 * @generated from message zdc.SetPageRolesRequest
 */
export type SetPageRolesRequest = Message<"zdc.SetPageRolesRequest"> & {
  /**
   * @generated from field: string page_id = 1;
   */
  pageId: string;

  /**
   * полная замена (как SetObjectRights)
   *
   * @generated from field: repeated zdc.PageRole items = 2;
   */
  items: PageRole[];
};

/**
 * Describes the message zdc.SetPageRolesRequest.
 * Use `create(SetPageRolesRequestSchema)` to create a new message.
 */
export const SetPageRolesRequestSchema: GenMessage<SetPageRolesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 970);

/**
 * --- Рабочий стол текущего пользователя ---
 *
 * @generated from message zdc.WorktableResponse
 */
export type WorktableResponse = Message<"zdc.WorktableResponse"> & {
  /**
   * @generated from field: zdc.Page page = 1;
   */
  page?: Page | undefined;

  /**
   * @generated from field: string page_id = 2;
   */
  pageId: string;

  /**
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * @generated from field: string synonym = 4;
   */
  synonym: string;
};

/**
 * Describes the message zdc.WorktableResponse.
 * Use `create(WorktableResponseSchema)` to create a new message.
 */
export const WorktableResponseSchema: GenMessage<WorktableResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 971);

/**
 * --- Публичная страница (без JWT) ---
 *
 * @generated from message zdc.GetPublicPageRequest
 */
export type GetPublicPageRequest = Message<"zdc.GetPublicPageRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.GetPublicPageRequest.
 * Use `create(GetPublicPageRequestSchema)` to create a new message.
 */
export const GetPublicPageRequestSchema: GenMessage<GetPublicPageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 972);

/**
 * @generated from message zdc.Site
 */
export type Site = Message<"zdc.Site"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * латиница, уникален (URL /p/{site})
   *
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string synonym = 4;
   */
  synonym: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * тема оформления (metadata themes; пусто = по умолчанию)
   *
   * @generated from field: string theme_id = 6;
   */
  themeId: string;

  /**
   * ["site.example.ru"] (Этап 2)
   *
   * @generated from field: repeated string domains = 7;
   */
  domains: string[];

  /**
   * ["ru","en"]; пусто → ["ru"]
   *
   * @generated from field: repeated string locales = 8;
   */
  locales: string[];

  /**
   * '' → первая из locales
   *
   * @generated from field: string default_locale = 9;
   */
  defaultLocale: string;

  /**
   * JSON {header,footer,menus,tokens,seo,pwa}
   *
   * @generated from field: string settings = 10;
   */
  settings: string;

  /**
   * Черновик/Опубликован (выключенный → 404)
   *
   * @generated from field: bool is_published = 11;
   */
  isPublished: boolean;

  /**
   * @generated from field: bool is_system = 12;
   */
  isSystem: boolean;

  /**
   * поставка
   *
   * @generated from field: string template_id = 13;
   */
  templateId: string;

  /**
   * @generated from field: string template_version = 14;
   */
  templateVersion: string;

  /**
   * @generated from field: string created_at = 15;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 16;
   */
  updatedAt: string;

  /**
   * @generated from field: string created_by = 17;
   */
  createdBy: string;

  /**
   * @generated from field: string updated_by = 18;
   */
  updatedBy: string;
};

/**
 * Describes the message zdc.Site.
 * Use `create(SiteSchema)` to create a new message.
 */
export const SiteSchema: GenMessage<Site> = /*@__PURE__*/
  messageDesc(file_zdc, 973);

/**
 * @generated from message zdc.SitePage
 */
export type SitePage = Message<"zdc.SitePage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string site_code = 2;
   */
  siteCode: string;

  /**
   * дерево страниц ('' = корень)
   *
   * @generated from field: string parent_id = 3;
   */
  parentId: string;

  /**
   * уникален в сайте
   *
   * @generated from field: string code = 4;
   */
  code: string;

  /**
   * '' (главная) | 'about' | 'uslugi/montazh'
   *
   * @generated from field: string slug = 5;
   */
  slug: string;

  /**
   * @generated from field: string name = 6;
   */
  name: string;

  /**
   * JSON PageLayout (rows→cols→widgets + appearance)
   *
   * @generated from field: string layout = 7;
   */
  layout: string;

  /**
   * JSON (многоязычный)
   *
   * @generated from field: string seo = 8;
   */
  seo: string;

  /**
   * 'draft' | 'published' (''=draft)
   *
   * @generated from field: string status = 9;
   */
  status: string;

  /**
   * @generated from field: int32 sort_order = 10;
   */
  sortOrder: number;

  /**
   * @generated from field: bool is_system = 11;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 12;
   */
  templateId: string;

  /**
   * @generated from field: string template_version = 13;
   */
  templateVersion: string;

  /**
   * @generated from field: string created_at = 14;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 15;
   */
  updatedAt: string;

  /**
   * @generated from field: string created_by = 16;
   */
  createdBy: string;

  /**
   * @generated from field: string updated_by = 17;
   */
  updatedBy: string;

  /**
   * Страницы ОБЪЕКТОВ (Этап 2): шаблон записи справочника/документа,
   * URL /p/{site}[/{locale}]/{slug_prefix}/{ref}.
   *
   * '' | 'object'
   *
   * @generated from field: string kind = 18;
   */
  kind: string;

  /**
   * 'catalog' | 'document'
   *
   * @generated from field: string object_type = 19;
   */
  objectType: string;

  /**
   * код справочника/документа
   *
   * @generated from field: string object_name = 20;
   */
  objectName: string;

  /**
   * 'item' | 'list' (список записей)
   *
   * @generated from field: string object_mode = 21;
   */
  objectMode: string;

  /**
   * префикс URL («uslugi»)
   *
   * @generated from field: string slug_prefix = 22;
   */
  slugPrefix: string;

  /**
   * данные записи (только GetPublicPage страницы объекта)
   *
   * @generated from field: map<string, string> record = 23;
   */
  record: { [key: string]: string };

  /**
   * Список записей (object_mode='list', хвосты Этапов 2–3): whitelist полей
   * отбора из query-параметров (CSV column_name) + постраничный результат.
   *
   * @generated from field: string query_fields = 24;
   */
  queryFields: string;

  /**
   * записи списка (GetPublicPage list-страницы)
   *
   * @generated from field: repeated zdc.SiteRecordItem records = 25;
   */
  records: SiteRecordItem[];

  /**
   * всего записей (list-страница)
   *
   * @generated from field: int32 total = 26;
   */
  total: number;

  /**
   * страница (1-based; 1 = без параметра)
   *
   * @generated from field: int32 page = 27;
   */
  page: number;

  /**
   * размер страницы (≤ 100)
   *
   * @generated from field: int32 page_size = 28;
   */
  pageSize: number;
};

/**
 * Describes the message zdc.SitePage.
 * Use `create(SitePageSchema)` to create a new message.
 */
export const SitePageSchema: GenMessage<SitePage> = /*@__PURE__*/
  messageDesc(file_zdc, 974);

/**
 * SiteRecordItem — запись страницы-списка объекта: ref (код/номер) + значения
 * колонок (+ {col}_presentation). SSoT — сервер.
 *
 * @generated from message zdc.SiteRecordItem
 */
export type SiteRecordItem = Message<"zdc.SiteRecordItem"> & {
  /**
   * @generated from field: string ref = 1;
   */
  ref: string;

  /**
   * @generated from field: map<string, string> values = 2;
   */
  values: { [key: string]: string };
};

/**
 * Describes the message zdc.SiteRecordItem.
 * Use `create(SiteRecordItemSchema)` to create a new message.
 */
export const SiteRecordItemSchema: GenMessage<SiteRecordItem> = /*@__PURE__*/
  messageDesc(file_zdc, 975);

/**
 * @generated from message zdc.SiteList
 */
export type SiteList = Message<"zdc.SiteList"> & {
  /**
   * @generated from field: repeated zdc.Site items = 1;
   */
  items: Site[];
};

/**
 * Describes the message zdc.SiteList.
 * Use `create(SiteListSchema)` to create a new message.
 */
export const SiteListSchema: GenMessage<SiteList> = /*@__PURE__*/
  messageDesc(file_zdc, 976);

/**
 * @generated from message zdc.ListSitesRequest
 */
export type ListSitesRequest = Message<"zdc.ListSitesRequest"> & {
};

/**
 * Describes the message zdc.ListSitesRequest.
 * Use `create(ListSitesRequestSchema)` to create a new message.
 */
export const ListSitesRequestSchema: GenMessage<ListSitesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 977);

/**
 * @generated from message zdc.GetSiteRequest
 */
export type GetSiteRequest = Message<"zdc.GetSiteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message zdc.GetSiteRequest.
 * Use `create(GetSiteRequestSchema)` to create a new message.
 */
export const GetSiteRequestSchema: GenMessage<GetSiteRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 978);

/**
 * @generated from message zdc.SaveSiteRequest
 */
export type SaveSiteRequest = Message<"zdc.SaveSiteRequest"> & {
  /**
   * пусто = создать
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string synonym = 4;
   */
  synonym: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: string theme_id = 6;
   */
  themeId: string;

  /**
   * @generated from field: repeated string domains = 7;
   */
  domains: string[];

  /**
   * @generated from field: repeated string locales = 8;
   */
  locales: string[];

  /**
   * @generated from field: string default_locale = 9;
   */
  defaultLocale: string;

  /**
   * @generated from field: string settings = 10;
   */
  settings: string;

  /**
   * @generated from field: bool is_published = 11;
   */
  isPublished: boolean;
};

/**
 * Describes the message zdc.SaveSiteRequest.
 * Use `create(SaveSiteRequestSchema)` to create a new message.
 */
export const SaveSiteRequestSchema: GenMessage<SaveSiteRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 979);

/**
 * @generated from message zdc.DeleteSiteRequest
 */
export type DeleteSiteRequest = Message<"zdc.DeleteSiteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteSiteRequest.
 * Use `create(DeleteSiteRequestSchema)` to create a new message.
 */
export const DeleteSiteRequestSchema: GenMessage<DeleteSiteRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 980);

/**
 * @generated from message zdc.CopySiteRequest
 */
export type CopySiteRequest = Message<"zdc.CopySiteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string code = 4;
   */
  code: string;
};

/**
 * Describes the message zdc.CopySiteRequest.
 * Use `create(CopySiteRequestSchema)` to create a new message.
 */
export const CopySiteRequestSchema: GenMessage<CopySiteRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 981);

/**
 * @generated from message zdc.UnprotectSiteRequest
 */
export type UnprotectSiteRequest = Message<"zdc.UnprotectSiteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.UnprotectSiteRequest.
 * Use `create(UnprotectSiteRequestSchema)` to create a new message.
 */
export const UnprotectSiteRequestSchema: GenMessage<UnprotectSiteRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 982);

/**
 * @generated from message zdc.SitePageList
 */
export type SitePageList = Message<"zdc.SitePageList"> & {
  /**
   * @generated from field: repeated zdc.SitePage items = 1;
   */
  items: SitePage[];
};

/**
 * Describes the message zdc.SitePageList.
 * Use `create(SitePageListSchema)` to create a new message.
 */
export const SitePageListSchema: GenMessage<SitePageList> = /*@__PURE__*/
  messageDesc(file_zdc, 983);

/**
 * @generated from message zdc.ListSitePagesRequest
 */
export type ListSitePagesRequest = Message<"zdc.ListSitePagesRequest"> & {
  /**
   * @generated from field: string site_code = 1;
   */
  siteCode: string;
};

/**
 * Describes the message zdc.ListSitePagesRequest.
 * Use `create(ListSitePagesRequestSchema)` to create a new message.
 */
export const ListSitePagesRequestSchema: GenMessage<ListSitePagesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 984);

/**
 * @generated from message zdc.GetSitePageRequest
 */
export type GetSitePageRequest = Message<"zdc.GetSitePageRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string site_code = 2;
   */
  siteCode: string;

  /**
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * @generated from field: string slug = 4;
   */
  slug: string;
};

/**
 * Describes the message zdc.GetSitePageRequest.
 * Use `create(GetSitePageRequestSchema)` to create a new message.
 */
export const GetSitePageRequestSchema: GenMessage<GetSitePageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 985);

/**
 * @generated from message zdc.SaveSitePageRequest
 */
export type SaveSitePageRequest = Message<"zdc.SaveSitePageRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string site_code = 2;
   */
  siteCode: string;

  /**
   * @generated from field: string parent_id = 3;
   */
  parentId: string;

  /**
   * @generated from field: string code = 4;
   */
  code: string;

  /**
   * @generated from field: string slug = 5;
   */
  slug: string;

  /**
   * @generated from field: string name = 6;
   */
  name: string;

  /**
   * @generated from field: string layout = 7;
   */
  layout: string;

  /**
   * @generated from field: string seo = 8;
   */
  seo: string;

  /**
   * @generated from field: string status = 9;
   */
  status: string;

  /**
   * @generated from field: int32 sort_order = 10;
   */
  sortOrder: number;

  /**
   * Страницы объектов (Этап 2)
   *
   * @generated from field: string kind = 11;
   */
  kind: string;

  /**
   * @generated from field: string object_type = 12;
   */
  objectType: string;

  /**
   * @generated from field: string object_name = 13;
   */
  objectName: string;

  /**
   * @generated from field: string object_mode = 14;
   */
  objectMode: string;

  /**
   * @generated from field: string slug_prefix = 15;
   */
  slugPrefix: string;

  /**
   * Поля отбора из URL (CSV column_name; whitelist query-параметров, §2 хвостов)
   *
   * @generated from field: string query_fields = 16;
   */
  queryFields: string;
};

/**
 * Describes the message zdc.SaveSitePageRequest.
 * Use `create(SaveSitePageRequestSchema)` to create a new message.
 */
export const SaveSitePageRequestSchema: GenMessage<SaveSitePageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 986);

/**
 * @generated from message zdc.DeleteSitePageRequest
 */
export type DeleteSitePageRequest = Message<"zdc.DeleteSitePageRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteSitePageRequest.
 * Use `create(DeleteSitePageRequestSchema)` to create a new message.
 */
export const DeleteSitePageRequestSchema: GenMessage<DeleteSitePageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 987);

/**
 * @generated from message zdc.CopySitePageRequest
 */
export type CopySitePageRequest = Message<"zdc.CopySitePageRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * @generated from field: string slug = 4;
   */
  slug: string;
};

/**
 * Describes the message zdc.CopySitePageRequest.
 * Use `create(CopySitePageRequestSchema)` to create a new message.
 */
export const CopySitePageRequestSchema: GenMessage<CopySitePageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 988);

/**
 * @generated from message zdc.GetPublicSiteRequest
 */
export type GetPublicSiteRequest = Message<"zdc.GetPublicSiteRequest"> & {
  /**
   * @generated from field: string site = 1;
   */
  site: string;

  /**
   * @generated from field: bool preview = 2;
   */
  preview: boolean;
};

/**
 * Describes the message zdc.GetPublicSiteRequest.
 * Use `create(GetPublicSiteRequestSchema)` to create a new message.
 */
export const GetPublicSiteRequestSchema: GenMessage<GetPublicSiteRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 989);

/**
 * @generated from message zdc.PublicSite
 */
export type PublicSite = Message<"zdc.PublicSite"> & {
  /**
   * @generated from field: zdc.Site site = 1;
   */
  site?: Site | undefined;

  /**
   * дерево: code/slug/name/status/seo (БЕЗ layout)
   *
   * @generated from field: repeated zdc.SitePage pages = 2;
   */
  pages: SitePage[];
};

/**
 * Describes the message zdc.PublicSite.
 * Use `create(PublicSiteSchema)` to create a new message.
 */
export const PublicSiteSchema: GenMessage<PublicSite> = /*@__PURE__*/
  messageDesc(file_zdc, 990);

/**
 * @generated from message zdc.GetSitePublicPageRequest
 */
export type GetSitePublicPageRequest = Message<"zdc.GetSitePublicPageRequest"> & {
  /**
   * @generated from field: string site = 1;
   */
  site: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string locale = 3;
   */
  locale: string;

  /**
   * @generated from field: bool preview = 4;
   */
  preview: boolean;

  /**
   * Список записей (object_mode='list'): страница 1-based, размер ≤ 100,
   * отборы — ТОЛЬКО поля query_fields страницы (unknown/пустые игнорируются).
   *
   * @generated from field: int32 page = 5;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 6;
   */
  pageSize: number;

  /**
   * @generated from field: map<string, string> filters = 7;
   */
  filters: { [key: string]: string };
};

/**
 * Describes the message zdc.GetSitePublicPageRequest.
 * Use `create(GetSitePublicPageRequestSchema)` to create a new message.
 */
export const GetSitePublicPageRequestSchema: GenMessage<GetSitePublicPageRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 991);

/**
 * @generated from message zdc.ListSiteSitemapRequest
 */
export type ListSiteSitemapRequest = Message<"zdc.ListSiteSitemapRequest"> & {
  /**
   * @generated from field: string site = 1;
   */
  site: string;
};

/**
 * Describes the message zdc.ListSiteSitemapRequest.
 * Use `create(ListSiteSitemapRequestSchema)` to create a new message.
 */
export const ListSiteSitemapRequestSchema: GenMessage<ListSiteSitemapRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 992);

/**
 * @generated from message zdc.SiteSitemap
 */
export type SiteSitemap = Message<"zdc.SiteSitemap"> & {
  /**
   * @generated from field: repeated zdc.SitePage items = 1;
   */
  items: SitePage[];
};

/**
 * Describes the message zdc.SiteSitemap.
 * Use `create(SiteSitemapSchema)` to create a new message.
 */
export const SiteSitemapSchema: GenMessage<SiteSitemap> = /*@__PURE__*/
  messageDesc(file_zdc, 993);

/**
 * --- Поиск по сайту (Этап 3) ---
 *
 * @generated from message zdc.SiteSearchRequest
 */
export type SiteSearchRequest = Message<"zdc.SiteSearchRequest"> & {
  /**
   * @generated from field: string site = 1;
   */
  site: string;

  /**
   * поисковая строка (пусто → пустой результат)
   *
   * @generated from field: string q = 2;
   */
  q: string;

  /**
   * 0-based
   *
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * ≤50
   *
   * @generated from field: int32 page_size = 4;
   */
  pageSize: number;

  /**
   * поля фасетов (только из whitelist целей)
   *
   * @generated from field: repeated string facets = 5;
   */
  facets: string[];

  /**
   * выбранный фасет (URL ?facet=field:value)
   *
   * @generated from field: string filter_field = 6;
   */
  filterField: string;

  /**
   * @generated from field: string filter_value = 7;
   */
  filterValue: string;
};

/**
 * Describes the message zdc.SiteSearchRequest.
 * Use `create(SiteSearchRequestSchema)` to create a new message.
 */
export const SiteSearchRequestSchema: GenMessage<SiteSearchRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 994);

/**
 * @generated from message zdc.SiteSearchItem
 */
export type SiteSearchItem = Message<"zdc.SiteSearchItem"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * готовый URL (urlTemplate + ref)
   *
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string excerpt = 3;
   */
  excerpt: string;

  /**
   * код/номер записи
   *
   * @generated from field: string ref = 4;
   */
  ref: string;

  /**
   * @generated from field: string object_type = 5;
   */
  objectType: string;

  /**
   * @generated from field: string object_code = 6;
   */
  objectCode: string;
};

/**
 * Describes the message zdc.SiteSearchItem.
 * Use `create(SiteSearchItemSchema)` to create a new message.
 */
export const SiteSearchItemSchema: GenMessage<SiteSearchItem> = /*@__PURE__*/
  messageDesc(file_zdc, 995);

/**
 * @generated from message zdc.SiteSearchFacetValue
 */
export type SiteSearchFacetValue = Message<"zdc.SiteSearchFacetValue"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: int32 count = 3;
   */
  count: number;
};

/**
 * Describes the message zdc.SiteSearchFacetValue.
 * Use `create(SiteSearchFacetValueSchema)` to create a new message.
 */
export const SiteSearchFacetValueSchema: GenMessage<SiteSearchFacetValue> = /*@__PURE__*/
  messageDesc(file_zdc, 996);

/**
 * @generated from message zdc.SiteSearchFacet
 */
export type SiteSearchFacet = Message<"zdc.SiteSearchFacet"> & {
  /**
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * @generated from field: repeated zdc.SiteSearchFacetValue values = 2;
   */
  values: SiteSearchFacetValue[];
};

/**
 * Describes the message zdc.SiteSearchFacet.
 * Use `create(SiteSearchFacetSchema)` to create a new message.
 */
export const SiteSearchFacetSchema: GenMessage<SiteSearchFacet> = /*@__PURE__*/
  messageDesc(file_zdc, 997);

/**
 * @generated from message zdc.SiteSearchResponse
 */
export type SiteSearchResponse = Message<"zdc.SiteSearchResponse"> & {
  /**
   * @generated from field: repeated zdc.SiteSearchItem items = 1;
   */
  items: SiteSearchItem[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * @generated from field: repeated zdc.SiteSearchFacet facets = 3;
   */
  facets: SiteSearchFacet[];
};

/**
 * Describes the message zdc.SiteSearchResponse.
 * Use `create(SiteSearchResponseSchema)` to create a new message.
 */
export const SiteSearchResponseSchema: GenMessage<SiteSearchResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 998);

/**
 * --- AI-перевод сайта (Этап 3) ---
 *
 * @generated from message zdc.TranslateSiteRequest
 */
export type TranslateSiteRequest = Message<"zdc.TranslateSiteRequest"> & {
  /**
   * код сайта
   *
   * @generated from field: string site = 1;
   */
  site: string;

  /**
   * целевая локаль (∈ локалей сайта)
   *
   * @generated from field: string target_locale = 2;
   */
  targetLocale: string;

  /**
   * '' = весь сайт (все страницы + настройки)
   *
   * @generated from field: string page_code = 3;
   */
  pageCode: string;
};

/**
 * Describes the message zdc.TranslateSiteRequest.
 * Use `create(TranslateSiteRequestSchema)` to create a new message.
 */
export const TranslateSiteRequestSchema: GenMessage<TranslateSiteRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 999);

/**
 * @generated from message zdc.TranslateSiteResponse
 */
export type TranslateSiteResponse = Message<"zdc.TranslateSiteResponse"> & {
  /**
   * добавлено переводов
   *
   * @generated from field: int32 translated = 1;
   */
  translated: number;

  /**
   * уже переведено (merge — не затираем)
   *
   * @generated from field: int32 skipped = 2;
   */
  skipped: number;

  /**
   * не удалось перевести (модель не вернула)
   *
   * @generated from field: int32 failed = 3;
   */
  failed: number;
};

/**
 * Describes the message zdc.TranslateSiteResponse.
 * Use `create(TranslateSiteResponseSchema)` to create a new message.
 */
export const TranslateSiteResponseSchema: GenMessage<TranslateSiteResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1000);

/**
 * @generated from message zdc.Review
 */
export type Review = Message<"zdc.Review"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * catalog | document | order | task | ...
   *
   * @generated from field: string object_type = 2;
   */
  objectType: string;

  /**
   * @generated from field: string object_code = 3;
   */
  objectCode: string;

  /**
   * @generated from field: string object_id = 4;
   */
  objectId: string;

  /**
   * '' — гость
   *
   * @generated from field: string author_id = 5;
   */
  authorId: string;

  /**
   * резолв сервера (entities.name)
   *
   * @generated from field: string author_name = 6;
   */
  authorName: string;

  /**
   * имя гостя (author_id пуст)
   *
   * @generated from field: string guest_name = 7;
   */
  guestName: string;

  /**
   * 1..5
   *
   * @generated from field: int32 rating = 8;
   */
  rating: number;

  /**
   * @generated from field: string text = 9;
   */
  text: string;

  /**
   * ''=new | published | rejected
   *
   * @generated from field: string status = 10;
   */
  status: string;

  /**
   * @generated from field: string created_at = 11;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.Review.
 * Use `create(ReviewSchema)` to create a new message.
 */
export const ReviewSchema: GenMessage<Review> = /*@__PURE__*/
  messageDesc(file_zdc, 1001);

/**
 * @generated from message zdc.ListReviewsRequest
 */
export type ListReviewsRequest = Message<"zdc.ListReviewsRequest"> & {
  /**
   * @generated from field: string object_type = 1;
   */
  objectType: string;

  /**
   * @generated from field: string object_code = 2;
   */
  objectCode: string;

  /**
   * @generated from field: string object_id = 3;
   */
  objectId: string;

  /**
   * 0-based
   *
   * @generated from field: int32 page = 4;
   */
  page: number;

  /**
   * ≤50
   *
   * @generated from field: int32 page_size = 5;
   */
  pageSize: number;

  /**
   * модератору — все статусы
   *
   * @generated from field: bool include_all = 6;
   */
  includeAll: boolean;
};

/**
 * Describes the message zdc.ListReviewsRequest.
 * Use `create(ListReviewsRequestSchema)` to create a new message.
 */
export const ListReviewsRequestSchema: GenMessage<ListReviewsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1002);

/**
 * @generated from message zdc.ReviewList
 */
export type ReviewList = Message<"zdc.ReviewList"> & {
  /**
   * @generated from field: repeated zdc.Review items = 1;
   */
  items: Review[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * средняя по published (для объекта)
   *
   * @generated from field: double rating_avg = 3;
   */
  ratingAvg: number;

  /**
   * количество published
   *
   * @generated from field: int32 count = 4;
   */
  count: number;
};

/**
 * Describes the message zdc.ReviewList.
 * Use `create(ReviewListSchema)` to create a new message.
 */
export const ReviewListSchema: GenMessage<ReviewList> = /*@__PURE__*/
  messageDesc(file_zdc, 1003);

/**
 * @generated from message zdc.CreateReviewRequest
 */
export type CreateReviewRequest = Message<"zdc.CreateReviewRequest"> & {
  /**
   * @generated from field: string object_type = 1;
   */
  objectType: string;

  /**
   * @generated from field: string object_code = 2;
   */
  objectCode: string;

  /**
   * @generated from field: string object_id = 3;
   */
  objectId: string;

  /**
   * 1..5 (обязательно)
   *
   * @generated from field: int32 rating = 4;
   */
  rating: number;

  /**
   * @generated from field: string text = 5;
   */
  text: string;

  /**
   * обязателен для гостя
   *
   * @generated from field: string guest_name = 6;
   */
  guestName: string;
};

/**
 * Describes the message zdc.CreateReviewRequest.
 * Use `create(CreateReviewRequestSchema)` to create a new message.
 */
export const CreateReviewRequestSchema: GenMessage<CreateReviewRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1004);

/**
 * @generated from message zdc.SetReviewStatusRequest
 */
export type SetReviewStatusRequest = Message<"zdc.SetReviewStatusRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * Describes the message zdc.SetReviewStatusRequest.
 * Use `create(SetReviewStatusRequestSchema)` to create a new message.
 */
export const SetReviewStatusRequestSchema: GenMessage<SetReviewStatusRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1005);

/**
 * @generated from message zdc.GetReviewSummaryRequest
 */
export type GetReviewSummaryRequest = Message<"zdc.GetReviewSummaryRequest"> & {
  /**
   * @generated from field: string object_type = 1;
   */
  objectType: string;

  /**
   * @generated from field: string object_code = 2;
   */
  objectCode: string;

  /**
   * @generated from field: repeated string object_ids = 3;
   */
  objectIds: string[];
};

/**
 * Describes the message zdc.GetReviewSummaryRequest.
 * Use `create(GetReviewSummaryRequestSchema)` to create a new message.
 */
export const GetReviewSummaryRequestSchema: GenMessage<GetReviewSummaryRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1006);

/**
 * @generated from message zdc.ReviewSummaryItem
 */
export type ReviewSummaryItem = Message<"zdc.ReviewSummaryItem"> & {
  /**
   * @generated from field: string object_id = 1;
   */
  objectId: string;

  /**
   * @generated from field: double rating_avg = 2;
   */
  ratingAvg: number;

  /**
   * @generated from field: int32 count = 3;
   */
  count: number;
};

/**
 * Describes the message zdc.ReviewSummaryItem.
 * Use `create(ReviewSummaryItemSchema)` to create a new message.
 */
export const ReviewSummaryItemSchema: GenMessage<ReviewSummaryItem> = /*@__PURE__*/
  messageDesc(file_zdc, 1007);

/**
 * @generated from message zdc.ReviewSummary
 */
export type ReviewSummary = Message<"zdc.ReviewSummary"> & {
  /**
   * @generated from field: repeated zdc.ReviewSummaryItem items = 1;
   */
  items: ReviewSummaryItem[];
};

/**
 * Describes the message zdc.ReviewSummary.
 * Use `create(ReviewSummarySchema)` to create a new message.
 */
export const ReviewSummarySchema: GenMessage<ReviewSummary> = /*@__PURE__*/
  messageDesc(file_zdc, 1008);

/**
 * @generated from message zdc.Poll
 */
export type Poll = Message<"zdc.Poll"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * none | keys | scales
   *
   * @generated from field: string scoring = 5;
   */
  scoring: string;

  /**
   * @generated from field: int32 threshold_pct = 6;
   */
  thresholdPct: number;

  /**
   * @generated from field: int32 time_limit_min = 7;
   */
  timeLimitMin: number;

  /**
   * @generated from field: int32 attempts = 8;
   */
  attempts: number;

  /**
   * @generated from field: bool shuffle = 9;
   */
  shuffle: boolean;

  /**
   * @generated from field: bool anonymous = 10;
   */
  anonymous: boolean;

  /**
   * @generated from field: bool map_to_subject = 11;
   */
  mapToSubject: boolean;

  /**
   * none | score | conclusion
   *
   * @generated from field: string show_result = 12;
   */
  showResult: string;

  /**
   * @generated from field: repeated string assign_roles = 13;
   */
  assignRoles: string[];

  /**
   * Персональные назначения: опрос виден указанным пользователям независимо
   * от ролей (списки пусты и у ролей, и у пользователей — доступно всем).
   *
   * @generated from field: repeated string assign_users = 15;
   */
  assignUsers: string[];

  /**
   * draft | open | closed
   *
   * @generated from field: string status = 14;
   */
  status: string;
};

/**
 * Describes the message zdc.Poll.
 * Use `create(PollSchema)` to create a new message.
 */
export const PollSchema: GenMessage<Poll> = /*@__PURE__*/
  messageDesc(file_zdc, 1009);

/**
 * @generated from message zdc.PollQuestion
 */
export type PollQuestion = Message<"zdc.PollQuestion"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string poll_id = 2;
   */
  pollId: string;

  /**
   * @generated from field: int32 ord = 3;
   */
  ord: number;

  /**
   * @generated from field: string text = 4;
   */
  text: string;

  /**
   * single|multi|scale1_5|number|text|date|file
   *
   * @generated from field: string type = 5;
   */
  type: string;

  /**
   * @generated from field: bool required = 6;
   */
  required: boolean;

  /**
   * @generated from field: repeated string options = 7;
   */
  options: string[];

  /**
   * @generated from field: string correct_json = 8;
   */
  correctJson: string;

  /**
   * @generated from field: double points = 9;
   */
  points: number;

  /**
   * @generated from field: string scale_code = 10;
   */
  scaleCode: string;

  /**
   * @generated from field: string image_file_id = 11;
   */
  imageFileId: string;

  /**
   * @generated from field: bool control = 12;
   */
  control: boolean;
};

/**
 * Describes the message zdc.PollQuestion.
 * Use `create(PollQuestionSchema)` to create a new message.
 */
export const PollQuestionSchema: GenMessage<PollQuestion> = /*@__PURE__*/
  messageDesc(file_zdc, 1010);

/**
 * @generated from message zdc.PollScale
 */
export type PollScale = Message<"zdc.PollScale"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string poll_id = 2;
   */
  pollId: string;

  /**
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * [{from,to,text,color?}]
   *
   * @generated from field: string ranges_json = 5;
   */
  rangesJson: string;
};

/**
 * Describes the message zdc.PollScale.
 * Use `create(PollScaleSchema)` to create a new message.
 */
export const PollScaleSchema: GenMessage<PollScale> = /*@__PURE__*/
  messageDesc(file_zdc, 1011);

/**
 * @generated from message zdc.PollFull
 */
export type PollFull = Message<"zdc.PollFull"> & {
  /**
   * @generated from field: zdc.Poll poll = 1;
   */
  poll?: Poll | undefined;

  /**
   * @generated from field: repeated zdc.PollQuestion questions = 2;
   */
  questions: PollQuestion[];

  /**
   * @generated from field: repeated zdc.PollScale scales = 3;
   */
  scales: PollScale[];
};

/**
 * Describes the message zdc.PollFull.
 * Use `create(PollFullSchema)` to create a new message.
 */
export const PollFullSchema: GenMessage<PollFull> = /*@__PURE__*/
  messageDesc(file_zdc, 1012);

/**
 * @generated from message zdc.SavePollRequest
 */
export type SavePollRequest = Message<"zdc.SavePollRequest"> & {
  /**
   * @generated from field: zdc.Poll poll = 1;
   */
  poll?: Poll | undefined;

  /**
   * @generated from field: repeated zdc.PollQuestion questions = 2;
   */
  questions: PollQuestion[];

  /**
   * @generated from field: repeated zdc.PollScale scales = 3;
   */
  scales: PollScale[];
};

/**
 * Describes the message zdc.SavePollRequest.
 * Use `create(SavePollRequestSchema)` to create a new message.
 */
export const SavePollRequestSchema: GenMessage<SavePollRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1013);

/**
 * @generated from message zdc.PollGet
 */
export type PollGet = Message<"zdc.PollGet"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.PollGet.
 * Use `create(PollGetSchema)` to create a new message.
 */
export const PollGetSchema: GenMessage<PollGet> = /*@__PURE__*/
  messageDesc(file_zdc, 1014);

/**
 * @generated from message zdc.PollList
 */
export type PollList = Message<"zdc.PollList"> & {
  /**
   * @generated from field: repeated zdc.Poll items = 1;
   */
  items: Poll[];
};

/**
 * Describes the message zdc.PollList.
 * Use `create(PollListSchema)` to create a new message.
 */
export const PollListSchema: GenMessage<PollList> = /*@__PURE__*/
  messageDesc(file_zdc, 1015);

/**
 * @generated from message zdc.PollQuestionAnswer
 */
export type PollQuestionAnswer = Message<"zdc.PollQuestionAnswer"> & {
  /**
   * @generated from field: string question_id = 1;
   */
  questionId: string;

  /**
   * @generated from field: string value_json = 2;
   */
  valueJson: string;
};

/**
 * Describes the message zdc.PollQuestionAnswer.
 * Use `create(PollQuestionAnswerSchema)` to create a new message.
 */
export const PollQuestionAnswerSchema: GenMessage<PollQuestionAnswer> = /*@__PURE__*/
  messageDesc(file_zdc, 1016);

/**
 * @generated from message zdc.SubmitPollAnswersRequest
 */
export type SubmitPollAnswersRequest = Message<"zdc.SubmitPollAnswersRequest"> & {
  /**
   * @generated from field: string poll_id = 1;
   */
  pollId: string;

  /**
   * @generated from field: string subject_id = 2;
   */
  subjectId: string;

  /**
   * @generated from field: int32 attempt = 3;
   */
  attempt: number;

  /**
   * @generated from field: repeated zdc.PollQuestionAnswer answers = 4;
   */
  answers: PollQuestionAnswer[];
};

/**
 * Describes the message zdc.SubmitPollAnswersRequest.
 * Use `create(SubmitPollAnswersRequestSchema)` to create a new message.
 */
export const SubmitPollAnswersRequestSchema: GenMessage<SubmitPollAnswersRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1017);

/**
 * РУЧНОЙ протокол внешней (авторской) методики: у шаблона нет вопросов и
 * авто-скоринга — специалист вносит результат сам (балл и/или заключение).
 * «Пройдено» вычисляется только при заданном пороге типа; пустой балл —
 * «Пройдено» не выставляется.
 *
 * @generated from message zdc.SubmitPollResultRequest
 */
export type SubmitPollResultRequest = Message<"zdc.SubmitPollResultRequest"> & {
  /**
   * id шаблона методики (как SubmitPollAnswers)
   *
   * @generated from field: string poll_id = 1;
   */
  pollId: string;

  /**
   * объект тестирования (клиент)
   *
   * @generated from field: string subject_id = 2;
   */
  subjectId: string;

  /**
   * балл (пусто — не выставлять)
   *
   * @generated from field: optional double score = 3;
   */
  score?: number | undefined;

  /**
   * заключение специалиста
   *
   * @generated from field: string conclusion = 4;
   */
  conclusion: string;

  /**
   * дата прохождения ГГГГ-ММ-ДД (пусто = сегодня)
   *
   * @generated from field: string date = 5;
   */
  date: string;
};

/**
 * Describes the message zdc.SubmitPollResultRequest.
 * Use `create(SubmitPollResultRequestSchema)` to create a new message.
 */
export const SubmitPollResultRequestSchema: GenMessage<SubmitPollResultRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1018);

/**
 * @generated from message zdc.PollResultInfo
 */
export type PollResultInfo = Message<"zdc.PollResultInfo"> & {
  /**
   * @generated from field: string poll_id = 1;
   */
  pollId: string;

  /**
   * @generated from field: string respondent = 2;
   */
  respondent: string;

  /**
   * @generated from field: string respondent_name = 3;
   */
  respondentName: string;

  /**
   * @generated from field: string subject_id = 4;
   */
  subjectId: string;

  /**
   * @generated from field: string scores_json = 5;
   */
  scoresJson: string;

  /**
   * @generated from field: double percent = 6;
   */
  percent: number;

  /**
   * @generated from field: bool passed = 7;
   */
  passed: boolean;

  /**
   * @generated from field: string conclusions_json = 8;
   */
  conclusionsJson: string;

  /**
   * @generated from field: int32 attempt = 9;
   */
  attempt: number;

  /**
   * @generated from field: string completed_at = 10;
   */
  completedAt: string;
};

/**
 * Describes the message zdc.PollResultInfo.
 * Use `create(PollResultInfoSchema)` to create a new message.
 */
export const PollResultInfoSchema: GenMessage<PollResultInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 1019);

/**
 * @generated from message zdc.PollResultList
 */
export type PollResultList = Message<"zdc.PollResultList"> & {
  /**
   * @generated from field: repeated zdc.PollResultInfo items = 1;
   */
  items: PollResultInfo[];
};

/**
 * Describes the message zdc.PollResultList.
 * Use `create(PollResultListSchema)` to create a new message.
 */
export const PollResultListSchema: GenMessage<PollResultList> = /*@__PURE__*/
  messageDesc(file_zdc, 1020);

/**
 * @generated from message zdc.SetPollStatusRequest
 */
export type SetPollStatusRequest = Message<"zdc.SetPollStatusRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * Describes the message zdc.SetPollStatusRequest.
 * Use `create(SetPollStatusRequestSchema)` to create a new message.
 */
export const SetPollStatusRequestSchema: GenMessage<SetPollStatusRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1021);

/**
 * @generated from message zdc.PollTypeInfo
 */
export type PollTypeInfo = Message<"zdc.PollTypeInfo"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: string scoring = 5;
   */
  scoring: string;

  /**
   * @generated from field: string template_id = 6;
   */
  templateId: string;
};

/**
 * Describes the message zdc.PollTypeInfo.
 * Use `create(PollTypeInfoSchema)` to create a new message.
 */
export const PollTypeInfoSchema: GenMessage<PollTypeInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 1022);

/**
 * @generated from message zdc.PollTypeList
 */
export type PollTypeList = Message<"zdc.PollTypeList"> & {
  /**
   * @generated from field: repeated zdc.PollTypeInfo items = 1;
   */
  items: PollTypeInfo[];
};

/**
 * Describes the message zdc.PollTypeList.
 * Use `create(PollTypeListSchema)` to create a new message.
 */
export const PollTypeListSchema: GenMessage<PollTypeList> = /*@__PURE__*/
  messageDesc(file_zdc, 1023);

/**
 * Онлайн-прохождение по ссылке/QR (гость без входа): специалист создаёт ссылку
 * на конкретную методику для конкретного клиента; гость проходит, результат
 * приходит в базу с привязкой к клиенту и владельцем-специалистом.
 *
 * @generated from message zdc.PollGuestLinkCreate
 */
export type PollGuestLinkCreate = Message<"zdc.PollGuestLinkCreate"> & {
  /**
   * код ТИПА опроса (методики)
   *
   * @generated from field: string poll_code = 1;
   */
  pollCode: string;

  /**
   * объект тестирования (клиент)
   *
   * @generated from field: string subject_id = 2;
   */
  subjectId: string;

  /**
   * срок действия ссылки (5..1440; 0 = 60)
   *
   * @generated from field: int32 ttl_minutes = 3;
   */
  ttlMinutes: number;

  /**
   * внешний origin клиента (для URL/QR)
   *
   * @generated from field: string origin = 4;
   */
  origin: string;
};

/**
 * Describes the message zdc.PollGuestLinkCreate.
 * Use `create(PollGuestLinkCreateSchema)` to create a new message.
 */
export const PollGuestLinkCreateSchema: GenMessage<PollGuestLinkCreate> = /*@__PURE__*/
  messageDesc(file_zdc, 1024);

/**
 * @generated from message zdc.PollGuestLink
 */
export type PollGuestLink = Message<"zdc.PollGuestLink"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string poll_code = 2;
   */
  pollCode: string;

  /**
   * @generated from field: string subject_id = 3;
   */
  subjectId: string;

  /**
   * @generated from field: string expires_at = 4;
   */
  expiresAt: string;

  /**
   * @generated from field: string url = 5;
   */
  url: string;

  /**
   * PNG base64 (сервер, go-qrcode)
   *
   * @generated from field: string qr_png_base64 = 6;
   */
  qrPngBase64: string;
};

/**
 * Describes the message zdc.PollGuestLink.
 * Use `create(PollGuestLinkSchema)` to create a new message.
 */
export const PollGuestLinkSchema: GenMessage<PollGuestLink> = /*@__PURE__*/
  messageDesc(file_zdc, 1025);

/**
 * @generated from message zdc.PollGuestLinkResolve
 */
export type PollGuestLinkResolve = Message<"zdc.PollGuestLinkResolve"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message zdc.PollGuestLinkResolve.
 * Use `create(PollGuestLinkResolveSchema)` to create a new message.
 */
export const PollGuestLinkResolveSchema: GenMessage<PollGuestLinkResolve> = /*@__PURE__*/
  messageDesc(file_zdc, 1026);

/**
 * @generated from message zdc.PollGuestForm
 */
export type PollGuestForm = Message<"zdc.PollGuestForm"> & {
  /**
   * @generated from field: string poll_code = 1;
   */
  pollCode: string;

  /**
   * @generated from field: string synonym = 2;
   */
  synonym: string;

  /**
   * @generated from field: string subject_id = 3;
   */
  subjectId: string;

  /**
   * @generated from field: string subject_name = 4;
   */
  subjectName: string;

  /**
   * @generated from field: zdc.PollFull form = 5;
   */
  form?: PollFull | undefined;

  /**
   * @generated from field: string show_result = 6;
   */
  showResult: string;

  /**
   * @generated from field: int32 time_limit_min = 7;
   */
  timeLimitMin: number;
};

/**
 * Describes the message zdc.PollGuestForm.
 * Use `create(PollGuestFormSchema)` to create a new message.
 */
export const PollGuestFormSchema: GenMessage<PollGuestForm> = /*@__PURE__*/
  messageDesc(file_zdc, 1027);

/**
 * @generated from message zdc.SubmitPollLinkAnswersRequest
 */
export type SubmitPollLinkAnswersRequest = Message<"zdc.SubmitPollLinkAnswersRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: repeated zdc.PollQuestionAnswer answers = 2;
   */
  answers: PollQuestionAnswer[];
};

/**
 * Describes the message zdc.SubmitPollLinkAnswersRequest.
 * Use `create(SubmitPollLinkAnswersRequestSchema)` to create a new message.
 */
export const SubmitPollLinkAnswersRequestSchema: GenMessage<SubmitPollLinkAnswersRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1028);

/**
 * ============ Классификаторы (§21: ФИАС/ГАР/Единицы и любые справочники) ============
 *
 * @generated from message zdc.Classifier
 */
export type Classifier = Message<"zdc.Classifier"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string target_catalog = 5;
   */
  targetCatalog: string;

  /**
   * '' | file_csv | external_api
   *
   * @generated from field: string source_type = 6;
   */
  sourceType: string;

  /**
   * JSON {delimiter,key_column,parent_column}
   *
   * @generated from field: string source_settings = 7;
   */
  sourceSettings: string;

  /**
   * draft | ready
   *
   * @generated from field: string status = 8;
   */
  status: string;

  /**
   * @generated from field: string last_import_at = 9;
   */
  lastImportAt: string;

  /**
   * @generated from field: int32 last_count = 10;
   */
  lastCount: number;

  /**
   * @generated from field: bool is_system = 11;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 12;
   */
  templateId: string;
};

/**
 * Describes the message zdc.Classifier.
 * Use `create(ClassifierSchema)` to create a new message.
 */
export const ClassifierSchema: GenMessage<Classifier> = /*@__PURE__*/
  messageDesc(file_zdc, 1029);

/**
 * @generated from message zdc.ClassifierList
 */
export type ClassifierList = Message<"zdc.ClassifierList"> & {
  /**
   * @generated from field: repeated zdc.Classifier items = 1;
   */
  items: Classifier[];
};

/**
 * Describes the message zdc.ClassifierList.
 * Use `create(ClassifierListSchema)` to create a new message.
 */
export const ClassifierListSchema: GenMessage<ClassifierList> = /*@__PURE__*/
  messageDesc(file_zdc, 1030);

/**
 * @generated from message zdc.ListClassifiersRequest
 */
export type ListClassifiersRequest = Message<"zdc.ListClassifiersRequest"> & {
};

/**
 * Describes the message zdc.ListClassifiersRequest.
 * Use `create(ListClassifiersRequestSchema)` to create a new message.
 */
export const ListClassifiersRequestSchema: GenMessage<ListClassifiersRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1031);

/**
 * @generated from message zdc.GetClassifierRequest
 */
export type GetClassifierRequest = Message<"zdc.GetClassifierRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.GetClassifierRequest.
 * Use `create(GetClassifierRequestSchema)` to create a new message.
 */
export const GetClassifierRequestSchema: GenMessage<GetClassifierRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1032);

/**
 * @generated from message zdc.SaveClassifierRequest
 */
export type SaveClassifierRequest = Message<"zdc.SaveClassifierRequest"> & {
  /**
   * @generated from field: zdc.Classifier classifier = 1;
   */
  classifier?: Classifier | undefined;
};

/**
 * Describes the message zdc.SaveClassifierRequest.
 * Use `create(SaveClassifierRequestSchema)` to create a new message.
 */
export const SaveClassifierRequestSchema: GenMessage<SaveClassifierRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1033);

/**
 * @generated from message zdc.DeleteClassifierRequest
 */
export type DeleteClassifierRequest = Message<"zdc.DeleteClassifierRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.DeleteClassifierRequest.
 * Use `create(DeleteClassifierRequestSchema)` to create a new message.
 */
export const DeleteClassifierRequestSchema: GenMessage<DeleteClassifierRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1034);

/**
 * @generated from message zdc.ImportClassifierRequest
 */
export type ImportClassifierRequest = Message<"zdc.ImportClassifierRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string file_b64 = 2;
   */
  fileB64: string;
};

/**
 * Describes the message zdc.ImportClassifierRequest.
 * Use `create(ImportClassifierRequestSchema)` to create a new message.
 */
export const ImportClassifierRequestSchema: GenMessage<ImportClassifierRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1035);

/**
 * @generated from message zdc.ImportClassifierResponse
 */
export type ImportClassifierResponse = Message<"zdc.ImportClassifierResponse"> & {
  /**
   * @generated from field: int32 count = 1;
   */
  count: number;
};

/**
 * Describes the message zdc.ImportClassifierResponse.
 * Use `create(ImportClassifierResponseSchema)` to create a new message.
 */
export const ImportClassifierResponseSchema: GenMessage<ImportClassifierResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1036);

/**
 * ============ Единый загрузчик (SSoT): прогресс/отмена/возобновление ============
 *
 * @generated from message zdc.DownloadJob
 */
export type DownloadJob = Message<"zdc.DownloadJob"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string dest_path = 3;
   */
  destPath: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: int64 done = 5;
   */
  done: bigint;

  /**
   * @generated from field: int64 total = 6;
   */
  total: bigint;

  /**
   * @generated from field: string error = 7;
   */
  error: string;
};

/**
 * Describes the message zdc.DownloadJob.
 * Use `create(DownloadJobSchema)` to create a new message.
 */
export const DownloadJobSchema: GenMessage<DownloadJob> = /*@__PURE__*/
  messageDesc(file_zdc, 1037);

/**
 * @generated from message zdc.StartDownloadRequest
 */
export type StartDownloadRequest = Message<"zdc.StartDownloadRequest"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: string dest_path = 2;
   */
  destPath: string;
};

/**
 * Describes the message zdc.StartDownloadRequest.
 * Use `create(StartDownloadRequestSchema)` to create a new message.
 */
export const StartDownloadRequestSchema: GenMessage<StartDownloadRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1038);

/**
 * @generated from message zdc.StartDownloadResponse
 */
export type StartDownloadResponse = Message<"zdc.StartDownloadResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.StartDownloadResponse.
 * Use `create(StartDownloadResponseSchema)` to create a new message.
 */
export const StartDownloadResponseSchema: GenMessage<StartDownloadResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1039);

/**
 * @generated from message zdc.CancelDownloadRequest
 */
export type CancelDownloadRequest = Message<"zdc.CancelDownloadRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.CancelDownloadRequest.
 * Use `create(CancelDownloadRequestSchema)` to create a new message.
 */
export const CancelDownloadRequestSchema: GenMessage<CancelDownloadRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1040);

/**
 * @generated from message zdc.ListDownloadsRequest
 */
export type ListDownloadsRequest = Message<"zdc.ListDownloadsRequest"> & {
};

/**
 * Describes the message zdc.ListDownloadsRequest.
 * Use `create(ListDownloadsRequestSchema)` to create a new message.
 */
export const ListDownloadsRequestSchema: GenMessage<ListDownloadsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1041);

/**
 * @generated from message zdc.DownloadJobList
 */
export type DownloadJobList = Message<"zdc.DownloadJobList"> & {
  /**
   * @generated from field: repeated zdc.DownloadJob items = 1;
   */
  items: DownloadJob[];
};

/**
 * Describes the message zdc.DownloadJobList.
 * Use `create(DownloadJobListSchema)` to create a new message.
 */
export const DownloadJobListSchema: GenMessage<DownloadJobList> = /*@__PURE__*/
  messageDesc(file_zdc, 1042);

/**
 * ============ ГАР (ФИАС): выгрузки и импорт регионов ============
 *
 * @generated from message zdc.GarDumpInfo
 */
export type GarDumpInfo = Message<"zdc.GarDumpInfo"> & {
  /**
   * @generated from field: string date = 1;
   */
  date: string;

  /**
   * @generated from field: string full_url = 2;
   */
  fullUrl: string;

  /**
   * @generated from field: int64 size = 3;
   */
  size: bigint;
};

/**
 * Describes the message zdc.GarDumpInfo.
 * Use `create(GarDumpInfoSchema)` to create a new message.
 */
export const GarDumpInfoSchema: GenMessage<GarDumpInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 1043);

/**
 * @generated from message zdc.GarStatusResponse
 */
export type GarStatusResponse = Message<"zdc.GarStatusResponse"> & {
  /**
   * @generated from field: zdc.GarDumpInfo info = 1;
   */
  info?: GarDumpInfo | undefined;

  /**
   * пусто = архив ещё не скачан
   *
   * @generated from field: string local_path = 2;
   */
  localPath: string;

  /**
   * @generated from field: bool downloading = 3;
   */
  downloading: boolean;

  /**
   * пусто = ничего не импортируется
   *
   * @generated from field: string importing_region = 4;
   */
  importingRegion: string;
};

/**
 * Describes the message zdc.GarStatusResponse.
 * Use `create(GarStatusResponseSchema)` to create a new message.
 */
export const GarStatusResponseSchema: GenMessage<GarStatusResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1044);

/**
 * @generated from message zdc.EmptyGar
 */
export type EmptyGar = Message<"zdc.EmptyGar"> & {
};

/**
 * Describes the message zdc.EmptyGar.
 * Use `create(EmptyGarSchema)` to create a new message.
 */
export const EmptyGarSchema: GenMessage<EmptyGar> = /*@__PURE__*/
  messageDesc(file_zdc, 1045);

/**
 * @generated from message zdc.GarImportRegionRequest
 */
export type GarImportRegionRequest = Message<"zdc.GarImportRegionRequest"> & {
  /**
   * @generated from field: string region_code = 1;
   */
  regionCode: string;
};

/**
 * Describes the message zdc.GarImportRegionRequest.
 * Use `create(GarImportRegionRequestSchema)` to create a new message.
 */
export const GarImportRegionRequestSchema: GenMessage<GarImportRegionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1046);

/**
 * @generated from message zdc.GarImportRegionResponse
 */
export type GarImportRegionResponse = Message<"zdc.GarImportRegionResponse"> & {
  /**
   * @generated from field: int32 count = 1;
   */
  count: number;
};

/**
 * Describes the message zdc.GarImportRegionResponse.
 * Use `create(GarImportRegionResponseSchema)` to create a new message.
 */
export const GarImportRegionResponseSchema: GenMessage<GarImportRegionResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1047);

/**
 * ============ Метрики (вычисляемые поля объектов) ============
 *
 * @generated from message zdc.ObjMetric
 */
export type ObjMetric = Message<"zdc.ObjMetric"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string entity_type = 4;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 5;
   */
  entityCode: string;

  /**
   * @generated from field: string source_table = 6;
   */
  sourceTable: string;

  /**
   * count|sum|last_value
   *
   * @generated from field: string metric_type = 7;
   */
  metricType: string;

  /**
   * @generated from field: string filter_field = 8;
   */
  filterField: string;

  /**
   * @generated from field: string filter_condition = 9;
   */
  filterCondition: string;

  /**
   * @objectId
   *
   * @generated from field: string filter_value = 10;
   */
  filterValue: string;

  /**
   * @generated from field: string value_field = 11;
   */
  valueField: string;

  /**
   * @generated from field: string order_field = 12;
   */
  orderField: string;

  /**
   * @generated from field: bool is_system = 13;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 14;
   */
  templateId: string;
};

/**
 * Describes the message zdc.ObjMetric.
 * Use `create(ObjMetricSchema)` to create a new message.
 */
export const ObjMetricSchema: GenMessage<ObjMetric> = /*@__PURE__*/
  messageDesc(file_zdc, 1048);

/**
 * @generated from message zdc.ObjMetricList
 */
export type ObjMetricList = Message<"zdc.ObjMetricList"> & {
  /**
   * @generated from field: repeated zdc.ObjMetric items = 1;
   */
  items: ObjMetric[];
};

/**
 * Describes the message zdc.ObjMetricList.
 * Use `create(ObjMetricListSchema)` to create a new message.
 */
export const ObjMetricListSchema: GenMessage<ObjMetricList> = /*@__PURE__*/
  messageDesc(file_zdc, 1049);

/**
 * @generated from message zdc.ListObjMetricsRequest
 */
export type ListObjMetricsRequest = Message<"zdc.ListObjMetricsRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;
};

/**
 * Describes the message zdc.ListObjMetricsRequest.
 * Use `create(ListObjMetricsRequestSchema)` to create a new message.
 */
export const ListObjMetricsRequestSchema: GenMessage<ListObjMetricsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1050);

/**
 * @generated from message zdc.GetObjMetricRequest
 */
export type GetObjMetricRequest = Message<"zdc.GetObjMetricRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;
};

/**
 * Describes the message zdc.GetObjMetricRequest.
 * Use `create(GetObjMetricRequestSchema)` to create a new message.
 */
export const GetObjMetricRequestSchema: GenMessage<GetObjMetricRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1051);

/**
 * @generated from message zdc.SaveObjMetricRequest
 */
export type SaveObjMetricRequest = Message<"zdc.SaveObjMetricRequest"> & {
  /**
   * @generated from field: zdc.ObjMetric metric = 1;
   */
  metric?: ObjMetric | undefined;
};

/**
 * Describes the message zdc.SaveObjMetricRequest.
 * Use `create(SaveObjMetricRequestSchema)` to create a new message.
 */
export const SaveObjMetricRequestSchema: GenMessage<SaveObjMetricRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1052);

/**
 * @generated from message zdc.DeleteObjMetricRequest
 */
export type DeleteObjMetricRequest = Message<"zdc.DeleteObjMetricRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;
};

/**
 * Describes the message zdc.DeleteObjMetricRequest.
 * Use `create(DeleteObjMetricRequestSchema)` to create a new message.
 */
export const DeleteObjMetricRequestSchema: GenMessage<DeleteObjMetricRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1053);

/**
 * ============================================================
 * Folder Service — УНИВЕРСАЛЬНЫЕ ПАПКИ (механизм ядра).
 * Папка = именованный набор отборов над списком любого объекта.
 * kind: system (ядро/поставка) | shared (общая) | user (личная).
 * Спец-значения фильтров: @current_user, @objectId.
 * ============================================================
 *
 * @generated from message zdc.HydraFolder
 */
export type HydraFolder = Message<"zdc.HydraFolder"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string synonym = 4;
   */
  synonym: string;

  /**
   * @generated from field: string entity_type = 5;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 6;
   */
  entityCode: string;

  /**
   * Отборы JSON [{field,condition,value}] (@current_user/@objectId)
   *
   * @generated from field: string filters = 7;
   */
  filters: string;

  /**
   * system | shared | user
   *
   * @generated from field: string kind = 8;
   */
  kind: string;

  /**
   * владелец личной папки
   *
   * @generated from field: string owner_id = 9;
   */
  ownerId: string;

  /**
   * @generated from field: int32 sort_order = 10;
   */
  sortOrder: number;

  /**
   * @generated from field: bool is_system = 11;
   */
  isSystem: boolean;
};

/**
 * Describes the message zdc.HydraFolder.
 * Use `create(HydraFolderSchema)` to create a new message.
 */
export const HydraFolderSchema: GenMessage<HydraFolder> = /*@__PURE__*/
  messageDesc(file_zdc, 1054);

/**
 * @generated from message zdc.FolderList
 */
export type FolderList = Message<"zdc.FolderList"> & {
  /**
   * @generated from field: repeated zdc.HydraFolder items = 1;
   */
  items: HydraFolder[];
};

/**
 * Describes the message zdc.FolderList.
 * Use `create(FolderListSchema)` to create a new message.
 */
export const FolderListSchema: GenMessage<FolderList> = /*@__PURE__*/
  messageDesc(file_zdc, 1055);

/**
 * @generated from message zdc.ListFoldersRequest
 */
export type ListFoldersRequest = Message<"zdc.ListFoldersRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;
};

/**
 * Describes the message zdc.ListFoldersRequest.
 * Use `create(ListFoldersRequestSchema)` to create a new message.
 */
export const ListFoldersRequestSchema: GenMessage<ListFoldersRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1056);

/**
 * @generated from message zdc.GetFolderRequest
 */
export type GetFolderRequest = Message<"zdc.GetFolderRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;

  /**
   * @generated from field: string code = 3;
   */
  code: string;
};

/**
 * Describes the message zdc.GetFolderRequest.
 * Use `create(GetFolderRequestSchema)` to create a new message.
 */
export const GetFolderRequestSchema: GenMessage<GetFolderRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1057);

/**
 * @generated from message zdc.SaveFolderRequest
 */
export type SaveFolderRequest = Message<"zdc.SaveFolderRequest"> & {
  /**
   * @generated from field: zdc.HydraFolder folder = 1;
   */
  folder?: HydraFolder | undefined;
};

/**
 * Describes the message zdc.SaveFolderRequest.
 * Use `create(SaveFolderRequestSchema)` to create a new message.
 */
export const SaveFolderRequestSchema: GenMessage<SaveFolderRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1058);

/**
 * @generated from message zdc.DeleteFolderRequest
 */
export type DeleteFolderRequest = Message<"zdc.DeleteFolderRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;

  /**
   * @generated from field: string code = 3;
   */
  code: string;
};

/**
 * Describes the message zdc.DeleteFolderRequest.
 * Use `create(DeleteFolderRequestSchema)` to create a new message.
 */
export const DeleteFolderRequestSchema: GenMessage<DeleteFolderRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1059);

/**
 * Счётчики папок (total по отборам + непрочитанные objects_reads) —
 * обобщённый механизм для плиток/сайдбара любых объектов (не только задач)
 *
 * @generated from message zdc.FolderCountsRequest
 */
export type FolderCountsRequest = Message<"zdc.FolderCountsRequest"> & {
  /**
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_code = 2;
   */
  entityCode: string;
};

/**
 * Describes the message zdc.FolderCountsRequest.
 * Use `create(FolderCountsRequestSchema)` to create a new message.
 */
export const FolderCountsRequestSchema: GenMessage<FolderCountsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1060);

/**
 * @generated from message zdc.FolderCountItem
 */
export type FolderCountItem = Message<"zdc.FolderCountItem"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * @generated from field: int32 unread = 3;
   */
  unread: number;
};

/**
 * Describes the message zdc.FolderCountItem.
 * Use `create(FolderCountItemSchema)` to create a new message.
 */
export const FolderCountItemSchema: GenMessage<FolderCountItem> = /*@__PURE__*/
  messageDesc(file_zdc, 1061);

/**
 * @generated from message zdc.FolderCountsResponse
 */
export type FolderCountsResponse = Message<"zdc.FolderCountsResponse"> & {
  /**
   * @generated from field: repeated zdc.FolderCountItem items = 1;
   */
  items: FolderCountItem[];
};

/**
 * Describes the message zdc.FolderCountsResponse.
 * Use `create(FolderCountsResponseSchema)` to create a new message.
 */
export const FolderCountsResponseSchema: GenMessage<FolderCountsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1062);

/**
 * ============================================================
 * Instance Service — КОНСОЛЬ ИНСТАНСА для УПРАВДОМА (global:admin,
 * public.entities). Данные ИНСТАНС-уровня: базы/пользователи/сессии
 * инстанса + миграции public-схемы. НЕ зависит от активной базы
 * (X-Hydra-Base игнорируется — всегда public).
 * ============================================================
 *
 * @generated from message zdc.InstanceInfo
 */
export type InstanceInfo = Message<"zdc.InstanceInfo"> & {
  /**
   * версия платформы
   *
   * @generated from field: string version = 1;
   */
  version: string;

  /**
   * postgres | sqlite (инстанс)
   *
   * @generated from field: string db_kind = 2;
   */
  dbKind: string;

  /**
   * @generated from field: int32 bases_total = 3;
   */
  basesTotal: number;

  /**
   * @generated from field: int32 bases_published = 4;
   */
  basesPublished: number;

  /**
   * пользователи инстанса (public.entities)
   *
   * @generated from field: int32 users = 5;
   */
  users: number;

  /**
   * активные сессии инстанса (не отозваны, не истекли)
   *
   * @generated from field: int32 sessions_active = 6;
   */
  sessionsActive: number;
};

/**
 * Describes the message zdc.InstanceInfo.
 * Use `create(InstanceInfoSchema)` to create a new message.
 */
export const InstanceInfoSchema: GenMessage<InstanceInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 1063);

/**
 * @generated from message zdc.InstanceMigration
 */
export type InstanceMigration = Message<"zdc.InstanceMigration"> & {
  /**
   * @generated from field: int32 version = 1;
   */
  version: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool applied = 3;
   */
  applied: boolean;

  /**
   * @generated from field: string applied_at = 4;
   */
  appliedAt: string;
};

/**
 * Describes the message zdc.InstanceMigration.
 * Use `create(InstanceMigrationSchema)` to create a new message.
 */
export const InstanceMigrationSchema: GenMessage<InstanceMigration> = /*@__PURE__*/
  messageDesc(file_zdc, 1064);

/**
 * @generated from message zdc.InstanceUser
 */
export type InstanceUser = Message<"zdc.InstanceUser"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string login = 2;
   */
  login: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * @generated from field: bool is_active = 5;
   */
  isActive: boolean;

  /**
   * @generated from field: bool is_system = 6;
   */
  isSystem: boolean;

  /**
   * @generated from field: string created_via = 7;
   */
  createdVia: string;

  /**
   * @generated from field: string last_seen_at = 8;
   */
  lastSeenAt: string;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.InstanceUser.
 * Use `create(InstanceUserSchema)` to create a new message.
 */
export const InstanceUserSchema: GenMessage<InstanceUser> = /*@__PURE__*/
  messageDesc(file_zdc, 1065);

/**
 * @generated from message zdc.InstanceSession
 */
export type InstanceSession = Message<"zdc.InstanceSession"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: string created_at = 3;
   */
  createdAt: string;

  /**
   * @generated from field: string expires_at = 4;
   */
  expiresAt: string;

  /**
   * @generated from field: string ip = 5;
   */
  ip: string;

  /**
   * @generated from field: string user_agent = 6;
   */
  userAgent: string;

  /**
   * @generated from field: string client_app = 7;
   */
  clientApp: string;
};

/**
 * Describes the message zdc.InstanceSession.
 * Use `create(InstanceSessionSchema)` to create a new message.
 */
export const InstanceSessionSchema: GenMessage<InstanceSession> = /*@__PURE__*/
  messageDesc(file_zdc, 1066);

/**
 * @generated from message zdc.InstanceData
 */
export type InstanceData = Message<"zdc.InstanceData"> & {
  /**
   * @generated from field: zdc.InstanceInfo info = 1;
   */
  info?: InstanceInfo | undefined;

  /**
   * @generated from field: repeated zdc.InstanceMigration migrations = 2;
   */
  migrations: InstanceMigration[];

  /**
   * @generated from field: repeated zdc.InstanceUser users = 3;
   */
  users: InstanceUser[];

  /**
   * @generated from field: repeated zdc.InstanceSession sessions = 4;
   */
  sessions: InstanceSession[];
};

/**
 * Describes the message zdc.InstanceData.
 * Use `create(InstanceDataSchema)` to create a new message.
 */
export const InstanceDataSchema: GenMessage<InstanceData> = /*@__PURE__*/
  messageDesc(file_zdc, 1067);

/**
 * ============================================================
 * AdapterService — ЕДИНЫЙ механизм адаптеров внешних систем (2026-08-30).
 * Адаптер = тип (вид) + реализация в нём: знает КАК взаимодействовать с
 * внешней системой (send/read/operate). «Кто» (пользователь/бот/контейнер)
 * взаимодействует посредством адаптера, и у него СВОИ настройки для этого
 * адаптера (телефон в Telegram, chat_id в Discord и т.п.) — они живут в
 * adapter_links. Общие прокси — отдельно (задал один — пользуются все).
 * ============================================================
 *
 * @generated from message zdc.AdapterTypeInfo
 */
export type AdapterTypeInfo = Message<"zdc.AdapterTypeInfo"> & {
  /**
   * код типа (telegram_bot, rss, youtube, ones...)
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string display = 2;
   */
  display: string;

  /**
   * иконка (lucide-имя/emoji)
   *
   * @generated from field: string icon = 3;
   */
  icon: string;

  /**
   * 'ai'|'channel'|'messenger'|'api'|...
   *
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * схема настроек ВИДА
   *
   * @generated from field: repeated zdc.ExternalApiFieldSchema fields = 6;
   */
  fields: ExternalApiFieldSchema[];

  /**
   * send/test/operate/receive
   *
   * @generated from field: repeated string capabilities = 7;
   */
  capabilities: string[];

  /**
   * тип НЕ создаётся вручную (встроен/настраивается в другом разделе)
   *
   * @generated from field: bool no_create = 8;
   */
  noCreate: boolean;

  /**
   * пояснение вместо кнопки «Создать» (при no_create)
   *
   * @generated from field: string create_note = 9;
   */
  createNote: string;

  /**
   * тип предназначен для подключения ПОЛЬЗОВАТЕЛЕМ в профиле
   *
   * @generated from field: bool profile_login = 10;
   */
  profileLogin: boolean;

  /**
   * supports_bot_binding — тип может быть ТРАНСПОРТОМ БОТА (волна 1a):
   * привязка bot_transports, входящие адресованы конкретному боту.
   *
   * @generated from field: bool supports_bot_binding = 11;
   */
  supportsBotBinding: boolean;
};

/**
 * Describes the message zdc.AdapterTypeInfo.
 * Use `create(AdapterTypeInfoSchema)` to create a new message.
 */
export const AdapterTypeInfoSchema: GenMessage<AdapterTypeInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 1068);

/**
 * @generated from message zdc.Adapter
 */
export type Adapter = Message<"zdc.Adapter"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * @generated from field: string adapter_type = 5;
   */
  adapterType: string;

  /**
   * настройки экземпляра (секреты скрыты)
   *
   * @generated from field: map<string, string> settings = 6;
   */
  settings: { [key: string]: string };

  /**
   * @generated from field: bool enabled = 7;
   */
  enabled: boolean;

  /**
   * @generated from field: bool is_system = 8;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 9;
   */
  templateId: string;

  /**
   * переопределение (пусто = из типа)
   *
   * @generated from field: string icon = 10;
   */
  icon: string;

  /**
   * общий прокси (adapter_proxies.code)
   *
   * @generated from field: string proxy_code = 11;
   */
  proxyCode: string;

  /**
   * @generated from field: string created_at = 12;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 13;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.Adapter.
 * Use `create(AdapterSchema)` to create a new message.
 */
export const AdapterSchema: GenMessage<Adapter> = /*@__PURE__*/
  messageDesc(file_zdc, 1069);

/**
 * @generated from message zdc.ListAdapterTypesResponse
 */
export type ListAdapterTypesResponse = Message<"zdc.ListAdapterTypesResponse"> & {
  /**
   * @generated from field: repeated zdc.AdapterTypeInfo items = 1;
   */
  items: AdapterTypeInfo[];
};

/**
 * Describes the message zdc.ListAdapterTypesResponse.
 * Use `create(ListAdapterTypesResponseSchema)` to create a new message.
 */
export const ListAdapterTypesResponseSchema: GenMessage<ListAdapterTypesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1070);

/**
 * @generated from message zdc.ListAdaptersResponse
 */
export type ListAdaptersResponse = Message<"zdc.ListAdaptersResponse"> & {
  /**
   * @generated from field: repeated zdc.Adapter items = 1;
   */
  items: Adapter[];
};

/**
 * Describes the message zdc.ListAdaptersResponse.
 * Use `create(ListAdaptersResponseSchema)` to create a new message.
 */
export const ListAdaptersResponseSchema: GenMessage<ListAdaptersResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1071);

/**
 * @generated from message zdc.SaveAdapterRequest
 */
export type SaveAdapterRequest = Message<"zdc.SaveAdapterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * @generated from field: string adapter_type = 5;
   */
  adapterType: string;

  /**
   * @generated from field: map<string, string> settings = 6;
   */
  settings: { [key: string]: string };

  /**
   * @generated from field: bool enabled = 7;
   */
  enabled: boolean;

  /**
   * @generated from field: string icon = 8;
   */
  icon: string;

  /**
   * @generated from field: string proxy_code = 9;
   */
  proxyCode: string;
};

/**
 * Describes the message zdc.SaveAdapterRequest.
 * Use `create(SaveAdapterRequestSchema)` to create a new message.
 */
export const SaveAdapterRequestSchema: GenMessage<SaveAdapterRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1072);

/**
 * @generated from message zdc.DeleteAdapterRequest
 */
export type DeleteAdapterRequest = Message<"zdc.DeleteAdapterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteAdapterRequest.
 * Use `create(DeleteAdapterRequestSchema)` to create a new message.
 */
export const DeleteAdapterRequestSchema: GenMessage<DeleteAdapterRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1073);

/**
 * --- Общие прокси ---
 *
 * @generated from message zdc.AdapterProxy
 */
export type AdapterProxy = Message<"zdc.AdapterProxy"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * socks5 | http | mtproto
   *
   * @generated from field: string proxy_type = 4;
   */
  proxyType: string;

  /**
   * @generated from field: string addr = 5;
   */
  addr: string;

  /**
   * @generated from field: string username = 6;
   */
  username: string;

  /**
   * true если пароль задан (не возвращается)
   *
   * @generated from field: bool password_set = 7;
   */
  passwordSet: boolean;

  /**
   * @generated from field: bool enabled = 8;
   */
  enabled: boolean;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 10;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.AdapterProxy.
 * Use `create(AdapterProxySchema)` to create a new message.
 */
export const AdapterProxySchema: GenMessage<AdapterProxy> = /*@__PURE__*/
  messageDesc(file_zdc, 1074);

/**
 * @generated from message zdc.ListProxiesResponse
 */
export type ListProxiesResponse = Message<"zdc.ListProxiesResponse"> & {
  /**
   * @generated from field: repeated zdc.AdapterProxy items = 1;
   */
  items: AdapterProxy[];
};

/**
 * Describes the message zdc.ListProxiesResponse.
 * Use `create(ListProxiesResponseSchema)` to create a new message.
 */
export const ListProxiesResponseSchema: GenMessage<ListProxiesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1075);

/**
 * @generated from message zdc.SaveProxyRequest
 */
export type SaveProxyRequest = Message<"zdc.SaveProxyRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string proxy_type = 4;
   */
  proxyType: string;

  /**
   * @generated from field: string addr = 5;
   */
  addr: string;

  /**
   * @generated from field: string username = 6;
   */
  username: string;

  /**
   * пусто = не менять
   *
   * @generated from field: string password = 7;
   */
  password: string;

  /**
   * @generated from field: bool enabled = 8;
   */
  enabled: boolean;
};

/**
 * Describes the message zdc.SaveProxyRequest.
 * Use `create(SaveProxyRequestSchema)` to create a new message.
 */
export const SaveProxyRequestSchema: GenMessage<SaveProxyRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1076);

/**
 * @generated from message zdc.DeleteProxyRequest
 */
export type DeleteProxyRequest = Message<"zdc.DeleteProxyRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteProxyRequest.
 * Use `create(DeleteProxyRequestSchema)` to create a new message.
 */
export const DeleteProxyRequestSchema: GenMessage<DeleteProxyRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1077);

/**
 * TestProxyRequest — проверка подключения СОХРАНЁННОГО прокси (кнопка
 * «Проверить подключение» в разделе «Прокси»).
 *
 * @generated from message zdc.TestProxyRequest
 */
export type TestProxyRequest = Message<"zdc.TestProxyRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.TestProxyRequest.
 * Use `create(TestProxyRequestSchema)` to create a new message.
 */
export const TestProxyRequestSchema: GenMessage<TestProxyRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1078);

/**
 * TestProxyResponse — итог проверки: ok=false + человеческое сообщение при
 * отказе; duration_ms — длительность TCP-подключения.
 *
 * @generated from message zdc.TestProxyResponse
 */
export type TestProxyResponse = Message<"zdc.TestProxyResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: int64 duration_ms = 3;
   */
  durationMs: bigint;
};

/**
 * Describes the message zdc.TestProxyResponse.
 * Use `create(TestProxyResponseSchema)` to create a new message.
 */
export const TestProxyResponseSchema: GenMessage<TestProxyResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1079);

/**
 * --- Внешние ссылки (у сущностей и контейнеров) ---
 *
 * @generated from message zdc.AdapterLink
 */
export type AdapterLink = Message<"zdc.AdapterLink"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string adapter_id = 2;
   */
  adapterId: string;

  /**
   * @generated from field: string entity_id = 3;
   */
  entityId: string;

  /**
   * @generated from field: string container_id = 4;
   */
  containerId: string;

  /**
   * @generated from field: string external_id = 5;
   */
  externalId: string;

  /**
   * телефон/логин/имя во внешней системе
   *
   * @generated from field: string external_name = 6;
   */
  externalName: string;

  /**
   * @generated from field: string linked_at = 7;
   */
  linkedAt: string;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;

  /**
   * резолв (для UI)
   *
   * @generated from field: string adapter_code = 9;
   */
  adapterCode: string;

  /**
   * @generated from field: string adapter_name = 10;
   */
  adapterName: string;

  /**
   * @generated from field: string adapter_icon = 11;
   */
  adapterIcon: string;
};

/**
 * Describes the message zdc.AdapterLink.
 * Use `create(AdapterLinkSchema)` to create a new message.
 */
export const AdapterLinkSchema: GenMessage<AdapterLink> = /*@__PURE__*/
  messageDesc(file_zdc, 1080);

/**
 * @generated from message zdc.ListAdapterLinksRequest
 */
export type ListAdapterLinksRequest = Message<"zdc.ListAdapterLinksRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string container_id = 2;
   */
  containerId: string;
};

/**
 * Describes the message zdc.ListAdapterLinksRequest.
 * Use `create(ListAdapterLinksRequestSchema)` to create a new message.
 */
export const ListAdapterLinksRequestSchema: GenMessage<ListAdapterLinksRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1081);

/**
 * @generated from message zdc.ListAdapterLinksResponse
 */
export type ListAdapterLinksResponse = Message<"zdc.ListAdapterLinksResponse"> & {
  /**
   * @generated from field: repeated zdc.AdapterLink items = 1;
   */
  items: AdapterLink[];
};

/**
 * Describes the message zdc.ListAdapterLinksResponse.
 * Use `create(ListAdapterLinksResponseSchema)` to create a new message.
 */
export const ListAdapterLinksResponseSchema: GenMessage<ListAdapterLinksResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1082);

/**
 * @generated from message zdc.SaveAdapterLinkRequest
 */
export type SaveAdapterLinkRequest = Message<"zdc.SaveAdapterLinkRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string adapter_id = 2;
   */
  adapterId: string;

  /**
   * @generated from field: string entity_id = 3;
   */
  entityId: string;

  /**
   * @generated from field: string container_id = 4;
   */
  containerId: string;

  /**
   * @generated from field: string external_id = 5;
   */
  externalId: string;

  /**
   * @generated from field: string external_name = 6;
   */
  externalName: string;
};

/**
 * Describes the message zdc.SaveAdapterLinkRequest.
 * Use `create(SaveAdapterLinkRequestSchema)` to create a new message.
 */
export const SaveAdapterLinkRequestSchema: GenMessage<SaveAdapterLinkRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1083);

/**
 * @generated from message zdc.DeleteAdapterLinkRequest
 */
export type DeleteAdapterLinkRequest = Message<"zdc.DeleteAdapterLinkRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteAdapterLinkRequest.
 * Use `create(DeleteAdapterLinkRequestSchema)` to create a new message.
 */
export const DeleteAdapterLinkRequestSchema: GenMessage<DeleteAdapterLinkRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1084);

/**
 * --- Сессии userbot'ов (принадлежат пользователю) ---
 *
 * @generated from message zdc.AdapterSessionInfo
 */
export type AdapterSessionInfo = Message<"zdc.AdapterSessionInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string adapter_id = 2;
   */
  adapterId: string;

  /**
   * @generated from field: string entity_id = 3;
   */
  entityId: string;

  /**
   * new | code_sent | email_address_required | email_code_sent | password_required | ready | error
   *
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: string proxy_type = 5;
   */
  proxyType: string;

  /**
   * @generated from field: string proxy_addr = 6;
   */
  proxyAddr: string;

  /**
   * @generated from field: string error = 7;
   */
  error: string;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 9;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.AdapterSessionInfo.
 * Use `create(AdapterSessionInfoSchema)` to create a new message.
 */
export const AdapterSessionInfoSchema: GenMessage<AdapterSessionInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 1085);

/**
 * @generated from message zdc.ListAdapterSessionsRequest
 */
export type ListAdapterSessionsRequest = Message<"zdc.ListAdapterSessionsRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string adapter_id = 2;
   */
  adapterId: string;
};

/**
 * Describes the message zdc.ListAdapterSessionsRequest.
 * Use `create(ListAdapterSessionsRequestSchema)` to create a new message.
 */
export const ListAdapterSessionsRequestSchema: GenMessage<ListAdapterSessionsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1086);

/**
 * @generated from message zdc.ListAdapterSessionsResponse
 */
export type ListAdapterSessionsResponse = Message<"zdc.ListAdapterSessionsResponse"> & {
  /**
   * @generated from field: repeated zdc.AdapterSessionInfo items = 1;
   */
  items: AdapterSessionInfo[];
};

/**
 * Describes the message zdc.ListAdapterSessionsResponse.
 * Use `create(ListAdapterSessionsResponseSchema)` to create a new message.
 */
export const ListAdapterSessionsResponseSchema: GenMessage<ListAdapterSessionsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1087);

/**
 * @generated from message zdc.DeleteAdapterSessionRequest
 */
export type DeleteAdapterSessionRequest = Message<"zdc.DeleteAdapterSessionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteAdapterSessionRequest.
 * Use `create(DeleteAdapterSessionRequestSchema)` to create a new message.
 */
export const DeleteAdapterSessionRequestSchema: GenMessage<DeleteAdapterSessionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1088);

/**
 * --- Вход userbot'а (MTProto/TDLib): пошаговый флоу (свои сессии) ---
 *
 * @generated from message zdc.AdapterLoginState
 */
export type AdapterLoginState = Message<"zdc.AdapterLoginState"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string adapter_id = 2;
   */
  adapterId: string;

  /**
   * code_sent | email_address_required | email_code_sent | password_required | ready | error
   *
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * маскированный номер
   *
   * @generated from field: string phone = 4;
   */
  phone: string;

  /**
   * @username / имя аккаунта (после входа)
   *
   * @generated from field: string account = 5;
   */
  account: string;

  /**
   * @generated from field: string error = 6;
   */
  error: string;

  /**
   * @generated from field: string updated_at = 7;
   */
  updatedAt: string;

  /**
   * маска адреса почты (u***@example.com), без полного адреса
   *
   * @generated from field: string email_pattern = 8;
   */
  emailPattern: string;

  /**
   * длина кода из письма (0 — неизвестна)
   *
   * @generated from field: int32 email_code_length = 9;
   */
  emailCodeLength: number;

  /**
   * available | pending | "" — можно ли сменить адрес
   *
   * @generated from field: string email_reset_state = 10;
   */
  emailResetState: string;
};

/**
 * Describes the message zdc.AdapterLoginState.
 * Use `create(AdapterLoginStateSchema)` to create a new message.
 */
export const AdapterLoginStateSchema: GenMessage<AdapterLoginState> = /*@__PURE__*/
  messageDesc(file_zdc, 1089);

/**
 * @generated from message zdc.StartAdapterLoginRequest
 */
export type StartAdapterLoginRequest = Message<"zdc.StartAdapterLoginRequest"> & {
  /**
   * @generated from field: string adapter_id = 1;
   */
  adapterId: string;

  /**
   * @generated from field: string phone = 2;
   */
  phone: string;
};

/**
 * Describes the message zdc.StartAdapterLoginRequest.
 * Use `create(StartAdapterLoginRequestSchema)` to create a new message.
 */
export const StartAdapterLoginRequestSchema: GenMessage<StartAdapterLoginRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1090);

/**
 * @generated from message zdc.SubmitAdapterLoginCodeRequest
 */
export type SubmitAdapterLoginCodeRequest = Message<"zdc.SubmitAdapterLoginCodeRequest"> & {
  /**
   * @generated from field: string adapter_id = 1;
   */
  adapterId: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message zdc.SubmitAdapterLoginCodeRequest.
 * Use `create(SubmitAdapterLoginCodeRequestSchema)` to create a new message.
 */
export const SubmitAdapterLoginCodeRequestSchema: GenMessage<SubmitAdapterLoginCodeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1091);

/**
 * @generated from message zdc.SubmitAdapterLoginEmailAddressRequest
 */
export type SubmitAdapterLoginEmailAddressRequest = Message<"zdc.SubmitAdapterLoginEmailAddressRequest"> & {
  /**
   * @generated from field: string adapter_id = 1;
   */
  adapterId: string;

  /**
   * @generated from field: string email_address = 2;
   */
  emailAddress: string;
};

/**
 * Describes the message zdc.SubmitAdapterLoginEmailAddressRequest.
 * Use `create(SubmitAdapterLoginEmailAddressRequestSchema)` to create a new message.
 */
export const SubmitAdapterLoginEmailAddressRequestSchema: GenMessage<SubmitAdapterLoginEmailAddressRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1092);

/**
 * @generated from message zdc.SubmitAdapterLoginEmailCodeRequest
 */
export type SubmitAdapterLoginEmailCodeRequest = Message<"zdc.SubmitAdapterLoginEmailCodeRequest"> & {
  /**
   * @generated from field: string adapter_id = 1;
   */
  adapterId: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message zdc.SubmitAdapterLoginEmailCodeRequest.
 * Use `create(SubmitAdapterLoginEmailCodeRequestSchema)` to create a new message.
 */
export const SubmitAdapterLoginEmailCodeRequestSchema: GenMessage<SubmitAdapterLoginEmailCodeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1093);

/**
 * @generated from message zdc.ResendAdapterLoginCodeRequest
 */
export type ResendAdapterLoginCodeRequest = Message<"zdc.ResendAdapterLoginCodeRequest"> & {
  /**
   * @generated from field: string adapter_id = 1;
   */
  adapterId: string;
};

/**
 * Describes the message zdc.ResendAdapterLoginCodeRequest.
 * Use `create(ResendAdapterLoginCodeRequestSchema)` to create a new message.
 */
export const ResendAdapterLoginCodeRequestSchema: GenMessage<ResendAdapterLoginCodeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1094);

/**
 * @generated from message zdc.ResetAdapterLoginEmailRequest
 */
export type ResetAdapterLoginEmailRequest = Message<"zdc.ResetAdapterLoginEmailRequest"> & {
  /**
   * @generated from field: string adapter_id = 1;
   */
  adapterId: string;
};

/**
 * Describes the message zdc.ResetAdapterLoginEmailRequest.
 * Use `create(ResetAdapterLoginEmailRequestSchema)` to create a new message.
 */
export const ResetAdapterLoginEmailRequestSchema: GenMessage<ResetAdapterLoginEmailRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1095);

/**
 * @generated from message zdc.SubmitAdapterLoginPasswordRequest
 */
export type SubmitAdapterLoginPasswordRequest = Message<"zdc.SubmitAdapterLoginPasswordRequest"> & {
  /**
   * @generated from field: string adapter_id = 1;
   */
  adapterId: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message zdc.SubmitAdapterLoginPasswordRequest.
 * Use `create(SubmitAdapterLoginPasswordRequestSchema)` to create a new message.
 */
export const SubmitAdapterLoginPasswordRequestSchema: GenMessage<SubmitAdapterLoginPasswordRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1096);

/**
 * @generated from message zdc.GetAdapterLoginRequest
 */
export type GetAdapterLoginRequest = Message<"zdc.GetAdapterLoginRequest"> & {
  /**
   * @generated from field: string adapter_id = 1;
   */
  adapterId: string;
};

/**
 * Describes the message zdc.GetAdapterLoginRequest.
 * Use `create(GetAdapterLoginRequestSchema)` to create a new message.
 */
export const GetAdapterLoginRequestSchema: GenMessage<GetAdapterLoginRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1097);

/**
 * @generated from message zdc.ChartOfAccounts
 */
export type ChartOfAccounts = Message<"zdc.ChartOfAccounts"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: bool supports_subconto = 4;
   */
  supportsSubconto: boolean;

  /**
   * @generated from field: bool supports_quantitative = 5;
   */
  supportsQuantitative: boolean;

  /**
   * @generated from field: int32 max_subconto_count = 6;
   */
  maxSubcontoCount: number;

  /**
   * @generated from field: string description = 7;
   */
  description: string;

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive: boolean;

  /**
   * @generated from field: bool is_system = 9;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 10;
   */
  templateId: string;
};

/**
 * Describes the message zdc.ChartOfAccounts.
 * Use `create(ChartOfAccountsSchema)` to create a new message.
 */
export const ChartOfAccountsSchema: GenMessage<ChartOfAccounts> = /*@__PURE__*/
  messageDesc(file_zdc, 1098);

/**
 * @generated from message zdc.ChartOfAccountsList
 */
export type ChartOfAccountsList = Message<"zdc.ChartOfAccountsList"> & {
  /**
   * @generated from field: repeated zdc.ChartOfAccounts items = 1;
   */
  items: ChartOfAccounts[];
};

/**
 * Describes the message zdc.ChartOfAccountsList.
 * Use `create(ChartOfAccountsListSchema)` to create a new message.
 */
export const ChartOfAccountsListSchema: GenMessage<ChartOfAccountsList> = /*@__PURE__*/
  messageDesc(file_zdc, 1099);

/**
 * @generated from message zdc.GetChartOfAccountsRequest
 */
export type GetChartOfAccountsRequest = Message<"zdc.GetChartOfAccountsRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.GetChartOfAccountsRequest.
 * Use `create(GetChartOfAccountsRequestSchema)` to create a new message.
 */
export const GetChartOfAccountsRequestSchema: GenMessage<GetChartOfAccountsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1100);

/**
 * @generated from message zdc.SaveChartOfAccountsRequest
 */
export type SaveChartOfAccountsRequest = Message<"zdc.SaveChartOfAccountsRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: bool supports_subconto = 4;
   */
  supportsSubconto: boolean;

  /**
   * @generated from field: bool supports_quantitative = 5;
   */
  supportsQuantitative: boolean;

  /**
   * @generated from field: int32 max_subconto_count = 6;
   */
  maxSubcontoCount: number;

  /**
   * @generated from field: string description = 7;
   */
  description: string;

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive: boolean;
};

/**
 * Describes the message zdc.SaveChartOfAccountsRequest.
 * Use `create(SaveChartOfAccountsRequestSchema)` to create a new message.
 */
export const SaveChartOfAccountsRequestSchema: GenMessage<SaveChartOfAccountsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1101);

/**
 * @generated from message zdc.DeleteChartOfAccountsRequest
 */
export type DeleteChartOfAccountsRequest = Message<"zdc.DeleteChartOfAccountsRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.DeleteChartOfAccountsRequest.
 * Use `create(DeleteChartOfAccountsRequestSchema)` to create a new message.
 */
export const DeleteChartOfAccountsRequestSchema: GenMessage<DeleteChartOfAccountsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1102);

/**
 * @generated from message zdc.ChartAccount
 */
export type ChartAccount = Message<"zdc.ChartAccount"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string chart_code = 2;
   */
  chartCode: string;

  /**
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: string account_type = 5;
   */
  accountType: string;

  /**
   * @generated from field: string parent_code = 6;
   */
  parentCode: string;

  /**
   * @generated from field: bool is_folder = 7;
   */
  isFolder: boolean;

  /**
   * @generated from field: bool off_balance = 8;
   */
  offBalance: boolean;

  /**
   * @generated from field: string description = 9;
   */
  description: string;

  /**
   * @generated from field: bool is_active = 10;
   */
  isActive: boolean;

  /**
   * @generated from field: bool is_predetermined = 11;
   */
  isPredetermined: boolean;

  /**
   * @generated from field: string predetermined_name = 12;
   */
  predeterminedName: string;

  /**
   * @generated from field: repeated string subconto = 13;
   */
  subconto: string[];

  /**
   * @generated from field: int32 sort_order = 14;
   */
  sortOrder: number;

  /**
   * @generated from field: string template_id = 15;
   */
  templateId: string;
};

/**
 * Describes the message zdc.ChartAccount.
 * Use `create(ChartAccountSchema)` to create a new message.
 */
export const ChartAccountSchema: GenMessage<ChartAccount> = /*@__PURE__*/
  messageDesc(file_zdc, 1103);

/**
 * @generated from message zdc.ChartAccountList
 */
export type ChartAccountList = Message<"zdc.ChartAccountList"> & {
  /**
   * @generated from field: repeated zdc.ChartAccount items = 1;
   */
  items: ChartAccount[];
};

/**
 * Describes the message zdc.ChartAccountList.
 * Use `create(ChartAccountListSchema)` to create a new message.
 */
export const ChartAccountListSchema: GenMessage<ChartAccountList> = /*@__PURE__*/
  messageDesc(file_zdc, 1104);

/**
 * @generated from message zdc.ListAccountsRequest
 */
export type ListAccountsRequest = Message<"zdc.ListAccountsRequest"> & {
  /**
   * @generated from field: string chart_code = 1;
   */
  chartCode: string;
};

/**
 * Describes the message zdc.ListAccountsRequest.
 * Use `create(ListAccountsRequestSchema)` to create a new message.
 */
export const ListAccountsRequestSchema: GenMessage<ListAccountsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1105);

/**
 * @generated from message zdc.SaveAccountRequest
 */
export type SaveAccountRequest = Message<"zdc.SaveAccountRequest"> & {
  /**
   * @generated from field: string chart_code = 1;
   */
  chartCode: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string account_type = 4;
   */
  accountType: string;

  /**
   * @generated from field: string parent_code = 5;
   */
  parentCode: string;

  /**
   * @generated from field: bool is_folder = 6;
   */
  isFolder: boolean;

  /**
   * @generated from field: bool off_balance = 7;
   */
  offBalance: boolean;

  /**
   * @generated from field: string description = 8;
   */
  description: string;

  /**
   * @generated from field: bool is_active = 9;
   */
  isActive: boolean;

  /**
   * @generated from field: repeated string subconto = 10;
   */
  subconto: string[];

  /**
   * @generated from field: int32 sort_order = 11;
   */
  sortOrder: number;
};

/**
 * Describes the message zdc.SaveAccountRequest.
 * Use `create(SaveAccountRequestSchema)` to create a new message.
 */
export const SaveAccountRequestSchema: GenMessage<SaveAccountRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1106);

/**
 * @generated from message zdc.DeleteAccountRequest
 */
export type DeleteAccountRequest = Message<"zdc.DeleteAccountRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteAccountRequest.
 * Use `create(DeleteAccountRequestSchema)` to create a new message.
 */
export const DeleteAccountRequestSchema: GenMessage<DeleteAccountRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1107);

/**
 * @generated from message zdc.SubcontoType
 */
export type SubcontoType = Message<"zdc.SubcontoType"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string value_type = 4;
   */
  valueType: string;

  /**
   * @generated from field: string ref_table = 5;
   */
  refTable: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: bool is_active = 7;
   */
  isActive: boolean;

  /**
   * @generated from field: bool is_system = 8;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 9;
   */
  templateId: string;
};

/**
 * Describes the message zdc.SubcontoType.
 * Use `create(SubcontoTypeSchema)` to create a new message.
 */
export const SubcontoTypeSchema: GenMessage<SubcontoType> = /*@__PURE__*/
  messageDesc(file_zdc, 1108);

/**
 * @generated from message zdc.SubcontoTypeList
 */
export type SubcontoTypeList = Message<"zdc.SubcontoTypeList"> & {
  /**
   * @generated from field: repeated zdc.SubcontoType items = 1;
   */
  items: SubcontoType[];
};

/**
 * Describes the message zdc.SubcontoTypeList.
 * Use `create(SubcontoTypeListSchema)` to create a new message.
 */
export const SubcontoTypeListSchema: GenMessage<SubcontoTypeList> = /*@__PURE__*/
  messageDesc(file_zdc, 1109);

/**
 * @generated from message zdc.SaveSubcontoTypeRequest
 */
export type SaveSubcontoTypeRequest = Message<"zdc.SaveSubcontoTypeRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string value_type = 4;
   */
  valueType: string;

  /**
   * @generated from field: string ref_table = 5;
   */
  refTable: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: bool is_active = 7;
   */
  isActive: boolean;
};

/**
 * Describes the message zdc.SaveSubcontoTypeRequest.
 * Use `create(SaveSubcontoTypeRequestSchema)` to create a new message.
 */
export const SaveSubcontoTypeRequestSchema: GenMessage<SaveSubcontoTypeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1110);

/**
 * @generated from message zdc.DeleteSubcontoTypeRequest
 */
export type DeleteSubcontoTypeRequest = Message<"zdc.DeleteSubcontoTypeRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.DeleteSubcontoTypeRequest.
 * Use `create(DeleteSubcontoTypeRequestSchema)` to create a new message.
 */
export const DeleteSubcontoTypeRequestSchema: GenMessage<DeleteSubcontoTypeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1111);

/**
 * @generated from message zdc.BillingSettings
 */
export type BillingSettings = Message<"zdc.BillingSettings"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * manual | internal — «основной способ» (подсказка)
   *
   * @generated from field: string mode = 2;
   */
  mode: string;

  /**
   * внутренний баланс/операции (независим от manual-доступов)
   *
   * @generated from field: bool money = 3;
   */
  money: boolean;

  /**
   * ссылка на элемент «Валюты» (id)
   *
   * @generated from field: string currency_ref = 4;
   */
  currencyRef: string;

  /**
   * символ/код валюты (отображение)
   *
   * @generated from field: string currency_display = 5;
   */
  currencyDisplay: string;
};

/**
 * Describes the message zdc.BillingSettings.
 * Use `create(BillingSettingsSchema)` to create a new message.
 */
export const BillingSettingsSchema: GenMessage<BillingSettings> = /*@__PURE__*/
  messageDesc(file_zdc, 1112);

/**
 * @generated from message zdc.GetBillingSettingsRequest
 */
export type GetBillingSettingsRequest = Message<"zdc.GetBillingSettingsRequest"> & {
};

/**
 * Describes the message zdc.GetBillingSettingsRequest.
 * Use `create(GetBillingSettingsRequestSchema)` to create a new message.
 */
export const GetBillingSettingsRequestSchema: GenMessage<GetBillingSettingsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1113);

/**
 * @generated from message zdc.GetBillingSettingsResponse
 */
export type GetBillingSettingsResponse = Message<"zdc.GetBillingSettingsResponse"> & {
  /**
   * @generated from field: zdc.BillingSettings settings = 1;
   */
  settings?: BillingSettings | undefined;
};

/**
 * Describes the message zdc.GetBillingSettingsResponse.
 * Use `create(GetBillingSettingsResponseSchema)` to create a new message.
 */
export const GetBillingSettingsResponseSchema: GenMessage<GetBillingSettingsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1114);

/**
 * @generated from message zdc.SetBillingSettingsRequest
 */
export type SetBillingSettingsRequest = Message<"zdc.SetBillingSettingsRequest"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: string mode = 2;
   */
  mode: string;

  /**
   * @generated from field: bool money = 3;
   */
  money: boolean;

  /**
   * ссылка на элемент «Валюты» (id; пусто = не задана)
   *
   * @generated from field: string currency_ref = 4;
   */
  currencyRef: string;
};

/**
 * Describes the message zdc.SetBillingSettingsRequest.
 * Use `create(SetBillingSettingsRequestSchema)` to create a new message.
 */
export const SetBillingSettingsRequestSchema: GenMessage<SetBillingSettingsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1115);

/**
 * @generated from message zdc.BillingAccount
 */
export type BillingAccount = Message<"zdc.BillingAccount"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * internal | bank
   *
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * ссылка на «Валюты» (id)
   *
   * @generated from field: string currency = 5;
   */
  currency: string;

  /**
   * символ/код валюты
   *
   * @generated from field: string currency_display = 6;
   */
  currencyDisplay: string;

  /**
   * ссылка на «Банки» (id; обязательна для kind='bank')
   *
   * @generated from field: string bank_id = 7;
   */
  bankId: string;

  /**
   * представление банка
   *
   * @generated from field: string bank_display = 8;
   */
  bankDisplay: string;

  /**
   * @generated from field: string account_number = 9;
   */
  accountNumber: string;

  /**
   * @generated from field: bool is_personal = 10;
   */
  isPersonal: boolean;

  /**
   * @generated from field: string owner_id = 11;
   */
  ownerId: string;

  /**
   * @generated from field: string owner_presentation = 12;
   */
  ownerPresentation: string;

  /**
   * @generated from field: bool is_marked = 13;
   */
  isMarked: boolean;

  /**
   * текущий баланс (движения регистра)
   *
   * @generated from field: int64 balance = 14;
   */
  balance: bigint;

  /**
   * доступно (баланс − активные холды)
   *
   * @generated from field: int64 available = 15;
   */
  available: bigint;
};

/**
 * Describes the message zdc.BillingAccount.
 * Use `create(BillingAccountSchema)` to create a new message.
 */
export const BillingAccountSchema: GenMessage<BillingAccount> = /*@__PURE__*/
  messageDesc(file_zdc, 1116);

/**
 * @generated from message zdc.ListBillingAccountsRequest
 */
export type ListBillingAccountsRequest = Message<"zdc.ListBillingAccountsRequest"> & {
  /**
   * пусто = все (админ)
   *
   * @generated from field: string owner_id = 1;
   */
  ownerId: string;
};

/**
 * Describes the message zdc.ListBillingAccountsRequest.
 * Use `create(ListBillingAccountsRequestSchema)` to create a new message.
 */
export const ListBillingAccountsRequestSchema: GenMessage<ListBillingAccountsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1117);

/**
 * @generated from message zdc.ListBillingAccountsResponse
 */
export type ListBillingAccountsResponse = Message<"zdc.ListBillingAccountsResponse"> & {
  /**
   * @generated from field: repeated zdc.BillingAccount items = 1;
   */
  items: BillingAccount[];
};

/**
 * Describes the message zdc.ListBillingAccountsResponse.
 * Use `create(ListBillingAccountsResponseSchema)` to create a new message.
 */
export const ListBillingAccountsResponseSchema: GenMessage<ListBillingAccountsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1118);

/**
 * @generated from message zdc.SaveBillingAccountRequest
 */
export type SaveBillingAccountRequest = Message<"zdc.SaveBillingAccountRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * ссылка на «Валюты» (id; пусто = валюта базы)
   *
   * @generated from field: string currency = 4;
   */
  currency: string;

  /**
   * @generated from field: string account_number = 5;
   */
  accountNumber: string;

  /**
   * @generated from field: bool is_personal = 6;
   */
  isPersonal: boolean;

  /**
   * владелец обязателен (пикер по определяемому типу)
   *
   * @generated from field: string owner_id = 7;
   */
  ownerId: string;

  /**
   * обязательна для kind='bank' (ссылка на «Банки»)
   *
   * @generated from field: string bank_id = 8;
   */
  bankId: string;
};

/**
 * Describes the message zdc.SaveBillingAccountRequest.
 * Use `create(SaveBillingAccountRequestSchema)` to create a new message.
 */
export const SaveBillingAccountRequestSchema: GenMessage<SaveBillingAccountRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1119);

/**
 * @generated from message zdc.DeleteBillingAccountRequest
 */
export type DeleteBillingAccountRequest = Message<"zdc.DeleteBillingAccountRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteBillingAccountRequest.
 * Use `create(DeleteBillingAccountRequestSchema)` to create a new message.
 */
export const DeleteBillingAccountRequestSchema: GenMessage<DeleteBillingAccountRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1120);

/**
 * @generated from message zdc.BillingOperation
 */
export type BillingOperation = Message<"zdc.BillingOperation"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string client_ref = 2;
   */
  clientRef: string;

  /**
   * deposit|debit|hold|capture|release|transfer|refund
   *
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * pending|done|failed|released
   *
   * @generated from field: string state = 4;
   */
  state: string;

  /**
   * @generated from field: int64 amount = 5;
   */
  amount: bigint;

  /**
   * @generated from field: string account_id = 6;
   */
  accountId: string;

  /**
   * @generated from field: string target_account_id = 7;
   */
  targetAccountId: string;

  /**
   * @generated from field: string meta = 8;
   */
  meta: string;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * @generated from field: string created_by = 10;
   */
  createdBy: string;
};

/**
 * Describes the message zdc.BillingOperation.
 * Use `create(BillingOperationSchema)` to create a new message.
 */
export const BillingOperationSchema: GenMessage<BillingOperation> = /*@__PURE__*/
  messageDesc(file_zdc, 1121);

/**
 * @generated from message zdc.ListBillingOperationsRequest
 */
export type ListBillingOperationsRequest = Message<"zdc.ListBillingOperationsRequest"> & {
  /**
   * пусто = все (админ)
   *
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;
};

/**
 * Describes the message zdc.ListBillingOperationsRequest.
 * Use `create(ListBillingOperationsRequestSchema)` to create a new message.
 */
export const ListBillingOperationsRequestSchema: GenMessage<ListBillingOperationsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1122);

/**
 * @generated from message zdc.ListBillingOperationsResponse
 */
export type ListBillingOperationsResponse = Message<"zdc.ListBillingOperationsResponse"> & {
  /**
   * @generated from field: repeated zdc.BillingOperation items = 1;
   */
  items: BillingOperation[];

  /**
   * @generated from field: int64 total_count = 2;
   */
  totalCount: bigint;
};

/**
 * Describes the message zdc.ListBillingOperationsResponse.
 * Use `create(ListBillingOperationsResponseSchema)` to create a new message.
 */
export const ListBillingOperationsResponseSchema: GenMessage<ListBillingOperationsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1123);

/**
 * @generated from message zdc.BillingBalance
 */
export type BillingBalance = Message<"zdc.BillingBalance"> & {
  /**
   * @generated from field: int64 balance = 1;
   */
  balance: bigint;

  /**
   * @generated from field: int64 holds = 2;
   */
  holds: bigint;

  /**
   * @generated from field: int64 available = 3;
   */
  available: bigint;

  /**
   * @generated from field: string currency = 4;
   */
  currency: string;
};

/**
 * Describes the message zdc.BillingBalance.
 * Use `create(BillingBalanceSchema)` to create a new message.
 */
export const BillingBalanceSchema: GenMessage<BillingBalance> = /*@__PURE__*/
  messageDesc(file_zdc, 1124);

/**
 * @generated from message zdc.BillingHold
 */
export type BillingHold = Message<"zdc.BillingHold"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string operation_id = 2;
   */
  operationId: string;

  /**
   * @generated from field: string account_id = 3;
   */
  accountId: string;

  /**
   * @generated from field: int64 amount = 4;
   */
  amount: bigint;

  /**
   * active|captured|released
   *
   * @generated from field: string state = 5;
   */
  state: string;

  /**
   * @generated from field: string expires_at = 6;
   */
  expiresAt: string;

  /**
   * @generated from field: string created_at = 7;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.BillingHold.
 * Use `create(BillingHoldSchema)` to create a new message.
 */
export const BillingHoldSchema: GenMessage<BillingHold> = /*@__PURE__*/
  messageDesc(file_zdc, 1125);

/**
 * @generated from message zdc.GetMyBillingAccountRequest
 */
export type GetMyBillingAccountRequest = Message<"zdc.GetMyBillingAccountRequest"> & {
};

/**
 * Describes the message zdc.GetMyBillingAccountRequest.
 * Use `create(GetMyBillingAccountRequestSchema)` to create a new message.
 */
export const GetMyBillingAccountRequestSchema: GenMessage<GetMyBillingAccountRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1126);

/**
 * @generated from message zdc.GetMyBillingAccountResponse
 */
export type GetMyBillingAccountResponse = Message<"zdc.GetMyBillingAccountResponse"> & {
  /**
   * @generated from field: zdc.BillingAccount account = 1;
   */
  account?: BillingAccount | undefined;

  /**
   * @generated from field: zdc.BillingBalance balance = 2;
   */
  balance?: BillingBalance | undefined;

  /**
   * @generated from field: repeated zdc.BillingHold holds = 3;
   */
  holds: BillingHold[];

  /**
   * @generated from field: repeated zdc.BillingOperation operations = 4;
   */
  operations: BillingOperation[];
};

/**
 * Describes the message zdc.GetMyBillingAccountResponse.
 * Use `create(GetMyBillingAccountResponseSchema)` to create a new message.
 */
export const GetMyBillingAccountResponseSchema: GenMessage<GetMyBillingAccountResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1127);

/**
 * @generated from message zdc.BillingAccess
 */
export type BillingAccess = Message<"zdc.BillingAccess"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string entity_presentation = 2;
   */
  entityPresentation: string;

  /**
   * 'app.<код>' | 'section.<код>' | 'feature.<ключ>'
   *
   * @generated from field: string scope = 3;
   */
  scope: string;

  /**
   * человекочитаемое представление области
   *
   * @generated from field: string scope_display = 4;
   */
  scopeDisplay: string;

  /**
   * @generated from field: string valid_until = 5;
   */
  validUntil: string;

  /**
   * granted|revoked
   *
   * @generated from field: string status = 6;
   */
  status: string;
};

/**
 * Describes the message zdc.BillingAccess.
 * Use `create(BillingAccessSchema)` to create a new message.
 */
export const BillingAccessSchema: GenMessage<BillingAccess> = /*@__PURE__*/
  messageDesc(file_zdc, 1128);

/**
 * @generated from message zdc.GrantBillingAccessRequest
 */
export type GrantBillingAccessRequest = Message<"zdc.GrantBillingAccessRequest"> & {
  /**
   * пусто = текущий пользователь
   *
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string scope = 2;
   */
  scope: string;

  /**
   * RFC3339; пусто = бессрочно
   *
   * @generated from field: string valid_until = 3;
   */
  validUntil: string;
};

/**
 * Describes the message zdc.GrantBillingAccessRequest.
 * Use `create(GrantBillingAccessRequestSchema)` to create a new message.
 */
export const GrantBillingAccessRequestSchema: GenMessage<GrantBillingAccessRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1129);

/**
 * @generated from message zdc.RevokeBillingAccessRequest
 */
export type RevokeBillingAccessRequest = Message<"zdc.RevokeBillingAccessRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string scope = 2;
   */
  scope: string;
};

/**
 * Describes the message zdc.RevokeBillingAccessRequest.
 * Use `create(RevokeBillingAccessRequestSchema)` to create a new message.
 */
export const RevokeBillingAccessRequestSchema: GenMessage<RevokeBillingAccessRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1130);

/**
 * @generated from message zdc.HasBillingAccessRequest
 */
export type HasBillingAccessRequest = Message<"zdc.HasBillingAccessRequest"> & {
  /**
   * пусто = текущий пользователь
   *
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string scope = 2;
   */
  scope: string;
};

/**
 * Describes the message zdc.HasBillingAccessRequest.
 * Use `create(HasBillingAccessRequestSchema)` to create a new message.
 */
export const HasBillingAccessRequestSchema: GenMessage<HasBillingAccessRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1131);

/**
 * @generated from message zdc.HasBillingAccessResponse
 */
export type HasBillingAccessResponse = Message<"zdc.HasBillingAccessResponse"> & {
  /**
   * @generated from field: bool granted = 1;
   */
  granted: boolean;
};

/**
 * Describes the message zdc.HasBillingAccessResponse.
 * Use `create(HasBillingAccessResponseSchema)` to create a new message.
 */
export const HasBillingAccessResponseSchema: GenMessage<HasBillingAccessResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1132);

/**
 * @generated from message zdc.ListBillingAccessRequest
 */
export type ListBillingAccessRequest = Message<"zdc.ListBillingAccessRequest"> & {
  /**
   * пусто = все (админ)
   *
   * @generated from field: string entity_id = 1;
   */
  entityId: string;
};

/**
 * Describes the message zdc.ListBillingAccessRequest.
 * Use `create(ListBillingAccessRequestSchema)` to create a new message.
 */
export const ListBillingAccessRequestSchema: GenMessage<ListBillingAccessRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1133);

/**
 * @generated from message zdc.ListBillingAccessResponse
 */
export type ListBillingAccessResponse = Message<"zdc.ListBillingAccessResponse"> & {
  /**
   * @generated from field: repeated zdc.BillingAccess items = 1;
   */
  items: BillingAccess[];
};

/**
 * Describes the message zdc.ListBillingAccessResponse.
 * Use `create(ListBillingAccessResponseSchema)` to create a new message.
 */
export const ListBillingAccessResponseSchema: GenMessage<ListBillingAccessResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1134);

/**
 * @generated from message zdc.BillingPlan
 */
export type BillingPlan = Message<"zdc.BillingPlan"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int64 amount = 3;
   */
  amount: bigint;

  /**
   * day | month | year
   *
   * @generated from field: string period = 4;
   */
  period: string;

  /**
   * 'app.<код>' | 'section.<код>' | 'feature.<ключ>'
   *
   * @generated from field: string scope = 5;
   */
  scope: string;

  /**
   * @generated from field: string scope_display = 6;
   */
  scopeDisplay: string;

  /**
   * @generated from field: bool is_active = 7;
   */
  isActive: boolean;
};

/**
 * Describes the message zdc.BillingPlan.
 * Use `create(BillingPlanSchema)` to create a new message.
 */
export const BillingPlanSchema: GenMessage<BillingPlan> = /*@__PURE__*/
  messageDesc(file_zdc, 1135);

/**
 * @generated from message zdc.ListBillingPlansRequest
 */
export type ListBillingPlansRequest = Message<"zdc.ListBillingPlansRequest"> & {
};

/**
 * Describes the message zdc.ListBillingPlansRequest.
 * Use `create(ListBillingPlansRequestSchema)` to create a new message.
 */
export const ListBillingPlansRequestSchema: GenMessage<ListBillingPlansRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1136);

/**
 * @generated from message zdc.ListBillingPlansResponse
 */
export type ListBillingPlansResponse = Message<"zdc.ListBillingPlansResponse"> & {
  /**
   * @generated from field: repeated zdc.BillingPlan items = 1;
   */
  items: BillingPlan[];
};

/**
 * Describes the message zdc.ListBillingPlansResponse.
 * Use `create(ListBillingPlansResponseSchema)` to create a new message.
 */
export const ListBillingPlansResponseSchema: GenMessage<ListBillingPlansResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1137);

/**
 * @generated from message zdc.SaveBillingPlanRequest
 */
export type SaveBillingPlanRequest = Message<"zdc.SaveBillingPlanRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int64 amount = 3;
   */
  amount: bigint;

  /**
   * @generated from field: string period = 4;
   */
  period: string;

  /**
   * @generated from field: string scope = 5;
   */
  scope: string;

  /**
   * @generated from field: bool is_active = 6;
   */
  isActive: boolean;
};

/**
 * Describes the message zdc.SaveBillingPlanRequest.
 * Use `create(SaveBillingPlanRequestSchema)` to create a new message.
 */
export const SaveBillingPlanRequestSchema: GenMessage<SaveBillingPlanRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1138);

/**
 * @generated from message zdc.DeleteBillingPlanRequest
 */
export type DeleteBillingPlanRequest = Message<"zdc.DeleteBillingPlanRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.DeleteBillingPlanRequest.
 * Use `create(DeleteBillingPlanRequestSchema)` to create a new message.
 */
export const DeleteBillingPlanRequestSchema: GenMessage<DeleteBillingPlanRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1139);

/**
 * Область доступа/тарифа: структура kind+id (каскад «вид → значение» в UI).
 *
 * @generated from message zdc.BillingScopeTarget
 */
export type BillingScopeTarget = Message<"zdc.BillingScopeTarget"> & {
  /**
   * app | section | feature
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * код приложения / имя раздела / ключ функции
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * человекочитаемое представление
   *
   * @generated from field: string display = 3;
   */
  display: string;
};

/**
 * Describes the message zdc.BillingScopeTarget.
 * Use `create(BillingScopeTargetSchema)` to create a new message.
 */
export const BillingScopeTargetSchema: GenMessage<BillingScopeTarget> = /*@__PURE__*/
  messageDesc(file_zdc, 1140);

/**
 * @generated from message zdc.BillingScopeTargets
 */
export type BillingScopeTargets = Message<"zdc.BillingScopeTargets"> & {
  /**
   * @generated from field: repeated zdc.BillingScopeTarget apps = 1;
   */
  apps: BillingScopeTarget[];

  /**
   * @generated from field: repeated zdc.BillingScopeTarget sections = 2;
   */
  sections: BillingScopeTarget[];

  /**
   * @generated from field: repeated zdc.BillingScopeTarget features = 3;
   */
  features: BillingScopeTarget[];
};

/**
 * Describes the message zdc.BillingScopeTargets.
 * Use `create(BillingScopeTargetsSchema)` to create a new message.
 */
export const BillingScopeTargetsSchema: GenMessage<BillingScopeTargets> = /*@__PURE__*/
  messageDesc(file_zdc, 1141);

/**
 * @generated from message zdc.ListBillingScopeTargetsRequest
 */
export type ListBillingScopeTargetsRequest = Message<"zdc.ListBillingScopeTargetsRequest"> & {
};

/**
 * Describes the message zdc.ListBillingScopeTargetsRequest.
 * Use `create(ListBillingScopeTargetsRequestSchema)` to create a new message.
 */
export const ListBillingScopeTargetsRequestSchema: GenMessage<ListBillingScopeTargetsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1142);

/**
 * @generated from message zdc.ListBillingScopeTargetsResponse
 */
export type ListBillingScopeTargetsResponse = Message<"zdc.ListBillingScopeTargetsResponse"> & {
  /**
   * @generated from field: zdc.BillingScopeTargets targets = 1;
   */
  targets?: BillingScopeTargets | undefined;
};

/**
 * Describes the message zdc.ListBillingScopeTargetsResponse.
 * Use `create(ListBillingScopeTargetsResponseSchema)` to create a new message.
 */
export const ListBillingScopeTargetsResponseSchema: GenMessage<ListBillingScopeTargetsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1143);

/**
 * @generated from message zdc.BillingSubscription
 */
export type BillingSubscription = Message<"zdc.BillingSubscription"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: string entity_presentation = 3;
   */
  entityPresentation: string;

  /**
   * @generated from field: string plan_code = 4;
   */
  planCode: string;

  /**
   * active|canceled|expired
   *
   * @generated from field: string state = 5;
   */
  state: string;

  /**
   * @generated from field: string valid_from = 6;
   */
  validFrom: string;

  /**
   * @generated from field: string valid_until = 7;
   */
  validUntil: string;

  /**
   * @generated from field: bool auto_renew = 8;
   */
  autoRenew: boolean;
};

/**
 * Describes the message zdc.BillingSubscription.
 * Use `create(BillingSubscriptionSchema)` to create a new message.
 */
export const BillingSubscriptionSchema: GenMessage<BillingSubscription> = /*@__PURE__*/
  messageDesc(file_zdc, 1144);

/**
 * @generated from message zdc.SubscribeBillingPlanRequest
 */
export type SubscribeBillingPlanRequest = Message<"zdc.SubscribeBillingPlanRequest"> & {
  /**
   * пусто = текущий пользователь
   *
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string plan_code = 2;
   */
  planCode: string;

  /**
   * @generated from field: bool auto_renew = 3;
   */
  autoRenew: boolean;
};

/**
 * Describes the message zdc.SubscribeBillingPlanRequest.
 * Use `create(SubscribeBillingPlanRequestSchema)` to create a new message.
 */
export const SubscribeBillingPlanRequestSchema: GenMessage<SubscribeBillingPlanRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1145);

/**
 * @generated from message zdc.CancelBillingSubscriptionRequest
 */
export type CancelBillingSubscriptionRequest = Message<"zdc.CancelBillingSubscriptionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.CancelBillingSubscriptionRequest.
 * Use `create(CancelBillingSubscriptionRequestSchema)` to create a new message.
 */
export const CancelBillingSubscriptionRequestSchema: GenMessage<CancelBillingSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1146);

/**
 * @generated from message zdc.ListBillingSubscriptionsRequest
 */
export type ListBillingSubscriptionsRequest = Message<"zdc.ListBillingSubscriptionsRequest"> & {
  /**
   * пусто = свои; админ — все
   *
   * @generated from field: string entity_id = 1;
   */
  entityId: string;
};

/**
 * Describes the message zdc.ListBillingSubscriptionsRequest.
 * Use `create(ListBillingSubscriptionsRequestSchema)` to create a new message.
 */
export const ListBillingSubscriptionsRequestSchema: GenMessage<ListBillingSubscriptionsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1147);

/**
 * @generated from message zdc.ListBillingSubscriptionsResponse
 */
export type ListBillingSubscriptionsResponse = Message<"zdc.ListBillingSubscriptionsResponse"> & {
  /**
   * @generated from field: repeated zdc.BillingSubscription items = 1;
   */
  items: BillingSubscription[];
};

/**
 * Describes the message zdc.ListBillingSubscriptionsResponse.
 * Use `create(ListBillingSubscriptionsResponseSchema)` to create a new message.
 */
export const ListBillingSubscriptionsResponseSchema: GenMessage<ListBillingSubscriptionsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1148);

/**
 * @generated from message zdc.ScheduledJob
 */
export type ScheduledJob = Message<"zdc.ScheduledJob"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * cron:... | every:...
   *
   * @generated from field: string schedule = 5;
   */
  schedule: string;

  /**
   * JSON (вид обработчика)
   *
   * @generated from field: string handler = 6;
   */
  handler: string;

  /**
   * JSON (вход)
   *
   * @generated from field: string payload = 7;
   */
  payload: string;

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive: boolean;

  /**
   * @generated from field: bool is_system = 9;
   */
  isSystem: boolean;

  /**
   * @generated from field: string template_id = 10;
   */
  templateId: string;

  /**
   * @generated from field: string template_version = 11;
   */
  templateVersion: string;

  /**
   * @generated from field: string last_run_at = 12;
   */
  lastRunAt: string;

  /**
   * done|error|skipped
   *
   * @generated from field: string last_status = 13;
   */
  lastStatus: string;

  /**
   * @generated from field: string last_error = 14;
   */
  lastError: string;

  /**
   * @generated from field: string next_run_at = 15;
   */
  nextRunAt: string;
};

/**
 * Describes the message zdc.ScheduledJob.
 * Use `create(ScheduledJobSchema)` to create a new message.
 */
export const ScheduledJobSchema: GenMessage<ScheduledJob> = /*@__PURE__*/
  messageDesc(file_zdc, 1149);

/**
 * @generated from message zdc.ListScheduledJobsRequest
 */
export type ListScheduledJobsRequest = Message<"zdc.ListScheduledJobsRequest"> & {
};

/**
 * Describes the message zdc.ListScheduledJobsRequest.
 * Use `create(ListScheduledJobsRequestSchema)` to create a new message.
 */
export const ListScheduledJobsRequestSchema: GenMessage<ListScheduledJobsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1150);

/**
 * @generated from message zdc.ListScheduledJobsResponse
 */
export type ListScheduledJobsResponse = Message<"zdc.ListScheduledJobsResponse"> & {
  /**
   * @generated from field: repeated zdc.ScheduledJob items = 1;
   */
  items: ScheduledJob[];
};

/**
 * Describes the message zdc.ListScheduledJobsResponse.
 * Use `create(ListScheduledJobsResponseSchema)` to create a new message.
 */
export const ListScheduledJobsResponseSchema: GenMessage<ListScheduledJobsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1151);

/**
 * @generated from message zdc.GetScheduledJobRequest
 */
export type GetScheduledJobRequest = Message<"zdc.GetScheduledJobRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.GetScheduledJobRequest.
 * Use `create(GetScheduledJobRequestSchema)` to create a new message.
 */
export const GetScheduledJobRequestSchema: GenMessage<GetScheduledJobRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1152);

/**
 * @generated from message zdc.SaveScheduledJobRequest
 */
export type SaveScheduledJobRequest = Message<"zdc.SaveScheduledJobRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string schedule = 4;
   */
  schedule: string;

  /**
   * @generated from field: string handler = 5;
   */
  handler: string;

  /**
   * @generated from field: string payload = 6;
   */
  payload: string;

  /**
   * @generated from field: bool is_active = 7;
   */
  isActive: boolean;
};

/**
 * Describes the message zdc.SaveScheduledJobRequest.
 * Use `create(SaveScheduledJobRequestSchema)` to create a new message.
 */
export const SaveScheduledJobRequestSchema: GenMessage<SaveScheduledJobRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1153);

/**
 * @generated from message zdc.DeleteScheduledJobRequest
 */
export type DeleteScheduledJobRequest = Message<"zdc.DeleteScheduledJobRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.DeleteScheduledJobRequest.
 * Use `create(DeleteScheduledJobRequestSchema)` to create a new message.
 */
export const DeleteScheduledJobRequestSchema: GenMessage<DeleteScheduledJobRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1154);

/**
 * @generated from message zdc.RunScheduledJobNowRequest
 */
export type RunScheduledJobNowRequest = Message<"zdc.RunScheduledJobNowRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.RunScheduledJobNowRequest.
 * Use `create(RunScheduledJobNowRequestSchema)` to create a new message.
 */
export const RunScheduledJobNowRequestSchema: GenMessage<RunScheduledJobNowRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1155);

/**
 * @generated from message zdc.ScheduledJobRun
 */
export type ScheduledJobRun = Message<"zdc.ScheduledJobRun"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string job_id = 2;
   */
  jobId: string;

  /**
   * @generated from field: string job_code = 3;
   */
  jobCode: string;

  /**
   * @generated from field: string started_at = 4;
   */
  startedAt: string;

  /**
   * @generated from field: string finished_at = 5;
   */
  finishedAt: string;

  /**
   * running|done|error|skipped
   *
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: string error = 7;
   */
  error: string;

  /**
   * JSON
   *
   * @generated from field: string result = 8;
   */
  result: string;

  /**
   * @generated from field: int32 duration_ms = 9;
   */
  durationMs: number;
};

/**
 * Describes the message zdc.ScheduledJobRun.
 * Use `create(ScheduledJobRunSchema)` to create a new message.
 */
export const ScheduledJobRunSchema: GenMessage<ScheduledJobRun> = /*@__PURE__*/
  messageDesc(file_zdc, 1156);

/**
 * @generated from message zdc.ListScheduledJobRunsRequest
 */
export type ListScheduledJobRunsRequest = Message<"zdc.ListScheduledJobRunsRequest"> & {
  /**
   * пусто = все задания
   *
   * @generated from field: string job_code = 1;
   */
  jobCode: string;

  /**
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;
};

/**
 * Describes the message zdc.ListScheduledJobRunsRequest.
 * Use `create(ListScheduledJobRunsRequestSchema)` to create a new message.
 */
export const ListScheduledJobRunsRequestSchema: GenMessage<ListScheduledJobRunsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1157);

/**
 * @generated from message zdc.ListScheduledJobRunsResponse
 */
export type ListScheduledJobRunsResponse = Message<"zdc.ListScheduledJobRunsResponse"> & {
  /**
   * @generated from field: repeated zdc.ScheduledJobRun items = 1;
   */
  items: ScheduledJobRun[];

  /**
   * @generated from field: int64 total_count = 2;
   */
  totalCount: bigint;
};

/**
 * Describes the message zdc.ListScheduledJobRunsResponse.
 * Use `create(ListScheduledJobRunsResponseSchema)` to create a new message.
 */
export const ListScheduledJobRunsResponseSchema: GenMessage<ListScheduledJobRunsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1158);

/**
 * @generated from message zdc.CreateRemoteGuestLinkRequest
 */
export type CreateRemoteGuestLinkRequest = Message<"zdc.CreateRemoteGuestLinkRequest"> & {
  /**
   * id сеанса (комната remote_{session_id})
   *
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * 5..1440; 0 = 60
   *
   * @generated from field: int32 ttl_minutes = 2;
   */
  ttlMinutes: number;
};

/**
 * Describes the message zdc.CreateRemoteGuestLinkRequest.
 * Use `create(CreateRemoteGuestLinkRequestSchema)` to create a new message.
 */
export const CreateRemoteGuestLinkRequestSchema: GenMessage<CreateRemoteGuestLinkRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1159);

/**
 * @generated from message zdc.CreateRemoteGuestLinkResponse
 */
export type CreateRemoteGuestLinkResponse = Message<"zdc.CreateRemoteGuestLinkResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * RFC3339
   *
   * @generated from field: string expires_at = 2;
   */
  expiresAt: string;
};

/**
 * Describes the message zdc.CreateRemoteGuestLinkResponse.
 * Use `create(CreateRemoteGuestLinkResponseSchema)` to create a new message.
 */
export const CreateRemoteGuestLinkResponseSchema: GenMessage<CreateRemoteGuestLinkResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1160);

/**
 * @generated from message zdc.ResolveRemoteGuestLinkRequest
 */
export type ResolveRemoteGuestLinkRequest = Message<"zdc.ResolveRemoteGuestLinkRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message zdc.ResolveRemoteGuestLinkRequest.
 * Use `create(ResolveRemoteGuestLinkRequestSchema)` to create a new message.
 */
export const ResolveRemoteGuestLinkRequestSchema: GenMessage<ResolveRemoteGuestLinkRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1161);

/**
 * @generated from message zdc.ResolveRemoteGuestLinkResponse
 */
export type ResolveRemoteGuestLinkResponse = Message<"zdc.ResolveRemoteGuestLinkResponse"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * remote_{session_id}
   *
   * @generated from field: string room = 2;
   */
  room: string;

  /**
   * LiveKit URL
   *
   * @generated from field: string url = 3;
   */
  url: string;

  /**
   * LiveKit access token (гость)
   *
   * @generated from field: string token = 4;
   */
  token: string;

  /**
   * @generated from field: string expires_at = 5;
   */
  expiresAt: string;
};

/**
 * Describes the message zdc.ResolveRemoteGuestLinkResponse.
 * Use `create(ResolveRemoteGuestLinkResponseSchema)` to create a new message.
 */
export const ResolveRemoteGuestLinkResponseSchema: GenMessage<ResolveRemoteGuestLinkResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1162);

/**
 * СЕССИЯ как объект платформы (Ф4): история/аудит/«мои сеансы», основа
 * биллинга quality-minutes. Гость (аноним) — viewer_id пуст.
 *
 * @generated from message zdc.RemoteSessionInfo
 */
export type RemoteSessionInfo = Message<"zdc.RemoteSessionInfo"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string room = 2;
   */
  room: string;

  /**
   * app|chat|guest
   *
   * @generated from field: string source = 3;
   */
  source: string;

  /**
   * @generated from field: string host_id = 4;
   */
  hostId: string;

  /**
   * @generated from field: string host_name = 5;
   */
  hostName: string;

  /**
   * @generated from field: string viewer_id = 6;
   */
  viewerId: string;

  /**
   * @generated from field: string viewer_name = 7;
   */
  viewerName: string;

  /**
   * active|ended
   *
   * @generated from field: string status = 8;
   */
  status: string;

  /**
   * @generated from field: string started_at = 9;
   */
  startedAt: string;

  /**
   * @generated from field: string ended_at = 10;
   */
  endedAt: string;

  /**
   * @generated from field: int32 duration_sec = 11;
   */
  durationSec: number;

  /**
   * JSON последней телеметрии
   *
   * @generated from field: string quality = 12;
   */
  quality: string;
};

/**
 * Describes the message zdc.RemoteSessionInfo.
 * Use `create(RemoteSessionInfoSchema)` to create a new message.
 */
export const RemoteSessionInfoSchema: GenMessage<RemoteSessionInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 1163);

/**
 * @generated from message zdc.StartRemoteSessionRequest
 */
export type StartRemoteSessionRequest = Message<"zdc.StartRemoteSessionRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * host|viewer
   *
   * @generated from field: string role = 2;
   */
  role: string;

  /**
   * remote_{session_id}
   *
   * @generated from field: string room = 3;
   */
  room: string;

  /**
   * app|chat|guest
   *
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * имя текущей стороны (профиль может быть пуст)
   *
   * @generated from field: string my_name = 5;
   */
  myName: string;

  /**
   * вторая сторона (если известна)
   *
   * @generated from field: string peer_id = 6;
   */
  peerId: string;

  /**
   * @generated from field: string peer_name = 7;
   */
  peerName: string;
};

/**
 * Describes the message zdc.StartRemoteSessionRequest.
 * Use `create(StartRemoteSessionRequestSchema)` to create a new message.
 */
export const StartRemoteSessionRequestSchema: GenMessage<StartRemoteSessionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1164);

/**
 * @generated from message zdc.EndRemoteSessionRequest
 */
export type EndRemoteSessionRequest = Message<"zdc.EndRemoteSessionRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: int32 duration_sec = 2;
   */
  durationSec: number;

  /**
   * JSON телеметрии (RTT/fps/битрейт)
   *
   * @generated from field: string quality = 3;
   */
  quality: string;
};

/**
 * Describes the message zdc.EndRemoteSessionRequest.
 * Use `create(EndRemoteSessionRequestSchema)` to create a new message.
 */
export const EndRemoteSessionRequestSchema: GenMessage<EndRemoteSessionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1165);

/**
 * @generated from message zdc.ListRemoteSessionsRequest
 */
export type ListRemoteSessionsRequest = Message<"zdc.ListRemoteSessionsRequest"> & {
  /**
   * @generated from field: int32 limit = 1;
   */
  limit: number;
};

/**
 * Describes the message zdc.ListRemoteSessionsRequest.
 * Use `create(ListRemoteSessionsRequestSchema)` to create a new message.
 */
export const ListRemoteSessionsRequestSchema: GenMessage<ListRemoteSessionsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1166);

/**
 * @generated from message zdc.ListRemoteSessionsResponse
 */
export type ListRemoteSessionsResponse = Message<"zdc.ListRemoteSessionsResponse"> & {
  /**
   * @generated from field: repeated zdc.RemoteSessionInfo items = 1;
   */
  items: RemoteSessionInfo[];
};

/**
 * Describes the message zdc.ListRemoteSessionsResponse.
 * Use `create(ListRemoteSessionsResponseSchema)` to create a new message.
 */
export const ListRemoteSessionsResponseSchema: GenMessage<ListRemoteSessionsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1167);

/**
 * ============================================================================
 * КОНТРАКТНЫЙ ЭНДПОИНТ СЕАНСА (наш wire-контракт v2, WebSocket): хост
 * РЕГИСТРИРУЕТ адрес своего сервера на ПЛАТФОРМЕ (SSoT — сервер), зритель
 * РЕЗОЛВИТ его по session_id — ручной ввод адреса НЕ нужен. Шина
 * `remote.session.endpoint.{id}` остаётся сигналом обнаружения сеанса.
 * ============================================================================
 *
 * @generated from message zdc.RegisterRemoteEndpointRequest
 */
export type RegisterRemoteEndpointRequest = Message<"zdc.RegisterRemoteEndpointRequest"> & {
  /**
   * id сеанса
   *
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * ws://<ip>:<port>/remote?token=… | wss://…
   *
   * @generated from field: string endpoint_url = 2;
   */
  endpointUrl: string;

  /**
   * 'contract' (пусто = contract)
   *
   * @generated from field: string transport = 3;
   */
  transport: string;
};

/**
 * Describes the message zdc.RegisterRemoteEndpointRequest.
 * Use `create(RegisterRemoteEndpointRequestSchema)` to create a new message.
 */
export const RegisterRemoteEndpointRequestSchema: GenMessage<RegisterRemoteEndpointRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1168);

/**
 * @generated from message zdc.RemoteEndpointInfo
 */
export type RemoteEndpointInfo = Message<"zdc.RemoteEndpointInfo"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string endpoint_url = 2;
   */
  endpointUrl: string;

  /**
   * @generated from field: string transport = 3;
   */
  transport: string;

  /**
   * RFC3339
   *
   * @generated from field: string registered_at = 4;
   */
  registeredAt: string;

  /**
   * id пользователя-хоста
   *
   * @generated from field: string registered_by = 5;
   */
  registeredBy: string;
};

/**
 * Describes the message zdc.RemoteEndpointInfo.
 * Use `create(RemoteEndpointInfoSchema)` to create a new message.
 */
export const RemoteEndpointInfoSchema: GenMessage<RemoteEndpointInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 1169);

/**
 * @generated from message zdc.GetRemoteEndpointRequest
 */
export type GetRemoteEndpointRequest = Message<"zdc.GetRemoteEndpointRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message zdc.GetRemoteEndpointRequest.
 * Use `create(GetRemoteEndpointRequestSchema)` to create a new message.
 */
export const GetRemoteEndpointRequestSchema: GenMessage<GetRemoteEndpointRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1170);

/**
 * ============================================================================
 * РЕЛЕЙ ЗА NAT (наш wire-контракт v2, WebSocket): хост и зритель соединяются
 * ИСХОДЯЩИМИ к серверу; сервер сводит пару по session_id и пересылает кадры
 * как есть (протокол кадров не разбирается). Входящие порты не нужны.
 * Каждая сторона получает СВОЙ короткоживущий токен по роли (TTL ~10 мин,
 * в БД — только sha256-хэш); подключение — к адресу relay_url с параметрами
 * role=host|viewer&token=… (эндпоинт /remote/relay/{session_id}).
 * ============================================================================
 *
 * @generated from message zdc.IssueRelayTokenRequest
 */
export type IssueRelayTokenRequest = Message<"zdc.IssueRelayTokenRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * host|viewer
   *
   * @generated from field: string role = 2;
   */
  role: string;
};

/**
 * Describes the message zdc.IssueRelayTokenRequest.
 * Use `create(IssueRelayTokenRequestSchema)` to create a new message.
 */
export const IssueRelayTokenRequestSchema: GenMessage<IssueRelayTokenRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1171);

/**
 * @generated from message zdc.IssueRelayTokenResponse
 */
export type IssueRelayTokenResponse = Message<"zdc.IssueRelayTokenResponse"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string role = 2;
   */
  role: string;

  /**
   * одноразовый короткоживущий токен релея
   *
   * @generated from field: string token = 3;
   */
  token: string;

  /**
   * ws(s)://<сервер>/remote/relay/{session_id}
   *
   * @generated from field: string relay_url = 4;
   */
  relayUrl: string;

  /**
   * RFC3339
   *
   * @generated from field: string expires_at = 5;
   */
  expiresAt: string;
};

/**
 * Describes the message zdc.IssueRelayTokenResponse.
 * Use `create(IssueRelayTokenResponseSchema)` to create a new message.
 */
export const IssueRelayTokenResponseSchema: GenMessage<IssueRelayTokenResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1172);

/**
 * ============================================================================
 * ПАРОЛЬ УДАЛЁННОГО ДОСТУПА (unattended, как AnyDesk): хост заранее задаёт
 * пароль — viewer подключается БЕЗ подтверждения на хосте. Политика
 * (mode: consent|password + unattended_enabled) хранится ПО УРОВНЯМ:
 * устройство → пользователь-хост → база (детерминированный резолв; SSoT —
 * сервер). Пароль хранится ТОЛЬКО bcrypt-хэшем и НИКОГДА не возвращается.
 * Честная оговорка: на Windows-хосте (наш движок) unattended работает
 * полноценно; на Android захват экрана требует согласия на сессию
 * (без MDM/Device Owner «без согласия» невозможно) — docs/platform/remote-access.md.
 * ============================================================================
 *
 * @generated from message zdc.RemoteAccessSettings
 */
export type RemoteAccessSettings = Message<"zdc.RemoteAccessSettings"> & {
  /**
   * user|device|base — фактическая запись уровня
   *
   * @generated from field: string scope_type = 1;
   */
  scopeType: string;

  /**
   * id пользователя/устройства ('' для base)
   *
   * @generated from field: string scope_id = 2;
   */
  scopeId: string;

  /**
   * consent|password
   *
   * @generated from field: string mode = 3;
   */
  mode: string;

  /**
   * включён вход по паролю
   *
   * @generated from field: bool unattended_enabled = 4;
   */
  unattendedEnabled: boolean;

  /**
   * пароль задан (хэш непуст)
   *
   * @generated from field: bool password_set = 5;
   */
  passwordSet: boolean;

  /**
   * consent|password с учётом наследования
   *
   * @generated from field: string effective_mode = 6;
   */
  effectiveMode: string;

  /**
   * user|device|base|none — ИСТОЧНИК политики
   *
   * @generated from field: string source_scope_type = 7;
   */
  sourceScopeType: string;

  /**
   * @generated from field: string updated_at = 8;
   */
  updatedAt: string;

  /**
   * @generated from field: string updated_by = 9;
   */
  updatedBy: string;
};

/**
 * Describes the message zdc.RemoteAccessSettings.
 * Use `create(RemoteAccessSettingsSchema)` to create a new message.
 */
export const RemoteAccessSettingsSchema: GenMessage<RemoteAccessSettings> = /*@__PURE__*/
  messageDesc(file_zdc, 1173);

/**
 * @generated from message zdc.GetRemoteAccessSettingsRequest
 */
export type GetRemoteAccessSettingsRequest = Message<"zdc.GetRemoteAccessSettingsRequest"> & {
  /**
   * пусто = я; иначе требуется remote_manage/админ
   *
   * @generated from field: string host_id = 1;
   */
  hostId: string;

  /**
   * конкретное устройство-хост (пусто = пользователь/база)
   *
   * @generated from field: string device_id = 2;
   */
  deviceId: string;

  /**
   * пусто = ЭФФЕКТИВНАЯ политика (device→user→base); иначе уровень
   *
   * @generated from field: string scope_type = 3;
   */
  scopeType: string;
};

/**
 * Describes the message zdc.GetRemoteAccessSettingsRequest.
 * Use `create(GetRemoteAccessSettingsRequestSchema)` to create a new message.
 */
export const GetRemoteAccessSettingsRequestSchema: GenMessage<GetRemoteAccessSettingsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1174);

/**
 * @generated from message zdc.SetRemoteAccessPasswordRequest
 */
export type SetRemoteAccessPasswordRequest = Message<"zdc.SetRemoteAccessPasswordRequest"> & {
  /**
   * пусто = я
   *
   * @generated from field: string host_id = 1;
   */
  hostId: string;

  /**
   * @generated from field: string device_id = 2;
   */
  deviceId: string;

  /**
   * consent|password (пусто = сохранить текущий)
   *
   * @generated from field: string mode = 3;
   */
  mode: string;

  /**
   * @generated from field: bool unattended_enabled = 4;
   */
  unattendedEnabled: boolean;

  /**
   * НОВЫЙ пароль (пусто = не менять; минимум 4 символа)
   *
   * @generated from field: string password = 5;
   */
  password: string;

  /**
   * стереть пароль (несовместимо с password)
   *
   * @generated from field: bool clear_password = 6;
   */
  clearPassword: boolean;

  /**
   * '' = user (host_id/себя) | device | base (remote_manage)
   *
   * @generated from field: string scope_type = 7;
   */
  scopeType: string;
};

/**
 * Describes the message zdc.SetRemoteAccessPasswordRequest.
 * Use `create(SetRemoteAccessPasswordRequestSchema)` to create a new message.
 */
export const SetRemoteAccessPasswordRequestSchema: GenMessage<SetRemoteAccessPasswordRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1175);

/**
 * @generated from message zdc.RevokeRemoteAccessRequest
 */
export type RevokeRemoteAccessRequest = Message<"zdc.RevokeRemoteAccessRequest"> & {
  /**
   * пусто = я
   *
   * @generated from field: string host_id = 1;
   */
  hostId: string;

  /**
   * @generated from field: string device_id = 2;
   */
  deviceId: string;

  /**
   * '' = user | device | base
   *
   * @generated from field: string scope_type = 3;
   */
  scopeType: string;
};

/**
 * Describes the message zdc.RevokeRemoteAccessRequest.
 * Use `create(RevokeRemoteAccessRequestSchema)` to create a new message.
 */
export const RevokeRemoteAccessRequestSchema: GenMessage<RevokeRemoteAccessRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1176);

/**
 * @generated from message zdc.StartRemoteSessionByPasswordRequest
 */
export type StartRemoteSessionByPasswordRequest = Message<"zdc.StartRemoteSessionByPasswordRequest"> & {
  /**
   * пользователь-хост
   *
   * @generated from field: string host_id = 1;
   */
  hostId: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * имя viewer (профиль может быть пуст)
   *
   * @generated from field: string my_name = 3;
   */
  myName: string;

  /**
   * app|chat|guest
   *
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * конкретное устройство-хост (иначе user→base)
   *
   * @generated from field: string device_id = 5;
   */
  deviceId: string;
};

/**
 * Describes the message zdc.StartRemoteSessionByPasswordRequest.
 * Use `create(StartRemoteSessionByPasswordRequestSchema)` to create a new message.
 */
export const StartRemoteSessionByPasswordRequestSchema: GenMessage<StartRemoteSessionByPasswordRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1177);

/**
 * @generated from message zdc.StartRemoteSessionByPasswordResponse
 */
export type StartRemoteSessionByPasswordResponse = Message<"zdc.StartRemoteSessionByPasswordResponse"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * remote_{session_id}
   *
   * @generated from field: string room = 2;
   */
  room: string;

  /**
   * LiveKit URL (пусто — LiveKit не настроен: контракт-транспорт)
   *
   * @generated from field: string url = 3;
   */
  url: string;

  /**
   * LiveKit access token (пусто — см. url)
   *
   * @generated from field: string token = 4;
   */
  token: string;
};

/**
 * Describes the message zdc.StartRemoteSessionByPasswordResponse.
 * Use `create(StartRemoteSessionByPasswordResponseSchema)` to create a new message.
 */
export const StartRemoteSessionByPasswordResponseSchema: GenMessage<StartRemoteSessionByPasswordResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1178);

/**
 * ============================================================================
 * ПЛАТЕЖИ — универсальный слой ПРИЁМА ДЕНЕГ (провайдер-агностичный):
 * сайты/приложения/игры/бизнес. Провайдеры: mock (тест без вложений),
 * manual (счёт/перевод), yookassa (карты/СБП/чеки) и любые из реестра.
 * ============================================================================
 *
 * @generated from message zdc.PaymentSettingsField
 */
export type PaymentSettingsField = Message<"zdc.PaymentSettingsField"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: bool required = 4;
   */
  required: boolean;

  /**
   * @generated from field: bool secret = 5;
   */
  secret: boolean;

  /**
   * @generated from field: string hint = 6;
   */
  hint: string;

  /**
   * @generated from field: string default_value = 7;
   */
  defaultValue: string;
};

/**
 * Describes the message zdc.PaymentSettingsField.
 * Use `create(PaymentSettingsFieldSchema)` to create a new message.
 */
export const PaymentSettingsFieldSchema: GenMessage<PaymentSettingsField> = /*@__PURE__*/
  messageDesc(file_zdc, 1179);

/**
 * @generated from message zdc.PaymentProviderInfo
 */
export type PaymentProviderInfo = Message<"zdc.PaymentProviderInfo"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;

  /**
   * @generated from field: int32 priority = 4;
   */
  priority: number;

  /**
   * @generated from field: repeated string capabilities = 5;
   */
  capabilities: string[];

  /**
   * @generated from field: repeated zdc.PaymentSettingsField schema = 6;
   */
  schema: PaymentSettingsField[];

  /**
   * @generated from field: map<string, string> settings = 7;
   */
  settings: { [key: string]: string };
};

/**
 * Describes the message zdc.PaymentProviderInfo.
 * Use `create(PaymentProviderInfoSchema)` to create a new message.
 */
export const PaymentProviderInfoSchema: GenMessage<PaymentProviderInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 1180);

/**
 * @generated from message zdc.PaymentIntent
 */
export type PaymentIntent = Message<"zdc.PaymentIntent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string provider = 2;
   */
  provider: string;

  /**
   * @generated from field: string account_id = 3;
   */
  accountId: string;

  /**
   * @generated from field: string user_id = 4;
   */
  userId: string;

  /**
   * @generated from field: int64 amount = 5;
   */
  amount: bigint;

  /**
   * @generated from field: string currency = 6;
   */
  currency: string;

  /**
   * @generated from field: string status = 7;
   */
  status: string;

  /**
   * @generated from field: string purpose = 8;
   */
  purpose: string;

  /**
   * @generated from field: string client_ref = 9;
   */
  clientRef: string;

  /**
   * @generated from field: string external_id = 10;
   */
  externalId: string;

  /**
   * @generated from field: string confirmation_url = 11;
   */
  confirmationUrl: string;

  /**
   * @generated from field: string created_at = 12;
   */
  createdAt: string;

  /**
   * @generated from field: string paid_at = 13;
   */
  paidAt: string;
};

/**
 * Describes the message zdc.PaymentIntent.
 * Use `create(PaymentIntentSchema)` to create a new message.
 */
export const PaymentIntentSchema: GenMessage<PaymentIntent> = /*@__PURE__*/
  messageDesc(file_zdc, 1181);

/**
 * @generated from message zdc.ListPaymentProvidersRequest
 */
export type ListPaymentProvidersRequest = Message<"zdc.ListPaymentProvidersRequest"> & {
};

/**
 * Describes the message zdc.ListPaymentProvidersRequest.
 * Use `create(ListPaymentProvidersRequestSchema)` to create a new message.
 */
export const ListPaymentProvidersRequestSchema: GenMessage<ListPaymentProvidersRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1182);

/**
 * @generated from message zdc.ListPaymentProvidersResponse
 */
export type ListPaymentProvidersResponse = Message<"zdc.ListPaymentProvidersResponse"> & {
  /**
   * @generated from field: repeated zdc.PaymentProviderInfo items = 1;
   */
  items: PaymentProviderInfo[];
};

/**
 * Describes the message zdc.ListPaymentProvidersResponse.
 * Use `create(ListPaymentProvidersResponseSchema)` to create a new message.
 */
export const ListPaymentProvidersResponseSchema: GenMessage<ListPaymentProvidersResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1183);

/**
 * @generated from message zdc.SavePaymentProviderRequest
 */
export type SavePaymentProviderRequest = Message<"zdc.SavePaymentProviderRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * @generated from field: map<string, string> settings = 3;
   */
  settings: { [key: string]: string };
};

/**
 * Describes the message zdc.SavePaymentProviderRequest.
 * Use `create(SavePaymentProviderRequestSchema)` to create a new message.
 */
export const SavePaymentProviderRequestSchema: GenMessage<SavePaymentProviderRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1184);

/**
 * @generated from message zdc.CreatePaymentRequest
 */
export type CreatePaymentRequest = Message<"zdc.CreatePaymentRequest"> & {
  /**
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * @generated from field: string account_id = 2;
   */
  accountId: string;

  /**
   * @generated from field: int64 amount = 3;
   */
  amount: bigint;

  /**
   * @generated from field: string currency = 4;
   */
  currency: string;

  /**
   * @generated from field: string purpose = 5;
   */
  purpose: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: string client_ref = 7;
   */
  clientRef: string;

  /**
   * @generated from field: string return_url = 8;
   */
  returnUrl: string;
};

/**
 * Describes the message zdc.CreatePaymentRequest.
 * Use `create(CreatePaymentRequestSchema)` to create a new message.
 */
export const CreatePaymentRequestSchema: GenMessage<CreatePaymentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1185);

/**
 * @generated from message zdc.GetPaymentRequest
 */
export type GetPaymentRequest = Message<"zdc.GetPaymentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetPaymentRequest.
 * Use `create(GetPaymentRequestSchema)` to create a new message.
 */
export const GetPaymentRequestSchema: GenMessage<GetPaymentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1186);

/**
 * @generated from message zdc.ListPaymentsRequest
 */
export type ListPaymentsRequest = Message<"zdc.ListPaymentsRequest"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message zdc.ListPaymentsRequest.
 * Use `create(ListPaymentsRequestSchema)` to create a new message.
 */
export const ListPaymentsRequestSchema: GenMessage<ListPaymentsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1187);

/**
 * @generated from message zdc.ListPaymentsResponse
 */
export type ListPaymentsResponse = Message<"zdc.ListPaymentsResponse"> & {
  /**
   * @generated from field: repeated zdc.PaymentIntent items = 1;
   */
  items: PaymentIntent[];
};

/**
 * Describes the message zdc.ListPaymentsResponse.
 * Use `create(ListPaymentsResponseSchema)` to create a new message.
 */
export const ListPaymentsResponseSchema: GenMessage<ListPaymentsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1188);

/**
 * @generated from message zdc.RefundPaymentRequest
 */
export type RefundPaymentRequest = Message<"zdc.RefundPaymentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 amount = 2;
   */
  amount: bigint;
};

/**
 * Describes the message zdc.RefundPaymentRequest.
 * Use `create(RefundPaymentRequestSchema)` to create a new message.
 */
export const RefundPaymentRequestSchema: GenMessage<RefundPaymentRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1189);

/**
 * ============================================================================
 * САЙТЫ: записи для публичного рендера (SSoT — сервер резолвит таблицу, схему,
 * поля и права «Гостя»; клиент только рендерит). Движок рендера — см.
 * plans/plan-render-engine.md.
 * ============================================================================
 *
 * @generated from message zdc.SiteRecordFilter
 */
export type SiteRecordFilter = Message<"zdc.SiteRecordFilter"> & {
  /**
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * @generated from field: string condition = 2;
   */
  condition: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * Describes the message zdc.SiteRecordFilter.
 * Use `create(SiteRecordFilterSchema)` to create a new message.
 */
export const SiteRecordFilterSchema: GenMessage<SiteRecordFilter> = /*@__PURE__*/
  messageDesc(file_zdc, 1190);

/**
 * @generated from message zdc.ListSiteRecordsRequest
 */
export type ListSiteRecordsRequest = Message<"zdc.ListSiteRecordsRequest"> & {
  /**
   * @generated from field: string site = 1;
   */
  site: string;

  /**
   * catalog | document | register | task_type | order_type
   *
   * @generated from field: string object_type = 2;
   */
  objectType: string;

  /**
   * @generated from field: string object_code = 3;
   */
  objectCode: string;

  /**
   * @generated from field: repeated zdc.SiteRecordFilter filters = 4;
   */
  filters: SiteRecordFilter[];

  /**
   * @generated from field: int32 page = 5;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 6;
   */
  pageSize: number;

  /**
   * column_name
   *
   * @generated from field: string sort = 7;
   */
  sort: string;

  /**
   * @generated from field: bool sort_desc = 8;
   */
  sortDesc: boolean;
};

/**
 * Describes the message zdc.ListSiteRecordsRequest.
 * Use `create(ListSiteRecordsRequestSchema)` to create a new message.
 */
export const ListSiteRecordsRequestSchema: GenMessage<ListSiteRecordsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1191);

/**
 * @generated from message zdc.SiteRecordField
 */
export type SiteRecordField = Message<"zdc.SiteRecordField"> & {
  /**
   * @generated from field: string column = 1;
   */
  column: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string data_type = 4;
   */
  dataType: string;

  /**
   * @generated from field: string format = 5;
   */
  format: string;

  /**
   * @generated from field: bool is_ref = 6;
   */
  isRef: boolean;

  /**
   * @generated from field: string ref_table = 7;
   */
  refTable: string;
};

/**
 * Describes the message zdc.SiteRecordField.
 * Use `create(SiteRecordFieldSchema)` to create a new message.
 */
export const SiteRecordFieldSchema: GenMessage<SiteRecordField> = /*@__PURE__*/
  messageDesc(file_zdc, 1192);

/**
 * @generated from message zdc.SiteRecord
 */
export type SiteRecord = Message<"zdc.SiteRecord"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * column -> значение (строкой)
   *
   * @generated from field: map<string, string> values = 2;
   */
  values: { [key: string]: string };

  /**
   * column -> представление ссылки/перечисления
   *
   * @generated from field: map<string, string> presentations = 3;
   */
  presentations: { [key: string]: string };
};

/**
 * Describes the message zdc.SiteRecord.
 * Use `create(SiteRecordSchema)` to create a new message.
 */
export const SiteRecordSchema: GenMessage<SiteRecord> = /*@__PURE__*/
  messageDesc(file_zdc, 1193);

/**
 * @generated from message zdc.ListSiteRecordsResponse
 */
export type ListSiteRecordsResponse = Message<"zdc.ListSiteRecordsResponse"> & {
  /**
   * @generated from field: repeated zdc.SiteRecordField fields = 1;
   */
  fields: SiteRecordField[];

  /**
   * @generated from field: repeated zdc.SiteRecord records = 2;
   */
  records: SiteRecord[];

  /**
   * @generated from field: int32 total = 3;
   */
  total: number;
};

/**
 * Describes the message zdc.ListSiteRecordsResponse.
 * Use `create(ListSiteRecordsResponseSchema)` to create a new message.
 */
export const ListSiteRecordsResponseSchema: GenMessage<ListSiteRecordsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1194);

/**
 * ============================================================================
 * ОБЛАСТИ АССЕТОВ (core|site:…|app:…|game:…|package:…): у каждого сайта/
 * приложения/игры — свои ассеты, общие (core) — переиспользуются (резолв
 * specific→core, internal/assets). См. plans/plan-scopes-assets-design.md.
 * ============================================================================
 *
 * @generated from message zdc.AssetInfo
 */
export type AssetInfo = Message<"zdc.AssetInfo"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string scope = 2;
   */
  scope: string;

  /**
   * @generated from field: string library = 3;
   */
  library: string;

  /**
   * @generated from field: string file_id = 4;
   */
  fileId: string;
};

/**
 * Describes the message zdc.AssetInfo.
 * Use `create(AssetInfoSchema)` to create a new message.
 */
export const AssetInfoSchema: GenMessage<AssetInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 1195);

/**
 * @generated from message zdc.ListAssetsRequest
 */
export type ListAssetsRequest = Message<"zdc.ListAssetsRequest"> & {
  /**
   * @generated from field: string scope = 1;
   */
  scope: string;
};

/**
 * Describes the message zdc.ListAssetsRequest.
 * Use `create(ListAssetsRequestSchema)` to create a new message.
 */
export const ListAssetsRequestSchema: GenMessage<ListAssetsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1196);

/**
 * @generated from message zdc.ListAssetsResponse
 */
export type ListAssetsResponse = Message<"zdc.ListAssetsResponse"> & {
  /**
   * @generated from field: repeated zdc.AssetInfo items = 1;
   */
  items: AssetInfo[];
};

/**
 * Describes the message zdc.ListAssetsResponse.
 * Use `create(ListAssetsResponseSchema)` to create a new message.
 */
export const ListAssetsResponseSchema: GenMessage<ListAssetsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1197);

/**
 * @generated from message zdc.SaveAssetRequest
 */
export type SaveAssetRequest = Message<"zdc.SaveAssetRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string scope = 2;
   */
  scope: string;

  /**
   * @generated from field: string library = 3;
   */
  library: string;

  /**
   * @generated from field: string file_id = 4;
   */
  fileId: string;
};

/**
 * Describes the message zdc.SaveAssetRequest.
 * Use `create(SaveAssetRequestSchema)` to create a new message.
 */
export const SaveAssetRequestSchema: GenMessage<SaveAssetRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1198);

/**
 * @generated from message zdc.DeleteAssetRequest
 */
export type DeleteAssetRequest = Message<"zdc.DeleteAssetRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string scope = 2;
   */
  scope: string;
};

/**
 * Describes the message zdc.DeleteAssetRequest.
 * Use `create(DeleteAssetRequestSchema)` to create a new message.
 */
export const DeleteAssetRequestSchema: GenMessage<DeleteAssetRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1199);

/**
 * @generated from message zdc.ResolveAssetRequest
 */
export type ResolveAssetRequest = Message<"zdc.ResolveAssetRequest"> & {
  /**
   * @generated from field: string site = 1;
   */
  site: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message zdc.ResolveAssetRequest.
 * Use `create(ResolveAssetRequestSchema)` to create a new message.
 */
export const ResolveAssetRequestSchema: GenMessage<ResolveAssetRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1200);

/**
 * @generated from message zdc.ResolveAssetResponse
 */
export type ResolveAssetResponse = Message<"zdc.ResolveAssetResponse"> & {
  /**
   * @generated from field: bool found = 1;
   */
  found: boolean;

  /**
   * @generated from field: string file_id = 2;
   */
  fileId: string;

  /**
   * @generated from field: string scope = 3;
   */
  scope: string;
};

/**
 * Describes the message zdc.ResolveAssetResponse.
 * Use `create(ResolveAssetResponseSchema)` to create a new message.
 */
export const ResolveAssetResponseSchema: GenMessage<ResolveAssetResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1201);

/**
 * ============================================================================
 * HydraID — глобальный номер человека `AAA BBB CCC D` (MVP, локально).
 * Verhoeff-контроль; выдача — internal/hydraid (SSoT, номер не меняется).
 * Резолв минимален: имя/аватар/локальный пользователь (приватность).
 * ============================================================================
 *
 * @generated from message zdc.HydraIdCard
 */
export type HydraIdCard = Message<"zdc.HydraIdCard"> & {
  /**
   * канонические 10 цифр
   *
   * @generated from field: string number = 1;
   */
  number: string;

  /**
   * человекочитаемый вид "AAA BBB CCC D"
   *
   * @generated from field: string display = 2;
   */
  display: string;

  /**
   * локальный пользователь базы
   *
   * @generated from field: string entity_id = 3;
   */
  entityId: string;

  /**
   * @generated from field: string login = 4;
   */
  login: string;

  /**
   * @generated from field: string name = 5;
   */
  name: string;

  /**
   * id файла аватара
   *
   * @generated from field: string avatar_url = 6;
   */
  avatarUrl: string;

  /**
   * subject_type — тип субъекта номера (волна 1a §4.9): person | bot | persona.
   * Боты (9xx) и личности (8xx) РЕЗОЛВЯТСЯ по номеру — интерфейс показывает
   * бейдж «бот»/«личность», чтобы номер бота не принимали за человека.
   *
   * @generated from field: string subject_type = 7;
   */
  subjectType: string;

  /**
   * remote — номер принадлежит ДРУГОЙ базе (найден в адресной книге сети):
   * локальных данных (entity_id/login/name/avatar_url) в карточке нет.
   *
   * @generated from field: bool remote = 8;
   */
  remote: boolean;

  /**
   * base_slug — домашний узел (slug) базы-владельца номера; только для remote
   * (имя базы — не персональные данные).
   *
   * @generated from field: string base_slug = 9;
   */
  baseSlug: string;
};

/**
 * Describes the message zdc.HydraIdCard.
 * Use `create(HydraIdCardSchema)` to create a new message.
 */
export const HydraIdCardSchema: GenMessage<HydraIdCard> = /*@__PURE__*/
  messageDesc(file_zdc, 1202);

/**
 * @generated from message zdc.GetMyHydraIdRequest
 */
export type GetMyHydraIdRequest = Message<"zdc.GetMyHydraIdRequest"> & {
};

/**
 * Describes the message zdc.GetMyHydraIdRequest.
 * Use `create(GetMyHydraIdRequestSchema)` to create a new message.
 */
export const GetMyHydraIdRequestSchema: GenMessage<GetMyHydraIdRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1203);

/**
 * @generated from message zdc.GetMyHydraIdResponse
 */
export type GetMyHydraIdResponse = Message<"zdc.GetMyHydraIdResponse"> & {
  /**
   * @generated from field: zdc.HydraIdCard card = 1;
   */
  card?: HydraIdCard | undefined;

  /**
   * QR на `hydra:<номер>` (PNG base64, сервер)
   *
   * @generated from field: string qr_png_base64 = 2;
   */
  qrPngBase64: string;
};

/**
 * Describes the message zdc.GetMyHydraIdResponse.
 * Use `create(GetMyHydraIdResponseSchema)` to create a new message.
 */
export const GetMyHydraIdResponseSchema: GenMessage<GetMyHydraIdResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1204);

/**
 * @generated from message zdc.ResolveHydraIdRequest
 */
export type ResolveHydraIdRequest = Message<"zdc.ResolveHydraIdRequest"> & {
  /**
   * @generated from field: string number = 1;
   */
  number: string;
};

/**
 * Describes the message zdc.ResolveHydraIdRequest.
 * Use `create(ResolveHydraIdRequestSchema)` to create a new message.
 */
export const ResolveHydraIdRequestSchema: GenMessage<ResolveHydraIdRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1205);

/**
 * @generated from message zdc.ResolveHydraIdResponse
 */
export type ResolveHydraIdResponse = Message<"zdc.ResolveHydraIdResponse"> & {
  /**
   * @generated from field: zdc.HydraIdCard card = 1;
   */
  card?: HydraIdCard | undefined;
};

/**
 * Describes the message zdc.ResolveHydraIdResponse.
 * Use `create(ResolveHydraIdResponseSchema)` to create a new message.
 */
export const ResolveHydraIdResponseSchema: GenMessage<ResolveHydraIdResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1206);

/**
 * @generated from message zdc.SearchHydraIdRequest
 */
export type SearchHydraIdRequest = Message<"zdc.SearchHydraIdRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;
};

/**
 * Describes the message zdc.SearchHydraIdRequest.
 * Use `create(SearchHydraIdRequestSchema)` to create a new message.
 */
export const SearchHydraIdRequestSchema: GenMessage<SearchHydraIdRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1207);

/**
 * @generated from message zdc.SearchHydraIdResponse
 */
export type SearchHydraIdResponse = Message<"zdc.SearchHydraIdResponse"> & {
  /**
   * @generated from field: repeated zdc.HydraIdCard items = 1;
   */
  items: HydraIdCard[];
};

/**
 * Describes the message zdc.SearchHydraIdResponse.
 * Use `create(SearchHydraIdResponseSchema)` to create a new message.
 */
export const SearchHydraIdResponseSchema: GenMessage<SearchHydraIdResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1208);

/**
 * ============================================================================
 * УСТРОЙСТВА HydraID — DeviceID = `{HydraID}:{Index}` (реестр `devices`).
 * SSoT — сервер: энролл идемпотентен (pubkey+kind+os+name), индекс человека
 * монотонный; отзыв — необратимый статус. Устройство принадлежит человеку
 * (по локальному пользователю базы), номер человека не меняется.
 * ============================================================================
 *
 * @generated from message zdc.Device
 */
export type Device = Message<"zdc.Device"> & {
  /**
   * `{HydraID}:{Index}`
   *
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * номер человека (10 цифр)
   *
   * @generated from field: string hydra_id = 2;
   */
  hydraId: string;

  /**
   * локальный пользователь базы
   *
   * @generated from field: string owner_id = 3;
   */
  ownerId: string;

  /**
   * монотонный индекс устройства человека
   *
   * @generated from field: int32 index = 4;
   */
  index: number;

  /**
   * desktop|mobile|web|iot|server
   *
   * @generated from field: string kind = 5;
   */
  kind: string;

  /**
   * @generated from field: string os = 6;
   */
  os: string;

  /**
   * @generated from field: string name = 7;
   */
  name: string;

  /**
   * открытый ключ устройства (Ed25519, может быть пуст)
   *
   * @generated from field: string pubkey = 8;
   */
  pubkey: string;

  /**
   * screen|input|files
   *
   * @generated from field: repeated string remote_caps = 9;
   */
  remoteCaps: string[];

  /**
   * unverified|trusted|managed
   *
   * @generated from field: string trust_level = 10;
   */
  trustLevel: string;

  /**
   * RFC3339 (последняя отметка «на связи»)
   *
   * @generated from field: string last_seen = 11;
   */
  lastSeen: string;

  /**
   * active|revoked|lost
   *
   * @generated from field: string status = 12;
   */
  status: string;
};

/**
 * Describes the message zdc.Device.
 * Use `create(DeviceSchema)` to create a new message.
 */
export const DeviceSchema: GenMessage<Device> = /*@__PURE__*/
  messageDesc(file_zdc, 1209);

/**
 * @generated from message zdc.DeviceList
 */
export type DeviceList = Message<"zdc.DeviceList"> & {
  /**
   * @generated from field: repeated zdc.Device items = 1;
   */
  items: Device[];
};

/**
 * Describes the message zdc.DeviceList.
 * Use `create(DeviceListSchema)` to create a new message.
 */
export const DeviceListSchema: GenMessage<DeviceList> = /*@__PURE__*/
  messageDesc(file_zdc, 1210);

/**
 * @generated from message zdc.ListMyDevicesRequest
 */
export type ListMyDevicesRequest = Message<"zdc.ListMyDevicesRequest"> & {
};

/**
 * Describes the message zdc.ListMyDevicesRequest.
 * Use `create(ListMyDevicesRequestSchema)` to create a new message.
 */
export const ListMyDevicesRequestSchema: GenMessage<ListMyDevicesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1211);

/**
 * @generated from message zdc.RegisterDeviceRequest
 */
export type RegisterDeviceRequest = Message<"zdc.RegisterDeviceRequest"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: string os = 2;
   */
  os: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string pubkey = 4;
   */
  pubkey: string;

  /**
   * @generated from field: repeated string remote_caps = 5;
   */
  remoteCaps: string[];
};

/**
 * Describes the message zdc.RegisterDeviceRequest.
 * Use `create(RegisterDeviceRequestSchema)` to create a new message.
 */
export const RegisterDeviceRequestSchema: GenMessage<RegisterDeviceRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1212);

/**
 * @generated from message zdc.RegisterDeviceResponse
 */
export type RegisterDeviceResponse = Message<"zdc.RegisterDeviceResponse"> & {
  /**
   * @generated from field: zdc.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message zdc.RegisterDeviceResponse.
 * Use `create(RegisterDeviceResponseSchema)` to create a new message.
 */
export const RegisterDeviceResponseSchema: GenMessage<RegisterDeviceResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1213);

/**
 * TouchDevice: last_seen = сейчас; непустое name — переименование устройства.
 *
 * @generated from message zdc.TouchDeviceRequest
 */
export type TouchDeviceRequest = Message<"zdc.TouchDeviceRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message zdc.TouchDeviceRequest.
 * Use `create(TouchDeviceRequestSchema)` to create a new message.
 */
export const TouchDeviceRequestSchema: GenMessage<TouchDeviceRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1214);

/**
 * @generated from message zdc.TouchDeviceResponse
 */
export type TouchDeviceResponse = Message<"zdc.TouchDeviceResponse"> & {
  /**
   * @generated from field: zdc.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message zdc.TouchDeviceResponse.
 * Use `create(TouchDeviceResponseSchema)` to create a new message.
 */
export const TouchDeviceResponseSchema: GenMessage<TouchDeviceResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1215);

/**
 * @generated from message zdc.RevokeDeviceRequest
 */
export type RevokeDeviceRequest = Message<"zdc.RevokeDeviceRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;
};

/**
 * Describes the message zdc.RevokeDeviceRequest.
 * Use `create(RevokeDeviceRequestSchema)` to create a new message.
 */
export const RevokeDeviceRequestSchema: GenMessage<RevokeDeviceRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1216);

/**
 * @generated from message zdc.RevokeDeviceResponse
 */
export type RevokeDeviceResponse = Message<"zdc.RevokeDeviceResponse"> & {
  /**
   * @generated from field: zdc.Device device = 1;
   */
  device?: Device | undefined;
};

/**
 * Describes the message zdc.RevokeDeviceResponse.
 * Use `create(RevokeDeviceResponseSchema)` to create a new message.
 */
export const RevokeDeviceResponseSchema: GenMessage<RevokeDeviceResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1217);

/**
 * @generated from message zdc.MobileRegisterDeviceRequest
 */
export type MobileRegisterDeviceRequest = Message<"zdc.MobileRegisterDeviceRequest"> & {
  /**
   * mobile
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * android | ios
   *
   * @generated from field: string os = 2;
   */
  os: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * открытый ключ устройства (Ed25519/EC P-256)
   *
   * @generated from field: string pubkey = 4;
   */
  pubkey: string;

  /**
   * screen|input|files (как в DeviceService)
   *
   * @generated from field: repeated string remote_caps = 5;
   */
  remoteCaps: string[];

  /**
   * @generated from field: string app_version = 6;
   */
  appVersion: string;

  /**
   * "sdk.mobile.v1"
   *
   * @generated from field: string sdk_version = 7;
   */
  sdkVersion: string;

  /**
   * JSON, см. §3.3 (schema-версионирован)
   *
   * @generated from field: string capability_manifest = 8;
   */
  capabilityManifest: string;

  /**
   * FCM-токен (может быть пусто на первом шаге)
   *
   * @generated from field: string push_token = 9;
   */
  pushToken: string;
};

/**
 * Describes the message zdc.MobileRegisterDeviceRequest.
 * Use `create(MobileRegisterDeviceRequestSchema)` to create a new message.
 */
export const MobileRegisterDeviceRequestSchema: GenMessage<MobileRegisterDeviceRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1218);

/**
 * @generated from message zdc.MobileRegisterDeviceResponse
 */
export type MobileRegisterDeviceResponse = Message<"zdc.MobileRegisterDeviceResponse"> & {
  /**
   * существующий zdc.Device (device_id = {HydraID}:{Index})
   *
   * @generated from field: zdc.Device device = 1;
   */
  device?: Device | undefined;

  /**
   * device-bound токен (показывается ОДИН раз)
   *
   * @generated from field: string device_token = 2;
   */
  deviceToken: string;

  /**
   * RFC3339
   *
   * @generated from field: string token_expires_at = 3;
   */
  tokenExpiresAt: string;

  /**
   * серверный ожидаемый манифест/версия
   *
   * @generated from field: string capability_policy = 4;
   */
  capabilityPolicy: string;

  /**
   * @generated from field: string server_time = 5;
   */
  serverTime: string;
};

/**
 * Describes the message zdc.MobileRegisterDeviceResponse.
 * Use `create(MobileRegisterDeviceResponseSchema)` to create a new message.
 */
export const MobileRegisterDeviceResponseSchema: GenMessage<MobileRegisterDeviceResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1219);

/**
 * @generated from message zdc.GetCapabilitiesRequest
 */
export type GetCapabilitiesRequest = Message<"zdc.GetCapabilitiesRequest"> & {
  /**
   * android | ios
   *
   * @generated from field: string platform = 1;
   */
  platform: string;

  /**
   * @generated from field: string os_version = 2;
   */
  osVersion: string;

  /**
   * @generated from field: string app_version = 3;
   */
  appVersion: string;

  /**
   * @generated from field: string sdk_version = 4;
   */
  sdkVersion: string;

  /**
   * store | internal | mdm
   *
   * @generated from field: string build_flavor = 5;
   */
  buildFlavor: string;

  /**
   * может быть пусто до регистрации
   *
   * @generated from field: string device_id = 6;
   */
  deviceId: string;
};

/**
 * Describes the message zdc.GetCapabilitiesRequest.
 * Use `create(GetCapabilitiesRequestSchema)` to create a new message.
 */
export const GetCapabilitiesRequestSchema: GenMessage<GetCapabilitiesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1220);

/**
 * @generated from message zdc.GetCapabilitiesResponse
 */
export type GetCapabilitiesResponse = Message<"zdc.GetCapabilitiesResponse"> & {
  /**
   * JSON: требуемые действия/флаги политики (версионир.)
   *
   * @generated from field: string capability_policy = 1;
   */
  capabilityPolicy: string;

  /**
   * @generated from field: int32 policy_version = 2;
   */
  policyVersion: number;

  /**
   * серверные переключатели (напр. mobile.vpn)
   *
   * @generated from field: map<string, bool> feature_flags = 3;
   */
  featureFlags: { [key: string]: boolean };

  /**
   * @generated from field: int64 server_time_unix = 4;
   */
  serverTimeUnix: bigint;

  /**
   * режимы блокировки звонков (Android)
   *
   * @generated from field: zdc.CallBlockingCapability call_blocking = 5;
   */
  callBlocking?: CallBlockingCapability | undefined;
};

/**
 * Describes the message zdc.GetCapabilitiesResponse.
 * Use `create(GetCapabilitiesResponseSchema)` to create a new message.
 */
export const GetCapabilitiesResponseSchema: GenMessage<GetCapabilitiesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1221);

/**
 * @generated from message zdc.MobileVpnConfigRequest
 */
export type MobileVpnConfigRequest = Message<"zdc.MobileVpnConfigRequest"> & {
  /**
   * обязательно (конфиг привязан к устройству)
   *
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * пусто = профиль по ролям (детерминированный выбор)
   *
   * @generated from field: string profile_code = 2;
   */
  profileCode: string;
};

/**
 * Describes the message zdc.MobileVpnConfigRequest.
 * Use `create(MobileVpnConfigRequestSchema)` to create a new message.
 */
export const MobileVpnConfigRequestSchema: GenMessage<MobileVpnConfigRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1222);

/**
 * @generated from message zdc.MobileVpnConfigResponse
 */
export type MobileVpnConfigResponse = Message<"zdc.MobileVpnConfigResponse"> & {
  /**
   * @generated from field: string profile_code = 1;
   */
  profileCode: string;

  /**
   * wireguard | vless | hysteria2
   *
   * @generated from field: string protocol = 2;
   */
  protocol: string;

  /**
   * ini (WG) | uri (vless://)
   *
   * @generated from field: string config_format = 3;
   */
  configFormat: string;

  /**
   * текст конфига; НЕ логируется
   *
   * @generated from field: string config = 4;
   */
  config: string;

  /**
   * QR того же текста (при необходимости)
   *
   * @generated from field: string qr_png_base64 = 5;
   */
  qrPngBase64: string;

  /**
   * ссылка/текст для копирования (vless://)
   *
   * @generated from field: string share_link = 6;
   */
  shareLink: string;

  /**
   * номер версии конфига (для rotate/кэша)
   *
   * @generated from field: string config_version = 7;
   */
  configVersion: string;

  /**
   * RFC3339: конфиг валиден до (пусто = бессрочно)
   *
   * @generated from field: string expires_at = 8;
   */
  expiresAt: string;
};

/**
 * Describes the message zdc.MobileVpnConfigResponse.
 * Use `create(MobileVpnConfigResponseSchema)` to create a new message.
 */
export const MobileVpnConfigResponseSchema: GenMessage<MobileVpnConfigResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1223);

/**
 * @generated from message zdc.RotateVpnConfigRequest
 */
export type RotateVpnConfigRequest = Message<"zdc.RotateVpnConfigRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * @generated from field: string profile_code = 2;
   */
  profileCode: string;

  /**
   * user | compromise | expiry | migration
   *
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message zdc.RotateVpnConfigRequest.
 * Use `create(RotateVpnConfigRequestSchema)` to create a new message.
 */
export const RotateVpnConfigRequestSchema: GenMessage<RotateVpnConfigRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1224);

/**
 * @generated from message zdc.LookupNumberRequest
 */
export type LookupNumberRequest = Message<"zdc.LookupNumberRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * E.164 (+7…)
   *
   * @generated from field: string number = 2;
   */
  number: string;

  /**
   * client_ref-идемпотентность
   *
   * @generated from field: string request_id = 3;
   */
  requestId: string;
};

/**
 * Describes the message zdc.LookupNumberRequest.
 * Use `create(LookupNumberRequestSchema)` to create a new message.
 */
export const LookupNumberRequestSchema: GenMessage<LookupNumberRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1225);

/**
 * @generated from message zdc.LookupNumberResponse
 */
export type LookupNumberResponse = Message<"zdc.LookupNumberResponse"> & {
  /**
   * @generated from field: string number = 1;
   */
  number: string;

  /**
   * нет совпадения — НЕ ошибка
   *
   * @generated from field: bool matched = 2;
   */
  matched: boolean;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * contacts | registry | business | internal | none
   *
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * client | partner | spam | unknown
   *
   * @generated from field: string category = 5;
   */
  category: string;

  /**
   * сколько держать в локальном LRU
   *
   * @generated from field: int32 allow_cache_seconds = 6;
   */
  allowCacheSeconds: number;

  /**
   * @generated from field: string server_time = 7;
   */
  serverTime: string;
};

/**
 * Describes the message zdc.LookupNumberResponse.
 * Use `create(LookupNumberResponseSchema)` to create a new message.
 */
export const LookupNumberResponseSchema: GenMessage<LookupNumberResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1226);

/**
 * @generated from message zdc.BlocklistEntry
 */
export type BlocklistEntry = Message<"zdc.BlocklistEntry"> & {
  /**
   * @generated from field: string number = 1;
   */
  number: string;

  /**
   * block | silence | allow
   *
   * @generated from field: string action = 2;
   */
  action: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * @generated from field: string category = 4;
   */
  category: string;

  /**
   * пусто = бессрочно
   *
   * @generated from field: string expires_at = 5;
   */
  expiresAt: string;

  /**
   * block | silence | ignore (пусто = режим политики)
   *
   * @generated from field: string mode = 6;
   */
  mode: string;

  /**
   * entity | contact (избранные/исключения)
   *
   * @generated from field: string ref_type = 7;
   */
  refType: string;

  /**
   * id сущности/контакта
   *
   * @generated from field: string ref_id = 8;
   */
  refId: string;
};

/**
 * Describes the message zdc.BlocklistEntry.
 * Use `create(BlocklistEntrySchema)` to create a new message.
 */
export const BlocklistEntrySchema: GenMessage<BlocklistEntry> = /*@__PURE__*/
  messageDesc(file_zdc, 1227);

/**
 * @generated from message zdc.SyncBlocklistRequest
 */
export type SyncBlocklistRequest = Message<"zdc.SyncBlocklistRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * @generated from field: string platform = 2;
   */
  platform: string;

  /**
   * 0 = полный список
   *
   * @generated from field: int64 since_version = 3;
   */
  sinceVersion: bigint;

  /**
   * device | role | user | base | all (all = объединение)
   *
   * @generated from field: string list_scope = 4;
   */
  listScope: string;
};

/**
 * Describes the message zdc.SyncBlocklistRequest.
 * Use `create(SyncBlocklistRequestSchema)` to create a new message.
 */
export const SyncBlocklistRequestSchema: GenMessage<SyncBlocklistRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1228);

/**
 * @generated from message zdc.SyncBlocklistResponse
 */
export type SyncBlocklistResponse = Message<"zdc.SyncBlocklistResponse"> & {
  /**
   * новая версия набора
   *
   * @generated from field: int64 version = 1;
   */
  version: bigint;

  /**
   * true = применять как полную замену
   *
   * @generated from field: bool full = 2;
   */
  full: boolean;

  /**
   * @generated from field: repeated zdc.BlocklistEntry added = 3;
   */
  added: BlocklistEntry[];

  /**
   * номера, которые надо снять
   *
   * @generated from field: repeated string removed = 4;
   */
  removed: string[];

  /**
   * @generated from field: int64 next_version = 5;
   */
  nextVersion: bigint;

  /**
   * @generated from field: string server_time = 6;
   */
  serverTime: string;

  /**
   * эффективная политика блокировки (режим/избранные)
   *
   * @generated from field: zdc.CallPolicy policy = 7;
   */
  policy?: CallPolicy | undefined;
};

/**
 * Describes the message zdc.SyncBlocklistResponse.
 * Use `create(SyncBlocklistResponseSchema)` to create a new message.
 */
export const SyncBlocklistResponseSchema: GenMessage<SyncBlocklistResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1229);

/**
 * Политика блокировки звонков/SMS (allowlist = «только избранные дозвонятся»).
 *
 * @generated from message zdc.CallPolicy
 */
export type CallPolicy = Message<"zdc.CallPolicy"> & {
  /**
   * device | user | role | base (источник политики)
   *
   * @generated from field: string scope = 1;
   */
  scope: string;

  /**
   * id области (base = "")
   *
   * @generated from field: string scope_id = 2;
   */
  scopeId: string;

  /**
   * off | blocklist | allowlist | all_except
   *
   * @generated from field: string mode = 3;
   */
  mode: string;

  /**
   * block | silence | ignore (для записей без mode)
   *
   * @generated from field: string default_mode = 4;
   */
  defaultMode: string;

  /**
   * @generated from field: bool enabled = 5;
   */
  enabled: boolean;

  /**
   * @generated from field: int64 version = 6;
   */
  version: bigint;

  /**
   * дополнение «Блокировка звонков» доступно ролям
   *
   * @generated from field: bool available = 7;
   */
  available: boolean;
};

/**
 * Describes the message zdc.CallPolicy.
 * Use `create(CallPolicySchema)` to create a new message.
 */
export const CallPolicySchema: GenMessage<CallPolicy> = /*@__PURE__*/
  messageDesc(file_zdc, 1230);

/**
 * @generated from message zdc.GetCallPolicyRequest
 */
export type GetCallPolicyRequest = Message<"zdc.GetCallPolicyRequest"> & {
  /**
   * пусто = без device-области
   *
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * пусто = ЭФФЕКТИВНАЯ; иначе запрошенная (админ)
   *
   * @generated from field: string scope = 2;
   */
  scope: string;

  /**
   * @generated from field: string scope_id = 3;
   */
  scopeId: string;
};

/**
 * Describes the message zdc.GetCallPolicyRequest.
 * Use `create(GetCallPolicyRequestSchema)` to create a new message.
 */
export const GetCallPolicyRequestSchema: GenMessage<GetCallPolicyRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1231);

/**
 * @generated from message zdc.SetCallPolicyRequest
 */
export type SetCallPolicyRequest = Message<"zdc.SetCallPolicyRequest"> & {
  /**
   * пусто = device-область не задаётся
   *
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * device|user (пользователь) | base|role|user|device (админ)
   *
   * @generated from field: string scope = 2;
   */
  scope: string;

  /**
   * пусто → своё устройство/пользователь
   *
   * @generated from field: string scope_id = 3;
   */
  scopeId: string;

  /**
   * off | blocklist | allowlist | all_except
   *
   * @generated from field: string mode = 4;
   */
  mode: string;

  /**
   * block | silence | ignore
   *
   * @generated from field: string default_mode = 5;
   */
  defaultMode: string;

  /**
   * @generated from field: bool enabled = 6;
   */
  enabled: boolean;
};

/**
 * Describes the message zdc.SetCallPolicyRequest.
 * Use `create(SetCallPolicyRequestSchema)` to create a new message.
 */
export const SetCallPolicyRequestSchema: GenMessage<SetCallPolicyRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1232);

/**
 * Capability блокировки звонков (SSoT — сервер; зеркалит Android CallScreeningService).
 *
 * @generated from message zdc.CallBlockingCapability
 */
export type CallBlockingCapability = Message<"zdc.CallBlockingCapability"> & {
  /**
   * механизм поддержан на платформе (android)
   *
   * @generated from field: bool supported = 1;
   */
  supported: boolean;

  /**
   * android | ios
   *
   * @generated from field: string platform = 2;
   */
  platform: string;

  /**
   * block | silence | ignore
   *
   * @generated from field: repeated string modes = 3;
   */
  modes: string[];

  /**
   * block
   *
   * @generated from field: string default_mode = 4;
   */
  defaultMode: string;

  /**
   * «только избранные дозвонятся»
   *
   * @generated from field: bool allowlist_supported = 5;
   */
  allowlistSupported: boolean;

  /**
   * ignore (гудки без звонка)
   *
   * @generated from field: repeated string best_effort = 6;
   */
  bestEffort: string[];

  /**
   * off | blocklist | allowlist | all_except
   *
   * @generated from field: repeated string policy_modes = 7;
   */
  policyModes: string[];
};

/**
 * Describes the message zdc.CallBlockingCapability.
 * Use `create(CallBlockingCapabilitySchema)` to create a new message.
 */
export const CallBlockingCapabilitySchema: GenMessage<CallBlockingCapability> = /*@__PURE__*/
  messageDesc(file_zdc, 1233);

/**
 * @generated from message zdc.PushPolicyRequest
 */
export type PushPolicyRequest = Message<"zdc.PushPolicyRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * @generated from field: string platform = 2;
   */
  platform: string;

  /**
   * @generated from field: string app_version = 3;
   */
  appVersion: string;

  /**
   * обновление токена
   *
   * @generated from field: string push_token = 4;
   */
  pushToken: string;

  /**
   * fcm | webpush
   *
   * @generated from field: string transport = 5;
   */
  transport: string;

  /**
   * @generated from field: string language = 6;
   */
  language: string;

  /**
   * JSON {from,to,tz} (пусто = нет)
   *
   * @generated from field: string quiet_hours = 7;
   */
  quietHours: string;
};

/**
 * Describes the message zdc.PushPolicyRequest.
 * Use `create(PushPolicyRequestSchema)` to create a new message.
 */
export const PushPolicyRequestSchema: GenMessage<PushPolicyRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1234);

/**
 * @generated from message zdc.PushPolicyResponse
 */
export type PushPolicyResponse = Message<"zdc.PushPolicyResponse"> & {
  /**
   * @generated from field: int32 policy_version = 1;
   */
  policyVersion: number;

  /**
   * @generated from field: bool do_not_disturb = 2;
   */
  doNotDisturb: boolean;

  /**
   * info | warning | error
   *
   * @generated from field: string min_severity = 3;
   */
  minSeverity: string;

  /**
   * @generated from field: repeated zdc.PushCategory categories = 4;
   */
  categories: PushCategory[];
};

/**
 * Describes the message zdc.PushPolicyResponse.
 * Use `create(PushPolicyResponseSchema)` to create a new message.
 */
export const PushPolicyResponseSchema: GenMessage<PushPolicyResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1235);

/**
 * @generated from message zdc.PushCategory
 */
export type PushCategory = Message<"zdc.PushCategory"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * @generated from field: string quiet_hours = 3;
   */
  quietHours: string;
};

/**
 * Describes the message zdc.PushCategory.
 * Use `create(PushCategorySchema)` to create a new message.
 */
export const PushCategorySchema: GenMessage<PushCategory> = /*@__PURE__*/
  messageDesc(file_zdc, 1236);

/**
 * @generated from message zdc.ReportCallEventRequest
 */
export type ReportCallEventRequest = Message<"zdc.ReportCallEventRequest"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * client_ref: идемпотентность повторов очереди
   *
   * @generated from field: string event_id = 2;
   */
  eventId: string;

  /**
   * @generated from field: string number = 3;
   */
  number: string;

  /**
   * blocked | silenced | allowed | looked_up
   *
   * @generated from field: string action = 4;
   */
  action: string;

  /**
   * block | silence | ignore | pass
   *
   * @generated from field: string mode = 5;
   */
  mode: string;

  /**
   * screening | directory
   *
   * @generated from field: string source = 6;
   */
  source: string;

  /**
   * @generated from field: bool matched = 7;
   */
  matched: boolean;

  /**
   * @generated from field: string category = 8;
   */
  category: string;

  /**
   * RFC3339
   *
   * @generated from field: string started_at = 9;
   */
  startedAt: string;

  /**
   * @generated from field: int64 duration_ms = 10;
   */
  durationMs: bigint;
};

/**
 * Describes the message zdc.ReportCallEventRequest.
 * Use `create(ReportCallEventRequestSchema)` to create a new message.
 */
export const ReportCallEventRequestSchema: GenMessage<ReportCallEventRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1237);

/**
 * @generated from message zdc.ReportCallEventResponse
 */
export type ReportCallEventResponse = Message<"zdc.ReportCallEventResponse"> & {
  /**
   * @generated from field: bool accepted = 1;
   */
  accepted: boolean;

  /**
   * @generated from field: string server_time = 2;
   */
  serverTime: string;
};

/**
 * Describes the message zdc.ReportCallEventResponse.
 * Use `create(ReportCallEventResponseSchema)` to create a new message.
 */
export const ReportCallEventResponseSchema: GenMessage<ReportCallEventResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1238);

/**
 * @generated from message zdc.SiteTemplateLicense
 */
export type SiteTemplateLicense = Message<"zdc.SiteTemplateLicense"> & {
  /**
   * MIT | CC0-1.0 | Unlicense …
   *
   * @generated from field: string spdx = 1;
   */
  spdx: string;

  /**
   * ссылка на текст лицензии
   *
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * автор/источник (журнал)
   *
   * @generated from field: string author = 3;
   */
  author: string;

  /**
   * страница источника
   *
   * @generated from field: string source_url = 4;
   */
  sourceUrl: string;

  /**
   * true → НЕ в галерею (карантин)
   *
   * @generated from field: bool attribution_required = 5;
   */
  attributionRequired: boolean;

  /**
   * включение в библиотеку
   *
   * @generated from field: bool redistribution_allowed = 6;
   */
  redistributionAllowed: boolean;

  /**
   * производные (подготовка в нашем формате)
   *
   * @generated from field: bool derivative_allowed = 7;
   */
  derivativeAllowed: boolean;

  /**
   * коммерческое использование
   *
   * @generated from field: bool commercial_allowed = 8;
   */
  commercialAllowed: boolean;
};

/**
 * Describes the message zdc.SiteTemplateLicense.
 * Use `create(SiteTemplateLicenseSchema)` to create a new message.
 */
export const SiteTemplateLicenseSchema: GenMessage<SiteTemplateLicense> = /*@__PURE__*/
  messageDesc(file_zdc, 1239);

/**
 * @generated from message zdc.SiteTemplate
 */
export type SiteTemplate = Message<"zdc.SiteTemplate"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string version = 3;
   */
  version: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * отрасли (ось фильтра)
   *
   * @generated from field: repeated string categories = 5;
   */
  categories: string[];

  /**
   * стиль
   *
   * @generated from field: repeated string tags = 6;
   */
  tags: string[];

  /**
   * признаки (форма/прайс/отзывы…)
   *
   * @generated from field: repeated string features = 7;
   */
  features: string[];

  /**
   * @generated from field: zdc.SiteTemplateLicense license = 8;
   */
  license?: SiteTemplateLicense | undefined;

  /**
   * путь внутри папки версии
   *
   * @generated from field: string preview_desktop = 9;
   */
  previewDesktop: string;

  /**
   * @generated from field: string preview_mobile = 10;
   */
  previewMobile: string;

  /**
   * sha256 содержимого версии
   *
   * @generated from field: string checksum = 11;
   */
  checksum: string;

  /**
   * есть демонстрационные тексты
   *
   * @generated from field: bool demo_content = 12;
   */
  demoContent: boolean;

  /**
   * @generated from field: string published_at = 13;
   */
  publishedAt: string;

  /**
   * курация: рекомендуемые
   *
   * @generated from field: bool featured = 14;
   */
  featured: boolean;
};

/**
 * Describes the message zdc.SiteTemplate.
 * Use `create(SiteTemplateSchema)` to create a new message.
 */
export const SiteTemplateSchema: GenMessage<SiteTemplate> = /*@__PURE__*/
  messageDesc(file_zdc, 1240);

/**
 * @generated from message zdc.ListSiteTemplatesRequest
 */
export type ListSiteTemplatesRequest = Message<"zdc.ListSiteTemplatesRequest"> & {
  /**
   * пусто = все (пересечение по любой)
   *
   * @generated from field: repeated string categories = 1;
   */
  categories: string[];

  /**
   * @generated from field: repeated string tags = 2;
   */
  tags: string[];

  /**
   * @generated from field: repeated string features = 3;
   */
  features: string[];

  /**
   * подстрока (код/имя/описание/оси)
   *
   * @generated from field: string search = 4;
   */
  search: string;

  /**
   * recommended | new | updated | name
   *
   * @generated from field: string sort = 5;
   */
  sort: string;
};

/**
 * Describes the message zdc.ListSiteTemplatesRequest.
 * Use `create(ListSiteTemplatesRequestSchema)` to create a new message.
 */
export const ListSiteTemplatesRequestSchema: GenMessage<ListSiteTemplatesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1241);

/**
 * @generated from message zdc.ListSiteTemplatesResponse
 */
export type ListSiteTemplatesResponse = Message<"zdc.ListSiteTemplatesResponse"> & {
  /**
   * @generated from field: repeated zdc.SiteTemplate items = 1;
   */
  items: SiteTemplate[];

  /**
   * доступные оси (для панели фильтров)
   *
   * @generated from field: repeated string categories = 2;
   */
  categories: string[];

  /**
   * @generated from field: repeated string tags = 3;
   */
  tags: string[];

  /**
   * @generated from field: repeated string features = 4;
   */
  features: string[];

  /**
   * @generated from field: string library_path = 5;
   */
  libraryPath: string;
};

/**
 * Describes the message zdc.ListSiteTemplatesResponse.
 * Use `create(ListSiteTemplatesResponseSchema)` to create a new message.
 */
export const ListSiteTemplatesResponseSchema: GenMessage<ListSiteTemplatesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1242);

/**
 * @generated from message zdc.GetSiteTemplateRequest
 */
export type GetSiteTemplateRequest = Message<"zdc.GetSiteTemplateRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string version = 2;
   */
  version: string;
};

/**
 * Describes the message zdc.GetSiteTemplateRequest.
 * Use `create(GetSiteTemplateRequestSchema)` to create a new message.
 */
export const GetSiteTemplateRequestSchema: GenMessage<GetSiteTemplateRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1243);

/**
 * @generated from message zdc.SiteTemplatePageInfo
 */
export type SiteTemplatePageInfo = Message<"zdc.SiteTemplatePageInfo"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * sha256 макета страницы
   *
   * @generated from field: string checksum = 5;
   */
  checksum: string;
};

/**
 * Describes the message zdc.SiteTemplatePageInfo.
 * Use `create(SiteTemplatePageInfoSchema)` to create a new message.
 */
export const SiteTemplatePageInfoSchema: GenMessage<SiteTemplatePageInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 1244);

/**
 * @generated from message zdc.SiteTemplateDetails
 */
export type SiteTemplateDetails = Message<"zdc.SiteTemplateDetails"> & {
  /**
   * @generated from field: zdc.SiteTemplate item = 1;
   */
  item?: SiteTemplate | undefined;

  /**
   * @generated from field: repeated zdc.SiteTemplatePageInfo pages = 2;
   */
  pages: SiteTemplatePageInfo[];

  /**
   * JSON темы (токены оформления)
   *
   * @generated from field: string theme = 3;
   */
  theme: string;
};

/**
 * Describes the message zdc.SiteTemplateDetails.
 * Use `create(SiteTemplateDetailsSchema)` to create a new message.
 */
export const SiteTemplateDetailsSchema: GenMessage<SiteTemplateDetails> = /*@__PURE__*/
  messageDesc(file_zdc, 1245);

/**
 * @generated from message zdc.ResolveTemplateAssetRequest
 */
export type ResolveTemplateAssetRequest = Message<"zdc.ResolveTemplateAssetRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string version = 2;
   */
  version: string;

  /**
   * путь внутри папки версии (без выхода наружу)
   *
   * @generated from field: string path = 3;
   */
  path: string;
};

/**
 * Describes the message zdc.ResolveTemplateAssetRequest.
 * Use `create(ResolveTemplateAssetRequestSchema)` to create a new message.
 */
export const ResolveTemplateAssetRequestSchema: GenMessage<ResolveTemplateAssetRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1246);

/**
 * @generated from message zdc.ResolveTemplateAssetResponse
 */
export type ResolveTemplateAssetResponse = Message<"zdc.ResolveTemplateAssetResponse"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType: string;
};

/**
 * Describes the message zdc.ResolveTemplateAssetResponse.
 * Use `create(ResolveTemplateAssetResponseSchema)` to create a new message.
 */
export const ResolveTemplateAssetResponseSchema: GenMessage<ResolveTemplateAssetResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1247);

/**
 * @generated from message zdc.ApplyTemplateToSiteRequest
 */
export type ApplyTemplateToSiteRequest = Message<"zdc.ApplyTemplateToSiteRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * пусто = последняя
   *
   * @generated from field: string version = 2;
   */
  version: string;

  /**
   * код нового/существующего сайта
   *
   * @generated from field: string site_code = 3;
   */
  siteCode: string;

  /**
   * имя сайта (новый; пусто → имя шаблона)
   *
   * @generated from field: string site_name = 4;
   */
  siteName: string;

  /**
   * new | add_pages
   *
   * @generated from field: string mode = 5;
   */
  mode: string;
};

/**
 * Describes the message zdc.ApplyTemplateToSiteRequest.
 * Use `create(ApplyTemplateToSiteRequestSchema)` to create a new message.
 */
export const ApplyTemplateToSiteRequestSchema: GenMessage<ApplyTemplateToSiteRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1248);

/**
 * @generated from message zdc.AppliedTemplatePage
 */
export type AppliedTemplatePage = Message<"zdc.AppliedTemplatePage"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string checksum = 4;
   */
  checksum: string;
};

/**
 * Describes the message zdc.AppliedTemplatePage.
 * Use `create(AppliedTemplatePageSchema)` to create a new message.
 */
export const AppliedTemplatePageSchema: GenMessage<AppliedTemplatePage> = /*@__PURE__*/
  messageDesc(file_zdc, 1249);

/**
 * @generated from message zdc.ApplyTemplateToSiteResponse
 */
export type ApplyTemplateToSiteResponse = Message<"zdc.ApplyTemplateToSiteResponse"> & {
  /**
   * @generated from field: string site_code = 1;
   */
  siteCode: string;

  /**
   * @generated from field: string template_code = 2;
   */
  templateCode: string;

  /**
   * @generated from field: string template_version = 3;
   */
  templateVersion: string;

  /**
   * @generated from field: repeated zdc.AppliedTemplatePage pages = 4;
   */
  pages: AppliedTemplatePage[];
};

/**
 * Describes the message zdc.ApplyTemplateToSiteResponse.
 * Use `create(ApplyTemplateToSiteResponseSchema)` to create a new message.
 */
export const ApplyTemplateToSiteResponseSchema: GenMessage<ApplyTemplateToSiteResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1250);

/**
 * @generated from message zdc.ReloadTemplateLibraryResponse
 */
export type ReloadTemplateLibraryResponse = Message<"zdc.ReloadTemplateLibraryResponse"> & {
  /**
   * шаблонов в каталоге после сканирования
   *
   * @generated from field: int32 indexed = 1;
   */
  indexed: number;

  /**
   * перенесено в карантин (лицензия/манифест)
   *
   * @generated from field: int32 quarantined = 2;
   */
  quarantined: number;

  /**
   * причины карантина (человеческий текст)
   *
   * @generated from field: repeated string reasons = 3;
   */
  reasons: string[];
};

/**
 * Describes the message zdc.ReloadTemplateLibraryResponse.
 * Use `create(ReloadTemplateLibraryResponseSchema)` to create a new message.
 */
export const ReloadTemplateLibraryResponseSchema: GenMessage<ReloadTemplateLibraryResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1251);

/**
 * @generated from message zdc.SiteTemplateUpdate
 */
export type SiteTemplateUpdate = Message<"zdc.SiteTemplateUpdate"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string version = 3;
   */
  version: string;

  /**
   * '' = не установлен
   *
   * @generated from field: string local_version = 4;
   */
  localVersion: string;

  /**
   * Ссылка на превью (абсолютная, на стороне Hub; пусто = превью нет) —
   * галерея показывает картинку ДО скачивания пакета.
   *
   * @generated from field: string preview = 5;
   */
  preview: string;
};

/**
 * Describes the message zdc.SiteTemplateUpdate.
 * Use `create(SiteTemplateUpdateSchema)` to create a new message.
 */
export const SiteTemplateUpdateSchema: GenMessage<SiteTemplateUpdate> = /*@__PURE__*/
  messageDesc(file_zdc, 1252);

/**
 * @generated from message zdc.CheckTemplateUpdatesResponse
 */
export type CheckTemplateUpdatesResponse = Message<"zdc.CheckTemplateUpdatesResponse"> & {
  /**
   * @generated from field: repeated zdc.SiteTemplateUpdate updates = 1;
   */
  updates: SiteTemplateUpdate[];

  /**
   * @generated from field: string feed_url = 2;
   */
  feedUrl: string;
};

/**
 * Describes the message zdc.CheckTemplateUpdatesResponse.
 * Use `create(CheckTemplateUpdatesResponseSchema)` to create a new message.
 */
export const CheckTemplateUpdatesResponseSchema: GenMessage<CheckTemplateUpdatesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1253);

/**
 * @generated from message zdc.InstallTemplatesFromHubRequest
 */
export type InstallTemplatesFromHubRequest = Message<"zdc.InstallTemplatesFromHubRequest"> & {
  /**
   * пусто → настройка packages.repository_url
   *
   * @generated from field: string hub_url = 1;
   */
  hubUrl: string;
};

/**
 * Describes the message zdc.InstallTemplatesFromHubRequest.
 * Use `create(InstallTemplatesFromHubRequestSchema)` to create a new message.
 */
export const InstallTemplatesFromHubRequestSchema: GenMessage<InstallTemplatesFromHubRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1254);

/**
 * @generated from message zdc.InstallTemplatesFromHubResponse
 */
export type InstallTemplatesFromHubResponse = Message<"zdc.InstallTemplatesFromHubResponse"> & {
  /**
   * @generated from field: repeated zdc.SiteTemplateUpdate installed = 1;
   */
  installed: SiteTemplateUpdate[];

  /**
   * @generated from field: repeated zdc.SiteTemplateUpdate skipped = 2;
   */
  skipped: SiteTemplateUpdate[];

  /**
   * «код версия: причина»
   *
   * @generated from field: repeated string failed = 3;
   */
  failed: string[];

  /**
   * @generated from field: string feed_url = 4;
   */
  feedUrl: string;
};

/**
 * Describes the message zdc.InstallTemplatesFromHubResponse.
 * Use `create(InstallTemplatesFromHubResponseSchema)` to create a new message.
 */
export const InstallTemplatesFromHubResponseSchema: GenMessage<InstallTemplatesFromHubResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1255);

/**
 * @generated from message zdc.CallSession
 */
export type CallSession = Message<"zdc.CallSession"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * комната медиасервера (conv_<id> — из чата; adhoc_<id> — иначе)
   *
   * @generated from field: string room = 2;
   */
  room: string;

  /**
   * audio | video
   *
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * ringing | active | declined | ended
   *
   * @generated from field: string state = 4;
   */
  state: string;

  /**
   * кто позвонил
   *
   * @generated from field: string initiator_id = 5;
   */
  initiatorId: string;

  /**
   * имя инициатора (SSoT — сервер)
   *
   * @generated from field: string initiator_name = 6;
   */
  initiatorName: string;

  /**
   * адресаты (без инициатора)
   *
   * @generated from field: repeated string callee_ids = 7;
   */
  calleeIds: string[];

  /**
   * имена адресатов (в том же порядке)
   *
   * @generated from field: repeated string callee_names = 8;
   */
  calleeNames: string[];

  /**
   * RFC3339
   *
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * RFC3339 (пусто — звонок не завершён)
   *
   * @generated from field: string ended_at = 10;
   */
  endedAt: string;

  /**
   * кто завершил/отклонил
   *
   * @generated from field: string ended_by = 11;
   */
  endedBy: string;

  /**
   * причина отклонения (необязательно)
   *
   * @generated from field: string decline_reason = 12;
   */
  declineReason: string;
};

/**
 * Describes the message zdc.CallSession.
 * Use `create(CallSessionSchema)` to create a new message.
 */
export const CallSessionSchema: GenMessage<CallSession> = /*@__PURE__*/
  messageDesc(file_zdc, 1256);

/**
 * @generated from message zdc.StartCallRequest
 */
export type StartCallRequest = Message<"zdc.StartCallRequest"> & {
  /**
   * Комната: пусто → adhoc_<id>; для звонка из чата клиент передаёт conv_<id>.
   *
   * @generated from field: string room = 1;
   */
  room: string;

  /**
   * Вид звонка: audio | video (пусто → video).
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * Явные адресаты. Пусто и комната conv_<id> → участники чата (кроме инициатора).
   *
   * @generated from field: repeated string callee_ids = 3;
   */
  calleeIds: string[];
};

/**
 * Describes the message zdc.StartCallRequest.
 * Use `create(StartCallRequestSchema)` to create a new message.
 */
export const StartCallRequestSchema: GenMessage<StartCallRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1257);

/**
 * @generated from message zdc.AnswerCallRequest
 */
export type AnswerCallRequest = Message<"zdc.AnswerCallRequest"> & {
  /**
   * @generated from field: string call_id = 1;
   */
  callId: string;
};

/**
 * Describes the message zdc.AnswerCallRequest.
 * Use `create(AnswerCallRequestSchema)` to create a new message.
 */
export const AnswerCallRequestSchema: GenMessage<AnswerCallRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1258);

/**
 * @generated from message zdc.DeclineCallRequest
 */
export type DeclineCallRequest = Message<"zdc.DeclineCallRequest"> & {
  /**
   * @generated from field: string call_id = 1;
   */
  callId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message zdc.DeclineCallRequest.
 * Use `create(DeclineCallRequestSchema)` to create a new message.
 */
export const DeclineCallRequestSchema: GenMessage<DeclineCallRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1259);

/**
 * @generated from message zdc.EndCallRequest
 */
export type EndCallRequest = Message<"zdc.EndCallRequest"> & {
  /**
   * @generated from field: string call_id = 1;
   */
  callId: string;
};

/**
 * Describes the message zdc.EndCallRequest.
 * Use `create(EndCallRequestSchema)` to create a new message.
 */
export const EndCallRequestSchema: GenMessage<EndCallRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1260);

/**
 * @generated from message zdc.GetCallRequest
 */
export type GetCallRequest = Message<"zdc.GetCallRequest"> & {
  /**
   * @generated from field: string call_id = 1;
   */
  callId: string;
};

/**
 * Describes the message zdc.GetCallRequest.
 * Use `create(GetCallRequestSchema)` to create a new message.
 */
export const GetCallRequestSchema: GenMessage<GetCallRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1261);

/**
 * @generated from message zdc.ListActiveCallsRequest
 */
export type ListActiveCallsRequest = Message<"zdc.ListActiveCallsRequest"> & {
};

/**
 * Describes the message zdc.ListActiveCallsRequest.
 * Use `create(ListActiveCallsRequestSchema)` to create a new message.
 */
export const ListActiveCallsRequestSchema: GenMessage<ListActiveCallsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1262);

/**
 * @generated from message zdc.ListActiveCallsResponse
 */
export type ListActiveCallsResponse = Message<"zdc.ListActiveCallsResponse"> & {
  /**
   * @generated from field: repeated zdc.CallSession items = 1;
   */
  items: CallSession[];
};

/**
 * Describes the message zdc.ListActiveCallsResponse.
 * Use `create(ListActiveCallsResponseSchema)` to create a new message.
 */
export const ListActiveCallsResponseSchema: GenMessage<ListActiveCallsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1263);

/**
 * @generated from message zdc.IdentityKeyInfo
 */
export type IdentityKeyInfo = Message<"zdc.IdentityKeyInfo"> & {
  /**
   * did:hydra:...#key-N
   *
   * @generated from field: string key_id = 1;
   */
  keyId: string;

  /**
   * root | signing | device
   *
   * @generated from field: string purpose = 2;
   */
  purpose: string;

  /**
   * ed25519 (ГОСТ — отдельный адаптер позже)
   *
   * @generated from field: string alg = 3;
   */
  alg: string;

  /**
   * base64url
   *
   * @generated from field: string public_key = 4;
   */
  publicKey: string;

  /**
   * sha256:<hex>
   *
   * @generated from field: string fingerprint = 5;
   */
  fingerprint: string;

  /**
   * @generated from field: bool is_active = 6;
   */
  isActive: boolean;

  /**
   * @generated from field: string valid_from = 7;
   */
  validFrom: string;

  /**
   * пусто — бессрочно (ротация задаёт окно verify)
   *
   * @generated from field: string valid_until = 8;
   */
  validUntil: string;

  /**
   * @generated from field: string rotated_at = 9;
   */
  rotatedAt: string;

  /**
   * @generated from field: string created_at = 10;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.IdentityKeyInfo.
 * Use `create(IdentityKeyInfoSchema)` to create a new message.
 */
export const IdentityKeyInfoSchema: GenMessage<IdentityKeyInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 1264);

/**
 * @generated from message zdc.SelfIdentity
 */
export type SelfIdentity = Message<"zdc.SelfIdentity"> & {
  /**
   * @generated from field: string did = 1;
   */
  did: string;

  /**
   * user@home
   *
   * @generated from field: string handle = 2;
   */
  handle: string;

  /**
   * база/домен
   *
   * @generated from field: string home = 3;
   */
  home: string;

  /**
   * канонический JSON DID-документа (с proof)
   *
   * @generated from field: string document = 4;
   */
  document: string;

  /**
   * @generated from field: int64 seq = 5;
   */
  seq: bigint;

  /**
   * @generated from field: string doc_hash = 6;
   */
  docHash: string;

  /**
   * @generated from field: string prev_hash = 7;
   */
  prevHash: string;

  /**
   * @generated from field: bool active = 8;
   */
  active: boolean;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 10;
   */
  updatedAt: string;

  /**
   * @generated from field: repeated zdc.IdentityKeyInfo keys = 11;
   */
  keys: IdentityKeyInfo[];

  /**
   * корневой сертификат (JSON) — для передачи доверия
   *
   * @generated from field: string root_trust_export = 12;
   */
  rootTrustExport: string;
};

/**
 * Describes the message zdc.SelfIdentity.
 * Use `create(SelfIdentitySchema)` to create a new message.
 */
export const SelfIdentitySchema: GenMessage<SelfIdentity> = /*@__PURE__*/
  messageDesc(file_zdc, 1265);

/**
 * @generated from message zdc.GetSelfIdentityRequest
 */
export type GetSelfIdentityRequest = Message<"zdc.GetSelfIdentityRequest"> & {
};

/**
 * Describes the message zdc.GetSelfIdentityRequest.
 * Use `create(GetSelfIdentityRequestSchema)` to create a new message.
 */
export const GetSelfIdentityRequestSchema: GenMessage<GetSelfIdentityRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1266);

/**
 * @generated from message zdc.RotateIdentityKeyRequest
 */
export type RotateIdentityKeyRequest = Message<"zdc.RotateIdentityKeyRequest"> & {
  /**
   * пусто = signing (ротация корня — не в Фазе 1)
   *
   * @generated from field: string purpose = 1;
   */
  purpose: string;

  /**
   * сколько СТАРЫЙ ключ валиден для verify (0 = 90)
   *
   * @generated from field: int32 validity_days = 2;
   */
  validityDays: number;
};

/**
 * Describes the message zdc.RotateIdentityKeyRequest.
 * Use `create(RotateIdentityKeyRequestSchema)` to create a new message.
 */
export const RotateIdentityKeyRequestSchema: GenMessage<RotateIdentityKeyRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1267);

/**
 * @generated from message zdc.TrustRootInfo
 */
export type TrustRootInfo = Message<"zdc.TrustRootInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string root_key_id = 2;
   */
  rootKeyId: string;

  /**
   * @generated from field: string alg = 3;
   */
  alg: string;

  /**
   * @generated from field: string public_key = 4;
   */
  publicKey: string;

  /**
   * @generated from field: string fingerprint = 5;
   */
  fingerprint: string;

  /**
   * @generated from field: string subject = 6;
   */
  subject: string;

  /**
   * '*' | artifact_id | 'prefix.*'
   *
   * @generated from field: string scope = 7;
   */
  scope: string;

  /**
   * @generated from field: string valid_from = 8;
   */
  validFrom: string;

  /**
   * пусто — бессрочно
   *
   * @generated from field: string valid_until = 9;
   */
  validUntil: string;

  /**
   * @generated from field: bool is_active = 10;
   */
  isActive: boolean;

  /**
   * @generated from field: string created_at = 11;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.TrustRootInfo.
 * Use `create(TrustRootInfoSchema)` to create a new message.
 */
export const TrustRootInfoSchema: GenMessage<TrustRootInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 1268);

/**
 * @generated from message zdc.TrustRootList
 */
export type TrustRootList = Message<"zdc.TrustRootList"> & {
  /**
   * @generated from field: repeated zdc.TrustRootInfo items = 1;
   */
  items: TrustRootInfo[];
};

/**
 * Describes the message zdc.TrustRootList.
 * Use `create(TrustRootListSchema)` to create a new message.
 */
export const TrustRootListSchema: GenMessage<TrustRootList> = /*@__PURE__*/
  messageDesc(file_zdc, 1269);

/**
 * @generated from message zdc.SaveTrustRootRequest
 */
export type SaveTrustRootRequest = Message<"zdc.SaveTrustRootRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string root_key_id = 2;
   */
  rootKeyId: string;

  /**
   * @generated from field: string alg = 3;
   */
  alg: string;

  /**
   * @generated from field: string public_key = 4;
   */
  publicKey: string;

  /**
   * @generated from field: string fingerprint = 5;
   */
  fingerprint: string;

  /**
   * @generated from field: string subject = 6;
   */
  subject: string;

  /**
   * @generated from field: string scope = 7;
   */
  scope: string;

  /**
   * @generated from field: string valid_from = 8;
   */
  validFrom: string;

  /**
   * @generated from field: string valid_until = 9;
   */
  validUntil: string;

  /**
   * @generated from field: bool is_active = 10;
   */
  isActive: boolean;
};

/**
 * Describes the message zdc.SaveTrustRootRequest.
 * Use `create(SaveTrustRootRequestSchema)` to create a new message.
 */
export const SaveTrustRootRequestSchema: GenMessage<SaveTrustRootRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1270);

/**
 * @generated from message zdc.DeleteTrustRootRequest
 */
export type DeleteTrustRootRequest = Message<"zdc.DeleteTrustRootRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteTrustRootRequest.
 * Use `create(DeleteTrustRootRequestSchema)` to create a new message.
 */
export const DeleteTrustRootRequestSchema: GenMessage<DeleteTrustRootRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1271);

/**
 * @generated from message zdc.TrustRootExportResponse
 */
export type TrustRootExportResponse = Message<"zdc.TrustRootExportResponse"> & {
  /**
   * @generated from field: string certificate = 1;
   */
  certificate: string;
};

/**
 * Describes the message zdc.TrustRootExportResponse.
 * Use `create(TrustRootExportResponseSchema)` to create a new message.
 */
export const TrustRootExportResponseSchema: GenMessage<TrustRootExportResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1272);

/**
 * @generated from message zdc.PublishArtifactRequest
 */
export type PublishArtifactRequest = Message<"zdc.PublishArtifactRequest"> & {
  /**
   * код артефакта (currencies/banks/…)
   *
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * пусто → patch-бамп предыдущей
   *
   * @generated from field: string version = 4;
   */
  version: string;

  /**
   * '' — общий; регион — отдельный поток seq
   *
   * @generated from field: string region = 5;
   */
  region: string;

  /**
   * таблица-источник
   *
   * @generated from field: string target_table = 6;
   */
  targetTable: string;

  /**
   * естественный ключ записи (default code)
   *
   * @generated from field: string key_field = 7;
   */
  keyField: string;

  /**
   * принудительный полный снапшот
   *
   * @generated from field: bool full = 8;
   */
  full: boolean;

  /**
   * срок signing-сертификата (0=365, -1=бессрочно)
   *
   * @generated from field: int32 validity_days = 9;
   */
  validityDays: number;

  /**
   * @generated from field: bool is_public = 10;
   */
  isPublic: boolean;

  /**
   * @generated from field: bool license_required = 11;
   */
  licenseRequired: boolean;
};

/**
 * Describes the message zdc.PublishArtifactRequest.
 * Use `create(PublishArtifactRequestSchema)` to create a new message.
 */
export const PublishArtifactRequestSchema: GenMessage<PublishArtifactRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1273);

/**
 * @generated from message zdc.PublishedArtifact
 */
export type PublishedArtifact = Message<"zdc.PublishedArtifact"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string version = 3;
   */
  version: string;

  /**
   * snapshot | delta
   *
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * @generated from field: int64 seq = 5;
   */
  seq: bigint;

  /**
   * @generated from field: int64 from_seq = 6;
   */
  fromSeq: bigint;

  /**
   * @generated from field: string region = 7;
   */
  region: string;

  /**
   * @generated from field: string content_hash = 8;
   */
  contentHash: string;

  /**
   * @generated from field: int64 size = 9;
   */
  size: bigint;

  /**
   * @generated from field: string file_name = 10;
   */
  fileName: string;

  /**
   * содержимое файла .hydra-ref (JSON)
   *
   * @generated from field: string envelope = 11;
   */
  envelope: string;

  /**
   * @generated from field: int32 ops = 12;
   */
  ops: number;

  /**
   * @generated from field: int32 records = 13;
   */
  records: number;
};

/**
 * Describes the message zdc.PublishedArtifact.
 * Use `create(PublishedArtifactSchema)` to create a new message.
 */
export const PublishedArtifactSchema: GenMessage<PublishedArtifact> = /*@__PURE__*/
  messageDesc(file_zdc, 1274);

/**
 * @generated from message zdc.PublishArtifactResponse
 */
export type PublishArtifactResponse = Message<"zdc.PublishArtifactResponse"> & {
  /**
   * @generated from field: zdc.PublishedArtifact artifact = 1;
   */
  artifact?: PublishedArtifact | undefined;

  /**
   * отправлено в центр (federation.publish_to_hub)
   *
   * @generated from field: bool hub_published = 2;
   */
  hubPublished: boolean;

  /**
   * причина, если отправка в центр не выполнена ('' = ок)
   *
   * @generated from field: string hub_error = 3;
   */
  hubError: string;
};

/**
 * Describes the message zdc.PublishArtifactResponse.
 * Use `create(PublishArtifactResponseSchema)` to create a new message.
 */
export const PublishArtifactResponseSchema: GenMessage<PublishArtifactResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1275);

/**
 * @generated from message zdc.PublishedArtifactInfo
 */
export type PublishedArtifactInfo = Message<"zdc.PublishedArtifactInfo"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string synonym = 3;
   */
  synonym: string;

  /**
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * @generated from field: string version = 5;
   */
  version: string;

  /**
   * @generated from field: int64 seq = 6;
   */
  seq: bigint;

  /**
   * @generated from field: string region = 7;
   */
  region: string;

  /**
   * @generated from field: string content_hash = 8;
   */
  contentHash: string;

  /**
   * @generated from field: int64 size = 9;
   */
  size: bigint;

  /**
   * @generated from field: string signing_key_id = 10;
   */
  signingKeyId: string;

  /**
   * @generated from field: string published_at = 11;
   */
  publishedAt: string;
};

/**
 * Describes the message zdc.PublishedArtifactInfo.
 * Use `create(PublishedArtifactInfoSchema)` to create a new message.
 */
export const PublishedArtifactInfoSchema: GenMessage<PublishedArtifactInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 1276);

/**
 * @generated from message zdc.ListPublishedArtifactsRequest
 */
export type ListPublishedArtifactsRequest = Message<"zdc.ListPublishedArtifactsRequest"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message zdc.ListPublishedArtifactsRequest.
 * Use `create(ListPublishedArtifactsRequestSchema)` to create a new message.
 */
export const ListPublishedArtifactsRequestSchema: GenMessage<ListPublishedArtifactsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1277);

/**
 * @generated from message zdc.ListPublishedArtifactsResponse
 */
export type ListPublishedArtifactsResponse = Message<"zdc.ListPublishedArtifactsResponse"> & {
  /**
   * @generated from field: repeated zdc.PublishedArtifactInfo items = 1;
   */
  items: PublishedArtifactInfo[];
};

/**
 * Describes the message zdc.ListPublishedArtifactsResponse.
 * Use `create(ListPublishedArtifactsResponseSchema)` to create a new message.
 */
export const ListPublishedArtifactsResponseSchema: GenMessage<ListPublishedArtifactsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1278);

/**
 * @generated from message zdc.GetArtifactFileRequest
 */
export type GetArtifactFileRequest = Message<"zdc.GetArtifactFileRequest"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: string region = 2;
   */
  region: string;

  /**
   * @generated from field: int64 seq = 3;
   */
  seq: bigint;
};

/**
 * Describes the message zdc.GetArtifactFileRequest.
 * Use `create(GetArtifactFileRequestSchema)` to create a new message.
 */
export const GetArtifactFileRequestSchema: GenMessage<GetArtifactFileRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1279);

/**
 * @generated from message zdc.ArtifactFileResponse
 */
export type ArtifactFileResponse = Message<"zdc.ArtifactFileResponse"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * @generated from field: string artifact_id = 3;
   */
  artifactId: string;

  /**
   * @generated from field: int64 seq = 4;
   */
  seq: bigint;
};

/**
 * Describes the message zdc.ArtifactFileResponse.
 * Use `create(ArtifactFileResponseSchema)` to create a new message.
 */
export const ArtifactFileResponseSchema: GenMessage<ArtifactFileResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1280);

/**
 * @generated from message zdc.ImportArtifactRequest
 */
export type ImportArtifactRequest = Message<"zdc.ImportArtifactRequest"> & {
  /**
   * файл .hydra-ref (JSON)
   *
   * @generated from field: string content = 1;
   */
  content: string;

  /**
   * таблица назначения (пусто — ранее применённая)
   *
   * @generated from field: string target_table = 2;
   */
  targetTable: string;

  /**
   * file | ui | conflict
   *
   * @generated from field: string source = 3;
   */
  source: string;
};

/**
 * Describes the message zdc.ImportArtifactRequest.
 * Use `create(ImportArtifactRequestSchema)` to create a new message.
 */
export const ImportArtifactRequestSchema: GenMessage<ImportArtifactRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1281);

/**
 * @generated from message zdc.ApplyResult
 */
export type ApplyResult = Message<"zdc.ApplyResult"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * apply | noop | rollback
   *
   * @generated from field: string action = 3;
   */
  action: string;

  /**
   * @generated from field: int64 from_seq = 4;
   */
  fromSeq: bigint;

  /**
   * @generated from field: int64 to_seq = 5;
   */
  toSeq: bigint;

  /**
   * @generated from field: int64 applied_seq = 6;
   */
  appliedSeq: bigint;

  /**
   * @generated from field: int32 rows = 7;
   */
  rows: number;

  /**
   * @generated from field: string target_table = 8;
   */
  targetTable: string;
};

/**
 * Describes the message zdc.ApplyResult.
 * Use `create(ApplyResultSchema)` to create a new message.
 */
export const ApplyResultSchema: GenMessage<ApplyResult> = /*@__PURE__*/
  messageDesc(file_zdc, 1282);

/**
 * @generated from message zdc.RollbackArtifactRequest
 */
export type RollbackArtifactRequest = Message<"zdc.RollbackArtifactRequest"> & {
  /**
   * @generated from field: string content = 1;
   */
  content: string;

  /**
   * @generated from field: string target_table = 2;
   */
  targetTable: string;
};

/**
 * Describes the message zdc.RollbackArtifactRequest.
 * Use `create(RollbackArtifactRequestSchema)` to create a new message.
 */
export const RollbackArtifactRequestSchema: GenMessage<RollbackArtifactRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1283);

/**
 * @generated from message zdc.ArtifactAppliedInfo
 */
export type ArtifactAppliedInfo = Message<"zdc.ArtifactAppliedInfo"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: string region = 2;
   */
  region: string;

  /**
   * @generated from field: int64 seq = 3;
   */
  seq: bigint;

  /**
   * @generated from field: string content_hash = 4;
   */
  contentHash: string;

  /**
   * @generated from field: string applied_at = 5;
   */
  appliedAt: string;

  /**
   * @generated from field: string target_table = 6;
   */
  targetTable: string;
};

/**
 * Describes the message zdc.ArtifactAppliedInfo.
 * Use `create(ArtifactAppliedInfoSchema)` to create a new message.
 */
export const ArtifactAppliedInfoSchema: GenMessage<ArtifactAppliedInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 1284);

/**
 * @generated from message zdc.ListInstalledArtifactsResponse
 */
export type ListInstalledArtifactsResponse = Message<"zdc.ListInstalledArtifactsResponse"> & {
  /**
   * @generated from field: repeated zdc.ArtifactAppliedInfo items = 1;
   */
  items: ArtifactAppliedInfo[];
};

/**
 * Describes the message zdc.ListInstalledArtifactsResponse.
 * Use `create(ListInstalledArtifactsResponseSchema)` to create a new message.
 */
export const ListInstalledArtifactsResponseSchema: GenMessage<ListInstalledArtifactsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1285);

/**
 * @generated from message zdc.ArtifactStatusRequest
 */
export type ArtifactStatusRequest = Message<"zdc.ArtifactStatusRequest"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: string region = 2;
   */
  region: string;
};

/**
 * Describes the message zdc.ArtifactStatusRequest.
 * Use `create(ArtifactStatusRequestSchema)` to create a new message.
 */
export const ArtifactStatusRequestSchema: GenMessage<ArtifactStatusRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1286);

/**
 * @generated from message zdc.ArtifactStatusResponse
 */
export type ArtifactStatusResponse = Message<"zdc.ArtifactStatusResponse"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: string region = 2;
   */
  region: string;

  /**
   * @generated from field: int64 published_seq = 3;
   */
  publishedSeq: bigint;

  /**
   * @generated from field: string published_kind = 4;
   */
  publishedKind: string;

  /**
   * @generated from field: string published_at = 5;
   */
  publishedAt: string;

  /**
   * @generated from field: int64 applied_seq = 6;
   */
  appliedSeq: bigint;

  /**
   * @generated from field: string applied_at = 7;
   */
  appliedAt: string;

  /**
   * @generated from field: string applied_hash = 8;
   */
  appliedHash: string;

  /**
   * @generated from field: string target_table = 9;
   */
  targetTable: string;

  /**
   * @generated from field: bool trust_root_found = 10;
   */
  trustRootFound: boolean;

  /**
   * @generated from field: bool subscribed = 11;
   */
  subscribed: boolean;

  /**
   * @generated from field: bool subscription_enabled = 12;
   */
  subscriptionEnabled: boolean;
};

/**
 * Describes the message zdc.ArtifactStatusResponse.
 * Use `create(ArtifactStatusResponseSchema)` to create a new message.
 */
export const ArtifactStatusResponseSchema: GenMessage<ArtifactStatusResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1287);

/**
 * @generated from message zdc.SubscriptionInfo
 */
export type SubscriptionInfo = Message<"zdc.SubscriptionInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string artifact_id = 2;
   */
  artifactId: string;

  /**
   * @generated from field: string region = 3;
   */
  region: string;

  /**
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;

  /**
   * @generated from field: string trust_root_fingerprint = 5;
   */
  trustRootFingerprint: string;

  /**
   * @generated from field: string updated_at = 6;
   */
  updatedAt: string;

  /**
   * @generated from field: string updated_by = 7;
   */
  updatedBy: string;

  /**
   * адрес центра-источника ('' = federation.hub_url базы)
   *
   * @generated from field: string source_url = 8;
   */
  sourceUrl: string;

  /**
   * таблица назначения ('' = из состояния применения)
   *
   * @generated from field: string target_table = 9;
   */
  targetTable: string;
};

/**
 * Describes the message zdc.SubscriptionInfo.
 * Use `create(SubscriptionInfoSchema)` to create a new message.
 */
export const SubscriptionInfoSchema: GenMessage<SubscriptionInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 1288);

/**
 * @generated from message zdc.ListSubscriptionsResponse
 */
export type ListSubscriptionsResponse = Message<"zdc.ListSubscriptionsResponse"> & {
  /**
   * @generated from field: repeated zdc.SubscriptionInfo items = 1;
   */
  items: SubscriptionInfo[];
};

/**
 * Describes the message zdc.ListSubscriptionsResponse.
 * Use `create(ListSubscriptionsResponseSchema)` to create a new message.
 */
export const ListSubscriptionsResponseSchema: GenMessage<ListSubscriptionsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1289);

/**
 * @generated from message zdc.SaveSubscriptionRequest
 */
export type SaveSubscriptionRequest = Message<"zdc.SaveSubscriptionRequest"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: string region = 2;
   */
  region: string;

  /**
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;

  /**
   * @generated from field: string trust_root_fingerprint = 4;
   */
  trustRootFingerprint: string;

  /**
   * '' = federation.hub_url базы
   *
   * @generated from field: string source_url = 5;
   */
  sourceUrl: string;

  /**
   * '' = из состояния применения
   *
   * @generated from field: string target_table = 6;
   */
  targetTable: string;
};

/**
 * Describes the message zdc.SaveSubscriptionRequest.
 * Use `create(SaveSubscriptionRequestSchema)` to create a new message.
 */
export const SaveSubscriptionRequestSchema: GenMessage<SaveSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1290);

/**
 * @generated from message zdc.DeleteSubscriptionRequest
 */
export type DeleteSubscriptionRequest = Message<"zdc.DeleteSubscriptionRequest"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: string region = 2;
   */
  region: string;
};

/**
 * Describes the message zdc.DeleteSubscriptionRequest.
 * Use `create(DeleteSubscriptionRequestSchema)` to create a new message.
 */
export const DeleteSubscriptionRequestSchema: GenMessage<DeleteSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1291);

/**
 * Догон обновлений с центра (Ф2): результат по одной подписке.
 *
 * @generated from message zdc.PullSubscriptionResult
 */
export type PullSubscriptionResult = Message<"zdc.PullSubscriptionResult"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: string region = 2;
   */
  region: string;

  /**
   * адрес источника (центр/партнёр)
   *
   * @generated from field: string source = 3;
   */
  source: string;

  /**
   * @generated from field: int64 from_seq = 4;
   */
  fromSeq: bigint;

  /**
   * @generated from field: int64 to_seq = 5;
   */
  toSeq: bigint;

  /**
   * applied|up_to_date|error
   *
   * @generated from field: string action = 6;
   */
  action: string;

  /**
   * целевая таблица применения
   *
   * @generated from field: string target = 7;
   */
  target: string;

  /**
   * @generated from field: int64 rows = 8;
   */
  rows: bigint;

  /**
   * @generated from field: string error = 9;
   */
  error: string;
};

/**
 * Describes the message zdc.PullSubscriptionResult.
 * Use `create(PullSubscriptionResultSchema)` to create a new message.
 */
export const PullSubscriptionResultSchema: GenMessage<PullSubscriptionResult> = /*@__PURE__*/
  messageDesc(file_zdc, 1292);

/**
 * @generated from message zdc.PullArtifactUpdatesRequest
 */
export type PullArtifactUpdatesRequest = Message<"zdc.PullArtifactUpdatesRequest"> & {
  /**
   * пусто = все включённые подписки
   *
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;
};

/**
 * Describes the message zdc.PullArtifactUpdatesRequest.
 * Use `create(PullArtifactUpdatesRequestSchema)` to create a new message.
 */
export const PullArtifactUpdatesRequestSchema: GenMessage<PullArtifactUpdatesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1293);

/**
 * @generated from message zdc.PullArtifactUpdatesResponse
 */
export type PullArtifactUpdatesResponse = Message<"zdc.PullArtifactUpdatesResponse"> & {
  /**
   * @generated from field: repeated zdc.PullSubscriptionResult items = 1;
   */
  items: PullSubscriptionResult[];

  /**
   * @generated from field: int32 applied = 2;
   */
  applied: number;

  /**
   * @generated from field: int32 failed = 3;
   */
  failed: number;

  /**
   * @generated from field: int32 up_to_date = 4;
   */
  upToDate: number;
};

/**
 * Describes the message zdc.PullArtifactUpdatesResponse.
 * Use `create(PullArtifactUpdatesResponseSchema)` to create a new message.
 */
export const PullArtifactUpdatesResponseSchema: GenMessage<PullArtifactUpdatesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1294);

/**
 * Федеративные настройки базы (вкладка «Сеть»): адрес центра, интервал догона,
 * авто-публикация. Ключ издателя центра — секрет базы (только флаг *_set).
 *
 * @generated from message zdc.FederationSettingsInfo
 */
export type FederationSettingsInfo = Message<"zdc.FederationSettingsInfo"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * off|direct|hub ('' = hub)
   *
   * @generated from field: string mode = 2;
   */
  mode: string;

  /**
   * @generated from field: string hub_url = 3;
   */
  hubUrl: string;

  /**
   * own|partners|open
   *
   * @generated from field: string trust_mode = 4;
   */
  trustMode: string;

  /**
   * минуты (0 = вручную)
   *
   * @generated from field: int32 pull_interval = 5;
   */
  pullInterval: number;

  /**
   * @generated from field: bool publish_to_hub = 6;
   */
  publishToHub: boolean;

  /**
   * @generated from field: bool publisher_key_set = 7;
   */
  publisherKeySet: boolean;

  /**
   * Межбазовый чат (волна 1b): по умолчанию ВЫКЛ (fail-closed).
   *
   * @generated from field: bool chat_enabled = 8;
   */
  chatEnabled: boolean;

  /**
   * Allow-list входящих конвертов: did:hydra:<uuid>[*] | hid:<цифры>.
   * Пустой список при включённом чате — принимаем НИКОГО.
   *
   * @generated from field: repeated string chat_allow = 9;
   */
  chatAllow: string[];

  /**
   * Суточные лимиты трафика межбазового чата (0 = без лимита): исходящие
   * сообщения/байты за сутки (UTC). Превышение: исходящие остаются локальными,
   * входящие сверх лимита отклоняются (fail-closed).
   *
   * @generated from field: int32 chat_daily_messages = 10;
   */
  chatDailyMessages: number;

  /**
   * @generated from field: int64 chat_daily_bytes = 11;
   */
  chatDailyBytes: bigint;
};

/**
 * Describes the message zdc.FederationSettingsInfo.
 * Use `create(FederationSettingsInfoSchema)` to create a new message.
 */
export const FederationSettingsInfoSchema: GenMessage<FederationSettingsInfo> = /*@__PURE__*/
  messageDesc(file_zdc, 1295);

/**
 * @generated from message zdc.SetFederationSettingsRequest
 */
export type SetFederationSettingsRequest = Message<"zdc.SetFederationSettingsRequest"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: string mode = 2;
   */
  mode: string;

  /**
   * @generated from field: string hub_url = 3;
   */
  hubUrl: string;

  /**
   * @generated from field: string trust_mode = 4;
   */
  trustMode: string;

  /**
   * @generated from field: int32 pull_interval = 5;
   */
  pullInterval: number;

  /**
   * @generated from field: bool publish_to_hub = 6;
   */
  publishToHub: boolean;

  /**
   * пусто = не менять
   *
   * @generated from field: string publisher_key = 7;
   */
  publisherKey: string;

  /**
   * true = удалить ключ
   *
   * @generated from field: bool clear_publisher_key = 8;
   */
  clearPublisherKey: boolean;

  /**
   * Межбазовый чат: поля применяются ВМЕСТЕ; chat_enabled НЕ задан → chat_allow
   * не применяется (сохранение вкладки «Сеть» без полей не затирает чат).
   *
   * @generated from field: optional bool chat_enabled = 9;
   */
  chatEnabled?: boolean | undefined;

  /**
   * при заданном chat_enabled — полная замена
   *
   * @generated from field: repeated string chat_allow = 10;
   */
  chatAllow: string[];

  /**
   * Суточные лимиты трафика межбазового чата (presence: не задан → не менять;
   * 0 — снять лимит).
   *
   * @generated from field: optional int32 chat_daily_messages = 11;
   */
  chatDailyMessages?: number | undefined;

  /**
   * @generated from field: optional int64 chat_daily_bytes = 12;
   */
  chatDailyBytes?: bigint | undefined;
};

/**
 * Describes the message zdc.SetFederationSettingsRequest.
 * Use `create(SetFederationSettingsRequestSchema)` to create a new message.
 */
export const SetFederationSettingsRequestSchema: GenMessage<SetFederationSettingsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1296);

/**
 * @generated from message zdc.PingHubResponse
 */
export type PingHubResponse = Message<"zdc.PingHubResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: int64 duration_ms = 2;
   */
  durationMs: bigint;

  /**
   * @generated from field: string hub_url = 3;
   */
  hubUrl: string;

  /**
   * @generated from field: string error = 4;
   */
  error: string;
};

/**
 * Describes the message zdc.PingHubResponse.
 * Use `create(PingHubResponseSchema)` to create a new message.
 */
export const PingHubResponseSchema: GenMessage<PingHubResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1297);

/**
 * ============================================================================
 * МЕЖБАЗОВЫЙ ЧАТ ЧЕРЕЗ ХАБ (волна 1b): личные сообщения между пользователями
 * РАЗНЫХ баз через центр (store-and-forward), доставка — в ЕДИНЫЙ direct-чат
 * платформы. ВАЖНО: сквозного шифрования НЕТ — подпись гарантирует авторство и
 * целостность, но текст виден инфраструктуре центра (явная фиксация в ТЗ).
 * ============================================================================
 *
 * @generated from message zdc.StartFedChatRequest
 */
export type StartFedChatRequest = Message<"zdc.StartFedChatRequest"> & {
  /**
   * номер собеседника (AAA BBB CCC D)
   *
   * @generated from field: string hydra_id = 1;
   */
  hydraId: string;
};

/**
 * Describes the message zdc.StartFedChatRequest.
 * Use `create(StartFedChatRequestSchema)` to create a new message.
 */
export const StartFedChatRequestSchema: GenMessage<StartFedChatRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1298);

/**
 * @generated from message zdc.StartFedChatResponse
 */
export type StartFedChatResponse = Message<"zdc.StartFedChatResponse"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * канонический номер (10 цифр)
   *
   * @generated from field: string hydra_id = 2;
   */
  hydraId: string;

  /**
   * локальная метка («Пользователь AAA BBB CCC D»)
   *
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * person|bot|persona
   *
   * @generated from field: string subject_type = 4;
   */
  subjectType: string;

  /**
   * true = номер этой базы (обычный чат, без центра)
   *
   * @generated from field: bool local = 5;
   */
  local: boolean;
};

/**
 * Describes the message zdc.StartFedChatResponse.
 * Use `create(StartFedChatResponseSchema)` to create a new message.
 */
export const StartFedChatResponseSchema: GenMessage<StartFedChatResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1299);

/**
 * Блокировка собеседника межбазового чата (fed_peer_blocks): локальное
 * решение базы, действует в ОБЕ стороны — конверты от адресата отклоняются,
 * сообщения ему не ставятся в очередь (остаются локальными).
 *
 * @generated from message zdc.FedPeerBlock
 */
export type FedPeerBlock = Message<"zdc.FedPeerBlock"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * канонический адресат: did:hydra:<uuid> | hid:<10 цифр>
   *
   * @generated from field: string target = 2;
   */
  target: string;

  /**
   * DID базы собеседника (если известен)
   *
   * @generated from field: string did = 3;
   */
  did: string;

  /**
   * номер собеседника (если известен)
   *
   * @generated from field: string hydra_id = 4;
   */
  hydraId: string;

  /**
   * причина (необязательно)
   *
   * @generated from field: string reason = 5;
   */
  reason: string;

  /**
   * @generated from field: string created_by = 6;
   */
  createdBy: string;

  /**
   * @generated from field: string created_at = 7;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.FedPeerBlock.
 * Use `create(FedPeerBlockSchema)` to create a new message.
 */
export const FedPeerBlockSchema: GenMessage<FedPeerBlock> = /*@__PURE__*/
  messageDesc(file_zdc, 1300);

/**
 * @generated from message zdc.BlockFedPeerRequest
 */
export type BlockFedPeerRequest = Message<"zdc.BlockFedPeerRequest"> & {
  /**
   * did:hydra:<uuid> | hid:<цифры>
   *
   * @generated from field: string peer = 1;
   */
  peer: string;

  /**
   * причина (необязательно)
   *
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message zdc.BlockFedPeerRequest.
 * Use `create(BlockFedPeerRequestSchema)` to create a new message.
 */
export const BlockFedPeerRequestSchema: GenMessage<BlockFedPeerRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1301);

/**
 * @generated from message zdc.UnblockFedPeerRequest
 */
export type UnblockFedPeerRequest = Message<"zdc.UnblockFedPeerRequest"> & {
  /**
   * адресат блокировки (принимается любой известный ключ)
   *
   * @generated from field: string peer = 1;
   */
  peer: string;
};

/**
 * Describes the message zdc.UnblockFedPeerRequest.
 * Use `create(UnblockFedPeerRequestSchema)` to create a new message.
 */
export const UnblockFedPeerRequestSchema: GenMessage<UnblockFedPeerRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1302);

/**
 * @generated from message zdc.ListBlockedFedPeersRequest
 */
export type ListBlockedFedPeersRequest = Message<"zdc.ListBlockedFedPeersRequest"> & {
};

/**
 * Describes the message zdc.ListBlockedFedPeersRequest.
 * Use `create(ListBlockedFedPeersRequestSchema)` to create a new message.
 */
export const ListBlockedFedPeersRequestSchema: GenMessage<ListBlockedFedPeersRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1303);

/**
 * @generated from message zdc.ListBlockedFedPeersResponse
 */
export type ListBlockedFedPeersResponse = Message<"zdc.ListBlockedFedPeersResponse"> & {
  /**
   * @generated from field: repeated zdc.FedPeerBlock items = 1;
   */
  items: FedPeerBlock[];
};

/**
 * Describes the message zdc.ListBlockedFedPeersResponse.
 * Use `create(ListBlockedFedPeersResponseSchema)` to create a new message.
 */
export const ListBlockedFedPeersResponseSchema: GenMessage<ListBlockedFedPeersResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1304);

/**
 * ============================================================================
 * ГОЛОСОВЫЕ КОМНАТЫ (волна 2, D7): постоянные комнаты как в Discord/Telegram —
 * вошёл-вышел, видно «кто внутри». Состояние и присутствие ведёт СЕРВЕР
 * (voice_rooms/voice_room_members), медиа — LiveKit (комната voice_<roomId>,
 * пропуск выдаёт GetRoomToken существующим механизмом LiveKit). Права:
 * публичная комната — вход всем авторизованным; приватная — по ролям
 * (settings.role_ids — имена ролей, как в JWT/section_roles); управление —
 * создатель/модератор/админ. События шины (live-обновление клиентов):
 * voice.room.joined|left|updated|deleted.{roomId}.
 * ============================================================================
 *
 * @generated from message zdc.VoiceRoomSettings
 */
export type VoiceRoomSettings = Message<"zdc.VoiceRoomSettings"> & {
  /**
   * 0 = без ограничения
   *
   * @generated from field: int32 max_participants = 1;
   */
  maxParticipants: number;

  /**
   * true — вход всем авторизованным
   *
   * @generated from field: bool is_public = 2;
   */
  isPublic: boolean;

  /**
   * роли доступа к приватной комнате (ИМЕНА ролей)
   *
   * @generated from field: repeated string role_ids = 3;
   */
  roleIds: string[];
};

/**
 * Describes the message zdc.VoiceRoomSettings.
 * Use `create(VoiceRoomSettingsSchema)` to create a new message.
 */
export const VoiceRoomSettingsSchema: GenMessage<VoiceRoomSettings> = /*@__PURE__*/
  messageDesc(file_zdc, 1305);

/**
 * @generated from message zdc.VoiceRoomMember
 */
export type VoiceRoomMember = Message<"zdc.VoiceRoomMember"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string entity_name = 2;
   */
  entityName: string;

  /**
   * moderator | speaker | listener
   *
   * @generated from field: string role = 3;
   */
  role: string;

  /**
   * active | left
   *
   * @generated from field: string state = 4;
   */
  state: string;

  /**
   * микрофон выключил сам
   *
   * @generated from field: bool muted_self = 5;
   */
  mutedSelf: boolean;

  /**
   * микрофон выключил модератор
   *
   * @generated from field: bool muted_by = 6;
   */
  mutedBy: boolean;

  /**
   * @generated from field: string joined_at = 7;
   */
  joinedAt: string;
};

/**
 * Describes the message zdc.VoiceRoomMember.
 * Use `create(VoiceRoomMemberSchema)` to create a new message.
 */
export const VoiceRoomMemberSchema: GenMessage<VoiceRoomMember> = /*@__PURE__*/
  messageDesc(file_zdc, 1306);

/**
 * @generated from message zdc.VoiceRoom
 */
export type VoiceRoom = Message<"zdc.VoiceRoom"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string topic = 4;
   */
  topic: string;

  /**
   * постоянная комната (не разовая)
   *
   * @generated from field: bool is_persistent = 5;
   */
  isPersistent: boolean;

  /**
   * @generated from field: string created_by = 6;
   */
  createdBy: string;

  /**
   * @generated from field: string creator_name = 7;
   */
  creatorName: string;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 9;
   */
  updatedAt: string;

  /**
   * @generated from field: zdc.VoiceRoomSettings settings = 10;
   */
  settings?: VoiceRoomSettings | undefined;

  /**
   * участники с состоянием (GetRoom/мутации)
   *
   * @generated from field: repeated zdc.VoiceRoomMember members = 11;
   */
  members: VoiceRoomMember[];

  /**
   * «кто внутри» сейчас
   *
   * @generated from field: int32 active_count = 12;
   */
  activeCount: number;
};

/**
 * Describes the message zdc.VoiceRoom.
 * Use `create(VoiceRoomSchema)` to create a new message.
 */
export const VoiceRoomSchema: GenMessage<VoiceRoom> = /*@__PURE__*/
  messageDesc(file_zdc, 1307);

/**
 * @generated from message zdc.CreateVoiceRoomRequest
 */
export type CreateVoiceRoomRequest = Message<"zdc.CreateVoiceRoomRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string topic = 2;
   */
  topic: string;

  /**
   * @generated from field: bool is_persistent = 3;
   */
  isPersistent: boolean;

  /**
   * @generated from field: zdc.VoiceRoomSettings settings = 4;
   */
  settings?: VoiceRoomSettings | undefined;
};

/**
 * Describes the message zdc.CreateVoiceRoomRequest.
 * Use `create(CreateVoiceRoomRequestSchema)` to create a new message.
 */
export const CreateVoiceRoomRequestSchema: GenMessage<CreateVoiceRoomRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1308);

/**
 * @generated from message zdc.ListVoiceRoomsRequest
 */
export type ListVoiceRoomsRequest = Message<"zdc.ListVoiceRoomsRequest"> & {
  /**
   * true — только созданные/с участием текущего
   *
   * @generated from field: bool only_mine = 1;
   */
  onlyMine: boolean;
};

/**
 * Describes the message zdc.ListVoiceRoomsRequest.
 * Use `create(ListVoiceRoomsRequestSchema)` to create a new message.
 */
export const ListVoiceRoomsRequestSchema: GenMessage<ListVoiceRoomsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1309);

/**
 * @generated from message zdc.ListVoiceRoomsResponse
 */
export type ListVoiceRoomsResponse = Message<"zdc.ListVoiceRoomsResponse"> & {
  /**
   * @generated from field: repeated zdc.VoiceRoom items = 1;
   */
  items: VoiceRoom[];
};

/**
 * Describes the message zdc.ListVoiceRoomsResponse.
 * Use `create(ListVoiceRoomsResponseSchema)` to create a new message.
 */
export const ListVoiceRoomsResponseSchema: GenMessage<ListVoiceRoomsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1310);

/**
 * @generated from message zdc.GetVoiceRoomRequest
 */
export type GetVoiceRoomRequest = Message<"zdc.GetVoiceRoomRequest"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;
};

/**
 * Describes the message zdc.GetVoiceRoomRequest.
 * Use `create(GetVoiceRoomRequestSchema)` to create a new message.
 */
export const GetVoiceRoomRequestSchema: GenMessage<GetVoiceRoomRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1311);

/**
 * @generated from message zdc.UpdateVoiceRoomRequest
 */
export type UpdateVoiceRoomRequest = Message<"zdc.UpdateVoiceRoomRequest"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * presence: не задано — не менять
   *
   * @generated from field: optional string name = 2;
   */
  name?: string | undefined;

  /**
   * @generated from field: optional string topic = 3;
   */
  topic?: string | undefined;

  /**
   * @generated from field: optional bool is_persistent = 4;
   */
  isPersistent?: boolean | undefined;

  /**
   * задано — полная замена настроек
   *
   * @generated from field: zdc.VoiceRoomSettings settings = 5;
   */
  settings?: VoiceRoomSettings | undefined;
};

/**
 * Describes the message zdc.UpdateVoiceRoomRequest.
 * Use `create(UpdateVoiceRoomRequestSchema)` to create a new message.
 */
export const UpdateVoiceRoomRequestSchema: GenMessage<UpdateVoiceRoomRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1312);

/**
 * @generated from message zdc.DeleteVoiceRoomRequest
 */
export type DeleteVoiceRoomRequest = Message<"zdc.DeleteVoiceRoomRequest"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;
};

/**
 * Describes the message zdc.DeleteVoiceRoomRequest.
 * Use `create(DeleteVoiceRoomRequestSchema)` to create a new message.
 */
export const DeleteVoiceRoomRequestSchema: GenMessage<DeleteVoiceRoomRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1313);

/**
 * @generated from message zdc.JoinVoiceRoomRequest
 */
export type JoinVoiceRoomRequest = Message<"zdc.JoinVoiceRoomRequest"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * войти с выключенным микрофоном
   *
   * @generated from field: bool muted_self = 2;
   */
  mutedSelf: boolean;
};

/**
 * Describes the message zdc.JoinVoiceRoomRequest.
 * Use `create(JoinVoiceRoomRequestSchema)` to create a new message.
 */
export const JoinVoiceRoomRequestSchema: GenMessage<JoinVoiceRoomRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1314);

/**
 * @generated from message zdc.LeaveVoiceRoomRequest
 */
export type LeaveVoiceRoomRequest = Message<"zdc.LeaveVoiceRoomRequest"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;
};

/**
 * Describes the message zdc.LeaveVoiceRoomRequest.
 * Use `create(LeaveVoiceRoomRequestSchema)` to create a new message.
 */
export const LeaveVoiceRoomRequestSchema: GenMessage<LeaveVoiceRoomRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1315);

/**
 * @generated from message zdc.SetVoiceRoomMemberRoleRequest
 */
export type SetVoiceRoomMemberRoleRequest = Message<"zdc.SetVoiceRoomMemberRoleRequest"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * moderator | speaker | listener
   *
   * @generated from field: string role = 3;
   */
  role: string;
};

/**
 * Describes the message zdc.SetVoiceRoomMemberRoleRequest.
 * Use `create(SetVoiceRoomMemberRoleRequestSchema)` to create a new message.
 */
export const SetVoiceRoomMemberRoleRequestSchema: GenMessage<SetVoiceRoomMemberRoleRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1316);

/**
 * @generated from message zdc.MuteVoiceRoomMemberRequest
 */
export type MuteVoiceRoomMemberRequest = Message<"zdc.MuteVoiceRoomMemberRequest"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * true — выключить микрофон участнику
   *
   * @generated from field: bool muted = 3;
   */
  muted: boolean;
};

/**
 * Describes the message zdc.MuteVoiceRoomMemberRequest.
 * Use `create(MuteVoiceRoomMemberRequestSchema)` to create a new message.
 */
export const MuteVoiceRoomMemberRequestSchema: GenMessage<MuteVoiceRoomMemberRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1317);

/**
 * @generated from message zdc.GetVoiceRoomTokenRequest
 */
export type GetVoiceRoomTokenRequest = Message<"zdc.GetVoiceRoomTokenRequest"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;
};

/**
 * Describes the message zdc.GetVoiceRoomTokenRequest.
 * Use `create(GetVoiceRoomTokenRequestSchema)` to create a new message.
 */
export const GetVoiceRoomTokenRequestSchema: GenMessage<GetVoiceRoomTokenRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1318);

/**
 * @generated from message zdc.GetVoiceRoomTokenResponse
 */
export type GetVoiceRoomTokenResponse = Message<"zdc.GetVoiceRoomTokenResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * адрес LiveKit (с сервера)
   *
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * имя комнаты LiveKit: voice_<roomId>
   *
   * @generated from field: string room = 3;
   */
  room: string;
};

/**
 * Describes the message zdc.GetVoiceRoomTokenResponse.
 * Use `create(GetVoiceRoomTokenResponseSchema)` to create a new message.
 */
export const GetVoiceRoomTokenResponseSchema: GenMessage<GetVoiceRoomTokenResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1319);

/**
 * ============================================================================
 * ИНБОКС ПОДДЕРЖКИ (§3.4, этап 1): обращения пользователей к «Поддержке» как
 * очередь работы специалистов. Обращение — НАДСТРОЙКА над существующим
 * механизмом «Поддержка» (роль/контакт/разлёт, БЕЗ дублирования чатов):
 * одно обращение на ЛИЧНЫЙ чат пользователя с ботом «Поддержка»
 * (conversation_id уникален), обновляется при каждом новом сообщении
 * пользователя; «решено» переоткрывается новым сообщением (status → new).
 * Статусы: new | in_progress | resolved; приоритет: low | normal | high;
 * канал-источник: chat ('' = внутренний чат), будущие мосты Telegram/MAX.
 * Права: роль «Поддержка» (support) или админ — весь инбокс; пользователь —
 * только СВОИ обращения. События шины (live-обновление):
 * support.ticket.created, support.ticket.updated.{id}.
 * ============================================================================
 *
 * @generated from message zdc.SupportTicket
 */
export type SupportTicket = Message<"zdc.SupportTicket"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * личный чат пользователя с «Поддержкой»
   *
   * @generated from field: string conversation_id = 2;
   */
  conversationId: string;

  /**
   * @generated from field: string requester_id = 3;
   */
  requesterId: string;

  /**
   * @generated from field: string requester_name = 4;
   */
  requesterName: string;

  /**
   * первая строка обращения (≤200)
   *
   * @generated from field: string subject = 5;
   */
  subject: string;

  /**
   * new | in_progress | resolved
   *
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * low | normal | high
   *
   * @generated from field: string priority = 7;
   */
  priority: string;

  /**
   * chat | telegram | max ...
   *
   * @generated from field: string channel = 8;
   */
  channel: string;

  /**
   * назначенный специалист
   *
   * @generated from field: string assigned_to = 9;
   */
  assignedTo: string;

  /**
   * @generated from field: string assigned_name = 10;
   */
  assignedName: string;

  /**
   * @generated from field: string assigned_at = 11;
   */
  assignedAt: string;

  /**
   * @generated from field: string resolved_at = 12;
   */
  resolvedAt: string;

  /**
   * последнее сообщение пользователя
   *
   * @generated from field: string last_message_at = 13;
   */
  lastMessageAt: string;

  /**
   * последний ответ поддержки
   *
   * @generated from field: string last_reply_at = 14;
   */
  lastReplyAt: string;

  /**
   * число сообщений пользователя
   *
   * @generated from field: int32 message_count = 15;
   */
  messageCount: number;

  /**
   * @generated from field: string created_at = 16;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 17;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.SupportTicket.
 * Use `create(SupportTicketSchema)` to create a new message.
 */
export const SupportTicketSchema: GenMessage<SupportTicket> = /*@__PURE__*/
  messageDesc(file_zdc, 1320);

/**
 * @generated from message zdc.ListSupportTicketsRequest
 */
export type ListSupportTicketsRequest = Message<"zdc.ListSupportTicketsRequest"> & {
  /**
   * '' = все
   *
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * '' = все | 'me' | 'none' | id пользователя
   *
   * @generated from field: string assigned = 2;
   */
  assigned: string;

  /**
   * '' = все
   *
   * @generated from field: string channel = 3;
   */
  channel: string;

  /**
   * поиск по теме обращения
   *
   * @generated from field: string search = 4;
   */
  search: string;

  /**
   * default 50, максимум 200
   *
   * @generated from field: int32 page_size = 5;
   */
  pageSize: number;

  /**
   * @generated from field: int32 offset = 6;
   */
  offset: number;
};

/**
 * Describes the message zdc.ListSupportTicketsRequest.
 * Use `create(ListSupportTicketsRequestSchema)` to create a new message.
 */
export const ListSupportTicketsRequestSchema: GenMessage<ListSupportTicketsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1321);

/**
 * @generated from message zdc.ListSupportTicketsResponse
 */
export type ListSupportTicketsResponse = Message<"zdc.ListSupportTicketsResponse"> & {
  /**
   * @generated from field: repeated zdc.SupportTicket items = 1;
   */
  items: SupportTicket[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message zdc.ListSupportTicketsResponse.
 * Use `create(ListSupportTicketsResponseSchema)` to create a new message.
 */
export const ListSupportTicketsResponseSchema: GenMessage<ListSupportTicketsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1322);

/**
 * @generated from message zdc.GetSupportTicketRequest
 */
export type GetSupportTicketRequest = Message<"zdc.GetSupportTicketRequest"> & {
  /**
   * @generated from field: string ticket_id = 1;
   */
  ticketId: string;
};

/**
 * Describes the message zdc.GetSupportTicketRequest.
 * Use `create(GetSupportTicketRequestSchema)` to create a new message.
 */
export const GetSupportTicketRequestSchema: GenMessage<GetSupportTicketRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1323);

/**
 * @generated from message zdc.AssignSupportTicketRequest
 */
export type AssignSupportTicketRequest = Message<"zdc.AssignSupportTicketRequest"> & {
  /**
   * @generated from field: string ticket_id = 1;
   */
  ticketId: string;

  /**
   * '' = снять назначение (вернуть в очередь)
   *
   * @generated from field: string assignee_id = 2;
   */
  assigneeId: string;
};

/**
 * Describes the message zdc.AssignSupportTicketRequest.
 * Use `create(AssignSupportTicketRequestSchema)` to create a new message.
 */
export const AssignSupportTicketRequestSchema: GenMessage<AssignSupportTicketRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1324);

/**
 * @generated from message zdc.SetSupportTicketStatusRequest
 */
export type SetSupportTicketStatusRequest = Message<"zdc.SetSupportTicketStatusRequest"> & {
  /**
   * @generated from field: string ticket_id = 1;
   */
  ticketId: string;

  /**
   * new | in_progress | resolved
   *
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * Describes the message zdc.SetSupportTicketStatusRequest.
 * Use `create(SetSupportTicketStatusRequestSchema)` to create a new message.
 */
export const SetSupportTicketStatusRequestSchema: GenMessage<SetSupportTicketStatusRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1325);

/**
 * @generated from message zdc.SetSupportTicketPriorityRequest
 */
export type SetSupportTicketPriorityRequest = Message<"zdc.SetSupportTicketPriorityRequest"> & {
  /**
   * @generated from field: string ticket_id = 1;
   */
  ticketId: string;

  /**
   * low | normal | high
   *
   * @generated from field: string priority = 2;
   */
  priority: string;
};

/**
 * Describes the message zdc.SetSupportTicketPriorityRequest.
 * Use `create(SetSupportTicketPriorityRequestSchema)` to create a new message.
 */
export const SetSupportTicketPriorityRequestSchema: GenMessage<SetSupportTicketPriorityRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1326);

/**
 * @generated from message zdc.ReplySupportTicketRequest
 */
export type ReplySupportTicketRequest = Message<"zdc.ReplySupportTicketRequest"> & {
  /**
   * @generated from field: string ticket_id = 1;
   */
  ticketId: string;

  /**
   * @generated from field: string text = 2;
   */
  text: string;
};

/**
 * Describes the message zdc.ReplySupportTicketRequest.
 * Use `create(ReplySupportTicketRequestSchema)` to create a new message.
 */
export const ReplySupportTicketRequestSchema: GenMessage<ReplySupportTicketRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1327);

/**
 * @generated from message zdc.SupportReplyTemplate
 */
export type SupportReplyTemplate = Message<"zdc.SupportReplyTemplate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string body = 3;
   */
  body: string;

  /**
   * @generated from field: int32 sort_order = 4;
   */
  sortOrder: number;
};

/**
 * Describes the message zdc.SupportReplyTemplate.
 * Use `create(SupportReplyTemplateSchema)` to create a new message.
 */
export const SupportReplyTemplateSchema: GenMessage<SupportReplyTemplate> = /*@__PURE__*/
  messageDesc(file_zdc, 1328);

/**
 * @generated from message zdc.ListSupportReplyTemplatesRequest
 */
export type ListSupportReplyTemplatesRequest = Message<"zdc.ListSupportReplyTemplatesRequest"> & {
};

/**
 * Describes the message zdc.ListSupportReplyTemplatesRequest.
 * Use `create(ListSupportReplyTemplatesRequestSchema)` to create a new message.
 */
export const ListSupportReplyTemplatesRequestSchema: GenMessage<ListSupportReplyTemplatesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1329);

/**
 * @generated from message zdc.ListSupportReplyTemplatesResponse
 */
export type ListSupportReplyTemplatesResponse = Message<"zdc.ListSupportReplyTemplatesResponse"> & {
  /**
   * @generated from field: repeated zdc.SupportReplyTemplate items = 1;
   */
  items: SupportReplyTemplate[];
};

/**
 * Describes the message zdc.ListSupportReplyTemplatesResponse.
 * Use `create(ListSupportReplyTemplatesResponseSchema)` to create a new message.
 */
export const ListSupportReplyTemplatesResponseSchema: GenMessage<ListSupportReplyTemplatesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1330);

/**
 * @generated from message zdc.SaveSupportReplyTemplateRequest
 */
export type SaveSupportReplyTemplateRequest = Message<"zdc.SaveSupportReplyTemplateRequest"> & {
  /**
   * пусто — создание
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string body = 3;
   */
  body: string;

  /**
   * @generated from field: int32 sort_order = 4;
   */
  sortOrder: number;
};

/**
 * Describes the message zdc.SaveSupportReplyTemplateRequest.
 * Use `create(SaveSupportReplyTemplateRequestSchema)` to create a new message.
 */
export const SaveSupportReplyTemplateRequestSchema: GenMessage<SaveSupportReplyTemplateRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1331);

/**
 * @generated from message zdc.DeleteSupportReplyTemplateRequest
 */
export type DeleteSupportReplyTemplateRequest = Message<"zdc.DeleteSupportReplyTemplateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteSupportReplyTemplateRequest.
 * Use `create(DeleteSupportReplyTemplateRequestSchema)` to create a new message.
 */
export const DeleteSupportReplyTemplateRequestSchema: GenMessage<DeleteSupportReplyTemplateRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1332);

/**
 * ============================================================
 * EcgService — СЕРВЕРНЫЙ разбор снимка ЭКГ.
 * Клиент (PWA/APK/desktop) присылает изображение на платформу; платформа
 * вызывает сервис-анализатор по своему адресу (ECG_ANALYZER_URL, по умолчанию
 * http://127.0.0.1:8100) и возвращает его ответ КАК ЕСТЬ (result_json) —
 * структура вероятностного вывода принадлежит анализатору.
 * Доступ: роль «Врач» (ядро «ГидраМедик»), «Студент», «Преподаватель» или
 * администратор.
 * ============================================================
 *
 * @generated from message zdc.AnalyzeEcgRequest
 */
export type AnalyzeEcgRequest = Message<"zdc.AnalyzeEcgRequest"> & {
  /**
   * изображение ЭКГ (JPEG/PNG)
   *
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * имя файла для журнала анализатора
   *
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * MIME (image/jpeg, image/png, ...)
   *
   * @generated from field: string content_type = 3;
   */
  contentType: string;
};

/**
 * Describes the message zdc.AnalyzeEcgRequest.
 * Use `create(AnalyzeEcgRequestSchema)` to create a new message.
 */
export const AnalyzeEcgRequestSchema: GenMessage<AnalyzeEcgRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1333);

/**
 * @generated from message zdc.AnalyzeEcgResponse
 */
export type AnalyzeEcgResponse = Message<"zdc.AnalyzeEcgResponse"> & {
  /**
   * Ответ анализатора как есть: status/quality/signal/measurements/findings/
   * pipeline_version. Разбор — на клиенте (parseAnalysis), без потери полей.
   *
   * @generated from field: string result_json = 1;
   */
  resultJson: string;

  /**
   * Версия пайплайна анализатора (из ответа; пусто — не сообщил).
   *
   * @generated from field: string pipeline_version = 2;
   */
  pipelineVersion: string;
};

/**
 * Describes the message zdc.AnalyzeEcgResponse.
 * Use `create(AnalyzeEcgResponseSchema)` to create a new message.
 */
export const AnalyzeEcgResponseSchema: GenMessage<AnalyzeEcgResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1334);

/**
 * @generated from message zdc.EcgAnalyzerStatus
 */
export type EcgAnalyzerStatus = Message<"zdc.EcgAnalyzerStatus"> & {
  /**
   * сервис-анализатор отвечает
   *
   * @generated from field: bool available = 1;
   */
  available: boolean;

  /**
   * версия пайплайна (если сообщил)
   *
   * @generated from field: string version = 2;
   */
  version: string;

  /**
   * человеческое пояснение (при недоступности)
   *
   * @generated from field: string detail = 3;
   */
  detail: string;
};

/**
 * Describes the message zdc.EcgAnalyzerStatus.
 * Use `create(EcgAnalyzerStatusSchema)` to create a new message.
 */
export const EcgAnalyzerStatusSchema: GenMessage<EcgAnalyzerStatus> = /*@__PURE__*/
  messageDesc(file_zdc, 1335);

/**
 * @generated from message zdc.DevopsNode
 */
export type DevopsNode = Message<"zdc.DevopsNode"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string host = 3;
   */
  host: string;

  /**
   * @generated from field: string ssh_user = 4;
   */
  sshUser: string;

  /**
   * @generated from field: int32 ssh_port = 5;
   */
  sshPort: number;

  /**
   * 'ssh' | 'local'
   *
   * @generated from field: string transport = 6;
   */
  transport: string;

  /**
   * @generated from field: string repo_path = 7;
   */
  repoPath: string;

  /**
   * @generated from field: string worktree_root = 8;
   */
  worktreeRoot: string;

  /**
   * @generated from field: string kilo_url = 9;
   */
  kiloUrl: string;

  /**
   * @generated from field: string labels = 10;
   */
  labels: string;

  /**
   * @generated from field: int32 max_tasks = 11;
   */
  maxTasks: number;

  /**
   * @generated from field: bool enabled = 12;
   */
  enabled: boolean;

  /**
   * @generated from field: string gitlab_project = 13;
   */
  gitlabProject: string;
};

/**
 * Describes the message zdc.DevopsNode.
 * Use `create(DevopsNodeSchema)` to create a new message.
 */
export const DevopsNodeSchema: GenMessage<DevopsNode> = /*@__PURE__*/
  messageDesc(file_zdc, 1336);

/**
 * @generated from message zdc.DevopsWorktree
 */
export type DevopsWorktree = Message<"zdc.DevopsWorktree"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: string branch = 2;
   */
  branch: string;

  /**
   * @generated from field: string head = 3;
   */
  head: string;

  /**
   * @generated from field: int32 dirty = 4;
   */
  dirty: number;

  /**
   * @generated from field: bool is_main = 5;
   */
  isMain: boolean;
};

/**
 * Describes the message zdc.DevopsWorktree.
 * Use `create(DevopsWorktreeSchema)` to create a new message.
 */
export const DevopsWorktreeSchema: GenMessage<DevopsWorktree> = /*@__PURE__*/
  messageDesc(file_zdc, 1337);

/**
 * @generated from message zdc.DevopsServiceUnit
 */
export type DevopsServiceUnit = Message<"zdc.DevopsServiceUnit"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string active = 2;
   */
  active: string;

  /**
   * @generated from field: string sub = 3;
   */
  sub: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;
};

/**
 * Describes the message zdc.DevopsServiceUnit.
 * Use `create(DevopsServiceUnitSchema)` to create a new message.
 */
export const DevopsServiceUnitSchema: GenMessage<DevopsServiceUnit> = /*@__PURE__*/
  messageDesc(file_zdc, 1338);

/**
 * @generated from message zdc.DevopsKiloSession
 */
export type DevopsKiloSession = Message<"zdc.DevopsKiloSession"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string directory = 3;
   */
  directory: string;

  /**
   * @generated from field: string updated_at = 4;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.DevopsKiloSession.
 * Use `create(DevopsKiloSessionSchema)` to create a new message.
 */
export const DevopsKiloSessionSchema: GenMessage<DevopsKiloSession> = /*@__PURE__*/
  messageDesc(file_zdc, 1339);

/**
 * @generated from message zdc.DevopsMergeRequest
 */
export type DevopsMergeRequest = Message<"zdc.DevopsMergeRequest"> & {
  /**
   * @generated from field: int32 iid = 1;
   */
  iid: number;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string source_branch = 3;
   */
  sourceBranch: string;

  /**
   * @generated from field: string web_url = 4;
   */
  webUrl: string;

  /**
   * @generated from field: string state = 5;
   */
  state: string;

  /**
   * @generated from field: string pipeline_status = 6;
   */
  pipelineStatus: string;
};

/**
 * Describes the message zdc.DevopsMergeRequest.
 * Use `create(DevopsMergeRequestSchema)` to create a new message.
 */
export const DevopsMergeRequestSchema: GenMessage<DevopsMergeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1340);

/**
 * @generated from message zdc.DevopsPipeline
 */
export type DevopsPipeline = Message<"zdc.DevopsPipeline"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string ref = 3;
   */
  ref: string;

  /**
   * @generated from field: string sha = 4;
   */
  sha: string;

  /**
   * @generated from field: string web_url = 5;
   */
  webUrl: string;

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.DevopsPipeline.
 * Use `create(DevopsPipelineSchema)` to create a new message.
 */
export const DevopsPipelineSchema: GenMessage<DevopsPipeline> = /*@__PURE__*/
  messageDesc(file_zdc, 1341);

/**
 * @generated from message zdc.DevopsNodeStatus
 */
export type DevopsNodeStatus = Message<"zdc.DevopsNodeStatus"> & {
  /**
   * @generated from field: string node_code = 1;
   */
  nodeCode: string;

  /**
   * @generated from field: bool online = 2;
   */
  online: boolean;

  /**
   * @generated from field: string collected_at = 3;
   */
  collectedAt: string;

  /**
   * @generated from field: string error = 4;
   */
  error: string;

  /**
   * @generated from field: string hostname = 5;
   */
  hostname: string;

  /**
   * @generated from field: string os = 6;
   */
  os: string;

  /**
   * @generated from field: int64 uptime_seconds = 7;
   */
  uptimeSeconds: bigint;

  /**
   * @generated from field: uint64 mem_total = 8;
   */
  memTotal: bigint;

  /**
   * @generated from field: uint64 mem_used = 9;
   */
  memUsed: bigint;

  /**
   * @generated from field: double mem_percent = 10;
   */
  memPercent: number;

  /**
   * @generated from field: string disk_path = 11;
   */
  diskPath: string;

  /**
   * @generated from field: uint64 disk_total = 12;
   */
  diskTotal: bigint;

  /**
   * @generated from field: uint64 disk_free = 13;
   */
  diskFree: bigint;

  /**
   * @generated from field: double disk_percent = 14;
   */
  diskPercent: number;

  /**
   * @generated from field: string branch = 15;
   */
  branch: string;

  /**
   * @generated from field: string head = 16;
   */
  head: string;

  /**
   * @generated from field: int32 dirty_files = 17;
   */
  dirtyFiles: number;

  /**
   * @generated from field: repeated zdc.DevopsWorktree worktrees = 18;
   */
  worktrees: DevopsWorktree[];

  /**
   * @generated from field: repeated zdc.DevopsServiceUnit services = 19;
   */
  services: DevopsServiceUnit[];

  /**
   * @generated from field: repeated zdc.DevopsKiloSession sessions = 20;
   */
  sessions: DevopsKiloSession[];

  /**
   * @generated from field: repeated zdc.DevopsMergeRequest merge_requests = 21;
   */
  mergeRequests: DevopsMergeRequest[];

  /**
   * @generated from field: repeated zdc.DevopsPipeline pipelines = 22;
   */
  pipelines: DevopsPipeline[];

  /**
   * @generated from field: repeated string errors = 23;
   */
  errors: string[];
};

/**
 * Describes the message zdc.DevopsNodeStatus.
 * Use `create(DevopsNodeStatusSchema)` to create a new message.
 */
export const DevopsNodeStatusSchema: GenMessage<DevopsNodeStatus> = /*@__PURE__*/
  messageDesc(file_zdc, 1342);

/**
 * @generated from message zdc.DevopsTask
 */
export type DevopsTask = Message<"zdc.DevopsTask"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string node_code = 3;
   */
  nodeCode: string;

  /**
   * @generated from field: string worktree = 4;
   */
  worktree: string;

  /**
   * @generated from field: string branch = 5;
   */
  branch: string;

  /**
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: string session_id = 7;
   */
  sessionId: string;

  /**
   * @generated from field: string mr_url = 8;
   */
  mrUrl: string;

  /**
   * @generated from field: string pipeline_status = 9;
   */
  pipelineStatus: string;

  /**
   * @generated from field: string comment = 10;
   */
  comment: string;

  /**
   * @generated from field: string kind = 11;
   */
  kind: string;

  /**
   * @generated from field: string started_at = 12;
   */
  startedAt: string;

  /**
   * @generated from field: string finished_at = 13;
   */
  finishedAt: string;

  /**
   * @generated from field: string last_error = 14;
   */
  lastError: string;

  /**
   * @generated from field: bool live = 15;
   */
  live: boolean;
};

/**
 * Describes the message zdc.DevopsTask.
 * Use `create(DevopsTaskSchema)` to create a new message.
 */
export const DevopsTaskSchema: GenMessage<DevopsTask> = /*@__PURE__*/
  messageDesc(file_zdc, 1343);

/**
 * @generated from message zdc.ListDevopsNodesRequest
 */
export type ListDevopsNodesRequest = Message<"zdc.ListDevopsNodesRequest"> & {
};

/**
 * Describes the message zdc.ListDevopsNodesRequest.
 * Use `create(ListDevopsNodesRequestSchema)` to create a new message.
 */
export const ListDevopsNodesRequestSchema: GenMessage<ListDevopsNodesRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1344);

/**
 * @generated from message zdc.ListDevopsNodesResponse
 */
export type ListDevopsNodesResponse = Message<"zdc.ListDevopsNodesResponse"> & {
  /**
   * @generated from field: repeated zdc.DevopsNode nodes = 1;
   */
  nodes: DevopsNode[];

  /**
   * @generated from field: repeated zdc.DevopsNodeStatus statuses = 2;
   */
  statuses: DevopsNodeStatus[];

  /**
   * @generated from field: bool gitlab_configured = 3;
   */
  gitlabConfigured: boolean;

  /**
   * @generated from field: string gitlab_error = 4;
   */
  gitlabError: string;
};

/**
 * Describes the message zdc.ListDevopsNodesResponse.
 * Use `create(ListDevopsNodesResponseSchema)` to create a new message.
 */
export const ListDevopsNodesResponseSchema: GenMessage<ListDevopsNodesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1345);

/**
 * @generated from message zdc.GetDevopsNodeStatusRequest
 */
export type GetDevopsNodeStatusRequest = Message<"zdc.GetDevopsNodeStatusRequest"> & {
  /**
   * @generated from field: string node_code = 1;
   */
  nodeCode: string;

  /**
   * @generated from field: bool refresh = 2;
   */
  refresh: boolean;
};

/**
 * Describes the message zdc.GetDevopsNodeStatusRequest.
 * Use `create(GetDevopsNodeStatusRequestSchema)` to create a new message.
 */
export const GetDevopsNodeStatusRequestSchema: GenMessage<GetDevopsNodeStatusRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1346);

/**
 * @generated from message zdc.RefreshDevopsNodeRequest
 */
export type RefreshDevopsNodeRequest = Message<"zdc.RefreshDevopsNodeRequest"> & {
  /**
   * @generated from field: string node_code = 1;
   */
  nodeCode: string;
};

/**
 * Describes the message zdc.RefreshDevopsNodeRequest.
 * Use `create(RefreshDevopsNodeRequestSchema)` to create a new message.
 */
export const RefreshDevopsNodeRequestSchema: GenMessage<RefreshDevopsNodeRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1347);

/**
 * @generated from message zdc.ListDevopsTasksRequest
 */
export type ListDevopsTasksRequest = Message<"zdc.ListDevopsTasksRequest"> & {
  /**
   * @generated from field: string node_code = 1;
   */
  nodeCode: string;
};

/**
 * Describes the message zdc.ListDevopsTasksRequest.
 * Use `create(ListDevopsTasksRequestSchema)` to create a new message.
 */
export const ListDevopsTasksRequestSchema: GenMessage<ListDevopsTasksRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1348);

/**
 * @generated from message zdc.ListDevopsTasksResponse
 */
export type ListDevopsTasksResponse = Message<"zdc.ListDevopsTasksResponse"> & {
  /**
   * @generated from field: repeated zdc.DevopsTask tasks = 1;
   */
  tasks: DevopsTask[];
};

/**
 * Describes the message zdc.ListDevopsTasksResponse.
 * Use `create(ListDevopsTasksResponseSchema)` to create a new message.
 */
export const ListDevopsTasksResponseSchema: GenMessage<ListDevopsTasksResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1349);

/**
 * @generated from message zdc.StartDevopsTaskRequest
 */
export type StartDevopsTaskRequest = Message<"zdc.StartDevopsTaskRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * пусто — узел задачи
   *
   * @generated from field: string node_code = 2;
   */
  nodeCode: string;
};

/**
 * Describes the message zdc.StartDevopsTaskRequest.
 * Use `create(StartDevopsTaskRequestSchema)` to create a new message.
 */
export const StartDevopsTaskRequestSchema: GenMessage<StartDevopsTaskRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1350);

/**
 * @generated from message zdc.StopDevopsTaskRequest
 */
export type StopDevopsTaskRequest = Message<"zdc.StopDevopsTaskRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;
};

/**
 * Describes the message zdc.StopDevopsTaskRequest.
 * Use `create(StopDevopsTaskRequestSchema)` to create a new message.
 */
export const StopDevopsTaskRequestSchema: GenMessage<StopDevopsTaskRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1351);

/**
 * ============================================================================
 * ЛИЧНЫЕ АССИСТЕНТЫ (P0): шаблоны, привязки, расход, согласования.
 * Объявления в конце файла — индексы существующих сообщений не сдвигаются.
 * ============================================================================
 * --- Личные ассистенты P0: шаблоны, привязки, расход, согласования ---
 * Зеркало internal/metadata/assistant_types.go. Ноль в квотах = без ограничения;
 * стоимость — в минорных единицах (центы).
 *
 * @generated from message zdc.AiAssistantQuotas
 */
export type AiAssistantQuotas = Message<"zdc.AiAssistantQuotas"> & {
  /**
   * @generated from field: int32 max_tokens_per_day = 1;
   */
  maxTokensPerDay: number;

  /**
   * @generated from field: int32 max_requests_per_hour = 2;
   */
  maxRequestsPerHour: number;

  /**
   * @generated from field: int64 max_cost_cents_per_day = 3;
   */
  maxCostCentsPerDay: bigint;

  /**
   * @generated from field: int32 max_context_tokens = 4;
   */
  maxContextTokens: number;
};

/**
 * Describes the message zdc.AiAssistantQuotas.
 * Use `create(AiAssistantQuotasSchema)` to create a new message.
 */
export const AiAssistantQuotasSchema: GenMessage<AiAssistantQuotas> = /*@__PURE__*/
  messageDesc(file_zdc, 1352);

/**
 * @generated from message zdc.AiAssistantPolicy
 */
export type AiAssistantPolicy = Message<"zdc.AiAssistantPolicy"> & {
  /**
   * @generated from field: bool user_can_override_model = 1;
   */
  userCanOverrideModel: boolean;

  /**
   * @generated from field: bool user_can_edit_style = 2;
   */
  userCanEditStyle: boolean;

  /**
   * @generated from field: bool user_can_edit_memory = 3;
   */
  userCanEditMemory: boolean;

  /**
   * 0 = 15 минут
   *
   * @generated from field: int32 approval_ttl_minutes = 4;
   */
  approvalTtlMinutes: number;
};

/**
 * Describes the message zdc.AiAssistantPolicy.
 * Use `create(AiAssistantPolicySchema)` to create a new message.
 */
export const AiAssistantPolicySchema: GenMessage<AiAssistantPolicy> = /*@__PURE__*/
  messageDesc(file_zdc, 1353);

/**
 * @generated from message zdc.AiAssistantStylePreset
 */
export type AiAssistantStylePreset = Message<"zdc.AiAssistantStylePreset"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string tone = 3;
   */
  tone: string;
};

/**
 * Describes the message zdc.AiAssistantStylePreset.
 * Use `create(AiAssistantStylePresetSchema)` to create a new message.
 */
export const AiAssistantStylePresetSchema: GenMessage<AiAssistantStylePreset> = /*@__PURE__*/
  messageDesc(file_zdc, 1354);

/**
 * @generated from message zdc.AiAssistantTemplate
 */
export type AiAssistantTemplate = Message<"zdc.AiAssistantTemplate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string agent_code = 5;
   */
  agentCode: string;

  /**
   * @generated from field: string provider_id = 6;
   */
  providerId: string;

  /**
   * @generated from field: string default_model_id = 7;
   */
  defaultModelId: string;

  /**
   * purpose → model_id
   *
   * @generated from field: map<string, string> model_mapping = 8;
   */
  modelMapping: { [key: string]: string };

  /**
   * @generated from field: string base_prompt = 9;
   */
  basePrompt: string;

  /**
   * @generated from field: string guard_prompt = 10;
   */
  guardPrompt: string;

  /**
   * @generated from field: repeated zdc.AiAssistantStylePreset style_presets = 11;
   */
  stylePresets: AiAssistantStylePreset[];

  /**
   * tools_allowlist_set=false → наследовать инструменты агента;
   * true + пустой список → запретить все инструменты.
   *
   * @generated from field: repeated string tools_allowlist = 12;
   */
  toolsAllowlist: string[];

  /**
   * @generated from field: bool tools_allowlist_set = 13;
   */
  toolsAllowlistSet: boolean;

  /**
   * требуют согласования пользователя
   *
   * @generated from field: repeated string destructive_tools = 14;
   */
  destructiveTools: string[];

  /**
   * '' | global | session | per_user
   *
   * @generated from field: string memory_scope = 15;
   */
  memoryScope: string;

  /**
   * @generated from field: int32 memory_ttl_days = 16;
   */
  memoryTtlDays: number;

  /**
   * @generated from field: bool allow_user_wipe = 17;
   */
  allowUserWipe: boolean;

  /**
   * @generated from field: repeated string channels = 18;
   */
  channels: string[];

  /**
   * @generated from field: zdc.AiAssistantQuotas quotas = 19;
   */
  quotas?: AiAssistantQuotas | undefined;

  /**
   * @generated from field: zdc.AiAssistantPolicy policy = 20;
   */
  policy?: AiAssistantPolicy | undefined;

  /**
   * @generated from field: int32 version = 21;
   */
  version: number;

  /**
   * @generated from field: bool is_active = 22;
   */
  isActive: boolean;

  /**
   * @generated from field: bool is_public = 23;
   */
  isPublic: boolean;

  /**
   * @generated from field: bool is_system = 24;
   */
  isSystem: boolean;

  /**
   * поставка-владелец
   *
   * @generated from field: string template_id = 25;
   */
  templateId: string;

  /**
   * @generated from field: string template_version = 26;
   */
  templateVersion: string;

  /**
   * @generated from field: string owner_id = 27;
   */
  ownerId: string;

  /**
   * @generated from field: string app_code = 28;
   */
  appCode: string;

  /**
   * @generated from field: string created_at = 29;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 30;
   */
  updatedAt: string;

  /**
   * @generated from field: string created_by = 31;
   */
  createdBy: string;

  /**
   * @generated from field: string updated_by = 32;
   */
  updatedBy: string;

  /**
   * Шаблон, который автоматически назначается НОВЫМ пользователям
   * (при создании, если у них нет своей привязки и назначения агента).
   * Управляется только SetAssistantDefaults (локальная политика базы).
   *
   * @generated from field: bool is_default_for_new_users = 33;
   */
  isDefaultForNewUsers: boolean;
};

/**
 * Describes the message zdc.AiAssistantTemplate.
 * Use `create(AiAssistantTemplateSchema)` to create a new message.
 */
export const AiAssistantTemplateSchema: GenMessage<AiAssistantTemplate> = /*@__PURE__*/
  messageDesc(file_zdc, 1355);

/**
 * @generated from message zdc.ListAssistantTemplatesResponse
 */
export type ListAssistantTemplatesResponse = Message<"zdc.ListAssistantTemplatesResponse"> & {
  /**
   * @generated from field: repeated zdc.AiAssistantTemplate items = 1;
   */
  items: AiAssistantTemplate[];
};

/**
 * Describes the message zdc.ListAssistantTemplatesResponse.
 * Use `create(ListAssistantTemplatesResponseSchema)` to create a new message.
 */
export const ListAssistantTemplatesResponseSchema: GenMessage<ListAssistantTemplatesResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1356);

/**
 * @generated from message zdc.AssistantDefaults
 */
export type AssistantDefaults = Message<"zdc.AssistantDefaults"> & {
  /**
   * '' = автоматическая привязка выключена
   *
   * @generated from field: string default_template_code = 1;
   */
  defaultTemplateCode: string;

  /**
   * Политика: системный агент без шаблона доступен обычным пользователям.
   * Администратору системный агент доступен всегда (настройка базы).
   *
   * @generated from field: bool allow_system_default = 2;
   */
  allowSystemDefault: boolean;
};

/**
 * Describes the message zdc.AssistantDefaults.
 * Use `create(AssistantDefaultsSchema)` to create a new message.
 */
export const AssistantDefaultsSchema: GenMessage<AssistantDefaults> = /*@__PURE__*/
  messageDesc(file_zdc, 1357);

/**
 * @generated from message zdc.SetAssistantDefaultsRequest
 */
export type SetAssistantDefaultsRequest = Message<"zdc.SetAssistantDefaultsRequest"> & {
  /**
   * @generated from field: string default_template_code = 1;
   */
  defaultTemplateCode: string;

  /**
   * @generated from field: bool allow_system_default = 2;
   */
  allowSystemDefault: boolean;
};

/**
 * Describes the message zdc.SetAssistantDefaultsRequest.
 * Use `create(SetAssistantDefaultsRequestSchema)` to create a new message.
 */
export const SetAssistantDefaultsRequestSchema: GenMessage<SetAssistantDefaultsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1358);

/**
 * @generated from message zdc.GetAssistantTemplateRequest
 */
export type GetAssistantTemplateRequest = Message<"zdc.GetAssistantTemplateRequest"> & {
  /**
   * приоритет: id → code
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message zdc.GetAssistantTemplateRequest.
 * Use `create(GetAssistantTemplateRequestSchema)` to create a new message.
 */
export const GetAssistantTemplateRequestSchema: GenMessage<GetAssistantTemplateRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1359);

/**
 * @generated from message zdc.SaveAssistantTemplateRequest
 */
export type SaveAssistantTemplateRequest = Message<"zdc.SaveAssistantTemplateRequest"> & {
  /**
   * ключ шаблона (неизменяем у существующего)
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string agent_code = 4;
   */
  agentCode: string;

  /**
   * @generated from field: string provider_id = 5;
   */
  providerId: string;

  /**
   * @generated from field: string default_model_id = 6;
   */
  defaultModelId: string;

  /**
   * @generated from field: map<string, string> model_mapping = 7;
   */
  modelMapping: { [key: string]: string };

  /**
   * @generated from field: string base_prompt = 8;
   */
  basePrompt: string;

  /**
   * @generated from field: string guard_prompt = 9;
   */
  guardPrompt: string;

  /**
   * @generated from field: repeated zdc.AiAssistantStylePreset style_presets = 10;
   */
  stylePresets: AiAssistantStylePreset[];

  /**
   * @generated from field: repeated string tools_allowlist = 11;
   */
  toolsAllowlist: string[];

  /**
   * @generated from field: bool tools_allowlist_set = 12;
   */
  toolsAllowlistSet: boolean;

  /**
   * @generated from field: repeated string destructive_tools = 13;
   */
  destructiveTools: string[];

  /**
   * @generated from field: string memory_scope = 14;
   */
  memoryScope: string;

  /**
   * @generated from field: int32 memory_ttl_days = 15;
   */
  memoryTtlDays: number;

  /**
   * @generated from field: bool allow_user_wipe = 16;
   */
  allowUserWipe: boolean;

  /**
   * @generated from field: repeated string channels = 17;
   */
  channels: string[];

  /**
   * @generated from field: zdc.AiAssistantQuotas quotas = 18;
   */
  quotas?: AiAssistantQuotas | undefined;

  /**
   * @generated from field: zdc.AiAssistantPolicy policy = 19;
   */
  policy?: AiAssistantPolicy | undefined;

  /**
   * @generated from field: bool is_active = 20;
   */
  isActive: boolean;

  /**
   * @generated from field: bool is_public = 21;
   */
  isPublic: boolean;
};

/**
 * Describes the message zdc.SaveAssistantTemplateRequest.
 * Use `create(SaveAssistantTemplateRequestSchema)` to create a new message.
 */
export const SaveAssistantTemplateRequestSchema: GenMessage<SaveAssistantTemplateRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1360);

/**
 * @generated from message zdc.DeleteAssistantTemplateRequest
 */
export type DeleteAssistantTemplateRequest = Message<"zdc.DeleteAssistantTemplateRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.DeleteAssistantTemplateRequest.
 * Use `create(DeleteAssistantTemplateRequestSchema)` to create a new message.
 */
export const DeleteAssistantTemplateRequestSchema: GenMessage<DeleteAssistantTemplateRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1361);

/**
 * Неизменяемая версия промта шаблона. Публикация/откат только добавляют
 * записи; поля существующих версий никогда не перезаписываются.
 *
 * @generated from message zdc.AiAssistantPromptVersion
 */
export type AiAssistantPromptVersion = Message<"zdc.AiAssistantPromptVersion"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string template_code = 2;
   */
  templateCode: string;

  /**
   * @generated from field: int32 version = 3;
   */
  version: number;

  /**
   * @generated from field: string base_prompt = 4;
   */
  basePrompt: string;

  /**
   * @generated from field: string guard_prompt = 5;
   */
  guardPrompt: string;

  /**
   * @generated from field: int32 rollout_pct = 6;
   */
  rolloutPct: number;

  /**
   * @generated from field: string note = 7;
   */
  note: string;

  /**
   * @generated from field: string published_by = 8;
   */
  publishedBy: string;

  /**
   * @generated from field: string published_at = 9;
   */
  publishedAt: string;

  /**
   * @generated from field: string created_at = 10;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.AiAssistantPromptVersion.
 * Use `create(AiAssistantPromptVersionSchema)` to create a new message.
 */
export const AiAssistantPromptVersionSchema: GenMessage<AiAssistantPromptVersion> = /*@__PURE__*/
  messageDesc(file_zdc, 1362);

/**
 * @generated from message zdc.ListAssistantPromptVersionsRequest
 */
export type ListAssistantPromptVersionsRequest = Message<"zdc.ListAssistantPromptVersionsRequest"> & {
  /**
   * @generated from field: string template_code = 1;
   */
  templateCode: string;
};

/**
 * Describes the message zdc.ListAssistantPromptVersionsRequest.
 * Use `create(ListAssistantPromptVersionsRequestSchema)` to create a new message.
 */
export const ListAssistantPromptVersionsRequestSchema: GenMessage<ListAssistantPromptVersionsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1363);

/**
 * @generated from message zdc.ListAssistantPromptVersionsResponse
 */
export type ListAssistantPromptVersionsResponse = Message<"zdc.ListAssistantPromptVersionsResponse"> & {
  /**
   * @generated from field: repeated zdc.AiAssistantPromptVersion items = 1;
   */
  items: AiAssistantPromptVersion[];
};

/**
 * Describes the message zdc.ListAssistantPromptVersionsResponse.
 * Use `create(ListAssistantPromptVersionsResponseSchema)` to create a new message.
 */
export const ListAssistantPromptVersionsResponseSchema: GenMessage<ListAssistantPromptVersionsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1364);

/**
 * @generated from message zdc.PublishAssistantPromptVersionRequest
 */
export type PublishAssistantPromptVersionRequest = Message<"zdc.PublishAssistantPromptVersionRequest"> & {
  /**
   * @generated from field: string template_code = 1;
   */
  templateCode: string;

  /**
   * @generated from field: string base_prompt = 2;
   */
  basePrompt: string;

  /**
   * @generated from field: string guard_prompt = 3;
   */
  guardPrompt: string;

  /**
   * 0 → 100
   *
   * @generated from field: int32 rollout_pct = 4;
   */
  rolloutPct: number;

  /**
   * @generated from field: string note = 5;
   */
  note: string;
};

/**
 * Describes the message zdc.PublishAssistantPromptVersionRequest.
 * Use `create(PublishAssistantPromptVersionRequestSchema)` to create a new message.
 */
export const PublishAssistantPromptVersionRequestSchema: GenMessage<PublishAssistantPromptVersionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1365);

/**
 * @generated from message zdc.RollbackAssistantPromptVersionRequest
 */
export type RollbackAssistantPromptVersionRequest = Message<"zdc.RollbackAssistantPromptVersionRequest"> & {
  /**
   * @generated from field: string template_code = 1;
   */
  templateCode: string;

  /**
   * @generated from field: int32 version = 2;
   */
  version: number;
};

/**
 * Describes the message zdc.RollbackAssistantPromptVersionRequest.
 * Use `create(RollbackAssistantPromptVersionRequestSchema)` to create a new message.
 */
export const RollbackAssistantPromptVersionRequestSchema: GenMessage<RollbackAssistantPromptVersionRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1366);

/**
 * @generated from message zdc.AiAssistantBindingOverrides
 */
export type AiAssistantBindingOverrides = Message<"zdc.AiAssistantBindingOverrides"> & {
  /**
   * @generated from field: string model_id = 1;
   */
  modelId: string;

  /**
   * @generated from field: string style = 2;
   */
  style: string;

  /**
   * @generated from field: string memory_scope = 3;
   */
  memoryScope: string;

  /**
   * @generated from field: repeated string channels = 4;
   */
  channels: string[];

  /**
   * @generated from field: string language = 5;
   */
  language: string;
};

/**
 * Describes the message zdc.AiAssistantBindingOverrides.
 * Use `create(AiAssistantBindingOverridesSchema)` to create a new message.
 */
export const AiAssistantBindingOverridesSchema: GenMessage<AiAssistantBindingOverrides> = /*@__PURE__*/
  messageDesc(file_zdc, 1367);

/**
 * @generated from message zdc.AiAssistantBinding
 */
export type AiAssistantBinding = Message<"zdc.AiAssistantBinding"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string template_code = 3;
   */
  templateCode: string;

  /**
   * основной ассистент пользователя
   *
   * @generated from field: bool is_default = 4;
   */
  isDefault: boolean;

  /**
   * @generated from field: zdc.AiAssistantBindingOverrides overrides = 5;
   */
  overrides?: AiAssistantBindingOverrides | undefined;

  /**
   * только ужесточение квот шаблона
   *
   * @generated from field: zdc.AiAssistantQuotas quota_overrides = 6;
   */
  quotaOverrides?: AiAssistantQuotas | undefined;

  /**
   * @generated from field: bool enabled = 7;
   */
  enabled: boolean;

  /**
   * @generated from field: string assigned_by = 8;
   */
  assignedBy: string;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 10;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.AiAssistantBinding.
 * Use `create(AiAssistantBindingSchema)` to create a new message.
 */
export const AiAssistantBindingSchema: GenMessage<AiAssistantBinding> = /*@__PURE__*/
  messageDesc(file_zdc, 1368);

/**
 * @generated from message zdc.ListAssistantBindingsRequest
 */
export type ListAssistantBindingsRequest = Message<"zdc.ListAssistantBindingsRequest"> & {
  /**
   * пусто = все (только админ); не-админ — принудительно свой
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message zdc.ListAssistantBindingsRequest.
 * Use `create(ListAssistantBindingsRequestSchema)` to create a new message.
 */
export const ListAssistantBindingsRequestSchema: GenMessage<ListAssistantBindingsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1369);

/**
 * @generated from message zdc.ListAssistantBindingsResponse
 */
export type ListAssistantBindingsResponse = Message<"zdc.ListAssistantBindingsResponse"> & {
  /**
   * @generated from field: repeated zdc.AiAssistantBinding items = 1;
   */
  items: AiAssistantBinding[];
};

/**
 * Describes the message zdc.ListAssistantBindingsResponse.
 * Use `create(ListAssistantBindingsResponseSchema)` to create a new message.
 */
export const ListAssistantBindingsResponseSchema: GenMessage<ListAssistantBindingsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1370);

/**
 * @generated from message zdc.SaveAssistantBindingRequest
 */
export type SaveAssistantBindingRequest = Message<"zdc.SaveAssistantBindingRequest"> & {
  /**
   * пусто = текущий пользователь
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string template_code = 2;
   */
  templateCode: string;

  /**
   * @generated from field: bool is_default = 3;
   */
  isDefault: boolean;

  /**
   * @generated from field: zdc.AiAssistantBindingOverrides overrides = 4;
   */
  overrides?: AiAssistantBindingOverrides | undefined;

  /**
   * @generated from field: zdc.AiAssistantQuotas quota_overrides = 5;
   */
  quotaOverrides?: AiAssistantQuotas | undefined;

  /**
   * @generated from field: bool enabled = 6;
   */
  enabled: boolean;
};

/**
 * Describes the message zdc.SaveAssistantBindingRequest.
 * Use `create(SaveAssistantBindingRequestSchema)` to create a new message.
 */
export const SaveAssistantBindingRequestSchema: GenMessage<SaveAssistantBindingRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1371);

/**
 * @generated from message zdc.BulkAssignAssistantBindingsRequest
 */
export type BulkAssignAssistantBindingsRequest = Message<"zdc.BulkAssignAssistantBindingsRequest"> & {
  /**
   * @generated from field: repeated string user_ids = 1;
   */
  userIds: string[];

  /**
   * @generated from field: string template_code = 2;
   */
  templateCode: string;

  /**
   * @generated from field: bool is_default = 3;
   */
  isDefault: boolean;

  /**
   * @generated from field: zdc.AiAssistantBindingOverrides overrides = 4;
   */
  overrides?: AiAssistantBindingOverrides | undefined;

  /**
   * @generated from field: zdc.AiAssistantQuotas quota_overrides = 5;
   */
  quotaOverrides?: AiAssistantQuotas | undefined;

  /**
   * @generated from field: bool enabled = 6;
   */
  enabled: boolean;
};

/**
 * Describes the message zdc.BulkAssignAssistantBindingsRequest.
 * Use `create(BulkAssignAssistantBindingsRequestSchema)` to create a new message.
 */
export const BulkAssignAssistantBindingsRequestSchema: GenMessage<BulkAssignAssistantBindingsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1372);

/**
 * @generated from message zdc.BulkAssignAssistantBindingsResponse
 */
export type BulkAssignAssistantBindingsResponse = Message<"zdc.BulkAssignAssistantBindingsResponse"> & {
  /**
   * @generated from field: int32 assigned = 1;
   */
  assigned: number;

  /**
   * дубликаты/пустые id
   *
   * @generated from field: repeated string skipped_user_ids = 2;
   */
  skippedUserIds: string[];
};

/**
 * Describes the message zdc.BulkAssignAssistantBindingsResponse.
 * Use `create(BulkAssignAssistantBindingsResponseSchema)` to create a new message.
 */
export const BulkAssignAssistantBindingsResponseSchema: GenMessage<BulkAssignAssistantBindingsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1373);

/**
 * @generated from message zdc.DeleteAssistantBindingRequest
 */
export type DeleteAssistantBindingRequest = Message<"zdc.DeleteAssistantBindingRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteAssistantBindingRequest.
 * Use `create(DeleteAssistantBindingRequestSchema)` to create a new message.
 */
export const DeleteAssistantBindingRequestSchema: GenMessage<DeleteAssistantBindingRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1374);

/**
 * @generated from message zdc.AiAssistantUsage
 */
export type AiAssistantUsage = Message<"zdc.AiAssistantUsage"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string template_code = 2;
   */
  templateCode: string;

  /**
   * @generated from field: string binding_id = 3;
   */
  bindingId: string;

  /**
   * YYYY-MM-DD (UTC)
   *
   * @generated from field: string usage_date = 4;
   */
  usageDate: string;

  /**
   * 0..23 (UTC)
   *
   * @generated from field: int32 usage_hour = 5;
   */
  usageHour: number;

  /**
   * @generated from field: int32 tokens_in = 6;
   */
  tokensIn: number;

  /**
   * @generated from field: int32 tokens_out = 7;
   */
  tokensOut: number;

  /**
   * @generated from field: int64 cost_cents = 8;
   */
  costCents: bigint;

  /**
   * @generated from field: int32 requests = 9;
   */
  requests: number;
};

/**
 * Describes the message zdc.AiAssistantUsage.
 * Use `create(AiAssistantUsageSchema)` to create a new message.
 */
export const AiAssistantUsageSchema: GenMessage<AiAssistantUsage> = /*@__PURE__*/
  messageDesc(file_zdc, 1375);

/**
 * @generated from message zdc.AiAssistantApproval
 */
export type AiAssistantApproval = Message<"zdc.AiAssistantApproval"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string template_code = 3;
   */
  templateCode: string;

  /**
   * @generated from field: string binding_id = 4;
   */
  bindingId: string;

  /**
   * @generated from field: string tool_code = 5;
   */
  toolCode: string;

  /**
   * JSON аргументов вызова
   *
   * @generated from field: string args = 6;
   */
  args: string;

  /**
   * @generated from field: string status = 7;
   */
  status: string;

  /**
   * @generated from field: string requested_at = 8;
   */
  requestedAt: string;

  /**
   * @generated from field: string decided_at = 9;
   */
  decidedAt: string;

  /**
   * @generated from field: string decided_by = 10;
   */
  decidedBy: string;

  /**
   * @generated from field: string expires_at = 11;
   */
  expiresAt: string;
};

/**
 * Describes the message zdc.AiAssistantApproval.
 * Use `create(AiAssistantApprovalSchema)` to create a new message.
 */
export const AiAssistantApprovalSchema: GenMessage<AiAssistantApproval> = /*@__PURE__*/
  messageDesc(file_zdc, 1376);

/**
 * @generated from message zdc.ListMyAssistantApprovalsResponse
 */
export type ListMyAssistantApprovalsResponse = Message<"zdc.ListMyAssistantApprovalsResponse"> & {
  /**
   * @generated from field: repeated zdc.AiAssistantApproval items = 1;
   */
  items: AiAssistantApproval[];
};

/**
 * Describes the message zdc.ListMyAssistantApprovalsResponse.
 * Use `create(ListMyAssistantApprovalsResponseSchema)` to create a new message.
 */
export const ListMyAssistantApprovalsResponseSchema: GenMessage<ListMyAssistantApprovalsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1377);

/**
 * @generated from message zdc.DecideMyAssistantApprovalRequest
 */
export type DecideMyAssistantApprovalRequest = Message<"zdc.DecideMyAssistantApprovalRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * false → rejected
   *
   * @generated from field: bool approved = 2;
   */
  approved: boolean;
};

/**
 * Describes the message zdc.DecideMyAssistantApprovalRequest.
 * Use `create(DecideMyAssistantApprovalRequestSchema)` to create a new message.
 */
export const DecideMyAssistantApprovalRequestSchema: GenMessage<DecideMyAssistantApprovalRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1378);

/**
 * @generated from message zdc.MyAssistant
 */
export type MyAssistant = Message<"zdc.MyAssistant"> & {
  /**
   * binding | assignment | system | requested
   *
   * @generated from field: string source = 1;
   */
  source: string;

  /**
   * @generated from field: zdc.AiAssistantTemplate template = 2;
   */
  template?: AiAssistantTemplate | undefined;

  /**
   * @generated from field: zdc.AiAssistantBinding binding = 3;
   */
  binding?: AiAssistantBinding | undefined;

  /**
   * @generated from field: string agent_code = 4;
   */
  agentCode: string;

  /**
   * @generated from field: string agent_name = 5;
   */
  agentName: string;

  /**
   * @generated from field: string model_id = 6;
   */
  modelId: string;

  /**
   * @generated from field: string model_name = 7;
   */
  modelName: string;

  /**
   * @generated from field: string provider_id = 8;
   */
  providerId: string;

  /**
   * @generated from field: map<string, string> model_mapping = 9;
   */
  modelMapping: { [key: string]: string };

  /**
   * @generated from field: zdc.AiAssistantQuotas quotas = 10;
   */
  quotas?: AiAssistantQuotas | undefined;

  /**
   * @generated from field: repeated string channels = 11;
   */
  channels: string[];

  /**
   * @generated from field: zdc.AiAssistantUsage usage_today = 12;
   */
  usageToday?: AiAssistantUsage | undefined;

  /**
   * @generated from field: repeated zdc.AiAssistantApproval pending_approvals = 13;
   */
  pendingApprovals: AiAssistantApproval[];
};

/**
 * Describes the message zdc.MyAssistant.
 * Use `create(MyAssistantSchema)` to create a new message.
 */
export const MyAssistantSchema: GenMessage<MyAssistant> = /*@__PURE__*/
  messageDesc(file_zdc, 1379);

/**
 * Доступность закреплённого чата ассистента (без ошибок конфигурации).
 *
 * @generated from message zdc.MyAssistantAvailability
 */
export type MyAssistantAvailability = Message<"zdc.MyAssistantAvailability"> & {
  /**
   * @generated from field: bool available = 1;
   */
  available: boolean;

  /**
   * понятная причина, если available=false
   *
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * binding | assignment | system | requested | none
   *
   * @generated from field: string source = 3;
   */
  source: string;

  /**
   * @generated from field: string template_code = 4;
   */
  templateCode: string;

  /**
   * @generated from field: bool has_binding = 5;
   */
  hasBinding: boolean;

  /**
   * @generated from field: string agent_code = 6;
   */
  agentCode: string;

  /**
   * @generated from field: string model_id = 7;
   */
  modelId: string;

  /**
   * @generated from field: string provider_id = 8;
   */
  providerId: string;
};

/**
 * Describes the message zdc.MyAssistantAvailability.
 * Use `create(MyAssistantAvailabilitySchema)` to create a new message.
 */
export const MyAssistantAvailabilitySchema: GenMessage<MyAssistantAvailability> = /*@__PURE__*/
  messageDesc(file_zdc, 1380);

/**
 * MailOAuthState — СОСТОЯНИЕ OAuth2 без секретов.
 *
 * @generated from message zdc.MailOAuthState
 */
export type MailOAuthState = Message<"zdc.MailOAuthState"> & {
  /**
   * gmail | outlook | mailru | custom
   *
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * @generated from field: string client_id = 2;
   */
  clientId: string;

  /**
   * @generated from field: string scope = 3;
   */
  scope: string;

  /**
   * @generated from field: string token_url = 4;
   */
  tokenUrl: string;

  /**
   * client_secret задан (значение скрыто)
   *
   * @generated from field: bool client_secret_set = 5;
   */
  clientSecretSet: boolean;

  /**
   * refresh_token задан (значение скрыто)
   *
   * @generated from field: bool refresh_token_set = 6;
   */
  refreshTokenSet: boolean;

  /**
   * есть краткосрочный access_token
   *
   * @generated from field: bool access_token_set = 7;
   */
  accessTokenSet: boolean;

  /**
   * RFC3339; пусто — срок неизвестен
   *
   * @generated from field: string access_token_expires_at = 8;
   */
  accessTokenExpiresAt: string;
};

/**
 * Describes the message zdc.MailOAuthState.
 * Use `create(MailOAuthStateSchema)` to create a new message.
 */
export const MailOAuthStateSchema: GenMessage<MailOAuthState> = /*@__PURE__*/
  messageDesc(file_zdc, 1381);

/**
 * MailEndpoint — настройки сервера SMTP/IMAP без секретов.
 *
 * @generated from message zdc.MailEndpoint
 */
export type MailEndpoint = Message<"zdc.MailEndpoint"> & {
  /**
   * @generated from field: string host = 1;
   */
  host: string;

  /**
   * @generated from field: int32 port = 2;
   */
  port: number;

  /**
   * @generated from field: string user = 3;
   */
  user: string;

  /**
   * tls | starttls | plain
   *
   * @generated from field: string security = 4;
   */
  security: string;

  /**
   * password | oauth2
   *
   * @generated from field: string auth_method = 5;
   */
  authMethod: string;

  /**
   * только SMTP
   *
   * @generated from field: string from = 6;
   */
  from: string;

  /**
   * только IMAP
   *
   * @generated from field: repeated string folders = 7;
   */
  folders: string[];

  /**
   * пароль задан (значение скрыто)
   *
   * @generated from field: bool password_set = 8;
   */
  passwordSet: boolean;

  /**
   * OAuth-состояние (если способ oauth2)
   *
   * @generated from field: zdc.MailOAuthState oauth = 9;
   */
  oauth?: MailOAuthState | undefined;
};

/**
 * Describes the message zdc.MailEndpoint.
 * Use `create(MailEndpointSchema)` to create a new message.
 */
export const MailEndpointSchema: GenMessage<MailEndpoint> = /*@__PURE__*/
  messageDesc(file_zdc, 1382);

/**
 * @generated from message zdc.MailAccount
 */
export type MailAccount = Message<"zdc.MailAccount"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string display_name = 4;
   */
  displayName: string;

  /**
   * пусто — общий (сервисный) пул базы
   *
   * @generated from field: string owner_id = 5;
   */
  ownerId: string;

  /**
   * @generated from field: bool enabled = 6;
   */
  enabled: boolean;

  /**
   * @generated from field: string last_sync_at = 7;
   */
  lastSyncAt: string;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 9;
   */
  updatedAt: string;

  /**
   * @generated from field: zdc.MailEndpoint smtp = 10;
   */
  smtp?: MailEndpoint | undefined;

  /**
   * @generated from field: zdc.MailEndpoint imap = 11;
   */
  imap?: MailEndpoint | undefined;
};

/**
 * Describes the message zdc.MailAccount.
 * Use `create(MailAccountSchema)` to create a new message.
 */
export const MailAccountSchema: GenMessage<MailAccount> = /*@__PURE__*/
  messageDesc(file_zdc, 1383);

/**
 * @generated from message zdc.ListMailAccountsRequest
 */
export type ListMailAccountsRequest = Message<"zdc.ListMailAccountsRequest"> & {
  /**
   * Фильтр по владельцу (только администратор). Не-админ всегда видит свои.
   *
   * @generated from field: string owner_id = 1;
   */
  ownerId: string;

  /**
   * по умолчанию только включённые
   *
   * @generated from field: bool include_disabled = 2;
   */
  includeDisabled: boolean;
};

/**
 * Describes the message zdc.ListMailAccountsRequest.
 * Use `create(ListMailAccountsRequestSchema)` to create a new message.
 */
export const ListMailAccountsRequestSchema: GenMessage<ListMailAccountsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1384);

/**
 * @generated from message zdc.ListMailAccountsResponse
 */
export type ListMailAccountsResponse = Message<"zdc.ListMailAccountsResponse"> & {
  /**
   * @generated from field: repeated zdc.MailAccount items = 1;
   */
  items: MailAccount[];

  /**
   * Действующий лимит и число активных ящиков ТЕКУЩЕГО пользователя
   * (0 в limit = без ограничения).
   *
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: int32 active_count = 3;
   */
  activeCount: number;
};

/**
 * Describes the message zdc.ListMailAccountsResponse.
 * Use `create(ListMailAccountsResponseSchema)` to create a new message.
 */
export const ListMailAccountsResponseSchema: GenMessage<ListMailAccountsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1385);

/**
 * @generated from message zdc.GetMailAccountRequest
 */
export type GetMailAccountRequest = Message<"zdc.GetMailAccountRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.GetMailAccountRequest.
 * Use `create(GetMailAccountRequestSchema)` to create a new message.
 */
export const GetMailAccountRequestSchema: GenMessage<GetMailAccountRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1386);

/**
 * @generated from message zdc.GetMailAccountResponse
 */
export type GetMailAccountResponse = Message<"zdc.GetMailAccountResponse"> & {
  /**
   * @generated from field: zdc.MailAccount account = 1;
   */
  account?: MailAccount | undefined;
};

/**
 * Describes the message zdc.GetMailAccountResponse.
 * Use `create(GetMailAccountResponseSchema)` to create a new message.
 */
export const GetMailAccountResponseSchema: GenMessage<GetMailAccountResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1387);

/**
 * MailOAuthInput — секреты OAuth2 только на запись.
 *
 * @generated from message zdc.MailOAuthInput
 */
export type MailOAuthInput = Message<"zdc.MailOAuthInput"> & {
  /**
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * @generated from field: string client_id = 2;
   */
  clientId: string;

  /**
   * пусто = не менять
   *
   * @generated from field: string client_secret = 3;
   */
  clientSecret: string;

  /**
   * пусто = не менять
   *
   * @generated from field: string refresh_token = 4;
   */
  refreshToken: string;

  /**
   * @generated from field: string scope = 5;
   */
  scope: string;

  /**
   * @generated from field: string token_url = 6;
   */
  tokenUrl: string;
};

/**
 * Describes the message zdc.MailOAuthInput.
 * Use `create(MailOAuthInputSchema)` to create a new message.
 */
export const MailOAuthInputSchema: GenMessage<MailOAuthInput> = /*@__PURE__*/
  messageDesc(file_zdc, 1388);

/**
 * @generated from message zdc.MailEndpointInput
 */
export type MailEndpointInput = Message<"zdc.MailEndpointInput"> & {
  /**
   * @generated from field: string host = 1;
   */
  host: string;

  /**
   * @generated from field: int32 port = 2;
   */
  port: number;

  /**
   * @generated from field: string user = 3;
   */
  user: string;

  /**
   * @generated from field: string security = 4;
   */
  security: string;

  /**
   * @generated from field: string auth_method = 5;
   */
  authMethod: string;

  /**
   * @generated from field: string from = 6;
   */
  from: string;

  /**
   * @generated from field: repeated string folders = 7;
   */
  folders: string[];

  /**
   * пусто = не менять
   *
   * @generated from field: string password = 8;
   */
  password: string;

  /**
   * явно удалить пароль
   *
   * @generated from field: bool clear_password = 9;
   */
  clearPassword: boolean;

  /**
   * пусто = не менять OAuth-параметры
   *
   * @generated from field: zdc.MailOAuthInput oauth = 10;
   */
  oauth?: MailOAuthInput | undefined;

  /**
   * явно удалить OAuth-параметры
   *
   * @generated from field: bool clear_oauth = 11;
   */
  clearOauth: boolean;
};

/**
 * Describes the message zdc.MailEndpointInput.
 * Use `create(MailEndpointInputSchema)` to create a new message.
 */
export const MailEndpointInputSchema: GenMessage<MailEndpointInput> = /*@__PURE__*/
  messageDesc(file_zdc, 1389);

/**
 * @generated from message zdc.SaveMailAccountRequest
 */
export type SaveMailAccountRequest = Message<"zdc.SaveMailAccountRequest"> & {
  /**
   * пусто = создать
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string display_name = 4;
   */
  displayName: string;

  /**
   * @generated from field: bool enabled = 5;
   */
  enabled: boolean;

  /**
   * только администратор; не-админ — принудительно свой
   *
   * @generated from field: string owner_id = 6;
   */
  ownerId: string;

  /**
   * @generated from field: zdc.MailEndpointInput smtp = 7;
   */
  smtp?: MailEndpointInput | undefined;

  /**
   * @generated from field: zdc.MailEndpointInput imap = 8;
   */
  imap?: MailEndpointInput | undefined;
};

/**
 * Describes the message zdc.SaveMailAccountRequest.
 * Use `create(SaveMailAccountRequestSchema)` to create a new message.
 */
export const SaveMailAccountRequestSchema: GenMessage<SaveMailAccountRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1390);

/**
 * @generated from message zdc.SaveMailAccountResponse
 */
export type SaveMailAccountResponse = Message<"zdc.SaveMailAccountResponse"> & {
  /**
   * @generated from field: zdc.MailAccount account = 1;
   */
  account?: MailAccount | undefined;
};

/**
 * Describes the message zdc.SaveMailAccountResponse.
 * Use `create(SaveMailAccountResponseSchema)` to create a new message.
 */
export const SaveMailAccountResponseSchema: GenMessage<SaveMailAccountResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1391);

/**
 * @generated from message zdc.DeleteMailAccountRequest
 */
export type DeleteMailAccountRequest = Message<"zdc.DeleteMailAccountRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteMailAccountRequest.
 * Use `create(DeleteMailAccountRequestSchema)` to create a new message.
 */
export const DeleteMailAccountRequestSchema: GenMessage<DeleteMailAccountRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1392);

/**
 * @generated from message zdc.DeleteMailAccountResponse
 */
export type DeleteMailAccountResponse = Message<"zdc.DeleteMailAccountResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.DeleteMailAccountResponse.
 * Use `create(DeleteMailAccountResponseSchema)` to create a new message.
 */
export const DeleteMailAccountResponseSchema: GenMessage<DeleteMailAccountResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1393);

/**
 * @generated from message zdc.ReconnectMailAccountRequest
 */
export type ReconnectMailAccountRequest = Message<"zdc.ReconnectMailAccountRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message zdc.ReconnectMailAccountRequest.
 * Use `create(ReconnectMailAccountRequestSchema)` to create a new message.
 */
export const ReconnectMailAccountRequestSchema: GenMessage<ReconnectMailAccountRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1394);

/**
 * @generated from message zdc.ReconnectMailAccountResponse
 */
export type ReconnectMailAccountResponse = Message<"zdc.ReconnectMailAccountResponse"> & {
  /**
   * @generated from field: zdc.MailAccount account = 1;
   */
  account?: MailAccount | undefined;

  /**
   * состояние догона IMAP сброшено
   *
   * @generated from field: bool reset_sync = 2;
   */
  resetSync: boolean;

  /**
   * ящик включён после переподключения
   *
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;

  /**
   * понятное описание (без секретов)
   *
   * @generated from field: string message = 4;
   */
  message: string;
};

/**
 * Describes the message zdc.ReconnectMailAccountResponse.
 * Use `create(ReconnectMailAccountResponseSchema)` to create a new message.
 */
export const ReconnectMailAccountResponseSchema: GenMessage<ReconnectMailAccountResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1395);

/**
 * @generated from message zdc.TestMailAccountRequest
 */
export type TestMailAccountRequest = Message<"zdc.TestMailAccountRequest"> & {
  /**
   * сохранённый ящик (приоритет)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * проверка ДО сохранения
   *
   * @generated from field: zdc.SaveMailAccountRequest draft = 2;
   */
  draft?: SaveMailAccountRequest | undefined;
};

/**
 * Describes the message zdc.TestMailAccountRequest.
 * Use `create(TestMailAccountRequestSchema)` to create a new message.
 */
export const TestMailAccountRequestSchema: GenMessage<TestMailAccountRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1396);

/**
 * @generated from message zdc.TestMailAccountResponse
 */
export type TestMailAccountResponse = Message<"zdc.TestMailAccountResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * блокируют включение
   *
   * @generated from field: repeated string problems = 2;
   */
  problems: string[];

  /**
   * не блокируют
   *
   * @generated from field: repeated string warnings = 3;
   */
  warnings: string[];

  /**
   * @generated from field: string checked_at = 4;
   */
  checkedAt: string;
};

/**
 * Describes the message zdc.TestMailAccountResponse.
 * Use `create(TestMailAccountResponseSchema)` to create a new message.
 */
export const TestMailAccountResponseSchema: GenMessage<TestMailAccountResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1397);

/**
 * ============================================================================
 * InviteService — ПРИГЛАШЕНИЯ И ДЕРЕВО УЧАСТНИКОВ (ядро, 2026-10-27).
 * 
 * Любой пользователь создаёт код приглашения (CreateInvite) и передаёт его
 * другому человеку; тот видит пригласившего до регистрации (ResolveInvite —
 * ПУБЛИЧНЫЙ) и принимает код при регистрации/входе (AcceptInvite, а также
 * RegisterRequest.invite_code). Платформа запоминает связь «приглашённый →
 * пригласивший», глубину и родителя (дерево) — ListMyInvited.
 * 
 * Правила: приглашать — все; видеть доходы/программу — роль «Приглашения —
 * программа» (invite_program), админ — всё. Вознаграждения НЕ начисляются
 * автоматически: только явным событием при включённых настройках базы
 * (settings.invites: reward_percent / reward_fixed / currency / levels).
 * Идемпотентность: повтор создания с client_ref — тот же код; повтор
 * AcceptInvite тем же кодом — существующая связь (already_accepted). Один
 * пользователь имеет одного пригласившего; чужой погашенный код — ошибка.
 * ============================================================================
 *
 * @generated from message zdc.InviteToken
 */
export type InviteToken = Message<"zdc.InviteToken"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string inviter_id = 3;
   */
  inviterId: string;

  /**
   * @generated from field: string inviter_name = 4;
   */
  inviterName: string;

  /**
   * active | used | revoked | expired
   *
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * кто погасил (id пользователя)
   *
   * @generated from field: string used_by = 6;
   */
  usedBy: string;

  /**
   * @generated from field: string used_at = 7;
   */
  usedAt: string;

  /**
   * @generated from field: string expires_at = 8;
   */
  expiresAt: string;

  /**
   * web | api | manual ...
   *
   * @generated from field: string source = 9;
   */
  source: string;

  /**
   * @generated from field: string created_at = 10;
   */
  createdAt: string;
};

/**
 * Describes the message zdc.InviteToken.
 * Use `create(InviteTokenSchema)` to create a new message.
 */
export const InviteTokenSchema: GenMessage<InviteToken> = /*@__PURE__*/
  messageDesc(file_zdc, 1398);

/**
 * @generated from message zdc.InviteSettings
 */
export type InviteSettings = Message<"zdc.InviteSettings"> & {
  /**
   * приглашения включены в базе
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * вознаграждения включены (по умолчанию НЕТ)
   *
   * @generated from field: bool rewards_enabled = 2;
   */
  rewardsEnabled: boolean;

  /**
   * процент от суммы события (0..100)
   *
   * @generated from field: double reward_percent = 3;
   */
  rewardPercent: number;

  /**
   * фиксированная сумма (минимальные единицы)
   *
   * @generated from field: int64 reward_fixed = 4;
   */
  rewardFixed: bigint;

  /**
   * валюта вознаграждения
   *
   * @generated from field: string currency = 5;
   */
  currency: string;

  /**
   * сколько уровней дерева получают начисление
   *
   * @generated from field: int32 reward_levels = 6;
   */
  rewardLevels: number;

  /**
   * предел глубины (0 — без ограничения)
   *
   * @generated from field: int32 max_depth = 7;
   */
  maxDepth: number;

  /**
   * роль «видеть доходы/программу»
   *
   * @generated from field: string program_role = 8;
   */
  programRole: string;
};

/**
 * Describes the message zdc.InviteSettings.
 * Use `create(InviteSettingsSchema)` to create a new message.
 */
export const InviteSettingsSchema: GenMessage<InviteSettings> = /*@__PURE__*/
  messageDesc(file_zdc, 1399);

/**
 * @generated from message zdc.InviteNode
 */
export type InviteNode = Message<"zdc.InviteNode"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string login = 3;
   */
  login: string;

  /**
   * прямой пригласивший
   *
   * @generated from field: string inviter_id = 4;
   */
  inviterId: string;

  /**
   * пригласивший пригласившего
   *
   * @generated from field: string parent_user_id = 5;
   */
  parentUserId: string;

  /**
   * 0 — корень, 1 — приглашён корнем
   *
   * @generated from field: int32 depth = 6;
   */
  depth: number;

  /**
   * @generated from field: string source = 7;
   */
  source: string;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;

  /**
   * прямых приглашённых
   *
   * @generated from field: int32 invited_count = 9;
   */
  invitedCount: number;

  /**
   * @generated from field: repeated zdc.InviteNode children = 10;
   */
  children: InviteNode[];
};

/**
 * Describes the message zdc.InviteNode.
 * Use `create(InviteNodeSchema)` to create a new message.
 */
export const InviteNodeSchema: GenMessage<InviteNode> = /*@__PURE__*/
  messageDesc(file_zdc, 1400);

/**
 * @generated from message zdc.CreateInviteRequest
 */
export type CreateInviteRequest = Message<"zdc.CreateInviteRequest"> & {
  /**
   * Идемпотентность: повтор с тем же client_ref возвращает тот же код.
   *
   * @generated from field: string client_ref = 1;
   */
  clientRef: string;

  /**
   * Срок действия кода в часах (0 — настройки базы: invites.code_ttl_hours).
   *
   * @generated from field: int32 expires_in_hours = 2;
   */
  expiresInHours: number;

  /**
   * откуда создан: web | api | manual ...
   *
   * @generated from field: string source = 3;
   */
  source: string;
};

/**
 * Describes the message zdc.CreateInviteRequest.
 * Use `create(CreateInviteRequestSchema)` to create a new message.
 */
export const CreateInviteRequestSchema: GenMessage<CreateInviteRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1401);

/**
 * @generated from message zdc.CreateInviteResponse
 */
export type CreateInviteResponse = Message<"zdc.CreateInviteResponse"> & {
  /**
   * @generated from field: zdc.InviteToken invite = 1;
   */
  invite?: InviteToken | undefined;

  /**
   * @generated from field: zdc.InviteSettings settings = 2;
   */
  settings?: InviteSettings | undefined;

  /**
   * true — код уже существовал (идемпотентность/действующий код пользователя).
   *
   * @generated from field: bool reused = 3;
   */
  reused: boolean;
};

/**
 * Describes the message zdc.CreateInviteResponse.
 * Use `create(CreateInviteResponseSchema)` to create a new message.
 */
export const CreateInviteResponseSchema: GenMessage<CreateInviteResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1402);

/**
 * @generated from message zdc.ResolveInviteRequest
 */
export type ResolveInviteRequest = Message<"zdc.ResolveInviteRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message zdc.ResolveInviteRequest.
 * Use `create(ResolveInviteRequestSchema)` to create a new message.
 */
export const ResolveInviteRequestSchema: GenMessage<ResolveInviteRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1403);

/**
 * @generated from message zdc.ResolveInviteResponse
 */
export type ResolveInviteResponse = Message<"zdc.ResolveInviteResponse"> & {
  /**
   * код можно принять сейчас
   *
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * @generated from field: zdc.InviteToken invite = 2;
   */
  invite?: InviteToken | undefined;

  /**
   * @generated from field: zdc.InviteSettings settings = 3;
   */
  settings?: InviteSettings | undefined;
};

/**
 * Describes the message zdc.ResolveInviteResponse.
 * Use `create(ResolveInviteResponseSchema)` to create a new message.
 */
export const ResolveInviteResponseSchema: GenMessage<ResolveInviteResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1404);

/**
 * @generated from message zdc.AcceptInviteRequest
 */
export type AcceptInviteRequest = Message<"zdc.AcceptInviteRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * Кого пригласили: пусто — текущий пользователь; чужой — только админ.
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * invite | manual ...
   *
   * @generated from field: string source = 3;
   */
  source: string;
};

/**
 * Describes the message zdc.AcceptInviteRequest.
 * Use `create(AcceptInviteRequestSchema)` to create a new message.
 */
export const AcceptInviteRequestSchema: GenMessage<AcceptInviteRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1405);

/**
 * @generated from message zdc.AcceptInviteResponse
 */
export type AcceptInviteResponse = Message<"zdc.AcceptInviteResponse"> & {
  /**
   * принятая связь (с глубиной)
   *
   * @generated from field: zdc.InviteNode node = 1;
   */
  node?: InviteNode | undefined;

  /**
   * повторный приём — связь уже была
   *
   * @generated from field: bool already_accepted = 2;
   */
  alreadyAccepted: boolean;

  /**
   * @generated from field: zdc.InviteSettings settings = 3;
   */
  settings?: InviteSettings | undefined;
};

/**
 * Describes the message zdc.AcceptInviteResponse.
 * Use `create(AcceptInviteResponseSchema)` to create a new message.
 */
export const AcceptInviteResponseSchema: GenMessage<AcceptInviteResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1406);

/**
 * @generated from message zdc.ListMyInvitedRequest
 */
export type ListMyInvitedRequest = Message<"zdc.ListMyInvitedRequest"> & {
  /**
   * Пусто — свои приглашения; чужой — только админ.
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * Предел обхода дерева (0 — настройки базы / жёсткий предел).
   *
   * @generated from field: int32 max_depth = 2;
   */
  maxDepth: number;
};

/**
 * Describes the message zdc.ListMyInvitedRequest.
 * Use `create(ListMyInvitedRequestSchema)` to create a new message.
 */
export const ListMyInvitedRequestSchema: GenMessage<ListMyInvitedRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1407);

/**
 * @generated from message zdc.ListMyInvitedResponse
 */
export type ListMyInvitedResponse = Message<"zdc.ListMyInvitedResponse"> & {
  /**
   * сам пользователь + дерево приглашённых
   *
   * @generated from field: zdc.InviteNode root = 1;
   */
  root?: InviteNode | undefined;

  /**
   * всего приглашённых ниже корня
   *
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * @generated from field: int32 max_depth_reached = 3;
   */
  maxDepthReached: number;

  /**
   * @generated from field: zdc.InviteSettings settings = 4;
   */
  settings?: InviteSettings | undefined;
};

/**
 * Describes the message zdc.ListMyInvitedResponse.
 * Use `create(ListMyInvitedResponseSchema)` to create a new message.
 */
export const ListMyInvitedResponseSchema: GenMessage<ListMyInvitedResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1408);

/**
 * @generated from message zdc.InviteReward
 */
export type InviteReward = Message<"zdc.InviteReward"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string invite_id = 2;
   */
  inviteId: string;

  /**
   * payment | invite
   *
   * @generated from field: string subject_type = 3;
   */
  subjectType: string;

  /**
   * платёж/событие (идемпотентность)
   *
   * @generated from field: string subject_id = 4;
   */
  subjectId: string;

  /**
   * кому начислено
   *
   * @generated from field: string inviter_id = 5;
   */
  inviterId: string;

  /**
   * @generated from field: string inviter_name = 6;
   */
  inviterName: string;

  /**
   * от кого
   *
   * @generated from field: string invited_id = 7;
   */
  invitedId: string;

  /**
   * @generated from field: string invited_name = 8;
   */
  invitedName: string;

  /**
   * 1 — прямой пригласивший
   *
   * @generated from field: int32 level = 9;
   */
  level: number;

  /**
   * минимальные единицы валюты
   *
   * @generated from field: int64 amount = 10;
   */
  amount: bigint;

  /**
   * @generated from field: double percent = 11;
   */
  percent: number;

  /**
   * @generated from field: string currency = 12;
   */
  currency: string;

  /**
   * pending | earned | paid | canceled
   *
   * @generated from field: string status = 13;
   */
  status: string;

  /**
   * проводка/биллинг-операция
   *
   * @generated from field: string ledger_id = 14;
   */
  ledgerId: string;

  /**
   * @generated from field: string created_at = 15;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 16;
   */
  updatedAt: string;
};

/**
 * Describes the message zdc.InviteReward.
 * Use `create(InviteRewardSchema)` to create a new message.
 */
export const InviteRewardSchema: GenMessage<InviteReward> = /*@__PURE__*/
  messageDesc(file_zdc, 1409);

/**
 * @generated from message zdc.ListInviteRewardsRequest
 */
export type ListInviteRewardsRequest = Message<"zdc.ListInviteRewardsRequest"> & {
  /**
   * пусто — свои (админ: все); чужой — только админ
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * '' — все
   *
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset: number;
};

/**
 * Describes the message zdc.ListInviteRewardsRequest.
 * Use `create(ListInviteRewardsRequestSchema)` to create a new message.
 */
export const ListInviteRewardsRequestSchema: GenMessage<ListInviteRewardsRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1410);

/**
 * @generated from message zdc.ListInviteRewardsResponse
 */
export type ListInviteRewardsResponse = Message<"zdc.ListInviteRewardsResponse"> & {
  /**
   * @generated from field: repeated zdc.InviteReward items = 1;
   */
  items: InviteReward[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * сумма по всему фильтру (не по странице)
   *
   * @generated from field: int64 total_amount = 3;
   */
  totalAmount: bigint;

  /**
   * @generated from field: zdc.InviteSettings settings = 4;
   */
  settings?: InviteSettings | undefined;
};

/**
 * Describes the message zdc.ListInviteRewardsResponse.
 * Use `create(ListInviteRewardsResponseSchema)` to create a new message.
 */
export const ListInviteRewardsResponseSchema: GenMessage<ListInviteRewardsResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1411);

/**
 * @generated from message zdc.AssignAttendingDoctorRequest
 */
export type AssignAttendingDoctorRequest = Message<"zdc.AssignAttendingDoctorRequest"> & {
  /**
   * @generated from field: string patient_id = 1;
   */
  patientId: string;

  /**
   * @generated from field: string doctor_id = 2;
   */
  doctorId: string;

  /**
   * необязательная причина передачи (в историю)
   *
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message zdc.AssignAttendingDoctorRequest.
 * Use `create(AssignAttendingDoctorRequestSchema)` to create a new message.
 */
export const AssignAttendingDoctorRequestSchema: GenMessage<AssignAttendingDoctorRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1412);

/**
 * @generated from message zdc.AssignAttendingDoctorResponse
 */
export type AssignAttendingDoctorResponse = Message<"zdc.AssignAttendingDoctorResponse"> & {
  /**
   * @generated from field: string patient_id = 1;
   */
  patientId: string;

  /**
   * @generated from field: string doctor_id = 2;
   */
  doctorId: string;

  /**
   * @generated from field: string doctor_name = 3;
   */
  doctorName: string;

  /**
   * @generated from field: string previous_doctor_id = 4;
   */
  previousDoctorId: string;

  /**
   * @generated from field: string previous_doctor_name = 5;
   */
  previousDoctorName: string;

  /**
   * id новой активной строки истории
   *
   * @generated from field: string care_team_id = 6;
   */
  careTeamId: string;

  /**
   * false — врач уже лечащий (идемпотентно)
   *
   * @generated from field: bool changed = 7;
   */
  changed: boolean;
};

/**
 * Describes the message zdc.AssignAttendingDoctorResponse.
 * Use `create(AssignAttendingDoctorResponseSchema)` to create a new message.
 */
export const AssignAttendingDoctorResponseSchema: GenMessage<AssignAttendingDoctorResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1413);

/**
 * @generated from message zdc.LabCsvRowError
 */
export type LabCsvRowError = Message<"zdc.LabCsvRowError"> & {
  /**
   * номер строки файла (0 — ошибка всего файла/связи)
   *
   * @generated from field: int32 line = 1;
   */
  line: number;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * исходная строка (для разбора)
   *
   * @generated from field: string raw = 3;
   */
  raw: string;
};

/**
 * Describes the message zdc.LabCsvRowError.
 * Use `create(LabCsvRowErrorSchema)` to create a new message.
 */
export const LabCsvRowErrorSchema: GenMessage<LabCsvRowError> = /*@__PURE__*/
  messageDesc(file_zdc, 1414);

/**
 * @generated from message zdc.ImportLabResultsCsvRequest
 */
export type ImportLabResultsCsvRequest = Message<"zdc.ImportLabResultsCsvRequest"> & {
  /**
   * @generated from field: string patient_id = 1;
   */
  patientId: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: bytes data = 3;
   */
  data: Uint8Array;

  /**
   * @generated from field: string lab_name = 4;
   */
  labName: string;

  /**
   * дата/время взятия (необязательно)
   *
   * @generated from field: string collected_at = 5;
   */
  collectedAt: string;
};

/**
 * Describes the message zdc.ImportLabResultsCsvRequest.
 * Use `create(ImportLabResultsCsvRequestSchema)` to create a new message.
 */
export const ImportLabResultsCsvRequestSchema: GenMessage<ImportLabResultsCsvRequest> = /*@__PURE__*/
  messageDesc(file_zdc, 1415);

/**
 * @generated from message zdc.ImportLabResultsCsvResponse
 */
export type ImportLabResultsCsvResponse = Message<"zdc.ImportLabResultsCsvResponse"> & {
  /**
   * пусто — не было валидных строк, документ не создан
   *
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * исходный файл в «Файлах» (не теряется)
   *
   * @generated from field: string source_file_id = 2;
   */
  sourceFileId: string;

  /**
   * @generated from field: int32 imported = 3;
   */
  imported: number;

  /**
   * @generated from field: int32 skipped = 4;
   */
  skipped: number;

  /**
   * @generated from field: repeated zdc.LabCsvRowError errors = 5;
   */
  errors: LabCsvRowError[];
};

/**
 * Describes the message zdc.ImportLabResultsCsvResponse.
 * Use `create(ImportLabResultsCsvResponseSchema)` to create a new message.
 */
export const ImportLabResultsCsvResponseSchema: GenMessage<ImportLabResultsCsvResponse> = /*@__PURE__*/
  messageDesc(file_zdc, 1416);

/**
 * @generated from enum zdc.ReportFormat
 */
export enum ReportFormat {
  /**
   * @generated from enum value: REPORT_FORMAT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPORT_FORMAT_JSON = 1;
   */
  JSON = 1,

  /**
   * @generated from enum value: REPORT_FORMAT_HTML = 2;
   */
  HTML = 2,

  /**
   * @generated from enum value: REPORT_FORMAT_CSV = 3;
   */
  CSV = 3,

  /**
   * @generated from enum value: REPORT_FORMAT_XLSX = 4;
   */
  XLSX = 4,

  /**
   * @generated from enum value: REPORT_FORMAT_PDF = 5;
   */
  PDF = 5,
}

/**
 * Describes the enum zdc.ReportFormat.
 */
export const ReportFormatSchema: GenEnum<ReportFormat> = /*@__PURE__*/
  enumDesc(file_zdc, 0);

/**
 * --- AskAgentStream: ПОТОКОВЫЙ вызов агента (server-streaming) ---
 * Тип события чанка (дискриминатор — однозначность, без «пусто/не задано»).
 *
 * @generated from enum zdc.AskAgentChunkType
 */
export enum AskAgentChunkType {
  /**
   * @generated from enum value: ASK_AGENT_CHUNK_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * токены финального ответа (content — дельта)
   *
   * @generated from enum value: ASK_AGENT_CHUNK_TYPE_TEXT_DELTA = 1;
   */
  TEXT_DELTA = 1,

  /**
   * агент начал вызывать инструмент (tool.name)
   *
   * @generated from enum value: ASK_AGENT_CHUNK_TYPE_TOOL_START = 2;
   */
  TOOL_START = 2,

  /**
   * результат инструмента (tool.name + content)
   *
   * @generated from enum value: ASK_AGENT_CHUNK_TYPE_TOOL_RESULT = 3;
   */
  TOOL_RESULT = 3,

  /**
   * успешное завершение (usage)
   *
   * @generated from enum value: ASK_AGENT_CHUNK_TYPE_DONE = 4;
   */
  DONE = 4,
}

/**
 * Describes the enum zdc.AskAgentChunkType.
 */
export const AskAgentChunkTypeSchema: GenEnum<AskAgentChunkType> = /*@__PURE__*/
  enumDesc(file_zdc, 1);

/**
 * Base management
 *
 * @generated from service zdc.BaseService
 */
export const BaseService: GenService<{
  /**
   * @generated from rpc zdc.BaseService.CreateBase
   */
  createBase: {
    methodKind: "unary";
    input: typeof CreateBaseRequestSchema;
    output: typeof BaseSchema;
  },
  /**
   * @generated from rpc zdc.BaseService.ListBases
   */
  listBases: {
    methodKind: "unary";
    input: typeof ListBasesRequestSchema;
    output: typeof BaseListSchema;
  },
  /**
   * @generated from rpc zdc.BaseService.GetBase
   */
  getBase: {
    methodKind: "unary";
    input: typeof GetBaseRequestSchema;
    output: typeof BaseSchema;
  },
  /**
   * @generated from rpc zdc.BaseService.UpdateBase
   */
  updateBase: {
    methodKind: "unary";
    input: typeof UpdateBaseRequestSchema;
    output: typeof BaseSchema;
  },
  /**
   * @generated from rpc zdc.BaseService.DeleteBase
   */
  deleteBase: {
    methodKind: "unary";
    input: typeof DeleteBaseRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.BaseService.PublishBase
   */
  publishBase: {
    methodKind: "unary";
    input: typeof PublishBaseRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.BaseService.UnpublishBase
   */
  unpublishBase: {
    methodKind: "unary";
    input: typeof PublishBaseRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.BaseService.OpenBase
   */
  openBase: {
    methodKind: "unary";
    input: typeof OpenBaseRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.BaseService.PullChanges
   */
  pullChanges: {
    methodKind: "unary";
    input: typeof PullChangesRequestSchema;
    output: typeof PullChangesResponseSchema;
  },
  /**
   * Настройки ТЕКУЩЕЙ базы (JSON из реестра; slug пуст = текущая/умолчание).
   * Для публикаций: имя/иконка приложения (pwa.*) и пр. — авторизованный.
   *
   * @generated from rpc zdc.BaseService.GetBaseSettings
   */
  getBaseSettings: {
    methodKind: "unary";
    input: typeof GetBaseSettingsRequestSchema;
    output: typeof GetBaseSettingsResponseSchema;
  },
  /**
   * @generated from rpc zdc.BaseService.PushChanges
   */
  pushChanges: {
    methodKind: "unary";
    input: typeof PushChangesRequestSchema;
    output: typeof PushChangesResponseSchema;
  },
  /**
   * Выгрузка/загрузка информационной базы (аналог .dt в 1С): один файл-снимок
   * (.hdd = ZIP + zstd). Только админ. См. internal/dump.
   *
   * @generated from rpc zdc.BaseService.ExportBase
   */
  exportBase: {
    methodKind: "unary";
    input: typeof ExportBaseRequestSchema;
    output: typeof ExportBaseResultSchema;
  },
  /**
   * @generated from rpc zdc.BaseService.InspectBaseDump
   */
  inspectBaseDump: {
    methodKind: "unary";
    input: typeof InspectBaseDumpRequestSchema;
    output: typeof BaseDumpManifestSchema;
  },
  /**
   * @generated from rpc zdc.BaseService.ImportBase
   */
  importBase: {
    methodKind: "unary";
    input: typeof ImportBaseRequestSchema;
    output: typeof ImportBaseResultSchema;
  },
  /**
   * Каталог локальных баз: регистрация существующего файла .sqlite или папки.
   *
   * @generated from rpc zdc.BaseService.RegisterLocalBase
   */
  registerLocalBase: {
    methodKind: "unary";
    input: typeof RegisterLocalBaseRequestSchema;
    output: typeof BaseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 0);

/**
 * @generated from service zdc.MetadataService
 */
export const MetadataService: GenService<{
  /**
   * Catalogs
   *
   * @generated from rpc zdc.MetadataService.ListCatalogs
   */
  listCatalogs: {
    methodKind: "unary";
    input: typeof ListCatalogsRequestSchema;
    output: typeof CatalogListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.ListCardTemplates
   */
  listCardTemplates: {
    methodKind: "unary";
    input: typeof ListCardTemplatesRequestSchema;
    output: typeof CardTemplateListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.GetCardTemplate
   */
  getCardTemplate: {
    methodKind: "unary";
    input: typeof GetCardTemplateRequestSchema;
    output: typeof CardTemplateSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.CreateCardTemplate
   */
  createCardTemplate: {
    methodKind: "unary";
    input: typeof CreateCardTemplateRequestSchema;
    output: typeof CardTemplateSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.UpdateCardTemplate
   */
  updateCardTemplate: {
    methodKind: "unary";
    input: typeof UpdateCardTemplateRequestSchema;
    output: typeof CardTemplateSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteCardTemplate
   */
  deleteCardTemplate: {
    methodKind: "unary";
    input: typeof DeleteCardTemplateRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.ResolveTableEntity
   */
  resolveTableEntity: {
    methodKind: "unary";
    input: typeof ResolveTableEntityRequestSchema;
    output: typeof ResolveTableEntityResponseSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.ListStandardCommands
   */
  listStandardCommands: {
    methodKind: "unary";
    input: typeof ListStandardCommandsRequestSchema;
    output: typeof StandardCommandListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.GetCatalog
   */
  getCatalog: {
    methodKind: "unary";
    input: typeof GetCatalogRequestSchema;
    output: typeof CatalogSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.CreateCatalog
   */
  createCatalog: {
    methodKind: "unary";
    input: typeof CreateCatalogRequestSchema;
    output: typeof CatalogSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.UpdateCatalog
   */
  updateCatalog: {
    methodKind: "unary";
    input: typeof UpdateCatalogRequestSchema;
    output: typeof CatalogSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteCatalog
   */
  deleteCatalog: {
    methodKind: "unary";
    input: typeof DeleteCatalogRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Documents
   *
   * @generated from rpc zdc.MetadataService.ListDocuments
   */
  listDocuments: {
    methodKind: "unary";
    input: typeof ListDocumentsRequestSchema;
    output: typeof DocumentListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.GetDocument
   */
  getDocument: {
    methodKind: "unary";
    input: typeof GetDocumentRequestSchema;
    output: typeof DocumentSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.CreateDocument
   */
  createDocument: {
    methodKind: "unary";
    input: typeof CreateDocumentRequestSchema;
    output: typeof DocumentSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.UpdateDocument
   */
  updateDocument: {
    methodKind: "unary";
    input: typeof UpdateDocumentRequestSchema;
    output: typeof DocumentSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteDocument
   */
  deleteDocument: {
    methodKind: "unary";
    input: typeof DeleteDocumentRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Registers
   *
   * @generated from rpc zdc.MetadataService.ListRegisters
   */
  listRegisters: {
    methodKind: "unary";
    input: typeof ListRegistersRequestSchema;
    output: typeof RegisterListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.GetRegister
   */
  getRegister: {
    methodKind: "unary";
    input: typeof GetRegisterRequestSchema;
    output: typeof RegisterSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.CreateRegister
   */
  createRegister: {
    methodKind: "unary";
    input: typeof CreateRegisterRequestSchema;
    output: typeof RegisterSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.UpdateRegister
   */
  updateRegister: {
    methodKind: "unary";
    input: typeof UpdateRegisterRequestSchema;
    output: typeof RegisterSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteRegister
   */
  deleteRegister: {
    methodKind: "unary";
    input: typeof DeleteRegisterRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Fields
   *
   * @generated from rpc zdc.MetadataService.ListFields
   */
  listFields: {
    methodKind: "unary";
    input: typeof ListFieldsRequestSchema;
    output: typeof FieldListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.GetField
   */
  getField: {
    methodKind: "unary";
    input: typeof GetFieldRequestSchema;
    output: typeof FieldSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.CreateField
   */
  createField: {
    methodKind: "unary";
    input: typeof CreateFieldRequestSchema;
    output: typeof FieldSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.UpdateField
   */
  updateField: {
    methodKind: "unary";
    input: typeof UpdateFieldRequestSchema;
    output: typeof FieldSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteField
   */
  deleteField: {
    methodKind: "unary";
    input: typeof DeleteFieldRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Дополнения платформы (реестр возможностей ядра)
   *
   * @generated from rpc zdc.MetadataService.ListFieldExtensions
   */
  listFieldExtensions: {
    methodKind: "unary";
    input: typeof ListFieldExtensionsRequestSchema;
    output: typeof FieldExtensionListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.GetFieldExtension
   */
  getFieldExtension: {
    methodKind: "unary";
    input: typeof GetFieldExtensionRequestSchema;
    output: typeof FieldExtensionSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.SaveFieldExtension
   */
  saveFieldExtension: {
    methodKind: "unary";
    input: typeof SaveFieldExtensionRequestSchema;
    output: typeof FieldExtensionSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteFieldExtension
   */
  deleteFieldExtension: {
    methodKind: "unary";
    input: typeof DeleteFieldExtensionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * «Снять с поддержки» (как в 1С): объект поставки → пользовательский
   *
   * @generated from rpc zdc.MetadataService.UnprotectTemplateObject
   */
  unprotectTemplateObject: {
    methodKind: "unary";
    input: typeof UnprotectTemplateObjectRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Defined types (как в 1С)
   *
   * @generated from rpc zdc.MetadataService.ListDefinedTypes
   */
  listDefinedTypes: {
    methodKind: "unary";
    input: typeof ListDefinedTypesRequestSchema;
    output: typeof DefinedTypeListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.GetDefinedType
   */
  getDefinedType: {
    methodKind: "unary";
    input: typeof GetDefinedTypeRequestSchema;
    output: typeof DefinedTypeSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.CreateDefinedType
   */
  createDefinedType: {
    methodKind: "unary";
    input: typeof CreateDefinedTypeRequestSchema;
    output: typeof DefinedTypeSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.UpdateDefinedType
   */
  updateDefinedType: {
    methodKind: "unary";
    input: typeof UpdateDefinedTypeRequestSchema;
    output: typeof DefinedTypeSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteDefinedType
   */
  deleteDefinedType: {
    methodKind: "unary";
    input: typeof DeleteDefinedTypeRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Перечисления (как в 1С): значения — предопределённые (имя/синоним/порядок)
   *
   * @generated from rpc zdc.MetadataService.ListEnums
   */
  listEnums: {
    methodKind: "unary";
    input: typeof ListEnumsRequestSchema;
    output: typeof EnumListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.GetEnum
   */
  getEnum: {
    methodKind: "unary";
    input: typeof GetEnumRequestSchema;
    output: typeof EnumSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.CreateEnum
   */
  createEnum: {
    methodKind: "unary";
    input: typeof CreateEnumRequestSchema;
    output: typeof EnumSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.UpdateEnum
   */
  updateEnum: {
    methodKind: "unary";
    input: typeof UpdateEnumRequestSchema;
    output: typeof EnumSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteEnum
   */
  deleteEnum: {
    methodKind: "unary";
    input: typeof DeleteEnumRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Предопределённые элементы (как в 1С): конфигурация → синхронизация в данные
   *
   * @generated from rpc zdc.MetadataService.ListPredetermined
   */
  listPredetermined: {
    methodKind: "unary";
    input: typeof ListPredeterminedRequestSchema;
    output: typeof PredeterminedListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.SavePredetermined
   */
  savePredetermined: {
    methodKind: "unary";
    input: typeof SavePredeterminedRequestSchema;
    output: typeof PredeterminedSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeletePredetermined
   */
  deletePredetermined: {
    methodKind: "unary";
    input: typeof DeletePredeterminedRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Функциональные опции (как в 1С): переключатели функциональности
   *
   * @generated from rpc zdc.MetadataService.ListFunctionalOptions
   */
  listFunctionalOptions: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof FunctionalOptionListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.GetFunctionalOption
   */
  getFunctionalOption: {
    methodKind: "unary";
    input: typeof GetFunctionalOptionRequestSchema;
    output: typeof FunctionalOptionSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.SaveFunctionalOption
   */
  saveFunctionalOption: {
    methodKind: "unary";
    input: typeof SaveFunctionalOptionRequestSchema;
    output: typeof FunctionalOptionSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteFunctionalOption
   */
  deleteFunctionalOption: {
    methodKind: "unary";
    input: typeof DeleteFunctionalOptionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Константы (как в 1С): отдельный элемент метаданных (реестр + значение)
   *
   * @generated from rpc zdc.MetadataService.ListConstants
   */
  listConstants: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ConstantListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.GetConstant
   */
  getConstant: {
    methodKind: "unary";
    input: typeof GetConstantRequestSchema;
    output: typeof ConstantSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.SaveConstant
   */
  saveConstant: {
    methodKind: "unary";
    input: typeof SaveConstantRequestSchema;
    output: typeof ConstantSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteConstant
   */
  deleteConstant: {
    methodKind: "unary";
    input: typeof DeleteConstantRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Языки (как в 1С): перечень языков конфигурации (системный «Русский»).
   * Настройка «Язык» конфигурации (ConfigInfo.language) ссылается на один из них.
   *
   * @generated from rpc zdc.MetadataService.ListLanguages
   */
  listLanguages: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof LanguageListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.SaveLanguage
   */
  saveLanguage: {
    methodKind: "unary";
    input: typeof SaveLanguageRequestSchema;
    output: typeof LanguageSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteLanguage
   */
  deleteLanguage: {
    methodKind: "unary";
    input: typeof DeleteLanguageRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Реестр переводов (Этап 3): ключ → локаль → значение (уникальность key+locale).
   * List/Save/Delete — конфигуратор; GetTranslations — рабочий (кэш клиента/рантайма).
   *
   * @generated from rpc zdc.MetadataService.ListTranslations
   */
  listTranslations: {
    methodKind: "unary";
    input: typeof ListTranslationsRequestSchema;
    output: typeof TranslationListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.SaveTranslation
   */
  saveTranslation: {
    methodKind: "unary";
    input: typeof SaveTranslationRequestSchema;
    output: typeof TranslationSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteTranslation
   */
  deleteTranslation: {
    methodKind: "unary";
    input: typeof DeleteTranslationRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.GetTranslations
   */
  getTranslations: {
    methodKind: "unary";
    input: typeof GetTranslationsRequestSchema;
    output: typeof TranslationListSchema;
  },
  /**
   * Активные опции ТЕКУЩЕГО пользователя (рабочий метод, любой авторизованный)
   *
   * @generated from rpc zdc.MetadataService.GetActiveOptions
   */
  getActiveOptions: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ActiveOptionListSchema;
  },
  /**
   * Модуль конфигурации (как 1С модуль приложения): onStartup/getFunctionalOptionParam
   *
   * @generated from rpc zdc.MetadataService.GetConfigModule
   */
  getConfigModule: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ConfigModuleSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.SaveConfigModule
   */
  saveConfigModule: {
    methodKind: "unary";
    input: typeof SaveConfigModuleRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Стили оформления (платформенный механизм) + слоты цветов
   *
   * @generated from rpc zdc.MetadataService.ListStyles
   */
  listStyles: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof StyleListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.SaveStyle
   */
  saveStyle: {
    methodKind: "unary";
    input: typeof SaveStyleRequestSchema;
    output: typeof StyleSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteStyle
   */
  deleteStyle: {
    methodKind: "unary";
    input: typeof DeleteStyleRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.ListStyleSlots
   */
  listStyleSlots: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof StyleSlotListSchema;
  },
  /**
   * Цвета (справочник, как в 1С): именованные цвета конфигурации —
   * синоним + hex. Темы ссылаются на цвета («primary = Бежевый»),
   * стили — тоже («стиль «Победа» → цвет «Зелёный»).
   *
   * @generated from rpc zdc.MetadataService.ListColors
   */
  listColors: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ColorListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.SaveColor
   */
  saveColor: {
    methodKind: "unary";
    input: typeof SaveColorRequestSchema;
    output: typeof ColorSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteColor
   */
  deleteColor: {
    methodKind: "unary";
    input: typeof DeleteColorRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Условное оформление (как в 1С, на стилях)
   *
   * @generated from rpc zdc.MetadataService.ListConditionalFormats
   */
  listConditionalFormats: {
    methodKind: "unary";
    input: typeof ListConditionalFormatsRequestSchema;
    output: typeof CondFormatListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.SaveConditionalFormat
   */
  saveConditionalFormat: {
    methodKind: "unary";
    input: typeof SaveCondFormatRequestSchema;
    output: typeof CondFormatSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteConditionalFormat
   */
  deleteConditionalFormat: {
    methodKind: "unary";
    input: typeof DeleteCondFormatRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Подписки на события (асинхронные) + уведомления пользователей
   *
   * @generated from rpc zdc.MetadataService.ListEventSubscriptions
   */
  listEventSubscriptions: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EventSubscriptionListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.SaveEventSubscription
   */
  saveEventSubscription: {
    methodKind: "unary";
    input: typeof SaveEventSubscriptionRequestSchema;
    output: typeof EventSubscriptionSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteEventSubscription
   */
  deleteEventSubscription: {
    methodKind: "unary";
    input: typeof DeleteEventSubscriptionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.ListNotifications
   */
  listNotifications: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof NotificationListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.MarkNotificationsRead
   */
  markNotificationsRead: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EmptySchema;
  },
  /**
   * Tabular Sections
   *
   * @generated from rpc zdc.MetadataService.ListTabularSections
   */
  listTabularSections: {
    methodKind: "unary";
    input: typeof ListTabularSectionsRequestSchema;
    output: typeof TabularSectionListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.GetTabularSection
   */
  getTabularSection: {
    methodKind: "unary";
    input: typeof GetTabularSectionRequestSchema;
    output: typeof TabularSectionSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.CreateTabularSection
   */
  createTabularSection: {
    methodKind: "unary";
    input: typeof CreateTabularSectionRequestSchema;
    output: typeof TabularSectionSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.UpdateTabularSection
   */
  updateTabularSection: {
    methodKind: "unary";
    input: typeof UpdateTabularSectionRequestSchema;
    output: typeof TabularSectionSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteTabularSection
   */
  deleteTabularSection: {
    methodKind: "unary";
    input: typeof DeleteTabularSectionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Tabular Columns
   *
   * @generated from rpc zdc.MetadataService.ListTabularColumns
   */
  listTabularColumns: {
    methodKind: "unary";
    input: typeof ListTabularColumnsRequestSchema;
    output: typeof TabularColumnListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.GetTabularColumn
   */
  getTabularColumn: {
    methodKind: "unary";
    input: typeof GetTabularColumnRequestSchema;
    output: typeof TabularColumnSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.CreateTabularColumn
   */
  createTabularColumn: {
    methodKind: "unary";
    input: typeof CreateTabularColumnRequestSchema;
    output: typeof TabularColumnSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.UpdateTabularColumn
   */
  updateTabularColumn: {
    methodKind: "unary";
    input: typeof UpdateTabularColumnRequestSchema;
    output: typeof TabularColumnSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteTabularColumn
   */
  deleteTabularColumn: {
    methodKind: "unary";
    input: typeof DeleteTabularColumnRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Forms
   *
   * @generated from rpc zdc.MetadataService.ListForms
   */
  listForms: {
    methodKind: "unary";
    input: typeof ListFormsRequestSchema;
    output: typeof FormListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.GetForm
   */
  getForm: {
    methodKind: "unary";
    input: typeof GetFormRequestSchema;
    output: typeof FormSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.CreateForm
   */
  createForm: {
    methodKind: "unary";
    input: typeof CreateFormRequestSchema;
    output: typeof FormSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.UpdateForm
   */
  updateForm: {
    methodKind: "unary";
    input: typeof UpdateFormRequestSchema;
    output: typeof FormSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteForm
   */
  deleteForm: {
    methodKind: "unary";
    input: typeof DeleteFormRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Modules
   *
   * @generated from rpc zdc.MetadataService.ListModules
   */
  listModules: {
    methodKind: "unary";
    input: typeof ListModulesRequestSchema;
    output: typeof ModuleListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.GetModule
   */
  getModule: {
    methodKind: "unary";
    input: typeof GetModuleRequestSchema;
    output: typeof ModuleSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.CreateModule
   */
  createModule: {
    methodKind: "unary";
    input: typeof CreateModuleRequestSchema;
    output: typeof ModuleSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.UpdateModule
   */
  updateModule: {
    methodKind: "unary";
    input: typeof UpdateModuleRequestSchema;
    output: typeof ModuleSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteModule
   */
  deleteModule: {
    methodKind: "unary";
    input: typeof DeleteModuleRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.ExecuteModule
   */
  executeModule: {
    methodKind: "unary";
    input: typeof ExecuteModuleRequestSchema;
    output: typeof ExecuteModuleResponseSchema;
  },
  /**
   * Posting
   *
   * @generated from rpc zdc.MetadataService.PostDocument
   */
  postDocument: {
    methodKind: "unary";
    input: typeof PostDocumentRequestSchema;
    output: typeof PostDocumentResponseSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.UnpostDocument
   */
  unpostDocument: {
    methodKind: "unary";
    input: typeof UnpostDocumentRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * DDL Generation
   *
   * @generated from rpc zdc.MetadataService.GenerateDDL
   */
  generateDDL: {
    methodKind: "unary";
    input: typeof GenerateDDLRequestSchema;
    output: typeof GenerateDDLResponseSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.ApplyDDL
   */
  applyDDL: {
    methodKind: "unary";
    input: typeof ApplyDDLRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Table Data (generic CRUD for physical tables of catalogs/documents)
   *
   * @generated from rpc zdc.MetadataService.ListTableData
   */
  listTableData: {
    methodKind: "unary";
    input: typeof ListTableDataRequestSchema;
    output: typeof TableDataResponseSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.CreateTableRow
   */
  createTableRow: {
    methodKind: "unary";
    input: typeof CreateTableRowRequestSchema;
    output: typeof TableRowResponseSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.UpdateTableRow
   */
  updateTableRow: {
    methodKind: "unary";
    input: typeof UpdateTableRowRequestSchema;
    output: typeof TableRowResponseSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteTableRow
   */
  deleteTableRow: {
    methodKind: "unary";
    input: typeof DeleteTableRowRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * ===== ЕДИНЫЙ МЕХАНИЗМ ФОРМ (SSoT, 2026-09-04) =====
   * Манифест формы: сервер резолвит у каждого поля макета purpose
   * (physical по column_name / form_attribute / special) — клиент НЕ решает,
   * куда писать значение (снимает коллизию «Адрес» и класс подобных багов).
   *
   * @generated from rpc zdc.MetadataService.GetFormManifest
   */
  getFormManifest: {
    methodKind: "unary";
    input: typeof GetFormManifestRequestSchema;
    output: typeof FormManifestSchema;
  },
  /**
   * Сохранение формы целиком: клиент шлёт {attribute: value}, сервер делит по
   * манифесту и маршрутизирует в существующие сервисы (права/статусы/модули
   * остаются там); модуль onBeforeSave — приоритетен (см. UpdateOrder).
   *
   * @generated from rpc zdc.MetadataService.SaveForm
   */
  saveForm: {
    methodKind: "unary";
    input: typeof SaveFormRequestSchema;
    output: typeof SaveFormResponseSchema;
  },
  /**
   * АВТОПОДБОР (дополнения платформы): поиск представлений в таблице-источнике
   * (справочник/документ/задачи/заявки/пользователи) по тексту (name/code/value/
   * number LIKE) — для «Дополнения адреса» (источник «Адреса») и универсального
   * автоподбора ссылочных полей. SSoT — сервер; чтение — по правам объекта.
   *
   * @generated from rpc zdc.MetadataService.SuggestReference
   */
  suggestReference: {
    methodKind: "unary";
    input: typeof SuggestReferenceRequestSchema;
    output: typeof SuggestReferenceResponseSchema;
  },
  /**
   * Audit history for metadata objects and table rows
   *
   * @generated from rpc zdc.MetadataService.GetAuditHistory
   */
  getAuditHistory: {
    methodKind: "unary";
    input: typeof GetAuditHistoryRequestSchema;
    output: typeof AuditHistoryResponseSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.MarkObjectRead
   */
  markObjectRead: {
    methodKind: "unary";
    input: typeof ObjectReadRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.GetNumbering
   */
  getNumbering: {
    methodKind: "unary";
    input: typeof GetNumberingRequestSchema;
    output: typeof NumberingConfigSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.SetNumbering
   */
  setNumbering: {
    methodKind: "unary";
    input: typeof SetNumberingRequestSchema;
    output: typeof NumberingConfigSchema;
  },
  /**
   * HydraQL — выполнение произвольных запросов (динамические списки по запросам,
   * произвольные колонки)
   *
   * @generated from rpc zdc.MetadataService.ExecuteHydraql
   */
  executeHydraql: {
    methodKind: "unary";
    input: typeof ExecuteHydraqlRequestSchema;
    output: typeof HydraqlResponseSchema;
  },
  /**
   * Резолв составной ссылки (как в 1С): по составу типов и id определяет,
   * в какой таблице существует запись, и возвращает тип + представление.
   * SSoT: сервер — единственный источник (id существует только в одной таблице состава).
   *
   * @generated from rpc zdc.MetadataService.ResolveReference
   */
  resolveReference: {
    methodKind: "unary";
    input: typeof ResolveReferenceRequestSchema;
    output: typeof ResolveReferenceResponseSchema;
  },
  /**
   * Права на объекты метаданных (как в 1С): список прав по ролям для объекта.
   *
   * @generated from rpc zdc.MetadataService.GetObjectRights
   */
  getObjectRights: {
    methodKind: "unary";
    input: typeof GetObjectRightsRequestSchema;
    output: typeof ObjectRightsListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.SetObjectRights
   */
  setObjectRights: {
    methodKind: "unary";
    input: typeof SetObjectRightsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * ХРАНИЛИЩЕ НАСТРОЕК (как в 1С «Хранилище настроек», но с администрированием):
   * key-value (JSON) с привязкой к ПОЛЬЗОВАТЕЛЮ (user_id пуст = глобально).
   * GetUserSettings — свои + глобальные (свои переопределяют глобальные).
   * Set/DeleteUserSetting — user_id пуст = глобально (только админ);
   * чужой user_id — только админ; свой — любой авторизованный.
   * ListAllUserSettings — только админ (страница «Настройки» в конфигураторе).
   *
   * @generated from rpc zdc.MetadataService.GetUserSettings
   */
  getUserSettings: {
    methodKind: "unary";
    input: typeof GetUserSettingsRequestSchema;
    output: typeof UserSettingsListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.SetUserSetting
   */
  setUserSetting: {
    methodKind: "unary";
    input: typeof SetUserSettingRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteUserSetting
   */
  deleteUserSetting: {
    methodKind: "unary";
    input: typeof DeleteUserSettingRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.ListAllUserSettings
   */
  listAllUserSettings: {
    methodKind: "unary";
    input: typeof ListAllUserSettingsRequestSchema;
    output: typeof UserSettingsListSchema;
  },
  /**
   * НАСТРОЙКИ ОБСУЖДЕНИЯ объекта метаданных (вкладка «Обсуждения» в свойствах):
   * авто-участники контекстного чата (автор/исполнитель/все ссылки на пользователя).
   *
   * @generated from rpc zdc.MetadataService.GetChatSettings
   */
  getChatSettings: {
    methodKind: "unary";
    input: typeof GetChatSettingsRequestSchema;
    output: typeof ChatSettingsSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.SetChatSettings
   */
  setChatSettings: {
    methodKind: "unary";
    input: typeof SetChatSettingsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Макеты (как в 1С): табличный документ / текст / HTML / Word / изображение
   *
   * @generated from rpc zdc.MetadataService.ListLayouts
   */
  listLayouts: {
    methodKind: "unary";
    input: typeof ListLayoutsRequestSchema;
    output: typeof LayoutListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.GetLayout
   */
  getLayout: {
    methodKind: "unary";
    input: typeof GetLayoutRequestSchema;
    output: typeof LayoutSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.CreateLayout
   */
  createLayout: {
    methodKind: "unary";
    input: typeof CreateLayoutRequestSchema;
    output: typeof LayoutSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.UpdateLayout
   */
  updateLayout: {
    methodKind: "unary";
    input: typeof UpdateLayoutRequestSchema;
    output: typeof LayoutSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeleteLayout
   */
  deleteLayout: {
    methodKind: "unary";
    input: typeof DeleteLayoutRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.RenderLayout
   */
  renderLayout: {
    methodKind: "unary";
    input: typeof RenderLayoutRequestSchema;
    output: typeof RenderLayoutResponseSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.ConvertXls
   */
  convertXls: {
    methodKind: "unary";
    input: typeof ConvertXlsRequestSchema;
    output: typeof ConvertXlsResponseSchema;
  },
  /**
   * Редактор табличного макета: импорт xlsx → сетка JSON, экспорт сетка → xlsx
   *
   * @generated from rpc zdc.MetadataService.LayoutImportGrid
   */
  layoutImportGrid: {
    methodKind: "unary";
    input: typeof ConvertXlsRequestSchema;
    output: typeof ConvertXlsResponseSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.LayoutExportGrid
   */
  layoutExportGrid: {
    methodKind: "unary";
    input: typeof ConvertXlsRequestSchema;
    output: typeof ConvertXlsResponseSchema;
  },
  /**
   * Полномочия (как в 1С «ПолномочияСотрудников», 2026-08-30):
   * реестр полномочий + значения у пользователя/роли/контейнера + резолв.
   *
   * @generated from rpc zdc.MetadataService.ListPermissions
   */
  listPermissions: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof PermissionListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.GetPermission
   */
  getPermission: {
    methodKind: "unary";
    input: typeof GetPermissionRequestSchema;
    output: typeof PermissionSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.SavePermission
   */
  savePermission: {
    methodKind: "unary";
    input: typeof SavePermissionRequestSchema;
    output: typeof PermissionSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeletePermission
   */
  deletePermission: {
    methodKind: "unary";
    input: typeof DeletePermissionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.ListPermissionValues
   */
  listPermissionValues: {
    methodKind: "unary";
    input: typeof ListPermissionValuesRequestSchema;
    output: typeof PermissionValueListSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.SavePermissionValue
   */
  savePermissionValue: {
    methodKind: "unary";
    input: typeof SavePermissionValueRequestSchema;
    output: typeof PermissionValueSchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.DeletePermissionValue
   */
  deletePermissionValue: {
    methodKind: "unary";
    input: typeof DeletePermissionValueRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.MetadataService.ResolvePermission
   */
  resolvePermission: {
    methodKind: "unary";
    input: typeof ResolvePermissionRequestSchema;
    output: typeof ResolvedPermissionSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 1);

/**
 * @generated from service zdc.EventLogService
 */
export const EventLogService: GenService<{
  /**
   * @generated from rpc zdc.EventLogService.LogEvent
   */
  logEvent: {
    methodKind: "unary";
    input: typeof LogEventRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.EventLogService.ListEvents
   */
  listEvents: {
    methodKind: "unary";
    input: typeof EventLogListRequestSchema;
    output: typeof EventLogListSchema;
  },
  /**
   * @generated from rpc zdc.EventLogService.ClearEvents
   */
  clearEvents: {
    methodKind: "unary";
    input: typeof EventLogClearRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 2);

/**
 * ============================================================
 * BackupService - бэкапы баз (.hdd, ретеншен-полиси). Только админ.
 * ============================================================
 *
 * @generated from service zdc.BackupService
 */
export const BackupService: GenService<{
  /**
   * @generated from rpc zdc.BackupService.CreateBackup
   */
  createBackup: {
    methodKind: "unary";
    input: typeof CreateBackupRequestSchema;
    output: typeof BackupInfoSchema;
  },
  /**
   * @generated from rpc zdc.BackupService.ListBackups
   */
  listBackups: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof BackupListSchema;
  },
  /**
   * @generated from rpc zdc.BackupService.DeleteBackup
   */
  deleteBackup: {
    methodKind: "unary";
    input: typeof DeleteBackupRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.BackupService.DownloadBackup
   */
  downloadBackup: {
    methodKind: "unary";
    input: typeof DownloadBackupRequestSchema;
    output: typeof DownloadBackupResultSchema;
  },
  /**
   * @generated from rpc zdc.BackupService.RestoreBackup
   */
  restoreBackup: {
    methodKind: "unary";
    input: typeof RestoreBackupRequestSchema;
    output: typeof RestoreBackupResultSchema;
  },
  /**
   * @generated from rpc zdc.BackupService.GetBackupSettings
   */
  getBackupSettings: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof BackupSettingsSchema;
  },
  /**
   * @generated from rpc zdc.BackupService.SetBackupSettings
   */
  setBackupSettings: {
    methodKind: "unary";
    input: typeof BackupSettingsSchema;
    output: typeof BackupSettingsSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 3);

/**
 * @generated from service zdc.FileService
 */
export const FileService: GenService<{
  /**
   * @generated from rpc zdc.FileService.ListStorages
   */
  listStorages: {
    methodKind: "unary";
    input: typeof ListStoragesRequestSchema;
    output: typeof StorageListSchema;
  },
  /**
   * @generated from rpc zdc.FileService.CreateStorage
   */
  createStorage: {
    methodKind: "unary";
    input: typeof CreateStorageRequestSchema;
    output: typeof StorageSchema;
  },
  /**
   * @generated from rpc zdc.FileService.UpdateStorage
   */
  updateStorage: {
    methodKind: "unary";
    input: typeof UpdateStorageRequestSchema;
    output: typeof StorageSchema;
  },
  /**
   * @generated from rpc zdc.FileService.DeleteStorage
   */
  deleteStorage: {
    methodKind: "unary";
    input: typeof DeleteStorageRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.FileService.ClearStorage
   */
  clearStorage: {
    methodKind: "unary";
    input: typeof ClearStorageRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.FileService.UploadFile
   */
  uploadFile: {
    methodKind: "unary";
    input: typeof UploadFileRequestSchema;
    output: typeof FileInfoSchema;
  },
  /**
   * @generated from rpc zdc.FileService.DownloadFile
   */
  downloadFile: {
    methodKind: "unary";
    input: typeof DownloadFileRequestSchema;
    output: typeof DownloadFileResponseSchema;
  },
  /**
   * ЧАНКОВАЯ ЗАГРУЗКА (offline-first, большие файлы): клиент режет файл на
   * части (4 МБ), грузит по одной с прогрессом/паузой/возобновлением/отменой.
   * Чанки пишутся в системное tmp-хранилище (parts/{upload_id}/); идемпотентны
   * (повторный чанк с тем же index перезаписывает — докачка с места паузы,
   * переживает перезагрузку сервера). При last-чанке файл собирается и
   * создаётся запись «Файлы» + содержимое в целевом хранилище.
   *
   * @generated from rpc zdc.FileService.StartChunkedUpload
   */
  startChunkedUpload: {
    methodKind: "unary";
    input: typeof StartChunkedUploadRequestSchema;
    output: typeof ChunkedUploadInfoSchema;
  },
  /**
   * @generated from rpc zdc.FileService.UploadChunk
   */
  uploadChunk: {
    methodKind: "unary";
    input: typeof UploadChunkRequestSchema;
    output: typeof ChunkedUploadInfoSchema;
  },
  /**
   * @generated from rpc zdc.FileService.GetChunkedUpload
   */
  getChunkedUpload: {
    methodKind: "unary";
    input: typeof GetChunkedUploadRequestSchema;
    output: typeof ChunkedUploadInfoSchema;
  },
  /**
   * @generated from rpc zdc.FileService.AbortChunkedUpload
   */
  abortChunkedUpload: {
    methodKind: "unary";
    input: typeof AbortChunkedUploadRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.FileService.DeleteFile
   */
  deleteFile: {
    methodKind: "unary";
    input: typeof DeleteFileRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Сведения о файле (карточка/действия): имя, размер, загрузил, дата загрузки (SSoT)
   *
   * @generated from rpc zdc.FileService.GetFileInfo
   */
  getFileInfo: {
    methodKind: "unary";
    input: typeof GetFileInfoRequestSchema;
    output: typeof FileDetailSchema;
  },
  /**
   * МИНИАТЮРА (серверная генерация): превью картинки/видео по id файла.
   * Картинки — встроенный Go-движок (мгновенно); видео — ffmpeg (кадр в момент).
   * Кэш в системном хранилище thumbs; формат — JPEG.
   *
   * @generated from rpc zdc.FileService.GetFileThumb
   */
  getFileThumb: {
    methodKind: "unary";
    input: typeof GetFileThumbRequestSchema;
    output: typeof GetFileThumbResponseSchema;
  },
  /**
   * Список файлов (коллекции: ТЧ «Поле», файлы по документам, страницы) — SSoT батч
   *
   * @generated from rpc zdc.FileService.ListFiles
   */
  listFiles: {
    methodKind: "unary";
    input: typeof ListFilesRequestSchema;
    output: typeof FileDetailListSchema;
  },
  /**
   * Синк файлов (offline-first): список {id, hash, size} — клиент качает
   * только отсутствующие/изменённые (hash-индекс в IndexedDB).
   *
   * @generated from rpc zdc.FileService.ListFileHashes
   */
  listFileHashes: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof FileHashListSchema;
  },
  /**
   * РАЗБОР СОДЕРЖИМОГО файла (SSoT): xlsx → сетки листов, csv/tsv → сетка,
   * docx → текст, txt/md/код → текст. Используется просмотрщиками на клиенте,
   * агентскими инструментами (file_parse) и автоматизациями (parse_file).
   *
   * @generated from rpc zdc.FileService.ParseContent
   */
  parseContent: {
    methodKind: "unary";
    input: typeof ParseContentRequestSchema;
    output: typeof ParseContentResponseSchema;
  },
  /**
   * M4 «Версии файлов»: история, скачивание конкретной версии, восстановление
   *
   * @generated from rpc zdc.FileService.ListFileVersions
   */
  listFileVersions: {
    methodKind: "unary";
    input: typeof ListFileVersionsRequestSchema;
    output: typeof FileVersionsResponseSchema;
  },
  /**
   * @generated from rpc zdc.FileService.DownloadFileVersion
   */
  downloadFileVersion: {
    methodKind: "unary";
    input: typeof DownloadFileVersionRequestSchema;
    output: typeof DownloadFileResponseSchema;
  },
  /**
   * @generated from rpc zdc.FileService.RestoreFileVersion
   */
  restoreFileVersion: {
    methodKind: "unary";
    input: typeof RestoreFileVersionRequestSchema;
    output: typeof FileVersionInfoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 4);

/**
 * @generated from service zdc.PictureService
 */
export const PictureService: GenService<{
  /**
   * @generated from rpc zdc.PictureService.ListPictureLibraries
   */
  listPictureLibraries: {
    methodKind: "unary";
    input: typeof ListPictureLibrariesRequestSchema;
    output: typeof PictureLibraryListSchema;
  },
  /**
   * @generated from rpc zdc.PictureService.GetPictureLibrary
   */
  getPictureLibrary: {
    methodKind: "unary";
    input: typeof GetPictureLibraryRequestSchema;
    output: typeof PictureLibrarySchema;
  },
  /**
   * @generated from rpc zdc.PictureService.SavePictureLibrary
   */
  savePictureLibrary: {
    methodKind: "unary";
    input: typeof SavePictureLibraryRequestSchema;
    output: typeof PictureLibrarySchema;
  },
  /**
   * @generated from rpc zdc.PictureService.DeletePictureLibrary
   */
  deletePictureLibrary: {
    methodKind: "unary";
    input: typeof DeletePictureLibraryRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.PictureService.ListPictures
   */
  listPictures: {
    methodKind: "unary";
    input: typeof ListPicturesRequestSchema;
    output: typeof PictureListSchema;
  },
  /**
   * @generated from rpc zdc.PictureService.GetPicture
   */
  getPicture: {
    methodKind: "unary";
    input: typeof GetPictureRequestSchema;
    output: typeof PictureSchema;
  },
  /**
   * @generated from rpc zdc.PictureService.SavePicture
   */
  savePicture: {
    methodKind: "unary";
    input: typeof SavePictureRequestSchema;
    output: typeof PictureSchema;
  },
  /**
   * @generated from rpc zdc.PictureService.DeletePicture
   */
  deletePicture: {
    methodKind: "unary";
    input: typeof DeletePictureRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 5);

/**
 * Entity (data) management
 *
 * @generated from service zdc.EntityService
 */
export const EntityService: GenService<{
  /**
   * @generated from rpc zdc.EntityService.ListEntities
   */
  listEntities: {
    methodKind: "unary";
    input: typeof ListEntitiesRequestSchema;
    output: typeof EntityListSchema;
  },
  /**
   * @generated from rpc zdc.EntityService.GetEntity
   */
  getEntity: {
    methodKind: "unary";
    input: typeof GetEntityRequestSchema;
    output: typeof EntitySchema;
  },
  /**
   * @generated from rpc zdc.EntityService.CreateEntity
   */
  createEntity: {
    methodKind: "unary";
    input: typeof CreateEntityRequestSchema;
    output: typeof EntitySchema;
  },
  /**
   * @generated from rpc zdc.EntityService.UpdateEntity
   */
  updateEntity: {
    methodKind: "unary";
    input: typeof UpdateEntityRequestSchema;
    output: typeof EntitySchema;
  },
  /**
   * @generated from rpc zdc.EntityService.DeleteEntity
   */
  deleteEntity: {
    methodKind: "unary";
    input: typeof DeleteEntityRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.EntityService.UpdateEntityOneCToken
   */
  updateEntityOneCToken: {
    methodKind: "unary";
    input: typeof UpdateEntityOneCTokenRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Entity Links (entity в†” 1C employee)
   *
   * @generated from rpc zdc.EntityService.ListEntityLinks
   */
  listEntityLinks: {
    methodKind: "unary";
    input: typeof ListEntityLinksRequestSchema;
    output: typeof EntityLinkListSchema;
  },
  /**
   * @generated from rpc zdc.EntityService.CreateEntityLink
   */
  createEntityLink: {
    methodKind: "unary";
    input: typeof CreateEntityLinkRequestSchema;
    output: typeof EntityLinkSchema;
  },
  /**
   * @generated from rpc zdc.EntityService.DeleteEntityLink
   */
  deleteEntityLink: {
    methodKind: "unary";
    input: typeof DeleteEntityLinkRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Entity Roles
   *
   * @generated from rpc zdc.EntityService.ListEntityRoles
   */
  listEntityRoles: {
    methodKind: "unary";
    input: typeof ListEntityRolesRequestSchema;
    output: typeof EntityRoleListSchema;
  },
  /**
   * @generated from rpc zdc.EntityService.SetEntityRole
   */
  setEntityRole: {
    methodKind: "unary";
    input: typeof SetEntityRoleRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.EntityService.DeleteEntityRole
   */
  deleteEntityRole: {
    methodKind: "unary";
    input: typeof DeleteEntityRoleRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Entity Permissions
   *
   * @generated from rpc zdc.EntityService.GetEntityPermissions
   */
  getEntityPermissions: {
    methodKind: "unary";
    input: typeof GetEntityPermissionsRequestSchema;
    output: typeof EntityPermissionListSchema;
  },
  /**
   * @generated from rpc zdc.EntityService.SetEntityPermission
   */
  setEntityPermission: {
    methodKind: "unary";
    input: typeof SetEntityPermissionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.EntityService.DeleteEntityPermission
   */
  deleteEntityPermission: {
    methodKind: "unary";
    input: typeof DeleteEntityPermissionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Entity Filter Assignments
   *
   * @generated from rpc zdc.EntityService.ListEntityFilterAssignments
   */
  listEntityFilterAssignments: {
    methodKind: "unary";
    input: typeof ListEntityFilterAssignmentsRequestSchema;
    output: typeof EntityFilterAssignmentListSchema;
  },
  /**
   * @generated from rpc zdc.EntityService.SetEntityFilterAssignment
   */
  setEntityFilterAssignment: {
    methodKind: "unary";
    input: typeof SetEntityFilterAssignmentRequestSchema;
    output: typeof EntityFilterAssignmentSchema;
  },
  /**
   * @generated from rpc zdc.EntityService.DeleteEntityFilterAssignment
   */
  deleteEntityFilterAssignment: {
    methodKind: "unary";
    input: typeof DeleteEntityFilterAssignmentRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Effective Filters
   *
   * @generated from rpc zdc.EntityService.GetEffectiveFilters
   */
  getEffectiveFilters: {
    methodKind: "unary";
    input: typeof GetEffectiveFiltersRequestSchema;
    output: typeof EffectiveFiltersResponseSchema;
  },
  /**
   * Каналы связи пользователя (entity_channels): telegram/whatsapp/email/...
   * CHANNEL AGNOSTIC: верификация каналов — внешний сервис (провайдер),
   * здесь только код/статус; channel — произвольная строка.
   *
   * @generated from rpc zdc.EntityService.ListEntityChannels
   */
  listEntityChannels: {
    methodKind: "unary";
    input: typeof ListEntityChannelsRequestSchema;
    output: typeof EntityChannelListSchema;
  },
  /**
   * @generated from rpc zdc.EntityService.SetEntityChannels
   */
  setEntityChannels: {
    methodKind: "unary";
    input: typeof SetEntityChannelsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.EntityService.SendVerificationCode
   */
  sendVerificationCode: {
    methodKind: "unary";
    input: typeof SendVerificationCodeRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.EntityService.VerifyChannel
   */
  verifyChannel: {
    methodKind: "unary";
    input: typeof VerifyChannelRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.EntityService.TestChannel
   */
  testChannel: {
    methodKind: "unary";
    input: typeof TestChannelRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.EntityService.ListChannels
   */
  listChannels: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ChannelInfoListSchema;
  },
  /**
   * ПРИГЛАШЕНИЕ ПОЛЬЗОВАТЕЛЯ (клиент сервиса/пациент): одноразовый код первого
   * входа. Доставка — канал пациента (sms при телефоне, иначе email); если
   * доставка невозможна (нет контакта/канал не настроен) — код возвращается
   * вызывающему для передачи вручную. Право: администратор ИЛИ изменение
   * карточки, привязанной к пользователю (реквизит «Пользователь»/user_id).
   *
   * @generated from rpc zdc.EntityService.InviteUser
   */
  inviteUser: {
    methodKind: "unary";
    input: typeof InviteUserRequestSchema;
    output: typeof InviteUserResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 6);

/**
 * Auth
 *
 * @generated from service zdc.AuthService
 */
export const AuthService: GenService<{
  /**
   * @generated from rpc zdc.AuthService.Login
   */
  login: {
    methodKind: "unary";
    input: typeof LoginRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.LoginEntities
   */
  loginEntities: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof LoginEntitiesResponseSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.Register
   */
  register: {
    methodKind: "unary";
    input: typeof RegisterRequestSchema;
    output: typeof RegisterResponseSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.CompleteRegistration
   */
  completeRegistration: {
    methodKind: "unary";
    input: typeof CompleteRegistrationRequestSchema;
    output: typeof CompleteRegistrationResponseSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.GetRegistrationSettings
   */
  getRegistrationSettings: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof RegistrationSettingsSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.AuthService.AdminSwitch
   */
  adminSwitch: {
    methodKind: "unary";
    input: typeof AdminSwitchRequestSchema;
    output: typeof AdminSwitchResponseSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.GetRoles
   */
  getRoles: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof RoleListSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.CreateRole
   */
  createRole: {
    methodKind: "unary";
    input: typeof CreateRoleRequestSchema;
    output: typeof RoleSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.UpdateRole
   */
  updateRole: {
    methodKind: "unary";
    input: typeof UpdateRoleRequestSchema;
    output: typeof RoleSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.DeleteRole
   */
  deleteRole: {
    methodKind: "unary";
    input: typeof DeleteRoleRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Вход по QR-коду (свой токен-ссылка у каждого пользователя; перегенерация
   * отменяет старые ссылки; LoginByQrToken — ПУБЛИЧНЫЙ метод)
   *
   * @generated from rpc zdc.AuthService.GetQrLoginToken
   */
  getQrLoginToken: {
    methodKind: "unary";
    input: typeof GetQrLoginTokenRequestSchema;
    output: typeof GetQrLoginTokenResponseSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.RegenerateQrLoginToken
   */
  regenerateQrLoginToken: {
    methodKind: "unary";
    input: typeof RegenerateQrLoginTokenRequestSchema;
    output: typeof GetQrLoginTokenResponseSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.LoginByQrToken
   */
  loginByQrToken: {
    methodKind: "unary";
    input: typeof LoginByQrTokenRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * ВХОД ПО КОДУ ПРИГЛАШЕНИЯ (клиент сервиса/пациент): одноразовый код из
   * приглашения (ПУБЛИЧНЫЙ, как LoginByQrToken; TTL/попытки/лимит запросов).
   *
   * @generated from rpc zdc.AuthService.LoginByInviteCode
   */
  loginByInviteCode: {
    methodKind: "unary";
    input: typeof LoginByInviteCodeRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * УСТАНОВКА ПЕРВЫХ УЧЁТНЫХ ДАННЫХ (пароль и/или цифровой ключ) — после
   * первого входа по коду приглашения; для обычных пользователей — смена
   * собственных данных в профиле (сессия уже подтверждает владение).
   *
   * @generated from rpc zdc.AuthService.SetLoginCredentials
   */
  setLoginCredentials: {
    methodKind: "unary";
    input: typeof SetLoginCredentialsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * M2 «Внешние логины»: вход по внешней идентичности (Telegram initData и др.)
   *
   * @generated from rpc zdc.AuthService.LoginByIdentity
   */
  loginByIdentity: {
    methodKind: "unary";
    input: typeof LoginByIdentityRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * Привязка внешней идентичности к ТЕКУЩЕМУ пользователю
   *
   * @generated from rpc zdc.AuthService.LinkIdentity
   */
  linkIdentity: {
    methodKind: "unary";
    input: typeof LinkIdentityRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Снятие привязки (своя — любой; чужая — админ)
   *
   * @generated from rpc zdc.AuthService.UnlinkIdentity
   */
  unlinkIdentity: {
    methodKind: "unary";
    input: typeof UnlinkIdentityRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Список привязок (свои — любой; чужие — админ)
   *
   * @generated from rpc zdc.AuthService.ListIdentities
   */
  listIdentities: {
    methodKind: "unary";
    input: typeof ListIdentitiesRequestSchema;
    output: typeof ListIdentitiesResponseSchema;
  },
  /**
   * M2/M3: доступные провайдеры входа базы (публично, для формы входа)
   *
   * @generated from rpc zdc.AuthService.GetLoginProviders
   */
  getLoginProviders: {
    methodKind: "unary";
    input: typeof LoginProvidersRequestSchema;
    output: typeof LoginProvidersResponseSchema;
  },
  /**
   * Предложение установки PWA после входа (настройка базы pwa.offer_enabled)
   *
   * @generated from rpc zdc.AuthService.GetPwaOffer
   */
  getPwaOffer: {
    methodKind: "unary";
    input: typeof GetPwaOfferRequestSchema;
    output: typeof GetPwaOfferResponseSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.SetPwaOffer
   */
  setPwaOffer: {
    methodKind: "unary";
    input: typeof SetPwaOfferRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Роль по умолчанию для новых пользователей (саморегистрация + ручное создание)
   *
   * @generated from rpc zdc.AuthService.GetDefaultRole
   */
  getDefaultRole: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof RoleSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.SetDefaultRole
   */
  setDefaultRole: {
    methodKind: "unary";
    input: typeof SetDefaultRoleRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Активные сессии пользователя (управление, принудительный разлогин)
   *
   * @generated from rpc zdc.AuthService.ListSessions
   */
  listSessions: {
    methodKind: "unary";
    input: typeof ListSessionsRequestSchema;
    output: typeof SessionListSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.ListAllSessions
   */
  listAllSessions: {
    methodKind: "unary";
    input: typeof ListAllSessionsRequestSchema;
    output: typeof SessionListSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.RevokeSession
   */
  revokeSession: {
    methodKind: "unary";
    input: typeof RevokeSessionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.AuthService.RevokeAllSessions
   */
  revokeAllSessions: {
    methodKind: "unary";
    input: typeof RevokeAllSessionsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * ПОДТВЕРЖДЕНИЕ ТЕЛЕФОНА без SMS/звонков (единый механизм кодов/каналов
   * VerifyService): код доставляется в Telegram/MAX (личная привязка), либо
   * заявку подтверждает оператор по одноразовой ссылке. Успех пишет
   * entities.phone_verified_at/via и помечает ТЕКУЩУЮ сессию доверенной.
   *
   * @generated from rpc zdc.AuthService.GetPhoneVerification
   */
  getPhoneVerification: {
    methodKind: "unary";
    input: typeof GetPhoneVerificationRequestSchema;
    output: typeof GetPhoneVerificationResponseSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.RequestPhoneVerification
   */
  requestPhoneVerification: {
    methodKind: "unary";
    input: typeof RequestPhoneVerificationRequestSchema;
    output: typeof RequestPhoneVerificationResponseSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.ConfirmPhoneVerification
   */
  confirmPhoneVerification: {
    methodKind: "unary";
    input: typeof ConfirmPhoneVerificationRequestSchema;
    output: typeof ConfirmPhoneVerificationResponseSchema;
  },
  /**
   * Привязать ПОДПИСАННОЕ подтверждение из центра доверия (attestation_token):
   * сервер проверяет подпись offline и сверяет phone_hash с текущим номером
   * пользователя. Успех пишет entities.phone_verified_at/via и помечает
   * ТЕКУЩУЮ сессию доверенной — как и ConfirmPhoneVerification.
   *
   * @generated from rpc zdc.AuthService.AttachPhoneVerification
   */
  attachPhoneVerification: {
    methodKind: "unary";
    input: typeof AttachPhoneVerificationRequestSchema;
    output: typeof AttachPhoneVerificationResponseSchema;
  },
  /**
   * Смена СВОЕГО номера (только поле phone): меняет номер, сбрасывает его
   * подтверждение и доверие устройств. Профильные поля (аватар и т.п.) НЕ
   * затрагиваются.
   *
   * @generated from rpc zdc.AuthService.SetMyPhone
   */
  setMyPhone: {
    methodKind: "unary";
    input: typeof SetMyPhoneRequestSchema;
    output: typeof SetMyPhoneResponseSchema;
  },
  /**
   * ДОВЕРЕННЫЕ УСТРОЙСТВА (сессии входа): только СВОИ; отзыв — разлогин.
   *
   * @generated from rpc zdc.AuthService.ListMyDevices
   */
  listMyDevices: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof SessionListSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.TrustMyDevice
   */
  trustMyDevice: {
    methodKind: "unary";
    input: typeof TrustMyDeviceRequestSchema;
    output: typeof SessionInfoSchema;
  },
  /**
   * @generated from rpc zdc.AuthService.RevokeMyDevice
   */
  revokeMyDevice: {
    methodKind: "unary";
    input: typeof RevokeMyDeviceRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 7);

/**
 * Event Bus (streaming)
 *
 * @generated from service zdc.EventBusService
 */
export const EventBusService: GenService<{
  /**
   * @generated from rpc zdc.EventBusService.Subscribe
   */
  subscribe: {
    methodKind: "server_streaming";
    input: typeof SubscribeRequestSchema;
    output: typeof EventSchema;
  },
  /**
   * @generated from rpc zdc.EventBusService.Publish
   */
  publish: {
    methodKind: "unary";
    input: typeof PublishRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Метрики шины (in-memory): темы/подписчики с delivered/dropped (топ по
   * дропам; prefix — фильтр тем, напр. app.<code>.). Только админ.
   *
   * @generated from rpc zdc.EventBusService.GetBusStats
   */
  getBusStats: {
    methodKind: "unary";
    input: typeof BusStatsRequestSchema;
    output: typeof BusStatsSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 8);

/**
 * @generated from service zdc.PackageService
 */
export const PackageService: GenService<{
  /**
   * @generated from rpc zdc.PackageService.ApplyPackage
   */
  applyPackage: {
    methodKind: "unary";
    input: typeof ApplyPackageRequestSchema;
    output: typeof ApplyPackageResultSchema;
  },
  /**
   * @generated from rpc zdc.PackageService.ExportPackage
   */
  exportPackage: {
    methodKind: "unary";
    input: typeof ExportPackageRequestSchema;
    output: typeof ConfigExportResultSchema;
  },
  /**
   * @generated from rpc zdc.PackageService.ListInstalled
   */
  listInstalled: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof InstalledPackageListSchema;
  },
  /**
   * @generated from rpc zdc.PackageService.CheckUpdates
   */
  checkUpdates: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof PackageUpdateListSchema;
  },
  /**
   * Применение из репозитория (LocalDir/HTTP index.json) одной кнопкой:
   * скачивание + проверка SHA-256 + min_platform + pkg.Apply.
   *
   * @generated from rpc zdc.PackageService.ApplyFromRepository
   */
  applyFromRepository: {
    methodKind: "unary";
    input: typeof ApplyFromRepositoryRequestSchema;
    output: typeof ApplyPackageResultSchema;
  },
  /**
   * @generated from rpc zdc.PackageService.UninstallPackage
   */
  uninstallPackage: {
    methodKind: "unary";
    input: typeof UninstallPackageRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.PackageService.ReapplyPackage
   */
  reapplyPackage: {
    methodKind: "unary";
    input: typeof ReapplyPackageRequestSchema;
    output: typeof ApplyPackageResultSchema;
  },
  /**
   * МАСТЕР-БАЗА: снять поддержку со всей поставки / обновить поставку из текущей базы
   *
   * @generated from rpc zdc.PackageService.UnprotectPackage
   */
  unprotectPackage: {
    methodKind: "unary";
    input: typeof UnprotectPackageRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.PackageService.RefreshPackage
   */
  refreshPackage: {
    methodKind: "unary";
    input: typeof RefreshPackageRequestSchema;
    output: typeof RefreshPackageResultSchema;
  },
  /**
   * @generated from rpc zdc.PackageService.GetPackageSettings
   */
  getPackageSettings: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof PackageSettingsSchema;
  },
  /**
   * @generated from rpc zdc.PackageService.SetPackageSettings
   */
  setPackageSettings: {
    methodKind: "unary";
    input: typeof PackageSettingsSchema;
    output: typeof PackageSettingsSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 9);

/**
 * ============================================================
 * Section Service
 * ============================================================
 *
 * @generated from service zdc.SectionService
 */
export const SectionService: GenService<{
  /**
   * @generated from rpc zdc.SectionService.ListSections
   */
  listSections: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof SectionListSchema;
  },
  /**
   * @generated from rpc zdc.SectionService.GetSection
   */
  getSection: {
    methodKind: "unary";
    input: typeof GetSectionRequestSchema;
    output: typeof SectionSchema;
  },
  /**
   * @generated from rpc zdc.SectionService.CreateSection
   */
  createSection: {
    methodKind: "unary";
    input: typeof CreateSectionRequestSchema;
    output: typeof SectionSchema;
  },
  /**
   * @generated from rpc zdc.SectionService.UpdateSection
   */
  updateSection: {
    methodKind: "unary";
    input: typeof UpdateSectionRequestSchema;
    output: typeof SectionSchema;
  },
  /**
   * @generated from rpc zdc.SectionService.DeleteSection
   */
  deleteSection: {
    methodKind: "unary";
    input: typeof DeleteSectionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.SectionService.ListSectionObjects
   */
  listSectionObjects: {
    methodKind: "unary";
    input: typeof ListSectionObjectsRequestSchema;
    output: typeof SectionObjectListSchema;
  },
  /**
   * @generated from rpc zdc.SectionService.CreateSectionObject
   */
  createSectionObject: {
    methodKind: "unary";
    input: typeof CreateSectionObjectRequestSchema;
    output: typeof SectionObjectSchema;
  },
  /**
   * @generated from rpc zdc.SectionService.DeleteSectionObject
   */
  deleteSectionObject: {
    methodKind: "unary";
    input: typeof DeleteSectionObjectRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 10);

/**
 * ============================================================
 * Theme Service
 * ============================================================
 *
 * @generated from service zdc.ThemeService
 */
export const ThemeService: GenService<{
  /**
   * @generated from rpc zdc.ThemeService.ListThemes
   */
  listThemes: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ThemeListSchema;
  },
  /**
   * @generated from rpc zdc.ThemeService.GetTheme
   */
  getTheme: {
    methodKind: "unary";
    input: typeof GetThemeRequestSchema;
    output: typeof ThemeSchema;
  },
  /**
   * @generated from rpc zdc.ThemeService.CreateTheme
   */
  createTheme: {
    methodKind: "unary";
    input: typeof CreateThemeRequestSchema;
    output: typeof ThemeSchema;
  },
  /**
   * @generated from rpc zdc.ThemeService.UpdateTheme
   */
  updateTheme: {
    methodKind: "unary";
    input: typeof UpdateThemeRequestSchema;
    output: typeof ThemeSchema;
  },
  /**
   * @generated from rpc zdc.ThemeService.DeleteTheme
   */
  deleteTheme: {
    methodKind: "unary";
    input: typeof DeleteThemeRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.ThemeService.SetDefaultTheme
   */
  setDefaultTheme: {
    methodKind: "unary";
    input: typeof SetDefaultThemeRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 11);

/**
 * ============================================================
 * Role Permission Service
 * ============================================================
 *
 * @generated from service zdc.RolePermissionService
 */
export const RolePermissionService: GenService<{
  /**
   * @generated from rpc zdc.RolePermissionService.ListRolePermissions
   */
  listRolePermissions: {
    methodKind: "unary";
    input: typeof ListRolePermissionsRequestSchema;
    output: typeof RolePermissionListSchema;
  },
  /**
   * @generated from rpc zdc.RolePermissionService.SetRolePermissions
   */
  setRolePermissions: {
    methodKind: "unary";
    input: typeof SetRolePermissionsRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 12);

/**
 * ============================================================
 * DBase Type Service
 * ============================================================
 *
 * @generated from service zdc.DBaseTypeService
 */
export const DBaseTypeService: GenService<{
  /**
   * @generated from rpc zdc.DBaseTypeService.ListDBaseTypes
   */
  listDBaseTypes: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof DBaseTypeListSchema;
  },
  /**
   * @generated from rpc zdc.DBaseTypeService.CreateDBaseType
   */
  createDBaseType: {
    methodKind: "unary";
    input: typeof CreateDBaseTypeRequestSchema;
    output: typeof DBaseTypeSchema;
  },
  /**
   * @generated from rpc zdc.DBaseTypeService.UpdateDBaseType
   */
  updateDBaseType: {
    methodKind: "unary";
    input: typeof UpdateDBaseTypeRequestSchema;
    output: typeof DBaseTypeSchema;
  },
  /**
   * @generated from rpc zdc.DBaseTypeService.DeleteDBaseType
   */
  deleteDBaseType: {
    methodKind: "unary";
    input: typeof DeleteDBaseTypeRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.DBaseTypeService.ListDBaseTypeQueries
   */
  listDBaseTypeQueries: {
    methodKind: "unary";
    input: typeof ListDBaseTypeQueriesRequestSchema;
    output: typeof DBaseTypeQueryListSchema;
  },
  /**
   * @generated from rpc zdc.DBaseTypeService.CreateDBaseTypeQuery
   */
  createDBaseTypeQuery: {
    methodKind: "unary";
    input: typeof CreateDBaseTypeQueryRequestSchema;
    output: typeof DBaseTypeQuerySchema;
  },
  /**
   * @generated from rpc zdc.DBaseTypeService.UpdateDBaseTypeQuery
   */
  updateDBaseTypeQuery: {
    methodKind: "unary";
    input: typeof UpdateDBaseTypeQueryRequestSchema;
    output: typeof DBaseTypeQuerySchema;
  },
  /**
   * @generated from rpc zdc.DBaseTypeService.DeleteDBaseTypeQuery
   */
  deleteDBaseTypeQuery: {
    methodKind: "unary";
    input: typeof DeleteDBaseTypeQueryRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 13);

/**
 * ============================================================
 * Sync Service (Tasks, Peripheral)
 * ============================================================
 *
 * @generated from service zdc.SyncService
 */
export const SyncService: GenService<{
  /**
   * @generated from rpc zdc.SyncService.ListSyncJobs
   */
  listSyncJobs: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof SyncJobListSchema;
  },
  /**
   * @generated from rpc zdc.SyncService.CreateSyncJob
   */
  createSyncJob: {
    methodKind: "unary";
    input: typeof CreateSyncJobRequestSchema;
    output: typeof SyncJobSchema;
  },
  /**
   * @generated from rpc zdc.SyncService.UpdateSyncJob
   */
  updateSyncJob: {
    methodKind: "unary";
    input: typeof UpdateSyncJobRequestSchema;
    output: typeof SyncJobSchema;
  },
  /**
   * @generated from rpc zdc.SyncService.DeleteSyncJob
   */
  deleteSyncJob: {
    methodKind: "unary";
    input: typeof DeleteSyncJobRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.SyncService.RunSyncJob
   */
  runSyncJob: {
    methodKind: "unary";
    input: typeof RunSyncJobRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.SyncService.ListPeripheralTasks
   */
  listPeripheralTasks: {
    methodKind: "unary";
    input: typeof ListPeripheralTasksRequestSchema;
    output: typeof PeripheralTaskListSchema;
  },
  /**
   * @generated from rpc zdc.SyncService.CreatePeripheralTask
   */
  createPeripheralTask: {
    methodKind: "unary";
    input: typeof CreatePeripheralTaskRequestSchema;
    output: typeof PeripheralTaskSchema;
  },
  /**
   * @generated from rpc zdc.SyncService.UpdatePeripheralTask
   */
  updatePeripheralTask: {
    methodKind: "unary";
    input: typeof UpdatePeripheralTaskRequestSchema;
    output: typeof PeripheralTaskSchema;
  },
  /**
   * @generated from rpc zdc.SyncService.DeletePeripheralTask
   */
  deletePeripheralTask: {
    methodKind: "unary";
    input: typeof DeletePeripheralTaskRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.SyncService.ListPeripheralSessions
   */
  listPeripheralSessions: {
    methodKind: "unary";
    input: typeof ListPeripheralSessionsRequestSchema;
    output: typeof PeripheralSessionListSchema;
  },
  /**
   * @generated from rpc zdc.SyncService.ClosePeripheralSession
   */
  closePeripheralSession: {
    methodKind: "unary";
    input: typeof ClosePeripheralSessionRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 14);

/**
 * ============================================================
 * Log Service
 * ============================================================
 *
 * @generated from service zdc.LogService
 */
export const LogService: GenService<{
  /**
   * @generated from rpc zdc.LogService.ListLogs
   */
  listLogs: {
    methodKind: "unary";
    input: typeof ListLogsRequestSchema;
    output: typeof LogListSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 15);

/**
 * ============================================================
 * Config Service
 * ============================================================
 *
 * @generated from service zdc.ConfigService
 */
export const ConfigService: GenService<{
  /**
   * @generated from rpc zdc.ConfigService.GetConfigInfo
   */
  getConfigInfo: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ConfigInfoSchema;
  },
  /**
   * @generated from rpc zdc.ConfigService.SetConfigInfo
   */
  setConfigInfo: {
    methodKind: "unary";
    input: typeof SetConfigInfoRequestSchema;
    output: typeof ConfigInfoSchema;
  },
  /**
   * @generated from rpc zdc.ConfigService.ExportConfig
   */
  exportConfig: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ConfigExportResultSchema;
  },
  /**
   * @generated from rpc zdc.ConfigService.ValidateConfig
   */
  validateConfig: {
    methodKind: "unary";
    input: typeof ValidateConfigRequestSchema;
    output: typeof ValidateConfigResultSchema;
  },
  /**
   * @generated from rpc zdc.ConfigService.ImportConfig
   */
  importConfig: {
    methodKind: "unary";
    input: typeof ImportConfigRequestSchema;
    output: typeof ImportConfigResultSchema;
  },
  /**
   * @generated from rpc zdc.ConfigService.ExportData
   */
  exportData: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ConfigExportResultSchema;
  },
  /**
   * @generated from rpc zdc.ConfigService.ImportData
   */
  importData: {
    methodKind: "unary";
    input: typeof ImportConfigRequestSchema;
    output: typeof ImportConfigResultSchema;
  },
  /**
   * @generated from rpc zdc.ConfigService.SyncS3
   */
  syncS3: {
    methodKind: "unary";
    input: typeof SyncS3RequestSchema;
    output: typeof SyncS3ResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 16);

/**
 * ============================================================
 * Indicator Service
 * ============================================================
 *
 * @generated from service zdc.IndicatorService
 */
export const IndicatorService: GenService<{
  /**
   * @generated from rpc zdc.IndicatorService.ListIndicators
   */
  listIndicators: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof IndicatorListSchema;
  },
  /**
   * @generated from rpc zdc.IndicatorService.CreateIndicator
   */
  createIndicator: {
    methodKind: "unary";
    input: typeof CreateIndicatorRequestSchema;
    output: typeof IndicatorSchema;
  },
  /**
   * @generated from rpc zdc.IndicatorService.UpdateIndicator
   */
  updateIndicator: {
    methodKind: "unary";
    input: typeof UpdateIndicatorRequestSchema;
    output: typeof IndicatorSchema;
  },
  /**
   * @generated from rpc zdc.IndicatorService.DeleteIndicator
   */
  deleteIndicator: {
    methodKind: "unary";
    input: typeof DeleteIndicatorRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.IndicatorService.ListIndicatorRecords
   */
  listIndicatorRecords: {
    methodKind: "unary";
    input: typeof ListIndicatorRecordsRequestSchema;
    output: typeof IndicatorRecordListSchema;
  },
  /**
   * @generated from rpc zdc.IndicatorService.CreateIndicatorRecord
   */
  createIndicatorRecord: {
    methodKind: "unary";
    input: typeof CreateIndicatorRecordRequestSchema;
    output: typeof IndicatorRecordSchema;
  },
  /**
   * @generated from rpc zdc.IndicatorService.DeleteIndicatorRecord
   */
  deleteIndicatorRecord: {
    methodKind: "unary";
    input: typeof DeleteIndicatorRecordRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 17);

/**
 * ============================================================
 * Statement Service — загрузка банковских выписок (PROVIDER-AGNOSTIC):
 * 1C Client-Bank (.txt, CP1251) и CSV → документы «ПоступлениеНаСчет»/
 * «СписаниеССчета» + проведение (движения в «ОстаткиНаСчетах»).
 * Автоподбор: счёт по номеру, контрагент по ИНН (нет — ошибка строки).
 * ============================================================
 *
 * @generated from service zdc.StatementService
 */
export const StatementService: GenService<{
  /**
   * @generated from rpc zdc.StatementService.ImportStatement
   */
  importStatement: {
    methodKind: "unary";
    input: typeof ImportStatementRequestSchema;
    output: typeof ImportStatementResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 18);

/**
 * ============================================================
 * ModuleService — вызов СЕРВЕРНЫХ функций модулей (как 1С: модуль формы
 * на клиенте вызывает экспортную функцию модуля ОБЪЕКТА на сервере).
 * Бизнес-логика живёт в модулях (поставка/пользователь), ядро — только
 * механизм вызова + русское API рантайма (Справочники/Файлы/ПарсерВыписки...).
 * ============================================================
 *
 * @generated from service zdc.ModuleService
 */
export const ModuleService: GenService<{
  /**
   * @generated from rpc zdc.ModuleService.Call
   */
  call: {
    methodKind: "unary";
    input: typeof CallModuleFunctionRequestSchema;
    output: typeof CallModuleFunctionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 19);

/**
 * ============================================================
 * Order Service (ЗАЯВКИ — ВСТРОЕННЫЙ ТИП ЯДРА, как Задачи):
 * системная таблица orders + типы заявок metadata_order_types.
 * Заказчик = всегда контрагент: «Сидоров Иван Иваныч + телефон» →
 * авто создание физ. лица (идемпотентно по телефону) → контрагент → заявка.
 * ResolveCustomer/CreateOrder — ГОСТЕВЫЕ методы (роль «Гость», строгие права).
 * ============================================================
 *
 * @generated from service zdc.OrderService
 */
export const OrderService: GenService<{
  /**
   * @generated from rpc zdc.OrderService.ResolveCustomer
   */
  resolveCustomer: {
    methodKind: "unary";
    input: typeof ResolveCustomerRequestSchema;
    output: typeof ResolveCustomerResponseSchema;
  },
  /**
   * @generated from rpc zdc.OrderService.CreateOrder
   */
  createOrder: {
    methodKind: "unary";
    input: typeof CreateOrderRequestSchema;
    output: typeof CreateOrderResponseSchema;
  },
  /**
   * Типы заявок — объекты метаданных (реестр metadata_order_types)
   *
   * @generated from rpc zdc.OrderService.ListOrderTypes
   */
  listOrderTypes: {
    methodKind: "unary";
    input: typeof ListOrderTypesRequestSchema;
    output: typeof OrderTypeListSchema;
  },
  /**
   * @generated from rpc zdc.OrderService.GetOrderType
   */
  getOrderType: {
    methodKind: "unary";
    input: typeof GetOrderTypeRequestSchema;
    output: typeof OrderTypeSchema;
  },
  /**
   * @generated from rpc zdc.OrderService.CreateOrderType
   */
  createOrderType: {
    methodKind: "unary";
    input: typeof CreateOrderTypeRequestSchema;
    output: typeof OrderTypeSchema;
  },
  /**
   * @generated from rpc zdc.OrderService.UpdateOrderType
   */
  updateOrderType: {
    methodKind: "unary";
    input: typeof UpdateOrderTypeRequestSchema;
    output: typeof OrderTypeSchema;
  },
  /**
   * @generated from rpc zdc.OrderService.DeleteOrderType
   */
  deleteOrderType: {
    methodKind: "unary";
    input: typeof DeleteOrderTypeRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Заявки (как задачи: статусы/фильтры/поиск)
   *
   * @generated from rpc zdc.OrderService.ListOrders
   */
  listOrders: {
    methodKind: "unary";
    input: typeof ListOrdersRequestSchema;
    output: typeof OrderListSchema;
  },
  /**
   * @generated from rpc zdc.OrderService.GetOrder
   */
  getOrder: {
    methodKind: "unary";
    input: typeof GetOrderRequestSchema;
    output: typeof OrderSchema;
  },
  /**
   * @generated from rpc zdc.OrderService.UpdateOrder
   */
  updateOrder: {
    methodKind: "unary";
    input: typeof UpdateOrderRequestSchema;
    output: typeof OrderSchema;
  },
  /**
   * @generated from rpc zdc.OrderService.DeleteOrder
   */
  deleteOrder: {
    methodKind: "unary";
    input: typeof DeleteOrderRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Восстановить помеченную заявку (снятие is_marked; каскадно — её задачи) — создатель/админ.
   *
   * @generated from rpc zdc.OrderService.RestoreOrder
   */
  restoreOrder: {
    methodKind: "unary";
    input: typeof RestoreOrderRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.OrderService.SetOrderStatus
   */
  setOrderStatus: {
    methodKind: "unary";
    input: typeof SetOrderStatusRequestSchema;
    output: typeof OrderSchema;
  },
  /**
   * @generated from rpc zdc.OrderService.GetOrderSettings
   */
  getOrderSettings: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof OrderSettingsSchema;
  },
  /**
   * @generated from rpc zdc.OrderService.SetOrderSettings
   */
  setOrderSettings: {
    methodKind: "unary";
    input: typeof OrderSettingsSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 20);

/**
 * ============================================================
 * DBase Operation Service (ping, sync, pull, migrate)
 * ============================================================
 *
 * @generated from service zdc.DBaseOperationService
 */
export const DBaseOperationService: GenService<{
  /**
   * @generated from rpc zdc.DBaseOperationService.PingDBase
   */
  pingDBase: {
    methodKind: "unary";
    input: typeof PingDBaseRequestSchema;
    output: typeof PingDBaseResponseSchema;
  },
  /**
   * @generated from rpc zdc.DBaseOperationService.MigrateDBase
   */
  migrateDBase: {
    methodKind: "unary";
    input: typeof MigrateDBaseRequestSchema;
    output: typeof MigrateDBaseResponseSchema;
  },
  /**
   * @generated from rpc zdc.DBaseOperationService.SyncRawData
   */
  syncRawData: {
    methodKind: "unary";
    input: typeof SyncRawDataRequestSchema;
    output: typeof SyncRawDataResponseSchema;
  },
  /**
   * @generated from rpc zdc.DBaseOperationService.PullData
   */
  pullData: {
    methodKind: "unary";
    input: typeof PullDataRequestSchema;
    output: typeof PullDataResponseSchema;
  },
  /**
   * @generated from rpc zdc.DBaseOperationService.RotateKey
   */
  rotateKey: {
    methodKind: "unary";
    input: typeof RotateKeyRequestSchema;
    output: typeof RotateKeyResponseSchema;
  },
  /**
   * @generated from rpc zdc.DBaseOperationService.TriggerPoll
   */
  triggerPoll: {
    methodKind: "unary";
    input: typeof TriggerPollRequestSchema;
    output: typeof TriggerPollResponseSchema;
  },
  /**
   * @generated from rpc zdc.DBaseOperationService.ListDBaseEmployees
   */
  listDBaseEmployees: {
    methodKind: "unary";
    input: typeof ListDBaseEmployeesRequestSchema;
    output: typeof DBaseEmployeeListSchema;
  },
  /**
   * @generated from rpc zdc.DBaseOperationService.ExecuteQueries
   */
  executeQueries: {
    methodKind: "unary";
    input: typeof ExecuteQueriesRequestSchema;
    output: typeof ExecuteQueriesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 21);

/**
 * ============================================================
 * Connector Service
 * ============================================================
 *
 * @generated from service zdc.ConnectorService
 */
export const ConnectorService: GenService<{
  /**
   * @generated from rpc zdc.ConnectorService.ListConnectors
   */
  listConnectors: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ConnectorListSchema;
  },
  /**
   * @generated from rpc zdc.ConnectorService.CreateConnector
   */
  createConnector: {
    methodKind: "unary";
    input: typeof CreateConnectorRequestSchema;
    output: typeof ConnectorSchema;
  },
  /**
   * @generated from rpc zdc.ConnectorService.UpdateConnector
   */
  updateConnector: {
    methodKind: "unary";
    input: typeof UpdateConnectorRequestSchema;
    output: typeof ConnectorSchema;
  },
  /**
   * @generated from rpc zdc.ConnectorService.DeleteConnector
   */
  deleteConnector: {
    methodKind: "unary";
    input: typeof DeleteConnectorRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.ConnectorService.ListConnectorObjects
   */
  listConnectorObjects: {
    methodKind: "unary";
    input: typeof ListConnectorObjectsRequestSchema;
    output: typeof ConnectorObjectListSchema;
  },
  /**
   * @generated from rpc zdc.ConnectorService.CreateConnectorObject
   */
  createConnectorObject: {
    methodKind: "unary";
    input: typeof CreateConnectorObjectRequestSchema;
    output: typeof ConnectorObjectSchema;
  },
  /**
   * @generated from rpc zdc.ConnectorService.DeleteConnectorObject
   */
  deleteConnectorObject: {
    methodKind: "unary";
    input: typeof DeleteConnectorObjectRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 22);

/**
 * ============================================================
 * Metric Service
 * ============================================================
 *
 * @generated from service zdc.MetricService
 */
export const MetricService: GenService<{
  /**
   * @generated from rpc zdc.MetricService.ListMetrics
   */
  listMetrics: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof MetricListSchema;
  },
  /**
   * @generated from rpc zdc.MetricService.CreateMetric
   */
  createMetric: {
    methodKind: "unary";
    input: typeof CreateMetricRequestSchema;
    output: typeof MetricSchema;
  },
  /**
   * @generated from rpc zdc.MetricService.UpdateMetric
   */
  updateMetric: {
    methodKind: "unary";
    input: typeof UpdateMetricRequestSchema;
    output: typeof MetricSchema;
  },
  /**
   * @generated from rpc zdc.MetricService.DeleteMetric
   */
  deleteMetric: {
    methodKind: "unary";
    input: typeof DeleteMetricRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 23);

/**
 * ============================================================
 * Event Page Service
 * ============================================================
 *
 * @generated from service zdc.EventPageService
 */
export const EventPageService: GenService<{
  /**
   * @generated from rpc zdc.EventPageService.ListEvents
   */
  listEvents: {
    methodKind: "unary";
    input: typeof ListEventsRequestSchema;
    output: typeof EventPageListSchema;
  },
  /**
   * @generated from rpc zdc.EventPageService.GetEventStats
   */
  getEventStats: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EventStatsSchema;
  },
  /**
   * @generated from rpc zdc.EventPageService.GetDeadLetter
   */
  getDeadLetter: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EventPageListSchema;
  },
  /**
   * @generated from rpc zdc.EventPageService.RetryEvent
   */
  retryEvent: {
    methodKind: "unary";
    input: typeof RetryEventRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.EventPageService.DeleteEventSchema
   */
  deleteEventSchema: {
    methodKind: "unary";
    input: typeof DeleteEventSchemaRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 24);

/**
 * ============================================================
 * Equipment Service (POS)
 * ============================================================
 *
 * @generated from service zdc.EquipmentService
 */
export const EquipmentService: GenService<{
  /**
   * @generated from rpc zdc.EquipmentService.ListEquipment
   */
  listEquipment: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EquipmentListSchema;
  },
  /**
   * @generated from rpc zdc.EquipmentService.CreateEquipment
   */
  createEquipment: {
    methodKind: "unary";
    input: typeof CreateEquipmentRequestSchema;
    output: typeof EquipmentSchema;
  },
  /**
   * @generated from rpc zdc.EquipmentService.UpdateEquipment
   */
  updateEquipment: {
    methodKind: "unary";
    input: typeof UpdateEquipmentRequestSchema;
    output: typeof EquipmentSchema;
  },
  /**
   * @generated from rpc zdc.EquipmentService.DeleteEquipment
   */
  deleteEquipment: {
    methodKind: "unary";
    input: typeof DeleteEquipmentRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.EquipmentService.TestEquipment
   */
  testEquipment: {
    methodKind: "unary";
    input: typeof TestEquipmentRequestSchema;
    output: typeof TestEquipmentResponseSchema;
  },
  /**
   * @generated from rpc zdc.EquipmentService.ListDrivers
   */
  listDrivers: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof DriverListSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 25);

/**
 * ============================================================
 * IoT Service
 * ============================================================
 *
 * @generated from service zdc.IoTService
 */
export const IoTService: GenService<{
  /**
   * @generated from rpc zdc.IoTService.ListDevices
   */
  listDevices: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof IoTDeviceListSchema;
  },
  /**
   * @generated from rpc zdc.IoTService.CreateDevice
   */
  createDevice: {
    methodKind: "unary";
    input: typeof CreateIoTDeviceRequestSchema;
    output: typeof IoTDeviceSchema;
  },
  /**
   * @generated from rpc zdc.IoTService.DeleteDevice
   */
  deleteDevice: {
    methodKind: "unary";
    input: typeof DeleteIoTDeviceRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.IoTService.ListDeviceGroups
   */
  listDeviceGroups: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof IoTDeviceGroupListSchema;
  },
  /**
   * @generated from rpc zdc.IoTService.ListRules
   */
  listRules: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof IoTRuleListSchema;
  },
  /**
   * @generated from rpc zdc.IoTService.CreateRule
   */
  createRule: {
    methodKind: "unary";
    input: typeof CreateIoTRuleRequestSchema;
    output: typeof IoTRuleSchema;
  },
  /**
   * @generated from rpc zdc.IoTService.DeleteRule
   */
  deleteRule: {
    methodKind: "unary";
    input: typeof DeleteIoTRuleRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.IoTService.ReloadRules
   */
  reloadRules: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 26);

/**
 * ============================================================
 * Analytics Service
 * ============================================================
 *
 * @generated from service zdc.AnalyticsService
 */
export const AnalyticsService: GenService<{
  /**
   * @generated from rpc zdc.AnalyticsService.GetKPI
   */
  getKPI: {
    methodKind: "unary";
    input: typeof GetKPIRequestSchema;
    output: typeof KPIResponseSchema;
  },
  /**
   * @generated from rpc zdc.AnalyticsService.RunReport
   */
  runReport: {
    methodKind: "unary";
    input: typeof RunReportRequestSchema;
    output: typeof RunReportResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 27);

/**
 * ============================================================
 * Form Properties Service
 * ============================================================
 *
 * @generated from service zdc.FormPropertiesService
 */
export const FormPropertiesService: GenService<{
  /**
   * @generated from rpc zdc.FormPropertiesService.GetFormProperties
   */
  getFormProperties: {
    methodKind: "unary";
    input: typeof GetFormPropertiesRequestSchema;
    output: typeof FormPropertiesResponseSchema;
  },
  /**
   * @generated from rpc zdc.FormPropertiesService.SetFormProperties
   */
  setFormProperties: {
    methodKind: "unary";
    input: typeof SetFormPropertiesRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.FormPropertiesService.GetFormFields
   */
  getFormFields: {
    methodKind: "unary";
    input: typeof GetFormFieldsRequestSchema;
    output: typeof FormFieldsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 28);

/**
 * @generated from service zdc.LockService
 */
export const LockService: GenService<{
  /**
   * @generated from rpc zdc.LockService.AcquireLock
   */
  acquireLock: {
    methodKind: "unary";
    input: typeof AcquireLockRequestSchema;
    output: typeof AcquireLockResponseSchema;
  },
  /**
   * @generated from rpc zdc.LockService.ReleaseLock
   */
  releaseLock: {
    methodKind: "unary";
    input: typeof ReleaseLockRequestSchema;
    output: typeof ReleaseLockResponseSchema;
  },
  /**
   * @generated from rpc zdc.LockService.ForceReleaseLock
   */
  forceReleaseLock: {
    methodKind: "unary";
    input: typeof ForceReleaseLockRequestSchema;
    output: typeof ForceReleaseLockResponseSchema;
  },
  /**
   * @generated from rpc zdc.LockService.ListLocks
   */
  listLocks: {
    methodKind: "unary";
    input: typeof ListLocksRequestSchema;
    output: typeof ListLocksResponseSchema;
  },
  /**
   * @generated from rpc zdc.LockService.RequestReleaseLock
   */
  requestReleaseLock: {
    methodKind: "unary";
    input: typeof RequestReleaseLockRequestSchema;
    output: typeof RequestReleaseLockResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 29);

/**
 * @generated from service zdc.ReportService
 */
export const ReportService: GenService<{
  /**
   * @generated from rpc zdc.ReportService.ListReports
   */
  listReports: {
    methodKind: "unary";
    input: typeof ListReportsRequestSchema;
    output: typeof ReportListSchema;
  },
  /**
   * @generated from rpc zdc.ReportService.GetReport
   */
  getReport: {
    methodKind: "unary";
    input: typeof GetReportRequestSchema;
    output: typeof ReportSchema;
  },
  /**
   * @generated from rpc zdc.ReportService.CreateReport
   */
  createReport: {
    methodKind: "unary";
    input: typeof CreateReportRequestSchema;
    output: typeof ReportSchema;
  },
  /**
   * @generated from rpc zdc.ReportService.UpdateReport
   */
  updateReport: {
    methodKind: "unary";
    input: typeof UpdateReportRequestSchema;
    output: typeof ReportSchema;
  },
  /**
   * @generated from rpc zdc.ReportService.DeleteReport
   */
  deleteReport: {
    methodKind: "unary";
    input: typeof DeleteReportRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.ReportService.RenderReport
   */
  renderReport: {
    methodKind: "unary";
    input: typeof RenderReportRequestSchema;
    output: typeof RenderReportResponseSchema;
  },
  /**
   * @generated from rpc zdc.ReportService.ExportReport
   */
  exportReport: {
    methodKind: "unary";
    input: typeof ExportReportRequestSchema;
    output: typeof ExportReportResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 30);

/**
 * @generated from service zdc.StatusService
 */
export const StatusService: GenService<{
  /**
   * @generated from rpc zdc.StatusService.ListStatusSchemas
   */
  listStatusSchemas: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof StatusSchemaListSchema;
  },
  /**
   * @generated from rpc zdc.StatusService.GetStatusSchema
   */
  getStatusSchema: {
    methodKind: "unary";
    input: typeof GetStatusSchemaRequestSchema;
    output: typeof StatusSchemaSchema;
  },
  /**
   * @generated from rpc zdc.StatusService.SaveStatusSchema
   */
  saveStatusSchema: {
    methodKind: "unary";
    input: typeof SaveStatusSchemaRequestSchema;
    output: typeof StatusSchemaSchema;
  },
  /**
   * @generated from rpc zdc.StatusService.DeleteStatusSchema
   */
  deleteStatusSchema: {
    methodKind: "unary";
    input: typeof DeleteStatusSchemaRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Переходы, доступные текущему пользователю (по ролям JWT).
   *
   * @generated from rpc zdc.StatusService.GetTransitions
   */
  getTransitions: {
    methodKind: "unary";
    input: typeof GetTransitionsRequestSchema;
    output: typeof GetTransitionsResponseSchema;
  },
  /**
   * @generated from rpc zdc.StatusService.ApplyStatus
   */
  applyStatus: {
    methodKind: "unary";
    input: typeof ApplyStatusRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 31);

/**
 * @generated from service zdc.TaskService
 */
export const TaskService: GenService<{
  /**
   * @generated from rpc zdc.TaskService.ListTasks
   */
  listTasks: {
    methodKind: "unary";
    input: typeof ListTasksRequestSchema;
    output: typeof TaskListSchema;
  },
  /**
   * @generated from rpc zdc.TaskService.GetTask
   */
  getTask: {
    methodKind: "unary";
    input: typeof GetTaskRequestSchema;
    output: typeof TaskSchema;
  },
  /**
   * @generated from rpc zdc.TaskService.CreateTask
   */
  createTask: {
    methodKind: "unary";
    input: typeof CreateTaskRequestSchema;
    output: typeof TaskSchema;
  },
  /**
   * @generated from rpc zdc.TaskService.UpdateTask
   */
  updateTask: {
    methodKind: "unary";
    input: typeof UpdateTaskRequestSchema;
    output: typeof TaskSchema;
  },
  /**
   * @generated from rpc zdc.TaskService.DeleteTask
   */
  deleteTask: {
    methodKind: "unary";
    input: typeof DeleteTaskRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Восстановить помеченную задачу (снятие is_marked) — создатель/админ.
   *
   * @generated from rpc zdc.TaskService.RestoreTask
   */
  restoreTask: {
    methodKind: "unary";
    input: typeof RestoreTaskRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.TaskService.SetTaskStatus
   */
  setTaskStatus: {
    methodKind: "unary";
    input: typeof SetTaskStatusRequestSchema;
    output: typeof TaskSchema;
  },
  /**
   * @generated from rpc zdc.TaskService.TakeTask
   */
  takeTask: {
    methodKind: "unary";
    input: typeof TakeTaskRequestSchema;
    output: typeof TaskSchema;
  },
  /**
   * @generated from rpc zdc.TaskService.ReleaseTask
   */
  releaseTask: {
    methodKind: "unary";
    input: typeof ReleaseTaskRequestSchema;
    output: typeof TaskSchema;
  },
  /**
   * «Передать»: исполнитель заменяется (передача обращения; см. TransferTaskRequest).
   *
   * @generated from rpc zdc.TaskService.TransferTask
   */
  transferTask: {
    methodKind: "unary";
    input: typeof TransferTaskRequestSchema;
    output: typeof TaskSchema;
  },
  /**
   * Типы задач — объекты метаданных (реестр metadata_task_types)
   *
   * @generated from rpc zdc.TaskService.ListTaskTypes
   */
  listTaskTypes: {
    methodKind: "unary";
    input: typeof ListTaskTypesRequestSchema;
    output: typeof TaskTypeListSchema;
  },
  /**
   * @generated from rpc zdc.TaskService.GetTaskType
   */
  getTaskType: {
    methodKind: "unary";
    input: typeof GetTaskTypeRequestSchema;
    output: typeof TaskTypeSchema;
  },
  /**
   * @generated from rpc zdc.TaskService.CreateTaskType
   */
  createTaskType: {
    methodKind: "unary";
    input: typeof CreateTaskTypeRequestSchema;
    output: typeof TaskTypeSchema;
  },
  /**
   * @generated from rpc zdc.TaskService.UpdateTaskType
   */
  updateTaskType: {
    methodKind: "unary";
    input: typeof UpdateTaskTypeRequestSchema;
    output: typeof TaskTypeSchema;
  },
  /**
   * @generated from rpc zdc.TaskService.DeleteTaskType
   */
  deleteTaskType: {
    methodKind: "unary";
    input: typeof DeleteTaskTypeRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * ПОЧТОВЫЙ ЯЩИК УДАЛЁН (легаси): папки — единый реестр FolderService
   * (metadata_folders), счётчики — FolderService.FolderCounts.
   * Подбор исполнителей (диспетчерский кейс «как в такси»): пользователи с
   * ролью «Исполнитель» + их навыки (через сотрудника/физлицо по телефону)
   *
   * @generated from rpc zdc.TaskService.SuggestAssignees
   */
  suggestAssignees: {
    methodKind: "unary";
    input: typeof SuggestAssigneesRequestSchema;
    output: typeof SuggestAssigneesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 32);

/**
 * @generated from service zdc.UiAgentService
 */
export const UiAgentService: GenService<{
  /**
   * @generated from rpc zdc.UiAgentService.Eval
   */
  eval: {
    methodKind: "unary";
    input: typeof UiAgentEvalRequestSchema;
    output: typeof UiAgentEvalResponseSchema;
  },
  /**
   * @generated from rpc zdc.UiAgentService.Snapshot
   */
  snapshot: {
    methodKind: "unary";
    input: typeof UiAgentSnapshotRequestSchema;
    output: typeof UiAgentSnapshotResponseSchema;
  },
  /**
   * @generated from rpc zdc.UiAgentService.Capture
   */
  capture: {
    methodKind: "unary";
    input: typeof UiAgentCaptureRequestSchema;
    output: typeof UiAgentCaptureResponseSchema;
  },
  /**
   * @generated from rpc zdc.UiAgentService.Drag
   */
  drag: {
    methodKind: "unary";
    input: typeof UiAgentDragRequestSchema;
    output: typeof UiAgentDragResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 33);

/**
 * @generated from service zdc.ExternalApiService
 */
export const ExternalApiService: GenService<{
  /**
   * Список типов внешних API (SSoT — сервер). Публичный (для формы настроек).
   *
   * @generated from rpc zdc.ExternalApiService.ListExternalApiTypes
   */
  listExternalApiTypes: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ExternalApiTypeListSchema;
  },
  /**
   * Подключения: CRUD + тест - только админ (конфигуратор).
   *
   * @generated from rpc zdc.ExternalApiService.ListExternalApis
   */
  listExternalApis: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ExternalApiListSchema;
  },
  /**
   * @generated from rpc zdc.ExternalApiService.GetExternalApi
   */
  getExternalApi: {
    methodKind: "unary";
    input: typeof GetExternalApiRequestSchema;
    output: typeof ExternalApiSchema;
  },
  /**
   * @generated from rpc zdc.ExternalApiService.CreateExternalApi
   */
  createExternalApi: {
    methodKind: "unary";
    input: typeof CreateExternalApiRequestSchema;
    output: typeof ExternalApiSchema;
  },
  /**
   * @generated from rpc zdc.ExternalApiService.UpdateExternalApi
   */
  updateExternalApi: {
    methodKind: "unary";
    input: typeof UpdateExternalApiRequestSchema;
    output: typeof ExternalApiSchema;
  },
  /**
   * @generated from rpc zdc.ExternalApiService.DeleteExternalApi
   */
  deleteExternalApi: {
    methodKind: "unary";
    input: typeof DeleteExternalApiRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.ExternalApiService.TestExternalApi
   */
  testExternalApi: {
    methodKind: "unary";
    input: typeof TestExternalApiRequestSchema;
    output: typeof TestExternalApiResultSchema;
  },
  /**
   * @generated from rpc zdc.ExternalApiService.ResetApiUsage
   */
  resetApiUsage: {
    methodKind: "unary";
    input: typeof ResetApiUsageRequestSchema;
    output: typeof ExternalApiSchema;
  },
  /**
   * Геокодирование (авторизованный).
   *
   * @generated from rpc zdc.ExternalApiService.Geocode
   */
  geocode: {
    methodKind: "unary";
    input: typeof GeocodeRequestSchema;
    output: typeof GeocodeResponseSchema;
  },
  /**
   * @generated from rpc zdc.ExternalApiService.ReverseGeocode
   */
  reverseGeocode: {
    methodKind: "unary";
    input: typeof ReverseGeocodeRequestSchema;
    output: typeof ReverseGeocodeResponseSchema;
  },
  /**
   * Подсказки адресов (авторизованный; включённое подключение типа 'dadata').
   *
   * @generated from rpc zdc.ExternalApiService.SuggestAddress
   */
  suggestAddress: {
    methodKind: "unary";
    input: typeof SuggestAddressRequestSchema;
    output: typeof SuggestAddressResponseSchema;
  },
  /**
   * Проверка/нормализация данных (включённое подключение типа 'dadata').
   *
   * @generated from rpc zdc.ExternalApiService.FindParty
   */
  findParty: {
    methodKind: "unary";
    input: typeof FindPartyRequestSchema;
    output: typeof PartyInfoSchema;
  },
  /**
   * @generated from rpc zdc.ExternalApiService.CleanName
   */
  cleanName: {
    methodKind: "unary";
    input: typeof CleanNameRequestSchema;
    output: typeof CleanNameResponseSchema;
  },
  /**
   * @generated from rpc zdc.ExternalApiService.CleanPhone
   */
  cleanPhone: {
    methodKind: "unary";
    input: typeof CleanPhoneRequestSchema;
    output: typeof CleanPhoneResponseSchema;
  },
  /**
   * @generated from rpc zdc.ExternalApiService.CleanPassport
   */
  cleanPassport: {
    methodKind: "unary";
    input: typeof CleanPassportRequestSchema;
    output: typeof CleanPassportResponseSchema;
  },
  /**
   * Адрес из подсказки: upsert иерархии справочников (address_hierarchy) + «Адреса».
   *
   * @generated from rpc zdc.ExternalApiService.ResolveAddressSuggestion
   */
  resolveAddressSuggestion: {
    methodKind: "unary";
    input: typeof ResolveAddressSuggestionRequestSchema;
    output: typeof ResolveAddressSuggestionResponseSchema;
  },
  /**
   * Распознавание речи (STT): транскрибация аудио-файла (id из FileService)
   * в текст (включённое подключение типа 'whisper'). Результат — ТОЛЬКО
   * вызывающему (личная транскрибация, не в сообщение).
   *
   * @generated from rpc zdc.ExternalApiService.TranscribeAudio
   */
  transcribeAudio: {
    methodKind: "unary";
    input: typeof TranscribeAudioRequestSchema;
    output: typeof TranscribeAudioResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 34);

/**
 * @generated from service zdc.GeoService
 */
export const GeoService: GenService<{
  /**
   * Подсказки адресов (кэш справочников → роутер провайдеров; гейт контура внутри).
   *
   * @generated from rpc zdc.GeoService.SuggestAddress
   */
  suggestAddress: {
    methodKind: "unary";
    input: typeof SuggestAddressRequestSchema;
    output: typeof GeoSuggestResponseSchema;
  },
  /**
   * Организация/ИП по ИНН (роутер провайдеров; кэша нет).
   *
   * @generated from rpc zdc.GeoService.FindParty
   */
  findParty: {
    methodKind: "unary";
    input: typeof FindPartyRequestSchema;
    output: typeof GeoPartyResponseSchema;
  },
  /**
   * Прямой геокодинг (адрес → координаты): провайдеры с capability geocode.
   *
   * @generated from rpc zdc.GeoService.Geocode
   */
  geocode: {
    methodKind: "unary";
    input: typeof GeoGeocodeRequestSchema;
    output: typeof GeoGeocodeResponseSchema;
  },
  /**
   * Обратный геокодинг (координаты → адрес): провайдеры с capability reverse.
   *
   * @generated from rpc zdc.GeoService.Reverse
   */
  reverse: {
    methodKind: "unary";
    input: typeof ReverseGeocodeRequestSchema;
    output: typeof GeoReverseResponseSchema;
  },
  /**
   * Выбранная подсказка → write-through в справочники (иерархия + «Адреса»).
   *
   * @generated from rpc zdc.GeoService.Resolve
   */
  resolve: {
    methodKind: "unary";
    input: typeof ResolveAddressSuggestionRequestSchema;
    output: typeof GeoResolveResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 35);

/**
 * Внутренний чат: права — участники чата (member_ids), админ — всё.
 *
 * @generated from service zdc.MessengerService
 */
export const MessengerService: GenService<{
  /**
   * @generated from rpc zdc.MessengerService.ListConversations
   */
  listConversations: {
    methodKind: "unary";
    input: typeof ListConversationsRequestSchema;
    output: typeof ListConversationsResponseSchema;
  },
  /**
   * @generated from rpc zdc.MessengerService.GetConversation
   */
  getConversation: {
    methodKind: "unary";
    input: typeof GetConversationRequestSchema;
    output: typeof GetConversationResponseSchema;
  },
  /**
   * @generated from rpc zdc.MessengerService.CreateConversation
   */
  createConversation: {
    methodKind: "unary";
    input: typeof CreateConversationRequestSchema;
    output: typeof CreateConversationResponseSchema;
  },
  /**
   * @generated from rpc zdc.MessengerService.AddConversationMember
   */
  addConversationMember: {
    methodKind: "unary";
    input: typeof AddConversationMemberRequestSchema;
    output: typeof AddConversationMemberResponseSchema;
  },
  /**
   * Управление группой (§2.3): удаление участника, выход, переименование.
   * Права: создатель чата (created_by) или глобальный администратор; создателя
   * удалить нельзя; последний участник не может выйти. События —
   * chat.conversation.updated.{convId} (участники/название) + уведомления
   * добавленным/удалённым (скрытый чат молчит, беззвучный — без push).
   *
   * @generated from rpc zdc.MessengerService.RemoveConversationMember
   */
  removeConversationMember: {
    methodKind: "unary";
    input: typeof RemoveConversationMemberRequestSchema;
    output: typeof RemoveConversationMemberResponseSchema;
  },
  /**
   * @generated from rpc zdc.MessengerService.LeaveConversation
   */
  leaveConversation: {
    methodKind: "unary";
    input: typeof LeaveConversationRequestSchema;
    output: typeof LeaveConversationResponseSchema;
  },
  /**
   * @generated from rpc zdc.MessengerService.SetConversationTitle
   */
  setConversationTitle: {
    methodKind: "unary";
    input: typeof SetConversationTitleRequestSchema;
    output: typeof SetConversationTitleResponseSchema;
  },
  /**
   * @generated from rpc zdc.MessengerService.SendMessage
   */
  sendMessage: {
    methodKind: "unary";
    input: typeof SendMessageRequestSchema;
    output: typeof SendMessageResponseSchema;
  },
  /**
   * @generated from rpc zdc.MessengerService.ListMessages
   */
  listMessages: {
    methodKind: "unary";
    input: typeof ListMessagesRequestSchema;
    output: typeof ListMessagesResponseSchema;
  },
  /**
   * @generated from rpc zdc.MessengerService.MarkConversationRead
   */
  markConversationRead: {
    methodKind: "unary";
    input: typeof MarkConversationReadRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Пометка удаления сообщений (как 1С — soft-delete, сборка мусора позже):
   * scope='self' — скрыть у себя (любой участник); scope='all' — пометить «у всех»
   * (только админ). Админ видит помеченные (is_deleted в ListMessages).
   *
   * @generated from rpc zdc.MessengerService.DeleteMessage
   */
  deleteMessage: {
    methodKind: "unary";
    input: typeof DeleteMessageRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.MessengerService.ClearConversation
   */
  clearConversation: {
    methodKind: "unary";
    input: typeof ClearConversationRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Реакция на сообщение (toggle моей эмодзи: добавить/убрать)
   *
   * @generated from rpc zdc.MessengerService.ReactToMessage
   */
  reactToMessage: {
    methodKind: "unary";
    input: typeof ReactToMessageRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Переслать сообщение в другой чат (текст + вложения; от текущего пользователя)
   *
   * @generated from rpc zdc.MessengerService.ForwardMessage
   */
  forwardMessage: {
    methodKind: "unary";
    input: typeof ForwardMessageRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Настройки внешних провайдеров (MESSENGER-AGNOSTIC): Get — авторизованный,
   * Set — только админ; Test — авторизованный (отправка себе).
   *
   * @generated from rpc zdc.MessengerService.GetMessengerSettings
   */
  getMessengerSettings: {
    methodKind: "unary";
    input: typeof GetMessengerSettingsRequestSchema;
    output: typeof MessengerSettingsSchema;
  },
  /**
   * @generated from rpc zdc.MessengerService.SetMessengerSettings
   */
  setMessengerSettings: {
    methodKind: "unary";
    input: typeof SetMessengerSettingsRequestSchema;
    output: typeof MessengerSettingsSchema;
  },
  /**
   * @generated from rpc zdc.MessengerService.TestTelegram
   */
  testTelegram: {
    methodKind: "unary";
    input: typeof TestTelegramRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Обои чата per-user per-chat (как в Telegram)
   *
   * @generated from rpc zdc.MessengerService.GetChatWallpaper
   */
  getChatWallpaper: {
    methodKind: "unary";
    input: typeof GetChatWallpaperRequestSchema;
    output: typeof ChatWallpaperSchema;
  },
  /**
   * @generated from rpc zdc.MessengerService.SetChatWallpaper
   */
  setChatWallpaper: {
    methodKind: "unary";
    input: typeof SetChatWallpaperRequestSchema;
    output: typeof ChatWallpaperSchema;
  },
  /**
   * @generated from rpc zdc.MessengerService.DeleteChatWallpaper
   */
  deleteChatWallpaper: {
    methodKind: "unary";
    input: typeof DeleteChatWallpaperRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Универсальные ссылки-приглашения чата (как в Telegram/1С):
   *   CreateConversationInvite  — участник группы создаёт секретную ссылку
   *                               (crypto/rand, base32; TTL/лимит погашений);
   *   ResolveConversationInvite — ПУБЛИЧНЫЙ: мета ссылки (title/kind/нужен ли
   *                               вход) БЕЗ раскрытия id чата;
   *   RedeemConversationInvite  — ПУБЛИЧНЫЙ: погашение ссылки — пользователь
   *                               добавляется в чат, гость получает данные
   *                               гостевого доступа (без записи в entities).
   *
   * @generated from rpc zdc.MessengerService.CreateConversationInvite
   */
  createConversationInvite: {
    methodKind: "unary";
    input: typeof CreateConversationInviteRequestSchema;
    output: typeof CreateConversationInviteResponseSchema;
  },
  /**
   * @generated from rpc zdc.MessengerService.ResolveConversationInvite
   */
  resolveConversationInvite: {
    methodKind: "unary";
    input: typeof ResolveConversationInviteRequestSchema;
    output: typeof ResolveConversationInviteResponseSchema;
  },
  /**
   * @generated from rpc zdc.MessengerService.RedeemConversationInvite
   */
  redeemConversationInvite: {
    methodKind: "unary";
    input: typeof RedeemConversationInviteRequestSchema;
    output: typeof RedeemConversationInviteResponseSchema;
  },
  /**
   * Поиск по сообщениям чатов пользователя (D1): регистронезависимо
   * (ILIKE на PostgreSQL / LIKE на SQLite), только активные сообщения;
   * conversation_id пуст — по всем чатам пользователя.
   *
   * @generated from rpc zdc.MessengerService.SearchMessages
   */
  searchMessages: {
    methodKind: "unary";
    input: typeof SearchMessagesRequestSchema;
    output: typeof SearchMessagesResponseSchema;
  },
  /**
   * Правка своего сообщения (D2): автор или админ; история версий сохраняется.
   *
   * @generated from rpc zdc.MessengerService.EditMessage
   */
  editMessage: {
    methodKind: "unary";
    input: typeof EditMessageRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Тред (D3): корень + прямые ответы (reply_to = корень), старые первыми.
   *
   * @generated from rpc zdc.MessengerService.ListThread
   */
  listThread: {
    methodKind: "unary";
    input: typeof ListThreadRequestSchema;
    output: typeof ListThreadResponseSchema;
  },
  /**
   * Закрепление сообщения (D6): pinned=true — закрепить, false — снять;
   * право — участник чата (админ — всё), идемпотентно. Событие
   * chat.message.pinned.{convId} — лента и панель обновляются точечно.
   *
   * @generated from rpc zdc.MessengerService.PinMessage
   */
  pinMessage: {
    methodKind: "unary";
    input: typeof PinMessageRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Закреплённые сообщения чата (D6, новые первыми): скрытые «у меня»
   * (deleted_for) не показываются; limit по умолчанию 50 (макс. 100).
   *
   * @generated from rpc zdc.MessengerService.ListPinnedMessages
   */
  listPinnedMessages: {
    methodKind: "unary";
    input: typeof ListPinnedMessagesRequestSchema;
    output: typeof ListPinnedMessagesResponseSchema;
  },
  /**
   * КОНВЕРСИЯ СООБЩЕНИЯ ЧАТА В ОБЪЕКТ (§2.3, «козырь» Object-Centric Chat):
   * текст сообщения → тема/описание заявки (kind='order') или задачи
   * (kind='task'); автор сообщения — заказчик заявки / автор задачи; объект
   * создаётся ШТАТНЫМИ механизмами (статусные схемы, нумераторы, модули
   * объекта, события данных, уведомления) — логика не дублируется. Задача
   * привязывается к объекту-контексту объектного обсуждения («Предмет»),
   * заявка — записью регистра «Заявки по документам» (order_links). Событие
   * шины chat.message.converted.{convId} + уведомление автору сообщения.
   *
   * @generated from rpc zdc.MessengerService.ConvertMessage
   */
  convertMessage: {
    methodKind: "unary";
    input: typeof ConvertMessageRequestSchema;
    output: typeof ConvertMessageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 36);

/**
 * @generated from service zdc.PushService
 */
export const PushService: GenService<{
  /**
   * VAPID public key — публичный (нужен до входа для подписки браузера).
   *
   * @generated from rpc zdc.PushService.GetVapidKey
   */
  getVapidKey: {
    methodKind: "unary";
    input: typeof PushGetVapidKeyRequestSchema;
    output: typeof PushVapidKeyResponseSchema;
  },
  /**
   * Пересоздание VAPID-ключей (админ): старые подписки становятся
   * невалидными (очищаются) — пользователи подписываются заново.
   *
   * @generated from rpc zdc.PushService.RotateVapidKey
   */
  rotateVapidKey: {
    methodKind: "unary";
    input: typeof PushGetVapidKeyRequestSchema;
    output: typeof PushVapidKeyResponseSchema;
  },
  /**
   * Подписка/отписка текущего пользователя (авторизованный).
   *
   * @generated from rpc zdc.PushService.Subscribe
   */
  subscribe: {
    methodKind: "unary";
    input: typeof PushSubscribeRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.PushService.Unsubscribe
   */
  unsubscribe: {
    methodKind: "unary";
    input: typeof PushUnsubscribeRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Список подписок — только админ.
   *
   * @generated from rpc zdc.PushService.ListSubscriptions
   */
  listSubscriptions: {
    methodKind: "unary";
    input: typeof PushListSubscriptionsRequestSchema;
    output: typeof PushListSubscriptionsResponseSchema;
  },
  /**
   * Отправка уведомления (админ; программно — из уведомлений платформы).
   *
   * @generated from rpc zdc.PushService.Send
   */
  send: {
    methodKind: "unary";
    input: typeof PushSendRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 37);

/**
 * @generated from service zdc.MediaService
 */
export const MediaService: GenService<{
  /**
   * Настройки медиа (авторизованный): livekit_url (клиент подключается),
   * enabled. URL не задан и embed не работает → enabled=false.
   *
   * @generated from rpc zdc.MediaService.GetMediaSettings
   */
  getMediaSettings: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof MediaSettingsSchema;
  },
  /**
   * Access-токен для комнаты (авторизованный): identity = текущий пользователь.
   *
   * @generated from rpc zdc.MediaService.CreateLiveKitToken
   */
  createLiveKitToken: {
    methodKind: "unary";
    input: typeof CreateLiveKitTokenRequestSchema;
    output: typeof CreateLiveKitTokenResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 38);

/**
 * Геокоординаты (чувствительные данные): универсальный сбор точек для любых
 * субъектов (файлы, пользователи/сотрудники). Включение — настройка базы
 * location.capture_enabled (по умолчанию выключено — сбор отклоняется явной
 * ошибкой). Чтение — настройка location.show_in_ui (по умолчанию выключено)
 * + роли location.view_roles (пусто = только admin).
 *
 * @generated from service zdc.LocationService
 */
export const LocationService: GenService<{
  /**
   * @generated from rpc zdc.LocationService.SaveLocationPoint
   */
  saveLocationPoint: {
    methodKind: "unary";
    input: typeof SaveLocationPointRequestSchema;
    output: typeof SaveLocationPointResponseSchema;
  },
  /**
   * Настройки геопозиции: чтение — авторизованный (UI), запись — админ.
   *
   * @generated from rpc zdc.LocationService.GetLocationSettings
   */
  getLocationSettings: {
    methodKind: "unary";
    input: typeof GetLocationSettingsRequestSchema;
    output: typeof LocationSettingsSchema;
  },
  /**
   * @generated from rpc zdc.LocationService.SetLocationSettings
   */
  setLocationSettings: {
    methodKind: "unary";
    input: typeof SetLocationSettingsRequestSchema;
    output: typeof LocationSettingsSchema;
  },
  /**
   * Список точек (карта/журнал): только при show_in_ui=true и праве
   * (admin или роль из view_roles) — иначе явная ошибка.
   *
   * @generated from rpc zdc.LocationService.ListLocationPoints
   */
  listLocationPoints: {
    methodKind: "unary";
    input: typeof ListLocationPointsRequestSchema;
    output: typeof ListLocationPointsResponseSchema;
  },
  /**
   * Статус отслеживания координат пользователя (эффективный режим по ролям):
   *   GetMyTrackingStatus — свои (профиль/карточка пользователя);
   *   GetUserTracking — админ (карточка пользователя в UsersPage);
   *   SetMyTracking/SetUserTracking — включить/выключить (SetUserTracking — админ;
   *   при unconditional выключить нельзя — сервер отклоняет).
   *
   * @generated from rpc zdc.LocationService.GetMyTrackingStatus
   */
  getMyTrackingStatus: {
    methodKind: "unary";
    input: typeof GetMyTrackingStatusRequestSchema;
    output: typeof TrackingStatusSchema;
  },
  /**
   * @generated from rpc zdc.LocationService.SetMyTracking
   */
  setMyTracking: {
    methodKind: "unary";
    input: typeof SetMyTrackingRequestSchema;
    output: typeof TrackingStatusSchema;
  },
  /**
   * @generated from rpc zdc.LocationService.GetUserTracking
   */
  getUserTracking: {
    methodKind: "unary";
    input: typeof GetUserTrackingRequestSchema;
    output: typeof TrackingStatusSchema;
  },
  /**
   * @generated from rpc zdc.LocationService.SetUserTracking
   */
  setUserTracking: {
    methodKind: "unary";
    input: typeof SetUserTrackingRequestSchema;
    output: typeof TrackingStatusSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 39);

/**
 * --- Сервис ---
 *
 * @generated from service zdc.AiService
 */
export const AiService: GenService<{
  /**
   * Провайдеры
   *
   * @generated from rpc zdc.AiService.ListAiProviderTypes
   */
  listAiProviderTypes: {
    methodKind: "unary";
    input: typeof ListAiProviderTypesRequestSchema;
    output: typeof ListAiProviderTypesResponseSchema;
  },
  /**
   * @generated from rpc zdc.AiService.ListAiProviders
   */
  listAiProviders: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListAiProvidersResponseSchema;
  },
  /**
   * @generated from rpc zdc.AiService.GetAiProvider
   */
  getAiProvider: {
    methodKind: "unary";
    input: typeof GetAiProviderRequestSchema;
    output: typeof AiProviderSchema;
  },
  /**
   * @generated from rpc zdc.AiService.SaveAiProvider
   */
  saveAiProvider: {
    methodKind: "unary";
    input: typeof SaveAiProviderRequestSchema;
    output: typeof AiProviderSchema;
  },
  /**
   * @generated from rpc zdc.AiService.DeleteAiProvider
   */
  deleteAiProvider: {
    methodKind: "unary";
    input: typeof DeleteAiProviderRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.AiService.TestAiProvider
   */
  testAiProvider: {
    methodKind: "unary";
    input: typeof TestAiProviderRequestSchema;
    output: typeof TestAiAgentResponseSchema;
  },
  /**
   * Модели (реестр; List — публичный для окна выбора)
   *
   * @generated from rpc zdc.AiService.ListAiModels
   */
  listAiModels: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListAiModelsResponseSchema;
  },
  /**
   * @generated from rpc zdc.AiService.SaveAiModel
   */
  saveAiModel: {
    methodKind: "unary";
    input: typeof SaveAiModelRequestSchema;
    output: typeof AiModelSchema;
  },
  /**
   * @generated from rpc zdc.AiService.DeleteAiModel
   */
  deleteAiModel: {
    methodKind: "unary";
    input: typeof DeleteAiModelRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Модели У ПРОВАЙДЕРА (GET {base}/models; рабочий — для окна выбора)
   *
   * @generated from rpc zdc.AiService.ListProviderModels
   */
  listProviderModels: {
    methodKind: "unary";
    input: typeof ListProviderModelsRequestSchema;
    output: typeof ListProviderModelsResponseSchema;
  },
  /**
   * Инструменты
   *
   * @generated from rpc zdc.AiService.ListAiTools
   */
  listAiTools: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListAiToolsResponseSchema;
  },
  /**
   * @generated from rpc zdc.AiService.SaveAiTool
   */
  saveAiTool: {
    methodKind: "unary";
    input: typeof SaveAiToolRequestSchema;
    output: typeof AiToolSchema;
  },
  /**
   * @generated from rpc zdc.AiService.DeleteAiTool
   */
  deleteAiTool: {
    methodKind: "unary";
    input: typeof DeleteAiToolRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Тест инструмента (все kinds: builtin/module/wasm; БЕЗ AI-провайдера; админ)
   *
   * @generated from rpc zdc.AiService.TestAiTool
   */
  testAiTool: {
    methodKind: "unary";
    input: typeof TestAiToolRequestSchema;
    output: typeof TestAiToolResponseSchema;
  },
  /**
   * Навыки (переиспользуемые инструкции агентов)
   *
   * @generated from rpc zdc.AiService.ListAiSkills
   */
  listAiSkills: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListAiSkillsResponseSchema;
  },
  /**
   * @generated from rpc zdc.AiService.SaveAiSkill
   */
  saveAiSkill: {
    methodKind: "unary";
    input: typeof SaveAiSkillRequestSchema;
    output: typeof AiSkillSchema;
  },
  /**
   * @generated from rpc zdc.AiService.DeleteAiSkill
   */
  deleteAiSkill: {
    methodKind: "unary";
    input: typeof DeleteAiSkillRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Персональный ассистент: назначения (подмена агента/модели пользователю/роли)
   *
   * @generated from rpc zdc.AiService.ListAssistantAssignments
   */
  listAssistantAssignments: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListAssistantAssignmentsResponseSchema;
  },
  /**
   * @generated from rpc zdc.AiService.SetAssistantAssignment
   */
  setAssistantAssignment: {
    methodKind: "unary";
    input: typeof AssistantAssignmentSchema;
    output: typeof AssistantAssignmentSchema;
  },
  /**
   * @generated from rpc zdc.AiService.DeleteAssistantAssignment
   */
  deleteAssistantAssignment: {
    methodKind: "unary";
    input: typeof DeleteAssistantAssignmentRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * ЛИЧНЫЕ АССИСТЕНТЫ (P0): шаблон — продуктовая обёртка над агентом
   * (промт/модель/allowlist/квоты/политика). CRUD шаблонов — админ базы
   * (конфигуратор). Существующие назначения выше НЕ дублируются.
   *
   * @generated from rpc zdc.AiService.ListAssistantTemplates
   */
  listAssistantTemplates: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListAssistantTemplatesResponseSchema;
  },
  /**
   * @generated from rpc zdc.AiService.GetAssistantTemplate
   */
  getAssistantTemplate: {
    methodKind: "unary";
    input: typeof GetAssistantTemplateRequestSchema;
    output: typeof AiAssistantTemplateSchema;
  },
  /**
   * @generated from rpc zdc.AiService.SaveAssistantTemplate
   */
  saveAssistantTemplate: {
    methodKind: "unary";
    input: typeof SaveAssistantTemplateRequestSchema;
    output: typeof AiAssistantTemplateSchema;
  },
  /**
   * @generated from rpc zdc.AiService.DeleteAssistantTemplate
   */
  deleteAssistantTemplate: {
    methodKind: "unary";
    input: typeof DeleteAssistantTemplateRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Ассистент по умолчанию для НОВЫХ пользователей (политика базы, админ).
   * Выбор default-шаблона не меняет содержимое шаблона (разрешён и для
   * поставочных): это локальная настройка базы, а не правка поставки.
   *
   * @generated from rpc zdc.AiService.GetAssistantDefaults
   */
  getAssistantDefaults: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof AssistantDefaultsSchema;
  },
  /**
   * @generated from rpc zdc.AiService.SetAssistantDefaults
   */
  setAssistantDefaults: {
    methodKind: "unary";
    input: typeof SetAssistantDefaultsRequestSchema;
    output: typeof AssistantDefaultsSchema;
  },
  /**
   * История промта шаблона: неизменяемая (только добавление версий). Доступ —
   * администратор базы ИЛИ владелец шаблона (owner_id). Публикация фиксирует
   * текущие base/guard в новой версии, откат создаёт НОВУЮ версию с содержимым
   * выбранной (старые записи истории не меняются).
   *
   * @generated from rpc zdc.AiService.ListAssistantPromptVersions
   */
  listAssistantPromptVersions: {
    methodKind: "unary";
    input: typeof ListAssistantPromptVersionsRequestSchema;
    output: typeof ListAssistantPromptVersionsResponseSchema;
  },
  /**
   * @generated from rpc zdc.AiService.PublishAssistantPromptVersion
   */
  publishAssistantPromptVersion: {
    methodKind: "unary";
    input: typeof PublishAssistantPromptVersionRequestSchema;
    output: typeof AiAssistantPromptVersionSchema;
  },
  /**
   * @generated from rpc zdc.AiService.RollbackAssistantPromptVersion
   */
  rollbackAssistantPromptVersion: {
    methodKind: "unary";
    input: typeof RollbackAssistantPromptVersionRequestSchema;
    output: typeof AiAssistantTemplateSchema;
  },
  /**
   * Привязка пользователя к шаблону. Админ — любому пользователю; сам
   * пользователь — ТОЛЬКО свои настройки (overrides) в рамках политики шаблона:
   * привязка не расширяет права/квоты и не выбирает произвольный шаблон.
   *
   * @generated from rpc zdc.AiService.ListAssistantBindings
   */
  listAssistantBindings: {
    methodKind: "unary";
    input: typeof ListAssistantBindingsRequestSchema;
    output: typeof ListAssistantBindingsResponseSchema;
  },
  /**
   * @generated from rpc zdc.AiService.SaveAssistantBinding
   */
  saveAssistantBinding: {
    methodKind: "unary";
    input: typeof SaveAssistantBindingRequestSchema;
    output: typeof AiAssistantBindingSchema;
  },
  /**
   * @generated from rpc zdc.AiService.BulkAssignAssistantBindings
   */
  bulkAssignAssistantBindings: {
    methodKind: "unary";
    input: typeof BulkAssignAssistantBindingsRequestSchema;
    output: typeof BulkAssignAssistantBindingsResponseSchema;
  },
  /**
   * @generated from rpc zdc.AiService.DeleteAssistantBinding
   */
  deleteAssistantBinding: {
    methodKind: "unary";
    input: typeof DeleteAssistantBindingRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Мой ассистент: детерминированный резолв binding → assignment → system,
   * эффективные квоты/каналы, расход за сегодня и согласования. Пользователь
   * видит ТОЛЬКО свои данные (user_id берётся из контекста).
   *
   * @generated from rpc zdc.AiService.GetMyAssistant
   */
  getMyAssistant: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof MyAssistantSchema;
  },
  /**
   * Доступность ассистента для закреплённого входа в чат: шаблон/привязка/
   * модель/провайдер + политика «системный агент без шаблона». Ошибки
   * конфигурации возвращаются состоянием (available=false + reason), а не
   * ошибкой RPC — оболочка скрывает чат без «красного» баннера.
   *
   * @generated from rpc zdc.AiService.GetMyAssistantAvailability
   */
  getMyAssistantAvailability: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof MyAssistantAvailabilitySchema;
  },
  /**
   * @generated from rpc zdc.AiService.ListMyAssistantApprovals
   */
  listMyAssistantApprovals: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListMyAssistantApprovalsResponseSchema;
  },
  /**
   * @generated from rpc zdc.AiService.DecideMyAssistantApproval
   */
  decideMyAssistantApproval: {
    methodKind: "unary";
    input: typeof DecideMyAssistantApprovalRequestSchema;
    output: typeof AiAssistantApprovalSchema;
  },
  /**
   * Профиль пользователя для ассистента (свой — любой; чужой/все — админ)
   *
   * @generated from rpc zdc.AiService.GetUserProfile
   */
  getUserProfile: {
    methodKind: "unary";
    input: typeof GetUserProfileRequestSchema;
    output: typeof AiUserProfileSchema;
  },
  /**
   * @generated from rpc zdc.AiService.SaveUserProfile
   */
  saveUserProfile: {
    methodKind: "unary";
    input: typeof SaveUserProfileRequestSchema;
    output: typeof AiUserProfileSchema;
  },
  /**
   * Агенты
   *
   * @generated from rpc zdc.AiService.ListAiAgents
   */
  listAiAgents: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListAiAgentsResponseSchema;
  },
  /**
   * @generated from rpc zdc.AiService.GetAiAgent
   */
  getAiAgent: {
    methodKind: "unary";
    input: typeof GetAiAgentRequestSchema;
    output: typeof AiAgentSchema;
  },
  /**
   * @generated from rpc zdc.AiService.SaveAiAgent
   */
  saveAiAgent: {
    methodKind: "unary";
    input: typeof SaveAiAgentRequestSchema;
    output: typeof AiAgentSchema;
  },
  /**
   * @generated from rpc zdc.AiService.DeleteAiAgent
   */
  deleteAiAgent: {
    methodKind: "unary";
    input: typeof DeleteAiAgentRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.AiService.TestAiAgent
   */
  testAiAgent: {
    methodKind: "unary";
    input: typeof TestAiAgentRequestSchema;
    output: typeof TestAiAgentResponseSchema;
  },
  /**
   * Вызов агента (авторизованный; проверка прав агента)
   *
   * @generated from rpc zdc.AiService.AskAgent
   */
  askAgent: {
    methodKind: "unary";
    input: typeof AskAgentRequestSchema;
    output: typeof AskAgentResponseSchema;
  },
  /**
   * ПОТОКОВЫЙ вызов агента (server-streaming; токены на лету + события
   * инструментов; ошибки — трейлером/return, чанки чистые данные)
   *
   * @generated from rpc zdc.AiService.AskAgentStream
   */
  askAgentStream: {
    methodKind: "server_streaming";
    input: typeof AskAgentRequestSchema;
    output: typeof AskAgentChunkSchema;
  },
  /**
   * Память
   *
   * @generated from rpc zdc.AiService.ListAiMemory
   */
  listAiMemory: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListAiMemoryResponseSchema;
  },
  /**
   * @generated from rpc zdc.AiService.SaveAiMemoryNode
   */
  saveAiMemoryNode: {
    methodKind: "unary";
    input: typeof SaveAiMemoryNodeRequestSchema;
    output: typeof AiMemoryNodeSchema;
  },
  /**
   * @generated from rpc zdc.AiService.DeleteAiMemory
   */
  deleteAiMemory: {
    methodKind: "unary";
    input: typeof DeleteAiMemoryRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Адаптеры
   *
   * @generated from rpc zdc.AiService.ListAiAdapterTypes
   */
  listAiAdapterTypes: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListAiAdapterTypesResponseSchema;
  },
  /**
   * @generated from rpc zdc.AiService.ListAiAdapters
   */
  listAiAdapters: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListAiAdaptersResponseSchema;
  },
  /**
   * @generated from rpc zdc.AiService.SaveAiAdapter
   */
  saveAiAdapter: {
    methodKind: "unary";
    input: typeof SaveAiAdapterRequestSchema;
    output: typeof AiAdapterSchema;
  },
  /**
   * @generated from rpc zdc.AiService.DeleteAiAdapter
   */
  deleteAiAdapter: {
    methodKind: "unary";
    input: typeof DeleteAiAdapterRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.AiService.TestAiAdapter
   */
  testAiAdapter: {
    methodKind: "unary";
    input: typeof TestAiAdapterRequestSchema;
    output: typeof TestAiAgentResponseSchema;
  },
  /**
   * Боты/личности
   *
   * @generated from rpc zdc.AiService.ListAiBots
   */
  listAiBots: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListAiBotsResponseSchema;
  },
  /**
   * @generated from rpc zdc.AiService.SaveAiBot
   */
  saveAiBot: {
    methodKind: "unary";
    input: typeof SaveAiBotRequestSchema;
    output: typeof AiBotSchema;
  },
  /**
   * @generated from rpc zdc.AiService.DeleteAiBot
   */
  deleteAiBot: {
    methodKind: "unary";
    input: typeof DeleteAiBotRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Привязки бота к транспортам (волна 1a «Боты»): internal | адаптер
   * (telegram_bot и другие типы с bot-приёмом); конфигуратор.
   *
   * @generated from rpc zdc.AiService.ListBotTransports
   */
  listBotTransports: {
    methodKind: "unary";
    input: typeof ListBotTransportsRequestSchema;
    output: typeof ListBotTransportsResponseSchema;
  },
  /**
   * @generated from rpc zdc.AiService.SaveBotTransport
   */
  saveBotTransport: {
    methodKind: "unary";
    input: typeof SaveBotTransportRequestSchema;
    output: typeof BotTransportSchema;
  },
  /**
   * @generated from rpc zdc.AiService.DeleteBotTransport
   */
  deleteBotTransport: {
    methodKind: "unary";
    input: typeof DeleteBotTransportRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Передачи диалога человеку (волна 1c §4.6): рабочие методы Предприятия
   * (оператор/роль-очередь; НЕ конфигуратор — работают в публикации).
   *
   * @generated from rpc zdc.AiService.ListBotHandoffs
   */
  listBotHandoffs: {
    methodKind: "unary";
    input: typeof ListBotHandoffsRequestSchema;
    output: typeof ListBotHandoffsResponseSchema;
  },
  /**
   * @generated from rpc zdc.AiService.RequestBotHandoff
   */
  requestBotHandoff: {
    methodKind: "unary";
    input: typeof RequestBotHandoffRequestSchema;
    output: typeof BotHandoffSchema;
  },
  /**
   * @generated from rpc zdc.AiService.TakeBotHandoff
   */
  takeBotHandoff: {
    methodKind: "unary";
    input: typeof TakeBotHandoffRequestSchema;
    output: typeof BotHandoffSchema;
  },
  /**
   * @generated from rpc zdc.AiService.ReturnBotHandoff
   */
  returnBotHandoff: {
    methodKind: "unary";
    input: typeof ReturnBotHandoffRequestSchema;
    output: typeof BotHandoffSchema;
  },
  /**
   * Аналитика бота (волна 1c §4.9): агрегаты из данных приёма/доставки/передач;
   * админ (конфигуратор).
   *
   * @generated from rpc zdc.AiService.GetBotAnalytics
   */
  getBotAnalytics: {
    methodKind: "unary";
    input: typeof GetBotAnalyticsRequestSchema;
    output: typeof GetBotAnalyticsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 40);

/**
 * ============================================================================
 * PageService — Рабочие столы + Движок страниц (2026-08-20)
 * Страница (Page) — контейнер с макетом (layout JSON: ряды/колонки/виджеты).
 * Рабочий стол (kind='worktable') — частный случай страницы, назначается
 * ролям/пользователям (page_roles). Публичные страницы (kind='site'/'public')
 * доступны по /p/{slug} без авторизации (GetPublicPage). SSoT — сервер.
 * ============================================================================
 *
 * @generated from service zdc.PageService
 */
export const PageService: GenService<{
  /**
   * CRUD страниц (конфигуратор, admin)
   *
   * @generated from rpc zdc.PageService.ListPages
   */
  listPages: {
    methodKind: "unary";
    input: typeof ListPagesRequestSchema;
    output: typeof PageListSchema;
  },
  /**
   * по id или code
   *
   * @generated from rpc zdc.PageService.GetPage
   */
  getPage: {
    methodKind: "unary";
    input: typeof GetPageRequestSchema;
    output: typeof PageSchema;
  },
  /**
   * @generated from rpc zdc.PageService.CreatePage
   */
  createPage: {
    methodKind: "unary";
    input: typeof CreatePageRequestSchema;
    output: typeof PageSchema;
  },
  /**
   * layout/name/synonym/kind
   *
   * @generated from rpc zdc.PageService.UpdatePage
   */
  updatePage: {
    methodKind: "unary";
    input: typeof UpdatePageRequestSchema;
    output: typeof PageSchema;
  },
  /**
   * поставочные — 412
   *
   * @generated from rpc zdc.PageService.DeletePage
   */
  deletePage: {
    methodKind: "unary";
    input: typeof DeletePageRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Назначения страницы ролям/пользователям (полная замена)
   *
   * @generated from rpc zdc.PageService.ListPageRoles
   */
  listPageRoles: {
    methodKind: "unary";
    input: typeof ListPageRolesRequestSchema;
    output: typeof PageRoleListSchema;
  },
  /**
   * @generated from rpc zdc.PageService.SetPageRoles
   */
  setPageRoles: {
    methodKind: "unary";
    input: typeof SetPageRolesRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Рабочий стол ТЕКУЩЕГО пользователя (резолв: пользователь → роли → глобально)
   *
   * @generated from rpc zdc.PageService.GetMyWorktable
   */
  getMyWorktable: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof WorktableResponseSchema;
  },
  /**
   * Workspace ТЕКУЩЕГО пользователя (rezolv: пользователь → роли → default workspace)
   *
   * @generated from rpc zdc.PageService.GetMyWorkspace
   */
  getMyWorkspace: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof PageSchema;
  },
  /**
   * Доступные воркспейсы пользователя + основной (пользователь → роль →
   * config.default_workspace → «Предприятие»). Воркспейс = контейнер ПРИЛОЖЕНИЙ
   * (Page.apps — коды kind='app'); чат — приложение, по умолчанию на весь воркспейс.
   *
   * @generated from rpc zdc.PageService.ListMyWorkspaces
   */
  listMyWorkspaces: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof WorkspaceListSchema;
  },
  /**
   * Вызвать БЭКЕНД приложения (kind='app' backend_url; свой сервис Go/Python/Rust).
   * Ядро проксирует на backend_url с JWT/RBAC-контекстом текущего пользователя
   * (заголовки X-Hydra-*). backend_url задаёт АДМИН в конфигураторе (без SSRF:
   * только http/https endpoint метаданных приложения). method — путь сервиса
   * (напр. '/api/chess/move'), body — JSON произвольный.
   *
   * @generated from rpc zdc.PageService.CallAppBackend
   */
  callAppBackend: {
    methodKind: "unary";
    input: typeof AppCallBackendRequestSchema;
    output: typeof AppCallBackendResponseSchema;
  },
  /**
   * Публичные страницы (без JWT): /p/{slug}
   *
   * @generated from rpc zdc.PageService.GetPublicPage
   */
  getPublicPage: {
    methodKind: "unary";
    input: typeof GetPublicPageRequestSchema;
    output: typeof PageSchema;
  },
  /**
   * Манифест ПРИЛОЖЕНИЯ (kind='app') для РАБОЧЕГО клиента (не конфигуратор):
   * любой авторизованный пользователь базы может открыть приложение
   * (AppPage/AppInline); отдаётся только kind='app'.
   *
   * @generated from rpc zdc.PageService.GetAppManifest
   */
  getAppManifest: {
    methodKind: "unary";
    input: typeof GetAppManifestRequestSchema;
    output: typeof PageSchema;
  },
  /**
   * «Скопировать рабочий стол» (копия страницы + её назначений)
   *
   * @generated from rpc zdc.PageService.CopyPage
   */
  copyPage: {
    methodKind: "unary";
    input: typeof CopyPageRequestSchema;
    output: typeof PageSchema;
  },
  /**
   * «Снять с поддержки» (как UnprotectTemplateObject)
   *
   * @generated from rpc zdc.PageService.UnprotectPage
   */
  unprotectPage: {
    methodKind: "unary";
    input: typeof UnprotectPageRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 41);

/**
 * ============================================================================
 * AppService — СЕРВИС-ПРИЛОЖЕНИЯ (под-этап A): конфиг сервиса приложения
 * (pages.backend_settings), запуск/остановка managed-процесса, health/логи/
 * статистика, секреты (AES-256-GCM) и сервисный токен (kind='service').
 * Save/Start/Stop/Generate/List*\/Save* — конфигуратор (guard.go);
 * GetAppSecrets — сервисный токен ЭТОГО приложения ИЛИ админ; значения
 * секретов НИКОГДА не логируются.
 * ============================================================================
 *
 * @generated from service zdc.AppService
 */
export const AppService: GenService<{
  /**
   * Список сервисов-приложений: конфиг (backend_settings) + runtime статус.
   *
   * @generated from rpc zdc.AppService.ListAppServices
   */
  listAppServices: {
    methodKind: "unary";
    input: typeof ListAppServicesRequestSchema;
    output: typeof AppServiceListSchema;
  },
  /**
   * Сохранить конфиг сервиса (валидация A1; backend_url — легаси/external).
   *
   * @generated from rpc zdc.AppService.SaveAppService
   */
  saveAppService: {
    methodKind: "unary";
    input: typeof SaveAppServiceRequestSchema;
    output: typeof AppServiceItemSchema;
  },
  /**
   * Запуск/остановка сервиса (managed — процесс; external — health-probe).
   *
   * @generated from rpc zdc.AppService.StartAppService
   */
  startAppService: {
    methodKind: "unary";
    input: typeof AppServiceRefSchema;
    output: typeof AppServiceItemSchema;
  },
  /**
   * @generated from rpc zdc.AppService.StopAppService
   */
  stopAppService: {
    methodKind: "unary";
    input: typeof AppServiceRefSchema;
    output: typeof AppServiceItemSchema;
  },
  /**
   * Логи сервиса (ring buffer, последние N строк).
   *
   * @generated from rpc zdc.AppService.ListAppServiceLogs
   */
  listAppServiceLogs: {
    methodKind: "unary";
    input: typeof ListAppServiceLogsRequestSchema;
    output: typeof AppServiceLogsResponseSchema;
  },
  /**
   * Статистика прокси (calls/errors/total_ms/last_error).
   *
   * @generated from rpc zdc.AppService.GetAppServiceStats
   */
  getAppServiceStats: {
    methodKind: "unary";
    input: typeof AppServiceRefSchema;
    output: typeof AppServiceStatsSchema;
  },
  /**
   * Сервисный токен: plaintext возвращается ОДИН раз; регенерация (epoch+1)
   * мгновенно инвалидирует ранее выданные токены.
   *
   * @generated from rpc zdc.AppService.GenerateAppServiceToken
   */
  generateAppServiceToken: {
    methodKind: "unary";
    input: typeof AppServiceRefSchema;
    output: typeof AppServiceTokenResponseSchema;
  },
  /**
   * Секреты: список КЛЮЧЕЙ (без значений), сохранение/удаление (пусто = удалить).
   *
   * @generated from rpc zdc.AppService.ListAppSecrets
   */
  listAppSecrets: {
    methodKind: "unary";
    input: typeof AppServiceRefSchema;
    output: typeof AppSecretsListSchema;
  },
  /**
   * @generated from rpc zdc.AppService.SaveAppSecret
   */
  saveAppSecret: {
    methodKind: "unary";
    input: typeof SaveAppSecretRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Значения секретов — сервисному токену этого app ИЛИ админу.
   *
   * @generated from rpc zdc.AppService.GetAppSecrets
   */
  getAppSecrets: {
    methodKind: "unary";
    input: typeof AppServiceRefSchema;
    output: typeof AppSecretsValuesSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 42);

/**
 * Таск-менеджер ядра: очередь фоновых заданий (sdk.jobs / async-агенты/приложения).
 *
 * @generated from service zdc.JobsService
 */
export const JobsService: GenService<{
  /**
   * Список заданий (фильтры status/app_code) — авторизованный (свои + админ все)
   *
   * @generated from rpc zdc.JobsService.ListJobs
   */
  listJobs: {
    methodKind: "unary";
    input: typeof JobsListRequestSchema;
    output: typeof JobsListResponseSchema;
  },
  /**
   * Статус задания
   *
   * @generated from rpc zdc.JobsService.GetJob
   */
  getJob: {
    methodKind: "unary";
    input: typeof JobsGetRequestSchema;
    output: typeof BackgroundJobSchema;
  },
  /**
   * Поставить задание в очередь (обработчик kind на сервере/бэкенде приложения)
   *
   * @generated from rpc zdc.JobsService.EnqueueJob
   */
  enqueueJob: {
    methodKind: "unary";
    input: typeof JobsEnqueueRequestSchema;
    output: typeof BackgroundJobSchema;
  },
  /**
   * Отменить задание (кооперативно)
   *
   * @generated from rpc zdc.JobsService.CancelJob
   */
  cancelJob: {
    methodKind: "unary";
    input: typeof JobsCancelRequestSchema;
    output: typeof BackgroundJobSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 43);

/**
 * @generated from service zdc.VerifyService
 */
export const VerifyService: GenService<{
  /**
   * Создать и доставить код по каналу (TTL/лимиты — политика сервиса)
   *
   * @generated from rpc zdc.VerifyService.SendVerification
   */
  sendVerification: {
    methodKind: "unary";
    input: typeof SendVerificationRequestSchema;
    output: typeof SendVerificationResponseSchema;
  },
  /**
   * Проверить код (однократно; число попыток ограничено)
   *
   * @generated from rpc zdc.VerifyService.VerifyCode
   */
  verifyCode: {
    methodKind: "unary";
    input: typeof VerifyCodeRequestSchema;
    output: typeof VerifyCodeResponseSchema;
  },
  /**
   * Запросить решение (approve/reject/confirm): запись + доставка в канал
   *
   * @generated from rpc zdc.VerifyService.SendActionMessage
   */
  sendActionMessage: {
    methodKind: "unary";
    input: typeof SendActionMessageRequestSchema;
    output: typeof SendActionMessageResponseSchema;
  },
  /**
   * Принять решение по токену (однократно)
   *
   * @generated from rpc zdc.VerifyService.ActConfirmation
   */
  actConfirmation: {
    methodKind: "unary";
    input: typeof ActConfirmationRequestSchema;
    output: typeof ActConfirmationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 44);

/**
 * @generated from service zdc.CalendarService
 */
export const CalendarService: GenService<{
  /**
   * События календаря + источники (сроки задач) в диапазоне дат
   *
   * @generated from rpc zdc.CalendarService.ListCalendar
   */
  listCalendar: {
    methodKind: "unary";
    input: typeof ListCalendarRequestSchema;
    output: typeof ListCalendarResponseSchema;
  },
  /**
   * @generated from rpc zdc.CalendarService.SaveCalendarEvent
   */
  saveCalendarEvent: {
    methodKind: "unary";
    input: typeof SaveCalendarEventRequestSchema;
    output: typeof CalendarEventInfoSchema;
  },
  /**
   * @generated from rpc zdc.CalendarService.DeleteCalendarEvent
   */
  deleteCalendarEvent: {
    methodKind: "unary";
    input: typeof DeleteCalendarEventRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 45);

/**
 * @generated from service zdc.TagService
 */
export const TagService: GenService<{
  /**
   * Теги «что угодно»: дерево + полиморфные связи (рабочие методы)
   *
   * @generated from rpc zdc.TagService.ListTags
   */
  listTags: {
    methodKind: "unary";
    input: typeof ListTagsRequestSchema;
    output: typeof ListTagsResponseSchema;
  },
  /**
   * @generated from rpc zdc.TagService.SaveTag
   */
  saveTag: {
    methodKind: "unary";
    input: typeof SaveTagRequestSchema;
    output: typeof SaveTagResponseSchema;
  },
  /**
   * @generated from rpc zdc.TagService.DeleteTag
   */
  deleteTag: {
    methodKind: "unary";
    input: typeof DeleteTagRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.TagService.SetSubjectTags
   */
  setSubjectTags: {
    methodKind: "unary";
    input: typeof SetSubjectTagsRequestSchema;
    output: typeof SetSubjectTagsResponseSchema;
  },
  /**
   * @generated from rpc zdc.TagService.ListSubjectTags
   */
  listSubjectTags: {
    methodKind: "unary";
    input: typeof ListSubjectTagsRequestSchema;
    output: typeof ListSubjectTagsResponseSchema;
  },
  /**
   * @generated from rpc zdc.TagService.ListSubjectsByTag
   */
  listSubjectsByTag: {
    methodKind: "unary";
    input: typeof ListSubjectsByTagRequestSchema;
    output: typeof ListSubjectsByTagResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 46);

/**
 * @generated from service zdc.ApprovalService
 */
export const ApprovalService: GenService<{
  /**
   * @generated from rpc zdc.ApprovalService.ListRouteTemplates
   */
  listRouteTemplates: {
    methodKind: "unary";
    input: typeof ListRouteTemplatesRequestSchema;
    output: typeof RouteTemplatesResponseSchema;
  },
  /**
   * @generated from rpc zdc.ApprovalService.SaveRouteTemplate
   */
  saveRouteTemplate: {
    methodKind: "unary";
    input: typeof SaveRouteTemplateRequestSchema;
    output: typeof RouteTemplateInfoSchema;
  },
  /**
   * @generated from rpc zdc.ApprovalService.DeleteRouteTemplate
   */
  deleteRouteTemplate: {
    methodKind: "unary";
    input: typeof DeleteRouteTemplateRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.ApprovalService.StartRoute
   */
  startRoute: {
    methodKind: "unary";
    input: typeof StartRouteRequestSchema;
    output: typeof RouteInstanceInfoSchema;
  },
  /**
   * @generated from rpc zdc.ApprovalService.GetRouteInstance
   */
  getRouteInstance: {
    methodKind: "unary";
    input: typeof GetRouteInstanceRequestSchema;
    output: typeof RouteInstanceInfoSchema;
  },
  /**
   * @generated from rpc zdc.ApprovalService.ListRouteInstances
   */
  listRouteInstances: {
    methodKind: "unary";
    input: typeof ListRouteInstancesRequestSchema;
    output: typeof RouteInstancesResponseSchema;
  },
  /**
   * @generated from rpc zdc.ApprovalService.ActRouteStep
   */
  actRouteStep: {
    methodKind: "unary";
    input: typeof ActRouteStepRequestSchema;
    output: typeof RouteInstanceInfoSchema;
  },
  /**
   * @generated from rpc zdc.ApprovalService.CancelRoute
   */
  cancelRoute: {
    methodKind: "unary";
    input: typeof CancelRouteRequestSchema;
    output: typeof RouteInstanceInfoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 47);

/**
 * @generated from service zdc.SignatureService
 */
export const SignatureService: GenService<{
  /**
   * @generated from rpc zdc.SignatureService.AttachSignature
   */
  attachSignature: {
    methodKind: "unary";
    input: typeof AttachSignatureRequestSchema;
    output: typeof SignatureInfoSchema;
  },
  /**
   * @generated from rpc zdc.SignatureService.ListSignatures
   */
  listSignatures: {
    methodKind: "unary";
    input: typeof ListSignaturesRequestSchema;
    output: typeof SignaturesResponseSchema;
  },
  /**
   * @generated from rpc zdc.SignatureService.GetSignature
   */
  getSignature: {
    methodKind: "unary";
    input: typeof GetSignatureRequestSchema;
    output: typeof SignatureInfoSchema;
  },
  /**
   * @generated from rpc zdc.SignatureService.SetSignatureStatus
   */
  setSignatureStatus: {
    methodKind: "unary";
    input: typeof SetSignatureStatusRequestSchema;
    output: typeof SignatureInfoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 48);

/**
 * @generated from service zdc.VpnService
 */
export const VpnService: GenService<{
  /**
   * @generated from rpc zdc.VpnService.ListVpnProfiles
   */
  listVpnProfiles: {
    methodKind: "unary";
    input: typeof ListVpnProfilesRequestSchema;
    output: typeof VpnProfilesResponseSchema;
  },
  /**
   * @generated from rpc zdc.VpnService.SaveVpnProfile
   */
  saveVpnProfile: {
    methodKind: "unary";
    input: typeof SaveVpnProfileRequestSchema;
    output: typeof VpnProfileInfoSchema;
  },
  /**
   * @generated from rpc zdc.VpnService.DeleteVpnProfile
   */
  deleteVpnProfile: {
    methodKind: "unary";
    input: typeof DeleteVpnProfileRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.VpnService.GetVpnAccess
   */
  getVpnAccess: {
    methodKind: "unary";
    input: typeof GetVpnAccessRequestSchema;
    output: typeof VpnAccessResponseSchema;
  },
  /**
   * @generated from rpc zdc.VpnService.SetVpnAccess
   */
  setVpnAccess: {
    methodKind: "unary";
    input: typeof SetVpnAccessRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.VpnService.GetVpnConfig
   */
  getVpnConfig: {
    methodKind: "unary";
    input: typeof VpnConfigRequestSchema;
    output: typeof VpnConfigResponseSchema;
  },
  /**
   * @generated from rpc zdc.VpnService.ListVpnSessions
   */
  listVpnSessions: {
    methodKind: "unary";
    input: typeof ListVpnSessionsRequestSchema;
    output: typeof VpnSessionsResponseSchema;
  },
  /**
   * @generated from rpc zdc.VpnService.StartVpnSession
   */
  startVpnSession: {
    methodKind: "unary";
    input: typeof StartVpnSessionRequestSchema;
    output: typeof StartVpnSessionResponseSchema;
  },
  /**
   * @generated from rpc zdc.VpnService.FinishVpnSession
   */
  finishVpnSession: {
    methodKind: "unary";
    input: typeof FinishVpnSessionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Политика протоколов по базе: GetVpnSettings — рабочий (фильтр списка);
   * SetVpnSettings — конфигуратор/админ.
   *
   * @generated from rpc zdc.VpnService.GetVpnSettings
   */
  getVpnSettings: {
    methodKind: "unary";
    input: typeof GetVpnSettingsRequestSchema;
    output: typeof GetVpnSettingsResponseSchema;
  },
  /**
   * @generated from rpc zdc.VpnService.SetVpnSettings
   */
  setVpnSettings: {
    methodKind: "unary";
    input: typeof SetVpnSettingsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * GetSshAccess — параметры подключения к встроенному SSH-серверу (роль
   * «VPN-клиент»/админ). Гейт проверяется на сервере; без роли — отказ.
   *
   * @generated from rpc zdc.VpnService.GetSshAccess
   */
  getSshAccess: {
    methodKind: "unary";
    input: typeof GetSshAccessRequestSchema;
    output: typeof SshAccessResponseSchema;
  },
  /**
   * TestVpnProfile — проверка доступности профиля (кнопка «Проверить
   * соединение»); гейт — «VPN-управление»/админ. Честный результат:
   * TCP / SSH-рукопожатие / «не поддерживается проверкой» (UDP/QUIC).
   *
   * @generated from rpc zdc.VpnService.TestVpnProfile
   */
  testVpnProfile: {
    methodKind: "unary";
    input: typeof TestVpnProfileRequestSchema;
    output: typeof TestVpnProfileResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 49);

/**
 * ============================================================
 * САЙТЫ (Этап 1 конструктора сайтов, 2026-10-03) — сайт как метаданные базы:
 * дерево страниц (slug/parent), макет из блоков (PageLayout), локали, SEO.
 * CRUD — конфигуратор (admin); GetPublicSite/GetPublicPage/ListSiteSitemap —
 * публичные (без JWT): рендер /p/{site}[/{locale}]/{slug} + SEO-шелл сервера.
 * ============================================================
 *
 * @generated from service zdc.SiteService
 */
export const SiteService: GenService<{
  /**
   * CRUD сайтов (конфигуратор, admin)
   *
   * @generated from rpc zdc.SiteService.ListSites
   */
  listSites: {
    methodKind: "unary";
    input: typeof ListSitesRequestSchema;
    output: typeof SiteListSchema;
  },
  /**
   * по id или code
   *
   * @generated from rpc zdc.SiteService.GetSite
   */
  getSite: {
    methodKind: "unary";
    input: typeof GetSiteRequestSchema;
    output: typeof SiteSchema;
  },
  /**
   * id пусто = создать
   *
   * @generated from rpc zdc.SiteService.SaveSite
   */
  saveSite: {
    methodKind: "unary";
    input: typeof SaveSiteRequestSchema;
    output: typeof SiteSchema;
  },
  /**
   * поставочные — 412
   *
   * @generated from rpc zdc.SiteService.DeleteSite
   */
  deleteSite: {
    methodKind: "unary";
    input: typeof DeleteSiteRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.SiteService.CopySite
   */
  copySite: {
    methodKind: "unary";
    input: typeof CopySiteRequestSchema;
    output: typeof SiteSchema;
  },
  /**
   * @generated from rpc zdc.SiteService.UnprotectSite
   */
  unprotectSite: {
    methodKind: "unary";
    input: typeof UnprotectSiteRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Страницы сайта (конфигуратор, admin)
   *
   * @generated from rpc zdc.SiteService.ListSitePages
   */
  listSitePages: {
    methodKind: "unary";
    input: typeof ListSitePagesRequestSchema;
    output: typeof SitePageListSchema;
  },
  /**
   * по id, (site_code,code) или (site_code,slug)
   *
   * @generated from rpc zdc.SiteService.GetSitePage
   */
  getSitePage: {
    methodKind: "unary";
    input: typeof GetSitePageRequestSchema;
    output: typeof SitePageSchema;
  },
  /**
   * @generated from rpc zdc.SiteService.SaveSitePage
   */
  saveSitePage: {
    methodKind: "unary";
    input: typeof SaveSitePageRequestSchema;
    output: typeof SitePageSchema;
  },
  /**
   * @generated from rpc zdc.SiteService.DeleteSitePage
   */
  deleteSitePage: {
    methodKind: "unary";
    input: typeof DeleteSitePageRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.SiteService.CopySitePage
   */
  copySitePage: {
    methodKind: "unary";
    input: typeof CopySitePageRequestSchema;
    output: typeof SitePageSchema;
  },
  /**
   * Публичные (без JWT; preview=true — только авторизованному: черновики)
   *
   * сайт + дерево страниц (без layout)
   *
   * @generated from rpc zdc.SiteService.GetPublicSite
   */
  getPublicSite: {
    methodKind: "unary";
    input: typeof GetPublicSiteRequestSchema;
    output: typeof PublicSiteSchema;
  },
  /**
   * layout + seo страницы
   *
   * @generated from rpc zdc.SiteService.GetPublicPage
   */
  getPublicPage: {
    methodKind: "unary";
    input: typeof GetSitePublicPageRequestSchema;
    output: typeof SitePageSchema;
  },
  /**
   * опубликованные страницы
   *
   * @generated from rpc zdc.SiteService.ListSiteSitemap
   */
  listSiteSitemap: {
    methodKind: "unary";
    input: typeof ListSiteSitemapRequestSchema;
    output: typeof SiteSitemapSchema;
  },
  /**
   * Поиск по сайту (Этап 3): только цели из site.settings.search.targets
   * (whitelist); права гостя/пользователя проверяются по каждой цели.
   *
   * публичный
   *
   * @generated from rpc zdc.SiteService.SiteSearch
   */
  siteSearch: {
    methodKind: "unary";
    input: typeof SiteSearchRequestSchema;
    output: typeof SiteSearchResponseSchema;
  },
  /**
   * AI-перевод сайта (Этап 3, конфигуратор/admin): строковые props {ru:"…"} →
   * добавляет target_locale (merge, без перезаписи существующего; html — не переводится).
   *
   * @generated from rpc zdc.SiteService.TranslateSite
   */
  translateSite: {
    methodKind: "unary";
    input: typeof TranslateSiteRequestSchema;
    output: typeof TranslateSiteResponseSchema;
  },
  /**
   * Записи для САЙТОВ (публичный): сервер резолвит таблицу/СХЕМУ/поля и права
   * роли «Гость» — клиентский рендер не знает про schema (SSoT/SRP движка рендера).
   *
   * @generated from rpc zdc.SiteService.ListSiteRecords
   */
  listSiteRecords: {
    methodKind: "unary";
    input: typeof ListSiteRecordsRequestSchema;
    output: typeof ListSiteRecordsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 50);

/**
 * @generated from service zdc.ReviewService
 */
export const ReviewService: GenService<{
  /**
   * Публичные (без JWT): только status='published'; авторизованному с правом
   * модерации — все. CreateReview — rate-limit публичных сабмитов.
   *
   * @generated from rpc zdc.ReviewService.ListReviews
   */
  listReviews: {
    methodKind: "unary";
    input: typeof ListReviewsRequestSchema;
    output: typeof ReviewListSchema;
  },
  /**
   * @generated from rpc zdc.ReviewService.CreateReview
   */
  createReview: {
    methodKind: "unary";
    input: typeof CreateReviewRequestSchema;
    output: typeof ReviewSchema;
  },
  /**
   * @generated from rpc zdc.ReviewService.GetReviewSummary
   */
  getReviewSummary: {
    methodKind: "unary";
    input: typeof GetReviewSummaryRequestSchema;
    output: typeof ReviewSummarySchema;
  },
  /**
   * Модерация: админ ИЛИ право «Изменение» на объект.
   *
   * @generated from rpc zdc.ReviewService.SetReviewStatus
   */
  setReviewStatus: {
    methodKind: "unary";
    input: typeof SetReviewStatusRequestSchema;
    output: typeof ReviewSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 51);

/**
 * @generated from service zdc.PollService
 */
export const PollService: GenService<{
  /**
   * @generated from rpc zdc.PollService.ListPolls
   */
  listPolls: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof PollListSchema;
  },
  /**
   * @generated from rpc zdc.PollService.ListPollTypes
   */
  listPollTypes: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof PollTypeListSchema;
  },
  /**
   * @generated from rpc zdc.PollService.GetPollFull
   */
  getPollFull: {
    methodKind: "unary";
    input: typeof PollGetSchema;
    output: typeof PollFullSchema;
  },
  /**
   * @generated from rpc zdc.PollService.SavePoll
   */
  savePoll: {
    methodKind: "unary";
    input: typeof SavePollRequestSchema;
    output: typeof PollFullSchema;
  },
  /**
   * @generated from rpc zdc.PollService.DeletePoll
   */
  deletePoll: {
    methodKind: "unary";
    input: typeof PollGetSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.PollService.SetPollStatus
   */
  setPollStatus: {
    methodKind: "unary";
    input: typeof SetPollStatusRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.PollService.SubmitPollAnswers
   */
  submitPollAnswers: {
    methodKind: "unary";
    input: typeof SubmitPollAnswersRequestSchema;
    output: typeof PollResultInfoSchema;
  },
  /**
   * Ручной протокол внешней (авторской) методики (без вопросов/авто-скоринга).
   *
   * @generated from rpc zdc.PollService.SubmitPollResult
   */
  submitPollResult: {
    methodKind: "unary";
    input: typeof SubmitPollResultRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.PollService.ListPollResults
   */
  listPollResults: {
    methodKind: "unary";
    input: typeof PollGetSchema;
    output: typeof PollResultListSchema;
  },
  /**
   * @generated from rpc zdc.PollService.ListMyAssignments
   */
  listMyAssignments: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof PollListSchema;
  },
  /**
   * Онлайн-прохождение: ссылка (специалист) → публичное прохождение гостя.
   *
   * @generated from rpc zdc.PollService.CreatePollGuestLink
   */
  createPollGuestLink: {
    methodKind: "unary";
    input: typeof PollGuestLinkCreateSchema;
    output: typeof PollGuestLinkSchema;
  },
  /**
   * @generated from rpc zdc.PollService.ResolvePollGuestLink
   */
  resolvePollGuestLink: {
    methodKind: "unary";
    input: typeof PollGuestLinkResolveSchema;
    output: typeof PollGuestFormSchema;
  },
  /**
   * @generated from rpc zdc.PollService.SubmitPollLinkAnswers
   */
  submitPollLinkAnswers: {
    methodKind: "unary";
    input: typeof SubmitPollLinkAnswersRequestSchema;
    output: typeof PollResultInfoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 52);

/**
 * @generated from service zdc.ClassifierService
 */
export const ClassifierService: GenService<{
  /**
   * @generated from rpc zdc.ClassifierService.ListClassifiers
   */
  listClassifiers: {
    methodKind: "unary";
    input: typeof ListClassifiersRequestSchema;
    output: typeof ClassifierListSchema;
  },
  /**
   * @generated from rpc zdc.ClassifierService.GetClassifier
   */
  getClassifier: {
    methodKind: "unary";
    input: typeof GetClassifierRequestSchema;
    output: typeof ClassifierSchema;
  },
  /**
   * @generated from rpc zdc.ClassifierService.SaveClassifier
   */
  saveClassifier: {
    methodKind: "unary";
    input: typeof SaveClassifierRequestSchema;
    output: typeof ClassifierSchema;
  },
  /**
   * @generated from rpc zdc.ClassifierService.DeleteClassifier
   */
  deleteClassifier: {
    methodKind: "unary";
    input: typeof DeleteClassifierRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.ClassifierService.ImportClassifierFile
   */
  importClassifierFile: {
    methodKind: "unary";
    input: typeof ImportClassifierRequestSchema;
    output: typeof ImportClassifierResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 53);

/**
 * @generated from service zdc.DownloadService
 */
export const DownloadService: GenService<{
  /**
   * @generated from rpc zdc.DownloadService.StartDownload
   */
  startDownload: {
    methodKind: "unary";
    input: typeof StartDownloadRequestSchema;
    output: typeof StartDownloadResponseSchema;
  },
  /**
   * @generated from rpc zdc.DownloadService.CancelDownload
   */
  cancelDownload: {
    methodKind: "unary";
    input: typeof CancelDownloadRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.DownloadService.GetDownload
   */
  getDownload: {
    methodKind: "unary";
    input: typeof DownloadJobSchema;
    output: typeof DownloadJobSchema;
  },
  /**
   * @generated from rpc zdc.DownloadService.ListDownloads
   */
  listDownloads: {
    methodKind: "unary";
    input: typeof ListDownloadsRequestSchema;
    output: typeof DownloadJobListSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 54);

/**
 * @generated from service zdc.GarService
 */
export const GarService: GenService<{
  /**
   * @generated from rpc zdc.GarService.GetStatus
   */
  getStatus: {
    methodKind: "unary";
    input: typeof EmptyGarSchema;
    output: typeof GarStatusResponseSchema;
  },
  /**
   * @generated from rpc zdc.GarService.StartDumpDownload
   */
  startDumpDownload: {
    methodKind: "unary";
    input: typeof EmptyGarSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.GarService.CancelDumpDownload
   */
  cancelDumpDownload: {
    methodKind: "unary";
    input: typeof EmptyGarSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.GarService.ImportRegion
   */
  importRegion: {
    methodKind: "unary";
    input: typeof GarImportRegionRequestSchema;
    output: typeof GarImportRegionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 55);

/**
 * @generated from service zdc.MetricsService
 */
export const MetricsService: GenService<{
  /**
   * @generated from rpc zdc.MetricsService.ListObjMetrics
   */
  listObjMetrics: {
    methodKind: "unary";
    input: typeof ListObjMetricsRequestSchema;
    output: typeof ObjMetricListSchema;
  },
  /**
   * @generated from rpc zdc.MetricsService.GetObjMetric
   */
  getObjMetric: {
    methodKind: "unary";
    input: typeof GetObjMetricRequestSchema;
    output: typeof ObjMetricSchema;
  },
  /**
   * @generated from rpc zdc.MetricsService.SaveObjMetric
   */
  saveObjMetric: {
    methodKind: "unary";
    input: typeof SaveObjMetricRequestSchema;
    output: typeof ObjMetricSchema;
  },
  /**
   * @generated from rpc zdc.MetricsService.DeleteObjMetric
   */
  deleteObjMetric: {
    methodKind: "unary";
    input: typeof DeleteObjMetricRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 56);

/**
 * @generated from service zdc.FolderService
 */
export const FolderService: GenService<{
  /**
   * @generated from rpc zdc.FolderService.ListFolders
   */
  listFolders: {
    methodKind: "unary";
    input: typeof ListFoldersRequestSchema;
    output: typeof FolderListSchema;
  },
  /**
   * @generated from rpc zdc.FolderService.GetFolder
   */
  getFolder: {
    methodKind: "unary";
    input: typeof GetFolderRequestSchema;
    output: typeof HydraFolderSchema;
  },
  /**
   * @generated from rpc zdc.FolderService.SaveFolder
   */
  saveFolder: {
    methodKind: "unary";
    input: typeof SaveFolderRequestSchema;
    output: typeof HydraFolderSchema;
  },
  /**
   * @generated from rpc zdc.FolderService.DeleteFolder
   */
  deleteFolder: {
    methodKind: "unary";
    input: typeof DeleteFolderRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.FolderService.FolderCounts
   */
  folderCounts: {
    methodKind: "unary";
    input: typeof FolderCountsRequestSchema;
    output: typeof FolderCountsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 57);

/**
 * @generated from service zdc.InstanceService
 */
export const InstanceService: GenService<{
  /**
   * @generated from rpc zdc.InstanceService.GetInstance
   */
  getInstance: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof InstanceDataSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 58);

/**
 * @generated from service zdc.AdapterService
 */
export const AdapterService: GenService<{
  /**
   * Типы (реестр, публичный — для форм настройки)
   *
   * @generated from rpc zdc.AdapterService.ListAdapterTypes
   */
  listAdapterTypes: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListAdapterTypesResponseSchema;
  },
  /**
   * Экземпляры (конфигуратор/админ)
   *
   * @generated from rpc zdc.AdapterService.ListAdapters
   */
  listAdapters: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListAdaptersResponseSchema;
  },
  /**
   * Экземпляры для ПОДКЛЮЧЕНИЯ В ПРОФИЛЕ (любой авторизованный): только типы
   * с profile_login, только включённые, БЕЗ секретов — клиент не запрашивает
   * админский ListAdapters (он закрыт requireAdmin).
   *
   * @generated from rpc zdc.AdapterService.ListProfileAdapters
   */
  listProfileAdapters: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListAdaptersResponseSchema;
  },
  /**
   * @generated from rpc zdc.AdapterService.SaveAdapter
   */
  saveAdapter: {
    methodKind: "unary";
    input: typeof SaveAdapterRequestSchema;
    output: typeof AdapterSchema;
  },
  /**
   * @generated from rpc zdc.AdapterService.DeleteAdapter
   */
  deleteAdapter: {
    methodKind: "unary";
    input: typeof DeleteAdapterRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Общие прокси
   *
   * @generated from rpc zdc.AdapterService.ListProxies
   */
  listProxies: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListProxiesResponseSchema;
  },
  /**
   * @generated from rpc zdc.AdapterService.SaveProxy
   */
  saveProxy: {
    methodKind: "unary";
    input: typeof SaveProxyRequestSchema;
    output: typeof AdapterProxySchema;
  },
  /**
   * @generated from rpc zdc.AdapterService.DeleteProxy
   */
  deleteProxy: {
    methodKind: "unary";
    input: typeof DeleteProxyRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Проверка подключения прокси: TCP-соединение с адресом (host:port).
   *
   * @generated from rpc zdc.AdapterService.TestProxy
   */
  testProxy: {
    methodKind: "unary";
    input: typeof TestProxyRequestSchema;
    output: typeof TestProxyResponseSchema;
  },
  /**
   * Внешние ссылки (рабочие: свои сущности, контейнеры)
   *
   * @generated from rpc zdc.AdapterService.ListAdapterLinks
   */
  listAdapterLinks: {
    methodKind: "unary";
    input: typeof ListAdapterLinksRequestSchema;
    output: typeof ListAdapterLinksResponseSchema;
  },
  /**
   * @generated from rpc zdc.AdapterService.SaveAdapterLink
   */
  saveAdapterLink: {
    methodKind: "unary";
    input: typeof SaveAdapterLinkRequestSchema;
    output: typeof AdapterLinkSchema;
  },
  /**
   * @generated from rpc zdc.AdapterService.DeleteAdapterLink
   */
  deleteAdapterLink: {
    methodKind: "unary";
    input: typeof DeleteAdapterLinkRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Сессии userbot'ов (свои — любой, чужие — админ)
   *
   * @generated from rpc zdc.AdapterService.ListAdapterSessions
   */
  listAdapterSessions: {
    methodKind: "unary";
    input: typeof ListAdapterSessionsRequestSchema;
    output: typeof ListAdapterSessionsResponseSchema;
  },
  /**
   * @generated from rpc zdc.AdapterService.DeleteAdapterSession
   */
  deleteAdapterSession: {
    methodKind: "unary";
    input: typeof DeleteAdapterSessionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Вход userbot'а (MTProto/TDLib): код из Telegram → (email-шаг) → пароль 2FA
   * (рабочие, свои сессии)
   *
   * @generated from rpc zdc.AdapterService.StartAdapterLogin
   */
  startAdapterLogin: {
    methodKind: "unary";
    input: typeof StartAdapterLoginRequestSchema;
    output: typeof AdapterLoginStateSchema;
  },
  /**
   * @generated from rpc zdc.AdapterService.SubmitAdapterLoginCode
   */
  submitAdapterLoginCode: {
    methodKind: "unary";
    input: typeof SubmitAdapterLoginCodeRequestSchema;
    output: typeof AdapterLoginStateSchema;
  },
  /**
   * @generated from rpc zdc.AdapterService.SubmitAdapterLoginEmailAddress
   */
  submitAdapterLoginEmailAddress: {
    methodKind: "unary";
    input: typeof SubmitAdapterLoginEmailAddressRequestSchema;
    output: typeof AdapterLoginStateSchema;
  },
  /**
   * @generated from rpc zdc.AdapterService.SubmitAdapterLoginEmailCode
   */
  submitAdapterLoginEmailCode: {
    methodKind: "unary";
    input: typeof SubmitAdapterLoginEmailCodeRequestSchema;
    output: typeof AdapterLoginStateSchema;
  },
  /**
   * @generated from rpc zdc.AdapterService.ResendAdapterLoginCode
   */
  resendAdapterLoginCode: {
    methodKind: "unary";
    input: typeof ResendAdapterLoginCodeRequestSchema;
    output: typeof AdapterLoginStateSchema;
  },
  /**
   * @generated from rpc zdc.AdapterService.ResetAdapterLoginEmail
   */
  resetAdapterLoginEmail: {
    methodKind: "unary";
    input: typeof ResetAdapterLoginEmailRequestSchema;
    output: typeof AdapterLoginStateSchema;
  },
  /**
   * @generated from rpc zdc.AdapterService.SubmitAdapterLoginPassword
   */
  submitAdapterLoginPassword: {
    methodKind: "unary";
    input: typeof SubmitAdapterLoginPasswordRequestSchema;
    output: typeof AdapterLoginStateSchema;
  },
  /**
   * @generated from rpc zdc.AdapterService.GetAdapterLogin
   */
  getAdapterLogin: {
    methodKind: "unary";
    input: typeof GetAdapterLoginRequestSchema;
    output: typeof AdapterLoginStateSchema;
  },
  /**
   * Тест экземпляра (кнопка «Проверить»)
   *
   * @generated from rpc zdc.AdapterService.TestAdapter
   */
  testAdapter: {
    methodKind: "unary";
    input: typeof SaveAdapterRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * M3: меню-кнопка приложения у бота (Telegram: setChatMenuButton web_app)
   *
   * @generated from rpc zdc.AdapterService.SetupAdapterMenu
   */
  setupAdapterMenu: {
    methodKind: "unary";
    input: typeof SetupAdapterMenuRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 59);

/**
 * @generated from service zdc.AccountingService
 */
export const AccountingService: GenService<{
  /**
   * Планы счетов
   *
   * @generated from rpc zdc.AccountingService.ListChartsOfAccounts
   */
  listChartsOfAccounts: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ChartOfAccountsListSchema;
  },
  /**
   * @generated from rpc zdc.AccountingService.GetChartOfAccounts
   */
  getChartOfAccounts: {
    methodKind: "unary";
    input: typeof GetChartOfAccountsRequestSchema;
    output: typeof ChartOfAccountsSchema;
  },
  /**
   * @generated from rpc zdc.AccountingService.SaveChartOfAccounts
   */
  saveChartOfAccounts: {
    methodKind: "unary";
    input: typeof SaveChartOfAccountsRequestSchema;
    output: typeof ChartOfAccountsSchema;
  },
  /**
   * @generated from rpc zdc.AccountingService.DeleteChartOfAccounts
   */
  deleteChartOfAccounts: {
    methodKind: "unary";
    input: typeof DeleteChartOfAccountsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Счета плана
   *
   * @generated from rpc zdc.AccountingService.ListAccounts
   */
  listAccounts: {
    methodKind: "unary";
    input: typeof ListAccountsRequestSchema;
    output: typeof ChartAccountListSchema;
  },
  /**
   * @generated from rpc zdc.AccountingService.SaveAccount
   */
  saveAccount: {
    methodKind: "unary";
    input: typeof SaveAccountRequestSchema;
    output: typeof ChartAccountSchema;
  },
  /**
   * @generated from rpc zdc.AccountingService.DeleteAccount
   */
  deleteAccount: {
    methodKind: "unary";
    input: typeof DeleteAccountRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Виды субконто
   *
   * @generated from rpc zdc.AccountingService.ListSubcontoTypes
   */
  listSubcontoTypes: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof SubcontoTypeListSchema;
  },
  /**
   * @generated from rpc zdc.AccountingService.SaveSubcontoType
   */
  saveSubcontoType: {
    methodKind: "unary";
    input: typeof SaveSubcontoTypeRequestSchema;
    output: typeof SubcontoTypeSchema;
  },
  /**
   * @generated from rpc zdc.AccountingService.DeleteSubcontoType
   */
  deleteSubcontoType: {
    methodKind: "unary";
    input: typeof DeleteSubcontoTypeRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 60);

/**
 * @generated from service zdc.BillingService
 */
export const BillingService: GenService<{
  /**
   * Настройки (Get — авторизованный; Set — админ/конфигуратор)
   *
   * @generated from rpc zdc.BillingService.GetBillingSettings
   */
  getBillingSettings: {
    methodKind: "unary";
    input: typeof GetBillingSettingsRequestSchema;
    output: typeof GetBillingSettingsResponseSchema;
  },
  /**
   * @generated from rpc zdc.BillingService.SetBillingSettings
   */
  setBillingSettings: {
    methodKind: "unary";
    input: typeof SetBillingSettingsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Счета (админ; личный счёт авто-создаётся ядром)
   *
   * @generated from rpc zdc.BillingService.ListBillingAccounts
   */
  listBillingAccounts: {
    methodKind: "unary";
    input: typeof ListBillingAccountsRequestSchema;
    output: typeof ListBillingAccountsResponseSchema;
  },
  /**
   * @generated from rpc zdc.BillingService.SaveBillingAccount
   */
  saveBillingAccount: {
    methodKind: "unary";
    input: typeof SaveBillingAccountRequestSchema;
    output: typeof BillingAccountSchema;
  },
  /**
   * @generated from rpc zdc.BillingService.DeleteBillingAccount
   */
  deleteBillingAccount: {
    methodKind: "unary";
    input: typeof DeleteBillingAccountRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Операции (админ — все/фильтр; свой счёт — через GetMyBillingAccount)
   *
   * @generated from rpc zdc.BillingService.ListBillingOperations
   */
  listBillingOperations: {
    methodKind: "unary";
    input: typeof ListBillingOperationsRequestSchema;
    output: typeof ListBillingOperationsResponseSchema;
  },
  /**
   * Свой счёт (авторизованный): счёт + баланс/холды + история
   *
   * @generated from rpc zdc.BillingService.GetMyBillingAccount
   */
  getMyBillingAccount: {
    methodKind: "unary";
    input: typeof GetMyBillingAccountRequestSchema;
    output: typeof GetMyBillingAccountResponseSchema;
  },
  /**
   * Доступы (админ — grant/revoke/list; Has — авторизованный)
   *
   * @generated from rpc zdc.BillingService.GrantBillingAccess
   */
  grantBillingAccess: {
    methodKind: "unary";
    input: typeof GrantBillingAccessRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.BillingService.RevokeBillingAccess
   */
  revokeBillingAccess: {
    methodKind: "unary";
    input: typeof RevokeBillingAccessRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.BillingService.HasBillingAccess
   */
  hasBillingAccess: {
    methodKind: "unary";
    input: typeof HasBillingAccessRequestSchema;
    output: typeof HasBillingAccessResponseSchema;
  },
  /**
   * @generated from rpc zdc.BillingService.ListBillingAccess
   */
  listBillingAccess: {
    methodKind: "unary";
    input: typeof ListBillingAccessRequestSchema;
    output: typeof ListBillingAccessResponseSchema;
  },
  /**
   * Тарифы (админ)
   *
   * @generated from rpc zdc.BillingService.ListBillingPlans
   */
  listBillingPlans: {
    methodKind: "unary";
    input: typeof ListBillingPlansRequestSchema;
    output: typeof ListBillingPlansResponseSchema;
  },
  /**
   * @generated from rpc zdc.BillingService.SaveBillingPlan
   */
  saveBillingPlan: {
    methodKind: "unary";
    input: typeof SaveBillingPlanRequestSchema;
    output: typeof BillingPlanSchema;
  },
  /**
   * @generated from rpc zdc.BillingService.DeleteBillingPlan
   */
  deleteBillingPlan: {
    methodKind: "unary";
    input: typeof DeleteBillingPlanRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Области доступа/тарифа (каскад «вид → значение»: приложения/разделы/функции)
   *
   * @generated from rpc zdc.BillingService.ListBillingScopeTargets
   */
  listBillingScopeTargets: {
    methodKind: "unary";
    input: typeof ListBillingScopeTargetsRequestSchema;
    output: typeof ListBillingScopeTargetsResponseSchema;
  },
  /**
   * Подписки (свои — любой; чужие — админ)
   *
   * @generated from rpc zdc.BillingService.SubscribeBillingPlan
   */
  subscribeBillingPlan: {
    methodKind: "unary";
    input: typeof SubscribeBillingPlanRequestSchema;
    output: typeof BillingSubscriptionSchema;
  },
  /**
   * @generated from rpc zdc.BillingService.CancelBillingSubscription
   */
  cancelBillingSubscription: {
    methodKind: "unary";
    input: typeof CancelBillingSubscriptionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.BillingService.ListBillingSubscriptions
   */
  listBillingSubscriptions: {
    methodKind: "unary";
    input: typeof ListBillingSubscriptionsRequestSchema;
    output: typeof ListBillingSubscriptionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 61);

/**
 * @generated from service zdc.SchedulerService
 */
export const SchedulerService: GenService<{
  /**
   * CRUD (конфигуратор): List/Get — список/получение; Save — upsert по code
   * (валидация расписания/обработчика); Delete — удаление (412 для
   * поставочных/системных); RunNow — «Выполнить сейчас» (запись в историю).
   *
   * @generated from rpc zdc.SchedulerService.ListScheduledJobs
   */
  listScheduledJobs: {
    methodKind: "unary";
    input: typeof ListScheduledJobsRequestSchema;
    output: typeof ListScheduledJobsResponseSchema;
  },
  /**
   * @generated from rpc zdc.SchedulerService.GetScheduledJob
   */
  getScheduledJob: {
    methodKind: "unary";
    input: typeof GetScheduledJobRequestSchema;
    output: typeof ScheduledJobSchema;
  },
  /**
   * @generated from rpc zdc.SchedulerService.SaveScheduledJob
   */
  saveScheduledJob: {
    methodKind: "unary";
    input: typeof SaveScheduledJobRequestSchema;
    output: typeof ScheduledJobSchema;
  },
  /**
   * @generated from rpc zdc.SchedulerService.DeleteScheduledJob
   */
  deleteScheduledJob: {
    methodKind: "unary";
    input: typeof DeleteScheduledJobRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.SchedulerService.RunScheduledJobNow
   */
  runScheduledJobNow: {
    methodKind: "unary";
    input: typeof RunScheduledJobNowRequestSchema;
    output: typeof ScheduledJobRunSchema;
  },
  /**
   * @generated from rpc zdc.SchedulerService.ListScheduledJobRuns
   */
  listScheduledJobRuns: {
    methodKind: "unary";
    input: typeof ListScheduledJobRunsRequestSchema;
    output: typeof ListScheduledJobRunsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 62);

/**
 * @generated from service zdc.RemoteService
 */
export const RemoteService: GenService<{
  /**
   * @generated from rpc zdc.RemoteService.CreateRemoteGuestLink
   */
  createRemoteGuestLink: {
    methodKind: "unary";
    input: typeof CreateRemoteGuestLinkRequestSchema;
    output: typeof CreateRemoteGuestLinkResponseSchema;
  },
  /**
   * @generated from rpc zdc.RemoteService.ResolveRemoteGuestLink
   */
  resolveRemoteGuestLink: {
    methodKind: "unary";
    input: typeof ResolveRemoteGuestLinkRequestSchema;
    output: typeof ResolveRemoteGuestLinkResponseSchema;
  },
  /**
   * Сессия как объект платформы (Ф4): старт/завершение/история (авторизованные;
   * гость не вызывает — сессия гостя фиксируется стороной хоста).
   *
   * @generated from rpc zdc.RemoteService.StartRemoteSession
   */
  startRemoteSession: {
    methodKind: "unary";
    input: typeof StartRemoteSessionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.RemoteService.EndRemoteSession
   */
  endRemoteSession: {
    methodKind: "unary";
    input: typeof EndRemoteSessionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.RemoteService.ListRemoteSessions
   */
  listRemoteSessions: {
    methodKind: "unary";
    input: typeof ListRemoteSessionsRequestSchema;
    output: typeof ListRemoteSessionsResponseSchema;
  },
  /**
   * Контрактный эндпоинт сеанса (наш wire-контракт v2): Register — хост
   * (сеанс существует/участник; upsert адреса); Get — зритель (адрес резолвит
   * ПЛАТФОРМА; нет записи → NotFound с русским текстом).
   *
   * @generated from rpc zdc.RemoteService.RegisterRemoteEndpoint
   */
  registerRemoteEndpoint: {
    methodKind: "unary";
    input: typeof RegisterRemoteEndpointRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.RemoteService.GetRemoteEndpoint
   */
  getRemoteEndpoint: {
    methodKind: "unary";
    input: typeof GetRemoteEndpointRequestSchema;
    output: typeof RemoteEndpointInfoSchema;
  },
  /**
   * Релей за NAT: выпуск короткоживущего токена роли (host|viewer) + адрес
   * релея сеанса. Хост подключается к релею (role=host), регистрирует адрес
   * (RegisterRemoteEndpoint, transport='relay') и публикует сигнал обнаружения;
   * зритель резолвит транспорт через GetRemoteEndpoint и подключается к релею
   * (role=viewer) со своим токеном.
   *
   * @generated from rpc zdc.RemoteService.IssueRelayToken
   */
  issueRelayToken: {
    methodKind: "unary";
    input: typeof IssueRelayTokenRequestSchema;
    output: typeof IssueRelayTokenResponseSchema;
  },
  /**
   * Пароль удалённого доступа (unattended): Get — владелец своей политики
   * (или remote_manage/админ для любого хоста); Set/Revoke — ТОЛЬКО
   * remote_manage/админ; StartByPassword — использование Remote
   * (remote_client/remote_manage/админ): верный пароль стартует сессию
   * БЕЗ подтверждения хоста, неверный — отказ, попытки — rate-limit + аудит.
   *
   * @generated from rpc zdc.RemoteService.GetRemoteAccessSettings
   */
  getRemoteAccessSettings: {
    methodKind: "unary";
    input: typeof GetRemoteAccessSettingsRequestSchema;
    output: typeof RemoteAccessSettingsSchema;
  },
  /**
   * @generated from rpc zdc.RemoteService.SetRemoteAccessPassword
   */
  setRemoteAccessPassword: {
    methodKind: "unary";
    input: typeof SetRemoteAccessPasswordRequestSchema;
    output: typeof RemoteAccessSettingsSchema;
  },
  /**
   * @generated from rpc zdc.RemoteService.RevokeRemoteAccess
   */
  revokeRemoteAccess: {
    methodKind: "unary";
    input: typeof RevokeRemoteAccessRequestSchema;
    output: typeof RemoteAccessSettingsSchema;
  },
  /**
   * @generated from rpc zdc.RemoteService.StartRemoteSessionByPassword
   */
  startRemoteSessionByPassword: {
    methodKind: "unary";
    input: typeof StartRemoteSessionByPasswordRequestSchema;
    output: typeof StartRemoteSessionByPasswordResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 63);

/**
 * @generated from service zdc.PaymentService
 */
export const PaymentService: GenService<{
  /**
   * @generated from rpc zdc.PaymentService.ListPaymentProviders
   */
  listPaymentProviders: {
    methodKind: "unary";
    input: typeof ListPaymentProvidersRequestSchema;
    output: typeof ListPaymentProvidersResponseSchema;
  },
  /**
   * @generated from rpc zdc.PaymentService.SavePaymentProvider
   */
  savePaymentProvider: {
    methodKind: "unary";
    input: typeof SavePaymentProviderRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.PaymentService.CreatePayment
   */
  createPayment: {
    methodKind: "unary";
    input: typeof CreatePaymentRequestSchema;
    output: typeof PaymentIntentSchema;
  },
  /**
   * @generated from rpc zdc.PaymentService.GetPayment
   */
  getPayment: {
    methodKind: "unary";
    input: typeof GetPaymentRequestSchema;
    output: typeof PaymentIntentSchema;
  },
  /**
   * @generated from rpc zdc.PaymentService.ListPayments
   */
  listPayments: {
    methodKind: "unary";
    input: typeof ListPaymentsRequestSchema;
    output: typeof ListPaymentsResponseSchema;
  },
  /**
   * @generated from rpc zdc.PaymentService.RefundPayment
   */
  refundPayment: {
    methodKind: "unary";
    input: typeof RefundPaymentRequestSchema;
    output: typeof PaymentIntentSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 64);

/**
 * @generated from service zdc.AssetService
 */
export const AssetService: GenService<{
  /**
   * @generated from rpc zdc.AssetService.ListAssets
   */
  listAssets: {
    methodKind: "unary";
    input: typeof ListAssetsRequestSchema;
    output: typeof ListAssetsResponseSchema;
  },
  /**
   * @generated from rpc zdc.AssetService.SaveAsset
   */
  saveAsset: {
    methodKind: "unary";
    input: typeof SaveAssetRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc zdc.AssetService.DeleteAsset
   */
  deleteAsset: {
    methodKind: "unary";
    input: typeof DeleteAssetRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Публичный: сайт резолвит ассет (свой → общий core).
   *
   * @generated from rpc zdc.AssetService.ResolveAsset
   */
  resolveAsset: {
    methodKind: "unary";
    input: typeof ResolveAssetRequestSchema;
    output: typeof ResolveAssetResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 65);

/**
 * @generated from service zdc.HydraIdService
 */
export const HydraIdService: GenService<{
  /**
   * Мой номер (выдаётся при необходимости — идемпотентно).
   *
   * @generated from rpc zdc.HydraIdService.GetMyHydraId
   */
  getMyHydraId: {
    methodKind: "unary";
    input: typeof GetMyHydraIdRequestSchema;
    output: typeof GetMyHydraIdResponseSchema;
  },
  /**
   * Резолв по полному номеру (Verhoeff проверяется ДО поиска).
   *
   * @generated from rpc zdc.HydraIdService.ResolveNumber
   */
  resolveNumber: {
    methodKind: "unary";
    input: typeof ResolveHydraIdRequestSchema;
    output: typeof ResolveHydraIdResponseSchema;
  },
  /**
   * «Найти по номеру» — по началу номера (минимум 3 цифры) или по полному.
   *
   * @generated from rpc zdc.HydraIdService.SearchByNumber
   */
  searchByNumber: {
    methodKind: "unary";
    input: typeof SearchHydraIdRequestSchema;
    output: typeof SearchHydraIdResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 66);

/**
 * @generated from service zdc.DeviceService
 */
export const DeviceService: GenService<{
  /**
   * Устройства текущего пользователя (по номеру человека).
   *
   * @generated from rpc zdc.DeviceService.ListMyDevices
   */
  listMyDevices: {
    methodKind: "unary";
    input: typeof ListMyDevicesRequestSchema;
    output: typeof DeviceListSchema;
  },
  /**
   * Идемпотентный энролл (pubkey+kind+os+name) — выдача индекса/DeviceID.
   *
   * @generated from rpc zdc.DeviceService.RegisterDevice
   */
  registerDevice: {
    methodKind: "unary";
    input: typeof RegisterDeviceRequestSchema;
    output: typeof RegisterDeviceResponseSchema;
  },
  /**
   * Отметка «на связи» + переименование (непустое name).
   *
   * @generated from rpc zdc.DeviceService.TouchDevice
   */
  touchDevice: {
    methodKind: "unary";
    input: typeof TouchDeviceRequestSchema;
    output: typeof TouchDeviceResponseSchema;
  },
  /**
   * Отзыв устройства (необратимо: status=revoked).
   *
   * @generated from rpc zdc.DeviceService.RevokeDevice
   */
  revokeDevice: {
    methodKind: "unary";
    input: typeof RevokeDeviceRequestSchema;
    output: typeof RevokeDeviceResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 67);

/**
 * ============================================================================
 * МОБИЛЬНОЕ ПРИЛОЖЕНИЕ — ФАЗА 0 (контракт sdk.mobile.v1).
 * Фасад MobileService: делегирует существующим сервисам (devices/vpn/hydraid),
 * добавляя device-bound контекст и мобильные DTO. Никакой второй реализации
 * бизнес-логики: RegisterDevice — hydraid, GetVpnConfig — metadata VpnProfile.
 * Device-bound: JWT получает claim `dev = {DeviceID}` (kind='device'); токены
 * хранятся в device_tokens (эпоха/отпечаток; отзыв — мгновенный).
 * ============================================================================
 *
 * @generated from service zdc.MobileService
 */
export const MobileService: GenService<{
  /**
   * Регистрация телефона за человеком: DeviceID + device-bound токен (один раз).
   *
   * @generated from rpc zdc.MobileService.RegisterDevice
   */
  registerDevice: {
    methodKind: "unary";
    input: typeof MobileRegisterDeviceRequestSchema;
    output: typeof MobileRegisterDeviceResponseSchema;
  },
  /**
   * Ожидаемый серверный манифест возможностей и флаги политики (discovery).
   *
   * @generated from rpc zdc.MobileService.GetCapabilities
   */
  getCapabilities: {
    methodKind: "unary";
    input: typeof GetCapabilitiesRequestSchema;
    output: typeof GetCapabilitiesResponseSchema;
  },
  /**
   * Конфиг VPN для ЭТОГО устройства (WG INI / vless://).
   *
   * @generated from rpc zdc.MobileService.GetVpnConfig
   */
  getVpnConfig: {
    methodKind: "unary";
    input: typeof MobileVpnConfigRequestSchema;
    output: typeof MobileVpnConfigResponseSchema;
  },
  /**
   * Перевыпуск конфига (новый peer/ключ), старый отзывается.
   *
   * @generated from rpc zdc.MobileService.RotateVpnConfig
   */
  rotateVpnConfig: {
    methodKind: "unary";
    input: typeof RotateVpnConfigRequestSchema;
    output: typeof MobileVpnConfigResponseSchema;
  },
  /**
   * «Кто звонит» — имя/категория из легальных источников (нет совпадения — не ошибка).
   *
   * @generated from rpc zdc.MobileService.LookupNumber
   */
  lookupNumber: {
    methodKind: "unary";
    input: typeof LookupNumberRequestSchema;
    output: typeof LookupNumberResponseSchema;
  },
  /**
   * Дельта серверного списка блокировок (add/remove, версия).
   *
   * @generated from rpc zdc.MobileService.SyncBlocklist
   */
  syncBlocklist: {
    methodKind: "unary";
    input: typeof SyncBlocklistRequestSchema;
    output: typeof SyncBlocklistResponseSchema;
  },
  /**
   * Политика уведомлений устройства (категории, тихие часы).
   *
   * @generated from rpc zdc.MobileService.PushPolicy
   */
  pushPolicy: {
    methodKind: "unary";
    input: typeof PushPolicyRequestSchema;
    output: typeof PushPolicyResponseSchema;
  },
  /**
   * Отчёт телефона о звонке (идемпотентно по event_id — повторы очереди не дублируют).
   *
   * @generated from rpc zdc.MobileService.ReportCallEvent
   */
  reportCallEvent: {
    methodKind: "unary";
    input: typeof ReportCallEventRequestSchema;
    output: typeof ReportCallEventResponseSchema;
  },
  /**
   * Политика блокировки звонков/SMS (режимы off|blocklist|allowlist|all_except).
   * Пользователь — своё устройство/себя; админ — база/роль/пользователь/устройство.
   *
   * @generated from rpc zdc.MobileService.GetCallPolicy
   */
  getCallPolicy: {
    methodKind: "unary";
    input: typeof GetCallPolicyRequestSchema;
    output: typeof CallPolicySchema;
  },
  /**
   * @generated from rpc zdc.MobileService.SetCallPolicy
   */
  setCallPolicy: {
    methodKind: "unary";
    input: typeof SetCallPolicyRequestSchema;
    output: typeof CallPolicySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 68);

/**
 * @generated from service zdc.SiteTemplateService
 */
export const SiteTemplateService: GenService<{
  /**
   * Галерея: каталог с фильтрами (категории/теги/признаки/поиск/сортировка).
   *
   * @generated from rpc zdc.SiteTemplateService.ListSiteTemplates
   */
  listSiteTemplates: {
    methodKind: "unary";
    input: typeof ListSiteTemplatesRequestSchema;
    output: typeof ListSiteTemplatesResponseSchema;
  },
  /**
   * Карточка шаблона: страницы/тема/лицензия.
   *
   * @generated from rpc zdc.SiteTemplateService.GetSiteTemplate
   */
  getSiteTemplate: {
    methodKind: "unary";
    input: typeof GetSiteTemplateRequestSchema;
    output: typeof SiteTemplateDetailsSchema;
  },
  /**
   * Файл шаблона (превью/медиа) — авторизованный, вне папки версии не выйти.
   *
   * @generated from rpc zdc.SiteTemplateService.ResolveTemplateAsset
   */
  resolveTemplateAsset: {
    methodKind: "unary";
    input: typeof ResolveTemplateAssetRequestSchema;
    output: typeof ResolveTemplateAssetResponseSchema;
  },
  /**
   * Применение к сайту базы: новый сайт / дополнение страниц (+журнал применения).
   *
   * @generated from rpc zdc.SiteTemplateService.ApplyTemplateToSite
   */
  applyTemplateToSite: {
    methodKind: "unary";
    input: typeof ApplyTemplateToSiteRequestSchema;
    output: typeof ApplyTemplateToSiteResponseSchema;
  },
  /**
   * Пересканировать библиотеку (админ).
   *
   * @generated from rpc zdc.SiteTemplateService.ReloadTemplateLibrary
   */
  reloadTemplateLibrary: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ReloadTemplateLibraryResponseSchema;
  },
  /**
   * Доступные обновления шаблонов из Hub (админ).
   *
   * @generated from rpc zdc.SiteTemplateService.CheckTemplateUpdates
   */
  checkTemplateUpdates: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof CheckTemplateUpdatesResponseSchema;
  },
  /**
   * Установка новых/обновлённых шаблонов из Hub (админ).
   *
   * @generated from rpc zdc.SiteTemplateService.InstallTemplatesFromHub
   */
  installTemplatesFromHub: {
    methodKind: "unary";
    input: typeof InstallTemplatesFromHubRequestSchema;
    output: typeof InstallTemplatesFromHubResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 69);

/**
 * @generated from service zdc.CallService
 */
export const CallService: GenService<{
  /**
   * Начало звонка: запись состояния + события адресатам + Web Push офлайн-получателям.
   *
   * @generated from rpc zdc.CallService.StartCall
   */
  startCall: {
    methodKind: "unary";
    input: typeof StartCallRequestSchema;
    output: typeof CallSessionSchema;
  },
  /**
   * Принять звонок (participant): ringing → active (идемпотентно).
   *
   * @generated from rpc zdc.CallService.AnswerCall
   */
  answerCall: {
    methodKind: "unary";
    input: typeof AnswerCallRequestSchema;
    output: typeof CallSessionSchema;
  },
  /**
   * Отклонить звонок (participant): ringing → declined (идемпотентно).
   *
   * @generated from rpc zdc.CallService.DeclineCall
   */
  declineCall: {
    methodKind: "unary";
    input: typeof DeclineCallRequestSchema;
    output: typeof CallSessionSchema;
  },
  /**
   * Завершить звонок (participant): ringing|active → ended (идемпотентно).
   *
   * @generated from rpc zdc.CallService.EndCall
   */
  endCall: {
    methodKind: "unary";
    input: typeof EndCallRequestSchema;
    output: typeof CallSessionSchema;
  },
  /**
   * Звонок по id (только участники) — подхват после открытия приложения по push.
   *
   * @generated from rpc zdc.CallService.GetCall
   */
  getCall: {
    methodKind: "unary";
    input: typeof GetCallRequestSchema;
    output: typeof CallSessionSchema;
  },
  /**
   * Активные (ringing|active) звонки текущего пользователя.
   *
   * @generated from rpc zdc.CallService.ListActiveCalls
   */
  listActiveCalls: {
    methodKind: "unary";
    input: typeof ListActiveCallsRequestSchema;
    output: typeof ListActiveCallsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 70);

/**
 * @generated from service zdc.IdentityService
 */
export const IdentityService: GenService<{
  /**
   * Идентичность текущей базы (DID/ключи/документ) — авторизованный.
   *
   * @generated from rpc zdc.IdentityService.GetSelfIdentity
   */
  getSelfIdentity: {
    methodKind: "unary";
    input: typeof GetSelfIdentityRequestSchema;
    output: typeof SelfIdentitySchema;
  },
  /**
   * Ротация signing-ключа (админ/«Федерация — управление»): новый ключ,
   * старый остаётся валиден для verify N дней, документ seq+1.
   *
   * @generated from rpc zdc.IdentityService.RotateIdentityKey
   */
  rotateIdentityKey: {
    methodKind: "unary";
    input: typeof RotateIdentityKeyRequestSchema;
    output: typeof IdentityKeyInfoSchema;
  },
  /**
   * Реестр доверенных корневых ключей.
   *
   * @generated from rpc zdc.IdentityService.ListTrustRoots
   */
  listTrustRoots: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof TrustRootListSchema;
  },
  /**
   * @generated from rpc zdc.IdentityService.SaveTrustRoot
   */
  saveTrustRoot: {
    methodKind: "unary";
    input: typeof SaveTrustRootRequestSchema;
    output: typeof TrustRootInfoSchema;
  },
  /**
   * @generated from rpc zdc.IdentityService.DeleteTrustRoot
   */
  deleteTrustRoot: {
    methodKind: "unary";
    input: typeof DeleteTrustRootRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Корневой сертификат базы (публичный материал) для передачи доверия.
   *
   * @generated from rpc zdc.IdentityService.ExportTrustRoot
   */
  exportTrustRoot: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof TrustRootExportResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 71);

/**
 * @generated from service zdc.ReferenceService
 */
export const ReferenceService: GenService<{
  /**
   * Публикация подписанного артефакта из таблицы базы (админ/управление
   * федерацией): снапшот seq=1 или дельта к предыдущему seq.
   *
   * @generated from rpc zdc.ReferenceService.PublishArtifact
   */
  publishArtifact: {
    methodKind: "unary";
    input: typeof PublishArtifactRequestSchema;
    output: typeof PublishArtifactResponseSchema;
  },
  /**
   * Каталог публикаций базы.
   *
   * @generated from rpc zdc.ReferenceService.ListPublishedArtifacts
   */
  listPublishedArtifacts: {
    methodKind: "unary";
    input: typeof ListPublishedArtifactsRequestSchema;
    output: typeof ListPublishedArtifactsResponseSchema;
  },
  /**
   * Файл публикации (seq=0 — последняя) — для offline-передачи.
   *
   * @generated from rpc zdc.ReferenceService.GetArtifactFile
   */
  getArtifactFile: {
    methodKind: "unary";
    input: typeof GetArtifactFileRequestSchema;
    output: typeof ArtifactFileResponseSchema;
  },
  /**
   * Импорт файла .hydra-ref: проверка подписи/цепочки/доверия/seq и
   * применение в одной транзакции (идемпотентно).
   *
   * @generated from rpc zdc.ReferenceService.ImportArtifact
   */
  importArtifact: {
    methodKind: "unary";
    input: typeof ImportArtifactRequestSchema;
    output: typeof ApplyResultSchema;
  },
  /**
   * ЯВНЫЙ откат к снапшоту с меньшим seq (аудит warning).
   *
   * @generated from rpc zdc.ReferenceService.RollbackArtifact
   */
  rollbackArtifact: {
    methodKind: "unary";
    input: typeof RollbackArtifactRequestSchema;
    output: typeof ApplyResultSchema;
  },
  /**
   * Применённые артефакты (состояние подписчика).
   *
   * @generated from rpc zdc.ReferenceService.ListInstalledArtifacts
   */
  listInstalledArtifacts: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListInstalledArtifactsResponseSchema;
  },
  /**
   * Статус артефакта: опубликованный/применённый seq, подписка, доверие.
   *
   * @generated from rpc zdc.ReferenceService.GetArtifactStatus
   */
  getArtifactStatus: {
    methodKind: "unary";
    input: typeof ArtifactStatusRequestSchema;
    output: typeof ArtifactStatusResponseSchema;
  },
  /**
   * Подписки (что качать; выключенная запрещает приём).
   *
   * @generated from rpc zdc.ReferenceService.ListSubscriptions
   */
  listSubscriptions: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListSubscriptionsResponseSchema;
  },
  /**
   * @generated from rpc zdc.ReferenceService.SaveSubscription
   */
  saveSubscription: {
    methodKind: "unary";
    input: typeof SaveSubscriptionRequestSchema;
    output: typeof SubscriptionInfoSchema;
  },
  /**
   * @generated from rpc zdc.ReferenceService.DeleteSubscription
   */
  deleteSubscription: {
    methodKind: "unary";
    input: typeof DeleteSubscriptionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Догон обновлений с центра/партнёра («Обновить сейчас»): применяет
   * доступные дельты/снапшот по подпискам, отчёт по каждой.
   *
   * @generated from rpc zdc.ReferenceService.PullArtifactUpdates
   */
  pullArtifactUpdates: {
    methodKind: "unary";
    input: typeof PullArtifactUpdatesRequestSchema;
    output: typeof PullArtifactUpdatesResponseSchema;
  },
  /**
   * Федеративные настройки базы (Сеть).
   *
   * @generated from rpc zdc.ReferenceService.GetFederationSettings
   */
  getFederationSettings: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof FederationSettingsInfoSchema;
  },
  /**
   * @generated from rpc zdc.ReferenceService.SetFederationSettings
   */
  setFederationSettings: {
    methodKind: "unary";
    input: typeof SetFederationSettingsRequestSchema;
    output: typeof FederationSettingsInfoSchema;
  },
  /**
   * Проверка связи с центром.
   *
   * @generated from rpc zdc.ReferenceService.PingHub
   */
  pingHub: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof PingHubResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 72);

/**
 * @generated from service zdc.FedChatService
 */
export const FedChatService: GenService<{
  /**
   * Открыть/создать личный чат с пользователем СЕТИ по его HydraID (единый
   * аккаунт человек↔человек и человек↔бот). Межбазовый чат выключен настройкой
   * базы (fail-closed) → FailedPrecondition; неверный номер → InvalidArgument;
   * номер не найден в сети → NotFound.
   *
   * @generated from rpc zdc.FedChatService.StartChatByHydraId
   */
  startChatByHydraId: {
    methodKind: "unary";
    input: typeof StartFedChatRequestSchema;
    output: typeof StartFedChatResponseSchema;
  },
  /**
   * Заблокировать собеседника межбазового чата (did:hydra:<uuid> | hid:<цифры>;
   * своя база): неверный адресат → InvalidArgument; уже заблокирован →
   * AlreadyExists.
   *
   * @generated from rpc zdc.FedChatService.BlockFedPeer
   */
  blockFedPeer: {
    methodKind: "unary";
    input: typeof BlockFedPeerRequestSchema;
    output: typeof FedPeerBlockSchema;
  },
  /**
   * Снять блокировку собеседника; нет записи → NotFound.
   *
   * @generated from rpc zdc.FedChatService.UnblockFedPeer
   */
  unblockFedPeer: {
    methodKind: "unary";
    input: typeof UnblockFedPeerRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Заблокированные собеседники базы.
   *
   * @generated from rpc zdc.FedChatService.ListBlockedFedPeers
   */
  listBlockedFedPeers: {
    methodKind: "unary";
    input: typeof ListBlockedFedPeersRequestSchema;
    output: typeof ListBlockedFedPeersResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 73);

/**
 * @generated from service zdc.VoiceRoomService
 */
export const VoiceRoomService: GenService<{
  /**
   * Создать комнату (создатель сразу в комнате — moderator, active).
   *
   * @generated from rpc zdc.VoiceRoomService.CreateRoom
   */
  createRoom: {
    methodKind: "unary";
    input: typeof CreateVoiceRoomRequestSchema;
    output: typeof VoiceRoomSchema;
  },
  /**
   * Видимые комнаты: публичные, «мои» и доступные по ролям (only_mine — только мои).
   *
   * @generated from rpc zdc.VoiceRoomService.ListRooms
   */
  listRooms: {
    methodKind: "unary";
    input: typeof ListVoiceRoomsRequestSchema;
    output: typeof ListVoiceRoomsResponseSchema;
  },
  /**
   * Комната с участниками и их состоянием (доступ по правилам комнаты).
   *
   * @generated from rpc zdc.VoiceRoomService.GetRoom
   */
  getRoom: {
    methodKind: "unary";
    input: typeof GetVoiceRoomRequestSchema;
    output: typeof VoiceRoomSchema;
  },
  /**
   * Имя/тема/настройки: создатель, модератор комнаты или админ.
   *
   * @generated from rpc zdc.VoiceRoomService.UpdateRoom
   */
  updateRoom: {
    methodKind: "unary";
    input: typeof UpdateVoiceRoomRequestSchema;
    output: typeof VoiceRoomSchema;
  },
  /**
   * Удаление комнаты с участниками: создатель или админ.
   *
   * @generated from rpc zdc.VoiceRoomService.DeleteRoom
   */
  deleteRoom: {
    methodKind: "unary";
    input: typeof DeleteVoiceRoomRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Войти в комнату (идемпотентно; предел участников проверяется).
   *
   * @generated from rpc zdc.VoiceRoomService.JoinRoom
   */
  joinRoom: {
    methodKind: "unary";
    input: typeof JoinVoiceRoomRequestSchema;
    output: typeof VoiceRoomSchema;
  },
  /**
   * Выйти из комнаты (идемпотентно; роль сохраняется для возврата).
   *
   * @generated from rpc zdc.VoiceRoomService.LeaveRoom
   */
  leaveRoom: {
    methodKind: "unary";
    input: typeof LeaveVoiceRoomRequestSchema;
    output: typeof VoiceRoomSchema;
  },
  /**
   * Роль участника: создатель/модератор/админ (роль создателя не меняется).
   *
   * @generated from rpc zdc.VoiceRoomService.SetMemberRole
   */
  setMemberRole: {
    methodKind: "unary";
    input: typeof SetVoiceRoomMemberRoleRequestSchema;
    output: typeof VoiceRoomSchema;
  },
  /**
   * Микрофон участника: создатель/модератор/админ.
   *
   * @generated from rpc zdc.VoiceRoomService.MuteMember
   */
  muteMember: {
    methodKind: "unary";
    input: typeof MuteVoiceRoomMemberRequestSchema;
    output: typeof VoiceRoomSchema;
  },
  /**
   * Пропуск LiveKit участнику, находящемуся в комнате (сначала JoinRoom).
   *
   * @generated from rpc zdc.VoiceRoomService.GetRoomToken
   */
  getRoomToken: {
    methodKind: "unary";
    input: typeof GetVoiceRoomTokenRequestSchema;
    output: typeof GetVoiceRoomTokenResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 74);

/**
 * @generated from service zdc.SupportService
 */
export const SupportService: GenService<{
  /**
   * Обращения: роль «Поддержка»/админ — все (фильтры), пользователь — свои.
   *
   * @generated from rpc zdc.SupportService.ListTickets
   */
  listTickets: {
    methodKind: "unary";
    input: typeof ListSupportTicketsRequestSchema;
    output: typeof ListSupportTicketsResponseSchema;
  },
  /**
   * Обращение по id: сотрудник поддержки/админ — любое, пользователь — своё.
   *
   * @generated from rpc zdc.SupportService.GetTicket
   */
  getTicket: {
    methodKind: "unary";
    input: typeof GetSupportTicketRequestSchema;
    output: typeof SupportTicketSchema;
  },
  /**
   * Назначить специалиста ('' — снять назначение); автор назначения уведомляется.
   *
   * @generated from rpc zdc.SupportService.AssignTicket
   */
  assignTicket: {
    methodKind: "unary";
    input: typeof AssignSupportTicketRequestSchema;
    output: typeof SupportTicketSchema;
  },
  /**
   * Сменить статус (new | in_progress | resolved); «решено» фиксирует время.
   *
   * @generated from rpc zdc.SupportService.SetTicketStatus
   */
  setTicketStatus: {
    methodKind: "unary";
    input: typeof SetSupportTicketStatusRequestSchema;
    output: typeof SupportTicketSchema;
  },
  /**
   * Сменить приоритет (low | normal | high) — очередь специалистов.
   *
   * @generated from rpc zdc.SupportService.SetTicketPriority
   */
  setTicketPriority: {
    methodKind: "unary";
    input: typeof SetSupportTicketPriorityRequestSchema;
    output: typeof SupportTicketSchema;
  },
  /**
   * Ответ пользователю в его личный чат (от бота «Поддержка»).
   *
   * @generated from rpc zdc.SupportService.ReplyTicket
   */
  replyTicket: {
    methodKind: "unary";
    input: typeof ReplySupportTicketRequestSchema;
    output: typeof SupportTicketSchema;
  },
  /**
   * Шаблоны ответов (общие для базы): список.
   *
   * @generated from rpc zdc.SupportService.ListReplyTemplates
   */
  listReplyTemplates: {
    methodKind: "unary";
    input: typeof ListSupportReplyTemplatesRequestSchema;
    output: typeof ListSupportReplyTemplatesResponseSchema;
  },
  /**
   * Шаблон: создание (пустой id) или обновление.
   *
   * @generated from rpc zdc.SupportService.SaveReplyTemplate
   */
  saveReplyTemplate: {
    methodKind: "unary";
    input: typeof SaveSupportReplyTemplateRequestSchema;
    output: typeof SupportReplyTemplateSchema;
  },
  /**
   * Удалить шаблон.
   *
   * @generated from rpc zdc.SupportService.DeleteReplyTemplate
   */
  deleteReplyTemplate: {
    methodKind: "unary";
    input: typeof DeleteSupportReplyTemplateRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 75);

/**
 * @generated from service zdc.EcgService
 */
export const EcgService: GenService<{
  /**
   * Разбор снимка ЭКГ сервером платформы (клиент НЕ обращается к localhost).
   *
   * @generated from rpc zdc.EcgService.AnalyzeEcg
   */
  analyzeEcg: {
    methodKind: "unary";
    input: typeof AnalyzeEcgRequestSchema;
    output: typeof AnalyzeEcgResponseSchema;
  },
  /**
   * Доступность сервиса-анализатора (диагностика на странице ЭКГ).
   *
   * @generated from rpc zdc.EcgService.GetEcgAnalyzerStatus
   */
  getEcgAnalyzerStatus: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EcgAnalyzerStatusSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 76);

/**
 * @generated from service zdc.DevopsService
 */
export const DevopsService: GenService<{
  /**
   * Узлы поставки + последние снимки состояния (кэш; без блокировки на SSH).
   *
   * @generated from rpc zdc.DevopsService.ListNodes
   */
  listNodes: {
    methodKind: "unary";
    input: typeof ListDevopsNodesRequestSchema;
    output: typeof ListDevopsNodesResponseSchema;
  },
  /**
   * Снимок узла: refresh=true — принудительный сбор (иначе кэш/устаревший).
   *
   * @generated from rpc zdc.DevopsService.GetNodeStatus
   */
  getNodeStatus: {
    methodKind: "unary";
    input: typeof GetDevopsNodeStatusRequestSchema;
    output: typeof DevopsNodeStatusSchema;
  },
  /**
   * Задачи разработки (dev_tasks) с признаком живого запуска.
   *
   * @generated from rpc zdc.DevopsService.ListTasks
   */
  listTasks: {
    methodKind: "unary";
    input: typeof ListDevopsTasksRequestSchema;
    output: typeof ListDevopsTasksResponseSchema;
  },
  /**
   * Принудительно обновить узел и вернуть свежий снимок.
   *
   * @generated from rpc zdc.DevopsService.RefreshNode
   */
  refreshNode: {
    methodKind: "unary";
    input: typeof RefreshDevopsNodeRequestSchema;
    output: typeof DevopsNodeStatusSchema;
  },
  /**
   * Запустить задачу: Kilo в рабочей копии под юнитом kilo-task-<id>.
   *
   * @generated from rpc zdc.DevopsService.StartTask
   */
  startTask: {
    methodKind: "unary";
    input: typeof StartDevopsTaskRequestSchema;
    output: typeof DevopsTaskSchema;
  },
  /**
   * Остановить запущенную задачу (тот же юнит).
   *
   * @generated from rpc zdc.DevopsService.StopTask
   */
  stopTask: {
    methodKind: "unary";
    input: typeof StopDevopsTaskRequestSchema;
    output: typeof DevopsTaskSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 77);

/**
 * @generated from service zdc.MailService
 */
export const MailService: GenService<{
  /**
   * Ящики: список (админ — все, остальные — свои) + лимит/занятость.
   *
   * @generated from rpc zdc.MailService.ListMailAccounts
   */
  listMailAccounts: {
    methodKind: "unary";
    input: typeof ListMailAccountsRequestSchema;
    output: typeof ListMailAccountsResponseSchema;
  },
  /**
   * @generated from rpc zdc.MailService.GetMailAccount
   */
  getMailAccount: {
    methodKind: "unary";
    input: typeof GetMailAccountRequestSchema;
    output: typeof GetMailAccountResponseSchema;
  },
  /**
   * Создать/изменить ящик. Полная замена настроек SMTP/IMAP; секреты —
   * только на запись (пусто = не менять).
   *
   * @generated from rpc zdc.MailService.SaveMailAccount
   */
  saveMailAccount: {
    methodKind: "unary";
    input: typeof SaveMailAccountRequestSchema;
    output: typeof SaveMailAccountResponseSchema;
  },
  /**
   * Удалить ящик и его письма/треды/вложения/очередь (необратимо).
   *
   * @generated from rpc zdc.MailService.DeleteMailAccount
   */
  deleteMailAccount: {
    methodKind: "unary";
    input: typeof DeleteMailAccountRequestSchema;
    output: typeof DeleteMailAccountResponseSchema;
  },
  /**
   * Переподключить БЕЗ сети: сбросить состояние догона IMAP и краткосрочные
   * access-токены (refresh_token сохраняется); выключенный ящик включается с
   * проверкой лимита. Следующий проход почтового механизма подхватит настройки.
   *
   * @generated from rpc zdc.MailService.ReconnectMailAccount
   */
  reconnectMailAccount: {
    methodKind: "unary";
    input: typeof ReconnectMailAccountRequestSchema;
    output: typeof ReconnectMailAccountResponseSchema;
  },
  /**
   * Проверить настройки БЕЗ сети (обязательные поля, порты, OAuth-полнота,
   * дубликат адреса). Возвращает проблемы/предупреждения; секреты не отдаёт.
   *
   * @generated from rpc zdc.MailService.TestMailAccount
   */
  testMailAccount: {
    methodKind: "unary";
    input: typeof TestMailAccountRequestSchema;
    output: typeof TestMailAccountResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 78);

/**
 * @generated from service zdc.InviteService
 */
export const InviteService: GenService<{
  /**
   * Создать код приглашения (или вернуть действующий) — ЛЮБОЙ пользователь.
   *
   * @generated from rpc zdc.InviteService.CreateInvite
   */
  createInvite: {
    methodKind: "unary";
    input: typeof CreateInviteRequestSchema;
    output: typeof CreateInviteResponseSchema;
  },
  /**
   * Предпросмотр кода до входа (ПУБЛИЧНЫЙ): кто приглашает, срок, статус.
   *
   * @generated from rpc zdc.InviteService.ResolveInvite
   */
  resolveInvite: {
    methodKind: "unary";
    input: typeof ResolveInviteRequestSchema;
    output: typeof ResolveInviteResponseSchema;
  },
  /**
   * Принять код (при регистрации/входе): связь + глубина, идемпотентно.
   *
   * @generated from rpc zdc.InviteService.AcceptInvite
   */
  acceptInvite: {
    methodKind: "unary";
    input: typeof AcceptInviteRequestSchema;
    output: typeof AcceptInviteResponseSchema;
  },
  /**
   * Дерево приглашений: свои — всем, чужие — только админ.
   *
   * @generated from rpc zdc.InviteService.ListMyInvited
   */
  listMyInvited: {
    methodKind: "unary";
    input: typeof ListMyInvitedRequestSchema;
    output: typeof ListMyInvitedResponseSchema;
  },
  /**
   * Доходы по приглашениям: роль «Приглашения — программа» или админ.
   *
   * @generated from rpc zdc.InviteService.ListInviteRewards
   */
  listInviteRewards: {
    methodKind: "unary";
    input: typeof ListInviteRewardsRequestSchema;
    output: typeof ListInviteRewardsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 79);

/**
 * @generated from service zdc.MedicService
 */
export const MedicService: GenService<{
  /**
   * @generated from rpc zdc.MedicService.AssignAttendingDoctor
   */
  assignAttendingDoctor: {
    methodKind: "unary";
    input: typeof AssignAttendingDoctorRequestSchema;
    output: typeof AssignAttendingDoctorResponseSchema;
  },
  /**
   * @generated from rpc zdc.MedicService.ImportLabResultsCsv
   */
  importLabResultsCsv: {
    methodKind: "unary";
    input: typeof ImportLabResultsCsvRequestSchema;
    output: typeof ImportLabResultsCsvResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_zdc, 80);

